/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "./";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 99);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(106);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(33);
module.exports.easing = __webpack_require__(192);
module.exports.canvas = __webpack_require__(193);
module.exports.options = __webpack_require__(194);


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var helpers = __webpack_require__(1);

module.exports = {
	/**
	 * @private
	 */
	_set: function(scope, values) {
		return helpers.merge(this[scope] || (this[scope] = {}), values);
	}
};


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/gtx.f31478dd.png";

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__(126);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__(135);
/* unused harmony reexport HashRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(65);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__(136);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__(138);
/* unused harmony reexport NavLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__(140);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(142);
/* unused harmony reexport Redirect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(66);
/* unused harmony reexport Route */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__(46);
/* unused harmony reexport Router */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__(144);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__(146);
/* unused harmony reexport Switch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__generatePath__ = __webpack_require__(148);
/* unused harmony reexport generatePath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__matchPath__ = __webpack_require__(149);
/* unused harmony reexport matchPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__withRouter__ = __webpack_require__(150);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_13__withRouter__["a"]; });





























/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(127)();
}


/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__availableLanguages_json__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__availableLanguages_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__availableLanguages_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__locales_en_json__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__locales_en_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__locales_en_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__locales_de_json__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__locales_de_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__locales_de_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// Available Languages
// Languages
// Router
var Lang=function(_Component){_inherits(Lang,_Component);function Lang(){_classCallCheck(this,Lang);return _possibleConstructorReturn(this,(Lang.__proto__||Object.getPrototypeOf(Lang)).apply(this,arguments));}_createClass(Lang,null,[{key:'translate',value:function translate(string,lang,stringToReplace){var stringSplit=string.split(':');var key=stringSplit[0];var name=stringSplit[1];var loadedLocale=this.getLanguageFromUrl(lang);var localeStringsToLoad=__WEBPACK_IMPORTED_MODULE_3__locales_de_json___default.a;switch(loadedLocale){case"EN":localeStringsToLoad=__WEBPACK_IMPORTED_MODULE_2__locales_en_json___default.a;break;default:localeStringsToLoad=__WEBPACK_IMPORTED_MODULE_3__locales_de_json___default.a;break;}try{if(name!==null&&stringSplit.length>0&&typeof stringSplit!=='undefined'&&typeof localeStringsToLoad!=='undefined'){var returnedString=localeStringsToLoad[key][name];if(returnedString!==undefined&&returnedString!==null&&typeof returnedString!=='undefined'){return returnedString;}else if(localeStringsToLoad!==__WEBPACK_IMPORTED_MODULE_3__locales_de_json___default.a){returnedString=__WEBPACK_IMPORTED_MODULE_3__locales_de_json___default.a[key][name];if(returnedString!==undefined&&returnedString!==null){return returnedString;}else{return string;}}}else{return string;}}catch(error){console.log(error);return string;}}},{key:'availableLanguages',value:function availableLanguages(){return __WEBPACK_IMPORTED_MODULE_1__availableLanguages_json___default.a.map(function(value){var languageObject={id:value.id,code:value.languageISO,displayString:value.languageDisplay};return languageObject;});}}]);return Lang;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Lang.getLanguageFromUrl=function(lang){switch(lang){case"/en":return"EN";default:return"DE";}};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* withRouter */])(Lang));

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var color = __webpack_require__(74);
var helpers = __webpack_require__(1);

function interpolate(start, view, model, ease) {
	var keys = Object.keys(model);
	var i, ilen, key, actual, origin, target, type, c0, c1;

	for (i = 0, ilen = keys.length; i < ilen; ++i) {
		key = keys[i];

		target = model[key];

		// if a value is added to the model after pivot() has been called, the view
		// doesn't contain it, so let's initialize the view to the target value.
		if (!view.hasOwnProperty(key)) {
			view[key] = target;
		}

		actual = view[key];

		if (actual === target || key[0] === '_') {
			continue;
		}

		if (!start.hasOwnProperty(key)) {
			start[key] = actual;
		}

		origin = start[key];

		type = typeof target;

		if (type === typeof origin) {
			if (type === 'string') {
				c0 = color(origin);
				if (c0.valid) {
					c1 = color(target);
					if (c1.valid) {
						view[key] = c1.mix(c0, ease).rgbString();
						continue;
					}
				}
			} else if (type === 'number' && isFinite(origin) && isFinite(target)) {
				view[key] = origin + (target - origin) * ease;
				continue;
			}
		}

		view[key] = target;
	}
}

var Element = function(configuration) {
	helpers.extend(this, configuration);
	this.initialize.apply(this, arguments);
};

helpers.extend(Element.prototype, {

	initialize: function() {
		this.hidden = false;
	},

	pivot: function() {
		var me = this;
		if (!me._view) {
			me._view = helpers.clone(me._model);
		}
		me._start = {};
		return me;
	},

	transition: function(ease) {
		var me = this;
		var model = me._model;
		var start = me._start;
		var view = me._view;

		// No animation -> No Transition
		if (!model || ease === 1) {
			me._view = model;
			me._start = null;
			return me;
		}

		if (!view) {
			view = me._view = {};
		}

		if (!start) {
			start = me._start = {};
		}

		interpolate(start, view, model, ease);

		return me;
	},

	tooltipPosition: function() {
		return {
			x: this._model.x,
			y: this._model.y
		};
	},

	hasValue: function() {
		return helpers.isNumber(this._model.x) && helpers.isNumber(this._model.y);
	}
});

Element.extend = helpers.inherits;

module.exports = Element;


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(80);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 11 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {};
module.exports.Arc = __webpack_require__(200);
module.exports.Line = __webpack_require__(201);
module.exports.Point = __webpack_require__(202);
module.exports.Rectangle = __webpack_require__(203);


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(248),
    getValue = __webpack_require__(253);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createBrowserHistory__ = __webpack_require__(130);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__createBrowserHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createHashHistory__ = __webpack_require__(133);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__createHashHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__ = __webpack_require__(134);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LocationUtils__ = __webpack_require__(31);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__LocationUtils__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_3__LocationUtils__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PathUtils__ = __webpack_require__(20);
/* unused harmony reexport parsePath */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__PathUtils__["b"]; });










/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AnimationSequence = exports.AnimationGroup = exports.Animation = exports.Animatable = exports.Animated = undefined;

var _animated = __webpack_require__(338);

Object.defineProperty(exports, 'Animated', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_animated).default;
  }
});

var _animatable = __webpack_require__(94);

Object.defineProperty(exports, 'Animatable', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_animatable).default;
  }
});

var _animation = __webpack_require__(93);

Object.defineProperty(exports, 'Animation', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_animation).default;
  }
});

var _animation_group = __webpack_require__(350);

Object.defineProperty(exports, 'AnimationGroup', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_animation_group).default;
  }
});

var _animation_sequence = __webpack_require__(351);

Object.defineProperty(exports, 'AnimationSequence', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_animation_sequence).default;
  }
});

var _animated2 = _interopRequireDefault(_animated);

var _animatable2 = _interopRequireDefault(_animatable);

var _animation2 = _interopRequireDefault(_animation);

var _animation_group2 = _interopRequireDefault(_animation_group);

var _animation_sequence2 = _interopRequireDefault(_animation_sequence);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// expose a default
exports.default = {
  Animated: _animated2.default,
  Animatable: _animatable2.default,
  Animation: _animation2.default,
  AnimationGroup: _animation_group2.default,
  AnimationSequence: _animation_sequence2.default
};

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/desk.61cbb171.png";

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/press.2f33b9ff.png";

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/senddesk.64a9e33b.png";

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addLeadingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return stripLeadingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return hasBasename; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return stripBasename; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return stripTrailingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return parsePath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createPath; });
var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var stripLeadingSlash = function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
};

var hasBasename = function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};

var stripBasename = function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};

var stripTrailingSlash = function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};

var parsePath = function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var createPath = function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;


  var path = pathname || '/';

  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;

  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;

  return path;
};

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var helpers = __webpack_require__(1);

function filterByPosition(array, position) {
	return helpers.where(array, function(v) {
		return v.position === position;
	});
}

function sortByWeight(array, reverse) {
	array.forEach(function(v, i) {
		v._tmpIndex_ = i;
		return v;
	});
	array.sort(function(a, b) {
		var v0 = reverse ? b : a;
		var v1 = reverse ? a : b;
		return v0.weight === v1.weight ?
			v0._tmpIndex_ - v1._tmpIndex_ :
			v0.weight - v1.weight;
	});
	array.forEach(function(v) {
		delete v._tmpIndex_;
	});
}

/**
 * @interface ILayoutItem
 * @prop {String} position - The position of the item in the chart layout. Possible values are
 * 'left', 'top', 'right', 'bottom', and 'chartArea'
 * @prop {Number} weight - The weight used to sort the item. Higher weights are further away from the chart area
 * @prop {Boolean} fullWidth - if true, and the item is horizontal, then push vertical boxes down
 * @prop {Function} isHorizontal - returns true if the layout item is horizontal (ie. top or bottom)
 * @prop {Function} update - Takes two parameters: width and height. Returns size of item
 * @prop {Function} getPadding -  Returns an object with padding on the edges
 * @prop {Number} width - Width of item. Must be valid after update()
 * @prop {Number} height - Height of item. Must be valid after update()
 * @prop {Number} left - Left edge of the item. Set by layout system and cannot be used in update
 * @prop {Number} top - Top edge of the item. Set by layout system and cannot be used in update
 * @prop {Number} right - Right edge of the item. Set by layout system and cannot be used in update
 * @prop {Number} bottom - Bottom edge of the item. Set by layout system and cannot be used in update
 */

// The layout service is very self explanatory.  It's responsible for the layout within a chart.
// Scales, Legends and Plugins all rely on the layout service and can easily register to be placed anywhere they need
// It is this service's responsibility of carrying out that layout.
module.exports = {
	defaults: {},

	/**
	 * Register a box to a chart.
	 * A box is simply a reference to an object that requires layout. eg. Scales, Legend, Title.
	 * @param {Chart} chart - the chart to use
	 * @param {ILayoutItem} item - the item to add to be layed out
	 */
	addBox: function(chart, item) {
		if (!chart.boxes) {
			chart.boxes = [];
		}

		// initialize item with default values
		item.fullWidth = item.fullWidth || false;
		item.position = item.position || 'top';
		item.weight = item.weight || 0;

		chart.boxes.push(item);
	},

	/**
	 * Remove a layoutItem from a chart
	 * @param {Chart} chart - the chart to remove the box from
	 * @param {Object} layoutItem - the item to remove from the layout
	 */
	removeBox: function(chart, layoutItem) {
		var index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
		if (index !== -1) {
			chart.boxes.splice(index, 1);
		}
	},

	/**
	 * Sets (or updates) options on the given `item`.
	 * @param {Chart} chart - the chart in which the item lives (or will be added to)
	 * @param {Object} item - the item to configure with the given options
	 * @param {Object} options - the new item options.
	 */
	configure: function(chart, item, options) {
		var props = ['fullWidth', 'position', 'weight'];
		var ilen = props.length;
		var i = 0;
		var prop;

		for (; i < ilen; ++i) {
			prop = props[i];
			if (options.hasOwnProperty(prop)) {
				item[prop] = options[prop];
			}
		}
	},

	/**
	 * Fits boxes of the given chart into the given size by having each box measure itself
	 * then running a fitting algorithm
	 * @param {Chart} chart - the chart
	 * @param {Number} width - the width to fit into
	 * @param {Number} height - the height to fit into
	 */
	update: function(chart, width, height) {
		if (!chart) {
			return;
		}

		var layoutOptions = chart.options.layout || {};
		var padding = helpers.options.toPadding(layoutOptions.padding);
		var leftPadding = padding.left;
		var rightPadding = padding.right;
		var topPadding = padding.top;
		var bottomPadding = padding.bottom;

		var leftBoxes = filterByPosition(chart.boxes, 'left');
		var rightBoxes = filterByPosition(chart.boxes, 'right');
		var topBoxes = filterByPosition(chart.boxes, 'top');
		var bottomBoxes = filterByPosition(chart.boxes, 'bottom');
		var chartAreaBoxes = filterByPosition(chart.boxes, 'chartArea');

		// Sort boxes by weight. A higher weight is further away from the chart area
		sortByWeight(leftBoxes, true);
		sortByWeight(rightBoxes, false);
		sortByWeight(topBoxes, true);
		sortByWeight(bottomBoxes, false);

		// Essentially we now have any number of boxes on each of the 4 sides.
		// Our canvas looks like the following.
		// The areas L1 and L2 are the left axes. R1 is the right axis, T1 is the top axis and
		// B1 is the bottom axis
		// There are also 4 quadrant-like locations (left to right instead of clockwise) reserved for chart overlays
		// These locations are single-box locations only, when trying to register a chartArea location that is already taken,
		// an error will be thrown.
		//
		// |----------------------------------------------------|
		// |                  T1 (Full Width)                   |
		// |----------------------------------------------------|
		// |    |    |                 T2                  |    |
		// |    |----|-------------------------------------|----|
		// |    |    | C1 |                           | C2 |    |
		// |    |    |----|                           |----|    |
		// |    |    |                                     |    |
		// | L1 | L2 |           ChartArea (C0)            | R1 |
		// |    |    |                                     |    |
		// |    |    |----|                           |----|    |
		// |    |    | C3 |                           | C4 |    |
		// |    |----|-------------------------------------|----|
		// |    |    |                 B1                  |    |
		// |----------------------------------------------------|
		// |                  B2 (Full Width)                   |
		// |----------------------------------------------------|
		//
		// What we do to find the best sizing, we do the following
		// 1. Determine the minimum size of the chart area.
		// 2. Split the remaining width equally between each vertical axis
		// 3. Split the remaining height equally between each horizontal axis
		// 4. Give each layout the maximum size it can be. The layout will return it's minimum size
		// 5. Adjust the sizes of each axis based on it's minimum reported size.
		// 6. Refit each axis
		// 7. Position each axis in the final location
		// 8. Tell the chart the final location of the chart area
		// 9. Tell any axes that overlay the chart area the positions of the chart area

		// Step 1
		var chartWidth = width - leftPadding - rightPadding;
		var chartHeight = height - topPadding - bottomPadding;
		var chartAreaWidth = chartWidth / 2; // min 50%
		var chartAreaHeight = chartHeight / 2; // min 50%

		// Step 2
		var verticalBoxWidth = (width - chartAreaWidth) / (leftBoxes.length + rightBoxes.length);

		// Step 3
		var horizontalBoxHeight = (height - chartAreaHeight) / (topBoxes.length + bottomBoxes.length);

		// Step 4
		var maxChartAreaWidth = chartWidth;
		var maxChartAreaHeight = chartHeight;
		var minBoxSizes = [];

		function getMinimumBoxSize(box) {
			var minSize;
			var isHorizontal = box.isHorizontal();

			if (isHorizontal) {
				minSize = box.update(box.fullWidth ? chartWidth : maxChartAreaWidth, horizontalBoxHeight);
				maxChartAreaHeight -= minSize.height;
			} else {
				minSize = box.update(verticalBoxWidth, maxChartAreaHeight);
				maxChartAreaWidth -= minSize.width;
			}

			minBoxSizes.push({
				horizontal: isHorizontal,
				minSize: minSize,
				box: box,
			});
		}

		helpers.each(leftBoxes.concat(rightBoxes, topBoxes, bottomBoxes), getMinimumBoxSize);

		// If a horizontal box has padding, we move the left boxes over to avoid ugly charts (see issue #2478)
		var maxHorizontalLeftPadding = 0;
		var maxHorizontalRightPadding = 0;
		var maxVerticalTopPadding = 0;
		var maxVerticalBottomPadding = 0;

		helpers.each(topBoxes.concat(bottomBoxes), function(horizontalBox) {
			if (horizontalBox.getPadding) {
				var boxPadding = horizontalBox.getPadding();
				maxHorizontalLeftPadding = Math.max(maxHorizontalLeftPadding, boxPadding.left);
				maxHorizontalRightPadding = Math.max(maxHorizontalRightPadding, boxPadding.right);
			}
		});

		helpers.each(leftBoxes.concat(rightBoxes), function(verticalBox) {
			if (verticalBox.getPadding) {
				var boxPadding = verticalBox.getPadding();
				maxVerticalTopPadding = Math.max(maxVerticalTopPadding, boxPadding.top);
				maxVerticalBottomPadding = Math.max(maxVerticalBottomPadding, boxPadding.bottom);
			}
		});

		// At this point, maxChartAreaHeight and maxChartAreaWidth are the size the chart area could
		// be if the axes are drawn at their minimum sizes.
		// Steps 5 & 6
		var totalLeftBoxesWidth = leftPadding;
		var totalRightBoxesWidth = rightPadding;
		var totalTopBoxesHeight = topPadding;
		var totalBottomBoxesHeight = bottomPadding;

		// Function to fit a box
		function fitBox(box) {
			var minBoxSize = helpers.findNextWhere(minBoxSizes, function(minBox) {
				return minBox.box === box;
			});

			if (minBoxSize) {
				if (box.isHorizontal()) {
					var scaleMargin = {
						left: Math.max(totalLeftBoxesWidth, maxHorizontalLeftPadding),
						right: Math.max(totalRightBoxesWidth, maxHorizontalRightPadding),
						top: 0,
						bottom: 0
					};

					// Don't use min size here because of label rotation. When the labels are rotated, their rotation highly depends
					// on the margin. Sometimes they need to increase in size slightly
					box.update(box.fullWidth ? chartWidth : maxChartAreaWidth, chartHeight / 2, scaleMargin);
				} else {
					box.update(minBoxSize.minSize.width, maxChartAreaHeight);
				}
			}
		}

		// Update, and calculate the left and right margins for the horizontal boxes
		helpers.each(leftBoxes.concat(rightBoxes), fitBox);

		helpers.each(leftBoxes, function(box) {
			totalLeftBoxesWidth += box.width;
		});

		helpers.each(rightBoxes, function(box) {
			totalRightBoxesWidth += box.width;
		});

		// Set the Left and Right margins for the horizontal boxes
		helpers.each(topBoxes.concat(bottomBoxes), fitBox);

		// Figure out how much margin is on the top and bottom of the vertical boxes
		helpers.each(topBoxes, function(box) {
			totalTopBoxesHeight += box.height;
		});

		helpers.each(bottomBoxes, function(box) {
			totalBottomBoxesHeight += box.height;
		});

		function finalFitVerticalBox(box) {
			var minBoxSize = helpers.findNextWhere(minBoxSizes, function(minSize) {
				return minSize.box === box;
			});

			var scaleMargin = {
				left: 0,
				right: 0,
				top: totalTopBoxesHeight,
				bottom: totalBottomBoxesHeight
			};

			if (minBoxSize) {
				box.update(minBoxSize.minSize.width, maxChartAreaHeight, scaleMargin);
			}
		}

		// Let the left layout know the final margin
		helpers.each(leftBoxes.concat(rightBoxes), finalFitVerticalBox);

		// Recalculate because the size of each layout might have changed slightly due to the margins (label rotation for instance)
		totalLeftBoxesWidth = leftPadding;
		totalRightBoxesWidth = rightPadding;
		totalTopBoxesHeight = topPadding;
		totalBottomBoxesHeight = bottomPadding;

		helpers.each(leftBoxes, function(box) {
			totalLeftBoxesWidth += box.width;
		});

		helpers.each(rightBoxes, function(box) {
			totalRightBoxesWidth += box.width;
		});

		helpers.each(topBoxes, function(box) {
			totalTopBoxesHeight += box.height;
		});
		helpers.each(bottomBoxes, function(box) {
			totalBottomBoxesHeight += box.height;
		});

		// We may be adding some padding to account for rotated x axis labels
		var leftPaddingAddition = Math.max(maxHorizontalLeftPadding - totalLeftBoxesWidth, 0);
		totalLeftBoxesWidth += leftPaddingAddition;
		totalRightBoxesWidth += Math.max(maxHorizontalRightPadding - totalRightBoxesWidth, 0);

		var topPaddingAddition = Math.max(maxVerticalTopPadding - totalTopBoxesHeight, 0);
		totalTopBoxesHeight += topPaddingAddition;
		totalBottomBoxesHeight += Math.max(maxVerticalBottomPadding - totalBottomBoxesHeight, 0);

		// Figure out if our chart area changed. This would occur if the dataset layout label rotation
		// changed due to the application of the margins in step 6. Since we can only get bigger, this is safe to do
		// without calling `fit` again
		var newMaxChartAreaHeight = height - totalTopBoxesHeight - totalBottomBoxesHeight;
		var newMaxChartAreaWidth = width - totalLeftBoxesWidth - totalRightBoxesWidth;

		if (newMaxChartAreaWidth !== maxChartAreaWidth || newMaxChartAreaHeight !== maxChartAreaHeight) {
			helpers.each(leftBoxes, function(box) {
				box.height = newMaxChartAreaHeight;
			});

			helpers.each(rightBoxes, function(box) {
				box.height = newMaxChartAreaHeight;
			});

			helpers.each(topBoxes, function(box) {
				if (!box.fullWidth) {
					box.width = newMaxChartAreaWidth;
				}
			});

			helpers.each(bottomBoxes, function(box) {
				if (!box.fullWidth) {
					box.width = newMaxChartAreaWidth;
				}
			});

			maxChartAreaHeight = newMaxChartAreaHeight;
			maxChartAreaWidth = newMaxChartAreaWidth;
		}

		// Step 7 - Position the boxes
		var left = leftPadding + leftPaddingAddition;
		var top = topPadding + topPaddingAddition;

		function placeBox(box) {
			if (box.isHorizontal()) {
				box.left = box.fullWidth ? leftPadding : totalLeftBoxesWidth;
				box.right = box.fullWidth ? width - rightPadding : totalLeftBoxesWidth + maxChartAreaWidth;
				box.top = top;
				box.bottom = top + box.height;

				// Move to next point
				top = box.bottom;

			} else {

				box.left = left;
				box.right = left + box.width;
				box.top = totalTopBoxesHeight;
				box.bottom = totalTopBoxesHeight + maxChartAreaHeight;

				// Move to next point
				left = box.right;
			}
		}

		helpers.each(leftBoxes.concat(topBoxes), placeBox);

		// Account for chart width and height
		left += maxChartAreaWidth;
		top += maxChartAreaHeight;

		helpers.each(rightBoxes, placeBox);
		helpers.each(bottomBoxes, placeBox);

		// Step 8
		chart.chartArea = {
			left: totalLeftBoxesWidth,
			top: totalTopBoxesHeight,
			right: totalLeftBoxesWidth + maxChartAreaWidth,
			bottom: totalTopBoxesHeight + maxChartAreaHeight
		};

		// Step 9
		helpers.each(chartAreaBoxes, function(box) {
			box.left = chart.chartArea.left;
			box.top = chart.chartArea.top;
			box.right = chart.chartArea.right;
			box.bottom = chart.chartArea.bottom;

			box.update(maxChartAreaWidth, maxChartAreaHeight);
		});
	}
};


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var helpers = __webpack_require__(1);

/**
 * Namespace to hold static tick generation functions
 * @namespace Chart.Ticks
 */
module.exports = {
	/**
	 * Namespace to hold formatters for different types of ticks
	 * @namespace Chart.Ticks.formatters
	 */
	formatters: {
		/**
		 * Formatter for value labels
		 * @method Chart.Ticks.formatters.values
		 * @param value the value to display
		 * @return {String|Array} the label to display
		 */
		values: function(value) {
			return helpers.isArray(value) ? value : '' + value;
		},

		/**
		 * Formatter for linear numeric ticks
		 * @method Chart.Ticks.formatters.linear
		 * @param tickValue {Number} the value to be formatted
		 * @param index {Number} the position of the tickValue parameter in the ticks array
		 * @param ticks {Array<Number>} the list of ticks being converted
		 * @return {String} string representation of the tickValue parameter
		 */
		linear: function(tickValue, index, ticks) {
			// If we have lots of ticks, don't use the ones
			var delta = ticks.length > 3 ? ticks[2] - ticks[1] : ticks[1] - ticks[0];

			// If we have a number like 2.5 as the delta, figure out how many decimal places we need
			if (Math.abs(delta) > 1) {
				if (tickValue !== Math.floor(tickValue)) {
					// not an integer
					delta = tickValue - Math.floor(tickValue);
				}
			}

			var logDelta = helpers.log10(Math.abs(delta));
			var tickString = '';

			if (tickValue !== 0) {
				var numDecimal = -1 * Math.floor(logDelta);
				numDecimal = Math.max(Math.min(numDecimal, 20), 0); // toFixed has a max of 20 decimal places
				tickString = tickValue.toFixed(numDecimal);
			} else {
				tickString = '0'; // never show decimal places for 0
			}

			return tickString;
		},

		logarithmic: function(tickValue, index, ticks) {
			var remain = tickValue / (Math.pow(10, Math.floor(helpers.log10(tickValue))));

			if (tickValue === 0) {
				return '0';
			} else if (remain === 1 || remain === 2 || remain === 5 || index === 0 || index === ticks.length - 1) {
				return tickValue.toExponential();
			}
			return '';
		}
	}
};


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(37),
    getRawTag = __webpack_require__(249),
    objectToString = __webpack_require__(250);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 24 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(282),
    baseKeys = __webpack_require__(289),
    isArrayLike = __webpack_require__(27);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 26 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(79),
    isLength = __webpack_require__(56);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/pretreat.0b38ce56.png";

/***/ }),
/* 29 */
/***/ (function(module, exports) {

(function(window, factory) {
	var lazySizes = factory(window, window.document);
	window.lazySizes = lazySizes;
	if(typeof module == 'object' && module.exports){
		module.exports = lazySizes;
	}
}(window, function l(window, document) {
	'use strict';
	/*jshint eqnull:true */
	if(!document.getElementsByClassName){return;}

	var lazysizes, lazySizesConfig;

	var docElem = document.documentElement;

	var Date = window.Date;

	var supportPicture = window.HTMLPictureElement;

	var _addEventListener = 'addEventListener';

	var _getAttribute = 'getAttribute';

	var addEventListener = window[_addEventListener];

	var setTimeout = window.setTimeout;

	var requestAnimationFrame = window.requestAnimationFrame || setTimeout;

	var requestIdleCallback = window.requestIdleCallback;

	var regPicture = /^picture$/i;

	var loadEvents = ['load', 'error', 'lazyincluded', '_lazyloaded'];

	var regClassCache = {};

	var forEach = Array.prototype.forEach;

	var hasClass = function(ele, cls) {
		if(!regClassCache[cls]){
			regClassCache[cls] = new RegExp('(\\s|^)'+cls+'(\\s|$)');
		}
		return regClassCache[cls].test(ele[_getAttribute]('class') || '') && regClassCache[cls];
	};

	var addClass = function(ele, cls) {
		if (!hasClass(ele, cls)){
			ele.setAttribute('class', (ele[_getAttribute]('class') || '').trim() + ' ' + cls);
		}
	};

	var removeClass = function(ele, cls) {
		var reg;
		if ((reg = hasClass(ele,cls))) {
			ele.setAttribute('class', (ele[_getAttribute]('class') || '').replace(reg, ' '));
		}
	};

	var addRemoveLoadEvents = function(dom, fn, add){
		var action = add ? _addEventListener : 'removeEventListener';
		if(add){
			addRemoveLoadEvents(dom, fn);
		}
		loadEvents.forEach(function(evt){
			dom[action](evt, fn);
		});
	};

	var triggerEvent = function(elem, name, detail, noBubbles, noCancelable){
		var event = document.createEvent('CustomEvent');

		if(!detail){
			detail = {};
		}

		detail.instance = lazysizes;

		event.initCustomEvent(name, !noBubbles, !noCancelable, detail);

		elem.dispatchEvent(event);
		return event;
	};

	var updatePolyfill = function (el, full){
		var polyfill;
		if( !supportPicture && ( polyfill = (window.picturefill || lazySizesConfig.pf) ) ){
			polyfill({reevaluate: true, elements: [el]});
		} else if(full && full.src){
			el.src = full.src;
		}
	};

	var getCSS = function (elem, style){
		return (getComputedStyle(elem, null) || {})[style];
	};

	var getWidth = function(elem, parent, width){
		width = width || elem.offsetWidth;

		while(width < lazySizesConfig.minSize && parent && !elem._lazysizesWidth){
			width =  parent.offsetWidth;
			parent = parent.parentNode;
		}

		return width;
	};

	var rAF = (function(){
		var running, waiting;
		var firstFns = [];
		var secondFns = [];
		var fns = firstFns;

		var run = function(){
			var runFns = fns;

			fns = firstFns.length ? secondFns : firstFns;

			running = true;
			waiting = false;

			while(runFns.length){
				runFns.shift()();
			}

			running = false;
		};

		var rafBatch = function(fn, queue){
			if(running && !queue){
				fn.apply(this, arguments);
			} else {
				fns.push(fn);

				if(!waiting){
					waiting = true;
					(document.hidden ? setTimeout : requestAnimationFrame)(run);
				}
			}
		};

		rafBatch._lsFlush = run;

		return rafBatch;
	})();

	var rAFIt = function(fn, simple){
		return simple ?
			function() {
				rAF(fn);
			} :
			function(){
				var that = this;
				var args = arguments;
				rAF(function(){
					fn.apply(that, args);
				});
			}
		;
	};

	var throttle = function(fn){
		var running;
		var lastTime = 0;
		var gDelay = lazySizesConfig.throttleDelay;
		var rICTimeout = lazySizesConfig.ricTimeout;
		var run = function(){
			running = false;
			lastTime = Date.now();
			fn();
		};
		var idleCallback = requestIdleCallback && rICTimeout > 49 ?
			function(){
				requestIdleCallback(run, {timeout: rICTimeout});

				if(rICTimeout !== lazySizesConfig.ricTimeout){
					rICTimeout = lazySizesConfig.ricTimeout;
				}
			} :
			rAFIt(function(){
				setTimeout(run);
			}, true)
		;

		return function(isPriority){
			var delay;

			if((isPriority = isPriority === true)){
				rICTimeout = 33;
			}

			if(running){
				return;
			}

			running =  true;

			delay = gDelay - (Date.now() - lastTime);

			if(delay < 0){
				delay = 0;
			}

			if(isPriority || delay < 9){
				idleCallback();
			} else {
				setTimeout(idleCallback, delay);
			}
		};
	};

	//based on http://modernjavascript.blogspot.de/2013/08/building-better-debounce.html
	var debounce = function(func) {
		var timeout, timestamp;
		var wait = 99;
		var run = function(){
			timeout = null;
			func();
		};
		var later = function() {
			var last = Date.now() - timestamp;

			if (last < wait) {
				setTimeout(later, wait - last);
			} else {
				(requestIdleCallback || run)(run);
			}
		};

		return function() {
			timestamp = Date.now();

			if (!timeout) {
				timeout = setTimeout(later, wait);
			}
		};
	};

	(function(){
		var prop;

		var lazySizesDefaults = {
			lazyClass: 'lazyload',
			loadedClass: 'lazyloaded',
			loadingClass: 'lazyloading',
			preloadClass: 'lazypreload',
			errorClass: 'lazyerror',
			//strictClass: 'lazystrict',
			autosizesClass: 'lazyautosizes',
			srcAttr: 'data-src',
			srcsetAttr: 'data-srcset',
			sizesAttr: 'data-sizes',
			//preloadAfterLoad: false,
			minSize: 40,
			customMedia: {},
			init: true,
			expFactor: 1.5,
			hFac: 0.8,
			loadMode: 2,
			loadHidden: true,
			ricTimeout: 0,
			throttleDelay: 125,
		};

		lazySizesConfig = window.lazySizesConfig || window.lazysizesConfig || {};

		for(prop in lazySizesDefaults){
			if(!(prop in lazySizesConfig)){
				lazySizesConfig[prop] = lazySizesDefaults[prop];
			}
		}

		window.lazySizesConfig = lazySizesConfig;

		setTimeout(function(){
			if(lazySizesConfig.init){
				init();
			}
		});
	})();

	var loader = (function(){
		var preloadElems, isCompleted, resetPreloadingTimer, loadMode, started;

		var eLvW, elvH, eLtop, eLleft, eLright, eLbottom;

		var defaultExpand, preloadExpand, hFac;

		var regImg = /^img$/i;
		var regIframe = /^iframe$/i;

		var supportScroll = ('onscroll' in window) && !(/glebot/.test(navigator.userAgent));

		var shrinkExpand = 0;
		var currentExpand = 0;

		var isLoading = 0;
		var lowRuns = -1;

		var resetPreloading = function(e){
			isLoading--;
			if(e && e.target){
				addRemoveLoadEvents(e.target, resetPreloading);
			}

			if(!e || isLoading < 0 || !e.target){
				isLoading = 0;
			}
		};

		var isNestedVisible = function(elem, elemExpand){
			var outerRect;
			var parent = elem;
			var visible = getCSS(document.body, 'visibility') == 'hidden' || getCSS(elem, 'visibility') != 'hidden';

			eLtop -= elemExpand;
			eLbottom += elemExpand;
			eLleft -= elemExpand;
			eLright += elemExpand;

			while(visible && (parent = parent.offsetParent) && parent != document.body && parent != docElem){
				visible = ((getCSS(parent, 'opacity') || 1) > 0);

				if(visible && getCSS(parent, 'overflow') != 'visible'){
					outerRect = parent.getBoundingClientRect();
					visible = eLright > outerRect.left &&
						eLleft < outerRect.right &&
						eLbottom > outerRect.top - 1 &&
						eLtop < outerRect.bottom + 1
					;
				}
			}

			return visible;
		};

		var checkElements = function() {
			var eLlen, i, rect, autoLoadElem, loadedSomething, elemExpand, elemNegativeExpand, elemExpandVal, beforeExpandVal;

			var lazyloadElems = lazysizes.elements;

			if((loadMode = lazySizesConfig.loadMode) && isLoading < 8 && (eLlen = lazyloadElems.length)){

				i = 0;

				lowRuns++;

				if(preloadExpand == null){
					if(!('expand' in lazySizesConfig)){
						lazySizesConfig.expand = docElem.clientHeight > 500 && docElem.clientWidth > 500 ? 500 : 370;
					}

					defaultExpand = lazySizesConfig.expand;
					preloadExpand = defaultExpand * lazySizesConfig.expFactor;
				}

				if(currentExpand < preloadExpand && isLoading < 1 && lowRuns > 2 && loadMode > 2 && !document.hidden){
					currentExpand = preloadExpand;
					lowRuns = 0;
				} else if(loadMode > 1 && lowRuns > 1 && isLoading < 6){
					currentExpand = defaultExpand;
				} else {
					currentExpand = shrinkExpand;
				}

				for(; i < eLlen; i++){

					if(!lazyloadElems[i] || lazyloadElems[i]._lazyRace){continue;}

					if(!supportScroll){unveilElement(lazyloadElems[i]);continue;}

					if(!(elemExpandVal = lazyloadElems[i][_getAttribute]('data-expand')) || !(elemExpand = elemExpandVal * 1)){
						elemExpand = currentExpand;
					}

					if(beforeExpandVal !== elemExpand){
						eLvW = innerWidth + (elemExpand * hFac);
						elvH = innerHeight + elemExpand;
						elemNegativeExpand = elemExpand * -1;
						beforeExpandVal = elemExpand;
					}

					rect = lazyloadElems[i].getBoundingClientRect();

					if ((eLbottom = rect.bottom) >= elemNegativeExpand &&
						(eLtop = rect.top) <= elvH &&
						(eLright = rect.right) >= elemNegativeExpand * hFac &&
						(eLleft = rect.left) <= eLvW &&
						(eLbottom || eLright || eLleft || eLtop) &&
						(lazySizesConfig.loadHidden || getCSS(lazyloadElems[i], 'visibility') != 'hidden') &&
						((isCompleted && isLoading < 3 && !elemExpandVal && (loadMode < 3 || lowRuns < 4)) || isNestedVisible(lazyloadElems[i], elemExpand))){
						unveilElement(lazyloadElems[i]);
						loadedSomething = true;
						if(isLoading > 9){break;}
					} else if(!loadedSomething && isCompleted && !autoLoadElem &&
						isLoading < 4 && lowRuns < 4 && loadMode > 2 &&
						(preloadElems[0] || lazySizesConfig.preloadAfterLoad) &&
						(preloadElems[0] || (!elemExpandVal && ((eLbottom || eLright || eLleft || eLtop) || lazyloadElems[i][_getAttribute](lazySizesConfig.sizesAttr) != 'auto')))){
						autoLoadElem = preloadElems[0] || lazyloadElems[i];
					}
				}

				if(autoLoadElem && !loadedSomething){
					unveilElement(autoLoadElem);
				}
			}
		};

		var throttledCheckElements = throttle(checkElements);

		var switchLoadingClass = function(e){
			addClass(e.target, lazySizesConfig.loadedClass);
			removeClass(e.target, lazySizesConfig.loadingClass);
			addRemoveLoadEvents(e.target, rafSwitchLoadingClass);
			triggerEvent(e.target, 'lazyloaded');
		};
		var rafedSwitchLoadingClass = rAFIt(switchLoadingClass);
		var rafSwitchLoadingClass = function(e){
			rafedSwitchLoadingClass({target: e.target});
		};

		var changeIframeSrc = function(elem, src){
			try {
				elem.contentWindow.location.replace(src);
			} catch(e){
				elem.src = src;
			}
		};

		var handleSources = function(source){
			var customMedia;

			var sourceSrcset = source[_getAttribute](lazySizesConfig.srcsetAttr);

			if( (customMedia = lazySizesConfig.customMedia[source[_getAttribute]('data-media') || source[_getAttribute]('media')]) ){
				source.setAttribute('media', customMedia);
			}

			if(sourceSrcset){
				source.setAttribute('srcset', sourceSrcset);
			}
		};

		var lazyUnveil = rAFIt(function (elem, detail, isAuto, sizes, isImg){
			var src, srcset, parent, isPicture, event, firesLoad;

			if(!(event = triggerEvent(elem, 'lazybeforeunveil', detail)).defaultPrevented){

				if(sizes){
					if(isAuto){
						addClass(elem, lazySizesConfig.autosizesClass);
					} else {
						elem.setAttribute('sizes', sizes);
					}
				}

				srcset = elem[_getAttribute](lazySizesConfig.srcsetAttr);
				src = elem[_getAttribute](lazySizesConfig.srcAttr);

				if(isImg) {
					parent = elem.parentNode;
					isPicture = parent && regPicture.test(parent.nodeName || '');
				}

				firesLoad = detail.firesLoad || (('src' in elem) && (srcset || src || isPicture));

				event = {target: elem};

				if(firesLoad){
					addRemoveLoadEvents(elem, resetPreloading, true);
					clearTimeout(resetPreloadingTimer);
					resetPreloadingTimer = setTimeout(resetPreloading, 2500);

					addClass(elem, lazySizesConfig.loadingClass);
					addRemoveLoadEvents(elem, rafSwitchLoadingClass, true);
				}

				if(isPicture){
					forEach.call(parent.getElementsByTagName('source'), handleSources);
				}

				if(srcset){
					elem.setAttribute('srcset', srcset);
				} else if(src && !isPicture){
					if(regIframe.test(elem.nodeName)){
						changeIframeSrc(elem, src);
					} else {
						elem.src = src;
					}
				}

				if(isImg && (srcset || isPicture)){
					updatePolyfill(elem, {src: src});
				}
			}

			if(elem._lazyRace){
				delete elem._lazyRace;
			}
			removeClass(elem, lazySizesConfig.lazyClass);

			rAF(function(){
				if( !firesLoad || (elem.complete && elem.naturalWidth > 1)){
					if(firesLoad){
						resetPreloading(event);
					} else {
						isLoading--;
					}
					switchLoadingClass(event);
				}
			}, true);
		});

		var unveilElement = function (elem){
			var detail;

			var isImg = regImg.test(elem.nodeName);

			//allow using sizes="auto", but don't use. it's invalid. Use data-sizes="auto" or a valid value for sizes instead (i.e.: sizes="80vw")
			var sizes = isImg && (elem[_getAttribute](lazySizesConfig.sizesAttr) || elem[_getAttribute]('sizes'));
			var isAuto = sizes == 'auto';

			if( (isAuto || !isCompleted) && isImg && (elem[_getAttribute]('src') || elem.srcset) && !elem.complete && !hasClass(elem, lazySizesConfig.errorClass) && hasClass(elem, lazySizesConfig.lazyClass)){return;}

			detail = triggerEvent(elem, 'lazyunveilread').detail;

			if(isAuto){
				 autoSizer.updateElem(elem, true, elem.offsetWidth);
			}

			elem._lazyRace = true;
			isLoading++;

			lazyUnveil(elem, detail, isAuto, sizes, isImg);
		};

		var onload = function(){
			if(isCompleted){return;}
			if(Date.now() - started < 999){
				setTimeout(onload, 999);
				return;
			}
			var afterScroll = debounce(function(){
				lazySizesConfig.loadMode = 3;
				throttledCheckElements();
			});

			isCompleted = true;

			lazySizesConfig.loadMode = 3;

			throttledCheckElements();

			addEventListener('scroll', function(){
				if(lazySizesConfig.loadMode == 3){
					lazySizesConfig.loadMode = 2;
				}
				afterScroll();
			}, true);
		};

		return {
			_: function(){
				started = Date.now();

				lazysizes.elements = document.getElementsByClassName(lazySizesConfig.lazyClass);
				preloadElems = document.getElementsByClassName(lazySizesConfig.lazyClass + ' ' + lazySizesConfig.preloadClass);
				hFac = lazySizesConfig.hFac;

				addEventListener('scroll', throttledCheckElements, true);

				addEventListener('resize', throttledCheckElements, true);

				if(window.MutationObserver){
					new MutationObserver( throttledCheckElements ).observe( docElem, {childList: true, subtree: true, attributes: true} );
				} else {
					docElem[_addEventListener]('DOMNodeInserted', throttledCheckElements, true);
					docElem[_addEventListener]('DOMAttrModified', throttledCheckElements, true);
					setInterval(throttledCheckElements, 999);
				}

				addEventListener('hashchange', throttledCheckElements, true);

				//, 'fullscreenchange'
				['focus', 'mouseover', 'click', 'load', 'transitionend', 'animationend', 'webkitAnimationEnd'].forEach(function(name){
					document[_addEventListener](name, throttledCheckElements, true);
				});

				if((/d$|^c/.test(document.readyState))){
					onload();
				} else {
					addEventListener('load', onload);
					document[_addEventListener]('DOMContentLoaded', throttledCheckElements);
					setTimeout(onload, 20000);
				}

				if(lazysizes.elements.length){
					checkElements();
					rAF._lsFlush();
				} else {
					throttledCheckElements();
				}
			},
			checkElems: throttledCheckElements,
			unveil: unveilElement
		};
	})();


	var autoSizer = (function(){
		var autosizesElems;

		var sizeElement = rAFIt(function(elem, parent, event, width){
			var sources, i, len;
			elem._lazysizesWidth = width;
			width += 'px';

			elem.setAttribute('sizes', width);

			if(regPicture.test(parent.nodeName || '')){
				sources = parent.getElementsByTagName('source');
				for(i = 0, len = sources.length; i < len; i++){
					sources[i].setAttribute('sizes', width);
				}
			}

			if(!event.detail.dataAttr){
				updatePolyfill(elem, event.detail);
			}
		});
		var getSizeElement = function (elem, dataAttr, width){
			var event;
			var parent = elem.parentNode;

			if(parent){
				width = getWidth(elem, parent, width);
				event = triggerEvent(elem, 'lazybeforesizes', {width: width, dataAttr: !!dataAttr});

				if(!event.defaultPrevented){
					width = event.detail.width;

					if(width && width !== elem._lazysizesWidth){
						sizeElement(elem, parent, event, width);
					}
				}
			}
		};

		var updateElementsSizes = function(){
			var i;
			var len = autosizesElems.length;
			if(len){
				i = 0;

				for(; i < len; i++){
					getSizeElement(autosizesElems[i]);
				}
			}
		};

		var debouncedUpdateElementsSizes = debounce(updateElementsSizes);

		return {
			_: function(){
				autosizesElems = document.getElementsByClassName(lazySizesConfig.autosizesClass);
				addEventListener('resize', debouncedUpdateElementsSizes);
			},
			checkElems: debouncedUpdateElementsSizes,
			updateElem: getSizeElement
		};
	})();

	var init = function(){
		if(!init.i){
			init.i = true;
			autoSizer._();
			loader._();
		}
	};

	lazysizes = {
		cfg: lazySizesConfig,
		autoSizer: autoSizer,
		loader: loader,
		init: init,
		uP: updatePolyfill,
		aC: addClass,
		rC: removeClass,
		hC: hasClass,
		fire: triggerEvent,
		gW: getWidth,
		rAF: rAF,
	};

	return lazysizes;
}
));


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return locationsAreEqual; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_resolve_pathname__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_value_equal__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PathUtils__ = __webpack_require__(20);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var createLocation = function createLocation(path, state, key, currentLocation) {
  var location = void 0;
  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = Object(__WEBPACK_IMPORTED_MODULE_2__PathUtils__["d" /* parsePath */])(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = _extends({}, path);

    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_0_resolve_pathname__["a" /* default */])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
};

var locationsAreEqual = function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_1_value_equal__["a" /* default */])(a.state, b.state);
};

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_close.76cae34c.svg";

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * @namespace Chart.helpers
 */
var helpers = {
	/**
	 * An empty function that can be used, for example, for optional callback.
	 */
	noop: function() {},

	/**
	 * Returns a unique id, sequentially generated from a global variable.
	 * @returns {Number}
	 * @function
	 */
	uid: (function() {
		var id = 0;
		return function() {
			return id++;
		};
	}()),

	/**
	 * Returns true if `value` is neither null nor undefined, else returns false.
	 * @param {*} value - The value to test.
	 * @returns {Boolean}
	 * @since 2.7.0
	 */
	isNullOrUndef: function(value) {
		return value === null || typeof value === 'undefined';
	},

	/**
	 * Returns true if `value` is an array, else returns false.
	 * @param {*} value - The value to test.
	 * @returns {Boolean}
	 * @function
	 */
	isArray: Array.isArray ? Array.isArray : function(value) {
		return Object.prototype.toString.call(value) === '[object Array]';
	},

	/**
	 * Returns true if `value` is an object (excluding null), else returns false.
	 * @param {*} value - The value to test.
	 * @returns {Boolean}
	 * @since 2.7.0
	 */
	isObject: function(value) {
		return value !== null && Object.prototype.toString.call(value) === '[object Object]';
	},

	/**
	 * Returns `value` if defined, else returns `defaultValue`.
	 * @param {*} value - The value to return if defined.
	 * @param {*} defaultValue - The value to return if `value` is undefined.
	 * @returns {*}
	 */
	valueOrDefault: function(value, defaultValue) {
		return typeof value === 'undefined' ? defaultValue : value;
	},

	/**
	 * Returns value at the given `index` in array if defined, else returns `defaultValue`.
	 * @param {Array} value - The array to lookup for value at `index`.
	 * @param {Number} index - The index in `value` to lookup for value.
	 * @param {*} defaultValue - The value to return if `value[index]` is undefined.
	 * @returns {*}
	 */
	valueAtIndexOrDefault: function(value, index, defaultValue) {
		return helpers.valueOrDefault(helpers.isArray(value) ? value[index] : value, defaultValue);
	},

	/**
	 * Calls `fn` with the given `args` in the scope defined by `thisArg` and returns the
	 * value returned by `fn`. If `fn` is not a function, this method returns undefined.
	 * @param {Function} fn - The function to call.
	 * @param {Array|undefined|null} args - The arguments with which `fn` should be called.
	 * @param {Object} [thisArg] - The value of `this` provided for the call to `fn`.
	 * @returns {*}
	 */
	callback: function(fn, args, thisArg) {
		if (fn && typeof fn.call === 'function') {
			return fn.apply(thisArg, args);
		}
	},

	/**
	 * Note(SB) for performance sake, this method should only be used when loopable type
	 * is unknown or in none intensive code (not called often and small loopable). Else
	 * it's preferable to use a regular for() loop and save extra function calls.
	 * @param {Object|Array} loopable - The object or array to be iterated.
	 * @param {Function} fn - The function to call for each item.
	 * @param {Object} [thisArg] - The value of `this` provided for the call to `fn`.
	 * @param {Boolean} [reverse] - If true, iterates backward on the loopable.
	 */
	each: function(loopable, fn, thisArg, reverse) {
		var i, len, keys;
		if (helpers.isArray(loopable)) {
			len = loopable.length;
			if (reverse) {
				for (i = len - 1; i >= 0; i--) {
					fn.call(thisArg, loopable[i], i);
				}
			} else {
				for (i = 0; i < len; i++) {
					fn.call(thisArg, loopable[i], i);
				}
			}
		} else if (helpers.isObject(loopable)) {
			keys = Object.keys(loopable);
			len = keys.length;
			for (i = 0; i < len; i++) {
				fn.call(thisArg, loopable[keys[i]], keys[i]);
			}
		}
	},

	/**
	 * Returns true if the `a0` and `a1` arrays have the same content, else returns false.
	 * @see http://stackoverflow.com/a/14853974
	 * @param {Array} a0 - The array to compare
	 * @param {Array} a1 - The array to compare
	 * @returns {Boolean}
	 */
	arrayEquals: function(a0, a1) {
		var i, ilen, v0, v1;

		if (!a0 || !a1 || a0.length !== a1.length) {
			return false;
		}

		for (i = 0, ilen = a0.length; i < ilen; ++i) {
			v0 = a0[i];
			v1 = a1[i];

			if (v0 instanceof Array && v1 instanceof Array) {
				if (!helpers.arrayEquals(v0, v1)) {
					return false;
				}
			} else if (v0 !== v1) {
				// NOTE: two different object instances will never be equal: {x:20} != {x:20}
				return false;
			}
		}

		return true;
	},

	/**
	 * Returns a deep copy of `source` without keeping references on objects and arrays.
	 * @param {*} source - The value to clone.
	 * @returns {*}
	 */
	clone: function(source) {
		if (helpers.isArray(source)) {
			return source.map(helpers.clone);
		}

		if (helpers.isObject(source)) {
			var target = {};
			var keys = Object.keys(source);
			var klen = keys.length;
			var k = 0;

			for (; k < klen; ++k) {
				target[keys[k]] = helpers.clone(source[keys[k]]);
			}

			return target;
		}

		return source;
	},

	/**
	 * The default merger when Chart.helpers.merge is called without merger option.
	 * Note(SB): this method is also used by configMerge and scaleMerge as fallback.
	 * @private
	 */
	_merger: function(key, target, source, options) {
		var tval = target[key];
		var sval = source[key];

		if (helpers.isObject(tval) && helpers.isObject(sval)) {
			helpers.merge(tval, sval, options);
		} else {
			target[key] = helpers.clone(sval);
		}
	},

	/**
	 * Merges source[key] in target[key] only if target[key] is undefined.
	 * @private
	 */
	_mergerIf: function(key, target, source) {
		var tval = target[key];
		var sval = source[key];

		if (helpers.isObject(tval) && helpers.isObject(sval)) {
			helpers.mergeIf(tval, sval);
		} else if (!target.hasOwnProperty(key)) {
			target[key] = helpers.clone(sval);
		}
	},

	/**
	 * Recursively deep copies `source` properties into `target` with the given `options`.
	 * IMPORTANT: `target` is not cloned and will be updated with `source` properties.
	 * @param {Object} target - The target object in which all sources are merged into.
	 * @param {Object|Array(Object)} source - Object(s) to merge into `target`.
	 * @param {Object} [options] - Merging options:
	 * @param {Function} [options.merger] - The merge method (key, target, source, options)
	 * @returns {Object} The `target` object.
	 */
	merge: function(target, source, options) {
		var sources = helpers.isArray(source) ? source : [source];
		var ilen = sources.length;
		var merge, i, keys, klen, k;

		if (!helpers.isObject(target)) {
			return target;
		}

		options = options || {};
		merge = options.merger || helpers._merger;

		for (i = 0; i < ilen; ++i) {
			source = sources[i];
			if (!helpers.isObject(source)) {
				continue;
			}

			keys = Object.keys(source);
			for (k = 0, klen = keys.length; k < klen; ++k) {
				merge(keys[k], target, source, options);
			}
		}

		return target;
	},

	/**
	 * Recursively deep copies `source` properties into `target` *only* if not defined in target.
	 * IMPORTANT: `target` is not cloned and will be updated with `source` properties.
	 * @param {Object} target - The target object in which all sources are merged into.
	 * @param {Object|Array(Object)} source - Object(s) to merge into `target`.
	 * @returns {Object} The `target` object.
	 */
	mergeIf: function(target, source) {
		return helpers.merge(target, source, {merger: helpers._mergerIf});
	},

	/**
	 * Applies the contents of two or more objects together into the first object.
	 * @param {Object} target - The target object in which all objects are merged into.
	 * @param {Object} arg1 - Object containing additional properties to merge in target.
	 * @param {Object} argN - Additional objects containing properties to merge in target.
	 * @returns {Object} The `target` object.
	 */
	extend: function(target) {
		var setFn = function(value, key) {
			target[key] = value;
		};
		for (var i = 1, ilen = arguments.length; i < ilen; ++i) {
			helpers.each(arguments[i], setFn);
		}
		return target;
	},

	/**
	 * Basic javascript inheritance based on the model created in Backbone.js
	 */
	inherits: function(extensions) {
		var me = this;
		var ChartElement = (extensions && extensions.hasOwnProperty('constructor')) ? extensions.constructor : function() {
			return me.apply(this, arguments);
		};

		var Surrogate = function() {
			this.constructor = ChartElement;
		};

		Surrogate.prototype = me.prototype;
		ChartElement.prototype = new Surrogate();
		ChartElement.extend = helpers.inherits;

		if (extensions) {
			helpers.extend(ChartElement.prototype, extensions);
		}

		ChartElement.__super__ = me.prototype;
		return ChartElement;
	}
};

module.exports = helpers;

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart.helpers.callback instead.
 * @function Chart.helpers.callCallback
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 * @private
 */
helpers.callCallback = helpers.callback;

/**
 * Provided for backward compatibility, use Array.prototype.indexOf instead.
 * Array.prototype.indexOf compatibility: Chrome, Opera, Safari, FF1.5+, IE9+
 * @function Chart.helpers.indexOf
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.indexOf = function(array, item, fromIndex) {
	return Array.prototype.indexOf.call(array, item, fromIndex);
};

/**
 * Provided for backward compatibility, use Chart.helpers.valueOrDefault instead.
 * @function Chart.helpers.getValueOrDefault
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.getValueOrDefault = helpers.valueOrDefault;

/**
 * Provided for backward compatibility, use Chart.helpers.valueAtIndexOrDefault instead.
 * @function Chart.helpers.getValueAtIndexOrDefault
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.getValueAtIndexOrDefault = helpers.valueAtIndexOrDefault;


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(238),
    listCacheDelete = __webpack_require__(239),
    listCacheGet = __webpack_require__(240),
    listCacheHas = __webpack_require__(241),
    listCacheSet = __webpack_require__(242);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(36);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 36 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(10);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(14);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(262);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(23),
    isObjectLike = __webpack_require__(26);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(40);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/dryer.939a5631.png";

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);


var createTransitionManager = function createTransitionManager() {
  var prompt = null;

  var setPrompt = function setPrompt(nextPrompt) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(prompt == null, 'A history supports only one prompt at a time');

    prompt = nextPrompt;

    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
          __WEBPACK_IMPORTED_MODULE_0_warning___default()(false, 'A history needs a getUserConfirmation function in order to use a prompt message');

          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  };

  var listeners = [];

  var appendListener = function appendListener(fn) {
    var isActive = true;

    var listener = function listener() {
      if (isActive) fn.apply(undefined, arguments);
    };

    listeners.push(listener);

    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var notifyListeners = function notifyListeners() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(undefined, args);
    });
  };

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createTransitionManager);

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__ = __webpack_require__(47);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__["a" /* default */]);

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, "A <Router> may have only one child element");

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, "You cannot change <Router history>");
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var parent = arguments[2];

  if (typeof options === "string") options = { path: options };

  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;


  if (path == null) return parent;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === "/" && url === "" ? "/" : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),
/* 49 */
/***/ (function(module, exports) {

module.exports = [{"id":1,"name":"GTX-Setup XS","short_name":"XS","capacity":35,"items":[{"id":1,"qty":1},{"id":2,"qty":1},{"id":3,"qty":1},{"id":4,"qty":0},{"id":5,"qty":0}]},{"id":2,"name":"GTX-Setup S","short_name":"S","capacity":70,"items":[{"id":1,"qty":2},{"id":2,"qty":2},{"id":3,"qty":1},{"id":4,"qty":0},{"id":5,"qty":0}]},{"id":3,"name":"GTX-Setup M","short_name":"M","capacity":105,"items":[{"id":1,"qty":3},{"id":2,"qty":1},{"id":3,"qty":1},{"id":4,"qty":0},{"id":5,"qty":1}]},{"id":4,"name":"GTX-Setup L","short_name":"L","capacity":140,"items":[{"id":1,"qty":4},{"id":2,"qty":1},{"id":3,"qty":1},{"id":4,"qty":0},{"id":5,"qty":1}]},{"id":5,"name":"GTX-Setup XL","short_name":"XL","capacity":175,"items":[{"id":1,"qty":5},{"id":2,"qty":1},{"id":3,"qty":1},{"id":4,"qty":0},{"id":5,"qty":1}]},{"id":6,"name":"GTX-Setup XXL","short_name":"XXL","capacity":210,"items":[{"id":1,"qty":6},{"id":2,"qty":0},{"id":3,"qty":0},{"id":4,"qty":1},{"id":5,"qty":1}]}]

/***/ }),
/* 50 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(52);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(237),
    isObjectLike = __webpack_require__(26);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(14),
    root = __webpack_require__(10);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(254),
    mapCacheDelete = __webpack_require__(261),
    mapCacheGet = __webpack_require__(263),
    mapCacheHas = __webpack_require__(264),
    mapCacheSet = __webpack_require__(265);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 55 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 56 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(299),
    baseMatchesProperty = __webpack_require__(302),
    identity = __webpack_require__(59),
    isArray = __webpack_require__(11),
    property = __webpack_require__(313);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(11),
    isSymbol = __webpack_require__(40);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 59 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(91);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(102);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 62 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return canUseDOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addEventListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return removeEventListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getConfirmation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return supportsHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return supportsPopStateOnHashChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return supportsGoWithoutReloadUsingHash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isExtraneousPopstateEvent; });
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

var getConfirmation = function getConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(15);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore everything but left clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ["replace", "to", "innerRef"]); // eslint-disable-line no-unused-vars

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Link> outside a <Router>");

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(to !== undefined, 'You must specify the "to" property');

    var history = this.context.router.history;

    var location = typeof to === "string" ? Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(to, null, null, history.location) : to;

    var href = history.createHref(location);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__ = __webpack_require__(67);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__["a" /* default */]);

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(48);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var isEmptyChildren = function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(router, "You should not use <Route> or withRouter() outside a <Router>");

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }, route.match);
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    if (component) return match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : null;

    if (render) return match ? render(props) : null;

    if (typeof children === "function") return children(props);

    if (children && !isEmptyChildren(children)) return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children);

    return null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  sensitive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(139)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compileGenerator = function compileGenerator(pattern) {
  var cacheKey = pattern;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var compiledGenerator = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default.a.compile(pattern);

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledGenerator;
    cacheCount++;
  }

  return compiledGenerator;
};

/**
 * Public API for generating a URL pathname from a pattern and parameters.
 */
var generatePath = function generatePath() {
  var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (pattern === "/") {
    return pattern;
  }
  var generator = compileGenerator(pattern);
  return generator(params, { pretty: true });
};

/* harmony default export */ __webpack_exports__["a"] = (generatePath);

/***/ }),
/* 70 */
/***/ (function(module, exports) {

module.exports = [{"id":1,"symbol":"€"},{"id":3,"symbol":"US$"}]

/***/ }),
/* 71 */
/***/ (function(module, exports) {

module.exports = [{"id":1,"name":"GTX Printer","localeName":"gtxprinter","prices":[{"id":1,"price":19995},{"id":3,"price":22695}]},{"id":2,"name":"Transferpresse","localeName":"transferpresse","prices":[{"id":1,"price":1290},{"id":3,"price":1548}]},{"id":3,"name":"Pretreatmaker","localeName":"pretreatmaker","prices":[{"id":1,"price":4339},{"id":3,"price":5206.8}]},{"id":4,"name":"Pretreatmaker LINE","localeName":"pretreatmakerLine","prices":[{"id":1,"price":75000},{"id":3,"price":90000}]},{"id":5,"name":"Tunneltrockner","localeName":"tunneltrockner","prices":[{"id":1,"price":15300},{"id":3,"price":18360}]}]

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_icons_icon_close_svg__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_icons_icon_close_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_icons_icon_close_svg__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var classNames=__webpack_require__(7);var ReadOnlyInput=function(_Component){_inherits(ReadOnlyInput,_Component);function ReadOnlyInput(props){_classCallCheck(this,ReadOnlyInput);var _this=_possibleConstructorReturn(this,(ReadOnlyInput.__proto__||Object.getPrototypeOf(ReadOnlyInput)).call(this,props));_this.handleInfoModal=function(){var infoModal=_this.refs.infoModal;var activeState=_this.state.infoActive;var section=_this.refs.section;if(infoModal!==undefined&&section!==undefined){if(activeState){infoModal.classList.remove(_this.props.styles.infoModalActive);section.classList.remove(_this.props.styles.containerRotate);_this.setState({infoActive:false});}else{infoModal.classList.add(_this.props.styles.infoModalActive);section.classList.add(_this.props.styles.containerRotate);_this.setState({infoActive:true});}}};_this.state={infoActive:false};return _this;}_createClass(ReadOnlyInput,[{key:'render',value:function render(){var styles=this.props.styles;var fullWidthStyleClass=this.props.fullWidth==="true"?styles.full:'';var separator=this.props.currency!==undefined&&this.props.unitInfo?" / ":"";var localisedNumber=this.props.floatValue?this.props.value:Number(parseFloat(this.props.value).toFixed(2)).toLocaleString('de-DE');var isHighlightedBoxStyles=this.props.highlightBox?styles.highlight:null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{ref:'section',className:classNames(styles.inputItem,fullWidthStyleClass,isHighlightedBoxStyles)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:styles.info},this.props.helpText&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:this.props.icon,alt:'Info',onMouseDown:this.handleInfoModal}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:styles.infoModal,ref:'infoModal',onMouseDown:this.handleInfoModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,this.props.description),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,this.props.helpText),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__assets_icons_icon_close_svg___default.a,alt:'Info',onMouseDown:this.handleInfoModal})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:this.props.type,className:styles.inputField,placeholder:localisedNumber,disabled:'disabled'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.props.currency!==undefined&&this.props.currency.symbol,' ',separator,' ',this.props.unitInfo),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:styles.bottom},this.props.description));}}]);return ReadOnlyInput;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ReadOnlyInput);

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Doughnut; });
/* unused harmony export Pie */
/* unused harmony export Line */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Bar; });
/* unused harmony export HorizontalBar */
/* unused harmony export Radar */
/* unused harmony export Polar */
/* unused harmony export Bubble */
/* unused harmony export Scatter */
/* unused harmony export defaults */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chart_js__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isEqual__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_find__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_keyBy__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_keyBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_keyBy__);
/* unused harmony reexport Chart */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var NODE_ENV = typeof process !== 'undefined' && Object({"NODE_ENV":"production","PUBLIC_URL":"."}) && "production";

var ChartComponent = function (_React$Component) {
  _inherits(ChartComponent, _React$Component);

  function ChartComponent() {
    var _temp, _this, _ret;

    _classCallCheck(this, ChartComponent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleOnClick = function (event) {
      var instance = _this.chartInstance;

      var _this$props = _this.props,
          getDatasetAtEvent = _this$props.getDatasetAtEvent,
          getElementAtEvent = _this$props.getElementAtEvent,
          getElementsAtEvent = _this$props.getElementsAtEvent,
          onElementsClick = _this$props.onElementsClick;


      getDatasetAtEvent && getDatasetAtEvent(instance.getDatasetAtEvent(event), event);
      getElementAtEvent && getElementAtEvent(instance.getElementAtEvent(event), event);
      getElementsAtEvent && getElementsAtEvent(instance.getElementsAtEvent(event), event);
      onElementsClick && onElementsClick(instance.getElementsAtEvent(event), event); // Backward compatibility
    }, _this.ref = function (element) {
      _this.element = element;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  ChartComponent.prototype.componentWillMount = function componentWillMount() {
    this.chartInstance = undefined;
  };

  ChartComponent.prototype.componentDidMount = function componentDidMount() {
    this.renderChart();
  };

  ChartComponent.prototype.componentDidUpdate = function componentDidUpdate() {
    if (this.props.redraw) {
      this.chartInstance.destroy();
      this.renderChart();
      return;
    }

    this.updateChart();
  };

  ChartComponent.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    var _props = this.props,
        redraw = _props.redraw,
        type = _props.type,
        options = _props.options,
        plugins = _props.plugins,
        legend = _props.legend,
        height = _props.height,
        width = _props.width;


    if (nextProps.redraw === true) {
      return true;
    }

    if (height !== nextProps.height || width !== nextProps.width) {
      return true;
    }

    if (type !== nextProps.type) {
      return true;
    }

    if (!__WEBPACK_IMPORTED_MODULE_3_lodash_isEqual___default()(legend, nextProps.legend)) {
      return true;
    }

    if (!__WEBPACK_IMPORTED_MODULE_3_lodash_isEqual___default()(options, nextProps.options)) {
      return true;
    }

    var nextData = this.transformDataProp(nextProps);

    if (!__WEBPACK_IMPORTED_MODULE_3_lodash_isEqual___default()(this.shadowDataProp, nextData)) {
      return true;
    }

    return !__WEBPACK_IMPORTED_MODULE_3_lodash_isEqual___default()(plugins, nextProps.plugins);
  };

  ChartComponent.prototype.componentWillUnmount = function componentWillUnmount() {
    this.chartInstance.destroy();
  };

  ChartComponent.prototype.transformDataProp = function transformDataProp(props) {
    var data = props.data;

    if (typeof data == 'function') {
      var node = this.element;
      return data(node);
    } else {
      return data;
    }
  };

  // Chart.js directly mutates the data.dataset objects by adding _meta proprerty
  // this makes impossible to compare the current and next data changes
  // therefore we memoize the data prop while sending a fake to Chart.js for mutation.
  // see https://github.com/chartjs/Chart.js/blob/master/src/core/core.controller.js#L615-L617


  ChartComponent.prototype.memoizeDataProps = function memoizeDataProps() {
    if (!this.props.data) {
      return;
    }

    var data = this.transformDataProp(this.props);

    this.shadowDataProp = _extends({}, data, {
      datasets: data.datasets && data.datasets.map(function (set) {
        return _extends({}, set);
      })
    });

    return data;
  };

  ChartComponent.prototype.checkDatasets = function checkDatasets(datasets) {
    var isDev = NODE_ENV !== 'production' && NODE_ENV !== 'prod';
    var usingCustomKeyProvider = this.props.datasetKeyProvider !== ChartComponent.getLabelAsKey;
    var multipleDatasets = datasets.length > 1;

    if (isDev && multipleDatasets && !usingCustomKeyProvider) {
      var shouldWarn = false;
      datasets.forEach(function (dataset) {
        if (!dataset.label) {
          shouldWarn = true;
        }
      });

      if (shouldWarn) {
        console.error('[react-chartjs-2] Warning: Each dataset needs a unique key. By default, the "label" property on each dataset is used. Alternatively, you may provide a "datasetKeyProvider" as a prop that returns a unique key.');
      }
    }
  };

  ChartComponent.prototype.updateChart = function updateChart() {
    var _this2 = this;

    var options = this.props.options;


    var data = this.memoizeDataProps(this.props);

    if (!this.chartInstance) return;

    if (options) {
      this.chartInstance.options = __WEBPACK_IMPORTED_MODULE_2_chart_js___default.a.helpers.configMerge(this.chartInstance.options, options);
    }

    // Pipe datasets to chart instance datasets enabling
    // seamless transitions
    var currentDatasets = this.chartInstance.config.data && this.chartInstance.config.data.datasets || [];
    var nextDatasets = data.datasets || [];
    this.checkDatasets(currentDatasets);

    var currentDatasetsIndexed = __WEBPACK_IMPORTED_MODULE_5_lodash_keyBy___default()(currentDatasets, this.props.datasetKeyProvider);

    // We can safely replace the dataset array, as long as we retain the _meta property
    // on each dataset.
    this.chartInstance.config.data.datasets = nextDatasets.map(function (next) {
      var current = currentDatasetsIndexed[_this2.props.datasetKeyProvider(next)];

      if (current && current.type === next.type) {
        // The data array must be edited in place. As chart.js adds listeners to it.
        current.data.splice(next.data.length);
        next.data.forEach(function (point, pid) {
          current.data[pid] = next.data[pid];
        });

        var _data = next.data,
            otherProps = _objectWithoutProperties(next, ['data']);
        // Merge properties. Notice a weakness here. If a property is removed
        // from next, it will be retained by current and never disappears.
        // Workaround is to set value to null or undefined in next.


        return _extends({}, current, otherProps);
      } else {
        return next;
      }
    });

    var datasets = data.datasets,
        rest = _objectWithoutProperties(data, ['datasets']);

    this.chartInstance.config.data = _extends({}, this.chartInstance.config.data, rest);

    this.chartInstance.update();
  };

  ChartComponent.prototype.renderChart = function renderChart() {
    var _props2 = this.props,
        options = _props2.options,
        legend = _props2.legend,
        type = _props2.type,
        redraw = _props2.redraw,
        plugins = _props2.plugins;

    var node = this.element;
    var data = this.memoizeDataProps();

    if (typeof legend !== 'undefined' && !__WEBPACK_IMPORTED_MODULE_3_lodash_isEqual___default()(ChartComponent.defaultProps.legend, legend)) {
      options.legend = legend;
    }

    this.chartInstance = new __WEBPACK_IMPORTED_MODULE_2_chart_js___default.a(node, {
      type: type,
      data: data,
      options: options,
      plugins: plugins
    });
  };

  ChartComponent.prototype.render = function render() {
    var _props3 = this.props,
        height = _props3.height,
        width = _props3.width,
        onElementsClick = _props3.onElementsClick;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('canvas', {
      ref: this.ref,
      height: height,
      width: width,
      onClick: this.handleOnClick
    });
  };

  return ChartComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

ChartComponent.getLabelAsKey = function (d) {
  return d.label;
};

ChartComponent.propTypes = {
  data: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]).isRequired,
  getDatasetAtEvent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  getElementAtEvent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  getElementsAtEvent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  height: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  legend: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  onElementsClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  options: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  plugins: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object),
  redraw: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  type: function type(props, propName, componentName) {
    if (!__WEBPACK_IMPORTED_MODULE_2_chart_js___default.a.controllers[props[propName]]) {
      return new Error('Invalid chart type `' + props[propName] + '` supplied to' + ' `' + componentName + '`.');
    }
  },
  width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  datasetKeyProvider: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};
ChartComponent.defaultProps = {
  legend: {
    display: true,
    position: 'bottom'
  },
  type: 'doughnut',
  height: 150,
  width: 300,
  redraw: false,
  options: {},
  datasetKeyProvider: ChartComponent.getLabelAsKey
};


/* unused harmony default export */ var _unused_webpack_default_export = (ChartComponent);

var Doughnut = function (_React$Component2) {
  _inherits(Doughnut, _React$Component2);

  function Doughnut() {
    _classCallCheck(this, Doughnut);

    return _possibleConstructorReturn(this, _React$Component2.apply(this, arguments));
  }

  Doughnut.prototype.render = function render() {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChartComponent, _extends({}, this.props, {
      ref: function ref(_ref) {
        return _this4.chartInstance = _ref && _ref.chartInstance;
      },
      type: 'doughnut'
    }));
  };

  return Doughnut;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var Pie = function (_React$Component3) {
  _inherits(Pie, _React$Component3);

  function Pie() {
    _classCallCheck(this, Pie);

    return _possibleConstructorReturn(this, _React$Component3.apply(this, arguments));
  }

  Pie.prototype.render = function render() {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChartComponent, _extends({}, this.props, {
      ref: function ref(_ref2) {
        return _this6.chartInstance = _ref2 && _ref2.chartInstance;
      },
      type: 'pie'
    }));
  };

  return Pie;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var Line = function (_React$Component4) {
  _inherits(Line, _React$Component4);

  function Line() {
    _classCallCheck(this, Line);

    return _possibleConstructorReturn(this, _React$Component4.apply(this, arguments));
  }

  Line.prototype.render = function render() {
    var _this8 = this;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChartComponent, _extends({}, this.props, {
      ref: function ref(_ref3) {
        return _this8.chartInstance = _ref3 && _ref3.chartInstance;
      },
      type: 'line'
    }));
  };

  return Line;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var Bar = function (_React$Component5) {
  _inherits(Bar, _React$Component5);

  function Bar() {
    _classCallCheck(this, Bar);

    return _possibleConstructorReturn(this, _React$Component5.apply(this, arguments));
  }

  Bar.prototype.render = function render() {
    var _this10 = this;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChartComponent, _extends({}, this.props, {
      ref: function ref(_ref4) {
        return _this10.chartInstance = _ref4 && _ref4.chartInstance;
      },
      type: 'bar'
    }));
  };

  return Bar;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var HorizontalBar = function (_React$Component6) {
  _inherits(HorizontalBar, _React$Component6);

  function HorizontalBar() {
    _classCallCheck(this, HorizontalBar);

    return _possibleConstructorReturn(this, _React$Component6.apply(this, arguments));
  }

  HorizontalBar.prototype.render = function render() {
    var _this12 = this;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChartComponent, _extends({}, this.props, {
      ref: function ref(_ref5) {
        return _this12.chartInstance = _ref5 && _ref5.chartInstance;
      },
      type: 'horizontalBar'
    }));
  };

  return HorizontalBar;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var Radar = function (_React$Component7) {
  _inherits(Radar, _React$Component7);

  function Radar() {
    _classCallCheck(this, Radar);

    return _possibleConstructorReturn(this, _React$Component7.apply(this, arguments));
  }

  Radar.prototype.render = function render() {
    var _this14 = this;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChartComponent, _extends({}, this.props, {
      ref: function ref(_ref6) {
        return _this14.chartInstance = _ref6 && _ref6.chartInstance;
      },
      type: 'radar'
    }));
  };

  return Radar;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var Polar = function (_React$Component8) {
  _inherits(Polar, _React$Component8);

  function Polar() {
    _classCallCheck(this, Polar);

    return _possibleConstructorReturn(this, _React$Component8.apply(this, arguments));
  }

  Polar.prototype.render = function render() {
    var _this16 = this;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChartComponent, _extends({}, this.props, {
      ref: function ref(_ref7) {
        return _this16.chartInstance = _ref7 && _ref7.chartInstance;
      },
      type: 'polarArea'
    }));
  };

  return Polar;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var Bubble = function (_React$Component9) {
  _inherits(Bubble, _React$Component9);

  function Bubble() {
    _classCallCheck(this, Bubble);

    return _possibleConstructorReturn(this, _React$Component9.apply(this, arguments));
  }

  Bubble.prototype.render = function render() {
    var _this18 = this;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChartComponent, _extends({}, this.props, {
      ref: function ref(_ref8) {
        return _this18.chartInstance = _ref8 && _ref8.chartInstance;
      },
      type: 'bubble'
    }));
  };

  return Bubble;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var Scatter = function (_React$Component10) {
  _inherits(Scatter, _React$Component10);

  function Scatter() {
    _classCallCheck(this, Scatter);

    return _possibleConstructorReturn(this, _React$Component10.apply(this, arguments));
  }

  Scatter.prototype.render = function render() {
    var _this20 = this;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChartComponent, _extends({}, this.props, {
      ref: function ref(_ref9) {
        return _this20.chartInstance = _ref9 && _ref9.chartInstance;
      },
      type: 'scatter'
    }));
  };

  return Scatter;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var defaults = __WEBPACK_IMPORTED_MODULE_2_chart_js___default.a.defaults;

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(189)))

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

/* MIT license */
var convert = __webpack_require__(196);
var string = __webpack_require__(198);

var Color = function (obj) {
	if (obj instanceof Color) {
		return obj;
	}
	if (!(this instanceof Color)) {
		return new Color(obj);
	}

	this.valid = false;
	this.values = {
		rgb: [0, 0, 0],
		hsl: [0, 0, 0],
		hsv: [0, 0, 0],
		hwb: [0, 0, 0],
		cmyk: [0, 0, 0, 0],
		alpha: 1
	};

	// parse Color() argument
	var vals;
	if (typeof obj === 'string') {
		vals = string.getRgba(obj);
		if (vals) {
			this.setValues('rgb', vals);
		} else if (vals = string.getHsla(obj)) {
			this.setValues('hsl', vals);
		} else if (vals = string.getHwb(obj)) {
			this.setValues('hwb', vals);
		}
	} else if (typeof obj === 'object') {
		vals = obj;
		if (vals.r !== undefined || vals.red !== undefined) {
			this.setValues('rgb', vals);
		} else if (vals.l !== undefined || vals.lightness !== undefined) {
			this.setValues('hsl', vals);
		} else if (vals.v !== undefined || vals.value !== undefined) {
			this.setValues('hsv', vals);
		} else if (vals.w !== undefined || vals.whiteness !== undefined) {
			this.setValues('hwb', vals);
		} else if (vals.c !== undefined || vals.cyan !== undefined) {
			this.setValues('cmyk', vals);
		}
	}
};

Color.prototype = {
	isValid: function () {
		return this.valid;
	},
	rgb: function () {
		return this.setSpace('rgb', arguments);
	},
	hsl: function () {
		return this.setSpace('hsl', arguments);
	},
	hsv: function () {
		return this.setSpace('hsv', arguments);
	},
	hwb: function () {
		return this.setSpace('hwb', arguments);
	},
	cmyk: function () {
		return this.setSpace('cmyk', arguments);
	},

	rgbArray: function () {
		return this.values.rgb;
	},
	hslArray: function () {
		return this.values.hsl;
	},
	hsvArray: function () {
		return this.values.hsv;
	},
	hwbArray: function () {
		var values = this.values;
		if (values.alpha !== 1) {
			return values.hwb.concat([values.alpha]);
		}
		return values.hwb;
	},
	cmykArray: function () {
		return this.values.cmyk;
	},
	rgbaArray: function () {
		var values = this.values;
		return values.rgb.concat([values.alpha]);
	},
	hslaArray: function () {
		var values = this.values;
		return values.hsl.concat([values.alpha]);
	},
	alpha: function (val) {
		if (val === undefined) {
			return this.values.alpha;
		}
		this.setValues('alpha', val);
		return this;
	},

	red: function (val) {
		return this.setChannel('rgb', 0, val);
	},
	green: function (val) {
		return this.setChannel('rgb', 1, val);
	},
	blue: function (val) {
		return this.setChannel('rgb', 2, val);
	},
	hue: function (val) {
		if (val) {
			val %= 360;
			val = val < 0 ? 360 + val : val;
		}
		return this.setChannel('hsl', 0, val);
	},
	saturation: function (val) {
		return this.setChannel('hsl', 1, val);
	},
	lightness: function (val) {
		return this.setChannel('hsl', 2, val);
	},
	saturationv: function (val) {
		return this.setChannel('hsv', 1, val);
	},
	whiteness: function (val) {
		return this.setChannel('hwb', 1, val);
	},
	blackness: function (val) {
		return this.setChannel('hwb', 2, val);
	},
	value: function (val) {
		return this.setChannel('hsv', 2, val);
	},
	cyan: function (val) {
		return this.setChannel('cmyk', 0, val);
	},
	magenta: function (val) {
		return this.setChannel('cmyk', 1, val);
	},
	yellow: function (val) {
		return this.setChannel('cmyk', 2, val);
	},
	black: function (val) {
		return this.setChannel('cmyk', 3, val);
	},

	hexString: function () {
		return string.hexString(this.values.rgb);
	},
	rgbString: function () {
		return string.rgbString(this.values.rgb, this.values.alpha);
	},
	rgbaString: function () {
		return string.rgbaString(this.values.rgb, this.values.alpha);
	},
	percentString: function () {
		return string.percentString(this.values.rgb, this.values.alpha);
	},
	hslString: function () {
		return string.hslString(this.values.hsl, this.values.alpha);
	},
	hslaString: function () {
		return string.hslaString(this.values.hsl, this.values.alpha);
	},
	hwbString: function () {
		return string.hwbString(this.values.hwb, this.values.alpha);
	},
	keyword: function () {
		return string.keyword(this.values.rgb, this.values.alpha);
	},

	rgbNumber: function () {
		var rgb = this.values.rgb;
		return (rgb[0] << 16) | (rgb[1] << 8) | rgb[2];
	},

	luminosity: function () {
		// http://www.w3.org/TR/WCAG20/#relativeluminancedef
		var rgb = this.values.rgb;
		var lum = [];
		for (var i = 0; i < rgb.length; i++) {
			var chan = rgb[i] / 255;
			lum[i] = (chan <= 0.03928) ? chan / 12.92 : Math.pow(((chan + 0.055) / 1.055), 2.4);
		}
		return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
	},

	contrast: function (color2) {
		// http://www.w3.org/TR/WCAG20/#contrast-ratiodef
		var lum1 = this.luminosity();
		var lum2 = color2.luminosity();
		if (lum1 > lum2) {
			return (lum1 + 0.05) / (lum2 + 0.05);
		}
		return (lum2 + 0.05) / (lum1 + 0.05);
	},

	level: function (color2) {
		var contrastRatio = this.contrast(color2);
		if (contrastRatio >= 7.1) {
			return 'AAA';
		}

		return (contrastRatio >= 4.5) ? 'AA' : '';
	},

	dark: function () {
		// YIQ equation from http://24ways.org/2010/calculating-color-contrast
		var rgb = this.values.rgb;
		var yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
		return yiq < 128;
	},

	light: function () {
		return !this.dark();
	},

	negate: function () {
		var rgb = [];
		for (var i = 0; i < 3; i++) {
			rgb[i] = 255 - this.values.rgb[i];
		}
		this.setValues('rgb', rgb);
		return this;
	},

	lighten: function (ratio) {
		var hsl = this.values.hsl;
		hsl[2] += hsl[2] * ratio;
		this.setValues('hsl', hsl);
		return this;
	},

	darken: function (ratio) {
		var hsl = this.values.hsl;
		hsl[2] -= hsl[2] * ratio;
		this.setValues('hsl', hsl);
		return this;
	},

	saturate: function (ratio) {
		var hsl = this.values.hsl;
		hsl[1] += hsl[1] * ratio;
		this.setValues('hsl', hsl);
		return this;
	},

	desaturate: function (ratio) {
		var hsl = this.values.hsl;
		hsl[1] -= hsl[1] * ratio;
		this.setValues('hsl', hsl);
		return this;
	},

	whiten: function (ratio) {
		var hwb = this.values.hwb;
		hwb[1] += hwb[1] * ratio;
		this.setValues('hwb', hwb);
		return this;
	},

	blacken: function (ratio) {
		var hwb = this.values.hwb;
		hwb[2] += hwb[2] * ratio;
		this.setValues('hwb', hwb);
		return this;
	},

	greyscale: function () {
		var rgb = this.values.rgb;
		// http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
		var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
		this.setValues('rgb', [val, val, val]);
		return this;
	},

	clearer: function (ratio) {
		var alpha = this.values.alpha;
		this.setValues('alpha', alpha - (alpha * ratio));
		return this;
	},

	opaquer: function (ratio) {
		var alpha = this.values.alpha;
		this.setValues('alpha', alpha + (alpha * ratio));
		return this;
	},

	rotate: function (degrees) {
		var hsl = this.values.hsl;
		var hue = (hsl[0] + degrees) % 360;
		hsl[0] = hue < 0 ? 360 + hue : hue;
		this.setValues('hsl', hsl);
		return this;
	},

	/**
	 * Ported from sass implementation in C
	 * https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
	 */
	mix: function (mixinColor, weight) {
		var color1 = this;
		var color2 = mixinColor;
		var p = weight === undefined ? 0.5 : weight;

		var w = 2 * p - 1;
		var a = color1.alpha() - color2.alpha();

		var w1 = (((w * a === -1) ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
		var w2 = 1 - w1;

		return this
			.rgb(
				w1 * color1.red() + w2 * color2.red(),
				w1 * color1.green() + w2 * color2.green(),
				w1 * color1.blue() + w2 * color2.blue()
			)
			.alpha(color1.alpha() * p + color2.alpha() * (1 - p));
	},

	toJSON: function () {
		return this.rgb();
	},

	clone: function () {
		// NOTE(SB): using node-clone creates a dependency to Buffer when using browserify,
		// making the final build way to big to embed in Chart.js. So let's do it manually,
		// assuming that values to clone are 1 dimension arrays containing only numbers,
		// except 'alpha' which is a number.
		var result = new Color();
		var source = this.values;
		var target = result.values;
		var value, type;

		for (var prop in source) {
			if (source.hasOwnProperty(prop)) {
				value = source[prop];
				type = ({}).toString.call(value);
				if (type === '[object Array]') {
					target[prop] = value.slice(0);
				} else if (type === '[object Number]') {
					target[prop] = value;
				} else {
					console.error('unexpected color value:', value);
				}
			}
		}

		return result;
	}
};

Color.prototype.spaces = {
	rgb: ['red', 'green', 'blue'],
	hsl: ['hue', 'saturation', 'lightness'],
	hsv: ['hue', 'saturation', 'value'],
	hwb: ['hue', 'whiteness', 'blackness'],
	cmyk: ['cyan', 'magenta', 'yellow', 'black']
};

Color.prototype.maxes = {
	rgb: [255, 255, 255],
	hsl: [360, 100, 100],
	hsv: [360, 100, 100],
	hwb: [360, 100, 100],
	cmyk: [100, 100, 100, 100]
};

Color.prototype.getValues = function (space) {
	var values = this.values;
	var vals = {};

	for (var i = 0; i < space.length; i++) {
		vals[space.charAt(i)] = values[space][i];
	}

	if (values.alpha !== 1) {
		vals.a = values.alpha;
	}

	// {r: 255, g: 255, b: 255, a: 0.4}
	return vals;
};

Color.prototype.setValues = function (space, vals) {
	var values = this.values;
	var spaces = this.spaces;
	var maxes = this.maxes;
	var alpha = 1;
	var i;

	this.valid = true;

	if (space === 'alpha') {
		alpha = vals;
	} else if (vals.length) {
		// [10, 10, 10]
		values[space] = vals.slice(0, space.length);
		alpha = vals[space.length];
	} else if (vals[space.charAt(0)] !== undefined) {
		// {r: 10, g: 10, b: 10}
		for (i = 0; i < space.length; i++) {
			values[space][i] = vals[space.charAt(i)];
		}

		alpha = vals.a;
	} else if (vals[spaces[space][0]] !== undefined) {
		// {red: 10, green: 10, blue: 10}
		var chans = spaces[space];

		for (i = 0; i < space.length; i++) {
			values[space][i] = vals[chans[i]];
		}

		alpha = vals.alpha;
	}

	values.alpha = Math.max(0, Math.min(1, (alpha === undefined ? values.alpha : alpha)));

	if (space === 'alpha') {
		return false;
	}

	var capped;

	// cap values of the space prior converting all values
	for (i = 0; i < space.length; i++) {
		capped = Math.max(0, Math.min(maxes[space][i], values[space][i]));
		values[space][i] = Math.round(capped);
	}

	// convert to all the other color spaces
	for (var sname in spaces) {
		if (sname !== space) {
			values[sname] = convert[space][sname](values[space]);
		}
	}

	return true;
};

Color.prototype.setSpace = function (space, args) {
	var vals = args[0];

	if (vals === undefined) {
		// color.rgb()
		return this.getValues(space);
	}

	// color.rgb(10, 10, 10)
	if (typeof vals === 'number') {
		vals = Array.prototype.slice.call(args);
	}

	this.setValues(space, vals);
	return this;
};

Color.prototype.setChannel = function (space, index, val) {
	var svalues = this.values[space];
	if (val === undefined) {
		// color.red()
		return svalues[index];
	} else if (val === svalues[index]) {
		// color.red(color.red())
		return this;
	}

	// color.red(100)
	svalues[index] = val;
	this.setValues(space, svalues);

	return this;
};

if (typeof window !== 'undefined') {
	window.Color = Color;
}

module.exports = Color;


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var helpers = __webpack_require__(1);

/**
 * Helper function to get relative position for an event
 * @param {Event|IEvent} event - The event to get the position for
 * @param {Chart} chart - The chart
 * @returns {Point} the event position
 */
function getRelativePosition(e, chart) {
	if (e.native) {
		return {
			x: e.x,
			y: e.y
		};
	}

	return helpers.getRelativePosition(e, chart);
}

/**
 * Helper function to traverse all of the visible elements in the chart
 * @param chart {chart} the chart
 * @param handler {Function} the callback to execute for each visible item
 */
function parseVisibleItems(chart, handler) {
	var datasets = chart.data.datasets;
	var meta, i, j, ilen, jlen;

	for (i = 0, ilen = datasets.length; i < ilen; ++i) {
		if (!chart.isDatasetVisible(i)) {
			continue;
		}

		meta = chart.getDatasetMeta(i);
		for (j = 0, jlen = meta.data.length; j < jlen; ++j) {
			var element = meta.data[j];
			if (!element._view.skip) {
				handler(element);
			}
		}
	}
}

/**
 * Helper function to get the items that intersect the event position
 * @param items {ChartElement[]} elements to filter
 * @param position {Point} the point to be nearest to
 * @return {ChartElement[]} the nearest items
 */
function getIntersectItems(chart, position) {
	var elements = [];

	parseVisibleItems(chart, function(element) {
		if (element.inRange(position.x, position.y)) {
			elements.push(element);
		}
	});

	return elements;
}

/**
 * Helper function to get the items nearest to the event position considering all visible items in teh chart
 * @param chart {Chart} the chart to look at elements from
 * @param position {Point} the point to be nearest to
 * @param intersect {Boolean} if true, only consider items that intersect the position
 * @param distanceMetric {Function} function to provide the distance between points
 * @return {ChartElement[]} the nearest items
 */
function getNearestItems(chart, position, intersect, distanceMetric) {
	var minDistance = Number.POSITIVE_INFINITY;
	var nearestItems = [];

	parseVisibleItems(chart, function(element) {
		if (intersect && !element.inRange(position.x, position.y)) {
			return;
		}

		var center = element.getCenterPoint();
		var distance = distanceMetric(position, center);

		if (distance < minDistance) {
			nearestItems = [element];
			minDistance = distance;
		} else if (distance === minDistance) {
			// Can have multiple items at the same distance in which case we sort by size
			nearestItems.push(element);
		}
	});

	return nearestItems;
}

/**
 * Get a distance metric function for two points based on the
 * axis mode setting
 * @param {String} axis the axis mode. x|y|xy
 */
function getDistanceMetricForAxis(axis) {
	var useX = axis.indexOf('x') !== -1;
	var useY = axis.indexOf('y') !== -1;

	return function(pt1, pt2) {
		var deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
		var deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
		return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
	};
}

function indexMode(chart, e, options) {
	var position = getRelativePosition(e, chart);
	// Default axis for index mode is 'x' to match old behaviour
	options.axis = options.axis || 'x';
	var distanceMetric = getDistanceMetricForAxis(options.axis);
	var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);
	var elements = [];

	if (!items.length) {
		return [];
	}

	chart.data.datasets.forEach(function(dataset, datasetIndex) {
		if (chart.isDatasetVisible(datasetIndex)) {
			var meta = chart.getDatasetMeta(datasetIndex);
			var element = meta.data[items[0]._index];

			// don't count items that are skipped (null data)
			if (element && !element._view.skip) {
				elements.push(element);
			}
		}
	});

	return elements;
}

/**
 * @interface IInteractionOptions
 */
/**
 * If true, only consider items that intersect the point
 * @name IInterfaceOptions#boolean
 * @type Boolean
 */

/**
 * Contains interaction related functions
 * @namespace Chart.Interaction
 */
module.exports = {
	// Helper function for different modes
	modes: {
		single: function(chart, e) {
			var position = getRelativePosition(e, chart);
			var elements = [];

			parseVisibleItems(chart, function(element) {
				if (element.inRange(position.x, position.y)) {
					elements.push(element);
					return elements;
				}
			});

			return elements.slice(0, 1);
		},

		/**
		 * @function Chart.Interaction.modes.label
		 * @deprecated since version 2.4.0
		 * @todo remove at version 3
		 * @private
		 */
		label: indexMode,

		/**
		 * Returns items at the same index. If the options.intersect parameter is true, we only return items if we intersect something
		 * If the options.intersect mode is false, we find the nearest item and return the items at the same index as that item
		 * @function Chart.Interaction.modes.index
		 * @since v2.4.0
		 * @param chart {chart} the chart we are returning items from
		 * @param e {Event} the event we are find things at
		 * @param options {IInteractionOptions} options to use during interaction
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		index: indexMode,

		/**
		 * Returns items in the same dataset. If the options.intersect parameter is true, we only return items if we intersect something
		 * If the options.intersect is false, we find the nearest item and return the items in that dataset
		 * @function Chart.Interaction.modes.dataset
		 * @param chart {chart} the chart we are returning items from
		 * @param e {Event} the event we are find things at
		 * @param options {IInteractionOptions} options to use during interaction
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		dataset: function(chart, e, options) {
			var position = getRelativePosition(e, chart);
			options.axis = options.axis || 'xy';
			var distanceMetric = getDistanceMetricForAxis(options.axis);
			var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);

			if (items.length > 0) {
				items = chart.getDatasetMeta(items[0]._datasetIndex).data;
			}

			return items;
		},

		/**
		 * @function Chart.Interaction.modes.x-axis
		 * @deprecated since version 2.4.0. Use index mode and intersect == true
		 * @todo remove at version 3
		 * @private
		 */
		'x-axis': function(chart, e) {
			return indexMode(chart, e, {intersect: false});
		},

		/**
		 * Point mode returns all elements that hit test based on the event position
		 * of the event
		 * @function Chart.Interaction.modes.intersect
		 * @param chart {chart} the chart we are returning items from
		 * @param e {Event} the event we are find things at
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		point: function(chart, e) {
			var position = getRelativePosition(e, chart);
			return getIntersectItems(chart, position);
		},

		/**
		 * nearest mode returns the element closest to the point
		 * @function Chart.Interaction.modes.intersect
		 * @param chart {chart} the chart we are returning items from
		 * @param e {Event} the event we are find things at
		 * @param options {IInteractionOptions} options to use
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		nearest: function(chart, e, options) {
			var position = getRelativePosition(e, chart);
			options.axis = options.axis || 'xy';
			var distanceMetric = getDistanceMetricForAxis(options.axis);
			var nearestItems = getNearestItems(chart, position, options.intersect, distanceMetric);

			// We have multiple items at the same distance from the event. Now sort by smallest
			if (nearestItems.length > 1) {
				nearestItems.sort(function(a, b) {
					var sizeA = a.getArea();
					var sizeB = b.getArea();
					var ret = sizeA - sizeB;

					if (ret === 0) {
						// if equal sort by dataset index
						ret = a._datasetIndex - b._datasetIndex;
					}

					return ret;
				});
			}

			// Return only 1 item
			return nearestItems.slice(0, 1);
		},

		/**
		 * x mode returns the elements that hit-test at the current x coordinate
		 * @function Chart.Interaction.modes.x
		 * @param chart {chart} the chart we are returning items from
		 * @param e {Event} the event we are find things at
		 * @param options {IInteractionOptions} options to use
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		x: function(chart, e, options) {
			var position = getRelativePosition(e, chart);
			var items = [];
			var intersectsItem = false;

			parseVisibleItems(chart, function(element) {
				if (element.inXRange(position.x)) {
					items.push(element);
				}

				if (element.inRange(position.x, position.y)) {
					intersectsItem = true;
				}
			});

			// If we want to trigger on an intersect and we don't have any items
			// that intersect the position, return nothing
			if (options.intersect && !intersectsItem) {
				items = [];
			}
			return items;
		},

		/**
		 * y mode returns the elements that hit-test at the current y coordinate
		 * @function Chart.Interaction.modes.y
		 * @param chart {chart} the chart we are returning items from
		 * @param e {Event} the event we are find things at
		 * @param options {IInteractionOptions} options to use
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		y: function(chart, e, options) {
			var position = getRelativePosition(e, chart);
			var items = [];
			var intersectsItem = false;

			parseVisibleItems(chart, function(element) {
				if (element.inYRange(position.y)) {
					items.push(element);
				}

				if (element.inRange(position.x, position.y)) {
					intersectsItem = true;
				}
			});

			// If we want to trigger on an intersect and we don't have any items
			// that intersect the position, return nothing
			if (options.intersect && !intersectsItem) {
				items = [];
			}
			return items;
		}
	}
};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var helpers = __webpack_require__(1);
var basic = __webpack_require__(204);
var dom = __webpack_require__(205);

// @TODO Make possible to select another platform at build time.
var implementation = dom._enabled ? dom : basic;

/**
 * @namespace Chart.platform
 * @see https://chartjs.gitbooks.io/proposals/content/Platform.html
 * @since 2.4.0
 */
module.exports = helpers.extend({
	/**
	 * @since 2.7.0
	 */
	initialize: function() {},

	/**
	 * Called at chart construction time, returns a context2d instance implementing
	 * the [W3C Canvas 2D Context API standard]{@link https://www.w3.org/TR/2dcontext/}.
	 * @param {*} item - The native item from which to acquire context (platform specific)
	 * @param {Object} options - The chart options
	 * @returns {CanvasRenderingContext2D} context2d instance
	 */
	acquireContext: function() {},

	/**
	 * Called at chart destruction time, releases any resources associated to the context
	 * previously returned by the acquireContext() method.
	 * @param {CanvasRenderingContext2D} context - The context2d instance
	 * @returns {Boolean} true if the method succeeded, else false
	 */
	releaseContext: function() {},

	/**
	 * Registers the specified listener on the given chart.
	 * @param {Chart} chart - Chart from which to listen for event
	 * @param {String} type - The ({@link IEvent}) type to listen for
	 * @param {Function} listener - Receives a notification (an object that implements
	 * the {@link IEvent} interface) when an event of the specified type occurs.
	 */
	addEventListener: function() {},

	/**
	 * Removes the specified listener previously registered with addEventListener.
	 * @param {Chart} chart -Chart from which to remove the listener
	 * @param {String} type - The ({@link IEvent}) type to remove
	 * @param {Function} listener - The listener function to remove from the event target.
	 */
	removeEventListener: function() {}

}, implementation);

/**
 * @interface IPlatform
 * Allows abstracting platform dependencies away from the chart
 * @borrows Chart.platform.acquireContext as acquireContext
 * @borrows Chart.platform.releaseContext as releaseContext
 * @borrows Chart.platform.addEventListener as addEventListener
 * @borrows Chart.platform.removeEventListener as removeEventListener
 */

/**
 * @interface IEvent
 * @prop {String} type - The event type name, possible values are:
 * 'contextmenu', 'mouseenter', 'mousedown', 'mousemove', 'mouseup', 'mouseout',
 * 'click', 'dblclick', 'keydown', 'keypress', 'keyup' and 'resize'
 * @prop {*} native - The original native event (null for emulated events, e.g. 'resize')
 * @prop {Number} x - The mouse x position, relative to the canvas (null for incompatible events)
 * @prop {Number} y - The mouse y position, relative to the canvas (null for incompatible events)
 */


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(2);
var helpers = __webpack_require__(1);

defaults._set('global', {
	plugins: {}
});

/**
 * The plugin service singleton
 * @namespace Chart.plugins
 * @since 2.1.0
 */
module.exports = {
	/**
	 * Globally registered plugins.
	 * @private
	 */
	_plugins: [],

	/**
	 * This identifier is used to invalidate the descriptors cache attached to each chart
	 * when a global plugin is registered or unregistered. In this case, the cache ID is
	 * incremented and descriptors are regenerated during following API calls.
	 * @private
	 */
	_cacheId: 0,

	/**
	 * Registers the given plugin(s) if not already registered.
	 * @param {Array|Object} plugins plugin instance(s).
	 */
	register: function(plugins) {
		var p = this._plugins;
		([]).concat(plugins).forEach(function(plugin) {
			if (p.indexOf(plugin) === -1) {
				p.push(plugin);
			}
		});

		this._cacheId++;
	},

	/**
	 * Unregisters the given plugin(s) only if registered.
	 * @param {Array|Object} plugins plugin instance(s).
	 */
	unregister: function(plugins) {
		var p = this._plugins;
		([]).concat(plugins).forEach(function(plugin) {
			var idx = p.indexOf(plugin);
			if (idx !== -1) {
				p.splice(idx, 1);
			}
		});

		this._cacheId++;
	},

	/**
	 * Remove all registered plugins.
	 * @since 2.1.5
	 */
	clear: function() {
		this._plugins = [];
		this._cacheId++;
	},

	/**
	 * Returns the number of registered plugins?
	 * @returns {Number}
	 * @since 2.1.5
	 */
	count: function() {
		return this._plugins.length;
	},

	/**
	 * Returns all registered plugin instances.
	 * @returns {Array} array of plugin objects.
	 * @since 2.1.5
	 */
	getAll: function() {
		return this._plugins;
	},

	/**
	 * Calls enabled plugins for `chart` on the specified hook and with the given args.
	 * This method immediately returns as soon as a plugin explicitly returns false. The
	 * returned value can be used, for instance, to interrupt the current action.
	 * @param {Object} chart - The chart instance for which plugins should be called.
	 * @param {String} hook - The name of the plugin method to call (e.g. 'beforeUpdate').
	 * @param {Array} [args] - Extra arguments to apply to the hook call.
	 * @returns {Boolean} false if any of the plugins return false, else returns true.
	 */
	notify: function(chart, hook, args) {
		var descriptors = this.descriptors(chart);
		var ilen = descriptors.length;
		var i, descriptor, plugin, params, method;

		for (i = 0; i < ilen; ++i) {
			descriptor = descriptors[i];
			plugin = descriptor.plugin;
			method = plugin[hook];
			if (typeof method === 'function') {
				params = [chart].concat(args || []);
				params.push(descriptor.options);
				if (method.apply(plugin, params) === false) {
					return false;
				}
			}
		}

		return true;
	},

	/**
	 * Returns descriptors of enabled plugins for the given chart.
	 * @returns {Array} [{ plugin, options }]
	 * @private
	 */
	descriptors: function(chart) {
		var cache = chart.$plugins || (chart.$plugins = {});
		if (cache.id === this._cacheId) {
			return cache.descriptors;
		}

		var plugins = [];
		var descriptors = [];
		var config = (chart && chart.config) || {};
		var options = (config.options && config.options.plugins) || {};

		this._plugins.concat(config.plugins || []).forEach(function(plugin) {
			var idx = plugins.indexOf(plugin);
			if (idx !== -1) {
				return;
			}

			var id = plugin.id;
			var opts = options[id];
			if (opts === false) {
				return;
			}

			if (opts === true) {
				opts = helpers.clone(defaults.global.plugins[id]);
			}

			plugins.push(plugin);
			descriptors.push({
				plugin: plugin,
				options: opts || {}
			});
		});

		cache.descriptors = descriptors;
		cache.id = this._cacheId;
		return descriptors;
	},

	/**
	 * Invalidates cache for the given chart: descriptors hold a reference on plugin option,
	 * but in some cases, this reference can be changed by the user when updating options.
	 * https://github.com/chartjs/Chart.js/issues/5111#issuecomment-355934167
	 * @private
	 */
	_invalidate: function(chart) {
		delete chart.$plugins;
	}
};

/**
 * Plugin extension hooks.
 * @interface IPlugin
 * @since 2.1.0
 */
/**
 * @method IPlugin#beforeInit
 * @desc Called before initializing `chart`.
 * @param {Chart.Controller} chart - The chart instance.
 * @param {Object} options - The plugin options.
 */
/**
 * @method IPlugin#afterInit
 * @desc Called after `chart` has been initialized and before the first update.
 * @param {Chart.Controller} chart - The chart instance.
 * @param {Object} options - The plugin options.
 */
/**
 * @method IPlugin#beforeUpdate
 * @desc Called before updating `chart`. If any plugin returns `false`, the update
 * is cancelled (and thus subsequent render(s)) until another `update` is triggered.
 * @param {Chart.Controller} chart - The chart instance.
 * @param {Object} options - The plugin options.
 * @returns {Boolean} `false` to cancel the chart update.
 */
/**
 * @method IPlugin#afterUpdate
 * @desc Called after `chart` has been updated and before rendering. Note that this
 * hook will not be called if the chart update has been previously cancelled.
 * @param {Chart.Controller} chart - The chart instance.
 * @param {Object} options - The plugin options.
 */
/**
 * @method IPlugin#beforeDatasetsUpdate
 * @desc Called before updating the `chart` datasets. If any plugin returns `false`,
 * the datasets update is cancelled until another `update` is triggered.
 * @param {Chart.Controller} chart - The chart instance.
 * @param {Object} options - The plugin options.
 * @returns {Boolean} false to cancel the datasets update.
 * @since version 2.1.5
*/
/**
 * @method IPlugin#afterDatasetsUpdate
 * @desc Called after the `chart` datasets have been updated. Note that this hook
 * will not be called if the datasets update has been previously cancelled.
 * @param {Chart.Controller} chart - The chart instance.
 * @param {Object} options - The plugin options.
 * @since version 2.1.5
 */
/**
 * @method IPlugin#beforeDatasetUpdate
 * @desc Called before updating the `chart` dataset at the given `args.index`. If any plugin
 * returns `false`, the datasets update is cancelled until another `update` is triggered.
 * @param {Chart} chart - The chart instance.
 * @param {Object} args - The call arguments.
 * @param {Number} args.index - The dataset index.
 * @param {Object} args.meta - The dataset metadata.
 * @param {Object} options - The plugin options.
 * @returns {Boolean} `false` to cancel the chart datasets drawing.
 */
/**
 * @method IPlugin#afterDatasetUpdate
 * @desc Called after the `chart` datasets at the given `args.index` has been updated. Note
 * that this hook will not be called if the datasets update has been previously cancelled.
 * @param {Chart} chart - The chart instance.
 * @param {Object} args - The call arguments.
 * @param {Number} args.index - The dataset index.
 * @param {Object} args.meta - The dataset metadata.
 * @param {Object} options - The plugin options.
 */
/**
 * @method IPlugin#beforeLayout
 * @desc Called before laying out `chart`. If any plugin returns `false`,
 * the layout update is cancelled until another `update` is triggered.
 * @param {Chart.Controller} chart - The chart instance.
 * @param {Object} options - The plugin options.
 * @returns {Boolean} `false` to cancel the chart layout.
 */
/**
 * @method IPlugin#afterLayout
 * @desc Called after the `chart` has been layed out. Note that this hook will not
 * be called if the layout update has been previously cancelled.
 * @param {Chart.Controller} chart - The chart instance.
 * @param {Object} options - The plugin options.
 */
/**
 * @method IPlugin#beforeRender
 * @desc Called before rendering `chart`. If any plugin returns `false`,
 * the rendering is cancelled until another `render` is triggered.
 * @param {Chart.Controller} chart - The chart instance.
 * @param {Object} options - The plugin options.
 * @returns {Boolean} `false` to cancel the chart rendering.
 */
/**
 * @method IPlugin#afterRender
 * @desc Called after the `chart` has been fully rendered (and animation completed). Note
 * that this hook will not be called if the rendering has been previously cancelled.
 * @param {Chart.Controller} chart - The chart instance.
 * @param {Object} options - The plugin options.
 */
/**
 * @method IPlugin#beforeDraw
 * @desc Called before drawing `chart` at every animation frame specified by the given
 * easing value. If any plugin returns `false`, the frame drawing is cancelled until
 * another `render` is triggered.
 * @param {Chart.Controller} chart - The chart instance.
 * @param {Number} easingValue - The current animation value, between 0.0 and 1.0.
 * @param {Object} options - The plugin options.
 * @returns {Boolean} `false` to cancel the chart drawing.
 */
/**
 * @method IPlugin#afterDraw
 * @desc Called after the `chart` has been drawn for the specific easing value. Note
 * that this hook will not be called if the drawing has been previously cancelled.
 * @param {Chart.Controller} chart - The chart instance.
 * @param {Number} easingValue - The current animation value, between 0.0 and 1.0.
 * @param {Object} options - The plugin options.
 */
/**
 * @method IPlugin#beforeDatasetsDraw
 * @desc Called before drawing the `chart` datasets. If any plugin returns `false`,
 * the datasets drawing is cancelled until another `render` is triggered.
 * @param {Chart.Controller} chart - The chart instance.
 * @param {Number} easingValue - The current animation value, between 0.0 and 1.0.
 * @param {Object} options - The plugin options.
 * @returns {Boolean} `false` to cancel the chart datasets drawing.
 */
/**
 * @method IPlugin#afterDatasetsDraw
 * @desc Called after the `chart` datasets have been drawn. Note that this hook
 * will not be called if the datasets drawing has been previously cancelled.
 * @param {Chart.Controller} chart - The chart instance.
 * @param {Number} easingValue - The current animation value, between 0.0 and 1.0.
 * @param {Object} options - The plugin options.
 */
/**
 * @method IPlugin#beforeDatasetDraw
 * @desc Called before drawing the `chart` dataset at the given `args.index` (datasets
 * are drawn in the reverse order). If any plugin returns `false`, the datasets drawing
 * is cancelled until another `render` is triggered.
 * @param {Chart} chart - The chart instance.
 * @param {Object} args - The call arguments.
 * @param {Number} args.index - The dataset index.
 * @param {Object} args.meta - The dataset metadata.
 * @param {Number} args.easingValue - The current animation value, between 0.0 and 1.0.
 * @param {Object} options - The plugin options.
 * @returns {Boolean} `false` to cancel the chart datasets drawing.
 */
/**
 * @method IPlugin#afterDatasetDraw
 * @desc Called after the `chart` datasets at the given `args.index` have been drawn
 * (datasets are drawn in the reverse order). Note that this hook will not be called
 * if the datasets drawing has been previously cancelled.
 * @param {Chart} chart - The chart instance.
 * @param {Object} args - The call arguments.
 * @param {Number} args.index - The dataset index.
 * @param {Object} args.meta - The dataset metadata.
 * @param {Number} args.easingValue - The current animation value, between 0.0 and 1.0.
 * @param {Object} options - The plugin options.
 */
/**
 * @method IPlugin#beforeTooltipDraw
 * @desc Called before drawing the `tooltip`. If any plugin returns `false`,
 * the tooltip drawing is cancelled until another `render` is triggered.
 * @param {Chart} chart - The chart instance.
 * @param {Object} args - The call arguments.
 * @param {Object} args.tooltip - The tooltip.
 * @param {Number} args.easingValue - The current animation value, between 0.0 and 1.0.
 * @param {Object} options - The plugin options.
 * @returns {Boolean} `false` to cancel the chart tooltip drawing.
 */
/**
 * @method IPlugin#afterTooltipDraw
 * @desc Called after drawing the `tooltip`. Note that this hook will not
 * be called if the tooltip drawing has been previously cancelled.
 * @param {Chart} chart - The chart instance.
 * @param {Object} args - The call arguments.
 * @param {Object} args.tooltip - The tooltip.
 * @param {Number} args.easingValue - The current animation value, between 0.0 and 1.0.
 * @param {Object} options - The plugin options.
 */
/**
 * @method IPlugin#beforeEvent
 * @desc Called before processing the specified `event`. If any plugin returns `false`,
 * the event will be discarded.
 * @param {Chart.Controller} chart - The chart instance.
 * @param {IEvent} event - The event object.
 * @param {Object} options - The plugin options.
 */
/**
 * @method IPlugin#afterEvent
 * @desc Called after the `event` has been consumed. Note that this hook
 * will not be called if the `event` has been previously discarded.
 * @param {Chart.Controller} chart - The chart instance.
 * @param {IEvent} event - The event object.
 * @param {Object} options - The plugin options.
 */
/**
 * @method IPlugin#resize
 * @desc Called after the chart as been resized.
 * @param {Chart.Controller} chart - The chart instance.
 * @param {Number} size - The new canvas display size (eq. canvas.style width & height).
 * @param {Object} options - The plugin options.
 */
/**
 * @method IPlugin#destroy
 * @desc Called after the chart as been destroyed.
 * @param {Chart.Controller} chart - The chart instance.
 * @param {Object} options - The plugin options.
 */


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(34),
    stackClear = __webpack_require__(243),
    stackDelete = __webpack_require__(244),
    stackGet = __webpack_require__(245),
    stackHas = __webpack_require__(246),
    stackSet = __webpack_require__(247);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(23),
    isObject = __webpack_require__(24);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(62)))

/***/ }),
/* 81 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(266),
    arraySome = __webpack_require__(269),
    cacheHas = __webpack_require__(270);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(284),
    isObjectLike = __webpack_require__(26);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(10),
    stubFalse = __webpack_require__(285);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(50)(module)))

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(286),
    baseUnary = __webpack_require__(287),
    nodeUtil = __webpack_require__(288);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 86 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(24);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 88 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(90),
    toKey = __webpack_require__(41);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(11),
    isKey = __webpack_require__(58),
    stringToPath = __webpack_require__(304),
    toString = __webpack_require__(307);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(14);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _dom_elements = __webpack_require__(339);

var _dom_elements2 = _interopRequireDefault(_dom_elements);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // eslint-disable-line no-unused-vars


var createHocForTypes = function createHocForTypes(Target) {
  var validPropTypes = Object.keys(Target.propTypes || {});

  var WrapElement = function WrapElement(tag) {
    var _class, _temp;

    return _temp = _class = function (_Component) {
      _inherits(Wrapped, _Component);

      function Wrapped() {
        _classCallCheck(this, Wrapped);

        return _possibleConstructorReturn(this, (Wrapped.__proto__ || Object.getPrototypeOf(Wrapped)).apply(this, arguments));
      }

      _createClass(Wrapped, [{
        key: 'render',
        value: function render() {
          var _this2 = this;

          var _props = this.props,
              children = _props.children,
              rest = _objectWithoutProperties(_props, ['children']);

          var propsToAnimation = validPropTypes.reduce(function (animationProps, validProp) {
            animationProps[validProp] = rest[validProp];
            return animationProps;
          }, {});

          var propsToChild = Object.keys(rest).reduce(function (childProps, childProp) {
            if (validPropTypes.indexOf(childProp) === -1) {
              childProps[childProp] = rest[childProp];
            }
            return childProps;
          }, {});

          return _react2.default.createElement(
            Target,
            _extends({}, propsToAnimation, {
              ref: function ref(el) {
                if (el && el.node) {
                  // pass node reference
                  _this2.node = el.node;
                }
              }
            }),
            (0, _react.createElement)(tag, propsToChild, children)
          );
        }
      }]);

      return Wrapped;
    }(_react.Component), _class.propTypes = {
      children: _propTypes.node
    }, _temp;
  };

  // Shorthands for all valid HTML Elements
  _dom_elements2.default.forEach(function (domElement) {
    Target[domElement] = WrapElement(domElement);
    Target[domElement].displayName = (Target.name || Target.displayName || 'WrapElement') + '.' + domElement;
  });

  return Target;
};

exports.default = createHocForTypes;

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _animatable = __webpack_require__(94);

var _animatable2 = _interopRequireDefault(_animatable);

var _playable = __webpack_require__(95);

var _playable2 = _interopRequireDefault(_playable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var assign = __webpack_require__(96);
var isEqual = __webpack_require__(51);

/**
 * <Animation/> is a simple implementation of <Animatable/> and controls a single
 * "player" instance for the wrapped element.
 */

var Animation = function (_Animatable) {
  _inherits(Animation, _Animatable);

  function Animation() {
    _classCallCheck(this, Animation);

    var _this = _possibleConstructorReturn(this, (Animation.__proto__ || Object.getPrototypeOf(Animation)).call(this));

    _this.state = {
      player: null
    };
    return _this;
  }

  /**
   * Start the animation and set the player in the state
   */


  _createClass(Animation, [{
    key: 'startAnimation',
    value: function startAnimation(props) {
      return this.setPlayer(this.node.animate(this.keyframes, this.timing), props);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var timing = nextProps.timing,
          keyframes = nextProps.keyframes;

      // create data structures for props

      if (timing && keyframes) {
        var newTiming = Object.assign({}, timing);

        if (!isEqual(keyframes, this.keyframes) || !isEqual(newTiming, this.timing)) {
          this.timing = newTiming;
          this.keyframes = keyframes;
          // start the new animation with the new config
          this.startAnimation(nextProps);
        }
      }

      this.updatePlayer(nextProps);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          timing = _props.timing,
          keyframes = _props.keyframes;

      // create data structures for props

      this.keyframes = keyframes;
      this.timing = Object.assign({}, timing);

      // start the animation
      var player = this.startAnimation();
      // But make sure that we honor the initial playState, if set.
      this.updatePlayer(this.props, player);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          children = _props2.children,
          getRef = _props2.getRef;


      this.element = _react2.default.cloneElement(children, {
        ref: function ref(node) {
          _this2.node = node;
          if (getRef) {
            getRef(node);
          }
          return node;
        }
      });

      return _react.Children.only(this.element);
    }
  }]);

  return Animation;
}(_animatable2.default);

assign(Animation.prototype, _playable2.default);

Animation.propTypes = assign({}, _animatable2.default.propTypes, {
  onCancel: _propTypes2.default.func,
  onFinish: _propTypes2.default.func,
  onPause: _propTypes2.default.func,
  onPlay: _propTypes2.default.func,
  onReverse: _propTypes2.default.func,
  currentTime: _propTypes2.default.number,
  playState: _propTypes2.default.oneOf(['running', 'paused', 'finished', 'idle', 'reversed'])
});

exports.default = Animation;

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _with_hoc_elements = __webpack_require__(92);

var _with_hoc_elements2 = _interopRequireDefault(_with_hoc_elements);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The <Animatable/> module wraps an element and expects props
 * with Keyframe Values and a Timing configuration. However, unlike
 * <Animation/> it doesn't start or maintain any players. <Animatable/> is meant
 * to be nested under other effects like <AnimationGroup/> or <AnimationSequence/>
 */
var Animatable = function (_Component) {
  _inherits(Animatable, _Component);

  function Animatable() {
    _classCallCheck(this, Animatable);

    return _possibleConstructorReturn(this, (Animatable.__proto__ || Object.getPrototypeOf(Animatable)).apply(this, arguments));
  }

  _createClass(Animatable, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      // get the children, and optional function to get a ref to the node
      var _props = this.props,
          children = _props.children,
          getRef = _props.getRef;

      // create our element

      this.element = _react2.default.cloneElement(children, {
        ref: function ref(node) {
          _this2.node = node;
          // if the user supplied a getRef function, pass the ref
          if (getRef) {
            getRef(node);
          }
          return node;
        }
      });

      // render only the child, creating no wrapping elements
      return _react.Children.only(this.element);
    }
  }]);

  return Animatable;
}(_react.Component);

Animatable.propTypes = {
  children: _propTypes2.default.element.isRequired,
  keyframes: _propTypes2.default.arrayOf(Object),
  getRef: _propTypes2.default.func,
  timing: _propTypes2.default.shape({
    delay: _propTypes2.default.number,
    endDelay: _propTypes2.default.number,
    fill: _propTypes2.default.oneOf(['none', 'forwards', 'backwards', 'both', 'auto']),
    iterationStart: _propTypes2.default.number,
    iterations: _propTypes2.default.number,
    duration: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
    direction: _propTypes2.default.oneOf(['normal', 'reverse', 'alternate', 'alternate-reverse']),
    easing: _propTypes2.default.string
  }).isRequired
};

exports.default = (0, _with_hoc_elements2.default)(Animatable);

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * A mixin for components that manage an animation Player.
 */
exports.default = {
  componentWillUnmount: function componentWillUnmount() {
    var player = this.state.player;
    var detachHandlersFromPlayer = this.detachHandlersFromPlayer;

    detachHandlersFromPlayer(player);
  },
  attachHandlersToPlayer: function attachHandlersToPlayer(player, props) {
    player.onfinish = props.onFinish;
    player.oncancel = props.onCancel;
  },
  detachHandlersFromPlayer: function detachHandlersFromPlayer(player) {
    if (player) {
      player.onfinish = null;
      player.oncancel = null;
    }
  },
  notifyHandlers: function notifyHandlers(event) {
    var player = this.state.player;

    if (!player) {
      return;
    }
    switch (event) {
      case 'running':
        if (this.props.onPlay) {
          this.props.onPlay(player);
        }
        break;
      case 'paused':
        if (this.props.onPause) {
          this.props.onPause(player);
        }
        break;
      case 'reversed':
        if (this.props.onReverse) {
          this.props.onReverse(player);
        }
        break;
      default:
        break;
    }
  },
  setPlayer: function setPlayer(player, props) {
    // cancel existing animation
    if (this.state.player) {
      this.state.player.cancel();
    }
    this.setState({ player: player });

    // attach native handlers
    this.attachHandlersToPlayer(player, props || this.props);

    return player;
  },


  /**
   * Shorthand for updating all relevant player state encoded into `props`.
   */
  updatePlayer: function updatePlayer(props) {
    var player = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state.player;

    var shouldUpdatePlayerState = void 0;
    // if the play state has been changed from the old to the new, or
    if (props.playState !== this.props.playState) {
      shouldUpdatePlayerState = true;
    }
    // different from the current player state
    if (player && player.playState && props.playState !== player.playState) {
      shouldUpdatePlayerState = true;
    }

    // don't do anything if the state is staying at reversed
    if (props.playState === 'reversed' && this.props.playState === 'reversed') {
      shouldUpdatePlayerState = false;
    }

    if (shouldUpdatePlayerState) {
      this.updatePlayState(props, player);
    }

    if (this.props.currentTime !== props.currentTime) {
      this.updateTime(props, player);
    }
  },
  updatePlayState: function updatePlayState(_ref) {
    var playState = _ref.playState;
    var player = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state.player;

    if (!playState || !player || player.playState === playState) {
      return;
    }

    switch (playState) {
      case 'running':
        player.play();
        break;
      case 'paused':
        player.pause();
        break;
      case 'finished':
        player.finish();
        break;
      case 'idle':
        player.cancel();
        break;
      case 'reversed':
        player.reverse();
        break;
      default:
        break;
    }

    // notify any handlers of the state change
    this.notifyHandlers(playState);
  },
  updateTime: function updateTime(_ref2) {
    var currentTime = _ref2.currentTime;
    var player = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state.player;

    if (!player || typeof currentTime !== 'number') {
      return;
    }

    player.currentTime = currentTime;
  }
};

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(97),
    copyObject = __webpack_require__(340),
    createAssigner = __webpack_require__(341),
    isArrayLike = __webpack_require__(27),
    isPrototype = __webpack_require__(86),
    keys = __webpack_require__(25);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */
var assign = createAssigner(function(object, source) {
  if (isPrototype(source) || isArrayLike(source)) {
    copyObject(source, keys(source), object);
    return;
  }
  for (var key in source) {
    if (hasOwnProperty.call(source, key)) {
      assignValue(object, key, source[key]);
    }
  }
});

module.exports = assign;


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(60),
    eq = __webpack_require__(36);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _playable = __webpack_require__(95);

var _playable2 = _interopRequireDefault(_playable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint no-unused-vars:0 */


var assign = __webpack_require__(96);
var isEqual = __webpack_require__(51);

/**
 * The Abstract <Effect/> component represents the behavior of a Grouped set of <Animatable/>
 * components. A sub-type must be provided.
 */

var Effect = function (_Component) {
  _inherits(Effect, _Component);

  function Effect(type) {
    _classCallCheck(this, Effect);

    var _this = _possibleConstructorReturn(this, (Effect.__proto__ || Object.getPrototypeOf(Effect)).call(this));

    _this.state = {
      player: null
    };

    /**
     * The type of groupable component.
     */
    _this.type = type;

    /**
     * Store the DOM nodes of the child <Animatable/>
     * @type {{}}
     */
    _this.nodes = {};

    /**
     * The effect
     * @type {null}
     */
    _this.effect = null;
    return _this;
  }

  _createClass(Effect, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.frameCache = Object.assign({}, this.buildFrameCache(this.props));
      this.keyframeEffects = this.getKeyframeEffectsFromChildren(this.props);
      this.effect = this.getEffectFromKeyframes(this.keyframeEffects);

      // start the animation
      var player = this.startAnimation();
      // But make sure that we honor the initial playState, if set.
      this.updatePlayer(this.props, player);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var nextKeyframes = this.getKeyframeEffectsFromChildren(nextProps);
      var newFrameCache = Object.assign({}, this.buildFrameCache(nextProps));
      var currentTime = nextProps.currentTime;


      if (!isEqual(newFrameCache, this.frameCache)) {
        this.keyframeEffects = nextKeyframes;
        this.effect = this.getEffectFromKeyframes(nextKeyframes);
        this.startAnimation(nextProps);
      }

      this.updatePlayer(nextProps);
    }
  }, {
    key: 'getKeyframeEffectsFromChildren',
    value: function getKeyframeEffectsFromChildren(props) {
      var _this2 = this;

      var children = props.children;

      return _react.Children.map(children, function (c, idx) {
        return new KeyframeEffect(_this2.nodes[idx], c.props.keyframes, c.props.timing);
      });
    }
  }, {
    key: 'startAnimation',
    value: function startAnimation(props) {
      return this.setPlayer(document.timeline.play(this.effect), props);
    }
  }, {
    key: 'buildFrameCache',
    value: function buildFrameCache(props) {
      var children = props.children;

      var cache = {};
      return _react.Children.forEach(children, function (c, idx) {
        cache[idx] = { frames: c.props.keyframes, timing: c.props.timing };
      });
    }
  }, {
    key: 'getEffectFromKeyframes',
    value: function getEffectFromKeyframes(keyframeEffects) {
      // create the group
      var Type = window[this.type] || window.GroupEffect;
      return new Type(keyframeEffects);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          children = _props.children,
          component = _props.component,
          getRef = _props.getRef;


      var childElements = _react.Children.map(children, function (c, idx) {
        return _react2.default.cloneElement(c, {
          ref: function ref(el) {
            if (el) {
              _this3.nodes[idx] = el.node;
              return el.node;
            }
            return null;
          }
        });
      });

      return _react2.default.createElement(component, _extends({}, this.props, {
        ref: function ref(node) {
          _this3.wrapper = node;
          if (getRef) {
            getRef(node);
          }
          return node;
        }
      }), childElements);
    }
  }]);

  return Effect;
}(_react.Component);

assign(Effect.prototype, _playable2.default);

Effect.defaultProps = {
  component: 'div'
};

Effect.propTypes = {
  onCancel: _propTypes2.default.func,
  onFinish: _propTypes2.default.func,
  onPause: _propTypes2.default.func,
  onPlay: _propTypes2.default.func,
  onReverse: _propTypes2.default.func,
  getRef: _propTypes2.default.func,
  currentTime: _propTypes2.default.number,
  playState: _propTypes2.default.oneOf(['running', 'paused', 'finished', 'idle', 'reversed']),
  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
  children: _propTypes2.default.arrayOf(_propTypes2.default.element).isRequired
};

exports.default = Effect;

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(100);
module.exports = __webpack_require__(105);


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(101).enable();
  window.Promise = __webpack_require__(103);
}

// fetch() polyfill for making API calls.
__webpack_require__(104);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(43);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(61);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(62)))

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(61);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 104 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_css__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__registerServiceWorker__ = __webpack_require__(372);
__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__App__["a" /* default */],null),document.getElementById('root'));Object(__WEBPACK_IMPORTED_MODULE_4__registerServiceWorker__["a" /* default */])();

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.3.0
 * react.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var m=__webpack_require__(43),n=__webpack_require__(63),p=__webpack_require__(44),q="function"===typeof Symbol&&Symbol["for"],r=q?Symbol["for"]("react.element"):60103,t=q?Symbol["for"]("react.portal"):60106,u=q?Symbol["for"]("react.fragment"):60107,v=q?Symbol["for"]("react.strict_mode"):60108,w=q?Symbol["for"]("react.provider"):60109,x=q?Symbol["for"]("react.context"):60110,y=q?Symbol["for"]("react.async_mode"):60111,z=q?Symbol["for"]("react.forward_ref"):60112,A="function"===
typeof Symbol&&Symbol.iterator;function B(a){for(var b=arguments.length-1,e="Minified React error #"+a+"; visit http://facebook.github.io/react/docs/error-decoder.html?invariant\x3d"+a,c=0;c<b;c++)e+="\x26args[]\x3d"+encodeURIComponent(arguments[c+1]);b=Error(e+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");b.name="Invariant Violation";b.framesToPop=1;throw b;}
var C={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}};function D(a,b,e){this.props=a;this.context=b;this.refs=n;this.updater=e||C}D.prototype.isReactComponent={};D.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?B("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};D.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function E(){}
E.prototype=D.prototype;function F(a,b,e){this.props=a;this.context=b;this.refs=n;this.updater=e||C}var G=F.prototype=new E;G.constructor=F;m(G,D.prototype);G.isPureReactComponent=!0;var H={current:null},I=Object.prototype.hasOwnProperty,J={key:!0,ref:!0,__self:!0,__source:!0};
function K(a,b,e){var c=void 0,d={},g=null,h=null;if(null!=b)for(c in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(g=""+b.key),b)I.call(b,c)&&!J.hasOwnProperty(c)&&(d[c]=b[c]);var f=arguments.length-2;if(1===f)d.children=e;else if(1<f){for(var k=Array(f),l=0;l<f;l++)k[l]=arguments[l+2];d.children=k}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===d[c]&&(d[c]=f[c]);return{$$typeof:r,type:a,key:g,ref:h,props:d,_owner:H.current}}
function L(a){return"object"===typeof a&&null!==a&&a.$$typeof===r}function escape(a){var b={"\x3d":"\x3d0",":":"\x3d2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var M=/\/+/g,N=[];function O(a,b,e,c){if(N.length){var d=N.pop();d.result=a;d.keyPrefix=b;d.func=e;d.context=c;d.count=0;return d}return{result:a,keyPrefix:b,func:e,context:c,count:0}}function P(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>N.length&&N.push(a)}
function Q(a,b,e,c){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case r:case t:g=!0}}if(g)return e(c,a,""===b?"."+R(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var h=0;h<a.length;h++){d=a[h];var f=b+R(d,h);g+=Q(d,f,e,c)}else if(null===a||"undefined"===typeof a?f=null:(f=A&&a[A]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),
h=0;!(d=a.next()).done;)d=d.value,f=b+R(d,h++),g+=Q(d,f,e,c);else"object"===d&&(e=""+a,B("31","[object Object]"===e?"object with keys {"+Object.keys(a).join(", ")+"}":e,""));return g}function R(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function S(a,b){a.func.call(a.context,b,a.count++)}
function T(a,b,e){var c=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?U(a,c,e,p.thatReturnsArgument):null!=a&&(L(a)&&(b=d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(M,"$\x26/")+"/")+e,a={$$typeof:r,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}),c.push(a))}function U(a,b,e,c,d){var g="";null!=e&&(g=(""+e).replace(M,"$\x26/")+"/");b=O(b,g,c,d);null==a||Q(a,"",T,b);P(b)}
var V={Children:{map:function(a,b,e){if(null==a)return a;var c=[];U(a,c,null,b,e);return c},forEach:function(a,b,e){if(null==a)return a;b=O(null,null,b,e);null==a||Q(a,"",S,b);P(b)},count:function(a){return null==a?0:Q(a,"",p.thatReturnsNull,null)},toArray:function(a){var b=[];U(a,b,null,p.thatReturnsArgument);return b},only:function(a){L(a)?void 0:B("143");return a}},createRef:function(){return{current:null}},Component:D,PureComponent:F,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:x,
_calculateChangedBits:b,_defaultValue:a,_currentValue:a,_changedBits:0,Provider:null,Consumer:null};a.Provider={$$typeof:w,context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:z,render:a}},Fragment:u,StrictMode:v,unstable_AsyncMode:y,createElement:K,cloneElement:function(a,b,e){var c=void 0,d=m({},a.props),g=a.key,h=a.ref,f=a._owner;if(null!=b){void 0!==b.ref&&(h=b.ref,f=H.current);void 0!==b.key&&(g=""+b.key);var k=void 0;a.type&&a.type.defaultProps&&(k=a.type.defaultProps);for(c in b)I.call(b,
c)&&!J.hasOwnProperty(c)&&(d[c]=void 0===b[c]&&void 0!==k?k[c]:b[c])}c=arguments.length-2;if(1===c)d.children=e;else if(1<c){k=Array(c);for(var l=0;l<c;l++)k[l]=arguments[l+2];d.children=k}return{$$typeof:r,type:a.type,key:g,ref:h,props:d,_owner:f}},createFactory:function(a){var b=K.bind(null,a);b.type=a;return b},isValidElement:L,version:"16.3.0",__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentOwner:H,assign:m}},W=Object.freeze({default:V}),X=W&&V||W;
module.exports=X["default"]?X["default"]:X;


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(108);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.3.0
 * react-dom.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var ba=__webpack_require__(0),m=__webpack_require__(109),A=__webpack_require__(43),C=__webpack_require__(44),ea=__webpack_require__(110),fa=__webpack_require__(111),ha=__webpack_require__(112),ja=__webpack_require__(63);
function D(a){for(var b=arguments.length-1,c="Minified React error #"+a+"; visit http://facebook.github.io/react/docs/error-decoder.html?invariant\x3d"+a,d=0;d<b;d++)c+="\x26args[]\x3d"+encodeURIComponent(arguments[d+1]);b=Error(c+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");b.name="Invariant Violation";b.framesToPop=1;throw b;}ba?void 0:D("227");
function ka(a,b,c,d,e,f,h,g,k){this._hasCaughtError=!1;this._caughtError=null;var v=Array.prototype.slice.call(arguments,3);try{b.apply(c,v)}catch(l){this._caughtError=l,this._hasCaughtError=!0}}
var E={_caughtError:null,_hasCaughtError:!1,_rethrowError:null,_hasRethrowError:!1,invokeGuardedCallback:function(a,b,c,d,e,f,h,g,k){ka.apply(E,arguments)},invokeGuardedCallbackAndCatchFirstError:function(a,b,c,d,e,f,h,g,k){E.invokeGuardedCallback.apply(this,arguments);if(E.hasCaughtError()){var v=E.clearCaughtError();E._hasRethrowError||(E._hasRethrowError=!0,E._rethrowError=v)}},rethrowCaughtError:function(){return ma.apply(E,arguments)},hasCaughtError:function(){return E._hasCaughtError},clearCaughtError:function(){if(E._hasCaughtError){var a=
E._caughtError;E._caughtError=null;E._hasCaughtError=!1;return a}D("198")}};function ma(){if(E._hasRethrowError){var a=E._rethrowError;E._rethrowError=null;E._hasRethrowError=!1;throw a;}}var na=null,oa={};
function pa(){if(na)for(var a in oa){var b=oa[a],c=na.indexOf(a);-1<c?void 0:D("96",a);if(!qa[c]){b.extractEvents?void 0:D("97",a);qa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],h=b,g=d;ra.hasOwnProperty(g)?D("99",g):void 0;ra[g]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&sa(k[e],h,g);e=!0}else f.registrationName?(sa(f.registrationName,h,g),e=!0):e=!1;e?void 0:D("98",d,a)}}}}
function sa(a,b,c){ta[a]?D("100",a):void 0;ta[a]=b;ua[a]=b.eventTypes[c].dependencies}var qa=[],ra={},ta={},ua={};function va(a){na?D("101"):void 0;na=Array.prototype.slice.call(a);pa()}function wa(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];oa.hasOwnProperty(c)&&oa[c]===d||(oa[c]?D("102",c):void 0,oa[c]=d,b=!0)}b&&pa()}
var xa=Object.freeze({plugins:qa,eventNameDispatchConfigs:ra,registrationNameModules:ta,registrationNameDependencies:ua,possibleRegistrationNames:null,injectEventPluginOrder:va,injectEventPluginsByName:wa}),Ca=null,Da=null,Ea=null;function Fa(a,b,c,d){b=a.type||"unknown-event";a.currentTarget=Ea(d);E.invokeGuardedCallbackAndCatchFirstError(b,c,void 0,a);a.currentTarget=null}
function Ga(a,b){null==b?D("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function Ha(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var Ia=null;
function Ja(a,b){if(a){var c=a._dispatchListeners,d=a._dispatchInstances;if(Array.isArray(c))for(var e=0;e<c.length&&!a.isPropagationStopped();e++)Fa(a,b,c[e],d[e]);else c&&Fa(a,b,c,d);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function Ka(a){return Ja(a,!0)}function La(a){return Ja(a,!1)}var Ma={injectEventPluginOrder:va,injectEventPluginsByName:wa};
function Na(a,b){var c=a.stateNode;if(!c)return null;var d=Ca(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?D("231",b,typeof c):void 0;
return c}function Oa(a,b){null!==a&&(Ia=Ga(Ia,a));a=Ia;Ia=null;a&&(b?Ha(a,Ka):Ha(a,La),Ia?D("95"):void 0,E.rethrowCaughtError())}function Pa(a,b,c,d){for(var e=null,f=0;f<qa.length;f++){var h=qa[f];h&&(h=h.extractEvents(a,b,c,d))&&(e=Ga(e,h))}Oa(e,!1)}var Qa=Object.freeze({injection:Ma,getListener:Na,runEventsInBatch:Oa,runExtractedEventsInBatch:Pa}),Ra=Math.random().toString(36).slice(2),F="__reactInternalInstance$"+Ra,Sa="__reactEventHandlers$"+Ra;
function Ta(a){if(a[F])return a[F];for(;!a[F];)if(a.parentNode)a=a.parentNode;else return null;a=a[F];return 5===a.tag||6===a.tag?a:null}function Ua(a){if(5===a.tag||6===a.tag)return a.stateNode;D("33")}function Va(a){return a[Sa]||null}var ab=Object.freeze({precacheFiberNode:function(a,b){b[F]=a},getClosestInstanceFromNode:Ta,getInstanceFromNode:function(a){a=a[F];return!a||5!==a.tag&&6!==a.tag?null:a},getNodeFromInstance:Ua,getFiberCurrentPropsFromNode:Va,updateFiberProps:function(a,b){a[Sa]=b}});
function L(a){do a=a["return"];while(a&&5!==a.tag);return a?a:null}function bb(a,b,c){for(var d=[];a;)d.push(a),a=L(a);for(a=d.length;0<a--;)b(d[a],"captured",c);for(a=0;a<d.length;a++)b(d[a],"bubbled",c)}function cb(a,b,c){if(b=Na(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=Ga(c._dispatchListeners,b),c._dispatchInstances=Ga(c._dispatchInstances,a)}function db(a){a&&a.dispatchConfig.phasedRegistrationNames&&bb(a._targetInst,cb,a)}
function eb(a){if(a&&a.dispatchConfig.phasedRegistrationNames){var b=a._targetInst;b=b?L(b):null;bb(b,cb,a)}}function fb(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Na(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=Ga(c._dispatchListeners,b),c._dispatchInstances=Ga(c._dispatchInstances,a))}function gb(a){a&&a.dispatchConfig.registrationName&&fb(a._targetInst,null,a)}function hb(a){Ha(a,db)}
function ib(a,b,c,d){if(c&&d)a:{var e=c;for(var f=d,h=0,g=e;g;g=L(g))h++;g=0;for(var k=f;k;k=L(k))g++;for(;0<h-g;)e=L(e),h--;for(;0<g-h;)f=L(f),g--;for(;h--;){if(e===f||e===f.alternate)break a;e=L(e);f=L(f)}e=null}else e=null;f=e;for(e=[];c&&c!==f;){h=c.alternate;if(null!==h&&h===f)break;e.push(c);c=L(c)}for(c=[];d&&d!==f;){h=d.alternate;if(null!==h&&h===f)break;c.push(d);d=L(d)}for(d=0;d<e.length;d++)fb(e[d],"bubbled",a);for(a=c.length;0<a--;)fb(c[a],"captured",b)}
var jb=Object.freeze({accumulateTwoPhaseDispatches:hb,accumulateTwoPhaseDispatchesSkipTarget:function(a){Ha(a,eb)},accumulateEnterLeaveDispatches:ib,accumulateDirectDispatches:function(a){Ha(a,gb)}}),kb=null;function lb(){!kb&&m.canUseDOM&&(kb="textContent"in document.documentElement?"textContent":"innerText");return kb}var M={_root:null,_startText:null,_fallbackText:null};
function mb(){if(M._fallbackText)return M._fallbackText;var a,b=M._startText,c=b.length,d,e=nb(),f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var h=c-a;for(d=1;d<=h&&b[c-d]===e[f-d];d++);M._fallbackText=e.slice(a,1<d?1-d:void 0);return M._fallbackText}function nb(){return"value"in M._root?M._root.value:M._root[lb()]}
var ob="dispatchConfig _targetInst nativeEvent isDefaultPrevented isPropagationStopped _dispatchListeners _dispatchInstances".split(" "),pb={type:null,target:null,currentTarget:C.thatReturnsNull,eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
function N(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?C.thatReturnsTrue:C.thatReturnsFalse;this.isPropagationStopped=C.thatReturnsFalse;return this}
A(N.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=C.thatReturnsTrue)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=C.thatReturnsTrue)},persist:function(){this.isPersistent=C.thatReturnsTrue},isPersistent:C.thatReturnsFalse,
destructor:function(){var a=this.constructor.Interface,b;for(b in a)this[b]=null;for(a=0;a<ob.length;a++)this[ob[a]]=null}});N.Interface=pb;N.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;A(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=A({},d.Interface,a);c.extend=d.extend;qb(c);return c};qb(N);
function rb(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}function sb(a){a instanceof this?void 0:D("223");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function qb(a){a.eventPool=[];a.getPooled=rb;a.release=sb}var tb=N.extend({data:null}),ub=N.extend({data:null}),vb=[9,13,27,32],wb=m.canUseDOM&&"CompositionEvent"in window,xb=null;m.canUseDOM&&"documentMode"in document&&(xb=document.documentMode);
var yb=m.canUseDOM&&"TextEvent"in window&&!xb,zb=m.canUseDOM&&(!wb||xb&&8<xb&&11>=xb),Ab=String.fromCharCode(32),Eb={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["topCompositionEnd","topKeyPress","topTextInput","topPaste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"topBlur topCompositionEnd topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"topBlur topCompositionStart topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"topBlur topCompositionUpdate topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")}},Kb=!1;
function Lb(a,b){switch(a){case "topKeyUp":return-1!==vb.indexOf(b.keyCode);case "topKeyDown":return 229!==b.keyCode;case "topKeyPress":case "topMouseDown":case "topBlur":return!0;default:return!1}}function Mb(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var Nb=!1;function Ob(a,b){switch(a){case "topCompositionEnd":return Mb(b);case "topKeyPress":if(32!==b.which)return null;Kb=!0;return Ab;case "topTextInput":return a=b.data,a===Ab&&Kb?null:a;default:return null}}
function Pb(a,b){if(Nb)return"topCompositionEnd"===a||!wb&&Lb(a,b)?(a=mb(),M._root=null,M._startText=null,M._fallbackText=null,Nb=!1,a):null;switch(a){case "topPaste":return null;case "topKeyPress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "topCompositionEnd":return zb?null:b.data;default:return null}}
var Qb={eventTypes:Eb,extractEvents:function(a,b,c,d){var e=void 0;var f=void 0;if(wb)b:{switch(a){case "topCompositionStart":e=Eb.compositionStart;break b;case "topCompositionEnd":e=Eb.compositionEnd;break b;case "topCompositionUpdate":e=Eb.compositionUpdate;break b}e=void 0}else Nb?Lb(a,c)&&(e=Eb.compositionEnd):"topKeyDown"===a&&229===c.keyCode&&(e=Eb.compositionStart);e?(zb&&(Nb||e!==Eb.compositionStart?e===Eb.compositionEnd&&Nb&&(f=mb()):(M._root=d,M._startText=nb(),Nb=!0)),e=tb.getPooled(e,
b,c,d),f?e.data=f:(f=Mb(c),null!==f&&(e.data=f)),hb(e),f=e):f=null;(a=yb?Ob(a,c):Pb(a,c))?(b=ub.getPooled(Eb.beforeInput,b,c,d),b.data=a,hb(b)):b=null;return null===f?b:null===b?f:[f,b]}},Rb=null,Sb=null,Tb=null;function Ub(a){if(a=Da(a)){Rb&&"function"===typeof Rb.restoreControlledState?void 0:D("194");var b=Ca(a.stateNode);Rb.restoreControlledState(a.stateNode,a.type,b)}}var Vb={injectFiberControlledHostComponent:function(a){Rb=a}};function Wb(a){Sb?Tb?Tb.push(a):Tb=[a]:Sb=a}
function Xb(){return null!==Sb||null!==Tb}function Yb(){if(Sb){var a=Sb,b=Tb;Tb=Sb=null;Ub(a);if(b)for(a=0;a<b.length;a++)Ub(b[a])}}var Zb=Object.freeze({injection:Vb,enqueueStateRestore:Wb,needsStateRestore:Xb,restoreStateIfNeeded:Yb});function $b(a,b){return a(b)}function ac(a,b,c){return a(b,c)}function bc(){}var cc=!1;function dc(a,b){if(cc)return a(b);cc=!0;try{return $b(a,b)}finally{cc=!1,Xb()&&(bc(),Yb())}}
var ec={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function fc(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!ec[a.type]:"textarea"===b?!0:!1}function gc(a){a=a.target||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}
function hc(a,b){if(!m.canUseDOM||b&&!("addEventListener"in document))return!1;a="on"+a;b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}function ic(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function jc(a){var b=ic(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"function"===typeof c.get&&"function"===typeof c.set)return Object.defineProperty(a,b,{configurable:!0,get:function(){return c.get.call(this)},set:function(a){d=""+a;c.set.call(this,a)}}),Object.defineProperty(a,b,{enumerable:c.enumerable}),{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=null;delete a[b]}}}
function kc(a){a._valueTracker||(a._valueTracker=jc(a))}function lc(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=ic(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}
var mc=ba.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,O="function"===typeof Symbol&&Symbol["for"],nc=O?Symbol["for"]("react.element"):60103,oc=O?Symbol["for"]("react.call"):60104,pc=O?Symbol["for"]("react.return"):60105,qc=O?Symbol["for"]("react.portal"):60106,rc=O?Symbol["for"]("react.fragment"):60107,sc=O?Symbol["for"]("react.strict_mode"):60108,tc=O?Symbol["for"]("react.provider"):60109,uc=O?Symbol["for"]("react.context"):60110,vc=O?Symbol["for"]("react.async_mode"):60111,
wc=O?Symbol["for"]("react.forward_ref"):60112,xc="function"===typeof Symbol&&Symbol.iterator;function yc(a){if(null===a||"undefined"===typeof a)return null;a=xc&&a[xc]||a["@@iterator"];return"function"===typeof a?a:null}function zc(a){a=a.type;if("function"===typeof a)return a.displayName||a.name;if("string"===typeof a)return a;switch(a){case rc:return"ReactFragment";case qc:return"ReactPortal";case oc:return"ReactCall";case pc:return"ReactReturn"}return null}
function Ac(a){var b="";do{a:switch(a.tag){case 0:case 1:case 2:case 5:var c=a._debugOwner,d=a._debugSource;var e=zc(a);var f=null;c&&(f=zc(c));c=d;e="\n    in "+(e||"Unknown")+(c?" (at "+c.fileName.replace(/^.*[\\\/]/,"")+":"+c.lineNumber+")":f?" (created by "+f+")":"");break a;default:e=""}b+=e;a=a["return"]}while(a);return b}
var Bc=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Cc={},Dc={};function Ec(a){if(Dc.hasOwnProperty(a))return!0;if(Cc.hasOwnProperty(a))return!1;if(Bc.test(a))return Dc[a]=!0;Cc[a]=!0;return!1}
function Fc(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}function Gc(a,b,c,d){if(null===b||"undefined"===typeof b||Fc(a,b,c,d))return!0;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}
function U(a,b,c,d,e){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b}var V={};"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){V[a]=new U(a,0,!1,a,null)});
[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];V[b]=new U(b,1,!1,a[1],null)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){V[a]=new U(a,2,!1,a.toLowerCase(),null)});["autoReverse","externalResourcesRequired","preserveAlpha"].forEach(function(a){V[a]=new U(a,2,!1,a,null)});
"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){V[a]=new U(a,3,!1,a.toLowerCase(),null)});["checked","multiple","muted","selected"].forEach(function(a){V[a]=new U(a,3,!0,a.toLowerCase(),null)});["capture","download"].forEach(function(a){V[a]=new U(a,4,!1,a.toLowerCase(),null)});
["cols","rows","size","span"].forEach(function(a){V[a]=new U(a,6,!1,a.toLowerCase(),null)});["rowSpan","start"].forEach(function(a){V[a]=new U(a,5,!1,a.toLowerCase(),null)});var Hc=/[\-\:]([a-z])/g;function Sc(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Hc,
Sc);V[b]=new U(b,1,!1,a,null)});"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Hc,Sc);V[b]=new U(b,1,!1,a,"http://www.w3.org/1999/xlink")});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Hc,Sc);V[b]=new U(b,1,!1,a,"http://www.w3.org/XML/1998/namespace")});V.tabIndex=new U("tabIndex",1,!1,"tabindex",null);
function Tc(a,b,c,d){var e=V.hasOwnProperty(b)?V[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Gc(b,c,e,d)&&(c=null),d||null===e?Ec(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
function Uc(a,b){var c=b.checked;return A({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}function Vc(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=Wc(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Xc(a,b){b=b.checked;null!=b&&Tc(a,"checked",b,!1)}
function Yc(a,b){Xc(a,b);var c=Wc(b.value);if(null!=c)if("number"===b.type){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);b.hasOwnProperty("value")?Zc(a,b.type,c):b.hasOwnProperty("defaultValue")&&Zc(a,b.type,Wc(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function $c(a,b){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue"))""===a.value&&(a.value=""+a._wrapperState.initialValue),a.defaultValue=""+a._wrapperState.initialValue;b=a.name;""!==b&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!a.defaultChecked;""!==b&&(a.name=b)}function Zc(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}
function Wc(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}var ad={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"topBlur topChange topClick topFocus topInput topKeyDown topKeyUp topSelectionChange".split(" ")}};function bd(a,b,c){a=N.getPooled(ad.change,a,b,c);a.type="change";Wb(c);hb(a);return a}var cd=null,dd=null;function ed(a){Oa(a,!1)}
function fd(a){var b=Ua(a);if(lc(b))return a}function gd(a,b){if("topChange"===a)return b}var hd=!1;m.canUseDOM&&(hd=hc("input")&&(!document.documentMode||9<document.documentMode));function id(){cd&&(cd.detachEvent("onpropertychange",jd),dd=cd=null)}function jd(a){"value"===a.propertyName&&fd(dd)&&(a=bd(dd,a,gc(a)),dc(ed,a))}function kd(a,b,c){"topFocus"===a?(id(),cd=b,dd=c,cd.attachEvent("onpropertychange",jd)):"topBlur"===a&&id()}
function ld(a){if("topSelectionChange"===a||"topKeyUp"===a||"topKeyDown"===a)return fd(dd)}function md(a,b){if("topClick"===a)return fd(b)}function nd(a,b){if("topInput"===a||"topChange"===a)return fd(b)}
var od={eventTypes:ad,_isInputEventSupported:hd,extractEvents:function(a,b,c,d){var e=b?Ua(b):window,f=void 0,h=void 0,g=e.nodeName&&e.nodeName.toLowerCase();"select"===g||"input"===g&&"file"===e.type?f=gd:fc(e)?hd?f=nd:(f=ld,h=kd):(g=e.nodeName,!g||"input"!==g.toLowerCase()||"checkbox"!==e.type&&"radio"!==e.type||(f=md));if(f&&(f=f(a,b)))return bd(f,c,d);h&&h(a,e,b);"topBlur"===a&&null!=b&&(a=b._wrapperState||e._wrapperState)&&a.controlled&&"number"===e.type&&Zc(e,"number",e.value)}},pd=N.extend({view:null,
detail:null}),qd={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function rd(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=qd[a])?!!b[a]:!1}function sd(){return rd}
var td=pd.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:sd,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)}}),ud={mouseEnter:{registrationName:"onMouseEnter",dependencies:["topMouseOut","topMouseOver"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["topMouseOut","topMouseOver"]}},vd={eventTypes:ud,extractEvents:function(a,
b,c,d){if("topMouseOver"===a&&(c.relatedTarget||c.fromElement)||"topMouseOut"!==a&&"topMouseOver"!==a)return null;var e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;"topMouseOut"===a?(a=b,b=(b=c.relatedTarget||c.toElement)?Ta(b):null):a=null;if(a===b)return null;var f=null==a?e:Ua(a);e=null==b?e:Ua(b);var h=td.getPooled(ud.mouseLeave,a,c,d);h.type="mouseleave";h.target=f;h.relatedTarget=e;c=td.getPooled(ud.mouseEnter,b,c,d);c.type="mouseenter";c.target=e;c.relatedTarget=
f;ib(h,c,a,b);return[h,c]}};function wd(a){var b=a;if(a.alternate)for(;b["return"];)b=b["return"];else{if(0!==(b.effectTag&2))return 1;for(;b["return"];)if(b=b["return"],0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function xd(a){return(a=a._reactInternalFiber)?2===wd(a):!1}function yd(a){2!==wd(a)?D("188"):void 0}
function zd(a){var b=a.alternate;if(!b)return b=wd(a),3===b?D("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c["return"],f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var h=e.child;h;){if(h===c)return yd(e),a;if(h===d)return yd(e),b;h=h.sibling}D("188")}if(c["return"]!==d["return"])c=e,d=f;else{h=!1;for(var g=e.child;g;){if(g===c){h=!0;c=e;d=f;break}if(g===d){h=!0;d=e;c=f;break}g=g.sibling}if(!h){for(g=f.child;g;){if(g===c){h=!0;c=f;d=e;break}if(g===d){h=!0;d=f;c=e;break}g=g.sibling}h?
void 0:D("189")}}c.alternate!==d?D("190"):void 0}3!==c.tag?D("188"):void 0;return c.stateNode.current===c?a:b}function Ad(a){a=zd(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child["return"]=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b["return"]||b["return"]===a)return null;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}}return null}
function Bd(a){a=zd(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child&&4!==b.tag)b.child["return"]=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b["return"]||b["return"]===a)return null;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}}return null}var Cd=N.extend({animationName:null,elapsedTime:null,pseudoElement:null}),Dd=N.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),Ed=pd.extend({relatedTarget:null});
function Fd(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var Gd={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},Hd={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},Id=pd.extend({key:function(a){if(a.key){var b=Gd[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=Fd(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?Hd[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:sd,charCode:function(a){return"keypress"===
a.type?Fd(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?Fd(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),Jd=td.extend({dataTransfer:null}),Kd=pd.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:sd}),Ld=N.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),Md=td.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),Nd={},Od={};function Pd(a,b){var c=a[0].toUpperCase()+a.slice(1),d="on"+c;c="top"+c;b={phasedRegistrationNames:{bubbled:d,captured:d+"Capture"},dependencies:[c],isInteractive:b};Nd[a]=b;Od[c]=b}
"blur cancel click close contextMenu copy cut doubleClick dragEnd dragStart drop focus input invalid keyDown keyPress keyUp mouseDown mouseUp paste pause play rateChange reset seeked submit touchCancel touchEnd touchStart volumeChange".split(" ").forEach(function(a){Pd(a,!0)});
"abort animationEnd animationIteration animationStart canPlay canPlayThrough drag dragEnter dragExit dragLeave dragOver durationChange emptied encrypted ended error load loadedData loadedMetadata loadStart mouseMove mouseOut mouseOver playing progress scroll seeking stalled suspend timeUpdate toggle touchMove transitionEnd waiting wheel".split(" ").forEach(function(a){Pd(a,!1)});
var Qd={eventTypes:Nd,isInteractiveTopLevelEventType:function(a){a=Od[a];return void 0!==a&&!0===a.isInteractive},extractEvents:function(a,b,c,d){var e=Od[a];if(!e)return null;switch(a){case "topKeyPress":if(0===Fd(c))return null;case "topKeyDown":case "topKeyUp":a=Id;break;case "topBlur":case "topFocus":a=Ed;break;case "topClick":if(2===c.button)return null;case "topDoubleClick":case "topMouseDown":case "topMouseMove":case "topMouseUp":case "topMouseOut":case "topMouseOver":case "topContextMenu":a=
td;break;case "topDrag":case "topDragEnd":case "topDragEnter":case "topDragExit":case "topDragLeave":case "topDragOver":case "topDragStart":case "topDrop":a=Jd;break;case "topTouchCancel":case "topTouchEnd":case "topTouchMove":case "topTouchStart":a=Kd;break;case "topAnimationEnd":case "topAnimationIteration":case "topAnimationStart":a=Cd;break;case "topTransitionEnd":a=Ld;break;case "topScroll":a=pd;break;case "topWheel":a=Md;break;case "topCopy":case "topCut":case "topPaste":a=Dd;break;default:a=
N}b=a.getPooled(e,b,c,d);hb(b);return b}},Rd=Qd.isInteractiveTopLevelEventType,Sd=[];function Td(a){var b=a.targetInst;do{if(!b){a.ancestors.push(b);break}var c;for(c=b;c["return"];)c=c["return"];c=3!==c.tag?null:c.stateNode.containerInfo;if(!c)break;a.ancestors.push(b);b=Ta(c)}while(b);for(c=0;c<a.ancestors.length;c++)b=a.ancestors[c],Pa(a.topLevelType,b,a.nativeEvent,gc(a.nativeEvent))}var Ud=!0;function Vd(a){Ud=!!a}
function W(a,b,c){if(!c)return null;a=(Rd(a)?Wd:Xd).bind(null,a);c.addEventListener(b,a,!1)}function Yd(a,b,c){if(!c)return null;a=(Rd(a)?Wd:Xd).bind(null,a);c.addEventListener(b,a,!0)}function Wd(a,b){ac(Xd,a,b)}
function Xd(a,b){if(Ud){var c=gc(b);c=Ta(c);null!==c&&"number"===typeof c.tag&&2!==wd(c)&&(c=null);if(Sd.length){var d=Sd.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{dc(Td,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>Sd.length&&Sd.push(a)}}}
var Zd=Object.freeze({get _enabled(){return Ud},setEnabled:Vd,isEnabled:function(){return Ud},trapBubbledEvent:W,trapCapturedEvent:Yd,dispatchEvent:Xd});function $d(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;c["ms"+a]="MS"+b;c["O"+a]="o"+b.toLowerCase();return c}
var ae={animationend:$d("Animation","AnimationEnd"),animationiteration:$d("Animation","AnimationIteration"),animationstart:$d("Animation","AnimationStart"),transitionend:$d("Transition","TransitionEnd")},be={},ce={};m.canUseDOM&&(ce=document.createElement("div").style,"AnimationEvent"in window||(delete ae.animationend.animation,delete ae.animationiteration.animation,delete ae.animationstart.animation),"TransitionEvent"in window||delete ae.transitionend.transition);
function de(a){if(be[a])return be[a];if(!ae[a])return a;var b=ae[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in ce)return be[a]=b[c];return a}
var ee={topAnimationEnd:de("animationend"),topAnimationIteration:de("animationiteration"),topAnimationStart:de("animationstart"),topBlur:"blur",topCancel:"cancel",topChange:"change",topClick:"click",topClose:"close",topCompositionEnd:"compositionend",topCompositionStart:"compositionstart",topCompositionUpdate:"compositionupdate",topContextMenu:"contextmenu",topCopy:"copy",topCut:"cut",topDoubleClick:"dblclick",topDrag:"drag",topDragEnd:"dragend",topDragEnter:"dragenter",topDragExit:"dragexit",topDragLeave:"dragleave",
topDragOver:"dragover",topDragStart:"dragstart",topDrop:"drop",topFocus:"focus",topInput:"input",topKeyDown:"keydown",topKeyPress:"keypress",topKeyUp:"keyup",topLoad:"load",topLoadStart:"loadstart",topMouseDown:"mousedown",topMouseMove:"mousemove",topMouseOut:"mouseout",topMouseOver:"mouseover",topMouseUp:"mouseup",topPaste:"paste",topScroll:"scroll",topSelectionChange:"selectionchange",topTextInput:"textInput",topToggle:"toggle",topTouchCancel:"touchcancel",topTouchEnd:"touchend",topTouchMove:"touchmove",
topTouchStart:"touchstart",topTransitionEnd:de("transitionend"),topWheel:"wheel"},fe={topAbort:"abort",topCanPlay:"canplay",topCanPlayThrough:"canplaythrough",topDurationChange:"durationchange",topEmptied:"emptied",topEncrypted:"encrypted",topEnded:"ended",topError:"error",topLoadedData:"loadeddata",topLoadedMetadata:"loadedmetadata",topLoadStart:"loadstart",topPause:"pause",topPlay:"play",topPlaying:"playing",topProgress:"progress",topRateChange:"ratechange",topSeeked:"seeked",topSeeking:"seeking",
topStalled:"stalled",topSuspend:"suspend",topTimeUpdate:"timeupdate",topVolumeChange:"volumechange",topWaiting:"waiting"},ge={},he=0,ie="_reactListenersID"+(""+Math.random()).slice(2);function je(a){Object.prototype.hasOwnProperty.call(a,ie)||(a[ie]=he++,ge[a[ie]]={});return ge[a[ie]]}function ke(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
function le(a,b){var c=ke(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=ke(c)}}function me(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&"text"===a.type||"textarea"===b||"true"===a.contentEditable)}
var ne=m.canUseDOM&&"documentMode"in document&&11>=document.documentMode,oe={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"topBlur topContextMenu topFocus topKeyDown topKeyUp topMouseDown topMouseUp topSelectionChange".split(" ")}},pe=null,qe=null,re=null,se=!1;
function ue(a,b){if(se||null==pe||pe!==ea())return null;var c=pe;"selectionStart"in c&&me(c)?c={start:c.selectionStart,end:c.selectionEnd}:window.getSelection?(c=window.getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset}):c=void 0;return re&&fa(re,c)?null:(re=c,a=N.getPooled(oe.select,qe,a,b),a.type="select",a.target=pe,hb(a),a)}
var we={eventTypes:oe,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=je(e);f=ua.onSelect;for(var h=0;h<f.length;h++){var g=f[h];if(!e.hasOwnProperty(g)||!e[g]){e=!1;break a}}e=!0}f=!e}if(f)return null;e=b?Ua(b):window;switch(a){case "topFocus":if(fc(e)||"true"===e.contentEditable)pe=e,qe=b,re=null;break;case "topBlur":re=qe=pe=null;break;case "topMouseDown":se=!0;break;case "topContextMenu":case "topMouseUp":return se=!1,ue(c,d);case "topSelectionChange":if(ne)break;
case "topKeyDown":case "topKeyUp":return ue(c,d)}return null}};Ma.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin TapEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));Ca=ab.getFiberCurrentPropsFromNode;Da=ab.getInstanceFromNode;Ea=ab.getNodeFromInstance;Ma.injectEventPluginsByName({SimpleEventPlugin:Qd,EnterLeaveEventPlugin:vd,ChangeEventPlugin:od,SelectEventPlugin:we,BeforeInputEventPlugin:Qb});
function xe(a,b,c,d){this.tag=a;this.key=c;this.stateNode=this.type=null;this.sibling=this.child=this["return"]=null;this.index=0;this.ref=null;this.pendingProps=b;this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.expirationTime=0;this.alternate=null}
function ye(a,b,c){var d=a.alternate;null===d?(d=new xe(a.tag,b,a.key,a.mode),d.type=a.type,d.stateNode=a.stateNode,d.alternate=a,a.alternate=d):(d.pendingProps=b,d.effectTag=0,d.nextEffect=null,d.firstEffect=null,d.lastEffect=null);d.expirationTime=c;d.child=a.child;d.memoizedProps=a.memoizedProps;d.memoizedState=a.memoizedState;d.updateQueue=a.updateQueue;d.sibling=a.sibling;d.index=a.index;d.ref=a.ref;return d}
function ze(a,b,c){var d=a.type,e=a.key;a=a.props;var f=void 0;if("function"===typeof d)f=d.prototype&&d.prototype.isReactComponent?2:0;else if("string"===typeof d)f=5;else switch(d){case rc:return Ae(a.children,b,c,e);case vc:f=11;b|=3;break;case sc:f=11;b|=2;break;case oc:f=7;break;case pc:f=9;break;default:if("object"===typeof d&&null!==d)switch(d.$$typeof){case tc:f=13;break;case uc:f=12;break;case wc:f=14;break;default:if("number"===typeof d.tag)return b=d,b.pendingProps=a,b.expirationTime=c,
b;D("130",null==d?d:typeof d,"")}else D("130",null==d?d:typeof d,"")}b=new xe(f,a,e,b);b.type=d;b.expirationTime=c;return b}function Ae(a,b,c,d){a=new xe(10,a,d,b);a.expirationTime=c;return a}function Be(a,b,c){a=new xe(6,a,null,b);a.expirationTime=c;return a}function Ce(a,b,c){b=new xe(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}var De=null,Ee=null;
function Fe(a){return function(b){try{return a(b)}catch(c){}}}function Ge(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);De=Fe(function(a){return b.onCommitFiberRoot(c,a)});Ee=Fe(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}function He(a){"function"===typeof De&&De(a)}function Ie(a){"function"===typeof Ee&&Ee(a)}new Set;
function Je(a){return{baseState:a,expirationTime:0,first:null,last:null,callbackList:null,hasForceUpdate:!1,isInitialized:!1,capturedValues:null}}function Ke(a,b){null===a.last?a.first=a.last=b:(a.last.next=b,a.last=b);if(0===a.expirationTime||a.expirationTime>b.expirationTime)a.expirationTime=b.expirationTime}var Le=void 0,Me=void 0;
function Ne(a){Le=Me=null;var b=a.alternate,c=a.updateQueue;null===c&&(c=a.updateQueue=Je(null));null!==b?(a=b.updateQueue,null===a&&(a=b.updateQueue=Je(null))):a=null;Le=c;Me=a!==c?a:null}function Oe(a,b){Ne(a);a=Le;var c=Me;null===c?Ke(a,b):null===a.last||null===c.last?(Ke(a,b),Ke(c,b)):(Ke(a,b),c.last=b)}function Pe(a,b,c,d){a=a.partialState;return"function"===typeof a?a.call(b,c,d):a}
function Qe(a,b,c,d,e,f){null!==a&&a.updateQueue===c&&(c=b.updateQueue={baseState:c.baseState,expirationTime:c.expirationTime,first:c.first,last:c.last,isInitialized:c.isInitialized,capturedValues:c.capturedValues,callbackList:null,hasForceUpdate:!1});c.expirationTime=0;c.isInitialized?a=c.baseState:(a=c.baseState=b.memoizedState,c.isInitialized=!0);for(var h=!0,g=c.first,k=!1;null!==g;){var v=g.expirationTime;if(v>f){var l=c.expirationTime;if(0===l||l>v)c.expirationTime=v;k||(k=!0,c.baseState=a)}else{k||
(c.first=g.next,null===c.first&&(c.last=null));if(g.isReplace)a=Pe(g,d,a,e),h=!0;else if(v=Pe(g,d,a,e))a=h?A({},a,v):A(a,v),h=!1;g.isForced&&(c.hasForceUpdate=!0);null!==g.callback&&(v=c.callbackList,null===v&&(v=c.callbackList=[]),v.push(g));null!==g.capturedValue&&(v=c.capturedValues,null===v?c.capturedValues=[g.capturedValue]:v.push(g.capturedValue))}g=g.next}null!==c.callbackList?b.effectTag|=32:null!==c.first||c.hasForceUpdate||null!==c.capturedValues||(b.updateQueue=null);k||(c.baseState=a);
return a}function Re(a,b){var c=a.callbackList;if(null!==c)for(a.callbackList=null,a=0;a<c.length;a++){var d=c[a],e=d.callback;d.callback=null;"function"!==typeof e?D("191",e):void 0;e.call(b)}}
function Se(a,b,c,d,e){function f(a,b,c,d,e,f){if(null===b||null!==a.updateQueue&&a.updateQueue.hasForceUpdate)return!0;var n=a.stateNode;a=a.type;return"function"===typeof n.shouldComponentUpdate?n.shouldComponentUpdate(c,e,f):a.prototype&&a.prototype.isPureReactComponent?!fa(b,c)||!fa(d,e):!0}function h(a,b){b.updater=r;a.stateNode=b;b._reactInternalFiber=a}function g(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&
b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&r.enqueueReplaceState(b,b.state,null)}function k(a,b,c,d){a=a.type;if("function"===typeof a.getDerivedStateFromProps)return a.getDerivedStateFromProps.call(null,c,d)}var v=a.cacheContext,l=a.getMaskedContext,p=a.getUnmaskedContext,y=a.isContextConsumer,B=a.hasContextChanged,r={isMounted:xd,enqueueSetState:function(a,d,e){a=a._reactInternalFiber;e=void 0===e?null:e;var f=c(a);Oe(a,{expirationTime:f,partialState:d,callback:e,isReplace:!1,isForced:!1,
capturedValue:null,next:null});b(a,f)},enqueueReplaceState:function(a,d,e){a=a._reactInternalFiber;e=void 0===e?null:e;var f=c(a);Oe(a,{expirationTime:f,partialState:d,callback:e,isReplace:!0,isForced:!1,capturedValue:null,next:null});b(a,f)},enqueueForceUpdate:function(a,d){a=a._reactInternalFiber;d=void 0===d?null:d;var e=c(a);Oe(a,{expirationTime:e,partialState:null,callback:d,isReplace:!1,isForced:!0,capturedValue:null,next:null});b(a,e)}};return{adoptClassInstance:h,callGetDerivedStateFromProps:k,
constructClassInstance:function(a,b){var c=a.type,d=p(a),e=y(a),f=e?l(a,d):ja;c=new c(b,f);var n=null!==c.state&&void 0!==c.state?c.state:null;h(a,c);a.memoizedState=n;b=k(a,c,b,n);null!==b&&void 0!==b&&(a.memoizedState=A({},a.memoizedState,b));e&&v(a,d,f);return c},mountClassInstance:function(a,b){var c=a.type,d=a.alternate,e=a.stateNode,f=a.pendingProps,n=p(a);e.props=f;e.state=a.memoizedState;e.refs=ja;e.context=l(a,n);"function"===typeof c.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||
"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||(c=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),c!==e.state&&r.enqueueReplaceState(e,e.state,null),c=a.updateQueue,null!==c&&(e.state=Qe(d,a,c,e,f,b)));"function"===typeof e.componentDidMount&&(a.effectTag|=4)},resumeMountClassInstance:function(a,b){var c=a.type,n=a.stateNode;n.props=a.memoizedProps;n.state=
a.memoizedState;var h=a.memoizedProps,r=a.pendingProps,y=n.context,q=p(a);q=l(a,q);(c="function"===typeof c.getDerivedStateFromProps||"function"===typeof n.getSnapshotBeforeUpdate)||"function"!==typeof n.UNSAFE_componentWillReceiveProps&&"function"!==typeof n.componentWillReceiveProps||(h!==r||y!==q)&&g(a,n,r,q);y=a.memoizedState;b=null!==a.updateQueue?Qe(null,a,a.updateQueue,n,r,b):y;var t=void 0;h!==r&&(t=k(a,n,r,b));null!==t&&void 0!==t&&(b=null===b||void 0===b?t:A({},b,t));if(!(h!==r||y!==b||
B()||null!==a.updateQueue&&a.updateQueue.hasForceUpdate))return"function"===typeof n.componentDidMount&&(a.effectTag|=4),!1;(h=f(a,h,r,y,b,q))?(c||"function"!==typeof n.UNSAFE_componentWillMount&&"function"!==typeof n.componentWillMount||("function"===typeof n.componentWillMount&&n.componentWillMount(),"function"===typeof n.UNSAFE_componentWillMount&&n.UNSAFE_componentWillMount()),"function"===typeof n.componentDidMount&&(a.effectTag|=4)):("function"===typeof n.componentDidMount&&(a.effectTag|=4),
d(a,r),e(a,b));n.props=r;n.state=b;n.context=q;return h},updateClassInstance:function(a,b,c){var n=b.type,x=b.stateNode;x.props=b.memoizedProps;x.state=b.memoizedState;var h=b.memoizedProps,r=b.pendingProps,q=x.context,t=p(b);t=l(b,t);(n="function"===typeof n.getDerivedStateFromProps||"function"===typeof x.getSnapshotBeforeUpdate)||"function"!==typeof x.UNSAFE_componentWillReceiveProps&&"function"!==typeof x.componentWillReceiveProps||(h!==r||q!==t)&&g(b,x,r,t);q=b.memoizedState;c=null!==b.updateQueue?
Qe(a,b,b.updateQueue,x,r,c):q;var u=void 0;h!==r&&(u=k(b,x,r,c));null!==u&&void 0!==u&&(c=null===c||void 0===c?u:A({},c,u));if(!(h!==r||q!==c||B()||null!==b.updateQueue&&b.updateQueue.hasForceUpdate))return"function"!==typeof x.componentDidUpdate||h===a.memoizedProps&&q===a.memoizedState||(b.effectTag|=4),"function"!==typeof x.getSnapshotBeforeUpdate||h===a.memoizedProps&&q===a.memoizedState||(b.effectTag|=2048),!1;(u=f(b,h,r,q,c,t))?(n||"function"!==typeof x.UNSAFE_componentWillUpdate&&"function"!==
typeof x.componentWillUpdate||("function"===typeof x.componentWillUpdate&&x.componentWillUpdate(r,c,t),"function"===typeof x.UNSAFE_componentWillUpdate&&x.UNSAFE_componentWillUpdate(r,c,t)),"function"===typeof x.componentDidUpdate&&(b.effectTag|=4),"function"===typeof x.getSnapshotBeforeUpdate&&(b.effectTag|=2048)):("function"!==typeof x.componentDidUpdate||h===a.memoizedProps&&q===a.memoizedState||(b.effectTag|=4),"function"!==typeof x.getSnapshotBeforeUpdate||h===a.memoizedProps&&q===a.memoizedState||
(b.effectTag|=2048),d(b,r),e(b,c));x.props=r;x.state=c;x.context=t;return u}}}var Te=Array.isArray;
function Ue(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;var d=void 0;c&&(2!==c.tag?D("110"):void 0,d=c.stateNode);d?void 0:D("147",a);var e=""+a;if(null!==b&&null!==b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs===ja?d.refs={}:d.refs;null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}"string"!==typeof a?D("148"):void 0;c._owner?void 0:D("254",a)}return a}
function Ve(a,b){"textarea"!==a.type&&D("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
function We(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=ye(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function h(b){a&&null===b.alternate&&(b.effectTag=2);return b}function g(a,b,c,d){if(null===b||6!==b.tag)return b=Be(c,a.mode,d),b["return"]=a,b;b=e(b,c,d);b["return"]=a;return b}function k(a,b,c,d){if(null!==b&&b.type===c.type)return d=e(b,c.props,d),d.ref=Ue(a,b,c),d["return"]=a,d;d=ze(c,a.mode,d);d.ref=Ue(a,b,c);d["return"]=a;return d}function v(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==c.implementation)return b=
Ce(c,a.mode,d),b["return"]=a,b;b=e(b,c.children||[],d);b["return"]=a;return b}function l(a,b,c,d,f){if(null===b||10!==b.tag)return b=Ae(c,a.mode,d,f),b["return"]=a,b;b=e(b,c,d);b["return"]=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Be(""+b,a.mode,c),b["return"]=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case nc:return c=ze(b,a.mode,c),c.ref=Ue(a,null,b),c["return"]=a,c;case qc:return b=Ce(b,a.mode,c),b["return"]=a,b}if(Te(b)||yc(b))return b=Ae(b,
a.mode,c,null),b["return"]=a,b;Ve(a,b)}return null}function y(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:g(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case nc:return c.key===e?c.type===rc?l(a,b,c.props.children,d,e):k(a,b,c,d):null;case qc:return c.key===e?v(a,b,c,d):null}if(Te(c)||yc(c))return null!==e?null:l(a,b,c,d,null);Ve(a,c)}return null}function B(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=a.get(c)||
null,g(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case nc:return a=a.get(null===d.key?c:d.key)||null,d.type===rc?l(b,a,d.props.children,e,d.key):k(b,a,d,e);case qc:return a=a.get(null===d.key?c:d.key)||null,v(b,a,d,e)}if(Te(d)||yc(d))return a=a.get(c)||null,l(b,a,d,e,null);Ve(b,d)}return null}function r(e,g,l,h){for(var r=null,k=null,q=g,t=g=0,u=null;null!==q&&t<l.length;t++){q.index>t?(u=q,q=null):u=q.sibling;var n=y(e,q,l[t],h);if(null===n){null===q&&(q=u);break}a&&q&&null===
n.alternate&&b(e,q);g=f(n,g,t);null===k?r=n:k.sibling=n;k=n;q=u}if(t===l.length)return c(e,q),r;if(null===q){for(;t<l.length;t++)if(q=p(e,l[t],h))g=f(q,g,t),null===k?r=q:k.sibling=q,k=q;return r}for(q=d(e,q);t<l.length;t++)if(u=B(q,e,t,l[t],h)){if(a&&null!==u.alternate)q["delete"](null===u.key?t:u.key);g=f(u,g,t);null===k?r=u:k.sibling=u;k=u}a&&q.forEach(function(a){return b(e,a)});return r}function Q(e,g,l,h){var r=yc(l);"function"!==typeof r?D("150"):void 0;l=r.call(l);null==l?D("151"):void 0;for(var k=
r=null,q=g,t=g=0,u=null,n=l.next();null!==q&&!n.done;t++,n=l.next()){q.index>t?(u=q,q=null):u=q.sibling;var H=y(e,q,n.value,h);if(null===H){q||(q=u);break}a&&q&&null===H.alternate&&b(e,q);g=f(H,g,t);null===k?r=H:k.sibling=H;k=H;q=u}if(n.done)return c(e,q),r;if(null===q){for(;!n.done;t++,n=l.next())n=p(e,n.value,h),null!==n&&(g=f(n,g,t),null===k?r=n:k.sibling=n,k=n);return r}for(q=d(e,q);!n.done;t++,n=l.next())if(n=B(q,e,t,n.value,h),null!==n){if(a&&null!==n.alternate)q["delete"](null===n.key?t:n.key);
g=f(n,g,t);null===k?r=n:k.sibling=n;k=n}a&&q.forEach(function(a){return b(e,a)});return r}return function(a,d,f,g){"object"===typeof f&&null!==f&&f.type===rc&&null===f.key&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case nc:a:{var k=f.key;for(l=d;null!==l;){if(l.key===k)if(10===l.tag?f.type===rc:l.type===f.type){c(a,l.sibling);d=e(l,f.type===rc?f.props.children:f.props,g);d.ref=Ue(a,l,f);d["return"]=a;a=d;break a}else{c(a,l);break}else b(a,l);l=l.sibling}f.type===
rc?(d=Ae(f.props.children,a.mode,g,f.key),d["return"]=a,a=d):(g=ze(f,a.mode,g),g.ref=Ue(a,d,f),g["return"]=a,a=g)}return h(a);case qc:a:{for(l=f.key;null!==d;){if(d.key===l)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],g);d["return"]=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=Ce(f,a.mode,g);d["return"]=a;a=d}return h(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&
6===d.tag?(c(a,d.sibling),d=e(d,f,g)):(c(a,d),d=Be(f,a.mode,g)),d["return"]=a,a=d,h(a);if(Te(f))return r(a,d,f,g);if(yc(f))return Q(a,d,f,g);l&&Ve(a,f);if("undefined"===typeof f)switch(a.tag){case 2:case 1:g=a.type,D("152",g.displayName||g.name||"Component")}return c(a,d)}}var Xe=We(!0),Ye=We(!1);
function Ze(a,b,c,d,e,f,h){function g(a,b,c){k(a,b,c,b.expirationTime)}function k(a,b,c,d){b.child=null===a?Ye(b,null,c,d):Xe(b,a.child,c,d)}function v(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function l(a,b,c,d,e,f){v(a,b);if(!c&&!e)return d&&z(b,!1),r(a,b);c=b.stateNode;mc.current=b;var g=e?null:c.render();b.effectTag|=1;e&&(k(a,b,null,f),b.child=null);k(a,b,g,f);b.memoizedState=c.state;b.memoizedProps=c.props;d&&z(b,!0);return b.child}function p(a){var b=a.stateNode;
b.pendingContext?u(a,b.pendingContext,b.pendingContext!==b.context):b.context&&u(a,b.context,!1);Y(a,b.containerInfo)}function y(a,b,c,d){var e=a.child;for(null!==e&&(e["return"]=a);null!==e;){switch(e.tag){case 12:var f=e.stateNode|0;if(e.type===b&&0!==(f&c)){for(f=e;null!==f;){var g=f.alternate;if(0===f.expirationTime||f.expirationTime>d)f.expirationTime=d,null!==g&&(0===g.expirationTime||g.expirationTime>d)&&(g.expirationTime=d);else if(null!==g&&(0===g.expirationTime||g.expirationTime>d))g.expirationTime=
d;else break;f=f["return"]}f=null}else f=e.child;break;case 13:f=e.type===a.type?null:e.child;break;default:f=e.child}if(null!==f)f["return"]=e;else for(f=e;null!==f;){if(f===a){f=null;break}e=f.sibling;if(null!==e){f=e;break}f=f["return"]}e=f}}function B(a,b,c){var d=b.type.context,e=b.pendingProps,f=b.memoizedProps;if(!q()&&f===e)return b.stateNode=0,G(b),r(a,b);var l=e.value;b.memoizedProps=e;if(null===f)l=1073741823;else if(f.value===e.value){if(f.children===e.children)return b.stateNode=0,G(b),
r(a,b);l=0}else{var t=f.value;if(t===l&&(0!==t||1/t===1/l)||t!==t&&l!==l){if(f.children===e.children)return b.stateNode=0,G(b),r(a,b);l=0}else if(l="function"===typeof d._calculateChangedBits?d._calculateChangedBits(t,l):1073741823,l|=0,0===l){if(f.children===e.children)return b.stateNode=0,G(b),r(a,b)}else y(b,d,l,c)}b.stateNode=l;G(b);g(a,b,e.children);return b.child}function r(a,b){null!==a&&b.child!==a.child?D("153"):void 0;if(null!==b.child){a=b.child;var c=ye(a,a.pendingProps,a.expirationTime);
b.child=c;for(c["return"]=b;null!==a.sibling;)a=a.sibling,c=c.sibling=ye(a,a.pendingProps,a.expirationTime),c["return"]=b;c.sibling=null}return b.child}var Q=a.shouldSetTextContent,n=a.shouldDeprioritizeSubtree,x=b.pushHostContext,Y=b.pushHostContainer,G=d.pushProvider,R=c.getMaskedContext,S=c.getUnmaskedContext,q=c.hasContextChanged,t=c.pushContextProvider,u=c.pushTopLevelContextObject,z=c.invalidateContextProvider,H=e.enterHydrationState,Wa=e.resetHydrationState,Bb=e.tryToClaimNextHydratableInstance;
a=Se(c,f,h,function(a,b){a.memoizedProps=b},function(a,b){a.memoizedState=b});var Jc=a.adoptClassInstance,Kc=a.callGetDerivedStateFromProps,Lc=a.constructClassInstance,Cb=a.mountClassInstance,Mc=a.resumeMountClassInstance,Db=a.updateClassInstance;return{beginWork:function(a,b,c){if(0===b.expirationTime||b.expirationTime>c){switch(b.tag){case 3:p(b);break;case 2:t(b);break;case 4:Y(b,b.stateNode.containerInfo);break;case 13:G(b)}return null}switch(b.tag){case 0:null!==a?D("155"):void 0;var d=b.type,
e=b.pendingProps,f=S(b);f=R(b,f);d=d(e,f);b.effectTag|=1;"object"===typeof d&&null!==d&&"function"===typeof d.render&&void 0===d.$$typeof?(f=b.type,b.tag=2,b.memoizedState=null!==d.state&&void 0!==d.state?d.state:null,"function"===typeof f.getDerivedStateFromProps&&(e=Kc(b,d,e,b.memoizedState),null!==e&&void 0!==e&&(b.memoizedState=A({},b.memoizedState,e))),e=t(b),Jc(b,d),Cb(b,c),a=l(a,b,!0,e,!1,c)):(b.tag=1,g(a,b,d),b.memoizedProps=e,a=b.child);return a;case 1:return e=b.type,c=b.pendingProps,q()||
b.memoizedProps!==c?(d=S(b),d=R(b,d),e=e(c,d),b.effectTag|=1,g(a,b,e),b.memoizedProps=c,a=b.child):a=r(a,b),a;case 2:e=t(b);null===a?null===b.stateNode?(Lc(b,b.pendingProps),Cb(b,c),d=!0):d=Mc(b,c):d=Db(a,b,c);f=!1;var h=b.updateQueue;null!==h&&null!==h.capturedValues&&(f=d=!0);return l(a,b,d,e,f,c);case 3:a:if(p(b),d=b.updateQueue,null!==d){f=b.memoizedState;e=Qe(a,b,d,null,null,c);b.memoizedState=e;d=b.updateQueue;if(null!==d&&null!==d.capturedValues)d=null;else if(f===e){Wa();a=r(a,b);break a}else d=
e.element;f=b.stateNode;(null===a||null===a.child)&&f.hydrate&&H(b)?(b.effectTag|=2,b.child=Ye(b,null,d,c)):(Wa(),g(a,b,d));b.memoizedState=e;a=b.child}else Wa(),a=r(a,b);return a;case 5:a:{x(b);null===a&&Bb(b);e=b.type;h=b.memoizedProps;d=b.pendingProps;f=null!==a?a.memoizedProps:null;if(!q()&&h===d){if(h=b.mode&1&&n(e,d))b.expirationTime=1073741823;if(!h||1073741823!==c){a=r(a,b);break a}}h=d.children;Q(e,d)?h=null:f&&Q(e,f)&&(b.effectTag|=16);v(a,b);1073741823!==c&&b.mode&1&&n(e,d)?(b.expirationTime=
1073741823,b.memoizedProps=d,a=null):(g(a,b,h),b.memoizedProps=d,a=b.child)}return a;case 6:return null===a&&Bb(b),b.memoizedProps=b.pendingProps,null;case 8:b.tag=7;case 7:return e=b.pendingProps,q()||b.memoizedProps!==e||(e=b.memoizedProps),d=e.children,b.stateNode=null===a?Ye(b,b.stateNode,d,c):Xe(b,a.stateNode,d,c),b.memoizedProps=e,b.stateNode;case 9:return null;case 4:return Y(b,b.stateNode.containerInfo),e=b.pendingProps,q()||b.memoizedProps!==e?(null===a?b.child=Xe(b,null,e,c):g(a,b,e),b.memoizedProps=
e,a=b.child):a=r(a,b),a;case 14:return c=b.type.render,c=c(b.pendingProps,b.ref),g(a,b,c),b.memoizedProps=c,b.child;case 10:return c=b.pendingProps,q()||b.memoizedProps!==c?(g(a,b,c),b.memoizedProps=c,a=b.child):a=r(a,b),a;case 11:return c=b.pendingProps.children,q()||null!==c&&b.memoizedProps!==c?(g(a,b,c),b.memoizedProps=c,a=b.child):a=r(a,b),a;case 13:return B(a,b,c);case 12:d=b.type;f=b.pendingProps;var u=b.memoizedProps;e=d._currentValue;h=d._changedBits;if(q()||0!==h||u!==f){b.memoizedProps=
f;u=f.unstable_observedBits;if(void 0===u||null===u)u=1073741823;b.stateNode=u;0!==(h&u)&&y(b,d,h,c);c=f.children;c=c(e);g(a,b,c);a=b.child}else a=r(a,b);return a;default:D("156")}}}}
function $e(a,b,c,d,e){function f(a){a.effectTag|=4}var h=a.createInstance,g=a.createTextInstance,k=a.appendInitialChild,v=a.finalizeInitialChildren,l=a.prepareUpdate,p=a.persistence,y=b.getRootHostContainer,B=b.popHostContext,r=b.getHostContext,Q=b.popHostContainer,n=c.popContextProvider,x=c.popTopLevelContextObject,Y=d.popProvider,G=e.prepareToHydrateHostInstance,R=e.prepareToHydrateHostTextInstance,S=e.popHydrationState,q=void 0,t=void 0,u=void 0;a.mutation?(q=function(){},t=function(a,b,c){(b.updateQueue=
c)&&f(b)},u=function(a,b,c,d){c!==d&&f(b)}):p?D("235"):D("236");return{completeWork:function(a,b,c){var d=b.pendingProps;switch(b.tag){case 1:return null;case 2:return n(b),a=b.stateNode,d=b.updateQueue,null!==d&&null!==d.capturedValues&&(b.effectTag&=-65,"function"===typeof a.componentDidCatch?b.effectTag|=256:d.capturedValues=null),null;case 3:Q(b);x(b);d=b.stateNode;d.pendingContext&&(d.context=d.pendingContext,d.pendingContext=null);if(null===a||null===a.child)S(b),b.effectTag&=-3;q(b);a=b.updateQueue;
null!==a&&null!==a.capturedValues&&(b.effectTag|=256);return null;case 5:B(b);c=y();var e=b.type;if(null!==a&&null!=b.stateNode){var p=a.memoizedProps,H=b.stateNode,z=r();H=l(H,e,p,d,c,z);t(a,b,H,e,p,d,c,z);a.ref!==b.ref&&(b.effectTag|=128)}else{if(!d)return null===b.stateNode?D("166"):void 0,null;a=r();if(S(b))G(b,c,a)&&f(b);else{p=h(e,d,c,a,b);a:for(z=b.child;null!==z;){if(5===z.tag||6===z.tag)k(p,z.stateNode);else if(4!==z.tag&&null!==z.child){z.child["return"]=z;z=z.child;continue}if(z===b)break;
for(;null===z.sibling;){if(null===z["return"]||z["return"]===b)break a;z=z["return"]}z.sibling["return"]=z["return"];z=z.sibling}v(p,e,d,c,a)&&f(b);b.stateNode=p}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)u(a,b,a.memoizedProps,d);else{if("string"!==typeof d)return null===b.stateNode?D("166"):void 0,null;a=y();c=r();S(b)?R(b)&&f(b):b.stateNode=g(d,a,c,b)}return null;case 7:(d=b.memoizedProps)?void 0:D("165");b.tag=8;e=[];a:for((p=b.stateNode)&&(p["return"]=b);null!==
p;){if(5===p.tag||6===p.tag||4===p.tag)D("247");else if(9===p.tag)e.push(p.pendingProps.value);else if(null!==p.child){p.child["return"]=p;p=p.child;continue}for(;null===p.sibling;){if(null===p["return"]||p["return"]===b)break a;p=p["return"]}p.sibling["return"]=p["return"];p=p.sibling}p=d.handler;d=p(d.props,e);b.child=Xe(b,null!==a?a.child:null,d,c);return b.child;case 8:return b.tag=7,null;case 9:return null;case 14:return null;case 10:return null;case 11:return null;case 4:return Q(b),q(b),null;
case 13:return Y(b),null;case 12:return null;case 0:D("167");default:D("156")}}}}
function af(a,b,c,d,e){var f=a.popHostContainer,h=a.popHostContext,g=b.popContextProvider,k=b.popTopLevelContextObject,v=c.popProvider;return{throwException:function(a,b,c){b.effectTag|=512;b.firstEffect=b.lastEffect=null;b={value:c,source:b,stack:Ac(b)};do{switch(a.tag){case 3:Ne(a);a.updateQueue.capturedValues=[b];a.effectTag|=1024;return;case 2:if(c=a.stateNode,0===(a.effectTag&64)&&null!==c&&"function"===typeof c.componentDidCatch&&!e(c)){Ne(a);c=a.updateQueue;var d=c.capturedValues;null===d?
c.capturedValues=[b]:d.push(b);a.effectTag|=1024;return}}a=a["return"]}while(null!==a)},unwindWork:function(a){switch(a.tag){case 2:g(a);var b=a.effectTag;return b&1024?(a.effectTag=b&-1025|64,a):null;case 3:return f(a),k(a),b=a.effectTag,b&1024?(a.effectTag=b&-1025|64,a):null;case 5:return h(a),null;case 4:return f(a),null;case 13:return v(a),null;default:return null}},unwindInterruptedWork:function(a){switch(a.tag){case 2:g(a);break;case 3:f(a);k(a);break;case 5:h(a);break;case 4:f(a);break;case 13:v(a)}}}}
function bf(a,b){var c=b.source;null===b.stack&&Ac(c);null!==c&&zc(c);b=b.value;null!==a&&2===a.tag&&zc(a);try{b&&b.suppressReactErrorLogging||console.error(b)}catch(d){d&&d.suppressReactErrorLogging||console.error(d)}}
function cf(a,b,c,d,e){function f(a){var c=a.ref;if(null!==c)if("function"===typeof c)try{c(null)}catch(u){b(a,u)}else c.current=null}function h(a){"function"===typeof Ie&&Ie(a);switch(a.tag){case 2:f(a);var c=a.stateNode;if("function"===typeof c.componentWillUnmount)try{c.props=a.memoizedProps,c.state=a.memoizedState,c.componentWillUnmount()}catch(u){b(a,u)}break;case 5:f(a);break;case 7:g(a.stateNode);break;case 4:p&&v(a)}}function g(a){for(var b=a;;)if(h(b),null===b.child||p&&4===b.tag){if(b===
a)break;for(;null===b.sibling;){if(null===b["return"]||b["return"]===a)return;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}else b.child["return"]=b,b=b.child}function k(a){return 5===a.tag||3===a.tag||4===a.tag}function v(a){for(var b=a,c=!1,d=void 0,e=void 0;;){if(!c){c=b["return"];a:for(;;){null===c?D("160"):void 0;switch(c.tag){case 5:d=c.stateNode;e=!1;break a;case 3:d=c.stateNode.containerInfo;e=!0;break a;case 4:d=c.stateNode.containerInfo;e=!0;break a}c=c["return"]}c=!0}if(5===
b.tag||6===b.tag)g(b),e?S(d,b.stateNode):R(d,b.stateNode);else if(4===b.tag?d=b.stateNode.containerInfo:h(b),null!==b.child){b.child["return"]=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b["return"]||b["return"]===a)return;b=b["return"];4===b.tag&&(c=!1)}b.sibling["return"]=b["return"];b=b.sibling}}var l=a.getPublicInstance,p=a.mutation;a=a.persistence;p||(a?D("235"):D("236"));var y=p.commitMount,B=p.commitUpdate,r=p.resetTextContent,Q=p.commitTextUpdate,n=p.appendChild,
x=p.appendChildToContainer,Y=p.insertBefore,G=p.insertInContainerBefore,R=p.removeChild,S=p.removeChildFromContainer;return{commitBeforeMutationLifeCycles:function(a,b){switch(b.tag){case 2:if(b.effectTag&2048&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;a.props=b.memoizedProps;a.state=b.memoizedState;b=a.getSnapshotBeforeUpdate(c,d);a.__reactInternalSnapshotBeforeUpdate=b}break;case 3:case 5:case 6:case 4:break;default:D("163")}},commitResetTextContent:function(a){r(a.stateNode)},
commitPlacement:function(a){a:{for(var b=a["return"];null!==b;){if(k(b)){var c=b;break a}b=b["return"]}D("160");c=void 0}var d=b=void 0;switch(c.tag){case 5:b=c.stateNode;d=!1;break;case 3:b=c.stateNode.containerInfo;d=!0;break;case 4:b=c.stateNode.containerInfo;d=!0;break;default:D("161")}c.effectTag&16&&(r(b),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c["return"]||k(c["return"])){c=null;break a}c=c["return"]}c.sibling["return"]=c["return"];for(c=c.sibling;5!==c.tag&&6!==
c.tag;){if(c.effectTag&2)continue b;if(null===c.child||4===c.tag)continue b;else c.child["return"]=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(5===e.tag||6===e.tag)c?d?G(b,e.stateNode,c):Y(b,e.stateNode,c):d?x(b,e.stateNode):n(b,e.stateNode);else if(4!==e.tag&&null!==e.child){e.child["return"]=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e["return"]||e["return"]===a)return;e=e["return"]}e.sibling["return"]=e["return"];e=e.sibling}},commitDeletion:function(a){v(a);
a["return"]=null;a.child=null;a.alternate&&(a.alternate.child=null,a.alternate["return"]=null)},commitWork:function(a,b){switch(b.tag){case 2:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,f=b.updateQueue;b.updateQueue=null;null!==f&&B(c,f,e,a,d,b)}break;case 6:null===b.stateNode?D("162"):void 0;c=b.memoizedProps;Q(b.stateNode,null!==a?a.memoizedProps:c,c);break;case 3:break;default:D("163")}},commitLifeCycles:function(a,b,c){switch(c.tag){case 2:a=
c.stateNode;if(c.effectTag&4)if(null===b)a.props=c.memoizedProps,a.state=c.memoizedState,a.componentDidMount();else{var d=b.memoizedProps;b=b.memoizedState;a.props=c.memoizedProps;a.state=c.memoizedState;a.componentDidUpdate(d,b,a.__reactInternalSnapshotBeforeUpdate)}c=c.updateQueue;null!==c&&Re(c,a);break;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=l(c.child.stateNode);break;case 2:a=c.child.stateNode}Re(b,a)}break;case 5:a=c.stateNode;null===b&&c.effectTag&
4&&y(a,c.type,c.memoizedProps,c);break;case 6:break;case 4:break;default:D("163")}},commitErrorLogging:function(a,b){switch(a.tag){case 2:var c=a.type;b=a.stateNode;var d=a.updateQueue;null===d||null===d.capturedValues?D("264"):void 0;var f=d.capturedValues;d.capturedValues=null;"function"!==typeof c.getDerivedStateFromCatch&&e(b);b.props=a.memoizedProps;b.state=a.memoizedState;for(c=0;c<f.length;c++){d=f[c];var g=d.value,h=d.stack;bf(a,d);b.componentDidCatch(g,{componentStack:null!==h?h:""})}break;
case 3:c=a.updateQueue;null===c||null===c.capturedValues?D("264"):void 0;f=c.capturedValues;c.capturedValues=null;for(c=0;c<f.length;c++)d=f[c],bf(a,d),b(d.value);break;default:D("265")}},commitAttachRef:function(a){var b=a.ref;if(null!==b){var c=a.stateNode;switch(a.tag){case 5:a=l(c);break;default:a=c}"function"===typeof b?b(a):b.current=a}},commitDetachRef:function(a){a=a.ref;null!==a&&("function"===typeof a?a(null):a.current=null)}}}var df={};
function ef(a,b){function c(a){a===df?D("174"):void 0;return a}var d=a.getChildHostContext,e=a.getRootHostContext;a=b.createCursor;var f=b.push,h=b.pop,g=a(df),k=a(df),v=a(df);return{getHostContext:function(){return c(g.current)},getRootHostContainer:function(){return c(v.current)},popHostContainer:function(a){h(g,a);h(k,a);h(v,a)},popHostContext:function(a){k.current===a&&(h(g,a),h(k,a))},pushHostContainer:function(a,b){f(v,b,a);b=e(b);f(k,a,a);f(g,b,a)},pushHostContext:function(a){var b=c(v.current),
e=c(g.current);b=d(e,a.type,b);e!==b&&(f(k,a,a),f(g,b,a))}}}
function ff(a){function b(a,b){var c=new xe(5,null,null,0);c.type="DELETED";c.stateNode=b;c["return"]=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}function c(a,b){switch(a.tag){case 5:return b=f(b,a.type,a.pendingProps),null!==b?(a.stateNode=b,!0):!1;case 6:return b=h(b,a.pendingProps),null!==b?(a.stateNode=b,!0):!1;default:return!1}}function d(a){for(a=a["return"];null!==a&&5!==a.tag&&3!==a.tag;)a=a["return"];p=a}var e=a.shouldSetTextContent;
a=a.hydration;if(!a)return{enterHydrationState:function(){return!1},resetHydrationState:function(){},tryToClaimNextHydratableInstance:function(){},prepareToHydrateHostInstance:function(){D("175")},prepareToHydrateHostTextInstance:function(){D("176")},popHydrationState:function(){return!1}};var f=a.canHydrateInstance,h=a.canHydrateTextInstance,g=a.getNextHydratableSibling,k=a.getFirstHydratableChild,v=a.hydrateInstance,l=a.hydrateTextInstance,p=null,y=null,B=!1;return{enterHydrationState:function(a){y=
k(a.stateNode.containerInfo);p=a;return B=!0},resetHydrationState:function(){y=p=null;B=!1},tryToClaimNextHydratableInstance:function(a){if(B){var d=y;if(d){if(!c(a,d)){d=g(d);if(!d||!c(a,d)){a.effectTag|=2;B=!1;p=a;return}b(p,y)}p=a;y=k(d)}else a.effectTag|=2,B=!1,p=a}},prepareToHydrateHostInstance:function(a,b,c){b=v(a.stateNode,a.type,a.memoizedProps,b,c,a);a.updateQueue=b;return null!==b?!0:!1},prepareToHydrateHostTextInstance:function(a){return l(a.stateNode,a.memoizedProps,a)},popHydrationState:function(a){if(a!==
p)return!1;if(!B)return d(a),B=!0,!1;var c=a.type;if(5!==a.tag||"head"!==c&&"body"!==c&&!e(c,a.memoizedProps))for(c=y;c;)b(a,c),c=g(c);d(a);y=p?g(a.stateNode):null;return!0}}}
function gf(a){function b(a,b,c){a=a.stateNode;a.__reactInternalMemoizedUnmaskedChildContext=b;a.__reactInternalMemoizedMaskedChildContext=c}function c(a){return 2===a.tag&&null!=a.type.childContextTypes}function d(a,b){var c=a.stateNode,d=a.type.childContextTypes;if("function"!==typeof c.getChildContext)return b;c=c.getChildContext();for(var e in c)e in d?void 0:D("108",zc(a)||"Unknown",e);return A({},b,c)}var e=a.createCursor,f=a.push,h=a.pop,g=e(ja),k=e(!1),v=ja;return{getUnmaskedContext:function(a){return c(a)?
v:g.current},cacheContext:b,getMaskedContext:function(a,c){var d=a.type.contextTypes;if(!d)return ja;var e=a.stateNode;if(e&&e.__reactInternalMemoizedUnmaskedChildContext===c)return e.__reactInternalMemoizedMaskedChildContext;var f={},g;for(g in d)f[g]=c[g];e&&b(a,c,f);return f},hasContextChanged:function(){return k.current},isContextConsumer:function(a){return 2===a.tag&&null!=a.type.contextTypes},isContextProvider:c,popContextProvider:function(a){c(a)&&(h(k,a),h(g,a))},popTopLevelContextObject:function(a){h(k,
a);h(g,a)},pushTopLevelContextObject:function(a,b,c){null!=g.cursor?D("168"):void 0;f(g,b,a);f(k,c,a)},processChildContext:d,pushContextProvider:function(a){if(!c(a))return!1;var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||ja;v=g.current;f(g,b,a);f(k,k.current,a);return!0},invalidateContextProvider:function(a,b){var c=a.stateNode;c?void 0:D("169");if(b){var e=d(a,v);c.__reactInternalMemoizedMergedChildContext=e;h(k,a);h(g,a);f(g,e,a)}else h(k,a);f(k,b,a)},findCurrentUnmaskedContext:function(a){for(2!==
wd(a)||2!==a.tag?D("170"):void 0;3!==a.tag;){if(c(a))return a.stateNode.__reactInternalMemoizedMergedChildContext;(a=a["return"])?void 0:D("171")}return a.stateNode.context}}}
function hf(a){var b=a.createCursor,c=a.push,d=a.pop,e=b(null),f=b(null),h=b(0);return{pushProvider:function(a){var b=a.type.context;c(h,b._changedBits,a);c(f,b._currentValue,a);c(e,a,a);b._currentValue=a.pendingProps.value;b._changedBits=a.stateNode},popProvider:function(a){var b=h.current,c=f.current;d(e,a);d(f,a);d(h,a);a=a.type.context;a._currentValue=c;a._changedBits=b}}}
function jf(){var a=[],b=-1;return{createCursor:function(a){return{current:a}},isEmpty:function(){return-1===b},pop:function(c){0>b||(c.current=a[b],a[b]=null,b--)},push:function(c,d){b++;a[b]=c.current;c.current=d},checkThatStackIsEmpty:function(){},resetStackAfterFatalErrorInDev:function(){}}}
function kf(a){function b(){if(null!==I)for(var a=I["return"];null!==a;)Lc(a),a=a["return"];Xa=null;Z=0;I=null;Nc=!1}function c(a){return null!==ya&&ya.has(a)}function d(a){for(;;){var b=a.alternate,c=a["return"],d=a.sibling;if(0===(a.effectTag&512)){b=Bb(b,a,Z);var e=a;if(1073741823===Z||1073741823!==e.expirationTime){b:switch(e.tag){case 3:case 2:var f=e.updateQueue;f=null===f?0:f.expirationTime;break b;default:f=0}for(var g=e.child;null!==g;)0!==g.expirationTime&&(0===f||f>g.expirationTime)&&(f=
g.expirationTime),g=g.sibling;e.expirationTime=f}if(null!==b)return b;null!==c&&0===(c.effectTag&512)&&(null===c.firstEffect&&(c.firstEffect=a.firstEffect),null!==a.lastEffect&&(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a));if(null!==d)return d;if(null!==c)a=c;else{Nc=!0;break}}else{a=Kc(a);if(null!==a)return a.effectTag&=2559,a;null!==c&&(c.firstEffect=c.lastEffect=
null,c.effectTag|=512);if(null!==d)return d;if(null!==c)a=c;else break}}return null}function e(a){var b=Wa(a.alternate,a,Z);null===b&&(b=d(a));mc.current=null;return b}function f(a,c,f){ca?D("243"):void 0;ca=!0;if(c!==Z||a!==Xa||null===I)b(),Xa=a,Z=c,I=ye(Xa.current,null,Z),a.pendingCommitExpirationTime=0;var g=!1;do{try{if(f)for(;null!==I&&!S();)I=e(I);else for(;null!==I;)I=e(I)}catch(Oc){if(null===I){g=!0;q(Oc);break}f=I;var h=f["return"];if(null===h){g=!0;q(Oc);break}Jc(h,f,Oc);I=d(f)}break}while(1);
ca=!1;if(g||null!==I)return null;if(Nc)return a.pendingCommitExpirationTime=c,a.current.alternate;D("262")}function h(a,b,c,d){a={value:c,source:a,stack:Ac(a)};Oe(b,{expirationTime:d,partialState:null,callback:null,isReplace:!1,isForced:!1,capturedValue:a,next:null});v(b,d)}function g(a,b){a:{ca&&!Ya?D("263"):void 0;for(var d=a["return"];null!==d;){switch(d.tag){case 2:var e=d.stateNode;if("function"===typeof d.type.getDerivedStateFromCatch||"function"===typeof e.componentDidCatch&&!c(e)){h(a,d,b,
1);a=void 0;break a}break;case 3:h(a,d,b,1);a=void 0;break a}d=d["return"]}3===a.tag&&h(a,a,b,1);a=void 0}return a}function k(a){a=0!==ia?ia:ca?Ya?1:Z:a.mode&1?za?10*(((l()+50)/10|0)+1):25*(((l()+500)/25|0)+1):1;za&&(0===da||a>da)&&(da=a);return a}function v(a,c){a:{for(;null!==a;){if(0===a.expirationTime||a.expirationTime>c)a.expirationTime=c;null!==a.alternate&&(0===a.alternate.expirationTime||a.alternate.expirationTime>c)&&(a.alternate.expirationTime=c);if(null===a["return"])if(3===a.tag){var d=
a.stateNode;!ca&&0!==Z&&c<Z&&b();ca&&!Ya&&Xa===d||B(d,c);Fb>wg&&D("185")}else{c=void 0;break a}a=a["return"]}c=void 0}return c}function l(){ve=Ic()-Pc;return xg=(ve/10|0)+2}function p(a,b,c,d,e){var f=ia;ia=1;try{return a(b,c,d,e)}finally{ia=f}}function y(a){if(0!==Gb){if(a>Gb)return;yg(Qc)}var b=Ic()-Pc;Gb=a;Qc=lg(Q,{timeout:10*(a-2)-b})}function B(a,b){if(null===a.nextScheduledRoot)a.remainingExpirationTime=b,null===K?(la=K=a,a.nextScheduledRoot=a):(K=K.nextScheduledRoot=a,K.nextScheduledRoot=la);
else{var c=a.remainingExpirationTime;if(0===c||b<c)a.remainingExpirationTime=b}T||(J?Hb&&(aa=a,P=1,G(a,1,!1)):1===b?n():y(b))}function r(){var a=0,b=null;if(null!==K)for(var c=K,d=la;null!==d;){var e=d.remainingExpirationTime;if(0===e){null===c||null===K?D("244"):void 0;if(d===d.nextScheduledRoot){la=K=d.nextScheduledRoot=null;break}else if(d===la)la=e=d.nextScheduledRoot,K.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===K){K=c;K.nextScheduledRoot=la;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=
d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{if(0===a||e<a)a=e,b=d;if(d===K)break;c=d;d=d.nextScheduledRoot}}c=aa;null!==c&&c===b&&1===a?Fb++:Fb=0;aa=b;P=a}function Q(a){x(0,!0,a)}function n(){x(1,!1,null)}function x(a,b,c){Za=c;r();if(b)for(;null!==aa&&0!==P&&(0===a||a>=P)&&(!Ib||l()>=P);)G(aa,P,!Ib),r();else for(;null!==aa&&0!==P&&(0===a||a>=P);)G(aa,P,!1),r();null!==Za&&(Gb=0,Qc=-1);0!==P&&y(P);Za=null;Ib=!1;Y()}function Y(){Fb=0;if(null!==Aa){var a=Aa;Aa=null;for(var b=
0;b<a.length;b++){var c=a[b];try{c._onComplete()}catch(vg){Ba||(Ba=!0,Jb=vg)}}}if(Ba)throw a=Jb,Jb=null,Ba=!1,a;}function G(a,b,c){T?D("245"):void 0;T=!0;c?(c=a.finishedWork,null!==c?R(a,c,b):(a.finishedWork=null,c=f(a,b,!0),null!==c&&(S()?a.finishedWork=c:R(a,c,b)))):(c=a.finishedWork,null!==c?R(a,c,b):(a.finishedWork=null,c=f(a,b,!1),null!==c&&R(a,c,b)));T=!1}function R(a,b,c){var d=a.firstBatch;if(null!==d&&d._expirationTime<=c&&(null===Aa?Aa=[d]:Aa.push(d),d._defer)){a.finishedWork=b;a.remainingExpirationTime=
0;return}a.finishedWork=null;Ya=ca=!0;c=b.stateNode;c.current===b?D("177"):void 0;d=c.pendingCommitExpirationTime;0===d?D("261"):void 0;c.pendingCommitExpirationTime=0;var e=l();mc.current=null;if(1<b.effectTag)if(null!==b.lastEffect){b.lastEffect.nextEffect=b;var f=b.firstEffect}else f=b;else f=b.firstEffect;zg(c.containerInfo);for(w=f;null!==w;){var h=!1,k=void 0;try{for(;null!==w;)w.effectTag&2048&&Cb(w.alternate,w),w=w.nextEffect}catch($a){h=!0,k=$a}h&&(null===w?D("178"):void 0,g(w,k),null!==
w&&(w=w.nextEffect))}for(w=f;null!==w;){h=!1;k=void 0;try{for(;null!==w;){var p=w.effectTag;p&16&&Mc(w);if(p&128){var n=w.alternate;null!==n&&kg(n)}switch(p&14){case 2:Db(w);w.effectTag&=-3;break;case 6:Db(w);w.effectTag&=-3;te(w.alternate,w);break;case 4:te(w.alternate,w);break;case 8:gg(w)}w=w.nextEffect}}catch($a){h=!0,k=$a}h&&(null===w?D("178"):void 0,g(w,k),null!==w&&(w=w.nextEffect))}Ag(c.containerInfo);c.current=b;for(w=f;null!==w;){p=!1;n=void 0;try{for(f=c,h=e,k=d;null!==w;){var r=w.effectTag;
r&36&&hg(f,w.alternate,w,h,k);r&256&&ig(w,q);r&128&&jg(w);var t=w.nextEffect;w.nextEffect=null;w=t}}catch($a){p=!0,n=$a}p&&(null===w?D("178"):void 0,g(w,n),null!==w&&(w=w.nextEffect))}ca=Ya=!1;"function"===typeof He&&He(b.stateNode);b=c.current.expirationTime;0===b&&(ya=null);a.remainingExpirationTime=b}function S(){return null===Za||Za.timeRemaining()>Bg?!1:Ib=!0}function q(a){null===aa?D("246"):void 0;aa.remainingExpirationTime=0;Ba||(Ba=!0,Jb=a)}var t=jf(),u=ef(a,t),z=gf(t);t=hf(t);var H=ff(a),
Wa=Ze(a,u,z,t,H,v,k).beginWork,Bb=$e(a,u,z,t,H).completeWork;u=af(u,z,t,v,c);var Jc=u.throwException,Kc=u.unwindWork,Lc=u.unwindInterruptedWork;u=cf(a,g,v,k,function(a){null===ya?ya=new Set([a]):ya.add(a)},l);var Cb=u.commitBeforeMutationLifeCycles,Mc=u.commitResetTextContent,Db=u.commitPlacement,gg=u.commitDeletion,te=u.commitWork,hg=u.commitLifeCycles,ig=u.commitErrorLogging,jg=u.commitAttachRef,kg=u.commitDetachRef,Ic=a.now,lg=a.scheduleDeferredCallback,yg=a.cancelDeferredCallback,zg=a.prepareForCommit,
Ag=a.resetAfterCommit,Pc=Ic(),xg=2,ve=Pc,Rc=0,ia=0,ca=!1,I=null,Xa=null,Z=0,w=null,Ya=!1,Nc=!1,ya=null,la=null,K=null,Gb=0,Qc=-1,T=!1,aa=null,P=0,da=0,Ib=!1,Ba=!1,Jb=null,Za=null,J=!1,Hb=!1,za=!1,Aa=null,wg=1E3,Fb=0,Bg=1;return{recalculateCurrentTime:l,computeExpirationForFiber:k,scheduleWork:v,requestWork:B,flushRoot:function(a,b){T?D("253"):void 0;aa=a;P=b;G(a,b,!1);n();Y()},batchedUpdates:function(a,b){var c=J;J=!0;try{return a(b)}finally{(J=c)||T||n()}},unbatchedUpdates:function(a,b){if(J&&!Hb){Hb=
!0;try{return a(b)}finally{Hb=!1}}return a(b)},flushSync:function(a,b){T?D("187"):void 0;var c=J;J=!0;try{return p(a,b)}finally{J=c,n()}},flushControlled:function(a){var b=J;J=!0;try{p(a)}finally{(J=b)||T||x(1,!1,null)}},deferredUpdates:function(a){var b=ia;ia=25*(((l()+500)/25|0)+1);try{return a()}finally{ia=b}},syncUpdates:p,interactiveUpdates:function(a,b,c){if(za)return a(b,c);J||T||0===da||(x(da,!1,null),da=0);var d=za,e=J;J=za=!0;try{return a(b,c)}finally{za=d,(J=e)||T||n()}},flushInteractiveUpdates:function(){T||
0===da||(x(da,!1,null),da=0)},computeUniqueAsyncExpiration:function(){var a=25*(((l()+500)/25|0)+1);a<=Rc&&(a=Rc+1);return Rc=a},legacyContext:z}}
function lf(a){function b(a,b,c,d,e,f){d=b.current;if(c){c=c._reactInternalFiber;var g=k(c);c=v(c)?l(c,g):g}else c=ja;null===b.context?b.context=c:b.pendingContext=c;b=f;Oe(d,{expirationTime:e,partialState:{element:a},callback:void 0===b?null:b,isReplace:!1,isForced:!1,capturedValue:null,next:null});h(d,e);return e}function c(a){a=Ad(a);return null===a?null:a.stateNode}var d=a.getPublicInstance;a=kf(a);var e=a.recalculateCurrentTime,f=a.computeExpirationForFiber,h=a.scheduleWork,g=a.legacyContext,
k=g.findCurrentUnmaskedContext,v=g.isContextProvider,l=g.processChildContext;return{createContainer:function(a,b,c){b=new xe(3,null,null,b?3:0);a={current:b,containerInfo:a,pendingChildren:null,pendingCommitExpirationTime:0,finishedWork:null,context:null,pendingContext:null,hydrate:c,remainingExpirationTime:0,firstBatch:null,nextScheduledRoot:null};return b.stateNode=a},updateContainer:function(a,c,d,g){var h=c.current,k=e();h=f(h);return b(a,c,d,k,h,g)},updateContainerAtExpirationTime:function(a,
c,d,f,g){var h=e();return b(a,c,d,h,f,g)},flushRoot:a.flushRoot,requestWork:a.requestWork,computeUniqueAsyncExpiration:a.computeUniqueAsyncExpiration,batchedUpdates:a.batchedUpdates,unbatchedUpdates:a.unbatchedUpdates,deferredUpdates:a.deferredUpdates,syncUpdates:a.syncUpdates,interactiveUpdates:a.interactiveUpdates,flushInteractiveUpdates:a.flushInteractiveUpdates,flushControlled:a.flushControlled,flushSync:a.flushSync,getPublicRootInstance:function(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return d(a.child.stateNode);
default:return a.child.stateNode}},findHostInstance:c,findHostInstanceWithNoPortals:function(a){a=Bd(a);return null===a?null:a.stateNode},injectIntoDevTools:function(a){var b=a.findFiberByHostInstance;return Ge(A({},a,{findHostInstanceByFiber:function(a){return c(a)},findFiberByHostInstance:function(a){return b?b(a):null}}))}}}var mf=Object.freeze({default:lf}),nf=mf&&lf||mf,of=nf["default"]?nf["default"]:nf;
function pf(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:qc,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}var qf="object"===typeof performance&&"function"===typeof performance.now,rf=void 0;rf=qf?function(){return performance.now()}:function(){return Date.now()};var sf=void 0,tf=void 0;
if(m.canUseDOM)if("function"!==typeof requestIdleCallback||"function"!==typeof cancelIdleCallback){var uf=null,vf=!1,wf=-1,xf=!1,yf=0,zf=33,Af=33,Bf=void 0;Bf=qf?{didTimeout:!1,timeRemaining:function(){var a=yf-performance.now();return 0<a?a:0}}:{didTimeout:!1,timeRemaining:function(){var a=yf-Date.now();return 0<a?a:0}};var Cf="__reactIdleCallback$"+Math.random().toString(36).slice(2);window.addEventListener("message",function(a){if(a.source===window&&a.data===Cf){vf=!1;a=rf();if(0>=yf-a)if(-1!==
wf&&wf<=a)Bf.didTimeout=!0;else{xf||(xf=!0,requestAnimationFrame(Df));return}else Bf.didTimeout=!1;wf=-1;a=uf;uf=null;null!==a&&a(Bf)}},!1);var Df=function(a){xf=!1;var b=a-yf+Af;b<Af&&zf<Af?(8>b&&(b=8),Af=b<zf?zf:b):zf=b;yf=a+Af;vf||(vf=!0,window.postMessage(Cf,"*"))};sf=function(a,b){uf=a;null!=b&&"number"===typeof b.timeout&&(wf=rf()+b.timeout);xf||(xf=!0,requestAnimationFrame(Df));return 0};tf=function(){uf=null;vf=!1;wf=-1}}else sf=window.requestIdleCallback,tf=window.cancelIdleCallback;else sf=
function(a){return setTimeout(function(){a({timeRemaining:function(){return Infinity},didTimeout:!1})})},tf=function(a){clearTimeout(a)};function Ef(a){var b="";ba.Children.forEach(a,function(a){null==a||"string"!==typeof a&&"number"!==typeof a||(b+=a)});return b}function Ff(a,b){a=A({children:void 0},b);if(b=Ef(b.children))a.children=b;return a}
function Gf(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+c;b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Hf(a,b){var c=b.value;a._wrapperState={initialValue:null!=c?c:b.defaultValue,wasMultiple:!!b.multiple}}function If(a,b){null!=b.dangerouslySetInnerHTML?D("91"):void 0;return A({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Jf(a,b){var c=b.value;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?D("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:D("93"),b=b[0]),c=""+b),null==c&&(c=""));a._wrapperState={initialValue:""+c}}
function Kf(a,b){var c=b.value;null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&(a.defaultValue=c));null!=b.defaultValue&&(a.defaultValue=b.defaultValue)}function Lf(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var Mf={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Nf(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Of(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Nf(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Pf=void 0,Qf=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Mf.svg||"innerHTML"in a)a.innerHTML=b;else{Pf=Pf||document.createElement("div");Pf.innerHTML="\x3csvg\x3e"+b+"\x3c/svg\x3e";for(b=Pf.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Rf(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
var Sf={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,
stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},Tf=["Webkit","ms","Moz","O"];Object.keys(Sf).forEach(function(a){Tf.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);Sf[b]=Sf[a]})});
function Uf(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--");var e=c;var f=b[c];e=null==f||"boolean"===typeof f||""===f?"":d||"number"!==typeof f||0===f||Sf.hasOwnProperty(e)&&Sf[e]?(""+f).trim():f+"px";"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var Vf=A({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function Wf(a,b,c){b&&(Vf[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?D("137",a,c()):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?D("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:D("61")),null!=b.style&&"object"!==typeof b.style?D("62",c()):void 0)}
function Xf(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var Yf=Mf.html,Zf=C.thatReturns("");
function $f(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=je(a);b=ua[b];for(var d=0;d<b.length;d++){var e=b[d];c.hasOwnProperty(e)&&c[e]||("topScroll"===e?Yd("topScroll","scroll",a):"topFocus"===e||"topBlur"===e?(Yd("topFocus","focus",a),Yd("topBlur","blur",a),c.topBlur=!0,c.topFocus=!0):"topCancel"===e?(hc("cancel",!0)&&Yd("topCancel","cancel",a),c.topCancel=!0):"topClose"===e?(hc("close",!0)&&Yd("topClose","close",a),c.topClose=!0):ee.hasOwnProperty(e)&&W(e,ee[e],a),c[e]=!0)}}
function ag(a,b,c,d){c=9===c.nodeType?c:c.ownerDocument;d===Yf&&(d=Nf(a));d===Yf?"script"===a?(a=c.createElement("div"),a.innerHTML="\x3cscript\x3e\x3c/script\x3e",a=a.removeChild(a.firstChild)):a="string"===typeof b.is?c.createElement(a,{is:b.is}):c.createElement(a):a=c.createElementNS(d,a);return a}function bg(a,b){return(9===b.nodeType?b:b.ownerDocument).createTextNode(a)}
function cg(a,b,c,d){var e=Xf(b,c);switch(b){case "iframe":case "object":W("topLoad","load",a);var f=c;break;case "video":case "audio":for(f in fe)fe.hasOwnProperty(f)&&W(f,fe[f],a);f=c;break;case "source":W("topError","error",a);f=c;break;case "img":case "image":case "link":W("topError","error",a);W("topLoad","load",a);f=c;break;case "form":W("topReset","reset",a);W("topSubmit","submit",a);f=c;break;case "details":W("topToggle","toggle",a);f=c;break;case "input":Vc(a,c);f=Uc(a,c);W("topInvalid",
"invalid",a);$f(d,"onChange");break;case "option":f=Ff(a,c);break;case "select":Hf(a,c);f=A({},c,{value:void 0});W("topInvalid","invalid",a);$f(d,"onChange");break;case "textarea":Jf(a,c);f=If(a,c);W("topInvalid","invalid",a);$f(d,"onChange");break;default:f=c}Wf(b,f,Zf);var h=f,g;for(g in h)if(h.hasOwnProperty(g)){var k=h[g];"style"===g?Uf(a,k,Zf):"dangerouslySetInnerHTML"===g?(k=k?k.__html:void 0,null!=k&&Qf(a,k)):"children"===g?"string"===typeof k?("textarea"!==b||""!==k)&&Rf(a,k):"number"===typeof k&&
Rf(a,""+k):"suppressContentEditableWarning"!==g&&"suppressHydrationWarning"!==g&&"autoFocus"!==g&&(ta.hasOwnProperty(g)?null!=k&&$f(d,g):null!=k&&Tc(a,g,k,e))}switch(b){case "input":kc(a);$c(a,c);break;case "textarea":kc(a);Lf(a,c);break;case "option":null!=c.value&&a.setAttribute("value",c.value);break;case "select":a.multiple=!!c.multiple;b=c.value;null!=b?Gf(a,!!c.multiple,b,!1):null!=c.defaultValue&&Gf(a,!!c.multiple,c.defaultValue,!0);break;default:"function"===typeof f.onClick&&(a.onclick=C)}}
function dg(a,b,c,d,e){var f=null;switch(b){case "input":c=Uc(a,c);d=Uc(a,d);f=[];break;case "option":c=Ff(a,c);d=Ff(a,d);f=[];break;case "select":c=A({},c,{value:void 0});d=A({},d,{value:void 0});f=[];break;case "textarea":c=If(a,c);d=If(a,d);f=[];break;default:"function"!==typeof c.onClick&&"function"===typeof d.onClick&&(a.onclick=C)}Wf(b,d,Zf);b=a=void 0;var h=null;for(a in c)if(!d.hasOwnProperty(a)&&c.hasOwnProperty(a)&&null!=c[a])if("style"===a){var g=c[a];for(b in g)g.hasOwnProperty(b)&&(h||
(h={}),h[b]="")}else"dangerouslySetInnerHTML"!==a&&"children"!==a&&"suppressContentEditableWarning"!==a&&"suppressHydrationWarning"!==a&&"autoFocus"!==a&&(ta.hasOwnProperty(a)?f||(f=[]):(f=f||[]).push(a,null));for(a in d){var k=d[a];g=null!=c?c[a]:void 0;if(d.hasOwnProperty(a)&&k!==g&&(null!=k||null!=g))if("style"===a)if(g){for(b in g)!g.hasOwnProperty(b)||k&&k.hasOwnProperty(b)||(h||(h={}),h[b]="");for(b in k)k.hasOwnProperty(b)&&g[b]!==k[b]&&(h||(h={}),h[b]=k[b])}else h||(f||(f=[]),f.push(a,h)),
h=k;else"dangerouslySetInnerHTML"===a?(k=k?k.__html:void 0,g=g?g.__html:void 0,null!=k&&g!==k&&(f=f||[]).push(a,""+k)):"children"===a?g===k||"string"!==typeof k&&"number"!==typeof k||(f=f||[]).push(a,""+k):"suppressContentEditableWarning"!==a&&"suppressHydrationWarning"!==a&&(ta.hasOwnProperty(a)?(null!=k&&$f(e,a),f||g===k||(f=[])):(f=f||[]).push(a,k))}h&&(f=f||[]).push("style",h);return f}
function eg(a,b,c,d,e){"input"===c&&"radio"===e.type&&null!=e.name&&Xc(a,e);Xf(c,d);d=Xf(c,e);for(var f=0;f<b.length;f+=2){var h=b[f],g=b[f+1];"style"===h?Uf(a,g,Zf):"dangerouslySetInnerHTML"===h?Qf(a,g):"children"===h?Rf(a,g):Tc(a,h,g,d)}switch(c){case "input":Yc(a,e);break;case "textarea":Kf(a,e);break;case "select":a._wrapperState.initialValue=void 0,b=a._wrapperState.wasMultiple,a._wrapperState.wasMultiple=!!e.multiple,c=e.value,null!=c?Gf(a,!!e.multiple,c,!1):b!==!!e.multiple&&(null!=e.defaultValue?
Gf(a,!!e.multiple,e.defaultValue,!0):Gf(a,!!e.multiple,e.multiple?[]:"",!1))}}
function fg(a,b,c,d,e){switch(b){case "iframe":case "object":W("topLoad","load",a);break;case "video":case "audio":for(var f in fe)fe.hasOwnProperty(f)&&W(f,fe[f],a);break;case "source":W("topError","error",a);break;case "img":case "image":case "link":W("topError","error",a);W("topLoad","load",a);break;case "form":W("topReset","reset",a);W("topSubmit","submit",a);break;case "details":W("topToggle","toggle",a);break;case "input":Vc(a,c);W("topInvalid","invalid",a);$f(e,"onChange");break;case "select":Hf(a,
c);W("topInvalid","invalid",a);$f(e,"onChange");break;case "textarea":Jf(a,c),W("topInvalid","invalid",a),$f(e,"onChange")}Wf(b,c,Zf);d=null;for(var h in c)c.hasOwnProperty(h)&&(f=c[h],"children"===h?"string"===typeof f?a.textContent!==f&&(d=["children",f]):"number"===typeof f&&a.textContent!==""+f&&(d=["children",""+f]):ta.hasOwnProperty(h)&&null!=f&&$f(e,h));switch(b){case "input":kc(a);$c(a,c);break;case "textarea":kc(a);Lf(a,c);break;case "select":case "option":break;default:"function"===typeof c.onClick&&
(a.onclick=C)}return d}function mg(a,b){return a.nodeValue!==b}
var ng=Object.freeze({createElement:ag,createTextNode:bg,setInitialProperties:cg,diffProperties:dg,updateProperties:eg,diffHydratedProperties:fg,diffHydratedText:mg,warnForUnmatchedText:function(){},warnForDeletedHydratableElement:function(){},warnForDeletedHydratableText:function(){},warnForInsertedHydratedElement:function(){},warnForInsertedHydratedText:function(){},restoreControlledState:function(a,b,c){switch(b){case "input":Yc(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=
c.parentNode;c=c.querySelectorAll("input[name\x3d"+JSON.stringify(""+b)+'][type\x3d"radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Va(d);e?void 0:D("90");lc(d);Yc(d,e)}}}break;case "textarea":Kf(a,c);break;case "select":b=c.value,null!=b&&Gf(a,!!c.multiple,b,!1)}}});Vb.injectFiberControlledHostComponent(ng);var og=null,pg=null;
function qg(a){this._expirationTime=X.computeUniqueAsyncExpiration();this._root=a;this._callbacks=this._next=null;this._hasChildren=this._didComplete=!1;this._children=null;this._defer=!0}qg.prototype.render=function(a){this._defer?void 0:D("250");this._hasChildren=!0;this._children=a;var b=this._root._internalRoot,c=this._expirationTime,d=new rg;X.updateContainerAtExpirationTime(a,b,null,c,d._onCommit);return d};
qg.prototype.then=function(a){if(this._didComplete)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
qg.prototype.commit=function(){var a=this._root._internalRoot,b=a.firstBatch;this._defer&&null!==b?void 0:D("251");if(this._hasChildren){var c=this._expirationTime;if(b!==this){this._hasChildren&&(c=this._expirationTime=b._expirationTime,this.render(this._children));for(var d=null,e=b;e!==this;)d=e,e=e._next;null===d?D("251"):void 0;d._next=e._next;this._next=b;a.firstBatch=this}this._defer=!1;X.flushRoot(a,c);b=this._next;this._next=null;b=a.firstBatch=b;null!==b&&b._hasChildren&&b.render(b._children)}else this._next=
null,this._defer=!1};qg.prototype._onComplete=function(){if(!this._didComplete){this._didComplete=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++)(0,a[b])()}};function rg(){this._callbacks=null;this._didCommit=!1;this._onCommit=this._onCommit.bind(this)}rg.prototype.then=function(a){if(this._didCommit)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
rg.prototype._onCommit=function(){if(!this._didCommit){this._didCommit=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++){var c=a[b];"function"!==typeof c?D("191",c):void 0;c()}}};function sg(a,b,c){this._internalRoot=X.createContainer(a,b,c)}sg.prototype.render=function(a,b){var c=this._internalRoot,d=new rg;b=void 0===b?null:b;null!==b&&d.then(b);X.updateContainer(a,c,null,d._onCommit);return d};
sg.prototype.unmount=function(a){var b=this._internalRoot,c=new rg;a=void 0===a?null:a;null!==a&&c.then(a);X.updateContainer(null,b,null,c._onCommit);return c};sg.prototype.legacy_renderSubtreeIntoContainer=function(a,b,c){var d=this._internalRoot,e=new rg;c=void 0===c?null:c;null!==c&&e.then(c);X.updateContainer(b,d,a,e._onCommit);return e};
sg.prototype.createBatch=function(){var a=new qg(this),b=a._expirationTime,c=this._internalRoot,d=c.firstBatch;if(null===d)c.firstBatch=a,a._next=null;else{for(c=null;null!==d&&d._expirationTime<=b;)c=d,d=d._next;a._next=d;null!==c&&(c._next=a)}return a};function tg(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}
function ug(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
var X=of({getRootHostContext:function(a){var b=a.nodeType;switch(b){case 9:case 11:a=(a=a.documentElement)?a.namespaceURI:Of(null,"");break;default:b=8===b?a.parentNode:a,a=b.namespaceURI||null,b=b.tagName,a=Of(a,b)}return a},getChildHostContext:function(a,b){return Of(a,b)},getPublicInstance:function(a){return a},prepareForCommit:function(){og=Ud;var a=ea();if(me(a)){if("selectionStart"in a)var b={start:a.selectionStart,end:a.selectionEnd};else a:{var c=window.getSelection&&window.getSelection();
if(c&&0!==c.rangeCount){b=c.anchorNode;var d=c.anchorOffset,e=c.focusNode;c=c.focusOffset;try{b.nodeType,e.nodeType}catch(B){b=null;break a}var f=0,h=-1,g=-1,k=0,v=0,l=a,p=null;b:for(;;){for(var y;;){l!==b||0!==d&&3!==l.nodeType||(h=f+d);l!==e||0!==c&&3!==l.nodeType||(g=f+c);3===l.nodeType&&(f+=l.nodeValue.length);if(null===(y=l.firstChild))break;p=l;l=y}for(;;){if(l===a)break b;p===b&&++k===d&&(h=f);p===e&&++v===c&&(g=f);if(null!==(y=l.nextSibling))break;l=p;p=l.parentNode}l=y}b=-1===h||-1===g?null:
{start:h,end:g}}else b=null}b=b||{start:0,end:0}}else b=null;pg={focusedElem:a,selectionRange:b};Vd(!1)},resetAfterCommit:function(){var a=pg,b=ea(),c=a.focusedElem,d=a.selectionRange;if(b!==c&&ha(document.documentElement,c)){if(me(c))if(b=d.start,a=d.end,void 0===a&&(a=b),"selectionStart"in c)c.selectionStart=b,c.selectionEnd=Math.min(a,c.value.length);else if(window.getSelection){b=window.getSelection();var e=c[lb()].length;a=Math.min(d.start,e);d=void 0===d.end?a:Math.min(d.end,e);!b.extend&&a>
d&&(e=d,d=a,a=e);e=le(c,a);var f=le(c,d);if(e&&f&&(1!==b.rangeCount||b.anchorNode!==e.node||b.anchorOffset!==e.offset||b.focusNode!==f.node||b.focusOffset!==f.offset)){var h=document.createRange();h.setStart(e.node,e.offset);b.removeAllRanges();a>d?(b.addRange(h),b.extend(f.node,f.offset)):(h.setEnd(f.node,f.offset),b.addRange(h))}}b=[];for(a=c;a=a.parentNode;)1===a.nodeType&&b.push({element:a,left:a.scrollLeft,top:a.scrollTop});c.focus();for(c=0;c<b.length;c++)a=b[c],a.element.scrollLeft=a.left,
a.element.scrollTop=a.top}pg=null;Vd(og);og=null},createInstance:function(a,b,c,d,e){a=ag(a,b,c,d);a[F]=e;a[Sa]=b;return a},appendInitialChild:function(a,b){a.appendChild(b)},finalizeInitialChildren:function(a,b,c,d){cg(a,b,c,d);return ug(b,c)},prepareUpdate:function(a,b,c,d,e){return dg(a,b,c,d,e)},shouldSetTextContent:function(a,b){return"textarea"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&"string"===
typeof b.dangerouslySetInnerHTML.__html},shouldDeprioritizeSubtree:function(a,b){return!!b.hidden},createTextInstance:function(a,b,c,d){a=bg(a,b);a[F]=d;return a},now:rf,mutation:{commitMount:function(a,b,c){ug(b,c)&&a.focus()},commitUpdate:function(a,b,c,d,e){a[Sa]=e;eg(a,b,c,d,e)},resetTextContent:function(a){Rf(a,"")},commitTextUpdate:function(a,b,c){a.nodeValue=c},appendChild:function(a,b){a.appendChild(b)},appendChildToContainer:function(a,b){8===a.nodeType?a.parentNode.insertBefore(b,a):a.appendChild(b)},
insertBefore:function(a,b,c){a.insertBefore(b,c)},insertInContainerBefore:function(a,b,c){8===a.nodeType?a.parentNode.insertBefore(b,c):a.insertBefore(b,c)},removeChild:function(a,b){a.removeChild(b)},removeChildFromContainer:function(a,b){8===a.nodeType?a.parentNode.removeChild(b):a.removeChild(b)}},hydration:{canHydrateInstance:function(a,b){return 1!==a.nodeType||b.toLowerCase()!==a.nodeName.toLowerCase()?null:a},canHydrateTextInstance:function(a,b){return""===b||3!==a.nodeType?null:a},getNextHydratableSibling:function(a){for(a=
a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a},getFirstHydratableChild:function(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a},hydrateInstance:function(a,b,c,d,e,f){a[F]=f;a[Sa]=c;return fg(a,b,c,e,d)},hydrateTextInstance:function(a,b,c){a[F]=c;return mg(a,b)},didNotMatchHydratedContainerTextInstance:function(){},didNotMatchHydratedTextInstance:function(){},didNotHydrateContainerInstance:function(){},didNotHydrateInstance:function(){},
didNotFindHydratableContainerInstance:function(){},didNotFindHydratableContainerTextInstance:function(){},didNotFindHydratableInstance:function(){},didNotFindHydratableTextInstance:function(){}},scheduleDeferredCallback:sf,cancelDeferredCallback:tf}),Cg=X;$b=Cg.batchedUpdates;ac=Cg.interactiveUpdates;bc=Cg.flushInteractiveUpdates;
function Dg(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new sg(a,!1,b)}
function Eg(a,b,c,d,e){tg(c)?void 0:D("200");var f=c._reactRootContainer;if(f){if("function"===typeof e){var h=e;e=function(){var a=X.getPublicRootInstance(f._internalRoot);h.call(a)}}null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)}else{f=c._reactRootContainer=Dg(c,d);if("function"===typeof e){var g=e;e=function(){var a=X.getPublicRootInstance(f._internalRoot);g.call(a)}}X.unbatchedUpdates(function(){null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)})}return X.getPublicRootInstance(f._internalRoot)}
function Fg(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;tg(b)?void 0:D("200");return pf(a,b,null,c)}
var Gg={createPortal:Fg,findDOMNode:function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(b)return X.findHostInstance(b);"function"===typeof a.render?D("188"):D("213",Object.keys(a))},hydrate:function(a,b,c){return Eg(null,a,b,!0,c)},render:function(a,b,c){return Eg(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){null==a||void 0===a._reactInternalFiber?D("38"):void 0;return Eg(a,b,c,!1,d)},unmountComponentAtNode:function(a){tg(a)?void 0:
D("40");return a._reactRootContainer?(X.unbatchedUpdates(function(){Eg(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:function(){return Fg.apply(void 0,arguments)},unstable_batchedUpdates:X.batchedUpdates,unstable_deferredUpdates:X.deferredUpdates,flushSync:X.flushSync,unstable_flushControlled:X.flushControlled,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{EventPluginHub:Qa,EventPluginRegistry:xa,EventPropagators:jb,ReactControlledComponent:Zb,ReactDOMComponentTree:ab,
ReactDOMEventListener:Zd},unstable_createRoot:function(a,b){return new sg(a,!0,null!=b&&!0===b.hydrate)}};X.injectIntoDevTools({findFiberByHostInstance:Ta,bundleType:0,version:"16.3.0",rendererPackageName:"react-dom"});var Hg=Object.freeze({default:Gg}),Ig=Hg&&Gg||Hg;module.exports=Ig["default"]?Ig["default"]:Ig;


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var isTextNode = __webpack_require__(113);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var isNode = __webpack_require__(114);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 115 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_header_header__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_banner_banner__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_banner_nav_banner_nav__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_social_social__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_contact_contact__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_calculator_calculator__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_footer_footer__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__data_scenarios_json__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__data_scenarios_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__data_scenarios_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__data_currencies_json__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__data_currencies_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__data_currencies_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lazysizes_plugins_respimg_ls_respimg_min_js__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lazysizes_plugins_respimg_ls_respimg_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lazysizes_plugins_respimg_ls_respimg_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lazysizes_plugins_bgset_ls_bgset_min_js__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lazysizes_plugins_bgset_ls_bgset_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lazysizes_plugins_bgset_ls_bgset_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lazysizes_plugins_unveilhooks_ls_unveilhooks_min_js__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lazysizes_plugins_unveilhooks_ls_unveilhooks_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lazysizes_plugins_unveilhooks_ls_unveilhooks_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lazysizes__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lazysizes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lazysizes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_router_dom__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// Components
//import Footer from './components/calculator/totals/sticky_footer'
// Lazy load images
// React Router
var App=function(_Component){_inherits(App,_Component);function App(props){_classCallCheck(this,App);var _this=_possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).call(this,props));_this._onLayout=function(event){_this.setState({isLoading:false});_this.isLoading=false;};_this.state={key:1,isLoading:true,showOverlay:false,currentScenario:__WEBPACK_IMPORTED_MODULE_8__data_scenarios_json___default.a[0],currentCurrency:__WEBPACK_IMPORTED_MODULE_9__data_currencies_json___default.a[0],combinedCosts:0};return _this;}_createClass(App,[{key:'showOverlay',value:function showOverlay(shouldShow){if(shouldShow){this.setState({showOverlay:true});}else{this.setState({showOverlay:false});}}},{key:'triggerScenarioChange',value:function triggerScenarioChange(scenario){this.setState({scenarioChange:scenario,currentScenario:scenario});}},{key:'triggerCurrencyChange',value:function triggerCurrencyChange(currency){this.setState({currentCurrency:currency});}},{key:'triggerDevicePriceChange',value:function triggerDevicePriceChange(device){this.setState({devicePriceChange:device});}},{key:'handleDevicePricingChange',value:function handleDevicePricingChange(devicePricing){this.setState({currentDevicePricing:devicePricing});}},{key:'handleCombinedCostsChange',value:function handleCombinedCostsChange(value){this.setState({combinedCosts:value});}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_router_dom__["a" /* BrowserRouter */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'App'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_header_header__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_banner_banner__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_banner_nav_banner_nav__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_calculator_calculator__["a" /* default */],{triggerCurrencyChange:function triggerCurrencyChange(currency){return _this2.triggerCurrencyChange(currency);},currentScenario:this.state.currentScenario,updatePricing:function updatePricing(devicePricing){return _this2.handleDevicePricingChange(devicePricing);},setCurrentScenario:function setCurrentScenario(scenario){return _this2.setState({currentScenario:scenario});},clearTrigger:function clearTrigger(){return _this2.setState({scenarioChange:null,devicePriceChange:null});},triggerScenarioChange:this.state.scenarioChange,triggerDevicePriceChange:this.state.devicePriceChange,triggerCombinedCostsUpdate:function triggerCombinedCostsUpdate(value){return _this2.handleCombinedCostsChange(value);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_contact_contact__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_social_social__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_footer_footer__["a" /* default */],null)));}}]);return App;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (App);

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__header_css__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__header_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__header_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_logo_png__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_images_logo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_logo_2x_png__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_logo_2x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_images_logo_2x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_logo_gtx_png__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_logo_gtx_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_images_logo_gtx_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_images_logo_gtx_2x_png__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_images_logo_gtx_2x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_images_logo_gtx_2x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__i18n__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_dom__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import search_icon from '../../assets/icons/icon_search.svg';
var Header=function(_Component){_inherits(Header,_Component);function Header(props){_classCallCheck(this,Header);var _this=_possibleConstructorReturn(this,(Header.__proto__||Object.getPrototypeOf(Header)).call(this,props));_this.returnLanguageArray=function(){var languages=__WEBPACK_IMPORTED_MODULE_6__i18n__["a" /* default */].availableLanguages();return languages.map(function(value){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'lang-'+value.id,style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["b" /* Link */],{to:value.code.toLowerCase(),onClick:function onClick(){return _this.toggleDropdown();},style:{color:'#0D2EA0',width:'100%',display:'block',margin:'.75em 0',textDecoration:'none'}},value.displayString));});};_this.toggleDropdown=function(){_this.setState({showDropdown:_this.state.showDropdown?false:true});};_this.state={showDropdown:false};return _this;}_createClass(Header,[{key:'render',value:function render(){var _this2=this;var activeOpacity=this.state.showDropdown?1:0;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1__header_css___default.a.header},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1__header_css___default.a.header__inner,style:{position:'relative'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:__WEBPACK_IMPORTED_MODULE_1__header_css___default.a.logo,href:'/'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_2__assets_images_logo_png___default.a,srcSet:__WEBPACK_IMPORTED_MODULE_2__assets_images_logo_png___default.a+" 1x, "+__WEBPACK_IMPORTED_MODULE_3__assets_images_logo_2x_png___default.a+" 2x",alt:''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:__WEBPACK_IMPORTED_MODULE_1__header_css___default.a.header__center,src:__WEBPACK_IMPORTED_MODULE_4__assets_images_logo_gtx_png___default.a,srcSet:__WEBPACK_IMPORTED_MODULE_4__assets_images_logo_gtx_png___default.a+" 1x , "+__WEBPACK_IMPORTED_MODULE_5__assets_images_logo_gtx_2x_png___default.a+" 2x",alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this2.toggleDropdown();},style:{marginLeft:'-3em',backgroundColor:'transparent',border:0,cursor:'pointer',marginRight:'1.5em'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontSize:16,color:'white',marginRight:'.5em',textTransform:'uppercase'}},__WEBPACK_IMPORTED_MODULE_6__i18n__["a" /* default */].getLanguageFromUrl(this.props.location.pathname)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{width:'12px',height:'7px',viewBox:'0 0 12 7',version:'1.1',xmlns:'http://www.w3.org/2000/svg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Desktop',stroke:'none',strokeWidth:'1',fill:'none',fillRule:'evenodd'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'BRO18I01_Printer_Tool_01_XS',transform:'translate(-1337.000000, -31.000000)',fill:'#FFFFFF'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Nav'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'Rectangle-14',transform:'translate(1342.662111, 31.662111) rotate(45.000000) translate(-1342.662111, -31.662111) ',points:'1346.66211 27.6546767 1346.66211 35.669546 1338.66211 35.669546'})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{style:{position:'absolute',right:0,top:'2.1em',zIndex:5,backgroundColor:'white',listStyle:'none',padding:'1em 3em 1em 2em',transition:'all .2s',opacity:activeOpacity}},this.returnLanguageArray())));}}]);return Header;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["c" /* withRouter */])(Header));

/***/ }),
/* 118 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"header":"_2m9dqKWO5gZmmOzue7sI9G","header__inner":"e0PU_kC8YT8SNegSDf0Hz","header__center":"_3kpQWKgZiCB2leZxndUeYN","logo":"_2DPVOJAVVHrwW7PtN635k","header__search":"_3ukNykVqdCHLCOTiEOERt"};

/***/ }),
/* 119 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 120 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 121 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAAAcCAYAAACXkxr4AAADp0lEQVR4AezYA2wlXRiH8S+fbdu21rbt3XBt27Zt27Zt27ZV92lymkxuZs68M3O3O7fbf/KLz7l4its+la1mbpGYmJhX8AdKYgCmY2oQTMMwvI5XcAx+2yj1PjjCuW9xEZLdxK92Fz6LTBiIgwjDo9h1vIeXfRokCm0dxvgV+yHZJWSIO6e7MC/WIiF2yc9BDGsjjJESpyDZOaSOP2t22bsYhYAlBVGrbxMjOy5DspP403g+8LJPsQnWSwoSjXoWMYriNiQ7gN8C7zBe9jY24HHsiiHIGYTC6gXESIZbkGwvvlVnLYP0hdOF4Q6u4wbuunQC7+EFjMdKoRVYYmExlmGlA8txGNLVVO/dq9gJyTbiC2MEo/gYf+Mh7HYHs1AbWfEHvsZ7+AjfufQ1nnHxsfJpfIsfTfyEN13c+SFWQbJwlFfnMuMBdFuPj9VjaYMMgt1WG38B+YH6AHIC9y2Uc3nve1gHySJQQZ1rB6stxjt2jx13yRs4Cd1W4W3N3yrvePAu3sbTLt+4i7BaZQ+xP8M2aRTDd0pnBG423lJ32wb5F5E2f7T9qHnif+IMznqwE++5DHIBVqskv89zlDD8YRJlKl6WPqb6qKZdb5snnQxedxUf+C2IeowvcACS7cO36txAjDbGkAZpDt1y2Dzh/xENL7vkzyCA+uCx00WUp9UdjoK0gW6pk4LEPI3JkG4fvlTnHQepDd2yP8lB1N9GI+F0W/GpmyC5oVsjmyecHCz0g8hjiLcFnzoN8hvCYLUNeNbmk0hndLFxNJSCqBijIJ337xQV5GUchNWiUSoI3/ozQiUI557HaARrG6Uf66X/x7qAvzwGmeP/IOo7Qx4jCvcg2Qq8Jw3yL8Kg23kUw9OJMYi67xkMgXS1kQU3IdlKuyjGJzMOkq1CNaTAZ3gLr+L5AC/g6VAJomL0gXQNDWdz4JaDKO9IgnyJs5AuCrdwHkewI8BOZAuFICpGXxcxjHfkRjgkm4vXtUHUpdlwD8FaSb8HcRGjgeaunpBujlkUs0sL4hqCseL+DOI9huY/3/0dRnlDG8TwS35jYg6iYvSDZNGoL3xOz2IkpJuBF7VB1MUvoxaOhXKQBIxhvP9FjIV04/CCCmJ7+Vsog5m46CHIQljtJj50EeR9XIfVqpqceRXDvMcQRRkP6abhbTdvQDrUwxzsM9iLE5ogpdAGrU00wKsuXvTLqGdxZxv8Z3LmR8SuHVktHv2xFHaGeYG4ggi7mqBusgUA1p3aQGgt9WsAAAAASUVORK5CYII="

/***/ }),
/* 122 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 123 */
/***/ (function(module, exports) {

module.exports = [{"id":1,"languageISO":"DE","languageDisplay":"DE"},{"id":2,"languageISO":"EN","languageDisplay":"EN"}]

/***/ }),
/* 124 */
/***/ (function(module, exports) {

module.exports = {"banner":{"calculate":"Calculate","benefits":"Benefits of DTG","benefitsLink":"https://brothergtx.com/benefits-of-dtg.html","technical":"Technical Specs","technicalLink":"https://brothergtx.com/technical-specs.html","multiMedia":"Multi-Media Gallery","multiMediaLink":"https://brothergtx.com/multi-media-gallery.html","contact":"Select your Region","contactLink":"https://brothergtx.com/select-your-region.html"},"contact":{"title":"Contact","text":"Do you have questions, requests or suggestions? Contact us via the contact form!","button":"Contact us","link":"https://brothergtx.com/select-your-region.html"},"social":{"title":"#brothergtx in Action","text":"Experience the next-generation printer: Follow #brothergtseries on Instagram to see its tremendous print speed, seamless design, and other powerful features.","button":"Follow #brothergtseries","link":""},"calculator":{"title":"Production Calculator","introText":"The new direct-to-garment printer GTX not only offers next-generation prints, with its production calculator this printer has definitely arrived in the future. On using the ROI calculator you enter the data of your planned production very conveniently, receiving all relevant information about the running costs immediately. So you always have your investments in view and under control.","termsLine1":"Indicated prices are net.","termsLine2":"The calculations and visualisations are for simulation only and may vary.","demandVolume":"Demand volume","productionWeeks":"Production weeks","productionHours":"Working time","listPrice":"List price","printColor":"Print colour","textileColor":"Garment colour","pieceHours":"Pieces / hour(s)","pieceHour":"Pieces / hour","pieceWeek":"Piece(s) / Weeks(s)","weekYear":"Weeks(s) / Year","hoursDay":"Hour(s) / Day","piece":"Piece","allSetups":"All setups","device":"Device","qty":"Quantity","months":"Months","month":"Month","earnings":"Earnings","unit":"Unit","capacity":"Capacity","apply":"Apply","gtxprinter":"GTX Printer","transferpresse":"Transfer press","pretreatmaker":"Pretreatmaker","pretreatmakerLine":"Pretreatmaker LINE","tunneltrockner":"Tunnel dryer","variableCosts":"variable costs","investment":"Investment","contributionMargin":"Contribution margin","turnover":"Turnover","year":"Year","materialCostsTextile":"Material costs (garment)","printCosts":"Print costs","maintenanceCosts":"Maintenance costs","costPerPiece":"Cost per unit","inkPack":"Ink package","pretreatPack":"Pretreatment package","printArea":"Print size","printFormatText":"average print format ","amortisationPeriod":"Amortisation period","amortisationAmount":"Amortisation amount","white":"white","colourful":"colourful","inkWhite":"Ink (white)","inkCMYK":"Ink (CMYK)","currency":"Currency","dark":"dark"},"steps":{"title":"Step by Step","demandVolumeHelp":"Please enter the volume of demand.","productionWeeksHelp":"Please enter the number of production weeks per year.","productionHoursHelp":"Please enter the number of production hours per day.","listPriceHelp":"Please enter the price per unit.","printColorHelp":"Please adjust the split between white and cmyk colours.","textileHelp":"Please adjust the split between white and coloured garments."},"help":{"button":"Help?","title":"Help"}}

/***/ }),
/* 125 */
/***/ (function(module, exports) {

module.exports = {"banner":{"calculate":"Kalkulieren","benefits":"Vorteile des DTG","benefitsLink":"https://brothergtx.com/de/vorteile-des-dtg.html","technical":"Technische Infos","technicalLink":"https://brothergtx.com/de/technische-infos.html","multiMedia":"Multi-Media Galerie","multiMediaLink":"https://brothergtx.com/de/multi-media-galerie.html","contact":"Händler in der Nähe finden","contactLink":"https://brothergtx.com/de/handler-in-der-nahe-finden.html"},"contact":{"title":"Kontakt","text":"Sie haben Fragen, Wünsche oder Anregungen? Kontaktieren Sie uns über das Kontaktformular!","button":"Kontakt aufnehmen","link":"https://brothergtx.com/de/handler-in-der-nahe-finden.html"},"social":{"title":"#brothergtx in Action","text":"Erleben Sie den Drucker der nächsten Generation: Folgen Sie #brothergtseries auf Instagram, um sich von seiner enormen Druckgeschwindigkeit, dem nahtloses Design und weiteren starke Funktionen begeistern zu lassen.","button":"#brothergtseries folgen","link":""},"calculator":{"title":"Produktionskalkulator","introText":"Der neue Textildirektdrucker GTX bietet nicht nur Drucke der nächsten Generation, sondern ist auch mit seinem Produktionskalkulator in der Zukunft angekommen. Über den ROI–Kalkulator können Sie nun ganz bequem die Daten Ihrer geplanten Produktion eingeben und erhalten sofort alle relevanten Informationen zu den laufenden Kosten. So haben Sie Ihre Investitionen stets im Blick und immer unter Kontrolle.","termsLine1":"Angegebene Preise sind Netto.","termsLine2":"Die angegebenen Kalkulationen und Visualisierungen dienen lediglich als Simulation und können abweichen.","demandVolume":"Nachfragevolumen","productionWeeks":"Produktionswochen","productionHours":"Arbeitszeit","listPrice":"Listenpreis","printColor":"Druckfarbe","textileColor":"Farbe Textil","pieceHours":"Stück / Stunde(n)","pieceHour":"Stück / Stunde","pieceWeek":"Stück / Woche(n)","weekYear":"Woche(n) / Jahr","hoursDay":"Stunde(n) / Tag","piece":"Stück","allSetups":"Alle Setups","device":"Gerät","qty":"Anzahl","months":"Monate","month":"Monat","earnings":"Ertrag","unit":"Einheit","capacity":"Kapazität","apply":"Anwenden","gtxprinter":"GTX Printer","transferpresse":"Transferpresse","pretreatmaker":"Pretreatmaker","pretreatmakerLine":"Pretreatmaker LINE","tunneltrockner":"Tunneltrockner","variableCosts":"variable Kosten","investment":"Investition","contributionMargin":"Deckungsbeitrag","turnover":"Umsatz","year":"Jahr","materialCostsTextile":"Materialkosten (Textil)","printCosts":"Druckkosten","maintenanceCosts":"Wartungskosten","costPerPiece":"Stückkosten","inkPack":"Tintenpackung","pretreatPack":"Pretreatmentpackung","printArea":"Druckfläche","printFormatText":"durchschnittliches Druckformat","amortisationPeriod":"Amortisationsdauer","amortisationAmount":"Amortisationsmenge","white":"weiß","colourful":"bunt","inkWhite":"Tinte (weiß)","inkCMYK":"Tinte (CMYK)","currency":"Währung","dark":"dunkel"},"steps":{"title":"Schritt für Schritt","demandVolumeHelp":"Bitte geben Sie das Nachfragevolumen ein.","productionWeeksHelp":"Bitte geben Sie die Anzahl der Produktionswochen pro Jahr an.","productionHoursHelp":"Bitte geben Sie die Arbeitszeit (Stunden) pro Tag an.","listPriceHelp":"Bitte geben Sie den Preis pro Stück an.","printColorHelp":"Bitte stellen Sie die Verteilung zwischen der weißen und cmyk Farben ein.","textileHelp":"Bitte stellen Sie die Verteilung zwischen den weißen und bunten Textilien ein."},"help":{"button":"Hilfe?","title":"Hilfe"}}

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(46);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["a" /* createBrowserHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.");
  };

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

BrowserRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  forceRefresh: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (BrowserRouter);

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(44);
var invariant = __webpack_require__(128);
var ReactPropTypesSecret = __webpack_require__(129);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PathUtils__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DOMUtils__ = __webpack_require__(64);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var getHistoryState = function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
};

/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */
var createBrowserHistory = function createBrowserHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["b" /* canUseDOM */], 'Browser history needs a DOM');

  var globalHistory = window.history;
  var canUseHistory = Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["g" /* supportsHistory */])();
  var needsHashChangeListener = !Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["h" /* supportsPopStateOnHashChange */])();

  var _props$forceRefresh = props.forceRefresh,
      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
      _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? __WEBPACK_IMPORTED_MODULE_5__DOMUtils__["c" /* getConfirmation */] : _props$getUserConfirm,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;

  var basename = props.basename ? Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["g" /* stripTrailingSlash */])(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */])(props.basename)) : '';

  var getDOMLocation = function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;


    var path = pathname + search + hash;

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!basename || Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["c" /* hasBasename */])(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["e" /* stripBasename */])(path, basename);

    return Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, key);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var handlePopState = function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["d" /* isExtraneousPopstateEvent */])(event)) return;

    handlePop(getDOMLocation(event.state));
  };

  var handleHashChange = function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  };

  var forceNextPop = false;

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allKeys.indexOf(fromLocation.key);

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key];

  // Public interface

  var createHref = function createHref(location) {
    return basename + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
  };

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.pushState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

          nextKeys.push(location.key);
          allKeys = nextKeys;

          setState({ action: action, location: location });
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');

        window.location.href = href;
      }
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.replaceState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);

          if (prevIndex !== -1) allKeys[prevIndex] = location.key;

          setState({ action: action, location: location });
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');

        window.location.replace(href);
      }
    });
  };

  var go = function go(n) {
    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

/* harmony default export */ __webpack_exports__["a"] = (createBrowserHistory);

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to) {
  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var toParts = to && to.split('/') || [];
  var fromParts = from && from.split('/') || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash = void 0;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) {
    fromParts.unshift('..');
  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (resolvePathname);

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function valueEqual(a, b) {
  if (a === b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return valueEqual(item, b[index]);
    });
  }

  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (aType !== bType) return false;

  if (aType === 'object') {
    var aValue = a.valueOf();
    var bValue = b.valueOf();

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);

    if (aKeys.length !== bKeys.length) return false;

    return aKeys.every(function (key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (valueEqual);

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PathUtils__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DOMUtils__ = __webpack_require__(64);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var HashChangeEvent = 'hashchange';

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["f" /* stripLeadingSlash */])(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["f" /* stripLeadingSlash */],
    decodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */]
  },
  slash: {
    encodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */],
    decodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */]
  }
};

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var createHashHistory = function createHashHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["b" /* canUseDOM */], 'Hash history needs a DOM');

  var globalHistory = window.history;
  var canGoWithoutReload = Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["f" /* supportsGoWithoutReloadUsingHash */])();

  var _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? __WEBPACK_IMPORTED_MODULE_5__DOMUtils__["c" /* getConfirmation */] : _props$getUserConfirm,
      _props$hashType = props.hashType,
      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;

  var basename = props.basename ? Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["g" /* stripTrailingSlash */])(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */])(props.basename)) : '';

  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;


  var getDOMLocation = function getDOMLocation() {
    var path = decodePath(getHashPath());

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!basename || Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["c" /* hasBasename */])(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["e" /* stripBasename */])(path, basename);

    return Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path);
  };

  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var forceNextPop = false;
  var ignorePath = null;

  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;

      if (!forceNextPop && Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["b" /* locationsAreEqual */])(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;

      handlePop(location);
    }
  };

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(toLocation));

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(fromLocation));

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  // Ensure the hash is encoded properly before doing anything else.
  var path = getHashPath();
  var encodedPath = encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  var initialLocation = getDOMLocation();
  var allPaths = [Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(initialLocation)];

  // Public interface

  var createHref = function createHref(location) {
    return '#' + encodePath(basename + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location));
  };

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Hash history cannot push state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);

        var prevIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

        nextPaths.push(path);
        allPaths = nextPaths;

        setState({ action: action, location: location });
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');

        setState();
      }
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Hash history cannot replace state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(history.location));

      if (prevIndex !== -1) allPaths[prevIndex] = path;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');

    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

/* harmony default export */ __webpack_exports__["a"] = (createHashHistory);

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PathUtils__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createTransitionManager__ = __webpack_require__(45);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var clamp = function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
};

/**
 * Creates a history object that stores locations in memory.
 */
var createMemoryHistory = function createMemoryHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getUserConfirmation = props.getUserConfirmation,
      _props$initialEntries = props.initialEntries,
      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
      _props$initialIndex = props.initialIndex,
      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;


  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_3__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = history.entries.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(entry, undefined, createKey()) : Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(entry, undefined, entry.key || createKey());
  });

  // Public interface

  var createHref = __WEBPACK_IMPORTED_MODULE_1__PathUtils__["b" /* createPath */];

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;

      var nextEntries = history.entries.slice(0);
      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      history.entries[history.index] = location;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);

    var action = 'POP';
    var location = history.entries[nextIndex];

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var canGo = function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  };

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return transitionManager.setPrompt(prompt);
  };

  var listen = function listen(listener) {
    return transitionManager.appendListener(listener);
  };

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };

  return history;
};

/* harmony default export */ __webpack_exports__["a"] = (createMemoryHistory);

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(46);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["b" /* createHashHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.");
  };

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

HashRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  hashType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(["hashbang", "noslash", "slash"]),
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (HashRouter);

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__ = __webpack_require__(137);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__["a" /* default */]);

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(47);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["d" /* createMemoryHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.");
  };

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (MemoryRouter);

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Route__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(65);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref["aria-current"],
      rest = _objectWithoutProperties(_ref, ["to", "exact", "strict", "location", "activeClassName", "className", "activeStyle", "style", "isActive", "aria-current"]);

  var path = (typeof to === "undefined" ? "undefined" : _typeof(to)) === "object" ? to.pathname : to;

  // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
  var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Route__["a" /* default */], {
    path: escapedPath,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], _extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(" ") : className,
        style: isActive ? _extends({}, style, activeStyle) : style,
        "aria-current": isActive && ariaCurrent || null
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */].propTypes.to,
  exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  "aria-current": __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["page", "step", "location", "date", "time", "true"])
};

NavLink.defaultProps = {
  activeClassName: "active",
  "aria-current": "page"
};

/* unused harmony default export */ var _unused_webpack_default_export = (NavLink);

/***/ }),
/* 139 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__ = __webpack_require__(141);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__["a" /* default */]);

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Prompt> outside a <Router>");

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Prompt);

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__ = __webpack_require__(143);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__["a" /* default */]);

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__generatePath__ = __webpack_require__(69);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/**
 * The public API for updating the location programmatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Redirect> outside a <Router>");

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(prevProps.to);
    var nextTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(this.props.to);

    if (Object(__WEBPACK_IMPORTED_MODULE_4_history__["f" /* locationsAreEqual */])(prevTo, nextTo)) {
      __WEBPACK_IMPORTED_MODULE_2_warning___default()(false, "You tried to redirect to the same route you're currently on: " + ("\"" + nextTo.pathname + nextTo.search + "\""));
      return;
    }

    this.perform();
  };

  Redirect.prototype.computeTo = function computeTo(_ref) {
    var computedMatch = _ref.computedMatch,
        to = _ref.to;

    if (computedMatch) {
      if (typeof to === "string") {
        return Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to, computedMatch.params);
      } else {
        return _extends({}, to, {
          pathname: Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to.pathname, computedMatch.params)
        });
      }
    }

    return to;
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var push = this.props.push;

    var to = this.computeTo(this.props);

    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, // private, from <Switch>
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__ = __webpack_require__(145);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__["a" /* default */]);

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Router__ = __webpack_require__(47);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: addLeadingSlash(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = addLeadingSlash(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createURL = function createURL(location) {
  return typeof location === "string" ? location : Object(__WEBPACK_IMPORTED_MODULE_4_history__["e" /* createPath */])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false, "You cannot %s with <StaticRouter>", methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return addLeadingSlash(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = "PUSH";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = "REPLACE";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.");
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ["basename", "context", "location"]);

    var history = {
      createHref: this.createHref,
      action: "POP",
      location: stripBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler("go"),
      goBack: staticHandler("goBack"),
      goForward: staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: "",
  location: "/"
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (StaticRouter);

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__ = __webpack_require__(147);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__["a" /* default */]);

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(48);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Switch> outside a <Router>");
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (match == null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) {
        var _element$props = element.props,
            pathProp = _element$props.path,
            exact = _element$props.exact,
            strict = _element$props.strict,
            sensitive = _element$props.sensitive,
            from = _element$props.from;

        var path = pathProp || from;

        child = element;
        match = Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }, route.match);
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__ = __webpack_require__(69);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__["a" /* default */]);

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__ = __webpack_require__(48);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__["a" /* default */]);

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__ = __webpack_require__(151);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__["a" /* default */]);

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(67);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ["wrappedComponentRef"]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], {
      children: function children(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, {
          ref: wrappedComponentRef
        }));
      }
    });
  };

  C.displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

/* harmony default export */ __webpack_exports__["a"] = (withRouter);

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__banner_css__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__banner_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__banner_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_background_jpg__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_background_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_images_background_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_logo_gtx_red_png__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_logo_gtx_red_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_images_logo_gtx_red_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_gtx_printer_png__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_gtx_printer_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_images_gtx_printer_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_images_gtx_printer_2x_png__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_images_gtx_printer_2x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_images_gtx_printer_2x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_icons_icon_down_svg__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_icons_icon_down_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_icons_icon_down_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jump_js__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__i18n__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router_dom__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Banner=function(_Component){_inherits(Banner,_Component);function Banner(){_classCallCheck(this,Banner);return _possibleConstructorReturn(this,(Banner.__proto__||Object.getPrototypeOf(Banner)).apply(this,arguments));}_createClass(Banner,[{key:'scrollToCalculator',value:function scrollToCalculator(){Object(__WEBPACK_IMPORTED_MODULE_7_jump_js__["a" /* default */])('.calculator');}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1__banner_css___default.a.banner+" lazyload",'data-bgset':__WEBPACK_IMPORTED_MODULE_2__assets_images_background_jpg___default.a},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1__banner_css___default.a.content},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3__assets_images_logo_gtx_red_png___default.a,alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:__WEBPACK_IMPORTED_MODULE_1__banner_css___default.a.text},'The X factor for your garment printing business')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:__WEBPACK_IMPORTED_MODULE_1__banner_css___default.a.printer,src:__WEBPACK_IMPORTED_MODULE_4__assets_images_gtx_printer_png___default.a,srcSet:__WEBPACK_IMPORTED_MODULE_4__assets_images_gtx_printer_png___default.a+" 1x , "+__WEBPACK_IMPORTED_MODULE_5__assets_images_gtx_printer_2x_png___default.a+" 2x",alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:__WEBPACK_IMPORTED_MODULE_1__banner_css___default.a.scroll,onClick:this.scrollToCalculator},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_8__i18n__["a" /* default */].translate("banner:calculate",this.props.location.pathname)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:__WEBPACK_IMPORTED_MODULE_1__banner_css___default.a.scrollImage,src:__WEBPACK_IMPORTED_MODULE_6__assets_icons_icon_down_svg___default.a,alt:''}))));}}]);return Banner;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["c" /* withRouter */])(Banner));

/***/ }),
/* 154 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"banner":"_1GfrdtCBH0f_qLHMdIa1Ux","content":"xAZuAj-OIRK-iVhaIV33n","text":"_21USph0Kk6h29Jey2u15-M","scroll":"_2Q3eMVMF3FtuOD2gpBm1J8","scrollImage":"_3pGt-C6XZYvokZJJ1SircR"};

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/background.cc4e527c.jpg";

/***/ }),
/* 156 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/gtx_printer.97aa794a.png";

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/gtx_printer@2x.b880c6b0.png";

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_down.84cca33e.svg";

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Robert Penner's easeInOutQuad

// find the rest of his easing functions here: http://robertpenner.com/easing/
// find them exported for ES6 consumption here: https://github.com/jaxgeller/ez.js

var easeInOutQuad = function easeInOutQuad(t, b, c, d) {
  t /= d / 2;
  if (t < 1) return c / 2 * t * t + b;
  t--;
  return -c / 2 * (t * (t - 2) - 1) + b;
};

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var jumper = function jumper() {
  // private variable cache
  // no variables are created during a jump, preventing memory leaks

  var element = void 0; // element to scroll to                   (node)

  var start = void 0; // where scroll starts                    (px)
  var stop = void 0; // where scroll stops                     (px)

  var offset = void 0; // adjustment from the stop position      (px)
  var easing = void 0; // easing function                        (function)
  var a11y = void 0; // accessibility support flag             (boolean)

  var distance = void 0; // distance of scroll                     (px)
  var duration = void 0; // scroll duration                        (ms)

  var timeStart = void 0; // time scroll started                    (ms)
  var timeElapsed = void 0; // time spent scrolling thus far          (ms)

  var next = void 0; // next scroll position                   (px)

  var callback = void 0; // to call when done scrolling            (function)

  // scroll position helper

  function location() {
    return window.scrollY || window.pageYOffset;
  }

  // element offset helper

  function top(element) {
    return element.getBoundingClientRect().top + start;
  }

  // rAF loop helper

  function loop(timeCurrent) {
    // store time scroll started, if not started already
    if (!timeStart) {
      timeStart = timeCurrent;
    }

    // determine time spent scrolling so far
    timeElapsed = timeCurrent - timeStart;

    // calculate next scroll position
    next = easing(timeElapsed, start, distance, duration);

    // scroll to it
    window.scrollTo(0, next);

    // check progress
    timeElapsed < duration ? window.requestAnimationFrame(loop) // continue scroll loop
    : done(); // scrolling is done
  }

  // scroll finished helper

  function done() {
    // account for rAF time rounding inaccuracies
    window.scrollTo(0, start + distance);

    // if scrolling to an element, and accessibility is enabled
    if (element && a11y) {
      // add tabindex indicating programmatic focus
      element.setAttribute('tabindex', '-1');

      // focus the element
      element.focus();
    }

    // if it exists, fire the callback
    if (typeof callback === 'function') {
      callback();
    }

    // reset time for next jump
    timeStart = false;
  }

  // API

  function jump(target) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    // resolve options, or use defaults
    duration = options.duration || 1000;
    offset = options.offset || 0;
    callback = options.callback; // "undefined" is a suitable default, and won't be called
    easing = options.easing || easeInOutQuad;
    a11y = options.a11y || false;

    // cache starting position
    start = location();

    // resolve target
    switch (typeof target === 'undefined' ? 'undefined' : _typeof(target)) {
      // scroll from current position
      case 'number':
        element = undefined; // no element to scroll to
        a11y = false; // make sure accessibility is off
        stop = start + target;
        break;

      // scroll to element (node)
      // bounding rect is relative to the viewport
      case 'object':
        element = target;
        stop = top(element);
        break;

      // scroll to element (selector)
      // bounding rect is relative to the viewport
      case 'string':
        element = document.querySelector(target);
        stop = top(element);
        break;
    }

    // resolve scroll distance, accounting for offset
    distance = stop - start + offset;

    // resolve duration
    switch (_typeof(options.duration)) {
      // number in ms
      case 'number':
        duration = options.duration;
        break;

      // function passed the distance of the scroll
      case 'function':
        duration = options.duration(distance);
        break;
    }

    // start the loop
    window.requestAnimationFrame(loop);
  }

  // expose only the jump method
  return jump;
};

// export singleton

var singleton = jumper();

/* harmony default export */ __webpack_exports__["a"] = (singleton);


/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__banner_nav_css__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__banner_nav_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__banner_nav_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_icons_ICN_Benefits_svg__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_icons_ICN_Benefits_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_icons_ICN_Benefits_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_icons_ICN_Specs_svg__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_icons_ICN_Specs_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_icons_ICN_Specs_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_icons_ICN_Gallery_svg__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_icons_ICN_Gallery_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_icons_ICN_Gallery_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_icons_ICN_Region_svg__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_icons_ICN_Region_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_icons_ICN_Region_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__i18n__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_dom__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BannerNav=function(_Component){_inherits(BannerNav,_Component);function BannerNav(){_classCallCheck(this,BannerNav);return _possibleConstructorReturn(this,(BannerNav.__proto__||Object.getPrototypeOf(BannerNav)).apply(this,arguments));}_createClass(BannerNav,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1__banner_nav_css___default.a.container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1__banner_nav_css___default.a.containerInner},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1__banner_nav_css___default.a.item},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:__WEBPACK_IMPORTED_MODULE_6__i18n__["a" /* default */].translate('banner:benefitsLink',this.props.location.pathname),target:'_blank',rel:'noopener noreferrer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_2__assets_icons_ICN_Benefits_svg___default.a,alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_6__i18n__["a" /* default */].translate('banner:benefits',this.props.location.pathname)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1__banner_nav_css___default.a.item},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:__WEBPACK_IMPORTED_MODULE_6__i18n__["a" /* default */].translate('banner:technicalLink',this.props.location.pathname),target:'_blank',rel:'noopener noreferrer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3__assets_icons_ICN_Specs_svg___default.a,alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_6__i18n__["a" /* default */].translate('banner:technical',this.props.location.pathname)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1__banner_nav_css___default.a.item},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:__WEBPACK_IMPORTED_MODULE_6__i18n__["a" /* default */].translate('banner:multiMediaLink',this.props.location.pathname),target:'_blank',rel:'noopener noreferrer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_4__assets_icons_ICN_Gallery_svg___default.a,alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_6__i18n__["a" /* default */].translate('banner:multiMedia',this.props.location.pathname)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1__banner_nav_css___default.a.item},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:__WEBPACK_IMPORTED_MODULE_6__i18n__["a" /* default */].translate('banner:contactLink',this.props.location.pathname),target:'_blank',rel:'noopener noreferrer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_5__assets_icons_ICN_Region_svg___default.a,alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_6__i18n__["a" /* default */].translate('banner:contact',this.props.location.pathname))))));}}]);return BannerNav;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["c" /* withRouter */])(BannerNav));

/***/ }),
/* 162 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"Z0Tc7Gb3N-4zFY05pl8WQ","containerInner":"_2FpUCSxDDyG7_PBCngRcC-","item":"ANNbRFn6MDy-xNjJmvF8p"};

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ICN_Benefits.ad993ed1.svg";

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ICN_Specs.5c46e3e0.svg";

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ICN_Gallery.84604b1c.svg";

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ICN_Region.36219212.svg";

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__social_css__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__social_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__social_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__i18n__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Social=function(_Component){_inherits(Social,_Component);function Social(){_classCallCheck(this,Social);return _possibleConstructorReturn(this,(Social.__proto__||Object.getPrototypeOf(Social)).apply(this,arguments));}_createClass(Social,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1__social_css___default.a.inputWrapperContainer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1__social_css___default.a.inputWrapperContainerInner},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1__social_css___default.a.titleContainer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1__social_css___default.a.titleInner},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,__WEBPACK_IMPORTED_MODULE_2__i18n__["a" /* default */].translate('social:title',this.props.location.pathname)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_2__i18n__["a" /* default */].translate('social:text',this.props.location.pathname)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'instafeed',className:__WEBPACK_IMPORTED_MODULE_1__social_css___default.a.socialFeed}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:__WEBPACK_IMPORTED_MODULE_1__social_css___default.a.btn,target:'_blank',rel:'noopener noreferrer',href:__WEBPACK_IMPORTED_MODULE_2__i18n__["a" /* default */].translate('social:link',this.props.location.pathname)},__WEBPACK_IMPORTED_MODULE_2__i18n__["a" /* default */].translate('social:button',this.props.location.pathname))));}}]);return Social;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* withRouter */])(Social));

/***/ }),
/* 168 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"inputWrapperContainer":"_3ZmqLsvx1NMTgbp97W3o8l","inputWrapperContainerInner":"_12rY7FvS0jWKkerUHMKSWb","titleContainer":"_1zMlfGIJByxuN9xQR6bZHA","titleInner":"_3NzONV7OAtX0XN5Pfn5WEJ","socialFeed":"_2bcdQJAmUp31lBKHOq2qZy","btn":"_3Y7TqTCD5AVG4sxt3J38cK"};

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__contact_css__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__contact_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__contact_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__i18n__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Contact=function(_Component){_inherits(Contact,_Component);function Contact(){_classCallCheck(this,Contact);return _possibleConstructorReturn(this,(Contact.__proto__||Object.getPrototypeOf(Contact)).apply(this,arguments));}_createClass(Contact,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1__contact_css___default.a.inputWrapperContainer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1__contact_css___default.a.inputWrapperContainerInner},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1__contact_css___default.a.titleContainer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1__contact_css___default.a.titleInner},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,__WEBPACK_IMPORTED_MODULE_2__i18n__["a" /* default */].translate('contact:title',this.props.location.pathname)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_2__i18n__["a" /* default */].translate('contact:text',this.props.location.pathname)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:__WEBPACK_IMPORTED_MODULE_1__contact_css___default.a.btn,target:'_blank',rel:'noopener noreferrer',href:__WEBPACK_IMPORTED_MODULE_2__i18n__["a" /* default */].translate('contact:link',this.props.location.pathname)},__WEBPACK_IMPORTED_MODULE_2__i18n__["a" /* default */].translate('contact:button',this.props.location.pathname))))));}}]);return Contact;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* withRouter */])(Contact));

/***/ }),
/* 170 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"inputWrapperContainer":"_2cnGahJbREWb6JpficaQ2T","inputWrapperContainerInner":"_3p8sReqTRYq_uAXos1ZzGt","titleContainer":"_3XwgWVVHBK2PTOQzymtP_3","titleInner":"_5-4F8kOBg2MaxdPrsYQE-","btn":"_14D9zFvMVYfttXQhWNBVsf"};

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__inputs_inputs_css__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__inputs_inputs_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__inputs_inputs_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_icons_icon_info_svg__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_icons_icon_info_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_icons_icon_info_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_currencies_json__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_currencies_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__data_currencies_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_devices_json__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_devices_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__data_devices_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_scenarios_json__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_scenarios_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__data_scenarios_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__data_din_printarea_json__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__data_din_printarea_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__data_din_printarea_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__data_pretreatment_json__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__data_pretreatment_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__data_pretreatment_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__data_ink_json__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__data_ink_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__data_ink_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__inputs_c_currency_dropdown__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__inputs_c_readonly_input__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__inputs_c_overview_group__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__inputs_c_slider_group__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__inputs_c_dropdown_group__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__inputs_c_user_input__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__inputs_c_scenario_dropdown__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__charts_c_bar_chart__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__charts_c_pie_chart__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__totals_c_totals__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__totals_c_scenario_overview__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__room_room__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__overlay_overlay__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__help_help__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__step_by_step_step_by_step__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__i18n__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_react_router_dom__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// Data. Returns normal JSON file for now.
// Grab inputs
// Grab graphs
// Grab totals
// Help
var classNames=__webpack_require__(7);var Calculator=function(_Component){_inherits(Calculator,_Component);function Calculator(props){_classCallCheck(this,Calculator);var _this=_possibleConstructorReturn(this,(Calculator.__proto__||Object.getPrototypeOf(Calculator)).call(this,props));_this.transformNaNorInfintyToZero=function(value){return isNaN(value)||!isFinite(value)?0.00:value;};_this.toNumber=function(value){return Number(_this.transformNaNorInfintyToZero(value));};_this.componentDidMount=function(){_this.updateWindowDimensions();window.addEventListener('resize',_this.updateWindowDimensions);};_this.toggleStepByStep=function(){_this.setState({showStepByStep:_this.state.showStepByStep?false:true});};_this.handleCurrencyChange=_this.handleCurrencyChange.bind(_this);_this.handleDinChange=_this.handleDinChange.bind(_this);_this.handlePretreatmentChange=_this.handlePretreatmentChange.bind(_this);_this.handleInkQtyChange=_this.handleInkQtyChange.bind(_this);_this.handlePrintColorPercentageChange=_this.handlePrintColorPercentageChange.bind(_this);_this.handleTextileColorPercentageChange=_this.handleTextileColorPercentageChange.bind(_this);_this.handleUserInputChange=_this.handleUserInputChange.bind(_this);_this.handleScenarioChange=_this.handleScenarioChange.bind(_this);_this.handleDeviceUserInputChange=_this.handleDeviceUserInputChange.bind(_this);_this.updateWindowDimensions=_this.updateWindowDimensions.bind(_this);_this.state={currency:__WEBPACK_IMPORTED_MODULE_3__data_currencies_json___default.a[0],scenario:__WEBPACK_IMPORTED_MODULE_5__data_scenarios_json___default.a[0],recommendedDevices:[],allDevices:__WEBPACK_IMPORTED_MODULE_4__data_devices_json___default.a,additionalDevices:[],//This will be populated via the room builder
devicePricing:[],// This will grab the totals for devices
deviceInvestment:0,din:[],pretreatment:[],pretreatmentPricing:[],pretreatmentPrice:0,hasPretreatmaker:true,// When 100% white colour, set this to false as we don't need it.
ink:[],inkPricing:[],printColorPercentage:20,textileColorPercentage:30,demandVolume:400,productionWeeks:48,productionHours:8,personnelCosts:0,personnelSingleCosts:0,listPrice:10.95,materialCostsTextile:1.80,maintenanceCosts:0,printCostsWithTextiles:0,combinedCost:0,contributionMarginSingle:0,contributionMarginSinglePercentage:0,payoffQty:0,payoffDuration:0,totalsDataSet:[],pieDataSet:[],// For the pie chart
turnover:0,gtxPrinterPrice:__WEBPACK_IMPORTED_MODULE_4__data_devices_json___default.a[0].prices[0].price,pretreatmakerPrice:__WEBPACK_IMPORTED_MODULE_4__data_devices_json___default.a[1].prices[0].price,transferpressPrice:__WEBPACK_IMPORTED_MODULE_4__data_devices_json___default.a[2].prices[0].price,pretreatmakerLinePrice:__WEBPACK_IMPORTED_MODULE_4__data_devices_json___default.a[3].prices[0].price,dryerPrice:__WEBPACK_IMPORTED_MODULE_4__data_devices_json___default.a[4].prices[0].price,alertActive:false,showOverlay:false,width:0,overrideAlert:false,// This is to avoid a never ending loop when the max scenario is selected but demand volume is higher than the max.
showStepByStep:false};return _this;}_createClass(Calculator,[{key:'handleAlertScenarioChange',value:function handleAlertScenarioChange(scenario){this.setState({alertActive:false});this.handleScenarioChange(scenario);}},{key:'updateTotals',value:function updateTotals(){// Handle all totals update across the state.
// Calculate costs
//// Personnel Costs
var personnelSingleCosts=this.toNumber(this.state.personnelCosts/(this.state.demandVolume/5/this.state.productionHours));this.setState({personnelSingleCosts:personnelSingleCosts});var demandVolume=this.toNumber(this.state.demandVolume);// Check if demand volume hr fits our selected scenario
var demandVolumeHr=this.toNumber(demandVolume/5/this.state.productionHours);var scenarioDemandVolumeMax=Number(this.state.scenario.capacity);if(demandVolumeHr>scenarioDemandVolumeMax&&!this.state.alertActive&&!this.state.overrideAlert){// Try and work out the correct scenario
var optimalScenario=__WEBPACK_IMPORTED_MODULE_5__data_scenarios_json___default.a.filter(function(scenario){return scenario.capacity>=demandVolumeHr;})[0];if(optimalScenario===undefined){optimalScenario=__WEBPACK_IMPORTED_MODULE_5__data_scenarios_json___default.a[5];// Grab the last scenario
}// Check if alert override needs to be triggered to avoid an endless loop when demand volume is higher than highest scenario
if(demandVolumeHr>optimalScenario.capacity){this.setState({overrideAlert:true});}// now show an alert if not open already
this.setState({alertActive:true});if(window.confirm("Leider übersteigt Ihr Nachfragevolumen die Kapazität des Set ups. Möchten Sie die zum optimalen Set up wechseln?")){this.handleAlertScenarioChange(optimalScenario);}else{this.setState({alertActive:false});}}if(demandVolumeHr<=scenarioDemandVolumeMax&&this.state.overrideAlert){this.setState({overrideAlert:false});}//// Maintenance Costs
// Grab currency (only USD) and then add multiplier
var multiplier=1;if(this.state.currency.id===3){multiplier=1.1922;// This is the EUR to USD conversion as per spreadsheet
}var maintenanceCosts=Number(parseFloat(0.40*multiplier).toFixed(2));this.setState({maintenanceCosts:this.toNumber(maintenanceCosts)});// Print color costs
//// Grab white and cmyk costs
//// Grab white and color textile costs
var cmykPrice=this.toNumber(this.state.cmykPricing);var whitePrice=this.toNumber(this.state.whitePricing);var textileColorPercentage=this.toNumber(this.state.textileColorPercentage/100);var printColorPercentage=this.toNumber(this.state.printColorPercentage/100);//const qtyWhite = this.toNumber(0.2 * (1 + (0.3 * textileColorPercentage)));
// Ink usage calculation
//const inkWhiteWhitePercentage = this.toNumber((1 - textileColorPercentage) * (1.00 - printColorPercentage))
var inkWhiteCmykPercentage=this.toNumber((1-textileColorPercentage)*printColorPercentage);var inkColorWhitePercentage=this.toNumber(textileColorPercentage*(1.00-printColorPercentage));var inkColorCmykPercentage=this.toNumber(textileColorPercentage*printColorPercentage);// wastage calculations
var wastageWhiteWhite=0;var wastageWhiteCmyk=0;var wastageCmykWhite=inkWhiteCmykPercentage*0.0018;var wastageCmykCmyk=0;var wastageColorWhiteWhite=0;var wastageColorWhiteCmyk=inkColorWhitePercentage*0.0063;var wastageColorCmykWhite=inkColorCmykPercentage*0.0018;var wastageColorCmykCmyk=inkColorCmykPercentage*0.0063;// consumption calculations
var consumptionCmyk=this.toNumber(wastageWhiteCmyk+wastageCmykCmyk+wastageColorWhiteCmyk+wastageColorCmykCmyk);var consumptionWhite=this.toNumber(wastageWhiteWhite+wastageCmykWhite+wastageColorWhiteWhite+wastageColorCmykWhite);var consumptionInkPriceCmyk=this.toNumber(cmykPrice*consumptionCmyk);var consumptionInkPriceWhite=this.toNumber(whitePrice*consumptionWhite);var consumptionInkPriceSum=this.toNumber(consumptionInkPriceCmyk+consumptionInkPriceWhite);// Pretreatment costs
var pretreatmentPrice=this.toNumber(this.state.pretreatmentPrice);var pretreatmentGram=this.toNumber(pretreatmentPrice/3);var dinQcm=this.toNumber(this.state.din.size_qcm);var pretreatmentPerItem=this.toNumber(dinQcm*0.0300*pretreatmentGram);// New calculation for pretreatment.
var pretreamentPerItemWithColour=this.toNumber(pretreatmentPerItem*textileColorPercentage);var printCostsWithTextiles=this.toNumber(dinQcm*consumptionInkPriceSum+pretreamentPerItemWithColour);this.setState({printCostsWithTextiles:printCostsWithTextiles});var textileCosts=this.toNumber(this.state.materialCostsTextile);var totalCosts=this.toNumber(printCostsWithTextiles+personnelSingleCosts+maintenanceCosts+textileCosts);this.setState({combinedCost:totalCosts},this.props.triggerCombinedCostsUpdate(totalCosts));// Get totals for costs & investements
// Stückdeckungsbeitrag
var contributionMarginSingle=this.toNumber(this.state.listPrice-totalCosts);this.setState({contributionMarginSingle:contributionMarginSingle,contributionMarginSinglePercentage:this.toNumber(contributionMarginSingle/this.state.listPrice*100)});var turnOver=this.toNumber(this.state.listPrice*this.state.demandVolume*this.state.productionWeeks);var variableCosts=this.toNumber(totalCosts*this.state.demandVolume*4*12);var investment=this.toNumber(this.state.deviceInvestment);// Deckungsbeitrag 2
var contributionMargin=this.toNumber(turnOver-variableCosts-investment);// Amortisations
var payoffQty=this.toNumber(investment/contributionMarginSingle);var payoffDuration=this.toNumber(payoffQty/this.state.demandVolume/(this.state.productionWeeks/12));// Set up pie chart data set
var pieData=[{title:__WEBPACK_IMPORTED_MODULE_24__i18n__["a" /* default */].translate('calculator:variableCosts',this.props.location.pathname),amount:variableCosts,amountPercentage:this.toNumber(variableCosts/turnOver)},{title:__WEBPACK_IMPORTED_MODULE_24__i18n__["a" /* default */].translate('calculator:investment',this.props.location.pathname),amount:investment,amountPercentage:this.toNumber(investment/turnOver)},{title:__WEBPACK_IMPORTED_MODULE_24__i18n__["a" /* default */].translate('calculator:contributionMargin',this.props.location.pathname),amount:contributionMargin,amountPercentage:this.toNumber(contributionMargin/turnOver)}];this.setState({payoffQty:payoffQty,payoffDuration:payoffDuration,turnover:turnOver,pieDataSet:pieData});// Now we want to set up 24 months worth of data,
// which we'll use for the totals and graph chart
var backflow=this.toNumber(this.state.productionWeeks/12*demandVolume*contributionMarginSingle);var investmentNegative=this.toNumber(investment*-1);var totalsData=[];var monthsToCalculate=24;var investmentNegativeStep=investmentNegative;for(var index=0;index<monthsToCalculate;index++){var restSum=backflow+investmentNegativeStep;investmentNegativeStep=restSum;totalsData.push({month:index+1,sum:this.toNumber(parseFloat(restSum).toFixed(2))});}this.setState({totalsDataSet:totalsData});this.props.updatePricing(this.state.devicePricing);this.props.triggerCombinedCostsUpdate(totalCosts);}},{key:'calculateDevicePricing',value:function calculateDevicePricing(){var _this2=this;var recommendedDevices=this.state.recommendedDevices;var allDevices=this.state.allDevices;if(recommendedDevices!==null&&recommendedDevices.length>0&&allDevices!==null&&allDevices.length>0){var devicePricingData=[];var overallSum=0;var self=this;recommendedDevices.forEach(function(entry){var deviceData=allDevices.filter(function(devices){return devices.id===entry.id;})[0];var pricing=deviceData.prices.filter(function(price){return price.id===self.state.currency.id;})[0];var price=0.00;if(entry.id===1){price=pricing.price;}else if(entry.id===2){price=pricing.price;}else if(entry.id===3){price=pricing.price;}else if(entry.id===4){price=pricing.price;}else if(entry.id===5){price=pricing.price;}var sum=price*entry.qty;overallSum+=sum;devicePricingData.push({id:entry.id,name:deviceData.name,localeName:deviceData.localeName,qty:entry.qty,unit_price:self.toNumber(price),price_sum:sum});});this.setState({devicePricing:devicePricingData,deviceInvestment:overallSum},function(){_this2.updateTotals();});}}},{key:'calculateInkPricing',value:function calculateInkPricing(){var _this3=this;var ink=this.state.ink;if(ink){var inkColorPricing=[];for(var index=0;index<ink.colors.length;index++){var color=ink.colors[index];var pricing=color.prices.filter(function(price){return price.id===_this3.state.currency.id;})[0];inkColorPricing.push({id:color.id,name:color.name,price:pricing.price,price_ml:pricing.price/ink.size});this.setState(_defineProperty({},color.name+"Pricing",pricing.price/ink.size));}if(inkColorPricing.length>0){this.setState({inkPricing:inkColorPricing},this.updateTotals);}}}},{key:'calculatePretreatmentPricing',value:function calculatePretreatmentPricing(){var _this4=this;var pretreatment=this.state.pretreatment;if(pretreatment){var pretreatmentPricing=[];// There should only be one slected, so no need for a loop.
var pricing=pretreatment.prices.filter(function(price){return price.id===_this4.state.currency.id;})[0];pretreatmentPricing.push({id:pretreatment.id,name:pretreatment.name,price:pricing.price,price_g:pricing.price/(pretreatment.size*1000)});this.setState({pretreatmentPrice:pricing.price/(pretreatment.size*1000)});if(pretreatmentPricing.length>0){this.setState({pretreatmentPricing:pretreatmentPricing},this.updateTotals);}}}},{key:'handlePricingDataChange',value:function handlePricingDataChange(){this.calculateDevicePricing();this.calculateInkPricing();this.calculatePretreatmentPricing();this.updateTotals();}},{key:'handleDeviceUserInputChange',value:function handleDeviceUserInputChange(value,name){this.setState(_defineProperty({},name,Number(value)),this.calculateDevicePricing);}},{key:'handleCurrencyChange',value:function handleCurrencyChange(selected){this.setState({currency:selected},this.handlePricingDataChange);this.props.triggerCurrencyChange(selected);}},{key:'handleDinChange',value:function handleDinChange(selected){this.setState({din:selected},this.updateTotals);}},{key:'handlePretreatmentChange',value:function handlePretreatmentChange(selected){this.setState({pretreatment:selected},this.handlePricingDataChange);}},{key:'handleInkQtyChange',value:function handleInkQtyChange(selected){this.setState({ink:selected},this.handlePricingDataChange);}},{key:'handlePrintColorPercentageChange',value:function handlePrintColorPercentageChange(selected){this.setState({printColorPercentage:selected},this.handlePricingDataChange);}},{key:'handleTextileColorPercentageChange',value:function handleTextileColorPercentageChange(selected){var selectedNumber=Number(selected);var hasPretreatmaker=true;if(selectedNumber===0){hasPretreatmaker=false;}this.setState({textileColorPercentage:selected,hasPretreatmaker:hasPretreatmaker},this.handlePricingDataChange);}},{key:'handleUserInputChange',value:function handleUserInputChange(value,name){// Grab state name by... name
this.setState(_defineProperty({},name,Number(value)),this.updateTotals);}},{key:'handleScenarioChange',value:function handleScenarioChange(selected){this.setState({scenario:selected});// Now we need to grab what devices we need.
if(selected!==null){var suggestedDevices=[];var scenarioItems=selected.items;for(var i=0;i<scenarioItems.length;i++){suggestedDevices.push({id:scenarioItems[i].id,qty:scenarioItems[i].qty});}if(suggestedDevices.length>0){this.setState({recommendedDevices:suggestedDevices},this.handlePricingDataChange);}// If we have a scenario above "M" we need to change the Tintenpackung and Pretreatmentpackung
if(selected.capacity!==null&&selected.capacity>=105){// for both JSON data points we only have 2 entries. Here, for speed, I am selected the last item in the feed.
this.handlePretreatmentChange(__WEBPACK_IMPORTED_MODULE_7__data_pretreatment_json___default.a[1]);this.handleInkQtyChange(__WEBPACK_IMPORTED_MODULE_8__data_ink_json___default.a[1]);}}}},{key:'componentDidUpdate',value:function componentDidUpdate(){if(typeof this.props.triggerScenarioChange!=='undefined'&&this.props.triggerScenarioChange&&this.props.triggerScenarioChange!==this.state.scenario){this.handleScenarioChange(this.props.triggerScenarioChange);this.props.clearTrigger();}//hasTouchedBase
if(!this.hasTouchedBase&&this.state.devicePricing.length>0){this.hasTouchedBase=true;this.props.updatePricing(this.state.devicePricing);}}},{key:'showOverlay',value:function showOverlay(ev,shouldShow){if(ev!==null){ev.preventDefault();}if(shouldShow){this.setState({showOverlay:true});}else{this.setState({showOverlay:false});}}},{key:'handleReset',value:function handleReset(){var root=document.getElementById('root');root.scrollIntoView({behavior:"instant",block:"start"});window.location.reload();}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('resize',this.updateWindowDimensions);}},{key:'updateWindowDimensions',value:function updateWindowDimensions(){this.setState({width:window.innerWidth});}},{key:'render',value:function render(){var _this5=this;var currency=this.state.currency;var scenario=this.state.scenario;var devicePricing=this.state.devicePricing;var din=this.state.din;var pretreatment=this.state.pretreatment;var ink=this.state.ink;var inkPricing=this.state.inkPricing;var totalsDataSet=this.state.totalsDataSet;var pathName=this.props.location.pathname;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classNames(__WEBPACK_IMPORTED_MODULE_1__inputs_inputs_css___default.a.inputWrapperContainer,'calculator')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1__inputs_inputs_css___default.a.inputWrapperContainerInner},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1__inputs_inputs_css___default.a.titleContainer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1__inputs_inputs_css___default.a.titleInner},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,__WEBPACK_IMPORTED_MODULE_24__i18n__["a" /* default */].translate('calculator:title',pathName)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_24__i18n__["a" /* default */].translate('calculator:introText',pathName))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__totals_c_scenario_overview__["a" /* default */],{scenarioData:scenario,deviceData:devicePricing,currency:currency,showOverlay:function showOverlay(ev,shouldShow){return _this5.showOverlay(ev,shouldShow);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1__inputs_inputs_css___default.a.inputWrapperContainerInner},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__overlay_overlay__["a" /* default */],{changeDevicePrice:function changeDevicePrice(device){_this5.triggerDevicePriceChange(device);},triggerScenarioChange:function triggerScenarioChange(scenario){return _this5.handleScenarioChange(scenario);},shouldShow:this.state.showOverlay,showOverlay:function showOverlay(ev,shouldShow){return _this5.showOverlay(ev,shouldShow);},scenarioData:scenario,deviceData:devicePricing,currency:currency//onChange={this.handleDeviceUserInputChange}
}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__room_room__["a" /* default */],{currentScenario:this.state.scenario}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__help_help__["a" /* default */],{styles:__WEBPACK_IMPORTED_MODULE_1__inputs_inputs_css___default.a}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1__inputs_inputs_css___default.a.stepbystepbutton},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:__WEBPACK_IMPORTED_MODULE_1__inputs_inputs_css___default.a.btn,onClick:function onClick(){return _this5.toggleStepByStep();}},__WEBPACK_IMPORTED_MODULE_24__i18n__["a" /* default */].translate('steps:title',pathName))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:__WEBPACK_IMPORTED_MODULE_1__inputs_inputs_css___default.a.inputWrapper},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:__WEBPACK_IMPORTED_MODULE_1__inputs_inputs_css___default.a.inputColumn},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1__inputs_inputs_css___default.a.inputContainer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__inputs_c_currency_dropdown__["a" /* default */],{data:__WEBPACK_IMPORTED_MODULE_3__data_currencies_json___default.a,onChange:this.handleCurrencyChange,unitInfo:__WEBPACK_IMPORTED_MODULE_24__i18n__["a" /* default */].translate('calculator:unit',pathName),description:__WEBPACK_IMPORTED_MODULE_24__i18n__["a" /* default */].translate('calculator:currency',pathName),styles:__WEBPACK_IMPORTED_MODULE_1__inputs_inputs_css___default.a,icon:__WEBPACK_IMPORTED_MODULE_2__assets_icons_icon_info_svg___default.a,helpText:'Hier w\xE4hlen Sie die W\xE4hrung aus.'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__inputs_c_scenario_dropdown__["a" /* default */],{data:__WEBPACK_IMPORTED_MODULE_5__data_scenarios_json___default.a,onChange:this.handleScenarioChange,name:'scenario',selected:scenario,returnShortName:'true',styles:__WEBPACK_IMPORTED_MODULE_1__inputs_inputs_css___default.a,icon:__WEBPACK_IMPORTED_MODULE_2__assets_icons_icon_info_svg___default.a,unitInfo:__WEBPACK_IMPORTED_MODULE_24__i18n__["a" /* default */].translate('calculator:unit',pathName),description:'GTX-Setup',helpText:'Hier w\xE4hlen Sie die Einheit aus.'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__inputs_c_readonly_input__["a" /* default */],{value:scenario.capacity,unitInfo:__WEBPACK_IMPORTED_MODULE_24__i18n__["a" /* default */].translate('calculator:pieceHour',pathName),description:__WEBPACK_IMPORTED_MODULE_24__i18n__["a" /* default */].translate('calculator:capacity',pathName),styles:__WEBPACK_IMPORTED_MODULE_1__inputs_inputs_css___default.a,icon:__WEBPACK_IMPORTED_MODULE_2__assets_icons_icon_info_svg___default.a,floatValue:'false',helpText:'Hier erfahren Sie die Anzahl der St\xFCcke pro Stunde.'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__inputs_c_overview_group__["a" /* default */],{styles:__WEBPACK_IMPORTED_MODULE_1__inputs_inputs_css___default.a,icon:__WEBPACK_IMPORTED_MODULE_2__assets_icons_icon_info_svg___default.a,currency:currency,deviceData:devicePricing,inkData:inkPricing,ink:ink}),this.state.width>685?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__charts_c_pie_chart__["a" /* default */],{data:this.state.pieDataSet,currency:currency,icon:__WEBPACK_IMPORTED_MODULE_2__assets_icons_icon_info_svg___default.a,styles:__WEBPACK_IMPORTED_MODULE_1__inputs_inputs_css___default.a}):null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:__WEBPACK_IMPORTED_MODULE_1__inputs_inputs_css___default.a.inputColumn},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1__inputs_inputs_css___default.a.inputContainer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__inputs_c_user_input__["a" /* default */],{description:__WEBPACK_IMPORTED_MODULE_24__i18n__["a" /* default */].translate('calculator:demandVolume',pathName),unitInfo:__WEBPACK_IMPORTED_MODULE_24__i18n__["a" /* default */].translate('calculator:pieceWeek',pathName),name:'demandVolume',onChange:this.handleUserInputChange,value:this.state.demandVolume,styles:__WEBPACK_IMPORTED_MODULE_1__inputs_inputs_css___default.a,icon:__WEBPACK_IMPORTED_MODULE_2__assets_icons_icon_info_svg___default.a,helpText:'Hier erfahren Sie die Anzahl der St\xFCcke pro Woche.'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__inputs_c_user_input__["a" /* default */],{description:__WEBPACK_IMPORTED_MODULE_24__i18n__["a" /* default */].translate('calculator:materialCostsTextile',pathName),unitInfo:__WEBPACK_IMPORTED_MODULE_24__i18n__["a" /* default */].translate('calculator:piece',pathName),name:'materialCostsTextile',onChange:this.handleUserInputChange,value:this.state.materialCostsTextile,currency:currency,styles:__WEBPACK_IMPORTED_MODULE_1__inputs_inputs_css___default.a,icon:__WEBPACK_IMPORTED_MODULE_2__assets_icons_icon_info_svg___default.a,helpText:'Hier erfahren Sie die Materialkosten (Textil) pro St\xFCck.'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__inputs_c_user_input__["a" /* default */],{description:__WEBPACK_IMPORTED_MODULE_24__i18n__["a" /* default */].translate('calculator:productionWeeks',pathName),unitInfo:__WEBPACK_IMPORTED_MODULE_24__i18n__["a" /* default */].translate('calculator:weekYear',pathName),onChange:this.handleUserInputChange,value:this.state.productionWeeks,name:'productionWeeks',styles:__WEBPACK_IMPORTED_MODULE_1__inputs_inputs_css___default.a,icon:__WEBPACK_IMPORTED_MODULE_2__assets_icons_icon_info_svg___default.a,helpText:'Hier erfahren Sie die Anzahl der Produktionswoche pro Jahr.'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__inputs_c_readonly_input__["a" /* default */],{value:this.state.printCostsWithTextiles,unitInfo:__WEBPACK_IMPORTED_MODULE_24__i18n__["a" /* default */].translate('calculator:piece',pathName),description:__WEBPACK_IMPORTED_MODULE_24__i18n__["a" /* default */].translate('calculator:printCosts',pathName),currency:currency,styles:__WEBPACK_IMPORTED_MODULE_1__inputs_inputs_css___default.a,icon:__WEBPACK_IMPORTED_MODULE_2__assets_icons_icon_info_svg___default.a,helpText:'Hier erfahren Sie die Druckkosten pro St\xFCck.'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__inputs_c_user_input__["a" /* default */],{description:__WEBPACK_IMPORTED_MODULE_24__i18n__["a" /* default */].translate('calculator:productionHours',pathName),unitInfo:__WEBPACK_IMPORTED_MODULE_24__i18n__["a" /* default */].translate('calculator:hoursDay',pathName),onChange:this.handleUserInputChange,value:this.state.productionHours,name:'productionHours',styles:__WEBPACK_IMPORTED_MODULE_1__inputs_inputs_css___default.a,icon:__WEBPACK_IMPORTED_MODULE_2__assets_icons_icon_info_svg___default.a,helpText:'Hier erfahren Sie die Anzahl der Produktionsstunden pro Tag.'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__inputs_c_readonly_input__["a" /* default */],{value:this.state.maintenanceCosts,unitInfo:__WEBPACK_IMPORTED_MODULE_24__i18n__["a" /* default */].translate('calculator:piece',pathName),description:__WEBPACK_IMPORTED_MODULE_24__i18n__["a" /* default */].translate('calculator:maintenanceCosts',pathName),currency:currency,styles:__WEBPACK_IMPORTED_MODULE_1__inputs_inputs_css___default.a,icon:__WEBPACK_IMPORTED_MODULE_2__assets_icons_icon_info_svg___default.a,helpText:'Hier erfahren Sie die Wartungskosten pro St\xFCck.'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__inputs_c_user_input__["a" /* default */],{description:__WEBPACK_IMPORTED_MODULE_24__i18n__["a" /* default */].translate('calculator:listPrice',pathName),unitInfo:__WEBPACK_IMPORTED_MODULE_24__i18n__["a" /* default */].translate('calculator:piece',pathName),onChange:this.handleUserInputChange,value:this.state.listPrice,name:'listPrice',currency:currency,styles:__WEBPACK_IMPORTED_MODULE_1__inputs_inputs_css___default.a,icon:__WEBPACK_IMPORTED_MODULE_2__assets_icons_icon_info_svg___default.a,helpText:'Hier erfahren Sie den Listenpreis pro St\xFCck.'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__inputs_c_readonly_input__["a" /* default */],{value:this.state.combinedCost,unitInfo:__WEBPACK_IMPORTED_MODULE_24__i18n__["a" /* default */].translate('calculator:piece',pathName),description:__WEBPACK_IMPORTED_MODULE_24__i18n__["a" /* default */].translate('calculator:costPerPiece',pathName),currency:currency,styles:__WEBPACK_IMPORTED_MODULE_1__inputs_inputs_css___default.a,icon:__WEBPACK_IMPORTED_MODULE_2__assets_icons_icon_info_svg___default.a,helpText:'Hier erfahren Sie die Kosten pro St\xFCck.'}),this.state.width>685?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__charts_c_bar_chart__["a" /* default */],{data:totalsDataSet,icon:__WEBPACK_IMPORTED_MODULE_2__assets_icons_icon_info_svg___default.a,styles:__WEBPACK_IMPORTED_MODULE_1__inputs_inputs_css___default.a}):null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:__WEBPACK_IMPORTED_MODULE_1__inputs_inputs_css___default.a.inputColumn},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1__inputs_inputs_css___default.a.inputContainer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__inputs_c_slider_group__["a" /* default */],{styles:__WEBPACK_IMPORTED_MODULE_1__inputs_inputs_css___default.a,onChangeColor:this.handlePrintColorPercentageChange,onChangeTextile:this.handleTextileColorPercentageChange,printColorPercentage:this.state.printColorPercentage,textileColorPercentage:this.state.textileColorPercentage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__inputs_c_dropdown_group__["a" /* default */],{styles:__WEBPACK_IMPORTED_MODULE_1__inputs_inputs_css___default.a,pretreatmentData:__WEBPACK_IMPORTED_MODULE_7__data_pretreatment_json___default.a,onChangePretreatment:this.handlePretreatmentChange,pretreatment:pretreatment,dinData:__WEBPACK_IMPORTED_MODULE_6__data_din_printarea_json___default.a,onChangeDin:this.handleDinChange,din:din,inkData:__WEBPACK_IMPORTED_MODULE_8__data_ink_json___default.a,onChangeInk:this.handleInkQtyChange,ink:ink}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__inputs_c_readonly_input__["a" /* default */],{value:this.state.payoffDuration,unitInfo:__WEBPACK_IMPORTED_MODULE_24__i18n__["a" /* default */].translate('calculator:months',pathName),description:__WEBPACK_IMPORTED_MODULE_24__i18n__["a" /* default */].translate('calculator:amortisationPeriod',pathName),styles:__WEBPACK_IMPORTED_MODULE_1__inputs_inputs_css___default.a,icon:__WEBPACK_IMPORTED_MODULE_2__assets_icons_icon_info_svg___default.a,helpText:'Hier erfahren Sie die Amortisationsdauer in Monaten.',highlightBox:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__inputs_c_readonly_input__["a" /* default */],{value:this.state.payoffQty,unitInfo:__WEBPACK_IMPORTED_MODULE_24__i18n__["a" /* default */].translate('calculator:piece',pathName),description:__WEBPACK_IMPORTED_MODULE_24__i18n__["a" /* default */].translate('calculator:amortisationAmount',pathName),styles:__WEBPACK_IMPORTED_MODULE_1__inputs_inputs_css___default.a,icon:__WEBPACK_IMPORTED_MODULE_2__assets_icons_icon_info_svg___default.a,helpText:'Hier erfahren Sie die Amortisationsmenge in St\xFCcken.',highlightBox:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__inputs_c_readonly_input__["a" /* default */],{value:this.state.contributionMarginSingle,unitInfo:__WEBPACK_IMPORTED_MODULE_24__i18n__["a" /* default */].translate('calculator:piece',pathName),description:__WEBPACK_IMPORTED_MODULE_24__i18n__["a" /* default */].translate('calculator:contributionMargin',pathName),styles:__WEBPACK_IMPORTED_MODULE_1__inputs_inputs_css___default.a,icon:__WEBPACK_IMPORTED_MODULE_2__assets_icons_icon_info_svg___default.a,currency:currency,helpText:'Hier erfahren Sie den Deckungsbeitrag pro St\xFCck.',highlightBox:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__inputs_c_readonly_input__["a" /* default */],{value:this.state.contributionMarginSinglePercentage,unitInfo:'%',description:__WEBPACK_IMPORTED_MODULE_24__i18n__["a" /* default */].translate('calculator:contributionMargin',pathName),styles:__WEBPACK_IMPORTED_MODULE_1__inputs_inputs_css___default.a,icon:__WEBPACK_IMPORTED_MODULE_2__assets_icons_icon_info_svg___default.a,helpText:'Hier erfahren Sie den Deckungsbeitrag in Prozent.',highlightBox:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__totals_c_totals__["a" /* default */],{data:this.state.totalsDataSet,styles:__WEBPACK_IMPORTED_MODULE_1__inputs_inputs_css___default.a,icon:__WEBPACK_IMPORTED_MODULE_2__assets_icons_icon_info_svg___default.a,helpText:'',highlightBox:true}),this.state.width<=685?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__charts_c_bar_chart__["a" /* default */],{data:totalsDataSet,icon:__WEBPACK_IMPORTED_MODULE_2__assets_icons_icon_info_svg___default.a,styles:__WEBPACK_IMPORTED_MODULE_1__inputs_inputs_css___default.a}):null,this.state.width<=685?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__charts_c_pie_chart__["a" /* default */],{data:this.state.pieDataSet,currency:currency,icon:__WEBPACK_IMPORTED_MODULE_2__assets_icons_icon_info_svg___default.a,styles:__WEBPACK_IMPORTED_MODULE_1__inputs_inputs_css___default.a}):null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1__inputs_inputs_css___default.a.footnote},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_24__i18n__["a" /* default */].translate('calculator:termsLine1',pathName)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_24__i18n__["a" /* default */].translate('calculator:termsLine2',pathName)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__step_by_step_step_by_step__["a" /* default */],{isOpen:this.state.showStepByStep,toggleStepByStep:function toggleStepByStep(){return _this5.toggleStepByStep();},handleUserInputChange:function handleUserInputChange(value,name){return _this5.handleUserInputChange(value,name);},calculatorState:this.state,onChangeColor:this.handlePrintColorPercentageChange,onChangeTextile:this.handleTextileColorPercentageChange}));}}]);return Calculator;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_25_react_router_dom__["c" /* withRouter */])(Calculator));

/***/ }),
/* 172 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"fullWidth":"ysjlZVMvdM2UEtoaq2OPe","inputWrapperContainer":"_3bLNVzD-eLOU_AzzH6tdxn","inputWrapperContainerInner":"_2ye-BOcaR0Vtvvslxg2Rgm","titleContainer":"g7GQuuH2HsZRYGHxquaQS","titleInner":"_1s9NLoDJqS9oChSKfLiFj_","inputWrapper":"_1m_ajcXAsiDG9T5sOoOYpo","inputColumn":"_2l5vyLmJfta29RQlTd8vbW","inputContainer":"_2AeyNyCCoFq8peqBRwbbS3","inputItem":"_1_im6OJ9t0cSDq5Zcpxz-k","containerRotate":"_2H2zS_gqO7B88OkD7Uotji","inputRowThree":"_1eyKsGSumnDE6BEyYyKQ9U","wide":"Nnwlgi9XMtI5Kqyhod5XG","full":"_1zd3EE3dZUSOXmqK1tJxgw","fullTotals":"_2mlr9-AxfNzrgdEd8Cjj9M","bottom":"_3jlUaUG4z6uRrsrh2Wfqbp","modulRegulator":"_2yr0f5vrCvS9YBHEHfniQz","row":"_22Xu1qIIaDUzq_UfhyDUxM","icon":"_2ZFE2wGVQ--piwGcoAXBz_","modulCalc":"_1CqROUue-QeGESKRU1mYF5","rowContainer":"_34gEcCDO4Jy7Tsl8snOU24","left":"_1ZA8qD0wlbaNL9KGqPelEI","right":"_20d3-WMm0zS8LwRq3gWd18","calc":"_25v8G7Y9Vj8MOfI1ouLc2w","inputItemCalc":"_3U8i1H32mk8PgeSCEoyHc8","totalsData":"_3rP8EyYNT898IEB-vnAnUp","positive":"_3vrVi5KO4UBpZNCavL2XvR","negative":"_3cuijENQlnufBeYt-t9joX","inputField":"_1j9GGA1tvkn5_VFg7Br31H","inputDropdown":"_3XVqqNDcAjUXq8ZT1dpm6I","inputColour":"_1G-75q1Lzwp6wPTVkyKeQZ","slider":"_3kETdfcsaxXQ8zUaA-ylxq","sliderData":"_1hWuxJlyomOAv1LHWcIyq-","info":"_1Pp80opL0L353XQ0eCcLkG","bottomRow":"wiLZz-4X-cJZkH3QpNWHt","btn":"_3siHMUe_Xcp_brYzeuvqsy","infoModal":"_1-KMEw8tQTukX7eKp9f2dt","infoModalActive":"OOsDeHKAksJ_JQvdqzHIe","show":"_3L6e6-pkP9j-MXlI4oXeT0","pieArea":"_2Wjl0yr_02fjrvinAKEHj2","pieParticluars":"eT89gkar_KWeIjY2yvC2R","pieInvestment":"_3vPSYNKdi2o2eS2TsytIDM","pieCosts":"_bEa_IFmYzPM4nBrJKqAX","pieDeckung":"KAQLZDYUCwmQRHP_Mabtc","pieNumber":"_1vsqDqozZFvQ7BRUIer25Y","pieTotals":"_3KSvjshWm3BA0E9KtAEHXx","modulRingdiagram":"_2lDtzz0Y4cqG2Nq2pOHGsE","twoColumn":"R2T7SCYD_pCBU2MJKBBju","oneColumn":"_10vxfsMRmmg9C3OMwNWEQn","dropdownContainer":"_2IsHM1fjrX6rnb68L3M1si","dropdownButton":"_3mkZRO2HddiygHFXEgrUiZ","dropdownButtonWidth":"_174NxOywd-oOI0P-RvMEPD","dropdownChoices":"_39URNnPQSxMObKgmSMNaKL","dropdownChoicesActive":"_1h6Gxm86GMFP1UzYHp8lCG","rightContainer":"_27HCoVpwNnRmuiRQgIlWhl","dropdownChoiceActive":"_2ip9pymWHCInm4KMAoZanY","rightInput":"_3vlJtcxQ3AfC0iSbs3LJX7","rightInfo":"_26GEI_WWBRtqblkaXwQcm3","reset":"_1QvoJx7uJ-PLPS-PROgwhN","inputButton":"_1NOWXGgP7DMtQfBjGYUqD4","helpButton":"_30vsety_RZe7bdJWhGPf7r","helpButtonContainer":"_2BkkkB1CpnMxVIBGweGMX9","helpOverlay":"_3b5XLEb3I5tFL4oHBNYNc7","helpOverlayContent":"AHnRYNv2Fxt_9RuAxuSvW","helpCloseButton":"_2ZERAnN2tXJtZlmBr3PSlT","helpContent":"_2xhHtvMu0R-oIoAB6WQHK5","highlight":"_2MDx2O06DuKz9q8LzcFKUi","footnote":"_1Y_N9SCQbkhCG3v10T6gcY","footnotetext":"_1CpP27HfHXe987mqVN3py7","stepbystepbutton":"_1p1Pc5a5E0gjAGmyc4PyqG"};

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_info.85c485ab.svg";

/***/ }),
/* 174 */
/***/ (function(module, exports) {

module.exports = [{"id":1,"name":"A3","width":29.7,"length":42,"size_qcm":1247.4},{"id":2,"name":"A4","width":21,"length":29.7,"size_qcm":623.7},{"id":3,"name":"A5","width":14.8,"length":21,"size_qcm":310.8},{"id":4,"name":"A6","width":10.5,"length":14.8,"size_qcm":155.4}]

/***/ }),
/* 175 */
/***/ (function(module, exports) {

module.exports = [{"id":1,"size":5,"name":5,"prices":[{"id":1,"price":170},{"id":3,"price":190.8}]},{"id":2,"size":20,"name":20,"prices":[{"id":1,"price":558},{"id":3,"price":630}]}]

/***/ }),
/* 176 */
/***/ (function(module, exports) {

module.exports = [{"id":1,"size":500,"name":500,"colors":[{"id":1,"name":"white","prices":[{"id":1,"price":160},{"id":3,"price":185}]},{"id":2,"name":"cmyk","prices":[{"id":1,"price":169},{"id":3,"price":196}]}]},{"id":2,"size":700,"name":700,"colors":[{"id":1,"name":"white","prices":[{"id":1,"price":175},{"id":3,"price":215.25}]},{"id":2,"name":"cmyk","prices":[{"id":1,"price":199},{"id":3,"price":244.8}]}]}]

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_icons_icon_close_svg__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_icons_icon_close_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_icons_icon_close_svg__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CurrencyDropdown=function(_Component){_inherits(CurrencyDropdown,_Component);function CurrencyDropdown(props){_classCallCheck(this,CurrencyDropdown);var _this=_possibleConstructorReturn(this,(CurrencyDropdown.__proto__||Object.getPrototypeOf(CurrencyDropdown)).call(this,props));_this.toggleDropdown=function(){var activeBool=_this.state.dropdownActive?false:true;_this.setState({dropdownActive:activeBool});};_this.handleInfoModal=function(){var infoModal=_this.refs.infoModal;var activeState=_this.state.infoActive;var section=_this.refs.section;if(infoModal!==undefined&&section!==undefined){if(activeState){infoModal.classList.remove(_this.props.styles.infoModalActive);section.classList.remove(_this.props.styles.containerRotate);_this.setState({infoActive:false});}else{infoModal.classList.add(_this.props.styles.infoModalActive);section.classList.add(_this.props.styles.containerRotate);_this.setState({infoActive:true,dropdownActive:false});}}};_this.handleChange=_this.handleChange.bind(_this);_this.state={infoActive:false,dropdownActive:false,selectedCurrency:_this.props.data[0]};return _this;}_createClass(CurrencyDropdown,[{key:'getCurrencyById',value:function getCurrencyById(eId){var selectedId=parseInt(eId,16);return this.props.data.filter(function(item){return item.id===selectedId;})[0];}},{key:'handleChange',value:function handleChange(e){var selectedCurrency=this.getCurrencyById(e);this.props.onChange(selectedCurrency);this.setState({dropdownActive:false,selectedCurrency:selectedCurrency});}},{key:'componentWillMount',value:function componentWillMount(){// set up first currency to display
this.props.onChange(this.props.data[0]);}},{key:'render',value:function render(){var _this2=this;var styles=this.props.styles;var currencyData=this.props.data;var activeDropdownStyle=this.state.dropdownActive?styles.dropdownChoicesActive:null;var listOptions=currencyData.map(function(item){var activeClass=_this2.state.selectedCurrency.id===item.id?styles.dropdownChoiceActive:null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:item.id,className:activeClass,onClick:function onClick(){return _this2.handleChange(item.id);}},item.symbol);});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{ref:'section',className:styles.inputItem},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:styles.info},this.props.helpText&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:this.props.icon,alt:'Info',onMouseDown:this.handleInfoModal}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:styles.infoModal,ref:'infoModal',onMouseDown:this.handleInfoModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,this.props.description),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,this.props.helpText),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_2__assets_icons_icon_close_svg___default.a,alt:'Info',onMouseDown:this.handleInfoModal})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:styles.dropdownContainer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:styles.dropdownButton,onClick:function onClick(){return _this2.toggleDropdown();}},this.state.selectedCurrency.symbol),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:__WEBPACK_IMPORTED_MODULE_1_classnames___default()([styles.dropdownChoices,activeDropdownStyle])},listOptions)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.props.unitInfo),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:styles.bottom},this.props.description));}}]);return CurrencyDropdown;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (CurrencyDropdown);

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__c_readonly_input__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__i18n__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var OverviewGroup=function(_Component){_inherits(OverviewGroup,_Component);function OverviewGroup(){_classCallCheck(this,OverviewGroup);return _possibleConstructorReturn(this,(OverviewGroup.__proto__||Object.getPrototypeOf(OverviewGroup)).apply(this,arguments));}_createClass(OverviewGroup,[{key:'render',value:function render(){var styles=this.props.styles;var infoIcon=this.props.icon;var currency=this.props.currency;var deviceData=this.props.deviceData;var inkData=this.props.inkData;var ink=this.props.ink;var gtxPrinter=deviceData.filter(function(item){return item.id===1;})[0];var transferPress=deviceData.filter(function(item){return item.id===2;})[0];var pretreatMaker=deviceData.filter(function(item){return item.id===3;})[0];var pretreatMakerLine=deviceData.filter(function(item){return item.id===4;})[0];var dryer=deviceData.filter(function(item){return item.id===5;})[0];var inkWhite=inkData.filter(function(item){return item.id===1;})[0];var inkCmyk=inkData.filter(function(item){return item.id===2;})[0];var helpTextCMYK='Hier erfahren Sie die Tintenkosten (CMYK) pro '+ink.name+' ml.';var helpTextWhite='Hier erfahren Sie die Tintenkosten (wei\xDF) pro '+ink.name+' ml.';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,gtxPrinter!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__c_readonly_input__["a" /* default */],{value:gtxPrinter.qty>0?gtxPrinter.unit_price:0,description:__WEBPACK_IMPORTED_MODULE_2__i18n__["a" /* default */].translate('calculator:'+gtxPrinter.localeName,this.props.location.pathname),styles:styles,icon:infoIcon,fullWidth:'true',currency:currency,helpText:'Hier erfahren Sie die Kosten f\xFCr den GTX Printer.'}),pretreatMaker!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__c_readonly_input__["a" /* default */],{value:pretreatMaker.qty>0?pretreatMaker.unit_price:0,description:__WEBPACK_IMPORTED_MODULE_2__i18n__["a" /* default */].translate('calculator:'+pretreatMaker.localeName,this.props.location.pathname),styles:styles,icon:infoIcon,currency:currency,helpText:'Hier erfahren Sie die Pretreatmakerkosten.'}),transferPress!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__c_readonly_input__["a" /* default */],{value:transferPress.qty>0?transferPress.unit_price:0,description:__WEBPACK_IMPORTED_MODULE_2__i18n__["a" /* default */].translate('calculator:'+transferPress.localeName,this.props.location.pathname),styles:styles,icon:infoIcon,currency:currency,helpText:'Hier erfahren Sie die Transferpressekosten.'}),inkCmyk!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__c_readonly_input__["a" /* default */],{value:inkCmyk.price,unitInfo:ink.name+"ml",description:__WEBPACK_IMPORTED_MODULE_2__i18n__["a" /* default */].translate('calculator:inkCMYK',this.props.location.pathname),styles:styles,icon:infoIcon,currency:currency,helpText:helpTextCMYK}),pretreatMakerLine!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__c_readonly_input__["a" /* default */],{value:pretreatMakerLine.qty>0?pretreatMakerLine.unit_price:0,description:__WEBPACK_IMPORTED_MODULE_2__i18n__["a" /* default */].translate('calculator:'+pretreatMakerLine.localeName,this.props.location.pathname),styles:styles,icon:infoIcon,currency:currency,helpText:'Hier erfahren Sie die Pretreatmaker LINE Kosten.'}),dryer!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__c_readonly_input__["a" /* default */],{value:dryer.qty>0?dryer.unit_price:0,description:__WEBPACK_IMPORTED_MODULE_2__i18n__["a" /* default */].translate('calculator:'+dryer.localeName,this.props.location.pathname),styles:styles,icon:infoIcon,currency:currency,helpText:'Hier erfahren Sie die Tunneltrocknerkosten.'}),inkWhite!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__c_readonly_input__["a" /* default */],{value:inkWhite.price,unitInfo:ink.name+"ml",description:__WEBPACK_IMPORTED_MODULE_2__i18n__["a" /* default */].translate('calculator:inkWhite',this.props.location.pathname),styles:styles,icon:infoIcon,currency:currency,helpText:helpTextWhite}));}}]);return OverviewGroup;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* withRouter */])(OverviewGroup));

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__c_slider_druckfarbe__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__c_slider_textil__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_icons_ICN_Druck_small_svg__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_icons_ICN_Druck_small_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_icons_ICN_Druck_small_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_icons_ICN_Textil_small_svg__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_icons_ICN_Textil_small_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_icons_ICN_Textil_small_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__i18n__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_dom__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var classNames=__webpack_require__(7);var SliderGroup=function(_Component){_inherits(SliderGroup,_Component);function SliderGroup(props){_classCallCheck(this,SliderGroup);var _this=_possibleConstructorReturn(this,(SliderGroup.__proto__||Object.getPrototypeOf(SliderGroup)).call(this,props));_this.handleChangeColor=_this.handleChangeColor.bind(_this);_this.handleChangeTextile=_this.handleChangeTextile.bind(_this);return _this;}_createClass(SliderGroup,[{key:'handleChangeColor',value:function handleChangeColor(selected){this.props.onChangeColor(selected);}},{key:'handleChangeTextile',value:function handleChangeTextile(selected){this.props.onChangeTextile(selected);}},{key:'render',value:function render(){var styles=this.props.styles;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classNames(styles.inputItem,styles.modulRegulator)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__c_slider_druckfarbe__["a" /* default */],{styles:styles,onChange:this.handleChangeColor,name:'druck',defaultValue:this.props.printColorPercentage,textilePercentage:this.props.textileColorPercentage,label:__WEBPACK_IMPORTED_MODULE_5__i18n__["a" /* default */].translate('calculator:printColor',this.props.location.pathname),white:__WEBPACK_IMPORTED_MODULE_5__i18n__["a" /* default */].translate('calculator:white',this.props.location.pathname),showPercentage:'true',icon:__WEBPACK_IMPORTED_MODULE_3__assets_icons_ICN_Druck_small_svg___default.a}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__c_slider_textil__["a" /* default */],{styles:styles,onChange:this.handleChangeTextile,name:'textile',defaultValue:this.props.textileColorPercentage,label:__WEBPACK_IMPORTED_MODULE_5__i18n__["a" /* default */].translate('calculator:textileColor',this.props.location.pathname),white:__WEBPACK_IMPORTED_MODULE_5__i18n__["a" /* default */].translate('calculator:white',this.props.location.pathname),colourful:__WEBPACK_IMPORTED_MODULE_5__i18n__["a" /* default */].translate('calculator:colourful',this.props.location.pathname),dark:__WEBPACK_IMPORTED_MODULE_5__i18n__["a" /* default */].translate('calculator:dark',this.props.location.pathname),showPercentage:'true',icon:__WEBPACK_IMPORTED_MODULE_4__assets_icons_ICN_Textil_small_svg___default.a}));}}]);return SliderGroup;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_react_router_dom__["c" /* withRouter */])(SliderGroup));

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SimpleSliderDruckfarbe=function(_Component){_inherits(SimpleSliderDruckfarbe,_Component);function SimpleSliderDruckfarbe(props){_classCallCheck(this,SimpleSliderDruckfarbe);var _this=_possibleConstructorReturn(this,(SimpleSliderDruckfarbe.__proto__||Object.getPrototypeOf(SimpleSliderDruckfarbe)).call(this,props));_this.setLabels=function(value){if(value<=0&&!_this.state.overrideLabels){_this.setState({leftLabel:_this.props.white});}else if(value>0&&value<100&&_this.state.leftLabel!==_this.props.white+"+cmyk"&&!_this.state.overrideLabels){_this.setState({leftLabel:_this.props.white+"+cmyk"});}if(_this.state.rightLabel!=="cmyk"&&!_this.state.overrideLabels){_this.setState({rightLabel:"cmyk"});}};_this.componentDidMount=function(){var value=_this.props.defaultValue;_this.props.onChange(value);};_this.componentDidUpdate=function(){if(_this.props.textilePercentage>=51&&!_this.state.overrideLabels){_this.setState({overrideLabels:true},function(){_this.setState({rightLabel:"cmyk+"+_this.props.white,leftLabel:""+_this.props.white});});}else if(_this.props.textilePercentage<=50&&_this.state.overrideLabels){_this.setState({overrideLabels:false},function(){_this.setLabels(_this.props.defaultValue);});}else if(_this.props.textilePercentage<=50&&!_this.state.overrideLabels&&_this.state.leftLabel!==""+_this.props.white){_this.setLabels(_this.props.defaultValue);}else if(_this.props.textilePercentage<=50&&!_this.state.overrideLabels&&_this.props.defaultValue>0&&_this.state.leftLabel!==_this.props.white+"+cmyk"){_this.setLabels(_this.props.defaultValue);}};_this.handleChange=_this.handleChange.bind(_this);_this.state={valueLeft:0,valueRight:0,leftLabel:_this.props.white+"+cmyk",rightLabel:"cmyk",overrideLabels:false};_this.transformed=false;return _this;}_createClass(SimpleSliderDruckfarbe,[{key:"handleChange",value:function handleChange(e){var value=e.target.value;this.props.onChange(value);this.setLabels(value);}},{key:"render",value:function render(){var styles=this.props.styles;var icon=this.props.icon;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:styles.row},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:styles.icon},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:icon,alt:""})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:styles.slider},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("aside",{className:styles.sliderData},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,100-this.props.defaultValue,this.props.showPercentage&&"%"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,this.props.defaultValue,this.props.showPercentage&&"%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{onChange:this.handleChange,type:"range",name:this.props.name,value:this.props.defaultValue,max:"100",min:"0",step:"1"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("aside",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,this.state.leftLabel),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:styles.bottom},this.props.label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,this.state.rightLabel)))));}}]);return SimpleSliderDruckfarbe;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (SimpleSliderDruckfarbe);

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SimpleSliderTextil=function(_Component){_inherits(SimpleSliderTextil,_Component);function SimpleSliderTextil(props){_classCallCheck(this,SimpleSliderTextil);var _this=_possibleConstructorReturn(this,(SimpleSliderTextil.__proto__||Object.getPrototypeOf(SimpleSliderTextil)).call(this,props));_this.setLabels=function(value){if(value>50&&_this.state.rightLabel!==_this.props.dark){_this.setState({rightLabel:_this.props.dark});}else if(value<=50&&_this.state.rightLabel!==_this.props.colourful){_this.setState({rightLabel:_this.props.colourful});}};_this.componentDidMount=function(){var value=_this.props.defaultValue;_this.props.onChange(value);_this.setLabels(value);};_this.componentDidUpdate=function(){_this.setLabels(_this.props.defaultValue);};_this.handleChange=_this.handleChange.bind(_this);_this.state={valueLeft:0,valueRight:0,leftLabel:_this.props.white,rightLabel:_this.props.colourful};_this.transformed=false;return _this;}_createClass(SimpleSliderTextil,[{key:"handleChange",value:function handleChange(e){var value=e.target.value;this.props.onChange(value);this.setLabels(value);}},{key:"render",value:function render(){var styles=this.props.styles;var icon=this.props.icon;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:styles.row},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:styles.icon},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:icon,alt:""})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:styles.slider},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("aside",{className:styles.sliderData},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,100-this.props.defaultValue,this.props.showPercentage&&"%"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,this.props.defaultValue,this.props.showPercentage&&"%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{onChange:this.handleChange,type:"range",name:this.props.name,value:this.props.defaultValue,max:"100",min:"0",step:"1"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("aside",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,this.props.white),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:styles.bottom},this.props.label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,this.state.rightLabel)))));}}]);return SimpleSliderTextil;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (SimpleSliderTextil);

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ICN_Druck_small.ce71823e.svg";

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ICN_Textil_small.fbcab56e.svg";

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__c_dropdown_row__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__i18n__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var classNames=__webpack_require__(7);var DropdownGroup=function(_Component){_inherits(DropdownGroup,_Component);function DropdownGroup(props){_classCallCheck(this,DropdownGroup);var _this=_possibleConstructorReturn(this,(DropdownGroup.__proto__||Object.getPrototypeOf(DropdownGroup)).call(this,props));_this.handleChangeInk=_this.handleChangeInk.bind(_this);_this.handleChangePretreatment=_this.handleChangePretreatment.bind(_this);_this.handleChangeDin=_this.handleChangeDin.bind(_this);return _this;}_createClass(DropdownGroup,[{key:'handleChangeInk',value:function handleChangeInk(selected){this.props.onChangeInk(selected);}},{key:'handleChangePretreatment',value:function handleChangePretreatment(selected){this.props.onChangePretreatment(selected);}},{key:'handleChangeDin',value:function handleChangeDin(selected){this.props.onChangeDin(selected);}},{key:'render',value:function render(){var styles=this.props.styles;var pretreatment_data=this.props.pretreatmentData;var selectedPretreatment=this.props.pretreatment;var din_data=this.props.dinData;var selectedDin=this.props.din;var ink_data=this.props.inkData;var selectedInk=this.props.ink;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classNames(styles.inputItem,styles.modulCalc)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__c_dropdown_row__["a" /* default */],{styles:styles,data:ink_data,onChange:this.handleChangeInk,description:__WEBPACK_IMPORTED_MODULE_2__i18n__["a" /* default */].translate('calculator:inkPack',this.props.location.pathname),unitInfo:'ml',name:'inkQty',selected:selectedInk}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__c_dropdown_row__["a" /* default */],{styles:styles,data:pretreatment_data,onChange:this.handleChangePretreatment,description:__WEBPACK_IMPORTED_MODULE_2__i18n__["a" /* default */].translate('calculator:pretreatPack',this.props.location.pathname),unitInfo:'kg',name:'pretreatment',selected:selectedPretreatment}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__c_dropdown_row__["a" /* default */],{styles:styles,data:din_data,onChange:this.handleChangeDin,description:__WEBPACK_IMPORTED_MODULE_2__i18n__["a" /* default */].translate('calculator:printArea',this.props.location.pathname),unitInfo:'DIN',name:'din',selected:selectedDin,preselect:'2',footnoteText:__WEBPACK_IMPORTED_MODULE_2__i18n__["a" /* default */].translate('calculator:printFormatText',this.props.location.pathname)}));}}]);return DropdownGroup;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* withRouter */])(DropdownGroup));

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var classNames=__webpack_require__(7);var DropdownRow=function(_Component){_inherits(DropdownRow,_Component);function DropdownRow(props){_classCallCheck(this,DropdownRow);var _this=_possibleConstructorReturn(this,(DropdownRow.__proto__||Object.getPrototypeOf(DropdownRow)).call(this,props));_this.toggleDropdown=function(){var activeBool=_this.state.dropdownActive?false:true;_this.setState({dropdownActive:activeBool});};_this.returnFootnoteText=function(text){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:_this.props.styles.footnotetext},text);};_this.handleChange=_this.handleChange.bind(_this);_this.state={dropdownActive:false};return _this;}_createClass(DropdownRow,[{key:'getById',value:function getById(eId){var selectedId=parseInt(eId,16);return this.props.data.filter(function(item){return item.id===selectedId;})[0];}},{key:'handleChange',value:function handleChange(e){var selected=this.getById(e);this.props.onChange(selected);this.setState({dropdownActive:false});}},{key:'componentWillMount',value:function componentWillMount(){// set up first item in the list
var preselected=this.props.preselect?this.props.preselect:0;this.props.onChange(this.props.data[preselected]);}},{key:'render',value:function render(){var _this2=this;var styles=this.props.styles;var data=this.props.data;var selectedItem=this.props.selected;var activeDropdownStyle=this.state.dropdownActive?styles.dropdownChoicesActive:null;var listOptions=data.map(function(item){var activeClass=item.id===selectedItem.id?styles.dropdownChoiceActive:null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:item.id,className:activeClass,onClick:function onClick(){return _this2.handleChange(item.id);}},item.name);});var footnoteText=this.props.footnoteText?this.returnFootnoteText(this.props.footnoteText):null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:styles.rowContainer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:styles.row},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:styles.left},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:classNames(styles.bottom,styles.bottomRow)},this.props.description),footnoteText),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:styles.rightContainer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:styles.rightInput},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:styles.dropdownContainer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:classNames(styles.dropdownButton,styles.dropdownButtonWidth),onClick:function onClick(){return _this2.toggleDropdown();}},selectedItem.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:classNames([styles.dropdownChoices,activeDropdownStyle])},listOptions))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:styles.rightInfo},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.props.unitInfo)))));}}]);return DropdownRow;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (DropdownRow);

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_icons_icon_close_svg__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_icons_icon_close_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_icons_icon_close_svg__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var classNames=__webpack_require__(7);var UserInput=function(_Component){_inherits(UserInput,_Component);function UserInput(props){_classCallCheck(this,UserInput);var _this=_possibleConstructorReturn(this,(UserInput.__proto__||Object.getPrototypeOf(UserInput)).call(this,props));_this.handleInfoModal=function(){var infoModal=_this.refs.infoModal;var activeState=_this.state.infoActive;var section=_this.refs.section;if(infoModal!==undefined&&section!==undefined){if(activeState){infoModal.classList.remove(_this.props.styles.infoModalActive);section.classList.remove(_this.props.styles.containerRotate);_this.setState({infoActive:false});}else{infoModal.classList.add(_this.props.styles.infoModalActive);section.classList.add(_this.props.styles.containerRotate);_this.setState({infoActive:true});}}};_this.handleChange=_this.handleChange.bind(_this);_this.state={infoActive:false};return _this;}_createClass(UserInput,[{key:'handleChange',value:function handleChange(e){var value=e.target.value;if(value===''){value=0;}var name=this.props.name;this.props.onChange(value,name);}},{key:'componentWillMount',value:function componentWillMount(){this.props.onChange(this.props.value,this.props.name);}},{key:'render',value:function render(){var styles=this.props.styles;var separator=this.props.currency!==undefined&&this.props.unitInfo?" / ":"";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{ref:'section',className:classNames(styles.inputItem,styles.inputColour)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:styles.info},this.props.helpText&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:this.props.icon,alt:'Info',onMouseDown:this.handleInfoModal}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:styles.infoModal,ref:'infoModal',onMouseDown:this.handleInfoModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,this.props.description),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,this.props.helpText),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__assets_icons_icon_close_svg___default.a,alt:'Info',onMouseDown:this.handleInfoModal})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:styles.inputField,type:'number'//defaultValue={parseFloat(this.props.value).toFixed(2)}
,value:this.props.value,name:this.props.name,onChange:this.handleChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.props.currency!==undefined&&this.props.currency.symbol,' ',separator,' ',this.props.unitInfo),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:styles.bottom},this.props.description));}}]);return UserInput;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (UserInput);

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_icons_icon_close_svg__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_icons_icon_close_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_icons_icon_close_svg__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ScenarioDropdown=function(_Component){_inherits(ScenarioDropdown,_Component);function ScenarioDropdown(props){_classCallCheck(this,ScenarioDropdown);var _this=_possibleConstructorReturn(this,(ScenarioDropdown.__proto__||Object.getPrototypeOf(ScenarioDropdown)).call(this,props));_this.handleInfoModal=function(){var infoModal=_this.refs.infoModal;var activeState=_this.state.infoActive;var section=_this.refs.section;if(infoModal!==undefined&&section!==undefined){if(activeState){infoModal.classList.remove(_this.props.styles.infoModalActive);section.classList.remove(_this.props.styles.containerRotate);_this.setState({infoActive:false});}else{infoModal.classList.add(_this.props.styles.infoModalActive);section.classList.add(_this.props.styles.containerRotate);_this.setState({infoActive:true,dropdownActive:false});}}};_this.toggleDropdown=function(){var activeBool=_this.state.dropdownActive?false:true;_this.setState({dropdownActive:activeBool});};_this.handleChange=_this.handleChange.bind(_this);_this.state={infoActive:false,dropdownActive:false};return _this;}_createClass(ScenarioDropdown,[{key:'getScenarioById',value:function getScenarioById(eId){var selectedId=parseInt(eId,16);return this.props.data.filter(function(item){return item.id===selectedId;})[0];}},{key:'handleChange',value:function handleChange(e){var selectedScenario=this.getScenarioById(e);this.props.onChange(selectedScenario);this.setState({dropdownActive:false});}},{key:'componentWillMount',value:function componentWillMount(){// set up first item in the list
this.props.onChange(this.props.data[0]);}},{key:'render',value:function render(){var _this2=this;var styles=this.props.styles;var data=this.props.data;var selectedItem=this.props.selected;var activeDropdownStyle=this.state.dropdownActive?styles.dropdownChoicesActive:null;var listOptions=data.map(function(scenario){var activeClass=scenario.id===selectedItem.id?styles.dropdownChoiceActive:null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:scenario.id,className:activeClass,onClick:function onClick(){return _this2.handleChange(scenario.id);}},scenario.short_name);});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{ref:'section',className:styles.inputItem},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:styles.info},this.props.helpText&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:this.props.icon,alt:'Info',onMouseDown:this.handleInfoModal}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:styles.infoModal,ref:'infoModal',onMouseDown:this.handleInfoModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,this.props.description),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,this.props.helpText),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_2__assets_icons_icon_close_svg___default.a,alt:'Info',onMouseDown:this.handleInfoModal})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:styles.dropdownContainer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:styles.dropdownButton,onClick:function onClick(){return _this2.toggleDropdown();}},selectedItem.short_name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:__WEBPACK_IMPORTED_MODULE_1_classnames___default()([styles.dropdownChoices,activeDropdownStyle])},listOptions)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.props.unitInfo),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:styles.bottom},this.props.description));}}]);return ScenarioDropdown;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ScenarioDropdown);

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_chartjs_2__ = __webpack_require__(73);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var classNames=__webpack_require__(7);var BarChart=function(_Component){_inherits(BarChart,_Component);function BarChart(){_classCallCheck(this,BarChart);return _possibleConstructorReturn(this,(BarChart.__proto__||Object.getPrototypeOf(BarChart)).apply(this,arguments));}_createClass(BarChart,[{key:'render',value:function render(){var styles=this.props.styles;var data=this.props.data;var monthArray=[];var totalsArray=[];for(var index=0;index<data.length;index++){monthArray.push("Monat "+data[index].month);totalsArray.push(data[index].sum);}var colors=totalsArray.map(function(value){return value<0?'#0D2EA0':'rgba(125,156,94,1)';});var testData={labels:monthArray,datasets:[{data:totalsArray,barThickness:8,borderColor:colors,backgroundColor:colors}]};var chartOptions={legend:{display:false},scales:{xAxes:[{display:false}],yAxes:[{display:false}]},datasets:[{barThickness:8}]};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classNames(styles.inputItem,styles.modulGraph)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_chartjs_2__["a" /* Bar */],{data:testData,options:chartOptions,height:171})));}}]);return BarChart;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (BarChart);

/***/ }),
/* 189 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * @namespace Chart
 */
var Chart = __webpack_require__(191)();

Chart.helpers = __webpack_require__(1);

// @todo dispatch these helpers into appropriated helpers/helpers.* file and write unit tests!
__webpack_require__(195)(Chart);

Chart.defaults = __webpack_require__(2);
Chart.Element = __webpack_require__(8);
Chart.elements = __webpack_require__(13);
Chart.Interaction = __webpack_require__(75);
Chart.layouts = __webpack_require__(21);
Chart.platform = __webpack_require__(76);
Chart.plugins = __webpack_require__(77);
Chart.Ticks = __webpack_require__(22);

__webpack_require__(206)(Chart);
__webpack_require__(207)(Chart);
__webpack_require__(208)(Chart);
__webpack_require__(209)(Chart);
__webpack_require__(210)(Chart);
__webpack_require__(211)(Chart);

__webpack_require__(212)(Chart);
__webpack_require__(213)(Chart);
__webpack_require__(214)(Chart);
__webpack_require__(215)(Chart);
__webpack_require__(216)(Chart);
__webpack_require__(217)(Chart);

// Controllers must be loaded after elements
// See Chart.core.datasetController.dataElementType
__webpack_require__(219)(Chart);
__webpack_require__(220)(Chart);
__webpack_require__(221)(Chart);
__webpack_require__(222)(Chart);
__webpack_require__(223)(Chart);
__webpack_require__(224)(Chart);
__webpack_require__(225)(Chart);

__webpack_require__(226)(Chart);
__webpack_require__(227)(Chart);
__webpack_require__(228)(Chart);
__webpack_require__(229)(Chart);
__webpack_require__(230)(Chart);
__webpack_require__(231)(Chart);
__webpack_require__(232)(Chart);

// Loading built-it plugins
var plugins = __webpack_require__(233);
for (var k in plugins) {
	if (plugins.hasOwnProperty(k)) {
		Chart.plugins.register(plugins[k]);
	}
}

Chart.platform.initialize();

module.exports = Chart;
if (typeof window !== 'undefined') {
	window.Chart = Chart;
}

// DEPRECATIONS

/**
 * Provided for backward compatibility, not available anymore
 * @namespace Chart.Legend
 * @deprecated since version 2.1.5
 * @todo remove at version 3
 * @private
 */
Chart.Legend = plugins.legend._element;

/**
 * Provided for backward compatibility, not available anymore
 * @namespace Chart.Title
 * @deprecated since version 2.1.5
 * @todo remove at version 3
 * @private
 */
Chart.Title = plugins.title._element;

/**
 * Provided for backward compatibility, use Chart.plugins instead
 * @namespace Chart.pluginService
 * @deprecated since version 2.1.5
 * @todo remove at version 3
 * @private
 */
Chart.pluginService = Chart.plugins;

/**
 * Provided for backward compatibility, inheriting from Chart.PlugingBase has no
 * effect, instead simply create/register plugins via plain JavaScript objects.
 * @interface Chart.PluginBase
 * @deprecated since version 2.5.0
 * @todo remove at version 3
 * @private
 */
Chart.PluginBase = Chart.Element.extend({});

/**
 * Provided for backward compatibility, use Chart.helpers.canvas instead.
 * @namespace Chart.canvasHelpers
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 * @private
 */
Chart.canvasHelpers = Chart.helpers.canvas;

/**
 * Provided for backward compatibility, use Chart.layouts instead.
 * @namespace Chart.layoutService
 * @deprecated since version 2.8.0
 * @todo remove at version 3
 * @private
 */
Chart.layoutService = Chart.layouts;


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(2);

defaults._set('global', {
	responsive: true,
	responsiveAnimationDuration: 0,
	maintainAspectRatio: true,
	events: ['mousemove', 'mouseout', 'click', 'touchstart', 'touchmove'],
	hover: {
		onHover: null,
		mode: 'nearest',
		intersect: true,
		animationDuration: 400
	},
	onClick: null,
	defaultColor: 'rgba(0,0,0,0.1)',
	defaultFontColor: '#666',
	defaultFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
	defaultFontSize: 12,
	defaultFontStyle: 'normal',
	showLines: true,

	// Element defaults defined in element extensions
	elements: {},

	// Layout options such as padding
	layout: {
		padding: {
			top: 0,
			right: 0,
			bottom: 0,
			left: 0
		}
	}
});

module.exports = function() {

	// Occupy the global variable of Chart, and create a simple base class
	var Chart = function(item, config) {
		this.construct(item, config);
		return this;
	};

	Chart.Chart = Chart;

	return Chart;
};


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var helpers = __webpack_require__(33);

/**
 * Easing functions adapted from Robert Penner's easing equations.
 * @namespace Chart.helpers.easingEffects
 * @see http://www.robertpenner.com/easing/
 */
var effects = {
	linear: function(t) {
		return t;
	},

	easeInQuad: function(t) {
		return t * t;
	},

	easeOutQuad: function(t) {
		return -t * (t - 2);
	},

	easeInOutQuad: function(t) {
		if ((t /= 0.5) < 1) {
			return 0.5 * t * t;
		}
		return -0.5 * ((--t) * (t - 2) - 1);
	},

	easeInCubic: function(t) {
		return t * t * t;
	},

	easeOutCubic: function(t) {
		return (t = t - 1) * t * t + 1;
	},

	easeInOutCubic: function(t) {
		if ((t /= 0.5) < 1) {
			return 0.5 * t * t * t;
		}
		return 0.5 * ((t -= 2) * t * t + 2);
	},

	easeInQuart: function(t) {
		return t * t * t * t;
	},

	easeOutQuart: function(t) {
		return -((t = t - 1) * t * t * t - 1);
	},

	easeInOutQuart: function(t) {
		if ((t /= 0.5) < 1) {
			return 0.5 * t * t * t * t;
		}
		return -0.5 * ((t -= 2) * t * t * t - 2);
	},

	easeInQuint: function(t) {
		return t * t * t * t * t;
	},

	easeOutQuint: function(t) {
		return (t = t - 1) * t * t * t * t + 1;
	},

	easeInOutQuint: function(t) {
		if ((t /= 0.5) < 1) {
			return 0.5 * t * t * t * t * t;
		}
		return 0.5 * ((t -= 2) * t * t * t * t + 2);
	},

	easeInSine: function(t) {
		return -Math.cos(t * (Math.PI / 2)) + 1;
	},

	easeOutSine: function(t) {
		return Math.sin(t * (Math.PI / 2));
	},

	easeInOutSine: function(t) {
		return -0.5 * (Math.cos(Math.PI * t) - 1);
	},

	easeInExpo: function(t) {
		return (t === 0) ? 0 : Math.pow(2, 10 * (t - 1));
	},

	easeOutExpo: function(t) {
		return (t === 1) ? 1 : -Math.pow(2, -10 * t) + 1;
	},

	easeInOutExpo: function(t) {
		if (t === 0) {
			return 0;
		}
		if (t === 1) {
			return 1;
		}
		if ((t /= 0.5) < 1) {
			return 0.5 * Math.pow(2, 10 * (t - 1));
		}
		return 0.5 * (-Math.pow(2, -10 * --t) + 2);
	},

	easeInCirc: function(t) {
		if (t >= 1) {
			return t;
		}
		return -(Math.sqrt(1 - t * t) - 1);
	},

	easeOutCirc: function(t) {
		return Math.sqrt(1 - (t = t - 1) * t);
	},

	easeInOutCirc: function(t) {
		if ((t /= 0.5) < 1) {
			return -0.5 * (Math.sqrt(1 - t * t) - 1);
		}
		return 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1);
	},

	easeInElastic: function(t) {
		var s = 1.70158;
		var p = 0;
		var a = 1;
		if (t === 0) {
			return 0;
		}
		if (t === 1) {
			return 1;
		}
		if (!p) {
			p = 0.3;
		}
		if (a < 1) {
			a = 1;
			s = p / 4;
		} else {
			s = p / (2 * Math.PI) * Math.asin(1 / a);
		}
		return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
	},

	easeOutElastic: function(t) {
		var s = 1.70158;
		var p = 0;
		var a = 1;
		if (t === 0) {
			return 0;
		}
		if (t === 1) {
			return 1;
		}
		if (!p) {
			p = 0.3;
		}
		if (a < 1) {
			a = 1;
			s = p / 4;
		} else {
			s = p / (2 * Math.PI) * Math.asin(1 / a);
		}
		return a * Math.pow(2, -10 * t) * Math.sin((t - s) * (2 * Math.PI) / p) + 1;
	},

	easeInOutElastic: function(t) {
		var s = 1.70158;
		var p = 0;
		var a = 1;
		if (t === 0) {
			return 0;
		}
		if ((t /= 0.5) === 2) {
			return 1;
		}
		if (!p) {
			p = 0.45;
		}
		if (a < 1) {
			a = 1;
			s = p / 4;
		} else {
			s = p / (2 * Math.PI) * Math.asin(1 / a);
		}
		if (t < 1) {
			return -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
		}
		return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p) * 0.5 + 1;
	},
	easeInBack: function(t) {
		var s = 1.70158;
		return t * t * ((s + 1) * t - s);
	},

	easeOutBack: function(t) {
		var s = 1.70158;
		return (t = t - 1) * t * ((s + 1) * t + s) + 1;
	},

	easeInOutBack: function(t) {
		var s = 1.70158;
		if ((t /= 0.5) < 1) {
			return 0.5 * (t * t * (((s *= (1.525)) + 1) * t - s));
		}
		return 0.5 * ((t -= 2) * t * (((s *= (1.525)) + 1) * t + s) + 2);
	},

	easeInBounce: function(t) {
		return 1 - effects.easeOutBounce(1 - t);
	},

	easeOutBounce: function(t) {
		if (t < (1 / 2.75)) {
			return 7.5625 * t * t;
		}
		if (t < (2 / 2.75)) {
			return 7.5625 * (t -= (1.5 / 2.75)) * t + 0.75;
		}
		if (t < (2.5 / 2.75)) {
			return 7.5625 * (t -= (2.25 / 2.75)) * t + 0.9375;
		}
		return 7.5625 * (t -= (2.625 / 2.75)) * t + 0.984375;
	},

	easeInOutBounce: function(t) {
		if (t < 0.5) {
			return effects.easeInBounce(t * 2) * 0.5;
		}
		return effects.easeOutBounce(t * 2 - 1) * 0.5 + 0.5;
	}
};

module.exports = {
	effects: effects
};

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart.helpers.easing.effects instead.
 * @function Chart.helpers.easingEffects
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.easingEffects = effects;


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var helpers = __webpack_require__(33);

/**
 * @namespace Chart.helpers.canvas
 */
var exports = module.exports = {
	/**
	 * Clears the entire canvas associated to the given `chart`.
	 * @param {Chart} chart - The chart for which to clear the canvas.
	 */
	clear: function(chart) {
		chart.ctx.clearRect(0, 0, chart.width, chart.height);
	},

	/**
	 * Creates a "path" for a rectangle with rounded corners at position (x, y) with a
	 * given size (width, height) and the same `radius` for all corners.
	 * @param {CanvasRenderingContext2D} ctx - The canvas 2D Context.
	 * @param {Number} x - The x axis of the coordinate for the rectangle starting point.
	 * @param {Number} y - The y axis of the coordinate for the rectangle starting point.
	 * @param {Number} width - The rectangle's width.
	 * @param {Number} height - The rectangle's height.
	 * @param {Number} radius - The rounded amount (in pixels) for the four corners.
	 * @todo handle `radius` as top-left, top-right, bottom-right, bottom-left array/object?
	 */
	roundedRect: function(ctx, x, y, width, height, radius) {
		if (radius) {
			var rx = Math.min(radius, width / 2);
			var ry = Math.min(radius, height / 2);

			ctx.moveTo(x + rx, y);
			ctx.lineTo(x + width - rx, y);
			ctx.quadraticCurveTo(x + width, y, x + width, y + ry);
			ctx.lineTo(x + width, y + height - ry);
			ctx.quadraticCurveTo(x + width, y + height, x + width - rx, y + height);
			ctx.lineTo(x + rx, y + height);
			ctx.quadraticCurveTo(x, y + height, x, y + height - ry);
			ctx.lineTo(x, y + ry);
			ctx.quadraticCurveTo(x, y, x + rx, y);
		} else {
			ctx.rect(x, y, width, height);
		}
	},

	drawPoint: function(ctx, style, radius, x, y) {
		var type, edgeLength, xOffset, yOffset, height, size;

		if (style && typeof style === 'object') {
			type = style.toString();
			if (type === '[object HTMLImageElement]' || type === '[object HTMLCanvasElement]') {
				ctx.drawImage(style, x - style.width / 2, y - style.height / 2, style.width, style.height);
				return;
			}
		}

		if (isNaN(radius) || radius <= 0) {
			return;
		}

		switch (style) {
		// Default includes circle
		default:
			ctx.beginPath();
			ctx.arc(x, y, radius, 0, Math.PI * 2);
			ctx.closePath();
			ctx.fill();
			break;
		case 'triangle':
			ctx.beginPath();
			edgeLength = 3 * radius / Math.sqrt(3);
			height = edgeLength * Math.sqrt(3) / 2;
			ctx.moveTo(x - edgeLength / 2, y + height / 3);
			ctx.lineTo(x + edgeLength / 2, y + height / 3);
			ctx.lineTo(x, y - 2 * height / 3);
			ctx.closePath();
			ctx.fill();
			break;
		case 'rect':
			size = 1 / Math.SQRT2 * radius;
			ctx.beginPath();
			ctx.fillRect(x - size, y - size, 2 * size, 2 * size);
			ctx.strokeRect(x - size, y - size, 2 * size, 2 * size);
			break;
		case 'rectRounded':
			var offset = radius / Math.SQRT2;
			var leftX = x - offset;
			var topY = y - offset;
			var sideSize = Math.SQRT2 * radius;
			ctx.beginPath();
			this.roundedRect(ctx, leftX, topY, sideSize, sideSize, radius / 2);
			ctx.closePath();
			ctx.fill();
			break;
		case 'rectRot':
			size = 1 / Math.SQRT2 * radius;
			ctx.beginPath();
			ctx.moveTo(x - size, y);
			ctx.lineTo(x, y + size);
			ctx.lineTo(x + size, y);
			ctx.lineTo(x, y - size);
			ctx.closePath();
			ctx.fill();
			break;
		case 'cross':
			ctx.beginPath();
			ctx.moveTo(x, y + radius);
			ctx.lineTo(x, y - radius);
			ctx.moveTo(x - radius, y);
			ctx.lineTo(x + radius, y);
			ctx.closePath();
			break;
		case 'crossRot':
			ctx.beginPath();
			xOffset = Math.cos(Math.PI / 4) * radius;
			yOffset = Math.sin(Math.PI / 4) * radius;
			ctx.moveTo(x - xOffset, y - yOffset);
			ctx.lineTo(x + xOffset, y + yOffset);
			ctx.moveTo(x - xOffset, y + yOffset);
			ctx.lineTo(x + xOffset, y - yOffset);
			ctx.closePath();
			break;
		case 'star':
			ctx.beginPath();
			ctx.moveTo(x, y + radius);
			ctx.lineTo(x, y - radius);
			ctx.moveTo(x - radius, y);
			ctx.lineTo(x + radius, y);
			xOffset = Math.cos(Math.PI / 4) * radius;
			yOffset = Math.sin(Math.PI / 4) * radius;
			ctx.moveTo(x - xOffset, y - yOffset);
			ctx.lineTo(x + xOffset, y + yOffset);
			ctx.moveTo(x - xOffset, y + yOffset);
			ctx.lineTo(x + xOffset, y - yOffset);
			ctx.closePath();
			break;
		case 'line':
			ctx.beginPath();
			ctx.moveTo(x - radius, y);
			ctx.lineTo(x + radius, y);
			ctx.closePath();
			break;
		case 'dash':
			ctx.beginPath();
			ctx.moveTo(x, y);
			ctx.lineTo(x + radius, y);
			ctx.closePath();
			break;
		}

		ctx.stroke();
	},

	clipArea: function(ctx, area) {
		ctx.save();
		ctx.beginPath();
		ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
		ctx.clip();
	},

	unclipArea: function(ctx) {
		ctx.restore();
	},

	lineTo: function(ctx, previous, target, flip) {
		if (target.steppedLine) {
			if ((target.steppedLine === 'after' && !flip) || (target.steppedLine !== 'after' && flip)) {
				ctx.lineTo(previous.x, target.y);
			} else {
				ctx.lineTo(target.x, previous.y);
			}
			ctx.lineTo(target.x, target.y);
			return;
		}

		if (!target.tension) {
			ctx.lineTo(target.x, target.y);
			return;
		}

		ctx.bezierCurveTo(
			flip ? previous.controlPointPreviousX : previous.controlPointNextX,
			flip ? previous.controlPointPreviousY : previous.controlPointNextY,
			flip ? target.controlPointNextX : target.controlPointPreviousX,
			flip ? target.controlPointNextY : target.controlPointPreviousY,
			target.x,
			target.y);
	}
};

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart.helpers.canvas.clear instead.
 * @namespace Chart.helpers.clear
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.clear = exports.clear;

/**
 * Provided for backward compatibility, use Chart.helpers.canvas.roundedRect instead.
 * @namespace Chart.helpers.drawRoundedRectangle
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.drawRoundedRectangle = function(ctx) {
	ctx.beginPath();
	exports.roundedRect.apply(exports, arguments);
	ctx.closePath();
};


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var helpers = __webpack_require__(33);

/**
 * @alias Chart.helpers.options
 * @namespace
 */
module.exports = {
	/**
	 * Converts the given line height `value` in pixels for a specific font `size`.
	 * @param {Number|String} value - The lineHeight to parse (eg. 1.6, '14px', '75%', '1.6em').
	 * @param {Number} size - The font size (in pixels) used to resolve relative `value`.
	 * @returns {Number} The effective line height in pixels (size * 1.2 if value is invalid).
	 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/line-height
	 * @since 2.7.0
	 */
	toLineHeight: function(value, size) {
		var matches = ('' + value).match(/^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/);
		if (!matches || matches[1] === 'normal') {
			return size * 1.2;
		}

		value = +matches[2];

		switch (matches[3]) {
		case 'px':
			return value;
		case '%':
			value /= 100;
			break;
		default:
			break;
		}

		return size * value;
	},

	/**
	 * Converts the given value into a padding object with pre-computed width/height.
	 * @param {Number|Object} value - If a number, set the value to all TRBL component,
	 *  else, if and object, use defined properties and sets undefined ones to 0.
	 * @returns {Object} The padding values (top, right, bottom, left, width, height)
	 * @since 2.7.0
	 */
	toPadding: function(value) {
		var t, r, b, l;

		if (helpers.isObject(value)) {
			t = +value.top || 0;
			r = +value.right || 0;
			b = +value.bottom || 0;
			l = +value.left || 0;
		} else {
			t = r = b = l = +value || 0;
		}

		return {
			top: t,
			right: r,
			bottom: b,
			left: l,
			height: t + b,
			width: l + r
		};
	},

	/**
	 * Evaluates the given `inputs` sequentially and returns the first defined value.
	 * @param {Array[]} inputs - An array of values, falling back to the last value.
	 * @param {Object} [context] - If defined and the current value is a function, the value
	 * is called with `context` as first argument and the result becomes the new input.
	 * @param {Number} [index] - If defined and the current value is an array, the value
	 * at `index` become the new input.
	 * @since 2.7.0
	 */
	resolve: function(inputs, context, index) {
		var i, ilen, value;

		for (i = 0, ilen = inputs.length; i < ilen; ++i) {
			value = inputs[i];
			if (value === undefined) {
				continue;
			}
			if (context !== undefined && typeof value === 'function') {
				value = value(context);
			}
			if (index !== undefined && helpers.isArray(value)) {
				value = value[index];
			}
			if (value !== undefined) {
				return value;
			}
		}
	}
};


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* global window: false */
/* global document: false */


var color = __webpack_require__(74);
var defaults = __webpack_require__(2);
var helpers = __webpack_require__(1);

module.exports = function(Chart) {

	// -- Basic js utility methods

	helpers.configMerge = function(/* objects ... */) {
		return helpers.merge(helpers.clone(arguments[0]), [].slice.call(arguments, 1), {
			merger: function(key, target, source, options) {
				var tval = target[key] || {};
				var sval = source[key];

				if (key === 'scales') {
					// scale config merging is complex. Add our own function here for that
					target[key] = helpers.scaleMerge(tval, sval);
				} else if (key === 'scale') {
					// used in polar area & radar charts since there is only one scale
					target[key] = helpers.merge(tval, [Chart.scaleService.getScaleDefaults(sval.type), sval]);
				} else {
					helpers._merger(key, target, source, options);
				}
			}
		});
	};

	helpers.scaleMerge = function(/* objects ... */) {
		return helpers.merge(helpers.clone(arguments[0]), [].slice.call(arguments, 1), {
			merger: function(key, target, source, options) {
				if (key === 'xAxes' || key === 'yAxes') {
					var slen = source[key].length;
					var i, type, scale;

					if (!target[key]) {
						target[key] = [];
					}

					for (i = 0; i < slen; ++i) {
						scale = source[key][i];
						type = helpers.valueOrDefault(scale.type, key === 'xAxes' ? 'category' : 'linear');

						if (i >= target[key].length) {
							target[key].push({});
						}

						if (!target[key][i].type || (scale.type && scale.type !== target[key][i].type)) {
							// new/untyped scale or type changed: let's apply the new defaults
							// then merge source scale to correctly overwrite the defaults.
							helpers.merge(target[key][i], [Chart.scaleService.getScaleDefaults(type), scale]);
						} else {
							// scales type are the same
							helpers.merge(target[key][i], scale);
						}
					}
				} else {
					helpers._merger(key, target, source, options);
				}
			}
		});
	};

	helpers.where = function(collection, filterCallback) {
		if (helpers.isArray(collection) && Array.prototype.filter) {
			return collection.filter(filterCallback);
		}
		var filtered = [];

		helpers.each(collection, function(item) {
			if (filterCallback(item)) {
				filtered.push(item);
			}
		});

		return filtered;
	};
	helpers.findIndex = Array.prototype.findIndex ?
		function(array, callback, scope) {
			return array.findIndex(callback, scope);
		} :
		function(array, callback, scope) {
			scope = scope === undefined ? array : scope;
			for (var i = 0, ilen = array.length; i < ilen; ++i) {
				if (callback.call(scope, array[i], i, array)) {
					return i;
				}
			}
			return -1;
		};
	helpers.findNextWhere = function(arrayToSearch, filterCallback, startIndex) {
		// Default to start of the array
		if (helpers.isNullOrUndef(startIndex)) {
			startIndex = -1;
		}
		for (var i = startIndex + 1; i < arrayToSearch.length; i++) {
			var currentItem = arrayToSearch[i];
			if (filterCallback(currentItem)) {
				return currentItem;
			}
		}
	};
	helpers.findPreviousWhere = function(arrayToSearch, filterCallback, startIndex) {
		// Default to end of the array
		if (helpers.isNullOrUndef(startIndex)) {
			startIndex = arrayToSearch.length;
		}
		for (var i = startIndex - 1; i >= 0; i--) {
			var currentItem = arrayToSearch[i];
			if (filterCallback(currentItem)) {
				return currentItem;
			}
		}
	};

	// -- Math methods
	helpers.isNumber = function(n) {
		return !isNaN(parseFloat(n)) && isFinite(n);
	};
	helpers.almostEquals = function(x, y, epsilon) {
		return Math.abs(x - y) < epsilon;
	};
	helpers.almostWhole = function(x, epsilon) {
		var rounded = Math.round(x);
		return (((rounded - epsilon) < x) && ((rounded + epsilon) > x));
	};
	helpers.max = function(array) {
		return array.reduce(function(max, value) {
			if (!isNaN(value)) {
				return Math.max(max, value);
			}
			return max;
		}, Number.NEGATIVE_INFINITY);
	};
	helpers.min = function(array) {
		return array.reduce(function(min, value) {
			if (!isNaN(value)) {
				return Math.min(min, value);
			}
			return min;
		}, Number.POSITIVE_INFINITY);
	};
	helpers.sign = Math.sign ?
		function(x) {
			return Math.sign(x);
		} :
		function(x) {
			x = +x; // convert to a number
			if (x === 0 || isNaN(x)) {
				return x;
			}
			return x > 0 ? 1 : -1;
		};
	helpers.log10 = Math.log10 ?
		function(x) {
			return Math.log10(x);
		} :
		function(x) {
			var exponent = Math.log(x) * Math.LOG10E; // Math.LOG10E = 1 / Math.LN10.
			// Check for whole powers of 10,
			// which due to floating point rounding error should be corrected.
			var powerOf10 = Math.round(exponent);
			var isPowerOf10 = x === Math.pow(10, powerOf10);

			return isPowerOf10 ? powerOf10 : exponent;
		};
	helpers.toRadians = function(degrees) {
		return degrees * (Math.PI / 180);
	};
	helpers.toDegrees = function(radians) {
		return radians * (180 / Math.PI);
	};
	// Gets the angle from vertical upright to the point about a centre.
	helpers.getAngleFromPoint = function(centrePoint, anglePoint) {
		var distanceFromXCenter = anglePoint.x - centrePoint.x;
		var distanceFromYCenter = anglePoint.y - centrePoint.y;
		var radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);

		var angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);

		if (angle < (-0.5 * Math.PI)) {
			angle += 2.0 * Math.PI; // make sure the returned angle is in the range of (-PI/2, 3PI/2]
		}

		return {
			angle: angle,
			distance: radialDistanceFromCenter
		};
	};
	helpers.distanceBetweenPoints = function(pt1, pt2) {
		return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
	};
	helpers.aliasPixel = function(pixelWidth) {
		return (pixelWidth % 2 === 0) ? 0 : 0.5;
	};
	helpers.splineCurve = function(firstPoint, middlePoint, afterPoint, t) {
		// Props to Rob Spencer at scaled innovation for his post on splining between points
		// http://scaledinnovation.com/analytics/splines/aboutSplines.html

		// This function must also respect "skipped" points

		var previous = firstPoint.skip ? middlePoint : firstPoint;
		var current = middlePoint;
		var next = afterPoint.skip ? middlePoint : afterPoint;

		var d01 = Math.sqrt(Math.pow(current.x - previous.x, 2) + Math.pow(current.y - previous.y, 2));
		var d12 = Math.sqrt(Math.pow(next.x - current.x, 2) + Math.pow(next.y - current.y, 2));

		var s01 = d01 / (d01 + d12);
		var s12 = d12 / (d01 + d12);

		// If all points are the same, s01 & s02 will be inf
		s01 = isNaN(s01) ? 0 : s01;
		s12 = isNaN(s12) ? 0 : s12;

		var fa = t * s01; // scaling factor for triangle Ta
		var fb = t * s12;

		return {
			previous: {
				x: current.x - fa * (next.x - previous.x),
				y: current.y - fa * (next.y - previous.y)
			},
			next: {
				x: current.x + fb * (next.x - previous.x),
				y: current.y + fb * (next.y - previous.y)
			}
		};
	};
	helpers.EPSILON = Number.EPSILON || 1e-14;
	helpers.splineCurveMonotone = function(points) {
		// This function calculates Bézier control points in a similar way than |splineCurve|,
		// but preserves monotonicity of the provided data and ensures no local extremums are added
		// between the dataset discrete points due to the interpolation.
		// See : https://en.wikipedia.org/wiki/Monotone_cubic_interpolation

		var pointsWithTangents = (points || []).map(function(point) {
			return {
				model: point._model,
				deltaK: 0,
				mK: 0
			};
		});

		// Calculate slopes (deltaK) and initialize tangents (mK)
		var pointsLen = pointsWithTangents.length;
		var i, pointBefore, pointCurrent, pointAfter;
		for (i = 0; i < pointsLen; ++i) {
			pointCurrent = pointsWithTangents[i];
			if (pointCurrent.model.skip) {
				continue;
			}

			pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
			pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
			if (pointAfter && !pointAfter.model.skip) {
				var slopeDeltaX = (pointAfter.model.x - pointCurrent.model.x);

				// In the case of two points that appear at the same x pixel, slopeDeltaX is 0
				pointCurrent.deltaK = slopeDeltaX !== 0 ? (pointAfter.model.y - pointCurrent.model.y) / slopeDeltaX : 0;
			}

			if (!pointBefore || pointBefore.model.skip) {
				pointCurrent.mK = pointCurrent.deltaK;
			} else if (!pointAfter || pointAfter.model.skip) {
				pointCurrent.mK = pointBefore.deltaK;
			} else if (this.sign(pointBefore.deltaK) !== this.sign(pointCurrent.deltaK)) {
				pointCurrent.mK = 0;
			} else {
				pointCurrent.mK = (pointBefore.deltaK + pointCurrent.deltaK) / 2;
			}
		}

		// Adjust tangents to ensure monotonic properties
		var alphaK, betaK, tauK, squaredMagnitude;
		for (i = 0; i < pointsLen - 1; ++i) {
			pointCurrent = pointsWithTangents[i];
			pointAfter = pointsWithTangents[i + 1];
			if (pointCurrent.model.skip || pointAfter.model.skip) {
				continue;
			}

			if (helpers.almostEquals(pointCurrent.deltaK, 0, this.EPSILON)) {
				pointCurrent.mK = pointAfter.mK = 0;
				continue;
			}

			alphaK = pointCurrent.mK / pointCurrent.deltaK;
			betaK = pointAfter.mK / pointCurrent.deltaK;
			squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
			if (squaredMagnitude <= 9) {
				continue;
			}

			tauK = 3 / Math.sqrt(squaredMagnitude);
			pointCurrent.mK = alphaK * tauK * pointCurrent.deltaK;
			pointAfter.mK = betaK * tauK * pointCurrent.deltaK;
		}

		// Compute control points
		var deltaX;
		for (i = 0; i < pointsLen; ++i) {
			pointCurrent = pointsWithTangents[i];
			if (pointCurrent.model.skip) {
				continue;
			}

			pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
			pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
			if (pointBefore && !pointBefore.model.skip) {
				deltaX = (pointCurrent.model.x - pointBefore.model.x) / 3;
				pointCurrent.model.controlPointPreviousX = pointCurrent.model.x - deltaX;
				pointCurrent.model.controlPointPreviousY = pointCurrent.model.y - deltaX * pointCurrent.mK;
			}
			if (pointAfter && !pointAfter.model.skip) {
				deltaX = (pointAfter.model.x - pointCurrent.model.x) / 3;
				pointCurrent.model.controlPointNextX = pointCurrent.model.x + deltaX;
				pointCurrent.model.controlPointNextY = pointCurrent.model.y + deltaX * pointCurrent.mK;
			}
		}
	};
	helpers.nextItem = function(collection, index, loop) {
		if (loop) {
			return index >= collection.length - 1 ? collection[0] : collection[index + 1];
		}
		return index >= collection.length - 1 ? collection[collection.length - 1] : collection[index + 1];
	};
	helpers.previousItem = function(collection, index, loop) {
		if (loop) {
			return index <= 0 ? collection[collection.length - 1] : collection[index - 1];
		}
		return index <= 0 ? collection[0] : collection[index - 1];
	};
	// Implementation of the nice number algorithm used in determining where axis labels will go
	helpers.niceNum = function(range, round) {
		var exponent = Math.floor(helpers.log10(range));
		var fraction = range / Math.pow(10, exponent);
		var niceFraction;

		if (round) {
			if (fraction < 1.5) {
				niceFraction = 1;
			} else if (fraction < 3) {
				niceFraction = 2;
			} else if (fraction < 7) {
				niceFraction = 5;
			} else {
				niceFraction = 10;
			}
		} else if (fraction <= 1.0) {
			niceFraction = 1;
		} else if (fraction <= 2) {
			niceFraction = 2;
		} else if (fraction <= 5) {
			niceFraction = 5;
		} else {
			niceFraction = 10;
		}

		return niceFraction * Math.pow(10, exponent);
	};
	// Request animation polyfill - http://www.paulirish.com/2011/requestanimationframe-for-smart-animating/
	helpers.requestAnimFrame = (function() {
		if (typeof window === 'undefined') {
			return function(callback) {
				callback();
			};
		}
		return window.requestAnimationFrame ||
			window.webkitRequestAnimationFrame ||
			window.mozRequestAnimationFrame ||
			window.oRequestAnimationFrame ||
			window.msRequestAnimationFrame ||
			function(callback) {
				return window.setTimeout(callback, 1000 / 60);
			};
	}());
	// -- DOM methods
	helpers.getRelativePosition = function(evt, chart) {
		var mouseX, mouseY;
		var e = evt.originalEvent || evt;
		var canvas = evt.currentTarget || evt.srcElement;
		var boundingRect = canvas.getBoundingClientRect();

		var touches = e.touches;
		if (touches && touches.length > 0) {
			mouseX = touches[0].clientX;
			mouseY = touches[0].clientY;

		} else {
			mouseX = e.clientX;
			mouseY = e.clientY;
		}

		// Scale mouse coordinates into canvas coordinates
		// by following the pattern laid out by 'jerryj' in the comments of
		// http://www.html5canvastutorials.com/advanced/html5-canvas-mouse-coordinates/
		var paddingLeft = parseFloat(helpers.getStyle(canvas, 'padding-left'));
		var paddingTop = parseFloat(helpers.getStyle(canvas, 'padding-top'));
		var paddingRight = parseFloat(helpers.getStyle(canvas, 'padding-right'));
		var paddingBottom = parseFloat(helpers.getStyle(canvas, 'padding-bottom'));
		var width = boundingRect.right - boundingRect.left - paddingLeft - paddingRight;
		var height = boundingRect.bottom - boundingRect.top - paddingTop - paddingBottom;

		// We divide by the current device pixel ratio, because the canvas is scaled up by that amount in each direction. However
		// the backend model is in unscaled coordinates. Since we are going to deal with our model coordinates, we go back here
		mouseX = Math.round((mouseX - boundingRect.left - paddingLeft) / (width) * canvas.width / chart.currentDevicePixelRatio);
		mouseY = Math.round((mouseY - boundingRect.top - paddingTop) / (height) * canvas.height / chart.currentDevicePixelRatio);

		return {
			x: mouseX,
			y: mouseY
		};

	};

	// Private helper function to convert max-width/max-height values that may be percentages into a number
	function parseMaxStyle(styleValue, node, parentProperty) {
		var valueInPixels;
		if (typeof styleValue === 'string') {
			valueInPixels = parseInt(styleValue, 10);

			if (styleValue.indexOf('%') !== -1) {
				// percentage * size in dimension
				valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
			}
		} else {
			valueInPixels = styleValue;
		}

		return valueInPixels;
	}

	/**
	 * Returns if the given value contains an effective constraint.
	 * @private
	 */
	function isConstrainedValue(value) {
		return value !== undefined && value !== null && value !== 'none';
	}

	// Private helper to get a constraint dimension
	// @param domNode : the node to check the constraint on
	// @param maxStyle : the style that defines the maximum for the direction we are using (maxWidth / maxHeight)
	// @param percentageProperty : property of parent to use when calculating width as a percentage
	// @see http://www.nathanaeljones.com/blog/2013/reading-max-width-cross-browser
	function getConstraintDimension(domNode, maxStyle, percentageProperty) {
		var view = document.defaultView;
		var parentNode = domNode.parentNode;
		var constrainedNode = view.getComputedStyle(domNode)[maxStyle];
		var constrainedContainer = view.getComputedStyle(parentNode)[maxStyle];
		var hasCNode = isConstrainedValue(constrainedNode);
		var hasCContainer = isConstrainedValue(constrainedContainer);
		var infinity = Number.POSITIVE_INFINITY;

		if (hasCNode || hasCContainer) {
			return Math.min(
				hasCNode ? parseMaxStyle(constrainedNode, domNode, percentageProperty) : infinity,
				hasCContainer ? parseMaxStyle(constrainedContainer, parentNode, percentageProperty) : infinity);
		}

		return 'none';
	}
	// returns Number or undefined if no constraint
	helpers.getConstraintWidth = function(domNode) {
		return getConstraintDimension(domNode, 'max-width', 'clientWidth');
	};
	// returns Number or undefined if no constraint
	helpers.getConstraintHeight = function(domNode) {
		return getConstraintDimension(domNode, 'max-height', 'clientHeight');
	};
	helpers.getMaximumWidth = function(domNode) {
		var container = domNode.parentNode;
		if (!container) {
			return domNode.clientWidth;
		}

		var paddingLeft = parseInt(helpers.getStyle(container, 'padding-left'), 10);
		var paddingRight = parseInt(helpers.getStyle(container, 'padding-right'), 10);
		var w = container.clientWidth - paddingLeft - paddingRight;
		var cw = helpers.getConstraintWidth(domNode);
		return isNaN(cw) ? w : Math.min(w, cw);
	};
	helpers.getMaximumHeight = function(domNode) {
		var container = domNode.parentNode;
		if (!container) {
			return domNode.clientHeight;
		}

		var paddingTop = parseInt(helpers.getStyle(container, 'padding-top'), 10);
		var paddingBottom = parseInt(helpers.getStyle(container, 'padding-bottom'), 10);
		var h = container.clientHeight - paddingTop - paddingBottom;
		var ch = helpers.getConstraintHeight(domNode);
		return isNaN(ch) ? h : Math.min(h, ch);
	};
	helpers.getStyle = function(el, property) {
		return el.currentStyle ?
			el.currentStyle[property] :
			document.defaultView.getComputedStyle(el, null).getPropertyValue(property);
	};
	helpers.retinaScale = function(chart, forceRatio) {
		var pixelRatio = chart.currentDevicePixelRatio = forceRatio || window.devicePixelRatio || 1;
		if (pixelRatio === 1) {
			return;
		}

		var canvas = chart.canvas;
		var height = chart.height;
		var width = chart.width;

		canvas.height = height * pixelRatio;
		canvas.width = width * pixelRatio;
		chart.ctx.scale(pixelRatio, pixelRatio);

		// If no style has been set on the canvas, the render size is used as display size,
		// making the chart visually bigger, so let's enforce it to the "correct" values.
		// See https://github.com/chartjs/Chart.js/issues/3575
		if (!canvas.style.height && !canvas.style.width) {
			canvas.style.height = height + 'px';
			canvas.style.width = width + 'px';
		}
	};
	// -- Canvas methods
	helpers.fontString = function(pixelSize, fontStyle, fontFamily) {
		return fontStyle + ' ' + pixelSize + 'px ' + fontFamily;
	};
	helpers.longestText = function(ctx, font, arrayOfThings, cache) {
		cache = cache || {};
		var data = cache.data = cache.data || {};
		var gc = cache.garbageCollect = cache.garbageCollect || [];

		if (cache.font !== font) {
			data = cache.data = {};
			gc = cache.garbageCollect = [];
			cache.font = font;
		}

		ctx.font = font;
		var longest = 0;
		helpers.each(arrayOfThings, function(thing) {
			// Undefined strings and arrays should not be measured
			if (thing !== undefined && thing !== null && helpers.isArray(thing) !== true) {
				longest = helpers.measureText(ctx, data, gc, longest, thing);
			} else if (helpers.isArray(thing)) {
				// if it is an array lets measure each element
				// to do maybe simplify this function a bit so we can do this more recursively?
				helpers.each(thing, function(nestedThing) {
					// Undefined strings and arrays should not be measured
					if (nestedThing !== undefined && nestedThing !== null && !helpers.isArray(nestedThing)) {
						longest = helpers.measureText(ctx, data, gc, longest, nestedThing);
					}
				});
			}
		});

		var gcLen = gc.length / 2;
		if (gcLen > arrayOfThings.length) {
			for (var i = 0; i < gcLen; i++) {
				delete data[gc[i]];
			}
			gc.splice(0, gcLen);
		}
		return longest;
	};
	helpers.measureText = function(ctx, data, gc, longest, string) {
		var textWidth = data[string];
		if (!textWidth) {
			textWidth = data[string] = ctx.measureText(string).width;
			gc.push(string);
		}
		if (textWidth > longest) {
			longest = textWidth;
		}
		return longest;
	};
	helpers.numberOfLabelLines = function(arrayOfThings) {
		var numberOfLines = 1;
		helpers.each(arrayOfThings, function(thing) {
			if (helpers.isArray(thing)) {
				if (thing.length > numberOfLines) {
					numberOfLines = thing.length;
				}
			}
		});
		return numberOfLines;
	};

	helpers.color = !color ?
		function(value) {
			console.error('Color.js not found!');
			return value;
		} :
		function(value) {
			/* global CanvasGradient */
			if (value instanceof CanvasGradient) {
				value = defaults.global.defaultColor;
			}

			return color(value);
		};

	helpers.getHoverColor = function(colorValue) {
		/* global CanvasPattern */
		return (colorValue instanceof CanvasPattern) ?
			colorValue :
			helpers.color(colorValue).saturate(0.5).darken(0.1).rgbString();
	};
};


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

var conversions = __webpack_require__(197);

var convert = function() {
   return new Converter();
}

for (var func in conversions) {
  // export Raw versions
  convert[func + "Raw"] =  (function(func) {
    // accept array or plain args
    return function(arg) {
      if (typeof arg == "number")
        arg = Array.prototype.slice.call(arguments);
      return conversions[func](arg);
    }
  })(func);

  var pair = /(\w+)2(\w+)/.exec(func),
      from = pair[1],
      to = pair[2];

  // export rgb2hsl and ["rgb"]["hsl"]
  convert[from] = convert[from] || {};

  convert[from][to] = convert[func] = (function(func) { 
    return function(arg) {
      if (typeof arg == "number")
        arg = Array.prototype.slice.call(arguments);
      
      var val = conversions[func](arg);
      if (typeof val == "string" || val === undefined)
        return val; // keyword

      for (var i = 0; i < val.length; i++)
        val[i] = Math.round(val[i]);
      return val;
    }
  })(func);
}


/* Converter does lazy conversion and caching */
var Converter = function() {
   this.convs = {};
};

/* Either get the values for a space or
  set the values for a space, depending on args */
Converter.prototype.routeSpace = function(space, args) {
   var values = args[0];
   if (values === undefined) {
      // color.rgb()
      return this.getValues(space);
   }
   // color.rgb(10, 10, 10)
   if (typeof values == "number") {
      values = Array.prototype.slice.call(args);        
   }

   return this.setValues(space, values);
};
  
/* Set the values for a space, invalidating cache */
Converter.prototype.setValues = function(space, values) {
   this.space = space;
   this.convs = {};
   this.convs[space] = values;
   return this;
};

/* Get the values for a space. If there's already
  a conversion for the space, fetch it, otherwise
  compute it */
Converter.prototype.getValues = function(space) {
   var vals = this.convs[space];
   if (!vals) {
      var fspace = this.space,
          from = this.convs[fspace];
      vals = convert[fspace][space](from);

      this.convs[space] = vals;
   }
  return vals;
};

["rgb", "hsl", "hsv", "cmyk", "keyword"].forEach(function(space) {
   Converter.prototype[space] = function(vals) {
      return this.routeSpace(space, arguments);
   }
});

module.exports = convert;

/***/ }),
/* 197 */
/***/ (function(module, exports) {

/* MIT license */

module.exports = {
  rgb2hsl: rgb2hsl,
  rgb2hsv: rgb2hsv,
  rgb2hwb: rgb2hwb,
  rgb2cmyk: rgb2cmyk,
  rgb2keyword: rgb2keyword,
  rgb2xyz: rgb2xyz,
  rgb2lab: rgb2lab,
  rgb2lch: rgb2lch,

  hsl2rgb: hsl2rgb,
  hsl2hsv: hsl2hsv,
  hsl2hwb: hsl2hwb,
  hsl2cmyk: hsl2cmyk,
  hsl2keyword: hsl2keyword,

  hsv2rgb: hsv2rgb,
  hsv2hsl: hsv2hsl,
  hsv2hwb: hsv2hwb,
  hsv2cmyk: hsv2cmyk,
  hsv2keyword: hsv2keyword,

  hwb2rgb: hwb2rgb,
  hwb2hsl: hwb2hsl,
  hwb2hsv: hwb2hsv,
  hwb2cmyk: hwb2cmyk,
  hwb2keyword: hwb2keyword,

  cmyk2rgb: cmyk2rgb,
  cmyk2hsl: cmyk2hsl,
  cmyk2hsv: cmyk2hsv,
  cmyk2hwb: cmyk2hwb,
  cmyk2keyword: cmyk2keyword,

  keyword2rgb: keyword2rgb,
  keyword2hsl: keyword2hsl,
  keyword2hsv: keyword2hsv,
  keyword2hwb: keyword2hwb,
  keyword2cmyk: keyword2cmyk,
  keyword2lab: keyword2lab,
  keyword2xyz: keyword2xyz,

  xyz2rgb: xyz2rgb,
  xyz2lab: xyz2lab,
  xyz2lch: xyz2lch,

  lab2xyz: lab2xyz,
  lab2rgb: lab2rgb,
  lab2lch: lab2lch,

  lch2lab: lch2lab,
  lch2xyz: lch2xyz,
  lch2rgb: lch2rgb
}


function rgb2hsl(rgb) {
  var r = rgb[0]/255,
      g = rgb[1]/255,
      b = rgb[2]/255,
      min = Math.min(r, g, b),
      max = Math.max(r, g, b),
      delta = max - min,
      h, s, l;

  if (max == min)
    h = 0;
  else if (r == max)
    h = (g - b) / delta;
  else if (g == max)
    h = 2 + (b - r) / delta;
  else if (b == max)
    h = 4 + (r - g)/ delta;

  h = Math.min(h * 60, 360);

  if (h < 0)
    h += 360;

  l = (min + max) / 2;

  if (max == min)
    s = 0;
  else if (l <= 0.5)
    s = delta / (max + min);
  else
    s = delta / (2 - max - min);

  return [h, s * 100, l * 100];
}

function rgb2hsv(rgb) {
  var r = rgb[0],
      g = rgb[1],
      b = rgb[2],
      min = Math.min(r, g, b),
      max = Math.max(r, g, b),
      delta = max - min,
      h, s, v;

  if (max == 0)
    s = 0;
  else
    s = (delta/max * 1000)/10;

  if (max == min)
    h = 0;
  else if (r == max)
    h = (g - b) / delta;
  else if (g == max)
    h = 2 + (b - r) / delta;
  else if (b == max)
    h = 4 + (r - g) / delta;

  h = Math.min(h * 60, 360);

  if (h < 0)
    h += 360;

  v = ((max / 255) * 1000) / 10;

  return [h, s, v];
}

function rgb2hwb(rgb) {
  var r = rgb[0],
      g = rgb[1],
      b = rgb[2],
      h = rgb2hsl(rgb)[0],
      w = 1/255 * Math.min(r, Math.min(g, b)),
      b = 1 - 1/255 * Math.max(r, Math.max(g, b));

  return [h, w * 100, b * 100];
}

function rgb2cmyk(rgb) {
  var r = rgb[0] / 255,
      g = rgb[1] / 255,
      b = rgb[2] / 255,
      c, m, y, k;

  k = Math.min(1 - r, 1 - g, 1 - b);
  c = (1 - r - k) / (1 - k) || 0;
  m = (1 - g - k) / (1 - k) || 0;
  y = (1 - b - k) / (1 - k) || 0;
  return [c * 100, m * 100, y * 100, k * 100];
}

function rgb2keyword(rgb) {
  return reverseKeywords[JSON.stringify(rgb)];
}

function rgb2xyz(rgb) {
  var r = rgb[0] / 255,
      g = rgb[1] / 255,
      b = rgb[2] / 255;

  // assume sRGB
  r = r > 0.04045 ? Math.pow(((r + 0.055) / 1.055), 2.4) : (r / 12.92);
  g = g > 0.04045 ? Math.pow(((g + 0.055) / 1.055), 2.4) : (g / 12.92);
  b = b > 0.04045 ? Math.pow(((b + 0.055) / 1.055), 2.4) : (b / 12.92);

  var x = (r * 0.4124) + (g * 0.3576) + (b * 0.1805);
  var y = (r * 0.2126) + (g * 0.7152) + (b * 0.0722);
  var z = (r * 0.0193) + (g * 0.1192) + (b * 0.9505);

  return [x * 100, y *100, z * 100];
}

function rgb2lab(rgb) {
  var xyz = rgb2xyz(rgb),
        x = xyz[0],
        y = xyz[1],
        z = xyz[2],
        l, a, b;

  x /= 95.047;
  y /= 100;
  z /= 108.883;

  x = x > 0.008856 ? Math.pow(x, 1/3) : (7.787 * x) + (16 / 116);
  y = y > 0.008856 ? Math.pow(y, 1/3) : (7.787 * y) + (16 / 116);
  z = z > 0.008856 ? Math.pow(z, 1/3) : (7.787 * z) + (16 / 116);

  l = (116 * y) - 16;
  a = 500 * (x - y);
  b = 200 * (y - z);

  return [l, a, b];
}

function rgb2lch(args) {
  return lab2lch(rgb2lab(args));
}

function hsl2rgb(hsl) {
  var h = hsl[0] / 360,
      s = hsl[1] / 100,
      l = hsl[2] / 100,
      t1, t2, t3, rgb, val;

  if (s == 0) {
    val = l * 255;
    return [val, val, val];
  }

  if (l < 0.5)
    t2 = l * (1 + s);
  else
    t2 = l + s - l * s;
  t1 = 2 * l - t2;

  rgb = [0, 0, 0];
  for (var i = 0; i < 3; i++) {
    t3 = h + 1 / 3 * - (i - 1);
    t3 < 0 && t3++;
    t3 > 1 && t3--;

    if (6 * t3 < 1)
      val = t1 + (t2 - t1) * 6 * t3;
    else if (2 * t3 < 1)
      val = t2;
    else if (3 * t3 < 2)
      val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
    else
      val = t1;

    rgb[i] = val * 255;
  }

  return rgb;
}

function hsl2hsv(hsl) {
  var h = hsl[0],
      s = hsl[1] / 100,
      l = hsl[2] / 100,
      sv, v;

  if(l === 0) {
      // no need to do calc on black
      // also avoids divide by 0 error
      return [0, 0, 0];
  }

  l *= 2;
  s *= (l <= 1) ? l : 2 - l;
  v = (l + s) / 2;
  sv = (2 * s) / (l + s);
  return [h, sv * 100, v * 100];
}

function hsl2hwb(args) {
  return rgb2hwb(hsl2rgb(args));
}

function hsl2cmyk(args) {
  return rgb2cmyk(hsl2rgb(args));
}

function hsl2keyword(args) {
  return rgb2keyword(hsl2rgb(args));
}


function hsv2rgb(hsv) {
  var h = hsv[0] / 60,
      s = hsv[1] / 100,
      v = hsv[2] / 100,
      hi = Math.floor(h) % 6;

  var f = h - Math.floor(h),
      p = 255 * v * (1 - s),
      q = 255 * v * (1 - (s * f)),
      t = 255 * v * (1 - (s * (1 - f))),
      v = 255 * v;

  switch(hi) {
    case 0:
      return [v, t, p];
    case 1:
      return [q, v, p];
    case 2:
      return [p, v, t];
    case 3:
      return [p, q, v];
    case 4:
      return [t, p, v];
    case 5:
      return [v, p, q];
  }
}

function hsv2hsl(hsv) {
  var h = hsv[0],
      s = hsv[1] / 100,
      v = hsv[2] / 100,
      sl, l;

  l = (2 - s) * v;
  sl = s * v;
  sl /= (l <= 1) ? l : 2 - l;
  sl = sl || 0;
  l /= 2;
  return [h, sl * 100, l * 100];
}

function hsv2hwb(args) {
  return rgb2hwb(hsv2rgb(args))
}

function hsv2cmyk(args) {
  return rgb2cmyk(hsv2rgb(args));
}

function hsv2keyword(args) {
  return rgb2keyword(hsv2rgb(args));
}

// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
function hwb2rgb(hwb) {
  var h = hwb[0] / 360,
      wh = hwb[1] / 100,
      bl = hwb[2] / 100,
      ratio = wh + bl,
      i, v, f, n;

  // wh + bl cant be > 1
  if (ratio > 1) {
    wh /= ratio;
    bl /= ratio;
  }

  i = Math.floor(6 * h);
  v = 1 - bl;
  f = 6 * h - i;
  if ((i & 0x01) != 0) {
    f = 1 - f;
  }
  n = wh + f * (v - wh);  // linear interpolation

  switch (i) {
    default:
    case 6:
    case 0: r = v; g = n; b = wh; break;
    case 1: r = n; g = v; b = wh; break;
    case 2: r = wh; g = v; b = n; break;
    case 3: r = wh; g = n; b = v; break;
    case 4: r = n; g = wh; b = v; break;
    case 5: r = v; g = wh; b = n; break;
  }

  return [r * 255, g * 255, b * 255];
}

function hwb2hsl(args) {
  return rgb2hsl(hwb2rgb(args));
}

function hwb2hsv(args) {
  return rgb2hsv(hwb2rgb(args));
}

function hwb2cmyk(args) {
  return rgb2cmyk(hwb2rgb(args));
}

function hwb2keyword(args) {
  return rgb2keyword(hwb2rgb(args));
}

function cmyk2rgb(cmyk) {
  var c = cmyk[0] / 100,
      m = cmyk[1] / 100,
      y = cmyk[2] / 100,
      k = cmyk[3] / 100,
      r, g, b;

  r = 1 - Math.min(1, c * (1 - k) + k);
  g = 1 - Math.min(1, m * (1 - k) + k);
  b = 1 - Math.min(1, y * (1 - k) + k);
  return [r * 255, g * 255, b * 255];
}

function cmyk2hsl(args) {
  return rgb2hsl(cmyk2rgb(args));
}

function cmyk2hsv(args) {
  return rgb2hsv(cmyk2rgb(args));
}

function cmyk2hwb(args) {
  return rgb2hwb(cmyk2rgb(args));
}

function cmyk2keyword(args) {
  return rgb2keyword(cmyk2rgb(args));
}


function xyz2rgb(xyz) {
  var x = xyz[0] / 100,
      y = xyz[1] / 100,
      z = xyz[2] / 100,
      r, g, b;

  r = (x * 3.2406) + (y * -1.5372) + (z * -0.4986);
  g = (x * -0.9689) + (y * 1.8758) + (z * 0.0415);
  b = (x * 0.0557) + (y * -0.2040) + (z * 1.0570);

  // assume sRGB
  r = r > 0.0031308 ? ((1.055 * Math.pow(r, 1.0 / 2.4)) - 0.055)
    : r = (r * 12.92);

  g = g > 0.0031308 ? ((1.055 * Math.pow(g, 1.0 / 2.4)) - 0.055)
    : g = (g * 12.92);

  b = b > 0.0031308 ? ((1.055 * Math.pow(b, 1.0 / 2.4)) - 0.055)
    : b = (b * 12.92);

  r = Math.min(Math.max(0, r), 1);
  g = Math.min(Math.max(0, g), 1);
  b = Math.min(Math.max(0, b), 1);

  return [r * 255, g * 255, b * 255];
}

function xyz2lab(xyz) {
  var x = xyz[0],
      y = xyz[1],
      z = xyz[2],
      l, a, b;

  x /= 95.047;
  y /= 100;
  z /= 108.883;

  x = x > 0.008856 ? Math.pow(x, 1/3) : (7.787 * x) + (16 / 116);
  y = y > 0.008856 ? Math.pow(y, 1/3) : (7.787 * y) + (16 / 116);
  z = z > 0.008856 ? Math.pow(z, 1/3) : (7.787 * z) + (16 / 116);

  l = (116 * y) - 16;
  a = 500 * (x - y);
  b = 200 * (y - z);

  return [l, a, b];
}

function xyz2lch(args) {
  return lab2lch(xyz2lab(args));
}

function lab2xyz(lab) {
  var l = lab[0],
      a = lab[1],
      b = lab[2],
      x, y, z, y2;

  if (l <= 8) {
    y = (l * 100) / 903.3;
    y2 = (7.787 * (y / 100)) + (16 / 116);
  } else {
    y = 100 * Math.pow((l + 16) / 116, 3);
    y2 = Math.pow(y / 100, 1/3);
  }

  x = x / 95.047 <= 0.008856 ? x = (95.047 * ((a / 500) + y2 - (16 / 116))) / 7.787 : 95.047 * Math.pow((a / 500) + y2, 3);

  z = z / 108.883 <= 0.008859 ? z = (108.883 * (y2 - (b / 200) - (16 / 116))) / 7.787 : 108.883 * Math.pow(y2 - (b / 200), 3);

  return [x, y, z];
}

function lab2lch(lab) {
  var l = lab[0],
      a = lab[1],
      b = lab[2],
      hr, h, c;

  hr = Math.atan2(b, a);
  h = hr * 360 / 2 / Math.PI;
  if (h < 0) {
    h += 360;
  }
  c = Math.sqrt(a * a + b * b);
  return [l, c, h];
}

function lab2rgb(args) {
  return xyz2rgb(lab2xyz(args));
}

function lch2lab(lch) {
  var l = lch[0],
      c = lch[1],
      h = lch[2],
      a, b, hr;

  hr = h / 360 * 2 * Math.PI;
  a = c * Math.cos(hr);
  b = c * Math.sin(hr);
  return [l, a, b];
}

function lch2xyz(args) {
  return lab2xyz(lch2lab(args));
}

function lch2rgb(args) {
  return lab2rgb(lch2lab(args));
}

function keyword2rgb(keyword) {
  return cssKeywords[keyword];
}

function keyword2hsl(args) {
  return rgb2hsl(keyword2rgb(args));
}

function keyword2hsv(args) {
  return rgb2hsv(keyword2rgb(args));
}

function keyword2hwb(args) {
  return rgb2hwb(keyword2rgb(args));
}

function keyword2cmyk(args) {
  return rgb2cmyk(keyword2rgb(args));
}

function keyword2lab(args) {
  return rgb2lab(keyword2rgb(args));
}

function keyword2xyz(args) {
  return rgb2xyz(keyword2rgb(args));
}

var cssKeywords = {
  aliceblue:  [240,248,255],
  antiquewhite: [250,235,215],
  aqua: [0,255,255],
  aquamarine: [127,255,212],
  azure:  [240,255,255],
  beige:  [245,245,220],
  bisque: [255,228,196],
  black:  [0,0,0],
  blanchedalmond: [255,235,205],
  blue: [0,0,255],
  blueviolet: [138,43,226],
  brown:  [165,42,42],
  burlywood:  [222,184,135],
  cadetblue:  [95,158,160],
  chartreuse: [127,255,0],
  chocolate:  [210,105,30],
  coral:  [255,127,80],
  cornflowerblue: [100,149,237],
  cornsilk: [255,248,220],
  crimson:  [220,20,60],
  cyan: [0,255,255],
  darkblue: [0,0,139],
  darkcyan: [0,139,139],
  darkgoldenrod:  [184,134,11],
  darkgray: [169,169,169],
  darkgreen:  [0,100,0],
  darkgrey: [169,169,169],
  darkkhaki:  [189,183,107],
  darkmagenta:  [139,0,139],
  darkolivegreen: [85,107,47],
  darkorange: [255,140,0],
  darkorchid: [153,50,204],
  darkred:  [139,0,0],
  darksalmon: [233,150,122],
  darkseagreen: [143,188,143],
  darkslateblue:  [72,61,139],
  darkslategray:  [47,79,79],
  darkslategrey:  [47,79,79],
  darkturquoise:  [0,206,209],
  darkviolet: [148,0,211],
  deeppink: [255,20,147],
  deepskyblue:  [0,191,255],
  dimgray:  [105,105,105],
  dimgrey:  [105,105,105],
  dodgerblue: [30,144,255],
  firebrick:  [178,34,34],
  floralwhite:  [255,250,240],
  forestgreen:  [34,139,34],
  fuchsia:  [255,0,255],
  gainsboro:  [220,220,220],
  ghostwhite: [248,248,255],
  gold: [255,215,0],
  goldenrod:  [218,165,32],
  gray: [128,128,128],
  green:  [0,128,0],
  greenyellow:  [173,255,47],
  grey: [128,128,128],
  honeydew: [240,255,240],
  hotpink:  [255,105,180],
  indianred:  [205,92,92],
  indigo: [75,0,130],
  ivory:  [255,255,240],
  khaki:  [240,230,140],
  lavender: [230,230,250],
  lavenderblush:  [255,240,245],
  lawngreen:  [124,252,0],
  lemonchiffon: [255,250,205],
  lightblue:  [173,216,230],
  lightcoral: [240,128,128],
  lightcyan:  [224,255,255],
  lightgoldenrodyellow: [250,250,210],
  lightgray:  [211,211,211],
  lightgreen: [144,238,144],
  lightgrey:  [211,211,211],
  lightpink:  [255,182,193],
  lightsalmon:  [255,160,122],
  lightseagreen:  [32,178,170],
  lightskyblue: [135,206,250],
  lightslategray: [119,136,153],
  lightslategrey: [119,136,153],
  lightsteelblue: [176,196,222],
  lightyellow:  [255,255,224],
  lime: [0,255,0],
  limegreen:  [50,205,50],
  linen:  [250,240,230],
  magenta:  [255,0,255],
  maroon: [128,0,0],
  mediumaquamarine: [102,205,170],
  mediumblue: [0,0,205],
  mediumorchid: [186,85,211],
  mediumpurple: [147,112,219],
  mediumseagreen: [60,179,113],
  mediumslateblue:  [123,104,238],
  mediumspringgreen:  [0,250,154],
  mediumturquoise:  [72,209,204],
  mediumvioletred:  [199,21,133],
  midnightblue: [25,25,112],
  mintcream:  [245,255,250],
  mistyrose:  [255,228,225],
  moccasin: [255,228,181],
  navajowhite:  [255,222,173],
  navy: [0,0,128],
  oldlace:  [253,245,230],
  olive:  [128,128,0],
  olivedrab:  [107,142,35],
  orange: [255,165,0],
  orangered:  [255,69,0],
  orchid: [218,112,214],
  palegoldenrod:  [238,232,170],
  palegreen:  [152,251,152],
  paleturquoise:  [175,238,238],
  palevioletred:  [219,112,147],
  papayawhip: [255,239,213],
  peachpuff:  [255,218,185],
  peru: [205,133,63],
  pink: [255,192,203],
  plum: [221,160,221],
  powderblue: [176,224,230],
  purple: [128,0,128],
  rebeccapurple: [102, 51, 153],
  red:  [255,0,0],
  rosybrown:  [188,143,143],
  royalblue:  [65,105,225],
  saddlebrown:  [139,69,19],
  salmon: [250,128,114],
  sandybrown: [244,164,96],
  seagreen: [46,139,87],
  seashell: [255,245,238],
  sienna: [160,82,45],
  silver: [192,192,192],
  skyblue:  [135,206,235],
  slateblue:  [106,90,205],
  slategray:  [112,128,144],
  slategrey:  [112,128,144],
  snow: [255,250,250],
  springgreen:  [0,255,127],
  steelblue:  [70,130,180],
  tan:  [210,180,140],
  teal: [0,128,128],
  thistle:  [216,191,216],
  tomato: [255,99,71],
  turquoise:  [64,224,208],
  violet: [238,130,238],
  wheat:  [245,222,179],
  white:  [255,255,255],
  whitesmoke: [245,245,245],
  yellow: [255,255,0],
  yellowgreen:  [154,205,50]
};

var reverseKeywords = {};
for (var key in cssKeywords) {
  reverseKeywords[JSON.stringify(cssKeywords[key])] = key;
}


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

/* MIT license */
var colorNames = __webpack_require__(199);

module.exports = {
   getRgba: getRgba,
   getHsla: getHsla,
   getRgb: getRgb,
   getHsl: getHsl,
   getHwb: getHwb,
   getAlpha: getAlpha,

   hexString: hexString,
   rgbString: rgbString,
   rgbaString: rgbaString,
   percentString: percentString,
   percentaString: percentaString,
   hslString: hslString,
   hslaString: hslaString,
   hwbString: hwbString,
   keyword: keyword
}

function getRgba(string) {
   if (!string) {
      return;
   }
   var abbr =  /^#([a-fA-F0-9]{3})$/i,
       hex =  /^#([a-fA-F0-9]{6})$/i,
       rgba = /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
       per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
       keyword = /(\w+)/;

   var rgb = [0, 0, 0],
       a = 1,
       match = string.match(abbr);
   if (match) {
      match = match[1];
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = parseInt(match[i] + match[i], 16);
      }
   }
   else if (match = string.match(hex)) {
      match = match[1];
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = parseInt(match.slice(i * 2, i * 2 + 2), 16);
      }
   }
   else if (match = string.match(rgba)) {
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = parseInt(match[i + 1]);
      }
      a = parseFloat(match[4]);
   }
   else if (match = string.match(per)) {
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
      }
      a = parseFloat(match[4]);
   }
   else if (match = string.match(keyword)) {
      if (match[1] == "transparent") {
         return [0, 0, 0, 0];
      }
      rgb = colorNames[match[1]];
      if (!rgb) {
         return;
      }
   }

   for (var i = 0; i < rgb.length; i++) {
      rgb[i] = scale(rgb[i], 0, 255);
   }
   if (!a && a != 0) {
      a = 1;
   }
   else {
      a = scale(a, 0, 1);
   }
   rgb[3] = a;
   return rgb;
}

function getHsla(string) {
   if (!string) {
      return;
   }
   var hsl = /^hsla?\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
   var match = string.match(hsl);
   if (match) {
      var alpha = parseFloat(match[4]);
      var h = scale(parseInt(match[1]), 0, 360),
          s = scale(parseFloat(match[2]), 0, 100),
          l = scale(parseFloat(match[3]), 0, 100),
          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
      return [h, s, l, a];
   }
}

function getHwb(string) {
   if (!string) {
      return;
   }
   var hwb = /^hwb\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
   var match = string.match(hwb);
   if (match) {
    var alpha = parseFloat(match[4]);
      var h = scale(parseInt(match[1]), 0, 360),
          w = scale(parseFloat(match[2]), 0, 100),
          b = scale(parseFloat(match[3]), 0, 100),
          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
      return [h, w, b, a];
   }
}

function getRgb(string) {
   var rgba = getRgba(string);
   return rgba && rgba.slice(0, 3);
}

function getHsl(string) {
  var hsla = getHsla(string);
  return hsla && hsla.slice(0, 3);
}

function getAlpha(string) {
   var vals = getRgba(string);
   if (vals) {
      return vals[3];
   }
   else if (vals = getHsla(string)) {
      return vals[3];
   }
   else if (vals = getHwb(string)) {
      return vals[3];
   }
}

// generators
function hexString(rgb) {
   return "#" + hexDouble(rgb[0]) + hexDouble(rgb[1])
              + hexDouble(rgb[2]);
}

function rgbString(rgba, alpha) {
   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
      return rgbaString(rgba, alpha);
   }
   return "rgb(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2] + ")";
}

function rgbaString(rgba, alpha) {
   if (alpha === undefined) {
      alpha = (rgba[3] !== undefined ? rgba[3] : 1);
   }
   return "rgba(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2]
           + ", " + alpha + ")";
}

function percentString(rgba, alpha) {
   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
      return percentaString(rgba, alpha);
   }
   var r = Math.round(rgba[0]/255 * 100),
       g = Math.round(rgba[1]/255 * 100),
       b = Math.round(rgba[2]/255 * 100);

   return "rgb(" + r + "%, " + g + "%, " + b + "%)";
}

function percentaString(rgba, alpha) {
   var r = Math.round(rgba[0]/255 * 100),
       g = Math.round(rgba[1]/255 * 100),
       b = Math.round(rgba[2]/255 * 100);
   return "rgba(" + r + "%, " + g + "%, " + b + "%, " + (alpha || rgba[3] || 1) + ")";
}

function hslString(hsla, alpha) {
   if (alpha < 1 || (hsla[3] && hsla[3] < 1)) {
      return hslaString(hsla, alpha);
   }
   return "hsl(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%)";
}

function hslaString(hsla, alpha) {
   if (alpha === undefined) {
      alpha = (hsla[3] !== undefined ? hsla[3] : 1);
   }
   return "hsla(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%, "
           + alpha + ")";
}

// hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
// (hwb have alpha optional & 1 is default value)
function hwbString(hwb, alpha) {
   if (alpha === undefined) {
      alpha = (hwb[3] !== undefined ? hwb[3] : 1);
   }
   return "hwb(" + hwb[0] + ", " + hwb[1] + "%, " + hwb[2] + "%"
           + (alpha !== undefined && alpha !== 1 ? ", " + alpha : "") + ")";
}

function keyword(rgb) {
  return reverseNames[rgb.slice(0, 3)];
}

// helpers
function scale(num, min, max) {
   return Math.min(Math.max(min, num), max);
}

function hexDouble(num) {
  var str = num.toString(16).toUpperCase();
  return (str.length < 2) ? "0" + str : str;
}


//create a list of reverse color names
var reverseNames = {};
for (var name in colorNames) {
   reverseNames[colorNames[name]] = name;
}


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
	"aliceblue": [240, 248, 255],
	"antiquewhite": [250, 235, 215],
	"aqua": [0, 255, 255],
	"aquamarine": [127, 255, 212],
	"azure": [240, 255, 255],
	"beige": [245, 245, 220],
	"bisque": [255, 228, 196],
	"black": [0, 0, 0],
	"blanchedalmond": [255, 235, 205],
	"blue": [0, 0, 255],
	"blueviolet": [138, 43, 226],
	"brown": [165, 42, 42],
	"burlywood": [222, 184, 135],
	"cadetblue": [95, 158, 160],
	"chartreuse": [127, 255, 0],
	"chocolate": [210, 105, 30],
	"coral": [255, 127, 80],
	"cornflowerblue": [100, 149, 237],
	"cornsilk": [255, 248, 220],
	"crimson": [220, 20, 60],
	"cyan": [0, 255, 255],
	"darkblue": [0, 0, 139],
	"darkcyan": [0, 139, 139],
	"darkgoldenrod": [184, 134, 11],
	"darkgray": [169, 169, 169],
	"darkgreen": [0, 100, 0],
	"darkgrey": [169, 169, 169],
	"darkkhaki": [189, 183, 107],
	"darkmagenta": [139, 0, 139],
	"darkolivegreen": [85, 107, 47],
	"darkorange": [255, 140, 0],
	"darkorchid": [153, 50, 204],
	"darkred": [139, 0, 0],
	"darksalmon": [233, 150, 122],
	"darkseagreen": [143, 188, 143],
	"darkslateblue": [72, 61, 139],
	"darkslategray": [47, 79, 79],
	"darkslategrey": [47, 79, 79],
	"darkturquoise": [0, 206, 209],
	"darkviolet": [148, 0, 211],
	"deeppink": [255, 20, 147],
	"deepskyblue": [0, 191, 255],
	"dimgray": [105, 105, 105],
	"dimgrey": [105, 105, 105],
	"dodgerblue": [30, 144, 255],
	"firebrick": [178, 34, 34],
	"floralwhite": [255, 250, 240],
	"forestgreen": [34, 139, 34],
	"fuchsia": [255, 0, 255],
	"gainsboro": [220, 220, 220],
	"ghostwhite": [248, 248, 255],
	"gold": [255, 215, 0],
	"goldenrod": [218, 165, 32],
	"gray": [128, 128, 128],
	"green": [0, 128, 0],
	"greenyellow": [173, 255, 47],
	"grey": [128, 128, 128],
	"honeydew": [240, 255, 240],
	"hotpink": [255, 105, 180],
	"indianred": [205, 92, 92],
	"indigo": [75, 0, 130],
	"ivory": [255, 255, 240],
	"khaki": [240, 230, 140],
	"lavender": [230, 230, 250],
	"lavenderblush": [255, 240, 245],
	"lawngreen": [124, 252, 0],
	"lemonchiffon": [255, 250, 205],
	"lightblue": [173, 216, 230],
	"lightcoral": [240, 128, 128],
	"lightcyan": [224, 255, 255],
	"lightgoldenrodyellow": [250, 250, 210],
	"lightgray": [211, 211, 211],
	"lightgreen": [144, 238, 144],
	"lightgrey": [211, 211, 211],
	"lightpink": [255, 182, 193],
	"lightsalmon": [255, 160, 122],
	"lightseagreen": [32, 178, 170],
	"lightskyblue": [135, 206, 250],
	"lightslategray": [119, 136, 153],
	"lightslategrey": [119, 136, 153],
	"lightsteelblue": [176, 196, 222],
	"lightyellow": [255, 255, 224],
	"lime": [0, 255, 0],
	"limegreen": [50, 205, 50],
	"linen": [250, 240, 230],
	"magenta": [255, 0, 255],
	"maroon": [128, 0, 0],
	"mediumaquamarine": [102, 205, 170],
	"mediumblue": [0, 0, 205],
	"mediumorchid": [186, 85, 211],
	"mediumpurple": [147, 112, 219],
	"mediumseagreen": [60, 179, 113],
	"mediumslateblue": [123, 104, 238],
	"mediumspringgreen": [0, 250, 154],
	"mediumturquoise": [72, 209, 204],
	"mediumvioletred": [199, 21, 133],
	"midnightblue": [25, 25, 112],
	"mintcream": [245, 255, 250],
	"mistyrose": [255, 228, 225],
	"moccasin": [255, 228, 181],
	"navajowhite": [255, 222, 173],
	"navy": [0, 0, 128],
	"oldlace": [253, 245, 230],
	"olive": [128, 128, 0],
	"olivedrab": [107, 142, 35],
	"orange": [255, 165, 0],
	"orangered": [255, 69, 0],
	"orchid": [218, 112, 214],
	"palegoldenrod": [238, 232, 170],
	"palegreen": [152, 251, 152],
	"paleturquoise": [175, 238, 238],
	"palevioletred": [219, 112, 147],
	"papayawhip": [255, 239, 213],
	"peachpuff": [255, 218, 185],
	"peru": [205, 133, 63],
	"pink": [255, 192, 203],
	"plum": [221, 160, 221],
	"powderblue": [176, 224, 230],
	"purple": [128, 0, 128],
	"rebeccapurple": [102, 51, 153],
	"red": [255, 0, 0],
	"rosybrown": [188, 143, 143],
	"royalblue": [65, 105, 225],
	"saddlebrown": [139, 69, 19],
	"salmon": [250, 128, 114],
	"sandybrown": [244, 164, 96],
	"seagreen": [46, 139, 87],
	"seashell": [255, 245, 238],
	"sienna": [160, 82, 45],
	"silver": [192, 192, 192],
	"skyblue": [135, 206, 235],
	"slateblue": [106, 90, 205],
	"slategray": [112, 128, 144],
	"slategrey": [112, 128, 144],
	"snow": [255, 250, 250],
	"springgreen": [0, 255, 127],
	"steelblue": [70, 130, 180],
	"tan": [210, 180, 140],
	"teal": [0, 128, 128],
	"thistle": [216, 191, 216],
	"tomato": [255, 99, 71],
	"turquoise": [64, 224, 208],
	"violet": [238, 130, 238],
	"wheat": [245, 222, 179],
	"white": [255, 255, 255],
	"whitesmoke": [245, 245, 245],
	"yellow": [255, 255, 0],
	"yellowgreen": [154, 205, 50]
};


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(2);
var Element = __webpack_require__(8);
var helpers = __webpack_require__(1);

defaults._set('global', {
	elements: {
		arc: {
			backgroundColor: defaults.global.defaultColor,
			borderColor: '#fff',
			borderWidth: 2
		}
	}
});

module.exports = Element.extend({
	inLabelRange: function(mouseX) {
		var vm = this._view;

		if (vm) {
			return (Math.pow(mouseX - vm.x, 2) < Math.pow(vm.radius + vm.hoverRadius, 2));
		}
		return false;
	},

	inRange: function(chartX, chartY) {
		var vm = this._view;

		if (vm) {
			var pointRelativePosition = helpers.getAngleFromPoint(vm, {x: chartX, y: chartY});
			var	angle = pointRelativePosition.angle;
			var distance = pointRelativePosition.distance;

			// Sanitise angle range
			var startAngle = vm.startAngle;
			var endAngle = vm.endAngle;
			while (endAngle < startAngle) {
				endAngle += 2.0 * Math.PI;
			}
			while (angle > endAngle) {
				angle -= 2.0 * Math.PI;
			}
			while (angle < startAngle) {
				angle += 2.0 * Math.PI;
			}

			// Check if within the range of the open/close angle
			var betweenAngles = (angle >= startAngle && angle <= endAngle);
			var withinRadius = (distance >= vm.innerRadius && distance <= vm.outerRadius);

			return (betweenAngles && withinRadius);
		}
		return false;
	},

	getCenterPoint: function() {
		var vm = this._view;
		var halfAngle = (vm.startAngle + vm.endAngle) / 2;
		var halfRadius = (vm.innerRadius + vm.outerRadius) / 2;
		return {
			x: vm.x + Math.cos(halfAngle) * halfRadius,
			y: vm.y + Math.sin(halfAngle) * halfRadius
		};
	},

	getArea: function() {
		var vm = this._view;
		return Math.PI * ((vm.endAngle - vm.startAngle) / (2 * Math.PI)) * (Math.pow(vm.outerRadius, 2) - Math.pow(vm.innerRadius, 2));
	},

	tooltipPosition: function() {
		var vm = this._view;
		var centreAngle = vm.startAngle + ((vm.endAngle - vm.startAngle) / 2);
		var rangeFromCentre = (vm.outerRadius - vm.innerRadius) / 2 + vm.innerRadius;

		return {
			x: vm.x + (Math.cos(centreAngle) * rangeFromCentre),
			y: vm.y + (Math.sin(centreAngle) * rangeFromCentre)
		};
	},

	draw: function() {
		var ctx = this._chart.ctx;
		var vm = this._view;
		var sA = vm.startAngle;
		var eA = vm.endAngle;

		ctx.beginPath();

		ctx.arc(vm.x, vm.y, vm.outerRadius, sA, eA);
		ctx.arc(vm.x, vm.y, vm.innerRadius, eA, sA, true);

		ctx.closePath();
		ctx.strokeStyle = vm.borderColor;
		ctx.lineWidth = vm.borderWidth;

		ctx.fillStyle = vm.backgroundColor;

		ctx.fill();
		ctx.lineJoin = 'bevel';

		if (vm.borderWidth) {
			ctx.stroke();
		}
	}
});


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(2);
var Element = __webpack_require__(8);
var helpers = __webpack_require__(1);

var globalDefaults = defaults.global;

defaults._set('global', {
	elements: {
		line: {
			tension: 0.4,
			backgroundColor: globalDefaults.defaultColor,
			borderWidth: 3,
			borderColor: globalDefaults.defaultColor,
			borderCapStyle: 'butt',
			borderDash: [],
			borderDashOffset: 0.0,
			borderJoinStyle: 'miter',
			capBezierPoints: true,
			fill: true, // do we fill in the area between the line and its base axis
		}
	}
});

module.exports = Element.extend({
	draw: function() {
		var me = this;
		var vm = me._view;
		var ctx = me._chart.ctx;
		var spanGaps = vm.spanGaps;
		var points = me._children.slice(); // clone array
		var globalOptionLineElements = globalDefaults.elements.line;
		var lastDrawnIndex = -1;
		var index, current, previous, currentVM;

		// If we are looping, adding the first point again
		if (me._loop && points.length) {
			points.push(points[0]);
		}

		ctx.save();

		// Stroke Line Options
		ctx.lineCap = vm.borderCapStyle || globalOptionLineElements.borderCapStyle;

		// IE 9 and 10 do not support line dash
		if (ctx.setLineDash) {
			ctx.setLineDash(vm.borderDash || globalOptionLineElements.borderDash);
		}

		ctx.lineDashOffset = vm.borderDashOffset || globalOptionLineElements.borderDashOffset;
		ctx.lineJoin = vm.borderJoinStyle || globalOptionLineElements.borderJoinStyle;
		ctx.lineWidth = vm.borderWidth || globalOptionLineElements.borderWidth;
		ctx.strokeStyle = vm.borderColor || globalDefaults.defaultColor;

		// Stroke Line
		ctx.beginPath();
		lastDrawnIndex = -1;

		for (index = 0; index < points.length; ++index) {
			current = points[index];
			previous = helpers.previousItem(points, index);
			currentVM = current._view;

			// First point moves to it's starting position no matter what
			if (index === 0) {
				if (!currentVM.skip) {
					ctx.moveTo(currentVM.x, currentVM.y);
					lastDrawnIndex = index;
				}
			} else {
				previous = lastDrawnIndex === -1 ? previous : points[lastDrawnIndex];

				if (!currentVM.skip) {
					if ((lastDrawnIndex !== (index - 1) && !spanGaps) || lastDrawnIndex === -1) {
						// There was a gap and this is the first point after the gap
						ctx.moveTo(currentVM.x, currentVM.y);
					} else {
						// Line to next point
						helpers.canvas.lineTo(ctx, previous._view, current._view);
					}
					lastDrawnIndex = index;
				}
			}
		}

		ctx.stroke();
		ctx.restore();
	}
});


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(2);
var Element = __webpack_require__(8);
var helpers = __webpack_require__(1);

var defaultColor = defaults.global.defaultColor;

defaults._set('global', {
	elements: {
		point: {
			radius: 3,
			pointStyle: 'circle',
			backgroundColor: defaultColor,
			borderColor: defaultColor,
			borderWidth: 1,
			// Hover
			hitRadius: 1,
			hoverRadius: 4,
			hoverBorderWidth: 1
		}
	}
});

function xRange(mouseX) {
	var vm = this._view;
	return vm ? (Math.abs(mouseX - vm.x) < vm.radius + vm.hitRadius) : false;
}

function yRange(mouseY) {
	var vm = this._view;
	return vm ? (Math.abs(mouseY - vm.y) < vm.radius + vm.hitRadius) : false;
}

module.exports = Element.extend({
	inRange: function(mouseX, mouseY) {
		var vm = this._view;
		return vm ? ((Math.pow(mouseX - vm.x, 2) + Math.pow(mouseY - vm.y, 2)) < Math.pow(vm.hitRadius + vm.radius, 2)) : false;
	},

	inLabelRange: xRange,
	inXRange: xRange,
	inYRange: yRange,

	getCenterPoint: function() {
		var vm = this._view;
		return {
			x: vm.x,
			y: vm.y
		};
	},

	getArea: function() {
		return Math.PI * Math.pow(this._view.radius, 2);
	},

	tooltipPosition: function() {
		var vm = this._view;
		return {
			x: vm.x,
			y: vm.y,
			padding: vm.radius + vm.borderWidth
		};
	},

	draw: function(chartArea) {
		var vm = this._view;
		var model = this._model;
		var ctx = this._chart.ctx;
		var pointStyle = vm.pointStyle;
		var radius = vm.radius;
		var x = vm.x;
		var y = vm.y;
		var color = helpers.color;
		var errMargin = 1.01; // 1.01 is margin for Accumulated error. (Especially Edge, IE.)
		var ratio = 0;

		if (vm.skip) {
			return;
		}

		ctx.strokeStyle = vm.borderColor || defaultColor;
		ctx.lineWidth = helpers.valueOrDefault(vm.borderWidth, defaults.global.elements.point.borderWidth);
		ctx.fillStyle = vm.backgroundColor || defaultColor;

		// Cliping for Points.
		// going out from inner charArea?
		if ((chartArea !== undefined) && ((model.x < chartArea.left) || (chartArea.right * errMargin < model.x) || (model.y < chartArea.top) || (chartArea.bottom * errMargin < model.y))) {
			// Point fade out
			if (model.x < chartArea.left) {
				ratio = (x - model.x) / (chartArea.left - model.x);
			} else if (chartArea.right * errMargin < model.x) {
				ratio = (model.x - x) / (model.x - chartArea.right);
			} else if (model.y < chartArea.top) {
				ratio = (y - model.y) / (chartArea.top - model.y);
			} else if (chartArea.bottom * errMargin < model.y) {
				ratio = (model.y - y) / (model.y - chartArea.bottom);
			}
			ratio = Math.round(ratio * 100) / 100;
			ctx.strokeStyle = color(ctx.strokeStyle).alpha(ratio).rgbString();
			ctx.fillStyle = color(ctx.fillStyle).alpha(ratio).rgbString();
		}

		helpers.canvas.drawPoint(ctx, pointStyle, radius, x, y);
	}
});


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(2);
var Element = __webpack_require__(8);

defaults._set('global', {
	elements: {
		rectangle: {
			backgroundColor: defaults.global.defaultColor,
			borderColor: defaults.global.defaultColor,
			borderSkipped: 'bottom',
			borderWidth: 0
		}
	}
});

function isVertical(bar) {
	return bar._view.width !== undefined;
}

/**
 * Helper function to get the bounds of the bar regardless of the orientation
 * @param bar {Chart.Element.Rectangle} the bar
 * @return {Bounds} bounds of the bar
 * @private
 */
function getBarBounds(bar) {
	var vm = bar._view;
	var x1, x2, y1, y2;

	if (isVertical(bar)) {
		// vertical
		var halfWidth = vm.width / 2;
		x1 = vm.x - halfWidth;
		x2 = vm.x + halfWidth;
		y1 = Math.min(vm.y, vm.base);
		y2 = Math.max(vm.y, vm.base);
	} else {
		// horizontal bar
		var halfHeight = vm.height / 2;
		x1 = Math.min(vm.x, vm.base);
		x2 = Math.max(vm.x, vm.base);
		y1 = vm.y - halfHeight;
		y2 = vm.y + halfHeight;
	}

	return {
		left: x1,
		top: y1,
		right: x2,
		bottom: y2
	};
}

module.exports = Element.extend({
	draw: function() {
		var ctx = this._chart.ctx;
		var vm = this._view;
		var left, right, top, bottom, signX, signY, borderSkipped;
		var borderWidth = vm.borderWidth;

		if (!vm.horizontal) {
			// bar
			left = vm.x - vm.width / 2;
			right = vm.x + vm.width / 2;
			top = vm.y;
			bottom = vm.base;
			signX = 1;
			signY = bottom > top ? 1 : -1;
			borderSkipped = vm.borderSkipped || 'bottom';
		} else {
			// horizontal bar
			left = vm.base;
			right = vm.x;
			top = vm.y - vm.height / 2;
			bottom = vm.y + vm.height / 2;
			signX = right > left ? 1 : -1;
			signY = 1;
			borderSkipped = vm.borderSkipped || 'left';
		}

		// Canvas doesn't allow us to stroke inside the width so we can
		// adjust the sizes to fit if we're setting a stroke on the line
		if (borderWidth) {
			// borderWidth shold be less than bar width and bar height.
			var barSize = Math.min(Math.abs(left - right), Math.abs(top - bottom));
			borderWidth = borderWidth > barSize ? barSize : borderWidth;
			var halfStroke = borderWidth / 2;
			// Adjust borderWidth when bar top position is near vm.base(zero).
			var borderLeft = left + (borderSkipped !== 'left' ? halfStroke * signX : 0);
			var borderRight = right + (borderSkipped !== 'right' ? -halfStroke * signX : 0);
			var borderTop = top + (borderSkipped !== 'top' ? halfStroke * signY : 0);
			var borderBottom = bottom + (borderSkipped !== 'bottom' ? -halfStroke * signY : 0);
			// not become a vertical line?
			if (borderLeft !== borderRight) {
				top = borderTop;
				bottom = borderBottom;
			}
			// not become a horizontal line?
			if (borderTop !== borderBottom) {
				left = borderLeft;
				right = borderRight;
			}
		}

		ctx.beginPath();
		ctx.fillStyle = vm.backgroundColor;
		ctx.strokeStyle = vm.borderColor;
		ctx.lineWidth = borderWidth;

		// Corner points, from bottom-left to bottom-right clockwise
		// | 1 2 |
		// | 0 3 |
		var corners = [
			[left, bottom],
			[left, top],
			[right, top],
			[right, bottom]
		];

		// Find first (starting) corner with fallback to 'bottom'
		var borders = ['bottom', 'left', 'top', 'right'];
		var startCorner = borders.indexOf(borderSkipped, 0);
		if (startCorner === -1) {
			startCorner = 0;
		}

		function cornerAt(index) {
			return corners[(startCorner + index) % 4];
		}

		// Draw rectangle from 'startCorner'
		var corner = cornerAt(0);
		ctx.moveTo(corner[0], corner[1]);

		for (var i = 1; i < 4; i++) {
			corner = cornerAt(i);
			ctx.lineTo(corner[0], corner[1]);
		}

		ctx.fill();
		if (borderWidth) {
			ctx.stroke();
		}
	},

	height: function() {
		var vm = this._view;
		return vm.base - vm.y;
	},

	inRange: function(mouseX, mouseY) {
		var inRange = false;

		if (this._view) {
			var bounds = getBarBounds(this);
			inRange = mouseX >= bounds.left && mouseX <= bounds.right && mouseY >= bounds.top && mouseY <= bounds.bottom;
		}

		return inRange;
	},

	inLabelRange: function(mouseX, mouseY) {
		var me = this;
		if (!me._view) {
			return false;
		}

		var inRange = false;
		var bounds = getBarBounds(me);

		if (isVertical(me)) {
			inRange = mouseX >= bounds.left && mouseX <= bounds.right;
		} else {
			inRange = mouseY >= bounds.top && mouseY <= bounds.bottom;
		}

		return inRange;
	},

	inXRange: function(mouseX) {
		var bounds = getBarBounds(this);
		return mouseX >= bounds.left && mouseX <= bounds.right;
	},

	inYRange: function(mouseY) {
		var bounds = getBarBounds(this);
		return mouseY >= bounds.top && mouseY <= bounds.bottom;
	},

	getCenterPoint: function() {
		var vm = this._view;
		var x, y;
		if (isVertical(this)) {
			x = vm.x;
			y = (vm.y + vm.base) / 2;
		} else {
			x = (vm.x + vm.base) / 2;
			y = vm.y;
		}

		return {x: x, y: y};
	},

	getArea: function() {
		var vm = this._view;
		return vm.width * Math.abs(vm.y - vm.base);
	},

	tooltipPosition: function() {
		var vm = this._view;
		return {
			x: vm.x,
			y: vm.y
		};
	}
});


/***/ }),
/* 204 */
/***/ (function(module, exports) {

/**
 * Platform fallback implementation (minimal).
 * @see https://github.com/chartjs/Chart.js/pull/4591#issuecomment-319575939
 */

module.exports = {
	acquireContext: function(item) {
		if (item && item.canvas) {
			// Support for any object associated to a canvas (including a context2d)
			item = item.canvas;
		}

		return item && item.getContext('2d') || null;
	}
};


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Chart.Platform implementation for targeting a web browser
 */



var helpers = __webpack_require__(1);

var EXPANDO_KEY = '$chartjs';
var CSS_PREFIX = 'chartjs-';
var CSS_RENDER_MONITOR = CSS_PREFIX + 'render-monitor';
var CSS_RENDER_ANIMATION = CSS_PREFIX + 'render-animation';
var ANIMATION_START_EVENTS = ['animationstart', 'webkitAnimationStart'];

/**
 * DOM event types -> Chart.js event types.
 * Note: only events with different types are mapped.
 * @see https://developer.mozilla.org/en-US/docs/Web/Events
 */
var EVENT_TYPES = {
	touchstart: 'mousedown',
	touchmove: 'mousemove',
	touchend: 'mouseup',
	pointerenter: 'mouseenter',
	pointerdown: 'mousedown',
	pointermove: 'mousemove',
	pointerup: 'mouseup',
	pointerleave: 'mouseout',
	pointerout: 'mouseout'
};

/**
 * The "used" size is the final value of a dimension property after all calculations have
 * been performed. This method uses the computed style of `element` but returns undefined
 * if the computed style is not expressed in pixels. That can happen in some cases where
 * `element` has a size relative to its parent and this last one is not yet displayed,
 * for example because of `display: none` on a parent node.
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/used_value
 * @returns {Number} Size in pixels or undefined if unknown.
 */
function readUsedSize(element, property) {
	var value = helpers.getStyle(element, property);
	var matches = value && value.match(/^(\d+)(\.\d+)?px$/);
	return matches ? Number(matches[1]) : undefined;
}

/**
 * Initializes the canvas style and render size without modifying the canvas display size,
 * since responsiveness is handled by the controller.resize() method. The config is used
 * to determine the aspect ratio to apply in case no explicit height has been specified.
 */
function initCanvas(canvas, config) {
	var style = canvas.style;

	// NOTE(SB) canvas.getAttribute('width') !== canvas.width: in the first case it
	// returns null or '' if no explicit value has been set to the canvas attribute.
	var renderHeight = canvas.getAttribute('height');
	var renderWidth = canvas.getAttribute('width');

	// Chart.js modifies some canvas values that we want to restore on destroy
	canvas[EXPANDO_KEY] = {
		initial: {
			height: renderHeight,
			width: renderWidth,
			style: {
				display: style.display,
				height: style.height,
				width: style.width
			}
		}
	};

	// Force canvas to display as block to avoid extra space caused by inline
	// elements, which would interfere with the responsive resize process.
	// https://github.com/chartjs/Chart.js/issues/2538
	style.display = style.display || 'block';

	if (renderWidth === null || renderWidth === '') {
		var displayWidth = readUsedSize(canvas, 'width');
		if (displayWidth !== undefined) {
			canvas.width = displayWidth;
		}
	}

	if (renderHeight === null || renderHeight === '') {
		if (canvas.style.height === '') {
			// If no explicit render height and style height, let's apply the aspect ratio,
			// which one can be specified by the user but also by charts as default option
			// (i.e. options.aspectRatio). If not specified, use canvas aspect ratio of 2.
			canvas.height = canvas.width / (config.options.aspectRatio || 2);
		} else {
			var displayHeight = readUsedSize(canvas, 'height');
			if (displayWidth !== undefined) {
				canvas.height = displayHeight;
			}
		}
	}

	return canvas;
}

/**
 * Detects support for options object argument in addEventListener.
 * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
 * @private
 */
var supportsEventListenerOptions = (function() {
	var supports = false;
	try {
		var options = Object.defineProperty({}, 'passive', {
			get: function() {
				supports = true;
			}
		});
		window.addEventListener('e', null, options);
	} catch (e) {
		// continue regardless of error
	}
	return supports;
}());

// Default passive to true as expected by Chrome for 'touchstart' and 'touchend' events.
// https://github.com/chartjs/Chart.js/issues/4287
var eventListenerOptions = supportsEventListenerOptions ? {passive: true} : false;

function addEventListener(node, type, listener) {
	node.addEventListener(type, listener, eventListenerOptions);
}

function removeEventListener(node, type, listener) {
	node.removeEventListener(type, listener, eventListenerOptions);
}

function createEvent(type, chart, x, y, nativeEvent) {
	return {
		type: type,
		chart: chart,
		native: nativeEvent || null,
		x: x !== undefined ? x : null,
		y: y !== undefined ? y : null,
	};
}

function fromNativeEvent(event, chart) {
	var type = EVENT_TYPES[event.type] || event.type;
	var pos = helpers.getRelativePosition(event, chart);
	return createEvent(type, chart, pos.x, pos.y, event);
}

function throttled(fn, thisArg) {
	var ticking = false;
	var args = [];

	return function() {
		args = Array.prototype.slice.call(arguments);
		thisArg = thisArg || this;

		if (!ticking) {
			ticking = true;
			helpers.requestAnimFrame.call(window, function() {
				ticking = false;
				fn.apply(thisArg, args);
			});
		}
	};
}

// Implementation based on https://github.com/marcj/css-element-queries
function createResizer(handler) {
	var resizer = document.createElement('div');
	var cls = CSS_PREFIX + 'size-monitor';
	var maxSize = 1000000;
	var style =
		'position:absolute;' +
		'left:0;' +
		'top:0;' +
		'right:0;' +
		'bottom:0;' +
		'overflow:hidden;' +
		'pointer-events:none;' +
		'visibility:hidden;' +
		'z-index:-1;';

	resizer.style.cssText = style;
	resizer.className = cls;
	resizer.innerHTML =
		'<div class="' + cls + '-expand" style="' + style + '">' +
			'<div style="' +
				'position:absolute;' +
				'width:' + maxSize + 'px;' +
				'height:' + maxSize + 'px;' +
				'left:0;' +
				'top:0">' +
			'</div>' +
		'</div>' +
		'<div class="' + cls + '-shrink" style="' + style + '">' +
			'<div style="' +
				'position:absolute;' +
				'width:200%;' +
				'height:200%;' +
				'left:0; ' +
				'top:0">' +
			'</div>' +
		'</div>';

	var expand = resizer.childNodes[0];
	var shrink = resizer.childNodes[1];

	resizer._reset = function() {
		expand.scrollLeft = maxSize;
		expand.scrollTop = maxSize;
		shrink.scrollLeft = maxSize;
		shrink.scrollTop = maxSize;
	};
	var onScroll = function() {
		resizer._reset();
		handler();
	};

	addEventListener(expand, 'scroll', onScroll.bind(expand, 'expand'));
	addEventListener(shrink, 'scroll', onScroll.bind(shrink, 'shrink'));

	return resizer;
}

// https://davidwalsh.name/detect-node-insertion
function watchForRender(node, handler) {
	var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});
	var proxy = expando.renderProxy = function(e) {
		if (e.animationName === CSS_RENDER_ANIMATION) {
			handler();
		}
	};

	helpers.each(ANIMATION_START_EVENTS, function(type) {
		addEventListener(node, type, proxy);
	});

	// #4737: Chrome might skip the CSS animation when the CSS_RENDER_MONITOR class
	// is removed then added back immediately (same animation frame?). Accessing the
	// `offsetParent` property will force a reflow and re-evaluate the CSS animation.
	// https://gist.github.com/paulirish/5d52fb081b3570c81e3a#box-metrics
	// https://github.com/chartjs/Chart.js/issues/4737
	expando.reflow = !!node.offsetParent;

	node.classList.add(CSS_RENDER_MONITOR);
}

function unwatchForRender(node) {
	var expando = node[EXPANDO_KEY] || {};
	var proxy = expando.renderProxy;

	if (proxy) {
		helpers.each(ANIMATION_START_EVENTS, function(type) {
			removeEventListener(node, type, proxy);
		});

		delete expando.renderProxy;
	}

	node.classList.remove(CSS_RENDER_MONITOR);
}

function addResizeListener(node, listener, chart) {
	var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});

	// Let's keep track of this added resizer and thus avoid DOM query when removing it.
	var resizer = expando.resizer = createResizer(throttled(function() {
		if (expando.resizer) {
			return listener(createEvent('resize', chart));
		}
	}));

	// The resizer needs to be attached to the node parent, so we first need to be
	// sure that `node` is attached to the DOM before injecting the resizer element.
	watchForRender(node, function() {
		if (expando.resizer) {
			var container = node.parentNode;
			if (container && container !== resizer.parentNode) {
				container.insertBefore(resizer, container.firstChild);
			}

			// The container size might have changed, let's reset the resizer state.
			resizer._reset();
		}
	});
}

function removeResizeListener(node) {
	var expando = node[EXPANDO_KEY] || {};
	var resizer = expando.resizer;

	delete expando.resizer;
	unwatchForRender(node);

	if (resizer && resizer.parentNode) {
		resizer.parentNode.removeChild(resizer);
	}
}

function injectCSS(platform, css) {
	// http://stackoverflow.com/q/3922139
	var style = platform._style || document.createElement('style');
	if (!platform._style) {
		platform._style = style;
		css = '/* Chart.js */\n' + css;
		style.setAttribute('type', 'text/css');
		document.getElementsByTagName('head')[0].appendChild(style);
	}

	style.appendChild(document.createTextNode(css));
}

module.exports = {
	/**
	 * This property holds whether this platform is enabled for the current environment.
	 * Currently used by platform.js to select the proper implementation.
	 * @private
	 */
	_enabled: typeof window !== 'undefined' && typeof document !== 'undefined',

	initialize: function() {
		var keyframes = 'from{opacity:0.99}to{opacity:1}';

		injectCSS(this,
			// DOM rendering detection
			// https://davidwalsh.name/detect-node-insertion
			'@-webkit-keyframes ' + CSS_RENDER_ANIMATION + '{' + keyframes + '}' +
			'@keyframes ' + CSS_RENDER_ANIMATION + '{' + keyframes + '}' +
			'.' + CSS_RENDER_MONITOR + '{' +
				'-webkit-animation:' + CSS_RENDER_ANIMATION + ' 0.001s;' +
				'animation:' + CSS_RENDER_ANIMATION + ' 0.001s;' +
			'}'
		);
	},

	acquireContext: function(item, config) {
		if (typeof item === 'string') {
			item = document.getElementById(item);
		} else if (item.length) {
			// Support for array based queries (such as jQuery)
			item = item[0];
		}

		if (item && item.canvas) {
			// Support for any object associated to a canvas (including a context2d)
			item = item.canvas;
		}

		// To prevent canvas fingerprinting, some add-ons undefine the getContext
		// method, for example: https://github.com/kkapsner/CanvasBlocker
		// https://github.com/chartjs/Chart.js/issues/2807
		var context = item && item.getContext && item.getContext('2d');

		// `instanceof HTMLCanvasElement/CanvasRenderingContext2D` fails when the item is
		// inside an iframe or when running in a protected environment. We could guess the
		// types from their toString() value but let's keep things flexible and assume it's
		// a sufficient condition if the item has a context2D which has item as `canvas`.
		// https://github.com/chartjs/Chart.js/issues/3887
		// https://github.com/chartjs/Chart.js/issues/4102
		// https://github.com/chartjs/Chart.js/issues/4152
		if (context && context.canvas === item) {
			initCanvas(item, config);
			return context;
		}

		return null;
	},

	releaseContext: function(context) {
		var canvas = context.canvas;
		if (!canvas[EXPANDO_KEY]) {
			return;
		}

		var initial = canvas[EXPANDO_KEY].initial;
		['height', 'width'].forEach(function(prop) {
			var value = initial[prop];
			if (helpers.isNullOrUndef(value)) {
				canvas.removeAttribute(prop);
			} else {
				canvas.setAttribute(prop, value);
			}
		});

		helpers.each(initial.style || {}, function(value, key) {
			canvas.style[key] = value;
		});

		// The canvas render size might have been changed (and thus the state stack discarded),
		// we can't use save() and restore() to restore the initial state. So make sure that at
		// least the canvas context is reset to the default state by setting the canvas width.
		// https://www.w3.org/TR/2011/WD-html5-20110525/the-canvas-element.html
		canvas.width = canvas.width;

		delete canvas[EXPANDO_KEY];
	},

	addEventListener: function(chart, type, listener) {
		var canvas = chart.canvas;
		if (type === 'resize') {
			// Note: the resize event is not supported on all browsers.
			addResizeListener(canvas, listener, chart);
			return;
		}

		var expando = listener[EXPANDO_KEY] || (listener[EXPANDO_KEY] = {});
		var proxies = expando.proxies || (expando.proxies = {});
		var proxy = proxies[chart.id + '_' + type] = function(event) {
			listener(fromNativeEvent(event, chart));
		};

		addEventListener(canvas, type, proxy);
	},

	removeEventListener: function(chart, type, listener) {
		var canvas = chart.canvas;
		if (type === 'resize') {
			// Note: the resize event is not supported on all browsers.
			removeResizeListener(canvas, listener);
			return;
		}

		var expando = listener[EXPANDO_KEY] || {};
		var proxies = expando.proxies || {};
		var proxy = proxies[chart.id + '_' + type];
		if (!proxy) {
			return;
		}

		removeEventListener(canvas, type, proxy);
	}
};

// DEPRECATIONS

/**
 * Provided for backward compatibility, use EventTarget.addEventListener instead.
 * EventTarget.addEventListener compatibility: Chrome, Opera 7, Safari, FF1.5+, IE9+
 * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener
 * @function Chart.helpers.addEvent
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.addEvent = addEventListener;

/**
 * Provided for backward compatibility, use EventTarget.removeEventListener instead.
 * EventTarget.removeEventListener compatibility: Chrome, Opera 7, Safari, FF1.5+, IE9+
 * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/removeEventListener
 * @function Chart.helpers.removeEvent
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.removeEvent = removeEventListener;


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* global window: false */


var defaults = __webpack_require__(2);
var Element = __webpack_require__(8);
var helpers = __webpack_require__(1);

defaults._set('global', {
	animation: {
		duration: 1000,
		easing: 'easeOutQuart',
		onProgress: helpers.noop,
		onComplete: helpers.noop
	}
});

module.exports = function(Chart) {

	Chart.Animation = Element.extend({
		chart: null, // the animation associated chart instance
		currentStep: 0, // the current animation step
		numSteps: 60, // default number of steps
		easing: '', // the easing to use for this animation
		render: null, // render function used by the animation service

		onAnimationProgress: null, // user specified callback to fire on each step of the animation
		onAnimationComplete: null, // user specified callback to fire when the animation finishes
	});

	Chart.animationService = {
		frameDuration: 17,
		animations: [],
		dropFrames: 0,
		request: null,

		/**
		 * @param {Chart} chart - The chart to animate.
		 * @param {Chart.Animation} animation - The animation that we will animate.
		 * @param {Number} duration - The animation duration in ms.
		 * @param {Boolean} lazy - if true, the chart is not marked as animating to enable more responsive interactions
		 */
		addAnimation: function(chart, animation, duration, lazy) {
			var animations = this.animations;
			var i, ilen;

			animation.chart = chart;

			if (!lazy) {
				chart.animating = true;
			}

			for (i = 0, ilen = animations.length; i < ilen; ++i) {
				if (animations[i].chart === chart) {
					animations[i] = animation;
					return;
				}
			}

			animations.push(animation);

			// If there are no animations queued, manually kickstart a digest, for lack of a better word
			if (animations.length === 1) {
				this.requestAnimationFrame();
			}
		},

		cancelAnimation: function(chart) {
			var index = helpers.findIndex(this.animations, function(animation) {
				return animation.chart === chart;
			});

			if (index !== -1) {
				this.animations.splice(index, 1);
				chart.animating = false;
			}
		},

		requestAnimationFrame: function() {
			var me = this;
			if (me.request === null) {
				// Skip animation frame requests until the active one is executed.
				// This can happen when processing mouse events, e.g. 'mousemove'
				// and 'mouseout' events will trigger multiple renders.
				me.request = helpers.requestAnimFrame.call(window, function() {
					me.request = null;
					me.startDigest();
				});
			}
		},

		/**
		 * @private
		 */
		startDigest: function() {
			var me = this;
			var startTime = Date.now();
			var framesToDrop = 0;

			if (me.dropFrames > 1) {
				framesToDrop = Math.floor(me.dropFrames);
				me.dropFrames = me.dropFrames % 1;
			}

			me.advance(1 + framesToDrop);

			var endTime = Date.now();

			me.dropFrames += (endTime - startTime) / me.frameDuration;

			// Do we have more stuff to animate?
			if (me.animations.length > 0) {
				me.requestAnimationFrame();
			}
		},

		/**
		 * @private
		 */
		advance: function(count) {
			var animations = this.animations;
			var animation, chart;
			var i = 0;

			while (i < animations.length) {
				animation = animations[i];
				chart = animation.chart;

				animation.currentStep = (animation.currentStep || 0) + count;
				animation.currentStep = Math.min(animation.currentStep, animation.numSteps);

				helpers.callback(animation.render, [chart, animation], chart);
				helpers.callback(animation.onAnimationProgress, [animation], chart);

				if (animation.currentStep >= animation.numSteps) {
					helpers.callback(animation.onAnimationComplete, [animation], chart);
					chart.animating = false;
					animations.splice(i, 1);
				} else {
					++i;
				}
			}
		}
	};

	/**
	 * Provided for backward compatibility, use Chart.Animation instead
	 * @prop Chart.Animation#animationObject
	 * @deprecated since version 2.6.0
	 * @todo remove at version 3
	 */
	Object.defineProperty(Chart.Animation.prototype, 'animationObject', {
		get: function() {
			return this;
		}
	});

	/**
	 * Provided for backward compatibility, use Chart.Animation#chart instead
	 * @prop Chart.Animation#chartInstance
	 * @deprecated since version 2.6.0
	 * @todo remove at version 3
	 */
	Object.defineProperty(Chart.Animation.prototype, 'chartInstance', {
		get: function() {
			return this.chart;
		},
		set: function(value) {
			this.chart = value;
		}
	});

};


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(2);
var helpers = __webpack_require__(1);
var Interaction = __webpack_require__(75);
var layouts = __webpack_require__(21);
var platform = __webpack_require__(76);
var plugins = __webpack_require__(77);

module.exports = function(Chart) {

	// Create a dictionary of chart types, to allow for extension of existing types
	Chart.types = {};

	// Store a reference to each instance - allowing us to globally resize chart instances on window resize.
	// Destroy method on the chart will remove the instance of the chart from this reference.
	Chart.instances = {};

	// Controllers available for dataset visualization eg. bar, line, slice, etc.
	Chart.controllers = {};

	/**
	 * Initializes the given config with global and chart default values.
	 */
	function initConfig(config) {
		config = config || {};

		// Do NOT use configMerge() for the data object because this method merges arrays
		// and so would change references to labels and datasets, preventing data updates.
		var data = config.data = config.data || {};
		data.datasets = data.datasets || [];
		data.labels = data.labels || [];

		config.options = helpers.configMerge(
			defaults.global,
			defaults[config.type],
			config.options || {});

		return config;
	}

	/**
	 * Updates the config of the chart
	 * @param chart {Chart} chart to update the options for
	 */
	function updateConfig(chart) {
		var newOptions = chart.options;

		helpers.each(chart.scales, function(scale) {
			layouts.removeBox(chart, scale);
		});

		newOptions = helpers.configMerge(
			Chart.defaults.global,
			Chart.defaults[chart.config.type],
			newOptions);

		chart.options = chart.config.options = newOptions;
		chart.ensureScalesHaveIDs();
		chart.buildOrUpdateScales();
		// Tooltip
		chart.tooltip._options = newOptions.tooltips;
		chart.tooltip.initialize();
	}

	function positionIsHorizontal(position) {
		return position === 'top' || position === 'bottom';
	}

	helpers.extend(Chart.prototype, /** @lends Chart */ {
		/**
		 * @private
		 */
		construct: function(item, config) {
			var me = this;

			config = initConfig(config);

			var context = platform.acquireContext(item, config);
			var canvas = context && context.canvas;
			var height = canvas && canvas.height;
			var width = canvas && canvas.width;

			me.id = helpers.uid();
			me.ctx = context;
			me.canvas = canvas;
			me.config = config;
			me.width = width;
			me.height = height;
			me.aspectRatio = height ? width / height : null;
			me.options = config.options;
			me._bufferedRender = false;

			/**
			 * Provided for backward compatibility, Chart and Chart.Controller have been merged,
			 * the "instance" still need to be defined since it might be called from plugins.
			 * @prop Chart#chart
			 * @deprecated since version 2.6.0
			 * @todo remove at version 3
			 * @private
			 */
			me.chart = me;
			me.controller = me; // chart.chart.controller #inception

			// Add the chart instance to the global namespace
			Chart.instances[me.id] = me;

			// Define alias to the config data: `chart.data === chart.config.data`
			Object.defineProperty(me, 'data', {
				get: function() {
					return me.config.data;
				},
				set: function(value) {
					me.config.data = value;
				}
			});

			if (!context || !canvas) {
				// The given item is not a compatible context2d element, let's return before finalizing
				// the chart initialization but after setting basic chart / controller properties that
				// can help to figure out that the chart is not valid (e.g chart.canvas !== null);
				// https://github.com/chartjs/Chart.js/issues/2807
				console.error("Failed to create chart: can't acquire context from the given item");
				return;
			}

			me.initialize();
			me.update();
		},

		/**
		 * @private
		 */
		initialize: function() {
			var me = this;

			// Before init plugin notification
			plugins.notify(me, 'beforeInit');

			helpers.retinaScale(me, me.options.devicePixelRatio);

			me.bindEvents();

			if (me.options.responsive) {
				// Initial resize before chart draws (must be silent to preserve initial animations).
				me.resize(true);
			}

			// Make sure scales have IDs and are built before we build any controllers.
			me.ensureScalesHaveIDs();
			me.buildOrUpdateScales();
			me.initToolTip();

			// After init plugin notification
			plugins.notify(me, 'afterInit');

			return me;
		},

		clear: function() {
			helpers.canvas.clear(this);
			return this;
		},

		stop: function() {
			// Stops any current animation loop occurring
			Chart.animationService.cancelAnimation(this);
			return this;
		},

		resize: function(silent) {
			var me = this;
			var options = me.options;
			var canvas = me.canvas;
			var aspectRatio = (options.maintainAspectRatio && me.aspectRatio) || null;

			// the canvas render width and height will be casted to integers so make sure that
			// the canvas display style uses the same integer values to avoid blurring effect.

			// Set to 0 instead of canvas.size because the size defaults to 300x150 if the element is collased
			var newWidth = Math.max(0, Math.floor(helpers.getMaximumWidth(canvas)));
			var newHeight = Math.max(0, Math.floor(aspectRatio ? newWidth / aspectRatio : helpers.getMaximumHeight(canvas)));

			if (me.width === newWidth && me.height === newHeight) {
				return;
			}

			canvas.width = me.width = newWidth;
			canvas.height = me.height = newHeight;
			canvas.style.width = newWidth + 'px';
			canvas.style.height = newHeight + 'px';

			helpers.retinaScale(me, options.devicePixelRatio);

			if (!silent) {
				// Notify any plugins about the resize
				var newSize = {width: newWidth, height: newHeight};
				plugins.notify(me, 'resize', [newSize]);

				// Notify of resize
				if (me.options.onResize) {
					me.options.onResize(me, newSize);
				}

				me.stop();
				me.update(me.options.responsiveAnimationDuration);
			}
		},

		ensureScalesHaveIDs: function() {
			var options = this.options;
			var scalesOptions = options.scales || {};
			var scaleOptions = options.scale;

			helpers.each(scalesOptions.xAxes, function(xAxisOptions, index) {
				xAxisOptions.id = xAxisOptions.id || ('x-axis-' + index);
			});

			helpers.each(scalesOptions.yAxes, function(yAxisOptions, index) {
				yAxisOptions.id = yAxisOptions.id || ('y-axis-' + index);
			});

			if (scaleOptions) {
				scaleOptions.id = scaleOptions.id || 'scale';
			}
		},

		/**
		 * Builds a map of scale ID to scale object for future lookup.
		 */
		buildOrUpdateScales: function() {
			var me = this;
			var options = me.options;
			var scales = me.scales || {};
			var items = [];
			var updated = Object.keys(scales).reduce(function(obj, id) {
				obj[id] = false;
				return obj;
			}, {});

			if (options.scales) {
				items = items.concat(
					(options.scales.xAxes || []).map(function(xAxisOptions) {
						return {options: xAxisOptions, dtype: 'category', dposition: 'bottom'};
					}),
					(options.scales.yAxes || []).map(function(yAxisOptions) {
						return {options: yAxisOptions, dtype: 'linear', dposition: 'left'};
					})
				);
			}

			if (options.scale) {
				items.push({
					options: options.scale,
					dtype: 'radialLinear',
					isDefault: true,
					dposition: 'chartArea'
				});
			}

			helpers.each(items, function(item) {
				var scaleOptions = item.options;
				var id = scaleOptions.id;
				var scaleType = helpers.valueOrDefault(scaleOptions.type, item.dtype);

				if (positionIsHorizontal(scaleOptions.position) !== positionIsHorizontal(item.dposition)) {
					scaleOptions.position = item.dposition;
				}

				updated[id] = true;
				var scale = null;
				if (id in scales && scales[id].type === scaleType) {
					scale = scales[id];
					scale.options = scaleOptions;
					scale.ctx = me.ctx;
					scale.chart = me;
				} else {
					var scaleClass = Chart.scaleService.getScaleConstructor(scaleType);
					if (!scaleClass) {
						return;
					}
					scale = new scaleClass({
						id: id,
						type: scaleType,
						options: scaleOptions,
						ctx: me.ctx,
						chart: me
					});
					scales[scale.id] = scale;
				}

				scale.mergeTicksOptions();

				// TODO(SB): I think we should be able to remove this custom case (options.scale)
				// and consider it as a regular scale part of the "scales"" map only! This would
				// make the logic easier and remove some useless? custom code.
				if (item.isDefault) {
					me.scale = scale;
				}
			});
			// clear up discarded scales
			helpers.each(updated, function(hasUpdated, id) {
				if (!hasUpdated) {
					delete scales[id];
				}
			});

			me.scales = scales;

			Chart.scaleService.addScalesToLayout(this);
		},

		buildOrUpdateControllers: function() {
			var me = this;
			var types = [];
			var newControllers = [];

			helpers.each(me.data.datasets, function(dataset, datasetIndex) {
				var meta = me.getDatasetMeta(datasetIndex);
				var type = dataset.type || me.config.type;

				if (meta.type && meta.type !== type) {
					me.destroyDatasetMeta(datasetIndex);
					meta = me.getDatasetMeta(datasetIndex);
				}
				meta.type = type;

				types.push(meta.type);

				if (meta.controller) {
					meta.controller.updateIndex(datasetIndex);
					meta.controller.linkScales();
				} else {
					var ControllerClass = Chart.controllers[meta.type];
					if (ControllerClass === undefined) {
						throw new Error('"' + meta.type + '" is not a chart type.');
					}

					meta.controller = new ControllerClass(me, datasetIndex);
					newControllers.push(meta.controller);
				}
			}, me);

			return newControllers;
		},

		/**
		 * Reset the elements of all datasets
		 * @private
		 */
		resetElements: function() {
			var me = this;
			helpers.each(me.data.datasets, function(dataset, datasetIndex) {
				me.getDatasetMeta(datasetIndex).controller.reset();
			}, me);
		},

		/**
		* Resets the chart back to it's state before the initial animation
		*/
		reset: function() {
			this.resetElements();
			this.tooltip.initialize();
		},

		update: function(config) {
			var me = this;

			if (!config || typeof config !== 'object') {
				// backwards compatibility
				config = {
					duration: config,
					lazy: arguments[1]
				};
			}

			updateConfig(me);

			// plugins options references might have change, let's invalidate the cache
			// https://github.com/chartjs/Chart.js/issues/5111#issuecomment-355934167
			plugins._invalidate(me);

			if (plugins.notify(me, 'beforeUpdate') === false) {
				return;
			}

			// In case the entire data object changed
			me.tooltip._data = me.data;

			// Make sure dataset controllers are updated and new controllers are reset
			var newControllers = me.buildOrUpdateControllers();

			// Make sure all dataset controllers have correct meta data counts
			helpers.each(me.data.datasets, function(dataset, datasetIndex) {
				me.getDatasetMeta(datasetIndex).controller.buildOrUpdateElements();
			}, me);

			me.updateLayout();

			// Can only reset the new controllers after the scales have been updated
			if (me.options.animation && me.options.animation.duration) {
				helpers.each(newControllers, function(controller) {
					controller.reset();
				});
			}

			me.updateDatasets();

			// Need to reset tooltip in case it is displayed with elements that are removed
			// after update.
			me.tooltip.initialize();

			// Last active contains items that were previously in the tooltip.
			// When we reset the tooltip, we need to clear it
			me.lastActive = [];

			// Do this before render so that any plugins that need final scale updates can use it
			plugins.notify(me, 'afterUpdate');

			if (me._bufferedRender) {
				me._bufferedRequest = {
					duration: config.duration,
					easing: config.easing,
					lazy: config.lazy
				};
			} else {
				me.render(config);
			}
		},

		/**
		 * Updates the chart layout unless a plugin returns `false` to the `beforeLayout`
		 * hook, in which case, plugins will not be called on `afterLayout`.
		 * @private
		 */
		updateLayout: function() {
			var me = this;

			if (plugins.notify(me, 'beforeLayout') === false) {
				return;
			}

			layouts.update(this, this.width, this.height);

			/**
			 * Provided for backward compatibility, use `afterLayout` instead.
			 * @method IPlugin#afterScaleUpdate
			 * @deprecated since version 2.5.0
			 * @todo remove at version 3
			 * @private
			 */
			plugins.notify(me, 'afterScaleUpdate');
			plugins.notify(me, 'afterLayout');
		},

		/**
		 * Updates all datasets unless a plugin returns `false` to the `beforeDatasetsUpdate`
		 * hook, in which case, plugins will not be called on `afterDatasetsUpdate`.
		 * @private
		 */
		updateDatasets: function() {
			var me = this;

			if (plugins.notify(me, 'beforeDatasetsUpdate') === false) {
				return;
			}

			for (var i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
				me.updateDataset(i);
			}

			plugins.notify(me, 'afterDatasetsUpdate');
		},

		/**
		 * Updates dataset at index unless a plugin returns `false` to the `beforeDatasetUpdate`
		 * hook, in which case, plugins will not be called on `afterDatasetUpdate`.
		 * @private
		 */
		updateDataset: function(index) {
			var me = this;
			var meta = me.getDatasetMeta(index);
			var args = {
				meta: meta,
				index: index
			};

			if (plugins.notify(me, 'beforeDatasetUpdate', [args]) === false) {
				return;
			}

			meta.controller.update();

			plugins.notify(me, 'afterDatasetUpdate', [args]);
		},

		render: function(config) {
			var me = this;

			if (!config || typeof config !== 'object') {
				// backwards compatibility
				config = {
					duration: config,
					lazy: arguments[1]
				};
			}

			var duration = config.duration;
			var lazy = config.lazy;

			if (plugins.notify(me, 'beforeRender') === false) {
				return;
			}

			var animationOptions = me.options.animation;
			var onComplete = function(animation) {
				plugins.notify(me, 'afterRender');
				helpers.callback(animationOptions && animationOptions.onComplete, [animation], me);
			};

			if (animationOptions && ((typeof duration !== 'undefined' && duration !== 0) || (typeof duration === 'undefined' && animationOptions.duration !== 0))) {
				var animation = new Chart.Animation({
					numSteps: (duration || animationOptions.duration) / 16.66, // 60 fps
					easing: config.easing || animationOptions.easing,

					render: function(chart, animationObject) {
						var easingFunction = helpers.easing.effects[animationObject.easing];
						var currentStep = animationObject.currentStep;
						var stepDecimal = currentStep / animationObject.numSteps;

						chart.draw(easingFunction(stepDecimal), stepDecimal, currentStep);
					},

					onAnimationProgress: animationOptions.onProgress,
					onAnimationComplete: onComplete
				});

				Chart.animationService.addAnimation(me, animation, duration, lazy);
			} else {
				me.draw();

				// See https://github.com/chartjs/Chart.js/issues/3781
				onComplete(new Chart.Animation({numSteps: 0, chart: me}));
			}

			return me;
		},

		draw: function(easingValue) {
			var me = this;

			me.clear();

			if (helpers.isNullOrUndef(easingValue)) {
				easingValue = 1;
			}

			me.transition(easingValue);

			if (plugins.notify(me, 'beforeDraw', [easingValue]) === false) {
				return;
			}

			// Draw all the scales
			helpers.each(me.boxes, function(box) {
				box.draw(me.chartArea);
			}, me);

			if (me.scale) {
				me.scale.draw();
			}

			me.drawDatasets(easingValue);
			me._drawTooltip(easingValue);

			plugins.notify(me, 'afterDraw', [easingValue]);
		},

		/**
		 * @private
		 */
		transition: function(easingValue) {
			var me = this;

			for (var i = 0, ilen = (me.data.datasets || []).length; i < ilen; ++i) {
				if (me.isDatasetVisible(i)) {
					me.getDatasetMeta(i).controller.transition(easingValue);
				}
			}

			me.tooltip.transition(easingValue);
		},

		/**
		 * Draws all datasets unless a plugin returns `false` to the `beforeDatasetsDraw`
		 * hook, in which case, plugins will not be called on `afterDatasetsDraw`.
		 * @private
		 */
		drawDatasets: function(easingValue) {
			var me = this;

			if (plugins.notify(me, 'beforeDatasetsDraw', [easingValue]) === false) {
				return;
			}

			// Draw datasets reversed to support proper line stacking
			for (var i = (me.data.datasets || []).length - 1; i >= 0; --i) {
				if (me.isDatasetVisible(i)) {
					me.drawDataset(i, easingValue);
				}
			}

			plugins.notify(me, 'afterDatasetsDraw', [easingValue]);
		},

		/**
		 * Draws dataset at index unless a plugin returns `false` to the `beforeDatasetDraw`
		 * hook, in which case, plugins will not be called on `afterDatasetDraw`.
		 * @private
		 */
		drawDataset: function(index, easingValue) {
			var me = this;
			var meta = me.getDatasetMeta(index);
			var args = {
				meta: meta,
				index: index,
				easingValue: easingValue
			};

			if (plugins.notify(me, 'beforeDatasetDraw', [args]) === false) {
				return;
			}

			meta.controller.draw(easingValue);

			plugins.notify(me, 'afterDatasetDraw', [args]);
		},

		/**
		 * Draws tooltip unless a plugin returns `false` to the `beforeTooltipDraw`
		 * hook, in which case, plugins will not be called on `afterTooltipDraw`.
		 * @private
		 */
		_drawTooltip: function(easingValue) {
			var me = this;
			var tooltip = me.tooltip;
			var args = {
				tooltip: tooltip,
				easingValue: easingValue
			};

			if (plugins.notify(me, 'beforeTooltipDraw', [args]) === false) {
				return;
			}

			tooltip.draw();

			plugins.notify(me, 'afterTooltipDraw', [args]);
		},

		// Get the single element that was clicked on
		// @return : An object containing the dataset index and element index of the matching element. Also contains the rectangle that was draw
		getElementAtEvent: function(e) {
			return Interaction.modes.single(this, e);
		},

		getElementsAtEvent: function(e) {
			return Interaction.modes.label(this, e, {intersect: true});
		},

		getElementsAtXAxis: function(e) {
			return Interaction.modes['x-axis'](this, e, {intersect: true});
		},

		getElementsAtEventForMode: function(e, mode, options) {
			var method = Interaction.modes[mode];
			if (typeof method === 'function') {
				return method(this, e, options);
			}

			return [];
		},

		getDatasetAtEvent: function(e) {
			return Interaction.modes.dataset(this, e, {intersect: true});
		},

		getDatasetMeta: function(datasetIndex) {
			var me = this;
			var dataset = me.data.datasets[datasetIndex];
			if (!dataset._meta) {
				dataset._meta = {};
			}

			var meta = dataset._meta[me.id];
			if (!meta) {
				meta = dataset._meta[me.id] = {
					type: null,
					data: [],
					dataset: null,
					controller: null,
					hidden: null,			// See isDatasetVisible() comment
					xAxisID: null,
					yAxisID: null
				};
			}

			return meta;
		},

		getVisibleDatasetCount: function() {
			var count = 0;
			for (var i = 0, ilen = this.data.datasets.length; i < ilen; ++i) {
				if (this.isDatasetVisible(i)) {
					count++;
				}
			}
			return count;
		},

		isDatasetVisible: function(datasetIndex) {
			var meta = this.getDatasetMeta(datasetIndex);

			// meta.hidden is a per chart dataset hidden flag override with 3 states: if true or false,
			// the dataset.hidden value is ignored, else if null, the dataset hidden state is returned.
			return typeof meta.hidden === 'boolean' ? !meta.hidden : !this.data.datasets[datasetIndex].hidden;
		},

		generateLegend: function() {
			return this.options.legendCallback(this);
		},

		/**
		 * @private
		 */
		destroyDatasetMeta: function(datasetIndex) {
			var id = this.id;
			var dataset = this.data.datasets[datasetIndex];
			var meta = dataset._meta && dataset._meta[id];

			if (meta) {
				meta.controller.destroy();
				delete dataset._meta[id];
			}
		},

		destroy: function() {
			var me = this;
			var canvas = me.canvas;
			var i, ilen;

			me.stop();

			// dataset controllers need to cleanup associated data
			for (i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
				me.destroyDatasetMeta(i);
			}

			if (canvas) {
				me.unbindEvents();
				helpers.canvas.clear(me);
				platform.releaseContext(me.ctx);
				me.canvas = null;
				me.ctx = null;
			}

			plugins.notify(me, 'destroy');

			delete Chart.instances[me.id];
		},

		toBase64Image: function() {
			return this.canvas.toDataURL.apply(this.canvas, arguments);
		},

		initToolTip: function() {
			var me = this;
			me.tooltip = new Chart.Tooltip({
				_chart: me,
				_chartInstance: me, // deprecated, backward compatibility
				_data: me.data,
				_options: me.options.tooltips
			}, me);
		},

		/**
		 * @private
		 */
		bindEvents: function() {
			var me = this;
			var listeners = me._listeners = {};
			var listener = function() {
				me.eventHandler.apply(me, arguments);
			};

			helpers.each(me.options.events, function(type) {
				platform.addEventListener(me, type, listener);
				listeners[type] = listener;
			});

			// Elements used to detect size change should not be injected for non responsive charts.
			// See https://github.com/chartjs/Chart.js/issues/2210
			if (me.options.responsive) {
				listener = function() {
					me.resize();
				};

				platform.addEventListener(me, 'resize', listener);
				listeners.resize = listener;
			}
		},

		/**
		 * @private
		 */
		unbindEvents: function() {
			var me = this;
			var listeners = me._listeners;
			if (!listeners) {
				return;
			}

			delete me._listeners;
			helpers.each(listeners, function(listener, type) {
				platform.removeEventListener(me, type, listener);
			});
		},

		updateHoverStyle: function(elements, mode, enabled) {
			var method = enabled ? 'setHoverStyle' : 'removeHoverStyle';
			var element, i, ilen;

			for (i = 0, ilen = elements.length; i < ilen; ++i) {
				element = elements[i];
				if (element) {
					this.getDatasetMeta(element._datasetIndex).controller[method](element);
				}
			}
		},

		/**
		 * @private
		 */
		eventHandler: function(e) {
			var me = this;
			var tooltip = me.tooltip;

			if (plugins.notify(me, 'beforeEvent', [e]) === false) {
				return;
			}

			// Buffer any update calls so that renders do not occur
			me._bufferedRender = true;
			me._bufferedRequest = null;

			var changed = me.handleEvent(e);
			// for smooth tooltip animations issue #4989
			// the tooltip should be the source of change
			// Animation check workaround:
			// tooltip._start will be null when tooltip isn't animating
			if (tooltip) {
				changed = tooltip._start
					? tooltip.handleEvent(e)
					: changed | tooltip.handleEvent(e);
			}

			plugins.notify(me, 'afterEvent', [e]);

			var bufferedRequest = me._bufferedRequest;
			if (bufferedRequest) {
				// If we have an update that was triggered, we need to do a normal render
				me.render(bufferedRequest);
			} else if (changed && !me.animating) {
				// If entering, leaving, or changing elements, animate the change via pivot
				me.stop();

				// We only need to render at this point. Updating will cause scales to be
				// recomputed generating flicker & using more memory than necessary.
				me.render(me.options.hover.animationDuration, true);
			}

			me._bufferedRender = false;
			me._bufferedRequest = null;

			return me;
		},

		/**
		 * Handle an event
		 * @private
		 * @param {IEvent} event the event to handle
		 * @return {Boolean} true if the chart needs to re-render
		 */
		handleEvent: function(e) {
			var me = this;
			var options = me.options || {};
			var hoverOptions = options.hover;
			var changed = false;

			me.lastActive = me.lastActive || [];

			// Find Active Elements for hover and tooltips
			if (e.type === 'mouseout') {
				me.active = [];
			} else {
				me.active = me.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions);
			}

			// Invoke onHover hook
			// Need to call with native event here to not break backwards compatibility
			helpers.callback(options.onHover || options.hover.onHover, [e.native, me.active], me);

			if (e.type === 'mouseup' || e.type === 'click') {
				if (options.onClick) {
					// Use e.native here for backwards compatibility
					options.onClick.call(me, e.native, me.active);
				}
			}

			// Remove styling for last active (even if it may still be active)
			if (me.lastActive.length) {
				me.updateHoverStyle(me.lastActive, hoverOptions.mode, false);
			}

			// Built in hover styling
			if (me.active.length && hoverOptions.mode) {
				me.updateHoverStyle(me.active, hoverOptions.mode, true);
			}

			changed = !helpers.arrayEquals(me.active, me.lastActive);

			// Remember Last Actives
			me.lastActive = me.active;

			return changed;
		}
	});

	/**
	 * Provided for backward compatibility, use Chart instead.
	 * @class Chart.Controller
	 * @deprecated since version 2.6.0
	 * @todo remove at version 3
	 * @private
	 */
	Chart.Controller = Chart;
};


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var helpers = __webpack_require__(1);

module.exports = function(Chart) {

	var arrayEvents = ['push', 'pop', 'shift', 'splice', 'unshift'];

	/**
	 * Hooks the array methods that add or remove values ('push', pop', 'shift', 'splice',
	 * 'unshift') and notify the listener AFTER the array has been altered. Listeners are
	 * called on the 'onData*' callbacks (e.g. onDataPush, etc.) with same arguments.
	 */
	function listenArrayEvents(array, listener) {
		if (array._chartjs) {
			array._chartjs.listeners.push(listener);
			return;
		}

		Object.defineProperty(array, '_chartjs', {
			configurable: true,
			enumerable: false,
			value: {
				listeners: [listener]
			}
		});

		arrayEvents.forEach(function(key) {
			var method = 'onData' + key.charAt(0).toUpperCase() + key.slice(1);
			var base = array[key];

			Object.defineProperty(array, key, {
				configurable: true,
				enumerable: false,
				value: function() {
					var args = Array.prototype.slice.call(arguments);
					var res = base.apply(this, args);

					helpers.each(array._chartjs.listeners, function(object) {
						if (typeof object[method] === 'function') {
							object[method].apply(object, args);
						}
					});

					return res;
				}
			});
		});
	}

	/**
	 * Removes the given array event listener and cleanup extra attached properties (such as
	 * the _chartjs stub and overridden methods) if array doesn't have any more listeners.
	 */
	function unlistenArrayEvents(array, listener) {
		var stub = array._chartjs;
		if (!stub) {
			return;
		}

		var listeners = stub.listeners;
		var index = listeners.indexOf(listener);
		if (index !== -1) {
			listeners.splice(index, 1);
		}

		if (listeners.length > 0) {
			return;
		}

		arrayEvents.forEach(function(key) {
			delete array[key];
		});

		delete array._chartjs;
	}

	// Base class for all dataset controllers (line, bar, etc)
	Chart.DatasetController = function(chart, datasetIndex) {
		this.initialize(chart, datasetIndex);
	};

	helpers.extend(Chart.DatasetController.prototype, {

		/**
		 * Element type used to generate a meta dataset (e.g. Chart.element.Line).
		 * @type {Chart.core.element}
		 */
		datasetElementType: null,

		/**
		 * Element type used to generate a meta data (e.g. Chart.element.Point).
		 * @type {Chart.core.element}
		 */
		dataElementType: null,

		initialize: function(chart, datasetIndex) {
			var me = this;
			me.chart = chart;
			me.index = datasetIndex;
			me.linkScales();
			me.addElements();
		},

		updateIndex: function(datasetIndex) {
			this.index = datasetIndex;
		},

		linkScales: function() {
			var me = this;
			var meta = me.getMeta();
			var dataset = me.getDataset();

			if (meta.xAxisID === null || !(meta.xAxisID in me.chart.scales)) {
				meta.xAxisID = dataset.xAxisID || me.chart.options.scales.xAxes[0].id;
			}
			if (meta.yAxisID === null || !(meta.yAxisID in me.chart.scales)) {
				meta.yAxisID = dataset.yAxisID || me.chart.options.scales.yAxes[0].id;
			}
		},

		getDataset: function() {
			return this.chart.data.datasets[this.index];
		},

		getMeta: function() {
			return this.chart.getDatasetMeta(this.index);
		},

		getScaleForId: function(scaleID) {
			return this.chart.scales[scaleID];
		},

		reset: function() {
			this.update(true);
		},

		/**
		 * @private
		 */
		destroy: function() {
			if (this._data) {
				unlistenArrayEvents(this._data, this);
			}
		},

		createMetaDataset: function() {
			var me = this;
			var type = me.datasetElementType;
			return type && new type({
				_chart: me.chart,
				_datasetIndex: me.index
			});
		},

		createMetaData: function(index) {
			var me = this;
			var type = me.dataElementType;
			return type && new type({
				_chart: me.chart,
				_datasetIndex: me.index,
				_index: index
			});
		},

		addElements: function() {
			var me = this;
			var meta = me.getMeta();
			var data = me.getDataset().data || [];
			var metaData = meta.data;
			var i, ilen;

			for (i = 0, ilen = data.length; i < ilen; ++i) {
				metaData[i] = metaData[i] || me.createMetaData(i);
			}

			meta.dataset = meta.dataset || me.createMetaDataset();
		},

		addElementAndReset: function(index) {
			var element = this.createMetaData(index);
			this.getMeta().data.splice(index, 0, element);
			this.updateElement(element, index, true);
		},

		buildOrUpdateElements: function() {
			var me = this;
			var dataset = me.getDataset();
			var data = dataset.data || (dataset.data = []);

			// In order to correctly handle data addition/deletion animation (an thus simulate
			// real-time charts), we need to monitor these data modifications and synchronize
			// the internal meta data accordingly.
			if (me._data !== data) {
				if (me._data) {
					// This case happens when the user replaced the data array instance.
					unlistenArrayEvents(me._data, me);
				}

				listenArrayEvents(data, me);
				me._data = data;
			}

			// Re-sync meta data in case the user replaced the data array or if we missed
			// any updates and so make sure that we handle number of datapoints changing.
			me.resyncElements();
		},

		update: helpers.noop,

		transition: function(easingValue) {
			var meta = this.getMeta();
			var elements = meta.data || [];
			var ilen = elements.length;
			var i = 0;

			for (; i < ilen; ++i) {
				elements[i].transition(easingValue);
			}

			if (meta.dataset) {
				meta.dataset.transition(easingValue);
			}
		},

		draw: function() {
			var meta = this.getMeta();
			var elements = meta.data || [];
			var ilen = elements.length;
			var i = 0;

			if (meta.dataset) {
				meta.dataset.draw();
			}

			for (; i < ilen; ++i) {
				elements[i].draw();
			}
		},

		removeHoverStyle: function(element, elementOpts) {
			var dataset = this.chart.data.datasets[element._datasetIndex];
			var index = element._index;
			var custom = element.custom || {};
			var valueOrDefault = helpers.valueAtIndexOrDefault;
			var model = element._model;

			model.backgroundColor = custom.backgroundColor ? custom.backgroundColor : valueOrDefault(dataset.backgroundColor, index, elementOpts.backgroundColor);
			model.borderColor = custom.borderColor ? custom.borderColor : valueOrDefault(dataset.borderColor, index, elementOpts.borderColor);
			model.borderWidth = custom.borderWidth ? custom.borderWidth : valueOrDefault(dataset.borderWidth, index, elementOpts.borderWidth);
		},

		setHoverStyle: function(element) {
			var dataset = this.chart.data.datasets[element._datasetIndex];
			var index = element._index;
			var custom = element.custom || {};
			var valueOrDefault = helpers.valueAtIndexOrDefault;
			var getHoverColor = helpers.getHoverColor;
			var model = element._model;

			model.backgroundColor = custom.hoverBackgroundColor ? custom.hoverBackgroundColor : valueOrDefault(dataset.hoverBackgroundColor, index, getHoverColor(model.backgroundColor));
			model.borderColor = custom.hoverBorderColor ? custom.hoverBorderColor : valueOrDefault(dataset.hoverBorderColor, index, getHoverColor(model.borderColor));
			model.borderWidth = custom.hoverBorderWidth ? custom.hoverBorderWidth : valueOrDefault(dataset.hoverBorderWidth, index, model.borderWidth);
		},

		/**
		 * @private
		 */
		resyncElements: function() {
			var me = this;
			var meta = me.getMeta();
			var data = me.getDataset().data;
			var numMeta = meta.data.length;
			var numData = data.length;

			if (numData < numMeta) {
				meta.data.splice(numData, numMeta - numData);
			} else if (numData > numMeta) {
				me.insertElements(numMeta, numData - numMeta);
			}
		},

		/**
		 * @private
		 */
		insertElements: function(start, count) {
			for (var i = 0; i < count; ++i) {
				this.addElementAndReset(start + i);
			}
		},

		/**
		 * @private
		 */
		onDataPush: function() {
			this.insertElements(this.getDataset().data.length - 1, arguments.length);
		},

		/**
		 * @private
		 */
		onDataPop: function() {
			this.getMeta().data.pop();
		},

		/**
		 * @private
		 */
		onDataShift: function() {
			this.getMeta().data.shift();
		},

		/**
		 * @private
		 */
		onDataSplice: function(start, count) {
			this.getMeta().data.splice(start, count);
			this.insertElements(start, arguments.length - 2);
		},

		/**
		 * @private
		 */
		onDataUnshift: function() {
			this.insertElements(0, arguments.length);
		}
	});

	Chart.DatasetController.extend = helpers.inherits;
};


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(2);
var helpers = __webpack_require__(1);
var layouts = __webpack_require__(21);

module.exports = function(Chart) {

	Chart.scaleService = {
		// Scale registration object. Extensions can register new scale types (such as log or DB scales) and then
		// use the new chart options to grab the correct scale
		constructors: {},
		// Use a registration function so that we can move to an ES6 map when we no longer need to support
		// old browsers

		// Scale config defaults
		defaults: {},
		registerScaleType: function(type, scaleConstructor, scaleDefaults) {
			this.constructors[type] = scaleConstructor;
			this.defaults[type] = helpers.clone(scaleDefaults);
		},
		getScaleConstructor: function(type) {
			return this.constructors.hasOwnProperty(type) ? this.constructors[type] : undefined;
		},
		getScaleDefaults: function(type) {
			// Return the scale defaults merged with the global settings so that we always use the latest ones
			return this.defaults.hasOwnProperty(type) ? helpers.merge({}, [defaults.scale, this.defaults[type]]) : {};
		},
		updateScaleDefaults: function(type, additions) {
			var me = this;
			if (me.defaults.hasOwnProperty(type)) {
				me.defaults[type] = helpers.extend(me.defaults[type], additions);
			}
		},
		addScalesToLayout: function(chart) {
			// Adds each scale to the chart.boxes array to be sized accordingly
			helpers.each(chart.scales, function(scale) {
				// Set ILayoutItem parameters for backwards compatibility
				scale.fullWidth = scale.options.fullWidth;
				scale.position = scale.options.position;
				scale.weight = scale.options.weight;
				layouts.addBox(chart, scale);
			});
		}
	};
};


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(2);
var Element = __webpack_require__(8);
var helpers = __webpack_require__(1);
var Ticks = __webpack_require__(22);

defaults._set('scale', {
	display: true,
	position: 'left',
	offset: false,

	// grid line settings
	gridLines: {
		display: true,
		color: 'rgba(0, 0, 0, 0.1)',
		lineWidth: 1,
		drawBorder: true,
		drawOnChartArea: true,
		drawTicks: true,
		tickMarkLength: 10,
		zeroLineWidth: 1,
		zeroLineColor: 'rgba(0,0,0,0.25)',
		zeroLineBorderDash: [],
		zeroLineBorderDashOffset: 0.0,
		offsetGridLines: false,
		borderDash: [],
		borderDashOffset: 0.0
	},

	// scale label
	scaleLabel: {
		// display property
		display: false,

		// actual label
		labelString: '',

		// line height
		lineHeight: 1.2,

		// top/bottom padding
		padding: {
			top: 4,
			bottom: 4
		}
	},

	// label settings
	ticks: {
		beginAtZero: false,
		minRotation: 0,
		maxRotation: 50,
		mirror: false,
		padding: 0,
		reverse: false,
		display: true,
		autoSkip: true,
		autoSkipPadding: 0,
		labelOffset: 0,
		// We pass through arrays to be rendered as multiline labels, we convert Others to strings here.
		callback: Ticks.formatters.values,
		minor: {},
		major: {}
	}
});

function labelsFromTicks(ticks) {
	var labels = [];
	var i, ilen;

	for (i = 0, ilen = ticks.length; i < ilen; ++i) {
		labels.push(ticks[i].label);
	}

	return labels;
}

function getLineValue(scale, index, offsetGridLines) {
	var lineValue = scale.getPixelForTick(index);

	if (offsetGridLines) {
		if (index === 0) {
			lineValue -= (scale.getPixelForTick(1) - lineValue) / 2;
		} else {
			lineValue -= (lineValue - scale.getPixelForTick(index - 1)) / 2;
		}
	}
	return lineValue;
}

module.exports = function(Chart) {

	function computeTextSize(context, tick, font) {
		return helpers.isArray(tick) ?
			helpers.longestText(context, font, tick) :
			context.measureText(tick).width;
	}

	function parseFontOptions(options) {
		var valueOrDefault = helpers.valueOrDefault;
		var globalDefaults = defaults.global;
		var size = valueOrDefault(options.fontSize, globalDefaults.defaultFontSize);
		var style = valueOrDefault(options.fontStyle, globalDefaults.defaultFontStyle);
		var family = valueOrDefault(options.fontFamily, globalDefaults.defaultFontFamily);

		return {
			size: size,
			style: style,
			family: family,
			font: helpers.fontString(size, style, family)
		};
	}

	function parseLineHeight(options) {
		return helpers.options.toLineHeight(
			helpers.valueOrDefault(options.lineHeight, 1.2),
			helpers.valueOrDefault(options.fontSize, defaults.global.defaultFontSize));
	}

	Chart.Scale = Element.extend({
		/**
		 * Get the padding needed for the scale
		 * @method getPadding
		 * @private
		 * @returns {Padding} the necessary padding
		 */
		getPadding: function() {
			var me = this;
			return {
				left: me.paddingLeft || 0,
				top: me.paddingTop || 0,
				right: me.paddingRight || 0,
				bottom: me.paddingBottom || 0
			};
		},

		/**
		 * Returns the scale tick objects ({label, major})
		 * @since 2.7
		 */
		getTicks: function() {
			return this._ticks;
		},

		// These methods are ordered by lifecyle. Utilities then follow.
		// Any function defined here is inherited by all scale types.
		// Any function can be extended by the scale type

		mergeTicksOptions: function() {
			var ticks = this.options.ticks;
			if (ticks.minor === false) {
				ticks.minor = {
					display: false
				};
			}
			if (ticks.major === false) {
				ticks.major = {
					display: false
				};
			}
			for (var key in ticks) {
				if (key !== 'major' && key !== 'minor') {
					if (typeof ticks.minor[key] === 'undefined') {
						ticks.minor[key] = ticks[key];
					}
					if (typeof ticks.major[key] === 'undefined') {
						ticks.major[key] = ticks[key];
					}
				}
			}
		},
		beforeUpdate: function() {
			helpers.callback(this.options.beforeUpdate, [this]);
		},
		update: function(maxWidth, maxHeight, margins) {
			var me = this;
			var i, ilen, labels, label, ticks, tick;

			// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
			me.beforeUpdate();

			// Absorb the master measurements
			me.maxWidth = maxWidth;
			me.maxHeight = maxHeight;
			me.margins = helpers.extend({
				left: 0,
				right: 0,
				top: 0,
				bottom: 0
			}, margins);
			me.longestTextCache = me.longestTextCache || {};

			// Dimensions
			me.beforeSetDimensions();
			me.setDimensions();
			me.afterSetDimensions();

			// Data min/max
			me.beforeDataLimits();
			me.determineDataLimits();
			me.afterDataLimits();

			// Ticks - `this.ticks` is now DEPRECATED!
			// Internal ticks are now stored as objects in the PRIVATE `this._ticks` member
			// and must not be accessed directly from outside this class. `this.ticks` being
			// around for long time and not marked as private, we can't change its structure
			// without unexpected breaking changes. If you need to access the scale ticks,
			// use scale.getTicks() instead.

			me.beforeBuildTicks();

			// New implementations should return an array of objects but for BACKWARD COMPAT,
			// we still support no return (`this.ticks` internally set by calling this method).
			ticks = me.buildTicks() || [];

			me.afterBuildTicks();

			me.beforeTickToLabelConversion();

			// New implementations should return the formatted tick labels but for BACKWARD
			// COMPAT, we still support no return (`this.ticks` internally changed by calling
			// this method and supposed to contain only string values).
			labels = me.convertTicksToLabels(ticks) || me.ticks;

			me.afterTickToLabelConversion();

			me.ticks = labels;   // BACKWARD COMPATIBILITY

			// IMPORTANT: from this point, we consider that `this.ticks` will NEVER change!

			// BACKWARD COMPAT: synchronize `_ticks` with labels (so potentially `this.ticks`)
			for (i = 0, ilen = labels.length; i < ilen; ++i) {
				label = labels[i];
				tick = ticks[i];
				if (!tick) {
					ticks.push(tick = {
						label: label,
						major: false
					});
				} else {
					tick.label = label;
				}
			}

			me._ticks = ticks;

			// Tick Rotation
			me.beforeCalculateTickRotation();
			me.calculateTickRotation();
			me.afterCalculateTickRotation();
			// Fit
			me.beforeFit();
			me.fit();
			me.afterFit();
			//
			me.afterUpdate();

			return me.minSize;

		},
		afterUpdate: function() {
			helpers.callback(this.options.afterUpdate, [this]);
		},

		//

		beforeSetDimensions: function() {
			helpers.callback(this.options.beforeSetDimensions, [this]);
		},
		setDimensions: function() {
			var me = this;
			// Set the unconstrained dimension before label rotation
			if (me.isHorizontal()) {
				// Reset position before calculating rotation
				me.width = me.maxWidth;
				me.left = 0;
				me.right = me.width;
			} else {
				me.height = me.maxHeight;

				// Reset position before calculating rotation
				me.top = 0;
				me.bottom = me.height;
			}

			// Reset padding
			me.paddingLeft = 0;
			me.paddingTop = 0;
			me.paddingRight = 0;
			me.paddingBottom = 0;
		},
		afterSetDimensions: function() {
			helpers.callback(this.options.afterSetDimensions, [this]);
		},

		// Data limits
		beforeDataLimits: function() {
			helpers.callback(this.options.beforeDataLimits, [this]);
		},
		determineDataLimits: helpers.noop,
		afterDataLimits: function() {
			helpers.callback(this.options.afterDataLimits, [this]);
		},

		//
		beforeBuildTicks: function() {
			helpers.callback(this.options.beforeBuildTicks, [this]);
		},
		buildTicks: helpers.noop,
		afterBuildTicks: function() {
			helpers.callback(this.options.afterBuildTicks, [this]);
		},

		beforeTickToLabelConversion: function() {
			helpers.callback(this.options.beforeTickToLabelConversion, [this]);
		},
		convertTicksToLabels: function() {
			var me = this;
			// Convert ticks to strings
			var tickOpts = me.options.ticks;
			me.ticks = me.ticks.map(tickOpts.userCallback || tickOpts.callback, this);
		},
		afterTickToLabelConversion: function() {
			helpers.callback(this.options.afterTickToLabelConversion, [this]);
		},

		//

		beforeCalculateTickRotation: function() {
			helpers.callback(this.options.beforeCalculateTickRotation, [this]);
		},
		calculateTickRotation: function() {
			var me = this;
			var context = me.ctx;
			var tickOpts = me.options.ticks;
			var labels = labelsFromTicks(me._ticks);

			// Get the width of each grid by calculating the difference
			// between x offsets between 0 and 1.
			var tickFont = parseFontOptions(tickOpts);
			context.font = tickFont.font;

			var labelRotation = tickOpts.minRotation || 0;

			if (labels.length && me.options.display && me.isHorizontal()) {
				var originalLabelWidth = helpers.longestText(context, tickFont.font, labels, me.longestTextCache);
				var labelWidth = originalLabelWidth;
				var cosRotation, sinRotation;

				// Allow 3 pixels x2 padding either side for label readability
				var tickWidth = me.getPixelForTick(1) - me.getPixelForTick(0) - 6;

				// Max label rotation can be set or default to 90 - also act as a loop counter
				while (labelWidth > tickWidth && labelRotation < tickOpts.maxRotation) {
					var angleRadians = helpers.toRadians(labelRotation);
					cosRotation = Math.cos(angleRadians);
					sinRotation = Math.sin(angleRadians);

					if (sinRotation * originalLabelWidth > me.maxHeight) {
						// go back one step
						labelRotation--;
						break;
					}

					labelRotation++;
					labelWidth = cosRotation * originalLabelWidth;
				}
			}

			me.labelRotation = labelRotation;
		},
		afterCalculateTickRotation: function() {
			helpers.callback(this.options.afterCalculateTickRotation, [this]);
		},

		//

		beforeFit: function() {
			helpers.callback(this.options.beforeFit, [this]);
		},
		fit: function() {
			var me = this;
			// Reset
			var minSize = me.minSize = {
				width: 0,
				height: 0
			};

			var labels = labelsFromTicks(me._ticks);

			var opts = me.options;
			var tickOpts = opts.ticks;
			var scaleLabelOpts = opts.scaleLabel;
			var gridLineOpts = opts.gridLines;
			var display = opts.display;
			var isHorizontal = me.isHorizontal();

			var tickFont = parseFontOptions(tickOpts);
			var tickMarkLength = opts.gridLines.tickMarkLength;

			// Width
			if (isHorizontal) {
				// subtract the margins to line up with the chartArea if we are a full width scale
				minSize.width = me.isFullWidth() ? me.maxWidth - me.margins.left - me.margins.right : me.maxWidth;
			} else {
				minSize.width = display && gridLineOpts.drawTicks ? tickMarkLength : 0;
			}

			// height
			if (isHorizontal) {
				minSize.height = display && gridLineOpts.drawTicks ? tickMarkLength : 0;
			} else {
				minSize.height = me.maxHeight; // fill all the height
			}

			// Are we showing a title for the scale?
			if (scaleLabelOpts.display && display) {
				var scaleLabelLineHeight = parseLineHeight(scaleLabelOpts);
				var scaleLabelPadding = helpers.options.toPadding(scaleLabelOpts.padding);
				var deltaHeight = scaleLabelLineHeight + scaleLabelPadding.height;

				if (isHorizontal) {
					minSize.height += deltaHeight;
				} else {
					minSize.width += deltaHeight;
				}
			}

			// Don't bother fitting the ticks if we are not showing them
			if (tickOpts.display && display) {
				var largestTextWidth = helpers.longestText(me.ctx, tickFont.font, labels, me.longestTextCache);
				var tallestLabelHeightInLines = helpers.numberOfLabelLines(labels);
				var lineSpace = tickFont.size * 0.5;
				var tickPadding = me.options.ticks.padding;

				if (isHorizontal) {
					// A horizontal axis is more constrained by the height.
					me.longestLabelWidth = largestTextWidth;

					var angleRadians = helpers.toRadians(me.labelRotation);
					var cosRotation = Math.cos(angleRadians);
					var sinRotation = Math.sin(angleRadians);

					// TODO - improve this calculation
					var labelHeight = (sinRotation * largestTextWidth)
						+ (tickFont.size * tallestLabelHeightInLines)
						+ (lineSpace * (tallestLabelHeightInLines - 1))
						+ lineSpace; // padding

					minSize.height = Math.min(me.maxHeight, minSize.height + labelHeight + tickPadding);

					me.ctx.font = tickFont.font;
					var firstLabelWidth = computeTextSize(me.ctx, labels[0], tickFont.font);
					var lastLabelWidth = computeTextSize(me.ctx, labels[labels.length - 1], tickFont.font);

					// Ensure that our ticks are always inside the canvas. When rotated, ticks are right aligned
					// which means that the right padding is dominated by the font height
					if (me.labelRotation !== 0) {
						me.paddingLeft = opts.position === 'bottom' ? (cosRotation * firstLabelWidth) + 3 : (cosRotation * lineSpace) + 3; // add 3 px to move away from canvas edges
						me.paddingRight = opts.position === 'bottom' ? (cosRotation * lineSpace) + 3 : (cosRotation * lastLabelWidth) + 3;
					} else {
						me.paddingLeft = firstLabelWidth / 2 + 3; // add 3 px to move away from canvas edges
						me.paddingRight = lastLabelWidth / 2 + 3;
					}
				} else {
					// A vertical axis is more constrained by the width. Labels are the
					// dominant factor here, so get that length first and account for padding
					if (tickOpts.mirror) {
						largestTextWidth = 0;
					} else {
						// use lineSpace for consistency with horizontal axis
						// tickPadding is not implemented for horizontal
						largestTextWidth += tickPadding + lineSpace;
					}

					minSize.width = Math.min(me.maxWidth, minSize.width + largestTextWidth);

					me.paddingTop = tickFont.size / 2;
					me.paddingBottom = tickFont.size / 2;
				}
			}

			me.handleMargins();

			me.width = minSize.width;
			me.height = minSize.height;
		},

		/**
		 * Handle margins and padding interactions
		 * @private
		 */
		handleMargins: function() {
			var me = this;
			if (me.margins) {
				me.paddingLeft = Math.max(me.paddingLeft - me.margins.left, 0);
				me.paddingTop = Math.max(me.paddingTop - me.margins.top, 0);
				me.paddingRight = Math.max(me.paddingRight - me.margins.right, 0);
				me.paddingBottom = Math.max(me.paddingBottom - me.margins.bottom, 0);
			}
		},

		afterFit: function() {
			helpers.callback(this.options.afterFit, [this]);
		},

		// Shared Methods
		isHorizontal: function() {
			return this.options.position === 'top' || this.options.position === 'bottom';
		},
		isFullWidth: function() {
			return (this.options.fullWidth);
		},

		// Get the correct value. NaN bad inputs, If the value type is object get the x or y based on whether we are horizontal or not
		getRightValue: function(rawValue) {
			// Null and undefined values first
			if (helpers.isNullOrUndef(rawValue)) {
				return NaN;
			}
			// isNaN(object) returns true, so make sure NaN is checking for a number; Discard Infinite values
			if (typeof rawValue === 'number' && !isFinite(rawValue)) {
				return NaN;
			}
			// If it is in fact an object, dive in one more level
			if (rawValue) {
				if (this.isHorizontal()) {
					if (rawValue.x !== undefined) {
						return this.getRightValue(rawValue.x);
					}
				} else if (rawValue.y !== undefined) {
					return this.getRightValue(rawValue.y);
				}
			}

			// Value is good, return it
			return rawValue;
		},

		/**
		 * Used to get the value to display in the tooltip for the data at the given index
		 * @param index
		 * @param datasetIndex
		 */
		getLabelForIndex: helpers.noop,

		/**
		 * Returns the location of the given data point. Value can either be an index or a numerical value
		 * The coordinate (0, 0) is at the upper-left corner of the canvas
		 * @param value
		 * @param index
		 * @param datasetIndex
		 */
		getPixelForValue: helpers.noop,

		/**
		 * Used to get the data value from a given pixel. This is the inverse of getPixelForValue
		 * The coordinate (0, 0) is at the upper-left corner of the canvas
		 * @param pixel
		 */
		getValueForPixel: helpers.noop,

		/**
		 * Returns the location of the tick at the given index
		 * The coordinate (0, 0) is at the upper-left corner of the canvas
		 */
		getPixelForTick: function(index) {
			var me = this;
			var offset = me.options.offset;
			if (me.isHorizontal()) {
				var innerWidth = me.width - (me.paddingLeft + me.paddingRight);
				var tickWidth = innerWidth / Math.max((me._ticks.length - (offset ? 0 : 1)), 1);
				var pixel = (tickWidth * index) + me.paddingLeft;

				if (offset) {
					pixel += tickWidth / 2;
				}

				var finalVal = me.left + Math.round(pixel);
				finalVal += me.isFullWidth() ? me.margins.left : 0;
				return finalVal;
			}
			var innerHeight = me.height - (me.paddingTop + me.paddingBottom);
			return me.top + (index * (innerHeight / (me._ticks.length - 1)));
		},

		/**
		 * Utility for getting the pixel location of a percentage of scale
		 * The coordinate (0, 0) is at the upper-left corner of the canvas
		 */
		getPixelForDecimal: function(decimal) {
			var me = this;
			if (me.isHorizontal()) {
				var innerWidth = me.width - (me.paddingLeft + me.paddingRight);
				var valueOffset = (innerWidth * decimal) + me.paddingLeft;

				var finalVal = me.left + Math.round(valueOffset);
				finalVal += me.isFullWidth() ? me.margins.left : 0;
				return finalVal;
			}
			return me.top + (decimal * me.height);
		},

		/**
		 * Returns the pixel for the minimum chart value
		 * The coordinate (0, 0) is at the upper-left corner of the canvas
		 */
		getBasePixel: function() {
			return this.getPixelForValue(this.getBaseValue());
		},

		getBaseValue: function() {
			var me = this;
			var min = me.min;
			var max = me.max;

			return me.beginAtZero ? 0 :
				min < 0 && max < 0 ? max :
				min > 0 && max > 0 ? min :
				0;
		},

		/**
		 * Returns a subset of ticks to be plotted to avoid overlapping labels.
		 * @private
		 */
		_autoSkip: function(ticks) {
			var skipRatio;
			var me = this;
			var isHorizontal = me.isHorizontal();
			var optionTicks = me.options.ticks.minor;
			var tickCount = ticks.length;
			var labelRotationRadians = helpers.toRadians(me.labelRotation);
			var cosRotation = Math.cos(labelRotationRadians);
			var longestRotatedLabel = me.longestLabelWidth * cosRotation;
			var result = [];
			var i, tick, shouldSkip;

			// figure out the maximum number of gridlines to show
			var maxTicks;
			if (optionTicks.maxTicksLimit) {
				maxTicks = optionTicks.maxTicksLimit;
			}

			if (isHorizontal) {
				skipRatio = false;

				if ((longestRotatedLabel + optionTicks.autoSkipPadding) * tickCount > (me.width - (me.paddingLeft + me.paddingRight))) {
					skipRatio = 1 + Math.floor(((longestRotatedLabel + optionTicks.autoSkipPadding) * tickCount) / (me.width - (me.paddingLeft + me.paddingRight)));
				}

				// if they defined a max number of optionTicks,
				// increase skipRatio until that number is met
				if (maxTicks && tickCount > maxTicks) {
					skipRatio = Math.max(skipRatio, Math.floor(tickCount / maxTicks));
				}
			}

			for (i = 0; i < tickCount; i++) {
				tick = ticks[i];

				// Since we always show the last tick,we need may need to hide the last shown one before
				shouldSkip = (skipRatio > 1 && i % skipRatio > 0) || (i % skipRatio === 0 && i + skipRatio >= tickCount);
				if (shouldSkip && i !== tickCount - 1) {
					// leave tick in place but make sure it's not displayed (#4635)
					delete tick.label;
				}
				result.push(tick);
			}
			return result;
		},

		// Actually draw the scale on the canvas
		// @param {rectangle} chartArea : the area of the chart to draw full grid lines on
		draw: function(chartArea) {
			var me = this;
			var options = me.options;
			if (!options.display) {
				return;
			}

			var context = me.ctx;
			var globalDefaults = defaults.global;
			var optionTicks = options.ticks.minor;
			var optionMajorTicks = options.ticks.major || optionTicks;
			var gridLines = options.gridLines;
			var scaleLabel = options.scaleLabel;

			var isRotated = me.labelRotation !== 0;
			var isHorizontal = me.isHorizontal();

			var ticks = optionTicks.autoSkip ? me._autoSkip(me.getTicks()) : me.getTicks();
			var tickFontColor = helpers.valueOrDefault(optionTicks.fontColor, globalDefaults.defaultFontColor);
			var tickFont = parseFontOptions(optionTicks);
			var majorTickFontColor = helpers.valueOrDefault(optionMajorTicks.fontColor, globalDefaults.defaultFontColor);
			var majorTickFont = parseFontOptions(optionMajorTicks);

			var tl = gridLines.drawTicks ? gridLines.tickMarkLength : 0;

			var scaleLabelFontColor = helpers.valueOrDefault(scaleLabel.fontColor, globalDefaults.defaultFontColor);
			var scaleLabelFont = parseFontOptions(scaleLabel);
			var scaleLabelPadding = helpers.options.toPadding(scaleLabel.padding);
			var labelRotationRadians = helpers.toRadians(me.labelRotation);

			var itemsToDraw = [];

			var axisWidth = me.options.gridLines.lineWidth;
			var xTickStart = options.position === 'right' ? me.right : me.right - axisWidth - tl;
			var xTickEnd = options.position === 'right' ? me.right + tl : me.right;
			var yTickStart = options.position === 'bottom' ? me.top + axisWidth : me.bottom - tl - axisWidth;
			var yTickEnd = options.position === 'bottom' ? me.top + axisWidth + tl : me.bottom + axisWidth;

			helpers.each(ticks, function(tick, index) {
				// autoskipper skipped this tick (#4635)
				if (helpers.isNullOrUndef(tick.label)) {
					return;
				}

				var label = tick.label;
				var lineWidth, lineColor, borderDash, borderDashOffset;
				if (index === me.zeroLineIndex && options.offset === gridLines.offsetGridLines) {
					// Draw the first index specially
					lineWidth = gridLines.zeroLineWidth;
					lineColor = gridLines.zeroLineColor;
					borderDash = gridLines.zeroLineBorderDash;
					borderDashOffset = gridLines.zeroLineBorderDashOffset;
				} else {
					lineWidth = helpers.valueAtIndexOrDefault(gridLines.lineWidth, index);
					lineColor = helpers.valueAtIndexOrDefault(gridLines.color, index);
					borderDash = helpers.valueOrDefault(gridLines.borderDash, globalDefaults.borderDash);
					borderDashOffset = helpers.valueOrDefault(gridLines.borderDashOffset, globalDefaults.borderDashOffset);
				}

				// Common properties
				var tx1, ty1, tx2, ty2, x1, y1, x2, y2, labelX, labelY;
				var textAlign = 'middle';
				var textBaseline = 'middle';
				var tickPadding = optionTicks.padding;

				if (isHorizontal) {
					var labelYOffset = tl + tickPadding;

					if (options.position === 'bottom') {
						// bottom
						textBaseline = !isRotated ? 'top' : 'middle';
						textAlign = !isRotated ? 'center' : 'right';
						labelY = me.top + labelYOffset;
					} else {
						// top
						textBaseline = !isRotated ? 'bottom' : 'middle';
						textAlign = !isRotated ? 'center' : 'left';
						labelY = me.bottom - labelYOffset;
					}

					var xLineValue = getLineValue(me, index, gridLines.offsetGridLines && ticks.length > 1);
					if (xLineValue < me.left) {
						lineColor = 'rgba(0,0,0,0)';
					}
					xLineValue += helpers.aliasPixel(lineWidth);

					labelX = me.getPixelForTick(index) + optionTicks.labelOffset; // x values for optionTicks (need to consider offsetLabel option)

					tx1 = tx2 = x1 = x2 = xLineValue;
					ty1 = yTickStart;
					ty2 = yTickEnd;
					y1 = chartArea.top;
					y2 = chartArea.bottom + axisWidth;
				} else {
					var isLeft = options.position === 'left';
					var labelXOffset;

					if (optionTicks.mirror) {
						textAlign = isLeft ? 'left' : 'right';
						labelXOffset = tickPadding;
					} else {
						textAlign = isLeft ? 'right' : 'left';
						labelXOffset = tl + tickPadding;
					}

					labelX = isLeft ? me.right - labelXOffset : me.left + labelXOffset;

					var yLineValue = getLineValue(me, index, gridLines.offsetGridLines && ticks.length > 1);
					if (yLineValue < me.top) {
						lineColor = 'rgba(0,0,0,0)';
					}
					yLineValue += helpers.aliasPixel(lineWidth);

					labelY = me.getPixelForTick(index) + optionTicks.labelOffset;

					tx1 = xTickStart;
					tx2 = xTickEnd;
					x1 = chartArea.left;
					x2 = chartArea.right + axisWidth;
					ty1 = ty2 = y1 = y2 = yLineValue;
				}

				itemsToDraw.push({
					tx1: tx1,
					ty1: ty1,
					tx2: tx2,
					ty2: ty2,
					x1: x1,
					y1: y1,
					x2: x2,
					y2: y2,
					labelX: labelX,
					labelY: labelY,
					glWidth: lineWidth,
					glColor: lineColor,
					glBorderDash: borderDash,
					glBorderDashOffset: borderDashOffset,
					rotation: -1 * labelRotationRadians,
					label: label,
					major: tick.major,
					textBaseline: textBaseline,
					textAlign: textAlign
				});
			});

			// Draw all of the tick labels, tick marks, and grid lines at the correct places
			helpers.each(itemsToDraw, function(itemToDraw) {
				if (gridLines.display) {
					context.save();
					context.lineWidth = itemToDraw.glWidth;
					context.strokeStyle = itemToDraw.glColor;
					if (context.setLineDash) {
						context.setLineDash(itemToDraw.glBorderDash);
						context.lineDashOffset = itemToDraw.glBorderDashOffset;
					}

					context.beginPath();

					if (gridLines.drawTicks) {
						context.moveTo(itemToDraw.tx1, itemToDraw.ty1);
						context.lineTo(itemToDraw.tx2, itemToDraw.ty2);
					}

					if (gridLines.drawOnChartArea) {
						context.moveTo(itemToDraw.x1, itemToDraw.y1);
						context.lineTo(itemToDraw.x2, itemToDraw.y2);
					}

					context.stroke();
					context.restore();
				}

				if (optionTicks.display) {
					// Make sure we draw text in the correct color and font
					context.save();
					context.translate(itemToDraw.labelX, itemToDraw.labelY);
					context.rotate(itemToDraw.rotation);
					context.font = itemToDraw.major ? majorTickFont.font : tickFont.font;
					context.fillStyle = itemToDraw.major ? majorTickFontColor : tickFontColor;
					context.textBaseline = itemToDraw.textBaseline;
					context.textAlign = itemToDraw.textAlign;

					var label = itemToDraw.label;
					if (helpers.isArray(label)) {
						var lineCount = label.length;
						var lineHeight = tickFont.size * 1.5;
						var y = me.isHorizontal() ? 0 : -lineHeight * (lineCount - 1) / 2;

						for (var i = 0; i < lineCount; ++i) {
							// We just make sure the multiline element is a string here..
							context.fillText('' + label[i], 0, y);
							// apply same lineSpacing as calculated @ L#320
							y += lineHeight;
						}
					} else {
						context.fillText(label, 0, 0);
					}
					context.restore();
				}
			});

			if (scaleLabel.display) {
				// Draw the scale label
				var scaleLabelX;
				var scaleLabelY;
				var rotation = 0;
				var halfLineHeight = parseLineHeight(scaleLabel) / 2;

				if (isHorizontal) {
					scaleLabelX = me.left + ((me.right - me.left) / 2); // midpoint of the width
					scaleLabelY = options.position === 'bottom'
						? me.bottom - halfLineHeight - scaleLabelPadding.bottom
						: me.top + halfLineHeight + scaleLabelPadding.top;
				} else {
					var isLeft = options.position === 'left';
					scaleLabelX = isLeft
						? me.left + halfLineHeight + scaleLabelPadding.top
						: me.right - halfLineHeight - scaleLabelPadding.top;
					scaleLabelY = me.top + ((me.bottom - me.top) / 2);
					rotation = isLeft ? -0.5 * Math.PI : 0.5 * Math.PI;
				}

				context.save();
				context.translate(scaleLabelX, scaleLabelY);
				context.rotate(rotation);
				context.textAlign = 'center';
				context.textBaseline = 'middle';
				context.fillStyle = scaleLabelFontColor; // render in correct colour
				context.font = scaleLabelFont.font;
				context.fillText(scaleLabel.labelString, 0, 0);
				context.restore();
			}

			if (gridLines.drawBorder) {
				// Draw the line at the edge of the axis
				context.lineWidth = helpers.valueAtIndexOrDefault(gridLines.lineWidth, 0);
				context.strokeStyle = helpers.valueAtIndexOrDefault(gridLines.color, 0);
				var x1 = me.left;
				var x2 = me.right + axisWidth;
				var y1 = me.top;
				var y2 = me.bottom + axisWidth;

				var aliasPixel = helpers.aliasPixel(context.lineWidth);
				if (isHorizontal) {
					y1 = y2 = options.position === 'top' ? me.bottom : me.top;
					y1 += aliasPixel;
					y2 += aliasPixel;
				} else {
					x1 = x2 = options.position === 'left' ? me.right : me.left;
					x1 += aliasPixel;
					x2 += aliasPixel;
				}

				context.beginPath();
				context.moveTo(x1, y1);
				context.lineTo(x2, y2);
				context.stroke();
			}
		}
	});
};


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(2);
var Element = __webpack_require__(8);
var helpers = __webpack_require__(1);

defaults._set('global', {
	tooltips: {
		enabled: true,
		custom: null,
		mode: 'nearest',
		position: 'average',
		intersect: true,
		backgroundColor: 'rgba(0,0,0,0.8)',
		titleFontStyle: 'bold',
		titleSpacing: 2,
		titleMarginBottom: 6,
		titleFontColor: '#fff',
		titleAlign: 'left',
		bodySpacing: 2,
		bodyFontColor: '#fff',
		bodyAlign: 'left',
		footerFontStyle: 'bold',
		footerSpacing: 2,
		footerMarginTop: 6,
		footerFontColor: '#fff',
		footerAlign: 'left',
		yPadding: 6,
		xPadding: 6,
		caretPadding: 2,
		caretSize: 5,
		cornerRadius: 6,
		multiKeyBackground: '#fff',
		displayColors: true,
		borderColor: 'rgba(0,0,0,0)',
		borderWidth: 0,
		callbacks: {
			// Args are: (tooltipItems, data)
			beforeTitle: helpers.noop,
			title: function(tooltipItems, data) {
				// Pick first xLabel for now
				var title = '';
				var labels = data.labels;
				var labelCount = labels ? labels.length : 0;

				if (tooltipItems.length > 0) {
					var item = tooltipItems[0];

					if (item.xLabel) {
						title = item.xLabel;
					} else if (labelCount > 0 && item.index < labelCount) {
						title = labels[item.index];
					}
				}

				return title;
			},
			afterTitle: helpers.noop,

			// Args are: (tooltipItems, data)
			beforeBody: helpers.noop,

			// Args are: (tooltipItem, data)
			beforeLabel: helpers.noop,
			label: function(tooltipItem, data) {
				var label = data.datasets[tooltipItem.datasetIndex].label || '';

				if (label) {
					label += ': ';
				}
				label += tooltipItem.yLabel;
				return label;
			},
			labelColor: function(tooltipItem, chart) {
				var meta = chart.getDatasetMeta(tooltipItem.datasetIndex);
				var activeElement = meta.data[tooltipItem.index];
				var view = activeElement._view;
				return {
					borderColor: view.borderColor,
					backgroundColor: view.backgroundColor
				};
			},
			labelTextColor: function() {
				return this._options.bodyFontColor;
			},
			afterLabel: helpers.noop,

			// Args are: (tooltipItems, data)
			afterBody: helpers.noop,

			// Args are: (tooltipItems, data)
			beforeFooter: helpers.noop,
			footer: helpers.noop,
			afterFooter: helpers.noop
		}
	}
});

module.exports = function(Chart) {

	/**
 	 * Helper method to merge the opacity into a color
 	 */
	function mergeOpacity(colorString, opacity) {
		var color = helpers.color(colorString);
		return color.alpha(opacity * color.alpha()).rgbaString();
	}

	// Helper to push or concat based on if the 2nd parameter is an array or not
	function pushOrConcat(base, toPush) {
		if (toPush) {
			if (helpers.isArray(toPush)) {
				// base = base.concat(toPush);
				Array.prototype.push.apply(base, toPush);
			} else {
				base.push(toPush);
			}
		}

		return base;
	}

	// Private helper to create a tooltip item model
	// @param element : the chart element (point, arc, bar) to create the tooltip item for
	// @return : new tooltip item
	function createTooltipItem(element) {
		var xScale = element._xScale;
		var yScale = element._yScale || element._scale; // handle radar || polarArea charts
		var index = element._index;
		var datasetIndex = element._datasetIndex;

		return {
			xLabel: xScale ? xScale.getLabelForIndex(index, datasetIndex) : '',
			yLabel: yScale ? yScale.getLabelForIndex(index, datasetIndex) : '',
			index: index,
			datasetIndex: datasetIndex,
			x: element._model.x,
			y: element._model.y
		};
	}

	/**
	 * Helper to get the reset model for the tooltip
	 * @param tooltipOpts {Object} the tooltip options
	 */
	function getBaseModel(tooltipOpts) {
		var globalDefaults = defaults.global;
		var valueOrDefault = helpers.valueOrDefault;

		return {
			// Positioning
			xPadding: tooltipOpts.xPadding,
			yPadding: tooltipOpts.yPadding,
			xAlign: tooltipOpts.xAlign,
			yAlign: tooltipOpts.yAlign,

			// Body
			bodyFontColor: tooltipOpts.bodyFontColor,
			_bodyFontFamily: valueOrDefault(tooltipOpts.bodyFontFamily, globalDefaults.defaultFontFamily),
			_bodyFontStyle: valueOrDefault(tooltipOpts.bodyFontStyle, globalDefaults.defaultFontStyle),
			_bodyAlign: tooltipOpts.bodyAlign,
			bodyFontSize: valueOrDefault(tooltipOpts.bodyFontSize, globalDefaults.defaultFontSize),
			bodySpacing: tooltipOpts.bodySpacing,

			// Title
			titleFontColor: tooltipOpts.titleFontColor,
			_titleFontFamily: valueOrDefault(tooltipOpts.titleFontFamily, globalDefaults.defaultFontFamily),
			_titleFontStyle: valueOrDefault(tooltipOpts.titleFontStyle, globalDefaults.defaultFontStyle),
			titleFontSize: valueOrDefault(tooltipOpts.titleFontSize, globalDefaults.defaultFontSize),
			_titleAlign: tooltipOpts.titleAlign,
			titleSpacing: tooltipOpts.titleSpacing,
			titleMarginBottom: tooltipOpts.titleMarginBottom,

			// Footer
			footerFontColor: tooltipOpts.footerFontColor,
			_footerFontFamily: valueOrDefault(tooltipOpts.footerFontFamily, globalDefaults.defaultFontFamily),
			_footerFontStyle: valueOrDefault(tooltipOpts.footerFontStyle, globalDefaults.defaultFontStyle),
			footerFontSize: valueOrDefault(tooltipOpts.footerFontSize, globalDefaults.defaultFontSize),
			_footerAlign: tooltipOpts.footerAlign,
			footerSpacing: tooltipOpts.footerSpacing,
			footerMarginTop: tooltipOpts.footerMarginTop,

			// Appearance
			caretSize: tooltipOpts.caretSize,
			cornerRadius: tooltipOpts.cornerRadius,
			backgroundColor: tooltipOpts.backgroundColor,
			opacity: 0,
			legendColorBackground: tooltipOpts.multiKeyBackground,
			displayColors: tooltipOpts.displayColors,
			borderColor: tooltipOpts.borderColor,
			borderWidth: tooltipOpts.borderWidth
		};
	}

	/**
	 * Get the size of the tooltip
	 */
	function getTooltipSize(tooltip, model) {
		var ctx = tooltip._chart.ctx;

		var height = model.yPadding * 2; // Tooltip Padding
		var width = 0;

		// Count of all lines in the body
		var body = model.body;
		var combinedBodyLength = body.reduce(function(count, bodyItem) {
			return count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length;
		}, 0);
		combinedBodyLength += model.beforeBody.length + model.afterBody.length;

		var titleLineCount = model.title.length;
		var footerLineCount = model.footer.length;
		var titleFontSize = model.titleFontSize;
		var bodyFontSize = model.bodyFontSize;
		var footerFontSize = model.footerFontSize;

		height += titleLineCount * titleFontSize; // Title Lines
		height += titleLineCount ? (titleLineCount - 1) * model.titleSpacing : 0; // Title Line Spacing
		height += titleLineCount ? model.titleMarginBottom : 0; // Title's bottom Margin
		height += combinedBodyLength * bodyFontSize; // Body Lines
		height += combinedBodyLength ? (combinedBodyLength - 1) * model.bodySpacing : 0; // Body Line Spacing
		height += footerLineCount ? model.footerMarginTop : 0; // Footer Margin
		height += footerLineCount * (footerFontSize); // Footer Lines
		height += footerLineCount ? (footerLineCount - 1) * model.footerSpacing : 0; // Footer Line Spacing

		// Title width
		var widthPadding = 0;
		var maxLineWidth = function(line) {
			width = Math.max(width, ctx.measureText(line).width + widthPadding);
		};

		ctx.font = helpers.fontString(titleFontSize, model._titleFontStyle, model._titleFontFamily);
		helpers.each(model.title, maxLineWidth);

		// Body width
		ctx.font = helpers.fontString(bodyFontSize, model._bodyFontStyle, model._bodyFontFamily);
		helpers.each(model.beforeBody.concat(model.afterBody), maxLineWidth);

		// Body lines may include some extra width due to the color box
		widthPadding = model.displayColors ? (bodyFontSize + 2) : 0;
		helpers.each(body, function(bodyItem) {
			helpers.each(bodyItem.before, maxLineWidth);
			helpers.each(bodyItem.lines, maxLineWidth);
			helpers.each(bodyItem.after, maxLineWidth);
		});

		// Reset back to 0
		widthPadding = 0;

		// Footer width
		ctx.font = helpers.fontString(footerFontSize, model._footerFontStyle, model._footerFontFamily);
		helpers.each(model.footer, maxLineWidth);

		// Add padding
		width += 2 * model.xPadding;

		return {
			width: width,
			height: height
		};
	}

	/**
	 * Helper to get the alignment of a tooltip given the size
	 */
	function determineAlignment(tooltip, size) {
		var model = tooltip._model;
		var chart = tooltip._chart;
		var chartArea = tooltip._chart.chartArea;
		var xAlign = 'center';
		var yAlign = 'center';

		if (model.y < size.height) {
			yAlign = 'top';
		} else if (model.y > (chart.height - size.height)) {
			yAlign = 'bottom';
		}

		var lf, rf; // functions to determine left, right alignment
		var olf, orf; // functions to determine if left/right alignment causes tooltip to go outside chart
		var yf; // function to get the y alignment if the tooltip goes outside of the left or right edges
		var midX = (chartArea.left + chartArea.right) / 2;
		var midY = (chartArea.top + chartArea.bottom) / 2;

		if (yAlign === 'center') {
			lf = function(x) {
				return x <= midX;
			};
			rf = function(x) {
				return x > midX;
			};
		} else {
			lf = function(x) {
				return x <= (size.width / 2);
			};
			rf = function(x) {
				return x >= (chart.width - (size.width / 2));
			};
		}

		olf = function(x) {
			return x + size.width + model.caretSize + model.caretPadding > chart.width;
		};
		orf = function(x) {
			return x - size.width - model.caretSize - model.caretPadding < 0;
		};
		yf = function(y) {
			return y <= midY ? 'top' : 'bottom';
		};

		if (lf(model.x)) {
			xAlign = 'left';

			// Is tooltip too wide and goes over the right side of the chart.?
			if (olf(model.x)) {
				xAlign = 'center';
				yAlign = yf(model.y);
			}
		} else if (rf(model.x)) {
			xAlign = 'right';

			// Is tooltip too wide and goes outside left edge of canvas?
			if (orf(model.x)) {
				xAlign = 'center';
				yAlign = yf(model.y);
			}
		}

		var opts = tooltip._options;
		return {
			xAlign: opts.xAlign ? opts.xAlign : xAlign,
			yAlign: opts.yAlign ? opts.yAlign : yAlign
		};
	}

	/**
	 * @Helper to get the location a tooltip needs to be placed at given the initial position (via the vm) and the size and alignment
	 */
	function getBackgroundPoint(vm, size, alignment, chart) {
		// Background Position
		var x = vm.x;
		var y = vm.y;

		var caretSize = vm.caretSize;
		var caretPadding = vm.caretPadding;
		var cornerRadius = vm.cornerRadius;
		var xAlign = alignment.xAlign;
		var yAlign = alignment.yAlign;
		var paddingAndSize = caretSize + caretPadding;
		var radiusAndPadding = cornerRadius + caretPadding;

		if (xAlign === 'right') {
			x -= size.width;
		} else if (xAlign === 'center') {
			x -= (size.width / 2);
			if (x + size.width > chart.width) {
				x = chart.width - size.width;
			}
			if (x < 0) {
				x = 0;
			}
		}

		if (yAlign === 'top') {
			y += paddingAndSize;
		} else if (yAlign === 'bottom') {
			y -= size.height + paddingAndSize;
		} else {
			y -= (size.height / 2);
		}

		if (yAlign === 'center') {
			if (xAlign === 'left') {
				x += paddingAndSize;
			} else if (xAlign === 'right') {
				x -= paddingAndSize;
			}
		} else if (xAlign === 'left') {
			x -= radiusAndPadding;
		} else if (xAlign === 'right') {
			x += radiusAndPadding;
		}

		return {
			x: x,
			y: y
		};
	}

	Chart.Tooltip = Element.extend({
		initialize: function() {
			this._model = getBaseModel(this._options);
			this._lastActive = [];
		},

		// Get the title
		// Args are: (tooltipItem, data)
		getTitle: function() {
			var me = this;
			var opts = me._options;
			var callbacks = opts.callbacks;

			var beforeTitle = callbacks.beforeTitle.apply(me, arguments);
			var title = callbacks.title.apply(me, arguments);
			var afterTitle = callbacks.afterTitle.apply(me, arguments);

			var lines = [];
			lines = pushOrConcat(lines, beforeTitle);
			lines = pushOrConcat(lines, title);
			lines = pushOrConcat(lines, afterTitle);

			return lines;
		},

		// Args are: (tooltipItem, data)
		getBeforeBody: function() {
			var lines = this._options.callbacks.beforeBody.apply(this, arguments);
			return helpers.isArray(lines) ? lines : lines !== undefined ? [lines] : [];
		},

		// Args are: (tooltipItem, data)
		getBody: function(tooltipItems, data) {
			var me = this;
			var callbacks = me._options.callbacks;
			var bodyItems = [];

			helpers.each(tooltipItems, function(tooltipItem) {
				var bodyItem = {
					before: [],
					lines: [],
					after: []
				};
				pushOrConcat(bodyItem.before, callbacks.beforeLabel.call(me, tooltipItem, data));
				pushOrConcat(bodyItem.lines, callbacks.label.call(me, tooltipItem, data));
				pushOrConcat(bodyItem.after, callbacks.afterLabel.call(me, tooltipItem, data));

				bodyItems.push(bodyItem);
			});

			return bodyItems;
		},

		// Args are: (tooltipItem, data)
		getAfterBody: function() {
			var lines = this._options.callbacks.afterBody.apply(this, arguments);
			return helpers.isArray(lines) ? lines : lines !== undefined ? [lines] : [];
		},

		// Get the footer and beforeFooter and afterFooter lines
		// Args are: (tooltipItem, data)
		getFooter: function() {
			var me = this;
			var callbacks = me._options.callbacks;

			var beforeFooter = callbacks.beforeFooter.apply(me, arguments);
			var footer = callbacks.footer.apply(me, arguments);
			var afterFooter = callbacks.afterFooter.apply(me, arguments);

			var lines = [];
			lines = pushOrConcat(lines, beforeFooter);
			lines = pushOrConcat(lines, footer);
			lines = pushOrConcat(lines, afterFooter);

			return lines;
		},

		update: function(changed) {
			var me = this;
			var opts = me._options;

			// Need to regenerate the model because its faster than using extend and it is necessary due to the optimization in Chart.Element.transition
			// that does _view = _model if ease === 1. This causes the 2nd tooltip update to set properties in both the view and model at the same time
			// which breaks any animations.
			var existingModel = me._model;
			var model = me._model = getBaseModel(opts);
			var active = me._active;

			var data = me._data;

			// In the case where active.length === 0 we need to keep these at existing values for good animations
			var alignment = {
				xAlign: existingModel.xAlign,
				yAlign: existingModel.yAlign
			};
			var backgroundPoint = {
				x: existingModel.x,
				y: existingModel.y
			};
			var tooltipSize = {
				width: existingModel.width,
				height: existingModel.height
			};
			var tooltipPosition = {
				x: existingModel.caretX,
				y: existingModel.caretY
			};

			var i, len;

			if (active.length) {
				model.opacity = 1;

				var labelColors = [];
				var labelTextColors = [];
				tooltipPosition = Chart.Tooltip.positioners[opts.position].call(me, active, me._eventPosition);

				var tooltipItems = [];
				for (i = 0, len = active.length; i < len; ++i) {
					tooltipItems.push(createTooltipItem(active[i]));
				}

				// If the user provided a filter function, use it to modify the tooltip items
				if (opts.filter) {
					tooltipItems = tooltipItems.filter(function(a) {
						return opts.filter(a, data);
					});
				}

				// If the user provided a sorting function, use it to modify the tooltip items
				if (opts.itemSort) {
					tooltipItems = tooltipItems.sort(function(a, b) {
						return opts.itemSort(a, b, data);
					});
				}

				// Determine colors for boxes
				helpers.each(tooltipItems, function(tooltipItem) {
					labelColors.push(opts.callbacks.labelColor.call(me, tooltipItem, me._chart));
					labelTextColors.push(opts.callbacks.labelTextColor.call(me, tooltipItem, me._chart));
				});


				// Build the Text Lines
				model.title = me.getTitle(tooltipItems, data);
				model.beforeBody = me.getBeforeBody(tooltipItems, data);
				model.body = me.getBody(tooltipItems, data);
				model.afterBody = me.getAfterBody(tooltipItems, data);
				model.footer = me.getFooter(tooltipItems, data);

				// Initial positioning and colors
				model.x = Math.round(tooltipPosition.x);
				model.y = Math.round(tooltipPosition.y);
				model.caretPadding = opts.caretPadding;
				model.labelColors = labelColors;
				model.labelTextColors = labelTextColors;

				// data points
				model.dataPoints = tooltipItems;

				// We need to determine alignment of the tooltip
				tooltipSize = getTooltipSize(this, model);
				alignment = determineAlignment(this, tooltipSize);
				// Final Size and Position
				backgroundPoint = getBackgroundPoint(model, tooltipSize, alignment, me._chart);
			} else {
				model.opacity = 0;
			}

			model.xAlign = alignment.xAlign;
			model.yAlign = alignment.yAlign;
			model.x = backgroundPoint.x;
			model.y = backgroundPoint.y;
			model.width = tooltipSize.width;
			model.height = tooltipSize.height;

			// Point where the caret on the tooltip points to
			model.caretX = tooltipPosition.x;
			model.caretY = tooltipPosition.y;

			me._model = model;

			if (changed && opts.custom) {
				opts.custom.call(me, model);
			}

			return me;
		},
		drawCaret: function(tooltipPoint, size) {
			var ctx = this._chart.ctx;
			var vm = this._view;
			var caretPosition = this.getCaretPosition(tooltipPoint, size, vm);

			ctx.lineTo(caretPosition.x1, caretPosition.y1);
			ctx.lineTo(caretPosition.x2, caretPosition.y2);
			ctx.lineTo(caretPosition.x3, caretPosition.y3);
		},
		getCaretPosition: function(tooltipPoint, size, vm) {
			var x1, x2, x3, y1, y2, y3;
			var caretSize = vm.caretSize;
			var cornerRadius = vm.cornerRadius;
			var xAlign = vm.xAlign;
			var yAlign = vm.yAlign;
			var ptX = tooltipPoint.x;
			var ptY = tooltipPoint.y;
			var width = size.width;
			var height = size.height;

			if (yAlign === 'center') {
				y2 = ptY + (height / 2);

				if (xAlign === 'left') {
					x1 = ptX;
					x2 = x1 - caretSize;
					x3 = x1;

					y1 = y2 + caretSize;
					y3 = y2 - caretSize;
				} else {
					x1 = ptX + width;
					x2 = x1 + caretSize;
					x3 = x1;

					y1 = y2 - caretSize;
					y3 = y2 + caretSize;
				}
			} else {
				if (xAlign === 'left') {
					x2 = ptX + cornerRadius + (caretSize);
					x1 = x2 - caretSize;
					x3 = x2 + caretSize;
				} else if (xAlign === 'right') {
					x2 = ptX + width - cornerRadius - caretSize;
					x1 = x2 - caretSize;
					x3 = x2 + caretSize;
				} else {
					x2 = vm.caretX;
					x1 = x2 - caretSize;
					x3 = x2 + caretSize;
				}
				if (yAlign === 'top') {
					y1 = ptY;
					y2 = y1 - caretSize;
					y3 = y1;
				} else {
					y1 = ptY + height;
					y2 = y1 + caretSize;
					y3 = y1;
					// invert drawing order
					var tmp = x3;
					x3 = x1;
					x1 = tmp;
				}
			}
			return {x1: x1, x2: x2, x3: x3, y1: y1, y2: y2, y3: y3};
		},
		drawTitle: function(pt, vm, ctx, opacity) {
			var title = vm.title;

			if (title.length) {
				ctx.textAlign = vm._titleAlign;
				ctx.textBaseline = 'top';

				var titleFontSize = vm.titleFontSize;
				var titleSpacing = vm.titleSpacing;

				ctx.fillStyle = mergeOpacity(vm.titleFontColor, opacity);
				ctx.font = helpers.fontString(titleFontSize, vm._titleFontStyle, vm._titleFontFamily);

				var i, len;
				for (i = 0, len = title.length; i < len; ++i) {
					ctx.fillText(title[i], pt.x, pt.y);
					pt.y += titleFontSize + titleSpacing; // Line Height and spacing

					if (i + 1 === title.length) {
						pt.y += vm.titleMarginBottom - titleSpacing; // If Last, add margin, remove spacing
					}
				}
			}
		},
		drawBody: function(pt, vm, ctx, opacity) {
			var bodyFontSize = vm.bodyFontSize;
			var bodySpacing = vm.bodySpacing;
			var body = vm.body;

			ctx.textAlign = vm._bodyAlign;
			ctx.textBaseline = 'top';
			ctx.font = helpers.fontString(bodyFontSize, vm._bodyFontStyle, vm._bodyFontFamily);

			// Before Body
			var xLinePadding = 0;
			var fillLineOfText = function(line) {
				ctx.fillText(line, pt.x + xLinePadding, pt.y);
				pt.y += bodyFontSize + bodySpacing;
			};

			// Before body lines
			ctx.fillStyle = mergeOpacity(vm.bodyFontColor, opacity);
			helpers.each(vm.beforeBody, fillLineOfText);

			var drawColorBoxes = vm.displayColors;
			xLinePadding = drawColorBoxes ? (bodyFontSize + 2) : 0;

			// Draw body lines now
			helpers.each(body, function(bodyItem, i) {
				var textColor = mergeOpacity(vm.labelTextColors[i], opacity);
				ctx.fillStyle = textColor;
				helpers.each(bodyItem.before, fillLineOfText);

				helpers.each(bodyItem.lines, function(line) {
					// Draw Legend-like boxes if needed
					if (drawColorBoxes) {
						// Fill a white rect so that colours merge nicely if the opacity is < 1
						ctx.fillStyle = mergeOpacity(vm.legendColorBackground, opacity);
						ctx.fillRect(pt.x, pt.y, bodyFontSize, bodyFontSize);

						// Border
						ctx.lineWidth = 1;
						ctx.strokeStyle = mergeOpacity(vm.labelColors[i].borderColor, opacity);
						ctx.strokeRect(pt.x, pt.y, bodyFontSize, bodyFontSize);

						// Inner square
						ctx.fillStyle = mergeOpacity(vm.labelColors[i].backgroundColor, opacity);
						ctx.fillRect(pt.x + 1, pt.y + 1, bodyFontSize - 2, bodyFontSize - 2);
						ctx.fillStyle = textColor;
					}

					fillLineOfText(line);
				});

				helpers.each(bodyItem.after, fillLineOfText);
			});

			// Reset back to 0 for after body
			xLinePadding = 0;

			// After body lines
			helpers.each(vm.afterBody, fillLineOfText);
			pt.y -= bodySpacing; // Remove last body spacing
		},
		drawFooter: function(pt, vm, ctx, opacity) {
			var footer = vm.footer;

			if (footer.length) {
				pt.y += vm.footerMarginTop;

				ctx.textAlign = vm._footerAlign;
				ctx.textBaseline = 'top';

				ctx.fillStyle = mergeOpacity(vm.footerFontColor, opacity);
				ctx.font = helpers.fontString(vm.footerFontSize, vm._footerFontStyle, vm._footerFontFamily);

				helpers.each(footer, function(line) {
					ctx.fillText(line, pt.x, pt.y);
					pt.y += vm.footerFontSize + vm.footerSpacing;
				});
			}
		},
		drawBackground: function(pt, vm, ctx, tooltipSize, opacity) {
			ctx.fillStyle = mergeOpacity(vm.backgroundColor, opacity);
			ctx.strokeStyle = mergeOpacity(vm.borderColor, opacity);
			ctx.lineWidth = vm.borderWidth;
			var xAlign = vm.xAlign;
			var yAlign = vm.yAlign;
			var x = pt.x;
			var y = pt.y;
			var width = tooltipSize.width;
			var height = tooltipSize.height;
			var radius = vm.cornerRadius;

			ctx.beginPath();
			ctx.moveTo(x + radius, y);
			if (yAlign === 'top') {
				this.drawCaret(pt, tooltipSize);
			}
			ctx.lineTo(x + width - radius, y);
			ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
			if (yAlign === 'center' && xAlign === 'right') {
				this.drawCaret(pt, tooltipSize);
			}
			ctx.lineTo(x + width, y + height - radius);
			ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
			if (yAlign === 'bottom') {
				this.drawCaret(pt, tooltipSize);
			}
			ctx.lineTo(x + radius, y + height);
			ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
			if (yAlign === 'center' && xAlign === 'left') {
				this.drawCaret(pt, tooltipSize);
			}
			ctx.lineTo(x, y + radius);
			ctx.quadraticCurveTo(x, y, x + radius, y);
			ctx.closePath();

			ctx.fill();

			if (vm.borderWidth > 0) {
				ctx.stroke();
			}
		},
		draw: function() {
			var ctx = this._chart.ctx;
			var vm = this._view;

			if (vm.opacity === 0) {
				return;
			}

			var tooltipSize = {
				width: vm.width,
				height: vm.height
			};
			var pt = {
				x: vm.x,
				y: vm.y
			};

			// IE11/Edge does not like very small opacities, so snap to 0
			var opacity = Math.abs(vm.opacity < 1e-3) ? 0 : vm.opacity;

			// Truthy/falsey value for empty tooltip
			var hasTooltipContent = vm.title.length || vm.beforeBody.length || vm.body.length || vm.afterBody.length || vm.footer.length;

			if (this._options.enabled && hasTooltipContent) {
				// Draw Background
				this.drawBackground(pt, vm, ctx, tooltipSize, opacity);

				// Draw Title, Body, and Footer
				pt.x += vm.xPadding;
				pt.y += vm.yPadding;

				// Titles
				this.drawTitle(pt, vm, ctx, opacity);

				// Body
				this.drawBody(pt, vm, ctx, opacity);

				// Footer
				this.drawFooter(pt, vm, ctx, opacity);
			}
		},

		/**
		 * Handle an event
		 * @private
		 * @param {IEvent} event - The event to handle
		 * @returns {Boolean} true if the tooltip changed
		 */
		handleEvent: function(e) {
			var me = this;
			var options = me._options;
			var changed = false;

			me._lastActive = me._lastActive || [];

			// Find Active Elements for tooltips
			if (e.type === 'mouseout') {
				me._active = [];
			} else {
				me._active = me._chart.getElementsAtEventForMode(e, options.mode, options);
			}

			// Remember Last Actives
			changed = !helpers.arrayEquals(me._active, me._lastActive);

			// Only handle target event on tooltip change
			if (changed) {
				me._lastActive = me._active;

				if (options.enabled || options.custom) {
					me._eventPosition = {
						x: e.x,
						y: e.y
					};

					me.update(true);
					me.pivot();
				}
			}

			return changed;
		}
	});

	/**
	 * @namespace Chart.Tooltip.positioners
	 */
	Chart.Tooltip.positioners = {
		/**
		 * Average mode places the tooltip at the average position of the elements shown
		 * @function Chart.Tooltip.positioners.average
		 * @param elements {ChartElement[]} the elements being displayed in the tooltip
		 * @returns {Point} tooltip position
		 */
		average: function(elements) {
			if (!elements.length) {
				return false;
			}

			var i, len;
			var x = 0;
			var y = 0;
			var count = 0;

			for (i = 0, len = elements.length; i < len; ++i) {
				var el = elements[i];
				if (el && el.hasValue()) {
					var pos = el.tooltipPosition();
					x += pos.x;
					y += pos.y;
					++count;
				}
			}

			return {
				x: Math.round(x / count),
				y: Math.round(y / count)
			};
		},

		/**
		 * Gets the tooltip position nearest of the item nearest to the event position
		 * @function Chart.Tooltip.positioners.nearest
		 * @param elements {Chart.Element[]} the tooltip elements
		 * @param eventPosition {Point} the position of the event in canvas coordinates
		 * @returns {Point} the tooltip position
		 */
		nearest: function(elements, eventPosition) {
			var x = eventPosition.x;
			var y = eventPosition.y;
			var minDistance = Number.POSITIVE_INFINITY;
			var i, len, nearestElement;

			for (i = 0, len = elements.length; i < len; ++i) {
				var el = elements[i];
				if (el && el.hasValue()) {
					var center = el.getCenterPoint();
					var d = helpers.distanceBetweenPoints(eventPosition, center);

					if (d < minDistance) {
						minDistance = d;
						nearestElement = el;
					}
				}
			}

			if (nearestElement) {
				var tp = nearestElement.tooltipPosition();
				x = tp.x;
				y = tp.y;
			}

			return {
				x: x,
				y: y
			};
		}
	};
};


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var helpers = __webpack_require__(1);

/**
 * Generate a set of linear ticks
 * @param generationOptions the options used to generate the ticks
 * @param dataRange the range of the data
 * @returns {Array<Number>} array of tick values
 */
function generateTicks(generationOptions, dataRange) {
	var ticks = [];
	// To get a "nice" value for the tick spacing, we will use the appropriately named
	// "nice number" algorithm. See http://stackoverflow.com/questions/8506881/nice-label-algorithm-for-charts-with-minimum-ticks
	// for details.

	var spacing;
	if (generationOptions.stepSize && generationOptions.stepSize > 0) {
		spacing = generationOptions.stepSize;
	} else {
		var niceRange = helpers.niceNum(dataRange.max - dataRange.min, false);
		spacing = helpers.niceNum(niceRange / (generationOptions.maxTicks - 1), true);
	}
	var niceMin = Math.floor(dataRange.min / spacing) * spacing;
	var niceMax = Math.ceil(dataRange.max / spacing) * spacing;

	// If min, max and stepSize is set and they make an evenly spaced scale use it.
	if (generationOptions.min && generationOptions.max && generationOptions.stepSize) {
		// If very close to our whole number, use it.
		if (helpers.almostWhole((generationOptions.max - generationOptions.min) / generationOptions.stepSize, spacing / 1000)) {
			niceMin = generationOptions.min;
			niceMax = generationOptions.max;
		}
	}

	var numSpaces = (niceMax - niceMin) / spacing;
	// If very close to our rounded value, use it.
	if (helpers.almostEquals(numSpaces, Math.round(numSpaces), spacing / 1000)) {
		numSpaces = Math.round(numSpaces);
	} else {
		numSpaces = Math.ceil(numSpaces);
	}

	var precision = 1;
	if (spacing < 1) {
		precision = Math.pow(10, spacing.toString().length - 2);
		niceMin = Math.round(niceMin * precision) / precision;
		niceMax = Math.round(niceMax * precision) / precision;
	}
	ticks.push(generationOptions.min !== undefined ? generationOptions.min : niceMin);
	for (var j = 1; j < numSpaces; ++j) {
		ticks.push(Math.round((niceMin + j * spacing) * precision) / precision);
	}
	ticks.push(generationOptions.max !== undefined ? generationOptions.max : niceMax);

	return ticks;
}


module.exports = function(Chart) {

	var noop = helpers.noop;

	Chart.LinearScaleBase = Chart.Scale.extend({
		getRightValue: function(value) {
			if (typeof value === 'string') {
				return +value;
			}
			return Chart.Scale.prototype.getRightValue.call(this, value);
		},

		handleTickRangeOptions: function() {
			var me = this;
			var opts = me.options;
			var tickOpts = opts.ticks;

			// If we are forcing it to begin at 0, but 0 will already be rendered on the chart,
			// do nothing since that would make the chart weird. If the user really wants a weird chart
			// axis, they can manually override it
			if (tickOpts.beginAtZero) {
				var minSign = helpers.sign(me.min);
				var maxSign = helpers.sign(me.max);

				if (minSign < 0 && maxSign < 0) {
					// move the top up to 0
					me.max = 0;
				} else if (minSign > 0 && maxSign > 0) {
					// move the bottom down to 0
					me.min = 0;
				}
			}

			var setMin = tickOpts.min !== undefined || tickOpts.suggestedMin !== undefined;
			var setMax = tickOpts.max !== undefined || tickOpts.suggestedMax !== undefined;

			if (tickOpts.min !== undefined) {
				me.min = tickOpts.min;
			} else if (tickOpts.suggestedMin !== undefined) {
				if (me.min === null) {
					me.min = tickOpts.suggestedMin;
				} else {
					me.min = Math.min(me.min, tickOpts.suggestedMin);
				}
			}

			if (tickOpts.max !== undefined) {
				me.max = tickOpts.max;
			} else if (tickOpts.suggestedMax !== undefined) {
				if (me.max === null) {
					me.max = tickOpts.suggestedMax;
				} else {
					me.max = Math.max(me.max, tickOpts.suggestedMax);
				}
			}

			if (setMin !== setMax) {
				// We set the min or the max but not both.
				// So ensure that our range is good
				// Inverted or 0 length range can happen when
				// ticks.min is set, and no datasets are visible
				if (me.min >= me.max) {
					if (setMin) {
						me.max = me.min + 1;
					} else {
						me.min = me.max - 1;
					}
				}
			}

			if (me.min === me.max) {
				me.max++;

				if (!tickOpts.beginAtZero) {
					me.min--;
				}
			}
		},
		getTickLimit: noop,
		handleDirectionalChanges: noop,

		buildTicks: function() {
			var me = this;
			var opts = me.options;
			var tickOpts = opts.ticks;

			// Figure out what the max number of ticks we can support it is based on the size of
			// the axis area. For now, we say that the minimum tick spacing in pixels must be 50
			// We also limit the maximum number of ticks to 11 which gives a nice 10 squares on
			// the graph. Make sure we always have at least 2 ticks
			var maxTicks = me.getTickLimit();
			maxTicks = Math.max(2, maxTicks);

			var numericGeneratorOptions = {
				maxTicks: maxTicks,
				min: tickOpts.min,
				max: tickOpts.max,
				stepSize: helpers.valueOrDefault(tickOpts.fixedStepSize, tickOpts.stepSize)
			};
			var ticks = me.ticks = generateTicks(numericGeneratorOptions, me);

			me.handleDirectionalChanges();

			// At this point, we need to update our max and min given the tick values since we have expanded the
			// range of the scale
			me.max = helpers.max(ticks);
			me.min = helpers.min(ticks);

			if (tickOpts.reverse) {
				ticks.reverse();

				me.start = me.max;
				me.end = me.min;
			} else {
				me.start = me.min;
				me.end = me.max;
			}
		},
		convertTicksToLabels: function() {
			var me = this;
			me.ticksAsNumbers = me.ticks.slice();
			me.zeroLineIndex = me.ticks.indexOf(0);

			Chart.Scale.prototype.convertTicksToLabels.call(me);
		}
	});
};


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function(Chart) {

	// Default config for a category scale
	var defaultConfig = {
		position: 'bottom'
	};

	var DatasetScale = Chart.Scale.extend({
		/**
		* Internal function to get the correct labels. If data.xLabels or data.yLabels are defined, use those
		* else fall back to data.labels
		* @private
		*/
		getLabels: function() {
			var data = this.chart.data;
			return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels;
		},

		determineDataLimits: function() {
			var me = this;
			var labels = me.getLabels();
			me.minIndex = 0;
			me.maxIndex = labels.length - 1;
			var findIndex;

			if (me.options.ticks.min !== undefined) {
				// user specified min value
				findIndex = labels.indexOf(me.options.ticks.min);
				me.minIndex = findIndex !== -1 ? findIndex : me.minIndex;
			}

			if (me.options.ticks.max !== undefined) {
				// user specified max value
				findIndex = labels.indexOf(me.options.ticks.max);
				me.maxIndex = findIndex !== -1 ? findIndex : me.maxIndex;
			}

			me.min = labels[me.minIndex];
			me.max = labels[me.maxIndex];
		},

		buildTicks: function() {
			var me = this;
			var labels = me.getLabels();
			// If we are viewing some subset of labels, slice the original array
			me.ticks = (me.minIndex === 0 && me.maxIndex === labels.length - 1) ? labels : labels.slice(me.minIndex, me.maxIndex + 1);
		},

		getLabelForIndex: function(index, datasetIndex) {
			var me = this;
			var data = me.chart.data;
			var isHorizontal = me.isHorizontal();

			if (data.yLabels && !isHorizontal) {
				return me.getRightValue(data.datasets[datasetIndex].data[index]);
			}
			return me.ticks[index - me.minIndex];
		},

		// Used to get data value locations.  Value can either be an index or a numerical value
		getPixelForValue: function(value, index) {
			var me = this;
			var offset = me.options.offset;
			// 1 is added because we need the length but we have the indexes
			var offsetAmt = Math.max((me.maxIndex + 1 - me.minIndex - (offset ? 0 : 1)), 1);

			// If value is a data object, then index is the index in the data array,
			// not the index of the scale. We need to change that.
			var valueCategory;
			if (value !== undefined && value !== null) {
				valueCategory = me.isHorizontal() ? value.x : value.y;
			}
			if (valueCategory !== undefined || (value !== undefined && isNaN(index))) {
				var labels = me.getLabels();
				value = valueCategory || value;
				var idx = labels.indexOf(value);
				index = idx !== -1 ? idx : index;
			}

			if (me.isHorizontal()) {
				var valueWidth = me.width / offsetAmt;
				var widthOffset = (valueWidth * (index - me.minIndex));

				if (offset) {
					widthOffset += (valueWidth / 2);
				}

				return me.left + Math.round(widthOffset);
			}
			var valueHeight = me.height / offsetAmt;
			var heightOffset = (valueHeight * (index - me.minIndex));

			if (offset) {
				heightOffset += (valueHeight / 2);
			}

			return me.top + Math.round(heightOffset);
		},
		getPixelForTick: function(index) {
			return this.getPixelForValue(this.ticks[index], index + this.minIndex, null);
		},
		getValueForPixel: function(pixel) {
			var me = this;
			var offset = me.options.offset;
			var value;
			var offsetAmt = Math.max((me._ticks.length - (offset ? 0 : 1)), 1);
			var horz = me.isHorizontal();
			var valueDimension = (horz ? me.width : me.height) / offsetAmt;

			pixel -= horz ? me.left : me.top;

			if (offset) {
				pixel -= (valueDimension / 2);
			}

			if (pixel <= 0) {
				value = 0;
			} else {
				value = Math.round(pixel / valueDimension);
			}

			return value + me.minIndex;
		},
		getBasePixel: function() {
			return this.bottom;
		}
	});

	Chart.scaleService.registerScaleType('category', DatasetScale, defaultConfig);

};


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(2);
var helpers = __webpack_require__(1);
var Ticks = __webpack_require__(22);

module.exports = function(Chart) {

	var defaultConfig = {
		position: 'left',
		ticks: {
			callback: Ticks.formatters.linear
		}
	};

	var LinearScale = Chart.LinearScaleBase.extend({

		determineDataLimits: function() {
			var me = this;
			var opts = me.options;
			var chart = me.chart;
			var data = chart.data;
			var datasets = data.datasets;
			var isHorizontal = me.isHorizontal();
			var DEFAULT_MIN = 0;
			var DEFAULT_MAX = 1;

			function IDMatches(meta) {
				return isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id;
			}

			// First Calculate the range
			me.min = null;
			me.max = null;

			var hasStacks = opts.stacked;
			if (hasStacks === undefined) {
				helpers.each(datasets, function(dataset, datasetIndex) {
					if (hasStacks) {
						return;
					}

					var meta = chart.getDatasetMeta(datasetIndex);
					if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta) &&
						meta.stack !== undefined) {
						hasStacks = true;
					}
				});
			}

			if (opts.stacked || hasStacks) {
				var valuesPerStack = {};

				helpers.each(datasets, function(dataset, datasetIndex) {
					var meta = chart.getDatasetMeta(datasetIndex);
					var key = [
						meta.type,
						// we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
						((opts.stacked === undefined && meta.stack === undefined) ? datasetIndex : ''),
						meta.stack
					].join('.');

					if (valuesPerStack[key] === undefined) {
						valuesPerStack[key] = {
							positiveValues: [],
							negativeValues: []
						};
					}

					// Store these per type
					var positiveValues = valuesPerStack[key].positiveValues;
					var negativeValues = valuesPerStack[key].negativeValues;

					if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
						helpers.each(dataset.data, function(rawValue, index) {
							var value = +me.getRightValue(rawValue);
							if (isNaN(value) || meta.data[index].hidden) {
								return;
							}

							positiveValues[index] = positiveValues[index] || 0;
							negativeValues[index] = negativeValues[index] || 0;

							if (opts.relativePoints) {
								positiveValues[index] = 100;
							} else if (value < 0) {
								negativeValues[index] += value;
							} else {
								positiveValues[index] += value;
							}
						});
					}
				});

				helpers.each(valuesPerStack, function(valuesForType) {
					var values = valuesForType.positiveValues.concat(valuesForType.negativeValues);
					var minVal = helpers.min(values);
					var maxVal = helpers.max(values);
					me.min = me.min === null ? minVal : Math.min(me.min, minVal);
					me.max = me.max === null ? maxVal : Math.max(me.max, maxVal);
				});

			} else {
				helpers.each(datasets, function(dataset, datasetIndex) {
					var meta = chart.getDatasetMeta(datasetIndex);
					if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
						helpers.each(dataset.data, function(rawValue, index) {
							var value = +me.getRightValue(rawValue);
							if (isNaN(value) || meta.data[index].hidden) {
								return;
							}

							if (me.min === null) {
								me.min = value;
							} else if (value < me.min) {
								me.min = value;
							}

							if (me.max === null) {
								me.max = value;
							} else if (value > me.max) {
								me.max = value;
							}
						});
					}
				});
			}

			me.min = isFinite(me.min) && !isNaN(me.min) ? me.min : DEFAULT_MIN;
			me.max = isFinite(me.max) && !isNaN(me.max) ? me.max : DEFAULT_MAX;

			// Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
			this.handleTickRangeOptions();
		},
		getTickLimit: function() {
			var maxTicks;
			var me = this;
			var tickOpts = me.options.ticks;

			if (me.isHorizontal()) {
				maxTicks = Math.min(tickOpts.maxTicksLimit ? tickOpts.maxTicksLimit : 11, Math.ceil(me.width / 50));
			} else {
				// The factor of 2 used to scale the font size has been experimentally determined.
				var tickFontSize = helpers.valueOrDefault(tickOpts.fontSize, defaults.global.defaultFontSize);
				maxTicks = Math.min(tickOpts.maxTicksLimit ? tickOpts.maxTicksLimit : 11, Math.ceil(me.height / (2 * tickFontSize)));
			}

			return maxTicks;
		},
		// Called after the ticks are built. We need
		handleDirectionalChanges: function() {
			if (!this.isHorizontal()) {
				// We are in a vertical orientation. The top value is the highest. So reverse the array
				this.ticks.reverse();
			}
		},
		getLabelForIndex: function(index, datasetIndex) {
			return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
		},
		// Utils
		getPixelForValue: function(value) {
			// This must be called after fit has been run so that
			// this.left, this.top, this.right, and this.bottom have been defined
			var me = this;
			var start = me.start;

			var rightValue = +me.getRightValue(value);
			var pixel;
			var range = me.end - start;

			if (me.isHorizontal()) {
				pixel = me.left + (me.width / range * (rightValue - start));
			} else {
				pixel = me.bottom - (me.height / range * (rightValue - start));
			}
			return pixel;
		},
		getValueForPixel: function(pixel) {
			var me = this;
			var isHorizontal = me.isHorizontal();
			var innerDimension = isHorizontal ? me.width : me.height;
			var offset = (isHorizontal ? pixel - me.left : me.bottom - pixel) / innerDimension;
			return me.start + ((me.end - me.start) * offset);
		},
		getPixelForTick: function(index) {
			return this.getPixelForValue(this.ticksAsNumbers[index]);
		}
	});
	Chart.scaleService.registerScaleType('linear', LinearScale, defaultConfig);

};


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var helpers = __webpack_require__(1);
var Ticks = __webpack_require__(22);

/**
 * Generate a set of logarithmic ticks
 * @param generationOptions the options used to generate the ticks
 * @param dataRange the range of the data
 * @returns {Array<Number>} array of tick values
 */
function generateTicks(generationOptions, dataRange) {
	var ticks = [];
	var valueOrDefault = helpers.valueOrDefault;

	// Figure out what the max number of ticks we can support it is based on the size of
	// the axis area. For now, we say that the minimum tick spacing in pixels must be 50
	// We also limit the maximum number of ticks to 11 which gives a nice 10 squares on
	// the graph
	var tickVal = valueOrDefault(generationOptions.min, Math.pow(10, Math.floor(helpers.log10(dataRange.min))));

	var endExp = Math.floor(helpers.log10(dataRange.max));
	var endSignificand = Math.ceil(dataRange.max / Math.pow(10, endExp));
	var exp, significand;

	if (tickVal === 0) {
		exp = Math.floor(helpers.log10(dataRange.minNotZero));
		significand = Math.floor(dataRange.minNotZero / Math.pow(10, exp));

		ticks.push(tickVal);
		tickVal = significand * Math.pow(10, exp);
	} else {
		exp = Math.floor(helpers.log10(tickVal));
		significand = Math.floor(tickVal / Math.pow(10, exp));
	}
	var precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;

	do {
		ticks.push(tickVal);

		++significand;
		if (significand === 10) {
			significand = 1;
			++exp;
			precision = exp >= 0 ? 1 : precision;
		}

		tickVal = Math.round(significand * Math.pow(10, exp) * precision) / precision;
	} while (exp < endExp || (exp === endExp && significand < endSignificand));

	var lastTick = valueOrDefault(generationOptions.max, tickVal);
	ticks.push(lastTick);

	return ticks;
}


module.exports = function(Chart) {

	var defaultConfig = {
		position: 'left',

		// label settings
		ticks: {
			callback: Ticks.formatters.logarithmic
		}
	};

	var LogarithmicScale = Chart.Scale.extend({
		determineDataLimits: function() {
			var me = this;
			var opts = me.options;
			var chart = me.chart;
			var data = chart.data;
			var datasets = data.datasets;
			var isHorizontal = me.isHorizontal();
			function IDMatches(meta) {
				return isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id;
			}

			// Calculate Range
			me.min = null;
			me.max = null;
			me.minNotZero = null;

			var hasStacks = opts.stacked;
			if (hasStacks === undefined) {
				helpers.each(datasets, function(dataset, datasetIndex) {
					if (hasStacks) {
						return;
					}

					var meta = chart.getDatasetMeta(datasetIndex);
					if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta) &&
						meta.stack !== undefined) {
						hasStacks = true;
					}
				});
			}

			if (opts.stacked || hasStacks) {
				var valuesPerStack = {};

				helpers.each(datasets, function(dataset, datasetIndex) {
					var meta = chart.getDatasetMeta(datasetIndex);
					var key = [
						meta.type,
						// we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
						((opts.stacked === undefined && meta.stack === undefined) ? datasetIndex : ''),
						meta.stack
					].join('.');

					if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
						if (valuesPerStack[key] === undefined) {
							valuesPerStack[key] = [];
						}

						helpers.each(dataset.data, function(rawValue, index) {
							var values = valuesPerStack[key];
							var value = +me.getRightValue(rawValue);
							// invalid, hidden and negative values are ignored
							if (isNaN(value) || meta.data[index].hidden || value < 0) {
								return;
							}
							values[index] = values[index] || 0;
							values[index] += value;
						});
					}
				});

				helpers.each(valuesPerStack, function(valuesForType) {
					if (valuesForType.length > 0) {
						var minVal = helpers.min(valuesForType);
						var maxVal = helpers.max(valuesForType);
						me.min = me.min === null ? minVal : Math.min(me.min, minVal);
						me.max = me.max === null ? maxVal : Math.max(me.max, maxVal);
					}
				});

			} else {
				helpers.each(datasets, function(dataset, datasetIndex) {
					var meta = chart.getDatasetMeta(datasetIndex);
					if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
						helpers.each(dataset.data, function(rawValue, index) {
							var value = +me.getRightValue(rawValue);
							// invalid, hidden and negative values are ignored
							if (isNaN(value) || meta.data[index].hidden || value < 0) {
								return;
							}

							if (me.min === null) {
								me.min = value;
							} else if (value < me.min) {
								me.min = value;
							}

							if (me.max === null) {
								me.max = value;
							} else if (value > me.max) {
								me.max = value;
							}

							if (value !== 0 && (me.minNotZero === null || value < me.minNotZero)) {
								me.minNotZero = value;
							}
						});
					}
				});
			}

			// Common base implementation to handle ticks.min, ticks.max
			this.handleTickRangeOptions();
		},
		handleTickRangeOptions: function() {
			var me = this;
			var opts = me.options;
			var tickOpts = opts.ticks;
			var valueOrDefault = helpers.valueOrDefault;
			var DEFAULT_MIN = 1;
			var DEFAULT_MAX = 10;

			me.min = valueOrDefault(tickOpts.min, me.min);
			me.max = valueOrDefault(tickOpts.max, me.max);

			if (me.min === me.max) {
				if (me.min !== 0 && me.min !== null) {
					me.min = Math.pow(10, Math.floor(helpers.log10(me.min)) - 1);
					me.max = Math.pow(10, Math.floor(helpers.log10(me.max)) + 1);
				} else {
					me.min = DEFAULT_MIN;
					me.max = DEFAULT_MAX;
				}
			}
			if (me.min === null) {
				me.min = Math.pow(10, Math.floor(helpers.log10(me.max)) - 1);
			}
			if (me.max === null) {
				me.max = me.min !== 0
					? Math.pow(10, Math.floor(helpers.log10(me.min)) + 1)
					: DEFAULT_MAX;
			}
			if (me.minNotZero === null) {
				if (me.min > 0) {
					me.minNotZero = me.min;
				} else if (me.max < 1) {
					me.minNotZero = Math.pow(10, Math.floor(helpers.log10(me.max)));
				} else {
					me.minNotZero = DEFAULT_MIN;
				}
			}
		},
		buildTicks: function() {
			var me = this;
			var opts = me.options;
			var tickOpts = opts.ticks;
			var reverse = !me.isHorizontal();

			var generationOptions = {
				min: tickOpts.min,
				max: tickOpts.max
			};
			var ticks = me.ticks = generateTicks(generationOptions, me);

			// At this point, we need to update our max and min given the tick values since we have expanded the
			// range of the scale
			me.max = helpers.max(ticks);
			me.min = helpers.min(ticks);

			if (tickOpts.reverse) {
				reverse = !reverse;
				me.start = me.max;
				me.end = me.min;
			} else {
				me.start = me.min;
				me.end = me.max;
			}
			if (reverse) {
				ticks.reverse();
			}
		},
		convertTicksToLabels: function() {
			this.tickValues = this.ticks.slice();

			Chart.Scale.prototype.convertTicksToLabels.call(this);
		},
		// Get the correct tooltip label
		getLabelForIndex: function(index, datasetIndex) {
			return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
		},
		getPixelForTick: function(index) {
			return this.getPixelForValue(this.tickValues[index]);
		},
		/**
		 * Returns the value of the first tick.
		 * @param {Number} value - The minimum not zero value.
		 * @return {Number} The first tick value.
		 * @private
		 */
		_getFirstTickValue: function(value) {
			var exp = Math.floor(helpers.log10(value));
			var significand = Math.floor(value / Math.pow(10, exp));

			return significand * Math.pow(10, exp);
		},
		getPixelForValue: function(value) {
			var me = this;
			var reverse = me.options.ticks.reverse;
			var log10 = helpers.log10;
			var firstTickValue = me._getFirstTickValue(me.minNotZero);
			var offset = 0;
			var innerDimension, pixel, start, end, sign;

			value = +me.getRightValue(value);
			if (reverse) {
				start = me.end;
				end = me.start;
				sign = -1;
			} else {
				start = me.start;
				end = me.end;
				sign = 1;
			}
			if (me.isHorizontal()) {
				innerDimension = me.width;
				pixel = reverse ? me.right : me.left;
			} else {
				innerDimension = me.height;
				sign *= -1; // invert, since the upper-left corner of the canvas is at pixel (0, 0)
				pixel = reverse ? me.top : me.bottom;
			}
			if (value !== start) {
				if (start === 0) { // include zero tick
					offset = helpers.getValueOrDefault(
						me.options.ticks.fontSize,
						Chart.defaults.global.defaultFontSize
					);
					innerDimension -= offset;
					start = firstTickValue;
				}
				if (value !== 0) {
					offset += innerDimension / (log10(end) - log10(start)) * (log10(value) - log10(start));
				}
				pixel += sign * offset;
			}
			return pixel;
		},
		getValueForPixel: function(pixel) {
			var me = this;
			var reverse = me.options.ticks.reverse;
			var log10 = helpers.log10;
			var firstTickValue = me._getFirstTickValue(me.minNotZero);
			var innerDimension, start, end, value;

			if (reverse) {
				start = me.end;
				end = me.start;
			} else {
				start = me.start;
				end = me.end;
			}
			if (me.isHorizontal()) {
				innerDimension = me.width;
				value = reverse ? me.right - pixel : pixel - me.left;
			} else {
				innerDimension = me.height;
				value = reverse ? pixel - me.top : me.bottom - pixel;
			}
			if (value !== start) {
				if (start === 0) { // include zero tick
					var offset = helpers.getValueOrDefault(
						me.options.ticks.fontSize,
						Chart.defaults.global.defaultFontSize
					);
					value -= offset;
					innerDimension -= offset;
					start = firstTickValue;
				}
				value *= log10(end) - log10(start);
				value /= innerDimension;
				value = Math.pow(10, log10(start) + value);
			}
			return value;
		}
	});
	Chart.scaleService.registerScaleType('logarithmic', LogarithmicScale, defaultConfig);

};


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(2);
var helpers = __webpack_require__(1);
var Ticks = __webpack_require__(22);

module.exports = function(Chart) {

	var globalDefaults = defaults.global;

	var defaultConfig = {
		display: true,

		// Boolean - Whether to animate scaling the chart from the centre
		animate: true,
		position: 'chartArea',

		angleLines: {
			display: true,
			color: 'rgba(0, 0, 0, 0.1)',
			lineWidth: 1
		},

		gridLines: {
			circular: false
		},

		// label settings
		ticks: {
			// Boolean - Show a backdrop to the scale label
			showLabelBackdrop: true,

			// String - The colour of the label backdrop
			backdropColor: 'rgba(255,255,255,0.75)',

			// Number - The backdrop padding above & below the label in pixels
			backdropPaddingY: 2,

			// Number - The backdrop padding to the side of the label in pixels
			backdropPaddingX: 2,

			callback: Ticks.formatters.linear
		},

		pointLabels: {
			// Boolean - if true, show point labels
			display: true,

			// Number - Point label font size in pixels
			fontSize: 10,

			// Function - Used to convert point labels
			callback: function(label) {
				return label;
			}
		}
	};

	function getValueCount(scale) {
		var opts = scale.options;
		return opts.angleLines.display || opts.pointLabels.display ? scale.chart.data.labels.length : 0;
	}

	function getPointLabelFontOptions(scale) {
		var pointLabelOptions = scale.options.pointLabels;
		var fontSize = helpers.valueOrDefault(pointLabelOptions.fontSize, globalDefaults.defaultFontSize);
		var fontStyle = helpers.valueOrDefault(pointLabelOptions.fontStyle, globalDefaults.defaultFontStyle);
		var fontFamily = helpers.valueOrDefault(pointLabelOptions.fontFamily, globalDefaults.defaultFontFamily);
		var font = helpers.fontString(fontSize, fontStyle, fontFamily);

		return {
			size: fontSize,
			style: fontStyle,
			family: fontFamily,
			font: font
		};
	}

	function measureLabelSize(ctx, fontSize, label) {
		if (helpers.isArray(label)) {
			return {
				w: helpers.longestText(ctx, ctx.font, label),
				h: (label.length * fontSize) + ((label.length - 1) * 1.5 * fontSize)
			};
		}

		return {
			w: ctx.measureText(label).width,
			h: fontSize
		};
	}

	function determineLimits(angle, pos, size, min, max) {
		if (angle === min || angle === max) {
			return {
				start: pos - (size / 2),
				end: pos + (size / 2)
			};
		} else if (angle < min || angle > max) {
			return {
				start: pos - size - 5,
				end: pos
			};
		}

		return {
			start: pos,
			end: pos + size + 5
		};
	}

	/**
	 * Helper function to fit a radial linear scale with point labels
	 */
	function fitWithPointLabels(scale) {
		/*
		 * Right, this is really confusing and there is a lot of maths going on here
		 * The gist of the problem is here: https://gist.github.com/nnnick/696cc9c55f4b0beb8fe9
		 *
		 * Reaction: https://dl.dropboxusercontent.com/u/34601363/toomuchscience.gif
		 *
		 * Solution:
		 *
		 * We assume the radius of the polygon is half the size of the canvas at first
		 * at each index we check if the text overlaps.
		 *
		 * Where it does, we store that angle and that index.
		 *
		 * After finding the largest index and angle we calculate how much we need to remove
		 * from the shape radius to move the point inwards by that x.
		 *
		 * We average the left and right distances to get the maximum shape radius that can fit in the box
		 * along with labels.
		 *
		 * Once we have that, we can find the centre point for the chart, by taking the x text protrusion
		 * on each side, removing that from the size, halving it and adding the left x protrusion width.
		 *
		 * This will mean we have a shape fitted to the canvas, as large as it can be with the labels
		 * and position it in the most space efficient manner
		 *
		 * https://dl.dropboxusercontent.com/u/34601363/yeahscience.gif
		 */

		var plFont = getPointLabelFontOptions(scale);

		// Get maximum radius of the polygon. Either half the height (minus the text width) or half the width.
		// Use this to calculate the offset + change. - Make sure L/R protrusion is at least 0 to stop issues with centre points
		var largestPossibleRadius = Math.min(scale.height / 2, scale.width / 2);
		var furthestLimits = {
			r: scale.width,
			l: 0,
			t: scale.height,
			b: 0
		};
		var furthestAngles = {};
		var i, textSize, pointPosition;

		scale.ctx.font = plFont.font;
		scale._pointLabelSizes = [];

		var valueCount = getValueCount(scale);
		for (i = 0; i < valueCount; i++) {
			pointPosition = scale.getPointPosition(i, largestPossibleRadius);
			textSize = measureLabelSize(scale.ctx, plFont.size, scale.pointLabels[i] || '');
			scale._pointLabelSizes[i] = textSize;

			// Add quarter circle to make degree 0 mean top of circle
			var angleRadians = scale.getIndexAngle(i);
			var angle = helpers.toDegrees(angleRadians) % 360;
			var hLimits = determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
			var vLimits = determineLimits(angle, pointPosition.y, textSize.h, 90, 270);

			if (hLimits.start < furthestLimits.l) {
				furthestLimits.l = hLimits.start;
				furthestAngles.l = angleRadians;
			}

			if (hLimits.end > furthestLimits.r) {
				furthestLimits.r = hLimits.end;
				furthestAngles.r = angleRadians;
			}

			if (vLimits.start < furthestLimits.t) {
				furthestLimits.t = vLimits.start;
				furthestAngles.t = angleRadians;
			}

			if (vLimits.end > furthestLimits.b) {
				furthestLimits.b = vLimits.end;
				furthestAngles.b = angleRadians;
			}
		}

		scale.setReductions(largestPossibleRadius, furthestLimits, furthestAngles);
	}

	/**
	 * Helper function to fit a radial linear scale with no point labels
	 */
	function fit(scale) {
		var largestPossibleRadius = Math.min(scale.height / 2, scale.width / 2);
		scale.drawingArea = Math.round(largestPossibleRadius);
		scale.setCenterPoint(0, 0, 0, 0);
	}

	function getTextAlignForAngle(angle) {
		if (angle === 0 || angle === 180) {
			return 'center';
		} else if (angle < 180) {
			return 'left';
		}

		return 'right';
	}

	function fillText(ctx, text, position, fontSize) {
		if (helpers.isArray(text)) {
			var y = position.y;
			var spacing = 1.5 * fontSize;

			for (var i = 0; i < text.length; ++i) {
				ctx.fillText(text[i], position.x, y);
				y += spacing;
			}
		} else {
			ctx.fillText(text, position.x, position.y);
		}
	}

	function adjustPointPositionForLabelHeight(angle, textSize, position) {
		if (angle === 90 || angle === 270) {
			position.y -= (textSize.h / 2);
		} else if (angle > 270 || angle < 90) {
			position.y -= textSize.h;
		}
	}

	function drawPointLabels(scale) {
		var ctx = scale.ctx;
		var opts = scale.options;
		var angleLineOpts = opts.angleLines;
		var pointLabelOpts = opts.pointLabels;

		ctx.lineWidth = angleLineOpts.lineWidth;
		ctx.strokeStyle = angleLineOpts.color;

		var outerDistance = scale.getDistanceFromCenterForValue(opts.ticks.reverse ? scale.min : scale.max);

		// Point Label Font
		var plFont = getPointLabelFontOptions(scale);

		ctx.textBaseline = 'top';

		for (var i = getValueCount(scale) - 1; i >= 0; i--) {
			if (angleLineOpts.display) {
				var outerPosition = scale.getPointPosition(i, outerDistance);
				ctx.beginPath();
				ctx.moveTo(scale.xCenter, scale.yCenter);
				ctx.lineTo(outerPosition.x, outerPosition.y);
				ctx.stroke();
				ctx.closePath();
			}

			if (pointLabelOpts.display) {
				// Extra 3px out for some label spacing
				var pointLabelPosition = scale.getPointPosition(i, outerDistance + 5);

				// Keep this in loop since we may support array properties here
				var pointLabelFontColor = helpers.valueAtIndexOrDefault(pointLabelOpts.fontColor, i, globalDefaults.defaultFontColor);
				ctx.font = plFont.font;
				ctx.fillStyle = pointLabelFontColor;

				var angleRadians = scale.getIndexAngle(i);
				var angle = helpers.toDegrees(angleRadians);
				ctx.textAlign = getTextAlignForAngle(angle);
				adjustPointPositionForLabelHeight(angle, scale._pointLabelSizes[i], pointLabelPosition);
				fillText(ctx, scale.pointLabels[i] || '', pointLabelPosition, plFont.size);
			}
		}
	}

	function drawRadiusLine(scale, gridLineOpts, radius, index) {
		var ctx = scale.ctx;
		ctx.strokeStyle = helpers.valueAtIndexOrDefault(gridLineOpts.color, index - 1);
		ctx.lineWidth = helpers.valueAtIndexOrDefault(gridLineOpts.lineWidth, index - 1);

		if (scale.options.gridLines.circular) {
			// Draw circular arcs between the points
			ctx.beginPath();
			ctx.arc(scale.xCenter, scale.yCenter, radius, 0, Math.PI * 2);
			ctx.closePath();
			ctx.stroke();
		} else {
			// Draw straight lines connecting each index
			var valueCount = getValueCount(scale);

			if (valueCount === 0) {
				return;
			}

			ctx.beginPath();
			var pointPosition = scale.getPointPosition(0, radius);
			ctx.moveTo(pointPosition.x, pointPosition.y);

			for (var i = 1; i < valueCount; i++) {
				pointPosition = scale.getPointPosition(i, radius);
				ctx.lineTo(pointPosition.x, pointPosition.y);
			}

			ctx.closePath();
			ctx.stroke();
		}
	}

	function numberOrZero(param) {
		return helpers.isNumber(param) ? param : 0;
	}

	var LinearRadialScale = Chart.LinearScaleBase.extend({
		setDimensions: function() {
			var me = this;
			var opts = me.options;
			var tickOpts = opts.ticks;
			// Set the unconstrained dimension before label rotation
			me.width = me.maxWidth;
			me.height = me.maxHeight;
			me.xCenter = Math.round(me.width / 2);
			me.yCenter = Math.round(me.height / 2);

			var minSize = helpers.min([me.height, me.width]);
			var tickFontSize = helpers.valueOrDefault(tickOpts.fontSize, globalDefaults.defaultFontSize);
			me.drawingArea = opts.display ? (minSize / 2) - (tickFontSize / 2 + tickOpts.backdropPaddingY) : (minSize / 2);
		},
		determineDataLimits: function() {
			var me = this;
			var chart = me.chart;
			var min = Number.POSITIVE_INFINITY;
			var max = Number.NEGATIVE_INFINITY;

			helpers.each(chart.data.datasets, function(dataset, datasetIndex) {
				if (chart.isDatasetVisible(datasetIndex)) {
					var meta = chart.getDatasetMeta(datasetIndex);

					helpers.each(dataset.data, function(rawValue, index) {
						var value = +me.getRightValue(rawValue);
						if (isNaN(value) || meta.data[index].hidden) {
							return;
						}

						min = Math.min(value, min);
						max = Math.max(value, max);
					});
				}
			});

			me.min = (min === Number.POSITIVE_INFINITY ? 0 : min);
			me.max = (max === Number.NEGATIVE_INFINITY ? 0 : max);

			// Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
			me.handleTickRangeOptions();
		},
		getTickLimit: function() {
			var tickOpts = this.options.ticks;
			var tickFontSize = helpers.valueOrDefault(tickOpts.fontSize, globalDefaults.defaultFontSize);
			return Math.min(tickOpts.maxTicksLimit ? tickOpts.maxTicksLimit : 11, Math.ceil(this.drawingArea / (1.5 * tickFontSize)));
		},
		convertTicksToLabels: function() {
			var me = this;

			Chart.LinearScaleBase.prototype.convertTicksToLabels.call(me);

			// Point labels
			me.pointLabels = me.chart.data.labels.map(me.options.pointLabels.callback, me);
		},
		getLabelForIndex: function(index, datasetIndex) {
			return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
		},
		fit: function() {
			if (this.options.pointLabels.display) {
				fitWithPointLabels(this);
			} else {
				fit(this);
			}
		},
		/**
		 * Set radius reductions and determine new radius and center point
		 * @private
		 */
		setReductions: function(largestPossibleRadius, furthestLimits, furthestAngles) {
			var me = this;
			var radiusReductionLeft = furthestLimits.l / Math.sin(furthestAngles.l);
			var radiusReductionRight = Math.max(furthestLimits.r - me.width, 0) / Math.sin(furthestAngles.r);
			var radiusReductionTop = -furthestLimits.t / Math.cos(furthestAngles.t);
			var radiusReductionBottom = -Math.max(furthestLimits.b - me.height, 0) / Math.cos(furthestAngles.b);

			radiusReductionLeft = numberOrZero(radiusReductionLeft);
			radiusReductionRight = numberOrZero(radiusReductionRight);
			radiusReductionTop = numberOrZero(radiusReductionTop);
			radiusReductionBottom = numberOrZero(radiusReductionBottom);

			me.drawingArea = Math.min(
				Math.round(largestPossibleRadius - (radiusReductionLeft + radiusReductionRight) / 2),
				Math.round(largestPossibleRadius - (radiusReductionTop + radiusReductionBottom) / 2));
			me.setCenterPoint(radiusReductionLeft, radiusReductionRight, radiusReductionTop, radiusReductionBottom);
		},
		setCenterPoint: function(leftMovement, rightMovement, topMovement, bottomMovement) {
			var me = this;
			var maxRight = me.width - rightMovement - me.drawingArea;
			var maxLeft = leftMovement + me.drawingArea;
			var maxTop = topMovement + me.drawingArea;
			var maxBottom = me.height - bottomMovement - me.drawingArea;

			me.xCenter = Math.round(((maxLeft + maxRight) / 2) + me.left);
			me.yCenter = Math.round(((maxTop + maxBottom) / 2) + me.top);
		},

		getIndexAngle: function(index) {
			var angleMultiplier = (Math.PI * 2) / getValueCount(this);
			var startAngle = this.chart.options && this.chart.options.startAngle ?
				this.chart.options.startAngle :
				0;

			var startAngleRadians = startAngle * Math.PI * 2 / 360;

			// Start from the top instead of right, so remove a quarter of the circle
			return index * angleMultiplier + startAngleRadians;
		},
		getDistanceFromCenterForValue: function(value) {
			var me = this;

			if (value === null) {
				return 0; // null always in center
			}

			// Take into account half font size + the yPadding of the top value
			var scalingFactor = me.drawingArea / (me.max - me.min);
			if (me.options.ticks.reverse) {
				return (me.max - value) * scalingFactor;
			}
			return (value - me.min) * scalingFactor;
		},
		getPointPosition: function(index, distanceFromCenter) {
			var me = this;
			var thisAngle = me.getIndexAngle(index) - (Math.PI / 2);
			return {
				x: Math.round(Math.cos(thisAngle) * distanceFromCenter) + me.xCenter,
				y: Math.round(Math.sin(thisAngle) * distanceFromCenter) + me.yCenter
			};
		},
		getPointPositionForValue: function(index, value) {
			return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
		},

		getBasePosition: function() {
			var me = this;
			var min = me.min;
			var max = me.max;

			return me.getPointPositionForValue(0,
				me.beginAtZero ? 0 :
				min < 0 && max < 0 ? max :
				min > 0 && max > 0 ? min :
				0);
		},

		draw: function() {
			var me = this;
			var opts = me.options;
			var gridLineOpts = opts.gridLines;
			var tickOpts = opts.ticks;
			var valueOrDefault = helpers.valueOrDefault;

			if (opts.display) {
				var ctx = me.ctx;
				var startAngle = this.getIndexAngle(0);

				// Tick Font
				var tickFontSize = valueOrDefault(tickOpts.fontSize, globalDefaults.defaultFontSize);
				var tickFontStyle = valueOrDefault(tickOpts.fontStyle, globalDefaults.defaultFontStyle);
				var tickFontFamily = valueOrDefault(tickOpts.fontFamily, globalDefaults.defaultFontFamily);
				var tickLabelFont = helpers.fontString(tickFontSize, tickFontStyle, tickFontFamily);

				helpers.each(me.ticks, function(label, index) {
					// Don't draw a centre value (if it is minimum)
					if (index > 0 || tickOpts.reverse) {
						var yCenterOffset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);

						// Draw circular lines around the scale
						if (gridLineOpts.display && index !== 0) {
							drawRadiusLine(me, gridLineOpts, yCenterOffset, index);
						}

						if (tickOpts.display) {
							var tickFontColor = valueOrDefault(tickOpts.fontColor, globalDefaults.defaultFontColor);
							ctx.font = tickLabelFont;

							ctx.save();
							ctx.translate(me.xCenter, me.yCenter);
							ctx.rotate(startAngle);

							if (tickOpts.showLabelBackdrop) {
								var labelWidth = ctx.measureText(label).width;
								ctx.fillStyle = tickOpts.backdropColor;
								ctx.fillRect(
									-labelWidth / 2 - tickOpts.backdropPaddingX,
									-yCenterOffset - tickFontSize / 2 - tickOpts.backdropPaddingY,
									labelWidth + tickOpts.backdropPaddingX * 2,
									tickFontSize + tickOpts.backdropPaddingY * 2
								);
							}

							ctx.textAlign = 'center';
							ctx.textBaseline = 'middle';
							ctx.fillStyle = tickFontColor;
							ctx.fillText(label, 0, -yCenterOffset);
							ctx.restore();
						}
					}
				});

				if (opts.angleLines.display || opts.pointLabels.display) {
					drawPointLabels(me);
				}
			}
		}
	});
	Chart.scaleService.registerScaleType('radialLinear', LinearRadialScale, defaultConfig);

};


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* global window: false */


var moment = __webpack_require__(218);
moment = typeof moment === 'function' ? moment : window.moment;

var defaults = __webpack_require__(2);
var helpers = __webpack_require__(1);

// Integer constants are from the ES6 spec.
var MIN_INTEGER = Number.MIN_SAFE_INTEGER || -9007199254740991;
var MAX_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;

var INTERVALS = {
	millisecond: {
		common: true,
		size: 1,
		steps: [1, 2, 5, 10, 20, 50, 100, 250, 500]
	},
	second: {
		common: true,
		size: 1000,
		steps: [1, 2, 5, 10, 30]
	},
	minute: {
		common: true,
		size: 60000,
		steps: [1, 2, 5, 10, 30]
	},
	hour: {
		common: true,
		size: 3600000,
		steps: [1, 2, 3, 6, 12]
	},
	day: {
		common: true,
		size: 86400000,
		steps: [1, 2, 5]
	},
	week: {
		common: false,
		size: 604800000,
		steps: [1, 2, 3, 4]
	},
	month: {
		common: true,
		size: 2.628e9,
		steps: [1, 2, 3]
	},
	quarter: {
		common: false,
		size: 7.884e9,
		steps: [1, 2, 3, 4]
	},
	year: {
		common: true,
		size: 3.154e10
	}
};

var UNITS = Object.keys(INTERVALS);

function sorter(a, b) {
	return a - b;
}

function arrayUnique(items) {
	var hash = {};
	var out = [];
	var i, ilen, item;

	for (i = 0, ilen = items.length; i < ilen; ++i) {
		item = items[i];
		if (!hash[item]) {
			hash[item] = true;
			out.push(item);
		}
	}

	return out;
}

/**
 * Returns an array of {time, pos} objects used to interpolate a specific `time` or position
 * (`pos`) on the scale, by searching entries before and after the requested value. `pos` is
 * a decimal between 0 and 1: 0 being the start of the scale (left or top) and 1 the other
 * extremity (left + width or top + height). Note that it would be more optimized to directly
 * store pre-computed pixels, but the scale dimensions are not guaranteed at the time we need
 * to create the lookup table. The table ALWAYS contains at least two items: min and max.
 *
 * @param {Number[]} timestamps - timestamps sorted from lowest to highest.
 * @param {String} distribution - If 'linear', timestamps will be spread linearly along the min
 * and max range, so basically, the table will contains only two items: {min, 0} and {max, 1}.
 * If 'series', timestamps will be positioned at the same distance from each other. In this
 * case, only timestamps that break the time linearity are registered, meaning that in the
 * best case, all timestamps are linear, the table contains only min and max.
 */
function buildLookupTable(timestamps, min, max, distribution) {
	if (distribution === 'linear' || !timestamps.length) {
		return [
			{time: min, pos: 0},
			{time: max, pos: 1}
		];
	}

	var table = [];
	var items = [min];
	var i, ilen, prev, curr, next;

	for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
		curr = timestamps[i];
		if (curr > min && curr < max) {
			items.push(curr);
		}
	}

	items.push(max);

	for (i = 0, ilen = items.length; i < ilen; ++i) {
		next = items[i + 1];
		prev = items[i - 1];
		curr = items[i];

		// only add points that breaks the scale linearity
		if (prev === undefined || next === undefined || Math.round((next + prev) / 2) !== curr) {
			table.push({time: curr, pos: i / (ilen - 1)});
		}
	}

	return table;
}

// @see adapted from http://www.anujgakhar.com/2014/03/01/binary-search-in-javascript/
function lookup(table, key, value) {
	var lo = 0;
	var hi = table.length - 1;
	var mid, i0, i1;

	while (lo >= 0 && lo <= hi) {
		mid = (lo + hi) >> 1;
		i0 = table[mid - 1] || null;
		i1 = table[mid];

		if (!i0) {
			// given value is outside table (before first item)
			return {lo: null, hi: i1};
		} else if (i1[key] < value) {
			lo = mid + 1;
		} else if (i0[key] > value) {
			hi = mid - 1;
		} else {
			return {lo: i0, hi: i1};
		}
	}

	// given value is outside table (after last item)
	return {lo: i1, hi: null};
}

/**
 * Linearly interpolates the given source `value` using the table items `skey` values and
 * returns the associated `tkey` value. For example, interpolate(table, 'time', 42, 'pos')
 * returns the position for a timestamp equal to 42. If value is out of bounds, values at
 * index [0, 1] or [n - 1, n] are used for the interpolation.
 */
function interpolate(table, skey, sval, tkey) {
	var range = lookup(table, skey, sval);

	// Note: the lookup table ALWAYS contains at least 2 items (min and max)
	var prev = !range.lo ? table[0] : !range.hi ? table[table.length - 2] : range.lo;
	var next = !range.lo ? table[1] : !range.hi ? table[table.length - 1] : range.hi;

	var span = next[skey] - prev[skey];
	var ratio = span ? (sval - prev[skey]) / span : 0;
	var offset = (next[tkey] - prev[tkey]) * ratio;

	return prev[tkey] + offset;
}

/**
 * Convert the given value to a moment object using the given time options.
 * @see http://momentjs.com/docs/#/parsing/
 */
function momentify(value, options) {
	var parser = options.parser;
	var format = options.parser || options.format;

	if (typeof parser === 'function') {
		return parser(value);
	}

	if (typeof value === 'string' && typeof format === 'string') {
		return moment(value, format);
	}

	if (!(value instanceof moment)) {
		value = moment(value);
	}

	if (value.isValid()) {
		return value;
	}

	// Labels are in an incompatible moment format and no `parser` has been provided.
	// The user might still use the deprecated `format` option to convert his inputs.
	if (typeof format === 'function') {
		return format(value);
	}

	return value;
}

function parse(input, scale) {
	if (helpers.isNullOrUndef(input)) {
		return null;
	}

	var options = scale.options.time;
	var value = momentify(scale.getRightValue(input), options);
	if (!value.isValid()) {
		return null;
	}

	if (options.round) {
		value.startOf(options.round);
	}

	return value.valueOf();
}

/**
 * Returns the number of unit to skip to be able to display up to `capacity` number of ticks
 * in `unit` for the given `min` / `max` range and respecting the interval steps constraints.
 */
function determineStepSize(min, max, unit, capacity) {
	var range = max - min;
	var interval = INTERVALS[unit];
	var milliseconds = interval.size;
	var steps = interval.steps;
	var i, ilen, factor;

	if (!steps) {
		return Math.ceil(range / (capacity * milliseconds));
	}

	for (i = 0, ilen = steps.length; i < ilen; ++i) {
		factor = steps[i];
		if (Math.ceil(range / (milliseconds * factor)) <= capacity) {
			break;
		}
	}

	return factor;
}

/**
 * Figures out what unit results in an appropriate number of auto-generated ticks
 */
function determineUnitForAutoTicks(minUnit, min, max, capacity) {
	var ilen = UNITS.length;
	var i, interval, factor;

	for (i = UNITS.indexOf(minUnit); i < ilen - 1; ++i) {
		interval = INTERVALS[UNITS[i]];
		factor = interval.steps ? interval.steps[interval.steps.length - 1] : MAX_INTEGER;

		if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) {
			return UNITS[i];
		}
	}

	return UNITS[ilen - 1];
}

/**
 * Figures out what unit to format a set of ticks with
 */
function determineUnitForFormatting(ticks, minUnit, min, max) {
	var duration = moment.duration(moment(max).diff(moment(min)));
	var ilen = UNITS.length;
	var i, unit;

	for (i = ilen - 1; i >= UNITS.indexOf(minUnit); i--) {
		unit = UNITS[i];
		if (INTERVALS[unit].common && duration.as(unit) >= ticks.length) {
			return unit;
		}
	}

	return UNITS[minUnit ? UNITS.indexOf(minUnit) : 0];
}

function determineMajorUnit(unit) {
	for (var i = UNITS.indexOf(unit) + 1, ilen = UNITS.length; i < ilen; ++i) {
		if (INTERVALS[UNITS[i]].common) {
			return UNITS[i];
		}
	}
}

/**
 * Generates a maximum of `capacity` timestamps between min and max, rounded to the
 * `minor` unit, aligned on the `major` unit and using the given scale time `options`.
 * Important: this method can return ticks outside the min and max range, it's the
 * responsibility of the calling code to clamp values if needed.
 */
function generate(min, max, capacity, options) {
	var timeOpts = options.time;
	var minor = timeOpts.unit || determineUnitForAutoTicks(timeOpts.minUnit, min, max, capacity);
	var major = determineMajorUnit(minor);
	var stepSize = helpers.valueOrDefault(timeOpts.stepSize, timeOpts.unitStepSize);
	var weekday = minor === 'week' ? timeOpts.isoWeekday : false;
	var majorTicksEnabled = options.ticks.major.enabled;
	var interval = INTERVALS[minor];
	var first = moment(min);
	var last = moment(max);
	var ticks = [];
	var time;

	if (!stepSize) {
		stepSize = determineStepSize(min, max, minor, capacity);
	}

	// For 'week' unit, handle the first day of week option
	if (weekday) {
		first = first.isoWeekday(weekday);
		last = last.isoWeekday(weekday);
	}

	// Align first/last ticks on unit
	first = first.startOf(weekday ? 'day' : minor);
	last = last.startOf(weekday ? 'day' : minor);

	// Make sure that the last tick include max
	if (last < max) {
		last.add(1, minor);
	}

	time = moment(first);

	if (majorTicksEnabled && major && !weekday && !timeOpts.round) {
		// Align the first tick on the previous `minor` unit aligned on the `major` unit:
		// we first aligned time on the previous `major` unit then add the number of full
		// stepSize there is between first and the previous major time.
		time.startOf(major);
		time.add(~~((first - time) / (interval.size * stepSize)) * stepSize, minor);
	}

	for (; time < last; time.add(stepSize, minor)) {
		ticks.push(+time);
	}

	ticks.push(+time);

	return ticks;
}

/**
 * Returns the right and left offsets from edges in the form of {left, right}.
 * Offsets are added when the `offset` option is true.
 */
function computeOffsets(table, ticks, min, max, options) {
	var left = 0;
	var right = 0;
	var upper, lower;

	if (options.offset && ticks.length) {
		if (!options.time.min) {
			upper = ticks.length > 1 ? ticks[1] : max;
			lower = ticks[0];
			left = (
				interpolate(table, 'time', upper, 'pos') -
				interpolate(table, 'time', lower, 'pos')
			) / 2;
		}
		if (!options.time.max) {
			upper = ticks[ticks.length - 1];
			lower = ticks.length > 1 ? ticks[ticks.length - 2] : min;
			right = (
				interpolate(table, 'time', upper, 'pos') -
				interpolate(table, 'time', lower, 'pos')
			) / 2;
		}
	}

	return {left: left, right: right};
}

function ticksFromTimestamps(values, majorUnit) {
	var ticks = [];
	var i, ilen, value, major;

	for (i = 0, ilen = values.length; i < ilen; ++i) {
		value = values[i];
		major = majorUnit ? value === +moment(value).startOf(majorUnit) : false;

		ticks.push({
			value: value,
			major: major
		});
	}

	return ticks;
}

function determineLabelFormat(data, timeOpts) {
	var i, momentDate, hasTime;
	var ilen = data.length;

	// find the label with the most parts (milliseconds, minutes, etc.)
	// format all labels with the same level of detail as the most specific label
	for (i = 0; i < ilen; i++) {
		momentDate = momentify(data[i], timeOpts);
		if (momentDate.millisecond() !== 0) {
			return 'MMM D, YYYY h:mm:ss.SSS a';
		}
		if (momentDate.second() !== 0 || momentDate.minute() !== 0 || momentDate.hour() !== 0) {
			hasTime = true;
		}
	}
	if (hasTime) {
		return 'MMM D, YYYY h:mm:ss a';
	}
	return 'MMM D, YYYY';
}

module.exports = function(Chart) {

	var defaultConfig = {
		position: 'bottom',

		/**
		 * Data distribution along the scale:
		 * - 'linear': data are spread according to their time (distances can vary),
		 * - 'series': data are spread at the same distance from each other.
		 * @see https://github.com/chartjs/Chart.js/pull/4507
		 * @since 2.7.0
		 */
		distribution: 'linear',

		/**
		 * Scale boundary strategy (bypassed by min/max time options)
		 * - `data`: make sure data are fully visible, ticks outside are removed
		 * - `ticks`: make sure ticks are fully visible, data outside are truncated
		 * @see https://github.com/chartjs/Chart.js/pull/4556
		 * @since 2.7.0
		 */
		bounds: 'data',

		time: {
			parser: false, // false == a pattern string from http://momentjs.com/docs/#/parsing/string-format/ or a custom callback that converts its argument to a moment
			format: false, // DEPRECATED false == date objects, moment object, callback or a pattern string from http://momentjs.com/docs/#/parsing/string-format/
			unit: false, // false == automatic or override with week, month, year, etc.
			round: false, // none, or override with week, month, year, etc.
			displayFormat: false, // DEPRECATED
			isoWeekday: false, // override week start day - see http://momentjs.com/docs/#/get-set/iso-weekday/
			minUnit: 'millisecond',

			// defaults to unit's corresponding unitFormat below or override using pattern string from http://momentjs.com/docs/#/displaying/format/
			displayFormats: {
				millisecond: 'h:mm:ss.SSS a', // 11:20:01.123 AM,
				second: 'h:mm:ss a', // 11:20:01 AM
				minute: 'h:mm a', // 11:20 AM
				hour: 'hA', // 5PM
				day: 'MMM D', // Sep 4
				week: 'll', // Week 46, or maybe "[W]WW - YYYY" ?
				month: 'MMM YYYY', // Sept 2015
				quarter: '[Q]Q - YYYY', // Q3
				year: 'YYYY' // 2015
			},
		},
		ticks: {
			autoSkip: false,

			/**
			 * Ticks generation input values:
			 * - 'auto': generates "optimal" ticks based on scale size and time options.
			 * - 'data': generates ticks from data (including labels from data {t|x|y} objects).
			 * - 'labels': generates ticks from user given `data.labels` values ONLY.
			 * @see https://github.com/chartjs/Chart.js/pull/4507
			 * @since 2.7.0
			 */
			source: 'auto',

			major: {
				enabled: false
			}
		}
	};

	var TimeScale = Chart.Scale.extend({
		initialize: function() {
			if (!moment) {
				throw new Error('Chart.js - Moment.js could not be found! You must include it before Chart.js to use the time scale. Download at https://momentjs.com');
			}

			this.mergeTicksOptions();

			Chart.Scale.prototype.initialize.call(this);
		},

		update: function() {
			var me = this;
			var options = me.options;

			// DEPRECATIONS: output a message only one time per update
			if (options.time && options.time.format) {
				console.warn('options.time.format is deprecated and replaced by options.time.parser.');
			}

			return Chart.Scale.prototype.update.apply(me, arguments);
		},

		/**
		 * Allows data to be referenced via 't' attribute
		 */
		getRightValue: function(rawValue) {
			if (rawValue && rawValue.t !== undefined) {
				rawValue = rawValue.t;
			}
			return Chart.Scale.prototype.getRightValue.call(this, rawValue);
		},

		determineDataLimits: function() {
			var me = this;
			var chart = me.chart;
			var timeOpts = me.options.time;
			var unit = timeOpts.unit || 'day';
			var min = MAX_INTEGER;
			var max = MIN_INTEGER;
			var timestamps = [];
			var datasets = [];
			var labels = [];
			var i, j, ilen, jlen, data, timestamp;

			// Convert labels to timestamps
			for (i = 0, ilen = chart.data.labels.length; i < ilen; ++i) {
				labels.push(parse(chart.data.labels[i], me));
			}

			// Convert data to timestamps
			for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
				if (chart.isDatasetVisible(i)) {
					data = chart.data.datasets[i].data;

					// Let's consider that all data have the same format.
					if (helpers.isObject(data[0])) {
						datasets[i] = [];

						for (j = 0, jlen = data.length; j < jlen; ++j) {
							timestamp = parse(data[j], me);
							timestamps.push(timestamp);
							datasets[i][j] = timestamp;
						}
					} else {
						timestamps.push.apply(timestamps, labels);
						datasets[i] = labels.slice(0);
					}
				} else {
					datasets[i] = [];
				}
			}

			if (labels.length) {
				// Sort labels **after** data have been converted
				labels = arrayUnique(labels).sort(sorter);
				min = Math.min(min, labels[0]);
				max = Math.max(max, labels[labels.length - 1]);
			}

			if (timestamps.length) {
				timestamps = arrayUnique(timestamps).sort(sorter);
				min = Math.min(min, timestamps[0]);
				max = Math.max(max, timestamps[timestamps.length - 1]);
			}

			min = parse(timeOpts.min, me) || min;
			max = parse(timeOpts.max, me) || max;

			// In case there is no valid min/max, set limits based on unit time option
			min = min === MAX_INTEGER ? +moment().startOf(unit) : min;
			max = max === MIN_INTEGER ? +moment().endOf(unit) + 1 : max;

			// Make sure that max is strictly higher than min (required by the lookup table)
			me.min = Math.min(min, max);
			me.max = Math.max(min + 1, max);

			// PRIVATE
			me._horizontal = me.isHorizontal();
			me._table = [];
			me._timestamps = {
				data: timestamps,
				datasets: datasets,
				labels: labels
			};
		},

		buildTicks: function() {
			var me = this;
			var min = me.min;
			var max = me.max;
			var options = me.options;
			var timeOpts = options.time;
			var timestamps = [];
			var ticks = [];
			var i, ilen, timestamp;

			switch (options.ticks.source) {
			case 'data':
				timestamps = me._timestamps.data;
				break;
			case 'labels':
				timestamps = me._timestamps.labels;
				break;
			case 'auto':
			default:
				timestamps = generate(min, max, me.getLabelCapacity(min), options);
			}

			if (options.bounds === 'ticks' && timestamps.length) {
				min = timestamps[0];
				max = timestamps[timestamps.length - 1];
			}

			// Enforce limits with user min/max options
			min = parse(timeOpts.min, me) || min;
			max = parse(timeOpts.max, me) || max;

			// Remove ticks outside the min/max range
			for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
				timestamp = timestamps[i];
				if (timestamp >= min && timestamp <= max) {
					ticks.push(timestamp);
				}
			}

			me.min = min;
			me.max = max;

			// PRIVATE
			me._unit = timeOpts.unit || determineUnitForFormatting(ticks, timeOpts.minUnit, me.min, me.max);
			me._majorUnit = determineMajorUnit(me._unit);
			me._table = buildLookupTable(me._timestamps.data, min, max, options.distribution);
			me._offsets = computeOffsets(me._table, ticks, min, max, options);
			me._labelFormat = determineLabelFormat(me._timestamps.data, timeOpts);

			return ticksFromTimestamps(ticks, me._majorUnit);
		},

		getLabelForIndex: function(index, datasetIndex) {
			var me = this;
			var data = me.chart.data;
			var timeOpts = me.options.time;
			var label = data.labels && index < data.labels.length ? data.labels[index] : '';
			var value = data.datasets[datasetIndex].data[index];

			if (helpers.isObject(value)) {
				label = me.getRightValue(value);
			}
			if (timeOpts.tooltipFormat) {
				return momentify(label, timeOpts).format(timeOpts.tooltipFormat);
			}
			if (typeof label === 'string') {
				return label;
			}

			return momentify(label, timeOpts).format(me._labelFormat);
		},

		/**
		 * Function to format an individual tick mark
		 * @private
		 */
		tickFormatFunction: function(tick, index, ticks, formatOverride) {
			var me = this;
			var options = me.options;
			var time = tick.valueOf();
			var formats = options.time.displayFormats;
			var minorFormat = formats[me._unit];
			var majorUnit = me._majorUnit;
			var majorFormat = formats[majorUnit];
			var majorTime = tick.clone().startOf(majorUnit).valueOf();
			var majorTickOpts = options.ticks.major;
			var major = majorTickOpts.enabled && majorUnit && majorFormat && time === majorTime;
			var label = tick.format(formatOverride ? formatOverride : major ? majorFormat : minorFormat);
			var tickOpts = major ? majorTickOpts : options.ticks.minor;
			var formatter = helpers.valueOrDefault(tickOpts.callback, tickOpts.userCallback);

			return formatter ? formatter(label, index, ticks) : label;
		},

		convertTicksToLabels: function(ticks) {
			var labels = [];
			var i, ilen;

			for (i = 0, ilen = ticks.length; i < ilen; ++i) {
				labels.push(this.tickFormatFunction(moment(ticks[i].value), i, ticks));
			}

			return labels;
		},

		/**
		 * @private
		 */
		getPixelForOffset: function(time) {
			var me = this;
			var size = me._horizontal ? me.width : me.height;
			var start = me._horizontal ? me.left : me.top;
			var pos = interpolate(me._table, 'time', time, 'pos');

			return start + size * (me._offsets.left + pos) / (me._offsets.left + 1 + me._offsets.right);
		},

		getPixelForValue: function(value, index, datasetIndex) {
			var me = this;
			var time = null;

			if (index !== undefined && datasetIndex !== undefined) {
				time = me._timestamps.datasets[datasetIndex][index];
			}

			if (time === null) {
				time = parse(value, me);
			}

			if (time !== null) {
				return me.getPixelForOffset(time);
			}
		},

		getPixelForTick: function(index) {
			var ticks = this.getTicks();
			return index >= 0 && index < ticks.length ?
				this.getPixelForOffset(ticks[index].value) :
				null;
		},

		getValueForPixel: function(pixel) {
			var me = this;
			var size = me._horizontal ? me.width : me.height;
			var start = me._horizontal ? me.left : me.top;
			var pos = (size ? (pixel - start) / size : 0) * (me._offsets.left + 1 + me._offsets.left) - me._offsets.right;
			var time = interpolate(me._table, 'pos', pos, 'time');

			return moment(time);
		},

		/**
		 * Crude approximation of what the label width might be
		 * @private
		 */
		getLabelWidth: function(label) {
			var me = this;
			var ticksOpts = me.options.ticks;
			var tickLabelWidth = me.ctx.measureText(label).width;
			var angle = helpers.toRadians(ticksOpts.maxRotation);
			var cosRotation = Math.cos(angle);
			var sinRotation = Math.sin(angle);
			var tickFontSize = helpers.valueOrDefault(ticksOpts.fontSize, defaults.global.defaultFontSize);

			return (tickLabelWidth * cosRotation) + (tickFontSize * sinRotation);
		},

		/**
		 * @private
		 */
		getLabelCapacity: function(exampleTime) {
			var me = this;

			var formatOverride = me.options.time.displayFormats.millisecond;	// Pick the longest format for guestimation

			var exampleLabel = me.tickFormatFunction(moment(exampleTime), 0, [], formatOverride);
			var tickLabelWidth = me.getLabelWidth(exampleLabel);
			var innerWidth = me.isHorizontal() ? me.width : me.height;

			var capacity = Math.floor(innerWidth / tickLabelWidth);
			return capacity > 0 ? capacity : 1;
		}
	});

	Chart.scaleService.registerScaleType('time', TimeScale, defaultConfig);
};


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks () {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback (callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return (Object.getOwnPropertyNames(obj).length === 0);
        } else {
            var k;
            for (k in obj) {
                if (obj.hasOwnProperty(k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }

    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }

    function map(arr, fn) {
        var res = [], i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty           : false,
            unusedTokens    : [],
            unusedInput     : [],
            overflow        : -2,
            charsLeftOver   : 0,
            nullInput       : false,
            invalidMonth    : null,
            invalidFormat   : false,
            userInvalidated : false,
            iso             : false,
            parsedDateParts : [],
            meridiem        : null,
            rfc2822         : false,
            weekdayMismatch : false
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this);
            var len = t.length >>> 0;

            for (var i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m);
            var parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            var isNowValid = !isNaN(m._d.getTime()) &&
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.weekdayMismatch &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid = isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            }
            else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid (flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        }
        else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [];

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    var updateInProgress = false;

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment (obj) {
        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
    }

    function absFloor (number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if ((dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false &&
                (typeof console !==  'undefined') && console.warn) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [];
                var arg;
                for (var i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (var key in arguments[0]) {
                            arg += key + ': ' + arguments[0][key] + ', ';
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }

    function set (config) {
        var prop, i;
        for (i in config) {
            prop = config[i];
            if (isFunction(prop)) {
                this[i] = prop;
            } else {
                this['_' + i] = prop;
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' + (/\d{1,2}/).source);
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (hasOwnProp(parentConfig, prop) &&
                    !hasOwnProp(childConfig, prop) &&
                    isObject(parentConfig[prop])) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i, res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    };

    function calendar (key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    var defaultLongDateFormat = {
        LTS  : 'h:mm:ss A',
        LT   : 'h:mm A',
        L    : 'MM/DD/YYYY',
        LL   : 'MMMM D, YYYY',
        LLL  : 'MMMM D, YYYY h:mm A',
        LLLL : 'dddd, MMMM D, YYYY h:mm A'
    };

    function longDateFormat (key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
            return val.slice(1);
        });

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate () {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d';
    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal (number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future : 'in %s',
        past   : '%s ago',
        s  : 'a few seconds',
        ss : '%d seconds',
        m  : 'a minute',
        mm : '%d minutes',
        h  : 'an hour',
        hh : '%d hours',
        d  : 'a day',
        dd : '%d days',
        M  : 'a month',
        MM : '%d months',
        y  : 'a year',
        yy : '%d years'
    };

    function relativeTime (number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return (isFunction(output)) ?
            output(number, withoutSuffix, string, isFuture) :
            output.replace(/%d/i, number);
    }

    function pastFuture (diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias (unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [];
        for (var u in unitsObj) {
            units.push({unit: u, priority: priorities[u]});
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

    var formatFunctions = {};

    var formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken (token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(func.apply(this, arguments), token);
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '', i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var match1         = /\d/;            //       0 - 9
    var match2         = /\d\d/;          //      00 - 99
    var match3         = /\d{3}/;         //     000 - 999
    var match4         = /\d{4}/;         //    0000 - 9999
    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
    var match1to2      = /\d\d?/;         //       0 - 99
    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
    var match1to3      = /\d{1,3}/;       //       0 - 999
    var match1to4      = /\d{1,4}/;       //       0 - 9999
    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

    var matchUnsigned  = /\d+/;           //       0 - inf
    var matchSigned    = /[+-]?\d+/;      //    -inf - inf

    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

    // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;

    var regexes = {};

    function addRegexToken (token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
            return (isStrict && strictRegex) ? strictRegex : regex;
        };
    }

    function getParseRegexForToken (token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken (token, callback) {
        var i, func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken (token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0;
    var MONTH = 1;
    var DATE = 2;
    var HOUR = 3;
    var MINUTE = 4;
    var SECOND = 5;
    var MILLISECOND = 6;
    var WEEK = 7;
    var WEEKDAY = 8;

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? '' + y : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY',   4],       0, 'year');
    addFormatToken(0, ['YYYYY',  5],       0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y',      matchSigned);
    addRegexToken('YY',     match1to2, match2);
    addRegexToken('YYYY',   match1to4, match4);
    addRegexToken('YYYYY',  match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear () {
        return isLeapYear(this.year());
    }

    function makeGetSet (unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get (mom, unit) {
        return mom.isValid() ?
            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
    }

    function set$1 (mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
            }
            else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet (units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }


    function stringSet (units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units);
            for (var i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M',    match1to2);
    addRegexToken('MM',   match1to2, match2);
    addRegexToken('MMM',  function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
    function localeMonths (m, format) {
        if (!m) {
            return isArray(this._months) ? this._months :
                this._months['standalone'];
        }
        return isArray(this._months) ? this._months[m.month()] :
            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }

    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
    function localeMonthsShort (m, format) {
        if (!m) {
            return isArray(this._monthsShort) ? this._monthsShort :
                this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse (monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
                return i;
            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth (mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth (value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth () {
        return daysInMonth(this.year(), this.month());
    }

    var defaultMonthsShortRegex = matchWord;
    function monthsShortRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict ?
                this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }

    var defaultMonthsRegex = matchWord;
    function monthsRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict ?
                this._monthsStrictRegex : this._monthsRegex;
        }
    }

    function computeMonthsParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }

    function createDate (y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date = new Date(y, m, d, h, M, s, ms);

        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
            date.setFullYear(y);
        }
        return date;
    }

    function createUTCDate (y) {
        var date = new Date(Date.UTC.apply(null, arguments));

        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
            date.setUTCFullYear(y);
        }
        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear, resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek, resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w',  match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W',  match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek (mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    };

    function localeFirstDayOfWeek () {
        return this._week.dow;
    }

    function localeFirstDayOfYear () {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek (input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek (input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d',    match1to2);
    addRegexToken('e',    match1to2);
    addRegexToken('E',    match1to2);
    addRegexToken('dd',   function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd',   function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd',   function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
    function localeWeekdays (m, format) {
        if (!m) {
            return isArray(this._weekdays) ? this._weekdays :
                this._weekdays['standalone'];
        }
        return isArray(this._weekdays) ? this._weekdays[m.day()] :
            this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
    }

    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
    function localeWeekdaysShort (m) {
        return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }

    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
    function localeWeekdaysMin (m) {
        return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse (weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    var defaultWeekdaysRegex = matchWord;
    function weekdaysRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict ?
                this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }

    var defaultWeekdaysShortRegex = matchWord;
    function weekdaysShortRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict ?
                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }

    var defaultWeekdaysMinRegex = matchWord;
    function weekdaysMinRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict ?
                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }


    function computeWeekdaysParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom, minp, shortp, longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = this.weekdaysMin(mom, '');
            shortp = this.weekdaysShort(mom, '');
            longp = this.weekdays(mom, '');
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 7; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    function meridiem (token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem (isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a',  matchMeridiem);
    addRegexToken('A',  matchMeridiem);
    addRegexToken('H',  match1to2);
    addRegexToken('h',  match1to2);
    addRegexToken('k',  match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM (input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return ((input + '').toLowerCase().charAt(0) === 'p');
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
    function localeMeridiem (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }


    // MOMENTS

    // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    var getSetHour = makeGetSet('Hours', true);

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse
    };

    // internal storage for locale config files
    var locales = {};
    var localeFamilies = {};
    var globalLocale;

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function loadLocale(name) {
        var oldLocale = null;
        // TODO: Find a better way to register and load all the locales in Node
        if (!locales[name] && (typeof module !== 'undefined') &&
                module && module.exports) {
            try {
                oldLocale = globalLocale._abbr;
                var aliasedRequire = require;
                !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
                getSetGlobalLocale(oldLocale);
            } catch (e) {}
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale (key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            }
            else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            }
            else {
                if ((typeof console !==  'undefined') && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn('Locale ' + key +  ' not found. Did you forget to load it?');
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale (name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride',
                        'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);


            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            // MERGE
            tmpLocale = loadLocale(name);
            if (tmpLocale != null) {
                parentConfig = tmpLocale._config;
            }
            config = mergeConfigs(parentConfig, config);
            locale = new Locale(config);
            locale.parentLocale = locales[name];
            locales[name] = locale;

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale (key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow (m) {
        var overflow;
        var a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
                -1;

            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray (config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 &&
                config._a[MINUTE] === 0 &&
                config._a[SECOND] === 0 &&
                config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            var curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from begining of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to begining of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

    var isoDates = [
        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
        ['YYYY-DDD', /\d{4}-\d{3}/],
        ['YYYY-MM', /\d{4}-\d\d/, false],
        ['YYYYYYMMDD', /[+-]\d{10}/],
        ['YYYYMMDD', /\d{8}/],
        // YYYYMM is NOT allowed by the standard
        ['GGGG[W]WWE', /\d{4}W\d{3}/],
        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
        ['YYYYDDD', /\d{7}/]
    ];

    // iso time formats and regexes
    var isoTimes = [
        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
        ['HH:mm', /\d\d:\d\d/],
        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
        ['HHmmss', /\d\d\d\d\d\d/],
        ['HHmm', /\d\d\d\d/],
        ['HH', /\d\d/]
    ];

    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

    // date from iso format
    function configFromISO(config) {
        var i, l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime, dateFormat, timeFormat, tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;

    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').trim();
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    var obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -4 * 60,
        EST: -5 * 60,
        CDT: -5 * 60,
        CST: -6 * 60,
        MDT: -6 * 60,
        MST: -7 * 60,
        PDT: -7 * 60,
        PST: -8 * 60
    };

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10);
            var m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i));
        if (match) {
            var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from iso format or fallback
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);

        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
        'discouraged and will be removed in an upcoming major release. Please refer to ' +
        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i, parsedInput, tokens, token, skipped,
            stringLength = string.length,
            totalParsedInputLength = 0;

        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            // console.log('token', token, 'parsedInput', parsedInput,
            //         'regex', getParseRegexForToken(token, config));
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                }
                else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            }
            else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

        configFromArray(config);
        checkOverflow(config);
    }


    function meridiemFixWrap (locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,

            scoreToBeat,
            i,
            currentScore;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (!isValid(tempConfig)) {
                continue;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (scoreToBeat == null || currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i);
        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
            return obj && parseInt(obj, 10);
        });

        configFromArray(config);
    }

    function createFromConfig (config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig (config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({nullInput: true});
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        }  else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC (input, format, locale, strict, isUTC) {
        var c = {};

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if ((isObject(input) && isObjectEmpty(input)) ||
                (isArray(input) && input.length === 0)) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other < this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    var prototypeMax = deprecate(
        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other > this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +(new Date());
    };

    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

    function isDurationValid(m) {
        for (var key in m) {
            if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
                return false;
            }
        }

        var unitHasDecimal = false;
        for (var i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration (duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds = +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days +
            weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months +
            quarters * 3 +
            years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration (obj) {
        return obj instanceof Duration;
    }

    function absRound (number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // FORMATTING

    function offset (token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset();
            var sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z',  matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher);

        if (matches === null) {
            return null;
        }

        var chunk   = matches[matches.length - 1] || [];
        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        var minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ?
          0 :
          parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset (m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset (input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone (input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC (keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal (keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset () {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            }
            else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset (input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime () {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted () {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {};

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() &&
                compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal () {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset () {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc () {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration (input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms : input._milliseconds,
                d  : input._days,
                M  : input._months
            };
        } else if (isNumber(input)) {
            duration = {};
            if (key) {
                duration[key] = input;
            } else {
                duration.milliseconds = input;
            }
        } else if (!!(match = aspNetRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y  : 0,
                d  : toInt(match[DATE])                         * sign,
                h  : toInt(match[HOUR])                         * sign,
                m  : toInt(match[MINUTE])                       * sign,
                s  : toInt(match[SECOND])                       * sign,
                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
            };
        } else if (!!(match = isoRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : (match[1] === '+') ? 1 : 1;
            duration = {
                y : parseIso(match[2], sign),
                M : parseIso(match[3], sign),
                w : parseIso(match[4], sign),
                d : parseIso(match[5], sign),
                h : parseIso(match[6], sign),
                m : parseIso(match[7], sign),
                s : parseIso(match[8], sign)
            };
        } else if (duration == null) {// checks for null or undefined
            duration = {};
        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso (inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {milliseconds: 0, months: 0};

        res.months = other.month() - base.month() +
            (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return {milliseconds: 0, months: 0};
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val; val = period; period = tmp;
            }

            val = typeof val === 'string' ? +val : val;
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract (mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add      = createAdder(1, 'add');
    var subtract = createAdder(-1, 'subtract');

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' :
                diff < -1 ? 'lastWeek' :
                diff < 0 ? 'lastDay' :
                diff < 1 ? 'sameDay' :
                diff < 2 ? 'nextDay' :
                diff < 7 ? 'nextWeek' : 'sameElse';
    }

    function calendar$1 (time, formats) {
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse';

        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }

    function clone () {
        return new Moment(this);
    }

    function isAfter (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween (from, to, units, inclusivity) {
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
            (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
    }

    function isSame (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units || 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }

    function isSameOrAfter (input, units) {
        return this.isSame(input, units) || this.isAfter(input,units);
    }

    function isSameOrBefore (input, units) {
        return this.isSame(input, units) || this.isBefore(input,units);
    }

    function diff (input, units, asFloat) {
        var that,
            zoneDelta,
            output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year': output = monthDiff(this, that) / 12; break;
            case 'month': output = monthDiff(this, that); break;
            case 'quarter': output = monthDiff(this, that) / 3; break;
            case 'second': output = (this - that) / 1e3; break; // 1000
            case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
            case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
            case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
            case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default: output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff (a, b) {
        // difference in months
        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2, adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString () {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true;
        var m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect () {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment';
        var zone = '';
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        var prefix = '[' + func + '("]';
        var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
        var suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format (inputString) {
        if (!inputString) {
            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow (withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow (withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale (key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData () {
        return this._locale;
    }

    function startOf (units) {
        units = normalizeUnits(units);
        // the following switch intentionally omits break keywords
        // to utilize falling through the cases.
        switch (units) {
            case 'year':
                this.month(0);
                /* falls through */
            case 'quarter':
            case 'month':
                this.date(1);
                /* falls through */
            case 'week':
            case 'isoWeek':
            case 'day':
            case 'date':
                this.hours(0);
                /* falls through */
            case 'hour':
                this.minutes(0);
                /* falls through */
            case 'minute':
                this.seconds(0);
                /* falls through */
            case 'second':
                this.milliseconds(0);
        }

        // weeks are a special case
        if (units === 'week') {
            this.weekday(0);
        }
        if (units === 'isoWeek') {
            this.isoWeekday(1);
        }

        // quarters are also special
        if (units === 'quarter') {
            this.month(Math.floor(this.month() / 3) * 3);
        }

        return this;
    }

    function endOf (units) {
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond') {
            return this;
        }

        // 'date' is an alias for 'day', so it should be considered as such.
        if (units === 'date') {
            units = 'day';
        }

        return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
    }

    function valueOf () {
        return this._d.valueOf() - ((this._offset || 0) * 60000);
    }

    function unix () {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate () {
        return new Date(this.valueOf());
    }

    function toArray () {
        var m = this;
        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
    }

    function toObject () {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }

    function toJSON () {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2 () {
        return isValid(this);
    }

    function parsingFlags () {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt () {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken (token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg',     'weekYear');
    addWeekYearFormatToken('ggggg',    'weekYear');
    addWeekYearFormatToken('GGGG',  'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);


    // PARSING

    addRegexToken('G',      matchSigned);
    addRegexToken('g',      matchSigned);
    addRegexToken('GG',     match1to2, match2);
    addRegexToken('gg',     match1to2, match2);
    addRegexToken('GGGG',   match1to4, match4);
    addRegexToken('gggg',   match1to4, match4);
    addRegexToken('GGGGG',  match1to6, match6);
    addRegexToken('ggggg',  match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input,
                this.week(),
                this.weekday(),
                this.localeData()._week.dow,
                this.localeData()._week.doy);
    }

    function getSetISOWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }

    function getISOWeeksInYear () {
        return weeksInYear(this.year(), 1, 4);
    }

    function getWeeksInYear () {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter (input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D',  match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ?
          (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
          locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD',  match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear (input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m',  match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s',  match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });


    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S',    match1to3, match1);
    addRegexToken('SS',   match1to3, match2);
    addRegexToken('SSS',  match1to3, match3);

    var token;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }
    // MOMENTS

    var getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z',  0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr () {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName () {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add               = add;
    proto.calendar          = calendar$1;
    proto.clone             = clone;
    proto.diff              = diff;
    proto.endOf             = endOf;
    proto.format            = format;
    proto.from              = from;
    proto.fromNow           = fromNow;
    proto.to                = to;
    proto.toNow             = toNow;
    proto.get               = stringGet;
    proto.invalidAt         = invalidAt;
    proto.isAfter           = isAfter;
    proto.isBefore          = isBefore;
    proto.isBetween         = isBetween;
    proto.isSame            = isSame;
    proto.isSameOrAfter     = isSameOrAfter;
    proto.isSameOrBefore    = isSameOrBefore;
    proto.isValid           = isValid$2;
    proto.lang              = lang;
    proto.locale            = locale;
    proto.localeData        = localeData;
    proto.max               = prototypeMax;
    proto.min               = prototypeMin;
    proto.parsingFlags      = parsingFlags;
    proto.set               = stringSet;
    proto.startOf           = startOf;
    proto.subtract          = subtract;
    proto.toArray           = toArray;
    proto.toObject          = toObject;
    proto.toDate            = toDate;
    proto.toISOString       = toISOString;
    proto.inspect           = inspect;
    proto.toJSON            = toJSON;
    proto.toString          = toString;
    proto.unix              = unix;
    proto.valueOf           = valueOf;
    proto.creationData      = creationData;
    proto.year       = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear    = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month       = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week           = proto.weeks        = getSetWeek;
    proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
    proto.weeksInYear    = getWeeksInYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.date       = getSetDayOfMonth;
    proto.day        = proto.days             = getSetDayOfWeek;
    proto.weekday    = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear  = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset            = getSetOffset;
    proto.utc                  = setOffsetToUTC;
    proto.local                = setOffsetToLocal;
    proto.parseZone            = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST                = isDaylightSavingTime;
    proto.isLocal              = isLocal;
    proto.isUtcOffset          = isUtcOffset;
    proto.isUtc                = isUtc;
    proto.isUTC                = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

    function createUnix (input) {
        return createLocal(input * 1000);
    }

    function createInZone () {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat (string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar        = calendar;
    proto$1.longDateFormat  = longDateFormat;
    proto$1.invalidDate     = invalidDate;
    proto$1.ordinal         = ordinal;
    proto$1.preparse        = preParsePostFormat;
    proto$1.postformat      = preParsePostFormat;
    proto$1.relativeTime    = relativeTime;
    proto$1.pastFuture      = pastFuture;
    proto$1.set             = set;

    proto$1.months            =        localeMonths;
    proto$1.monthsShort       =        localeMonthsShort;
    proto$1.monthsParse       =        localeMonthsParse;
    proto$1.monthsRegex       = monthsRegex;
    proto$1.monthsShortRegex  = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays       =        localeWeekdays;
    proto$1.weekdaysMin    =        localeWeekdaysMin;
    proto$1.weekdaysShort  =        localeWeekdaysShort;
    proto$1.weekdaysParse  =        localeWeekdaysParse;

    proto$1.weekdaysRegex       =        weekdaysRegex;
    proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
    proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1 (format, index, field, setter) {
        var locale = getLocale();
        var utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl (format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i;
        var out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl (localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0;

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        var i;
        var out = [];
        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths (format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort (format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (toInt(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    // Side effect imports

    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

    var mathAbs = Math.abs;

    function abs () {
        var data           = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days         = mathAbs(this._days);
        this._months       = mathAbs(this._months);

        data.milliseconds  = mathAbs(data.milliseconds);
        data.seconds       = mathAbs(data.seconds);
        data.minutes       = mathAbs(data.minutes);
        data.hours         = mathAbs(data.hours);
        data.months        = mathAbs(data.months);
        data.years         = mathAbs(data.years);

        return this;
    }

    function addSubtract$1 (duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days         += direction * other._days;
        duration._months       += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1 (input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1 (input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil (number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble () {
        var milliseconds = this._milliseconds;
        var days         = this._days;
        var months       = this._months;
        var data         = this._data;
        var seconds, minutes, hours, years, monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0))) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds           = absFloor(milliseconds / 1000);
        data.seconds      = seconds % 60;

        minutes           = absFloor(seconds / 60);
        data.minutes      = minutes % 60;

        hours             = absFloor(minutes / 60);
        data.hours        = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days   = days;
        data.months = months;
        data.years  = years;

        return this;
    }

    function daysToMonths (days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }

    function monthsToDays (months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }

    function as (units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days;
        var months;
        var milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'year') {
            days   = this._days   + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            return units === 'month' ? months : months / 12;
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week'   : return days / 7     + milliseconds / 6048e5;
                case 'day'    : return days         + milliseconds / 864e5;
                case 'hour'   : return days * 24    + milliseconds / 36e5;
                case 'minute' : return days * 1440  + milliseconds / 6e4;
                case 'second' : return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
                default: throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1 () {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs (alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms');
    var asSeconds      = makeAs('s');
    var asMinutes      = makeAs('m');
    var asHours        = makeAs('h');
    var asDays         = makeAs('d');
    var asWeeks        = makeAs('w');
    var asMonths       = makeAs('M');
    var asYears        = makeAs('y');

    function clone$1 () {
        return createDuration(this);
    }

    function get$2 (units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds');
    var seconds      = makeGetter('seconds');
    var minutes      = makeGetter('minutes');
    var hours        = makeGetter('hours');
    var days         = makeGetter('days');
    var months       = makeGetter('months');
    var years        = makeGetter('years');

    function weeks () {
        return absFloor(this.days() / 7);
    }

    var round = Math.round;
    var thresholds = {
        ss: 44,         // a few seconds to seconds
        s : 45,         // seconds to minute
        m : 45,         // minutes to hour
        h : 22,         // hours to day
        d : 26,         // days to month
        M : 11          // months to year
    };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
        var duration = createDuration(posNegDuration).abs();
        var seconds  = round(duration.as('s'));
        var minutes  = round(duration.as('m'));
        var hours    = round(duration.as('h'));
        var days     = round(duration.as('d'));
        var months   = round(duration.as('M'));
        var years    = round(duration.as('y'));

        var a = seconds <= thresholds.ss && ['s', seconds]  ||
                seconds < thresholds.s   && ['ss', seconds] ||
                minutes <= 1             && ['m']           ||
                minutes < thresholds.m   && ['mm', minutes] ||
                hours   <= 1             && ['h']           ||
                hours   < thresholds.h   && ['hh', hours]   ||
                days    <= 1             && ['d']           ||
                days    < thresholds.d   && ['dd', days]    ||
                months  <= 1             && ['M']           ||
                months  < thresholds.M   && ['MM', months]  ||
                years   <= 1             && ['y']           || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding (roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof(roundingFunction) === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold (threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize (withSuffix) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var locale = this.localeData();
        var output = relativeTime$1(this, !withSuffix, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return ((x > 0) - (x < 0)) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000;
        var days         = abs$1(this._days);
        var months       = abs$1(this._months);
        var minutes, hours, years;

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes           = absFloor(seconds / 60);
        hours             = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years  = absFloor(months / 12);
        months %= 12;


        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        var Y = years;
        var M = months;
        var D = days;
        var h = hours;
        var m = minutes;
        var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        var total = this.asSeconds();

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        var totalSign = total < 0 ? '-' : '';
        var ymSign = sign(this._months) !== sign(total) ? '-' : '';
        var daysSign = sign(this._days) !== sign(total) ? '-' : '';
        var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return totalSign + 'P' +
            (Y ? ymSign + Y + 'Y' : '') +
            (M ? ymSign + M + 'M' : '') +
            (D ? daysSign + D + 'D' : '') +
            ((h || m || s) ? 'T' : '') +
            (h ? hmsSign + h + 'H' : '') +
            (m ? hmsSign + m + 'M' : '') +
            (s ? hmsSign + s + 'S' : '');
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid        = isValid$1;
    proto$2.abs            = abs;
    proto$2.add            = add$1;
    proto$2.subtract       = subtract$1;
    proto$2.as             = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds      = asSeconds;
    proto$2.asMinutes      = asMinutes;
    proto$2.asHours        = asHours;
    proto$2.asDays         = asDays;
    proto$2.asWeeks        = asWeeks;
    proto$2.asMonths       = asMonths;
    proto$2.asYears        = asYears;
    proto$2.valueOf        = valueOf$1;
    proto$2._bubble        = bubble;
    proto$2.clone          = clone$1;
    proto$2.get            = get$2;
    proto$2.milliseconds   = milliseconds;
    proto$2.seconds        = seconds;
    proto$2.minutes        = minutes;
    proto$2.hours          = hours;
    proto$2.days           = days;
    proto$2.weeks          = weeks;
    proto$2.months         = months;
    proto$2.years          = years;
    proto$2.humanize       = humanize;
    proto$2.toISOString    = toISOString$1;
    proto$2.toString       = toISOString$1;
    proto$2.toJSON         = toISOString$1;
    proto$2.locale         = locale;
    proto$2.localeData     = localeData;

    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;

    // Side effect imports

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input, 10) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    // Side effect imports


    hooks.version = '2.22.1';

    setHookCallback(createLocal);

    hooks.fn                    = proto;
    hooks.min                   = min;
    hooks.max                   = max;
    hooks.now                   = now;
    hooks.utc                   = createUTC;
    hooks.unix                  = createUnix;
    hooks.months                = listMonths;
    hooks.isDate                = isDate;
    hooks.locale                = getSetGlobalLocale;
    hooks.invalid               = createInvalid;
    hooks.duration              = createDuration;
    hooks.isMoment              = isMoment;
    hooks.weekdays              = listWeekdays;
    hooks.parseZone             = createInZone;
    hooks.localeData            = getLocale;
    hooks.isDuration            = isDuration;
    hooks.monthsShort           = listMonthsShort;
    hooks.weekdaysMin           = listWeekdaysMin;
    hooks.defineLocale          = defineLocale;
    hooks.updateLocale          = updateLocale;
    hooks.locales               = listLocales;
    hooks.weekdaysShort         = listWeekdaysShort;
    hooks.normalizeUnits        = normalizeUnits;
    hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat        = getCalendarFormat;
    hooks.prototype             = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD',                             // <input type="date" />
        TIME: 'HH:mm',                                  // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
        WEEK: 'YYYY-[W]WW',                             // <input type="week" />
        MONTH: 'YYYY-MM'                                // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(50)(module)))

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(2);
var elements = __webpack_require__(13);
var helpers = __webpack_require__(1);

defaults._set('bar', {
	hover: {
		mode: 'label'
	},

	scales: {
		xAxes: [{
			type: 'category',

			// Specific to Bar Controller
			categoryPercentage: 0.8,
			barPercentage: 0.9,

			// offset settings
			offset: true,

			// grid line settings
			gridLines: {
				offsetGridLines: true
			}
		}],

		yAxes: [{
			type: 'linear'
		}]
	}
});

defaults._set('horizontalBar', {
	hover: {
		mode: 'index',
		axis: 'y'
	},

	scales: {
		xAxes: [{
			type: 'linear',
			position: 'bottom'
		}],

		yAxes: [{
			position: 'left',
			type: 'category',

			// Specific to Horizontal Bar Controller
			categoryPercentage: 0.8,
			barPercentage: 0.9,

			// offset settings
			offset: true,

			// grid line settings
			gridLines: {
				offsetGridLines: true
			}
		}]
	},

	elements: {
		rectangle: {
			borderSkipped: 'left'
		}
	},

	tooltips: {
		callbacks: {
			title: function(item, data) {
				// Pick first xLabel for now
				var title = '';

				if (item.length > 0) {
					if (item[0].yLabel) {
						title = item[0].yLabel;
					} else if (data.labels.length > 0 && item[0].index < data.labels.length) {
						title = data.labels[item[0].index];
					}
				}

				return title;
			},

			label: function(item, data) {
				var datasetLabel = data.datasets[item.datasetIndex].label || '';
				return datasetLabel + ': ' + item.xLabel;
			}
		},
		mode: 'index',
		axis: 'y'
	}
});

/**
 * Computes the "optimal" sample size to maintain bars equally sized while preventing overlap.
 * @private
 */
function computeMinSampleSize(scale, pixels) {
	var min = scale.isHorizontal() ? scale.width : scale.height;
	var ticks = scale.getTicks();
	var prev, curr, i, ilen;

	for (i = 1, ilen = pixels.length; i < ilen; ++i) {
		min = Math.min(min, pixels[i] - pixels[i - 1]);
	}

	for (i = 0, ilen = ticks.length; i < ilen; ++i) {
		curr = scale.getPixelForTick(i);
		min = i > 0 ? Math.min(min, curr - prev) : min;
		prev = curr;
	}

	return min;
}

/**
 * Computes an "ideal" category based on the absolute bar thickness or, if undefined or null,
 * uses the smallest interval (see computeMinSampleSize) that prevents bar overlapping. This
 * mode currently always generates bars equally sized (until we introduce scriptable options?).
 * @private
 */
function computeFitCategoryTraits(index, ruler, options) {
	var thickness = options.barThickness;
	var count = ruler.stackCount;
	var curr = ruler.pixels[index];
	var size, ratio;

	if (helpers.isNullOrUndef(thickness)) {
		size = ruler.min * options.categoryPercentage;
		ratio = options.barPercentage;
	} else {
		// When bar thickness is enforced, category and bar percentages are ignored.
		// Note(SB): we could add support for relative bar thickness (e.g. barThickness: '50%')
		// and deprecate barPercentage since this value is ignored when thickness is absolute.
		size = thickness * count;
		ratio = 1;
	}

	return {
		chunk: size / count,
		ratio: ratio,
		start: curr - (size / 2)
	};
}

/**
 * Computes an "optimal" category that globally arranges bars side by side (no gap when
 * percentage options are 1), based on the previous and following categories. This mode
 * generates bars with different widths when data are not evenly spaced.
 * @private
 */
function computeFlexCategoryTraits(index, ruler, options) {
	var pixels = ruler.pixels;
	var curr = pixels[index];
	var prev = index > 0 ? pixels[index - 1] : null;
	var next = index < pixels.length - 1 ? pixels[index + 1] : null;
	var percent = options.categoryPercentage;
	var start, size;

	if (prev === null) {
		// first data: its size is double based on the next point or,
		// if it's also the last data, we use the scale end extremity.
		prev = curr - (next === null ? ruler.end - curr : next - curr);
	}

	if (next === null) {
		// last data: its size is also double based on the previous point.
		next = curr + curr - prev;
	}

	start = curr - ((curr - prev) / 2) * percent;
	size = ((next - prev) / 2) * percent;

	return {
		chunk: size / ruler.stackCount,
		ratio: options.barPercentage,
		start: start
	};
}

module.exports = function(Chart) {

	Chart.controllers.bar = Chart.DatasetController.extend({

		dataElementType: elements.Rectangle,

		initialize: function() {
			var me = this;
			var meta;

			Chart.DatasetController.prototype.initialize.apply(me, arguments);

			meta = me.getMeta();
			meta.stack = me.getDataset().stack;
			meta.bar = true;
		},

		update: function(reset) {
			var me = this;
			var rects = me.getMeta().data;
			var i, ilen;

			me._ruler = me.getRuler();

			for (i = 0, ilen = rects.length; i < ilen; ++i) {
				me.updateElement(rects[i], i, reset);
			}
		},

		updateElement: function(rectangle, index, reset) {
			var me = this;
			var chart = me.chart;
			var meta = me.getMeta();
			var dataset = me.getDataset();
			var custom = rectangle.custom || {};
			var rectangleOptions = chart.options.elements.rectangle;

			rectangle._xScale = me.getScaleForId(meta.xAxisID);
			rectangle._yScale = me.getScaleForId(meta.yAxisID);
			rectangle._datasetIndex = me.index;
			rectangle._index = index;

			rectangle._model = {
				datasetLabel: dataset.label,
				label: chart.data.labels[index],
				borderSkipped: custom.borderSkipped ? custom.borderSkipped : rectangleOptions.borderSkipped,
				backgroundColor: custom.backgroundColor ? custom.backgroundColor : helpers.valueAtIndexOrDefault(dataset.backgroundColor, index, rectangleOptions.backgroundColor),
				borderColor: custom.borderColor ? custom.borderColor : helpers.valueAtIndexOrDefault(dataset.borderColor, index, rectangleOptions.borderColor),
				borderWidth: custom.borderWidth ? custom.borderWidth : helpers.valueAtIndexOrDefault(dataset.borderWidth, index, rectangleOptions.borderWidth)
			};

			me.updateElementGeometry(rectangle, index, reset);

			rectangle.pivot();
		},

		/**
		 * @private
		 */
		updateElementGeometry: function(rectangle, index, reset) {
			var me = this;
			var model = rectangle._model;
			var vscale = me.getValueScale();
			var base = vscale.getBasePixel();
			var horizontal = vscale.isHorizontal();
			var ruler = me._ruler || me.getRuler();
			var vpixels = me.calculateBarValuePixels(me.index, index);
			var ipixels = me.calculateBarIndexPixels(me.index, index, ruler);

			model.horizontal = horizontal;
			model.base = reset ? base : vpixels.base;
			model.x = horizontal ? reset ? base : vpixels.head : ipixels.center;
			model.y = horizontal ? ipixels.center : reset ? base : vpixels.head;
			model.height = horizontal ? ipixels.size : undefined;
			model.width = horizontal ? undefined : ipixels.size;
		},

		/**
		 * @private
		 */
		getValueScaleId: function() {
			return this.getMeta().yAxisID;
		},

		/**
		 * @private
		 */
		getIndexScaleId: function() {
			return this.getMeta().xAxisID;
		},

		/**
		 * @private
		 */
		getValueScale: function() {
			return this.getScaleForId(this.getValueScaleId());
		},

		/**
		 * @private
		 */
		getIndexScale: function() {
			return this.getScaleForId(this.getIndexScaleId());
		},

		/**
		 * Returns the stacks based on groups and bar visibility.
		 * @param {Number} [last] - The dataset index
		 * @returns {Array} The stack list
		 * @private
		 */
		_getStacks: function(last) {
			var me = this;
			var chart = me.chart;
			var scale = me.getIndexScale();
			var stacked = scale.options.stacked;
			var ilen = last === undefined ? chart.data.datasets.length : last + 1;
			var stacks = [];
			var i, meta;

			for (i = 0; i < ilen; ++i) {
				meta = chart.getDatasetMeta(i);
				if (meta.bar && chart.isDatasetVisible(i) &&
					(stacked === false ||
					(stacked === true && stacks.indexOf(meta.stack) === -1) ||
					(stacked === undefined && (meta.stack === undefined || stacks.indexOf(meta.stack) === -1)))) {
					stacks.push(meta.stack);
				}
			}

			return stacks;
		},

		/**
		 * Returns the effective number of stacks based on groups and bar visibility.
		 * @private
		 */
		getStackCount: function() {
			return this._getStacks().length;
		},

		/**
		 * Returns the stack index for the given dataset based on groups and bar visibility.
		 * @param {Number} [datasetIndex] - The dataset index
		 * @param {String} [name] - The stack name to find
		 * @returns {Number} The stack index
		 * @private
		 */
		getStackIndex: function(datasetIndex, name) {
			var stacks = this._getStacks(datasetIndex);
			var index = (name !== undefined)
				? stacks.indexOf(name)
				: -1; // indexOf returns -1 if element is not present

			return (index === -1)
				? stacks.length - 1
				: index;
		},

		/**
		 * @private
		 */
		getRuler: function() {
			var me = this;
			var scale = me.getIndexScale();
			var stackCount = me.getStackCount();
			var datasetIndex = me.index;
			var isHorizontal = scale.isHorizontal();
			var start = isHorizontal ? scale.left : scale.top;
			var end = start + (isHorizontal ? scale.width : scale.height);
			var pixels = [];
			var i, ilen, min;

			for (i = 0, ilen = me.getMeta().data.length; i < ilen; ++i) {
				pixels.push(scale.getPixelForValue(null, i, datasetIndex));
			}

			min = helpers.isNullOrUndef(scale.options.barThickness)
				? computeMinSampleSize(scale, pixels)
				: -1;

			return {
				min: min,
				pixels: pixels,
				start: start,
				end: end,
				stackCount: stackCount,
				scale: scale
			};
		},

		/**
		 * Note: pixel values are not clamped to the scale area.
		 * @private
		 */
		calculateBarValuePixels: function(datasetIndex, index) {
			var me = this;
			var chart = me.chart;
			var meta = me.getMeta();
			var scale = me.getValueScale();
			var datasets = chart.data.datasets;
			var value = scale.getRightValue(datasets[datasetIndex].data[index]);
			var stacked = scale.options.stacked;
			var stack = meta.stack;
			var start = 0;
			var i, imeta, ivalue, base, head, size;

			if (stacked || (stacked === undefined && stack !== undefined)) {
				for (i = 0; i < datasetIndex; ++i) {
					imeta = chart.getDatasetMeta(i);

					if (imeta.bar &&
						imeta.stack === stack &&
						imeta.controller.getValueScaleId() === scale.id &&
						chart.isDatasetVisible(i)) {

						ivalue = scale.getRightValue(datasets[i].data[index]);
						if ((value < 0 && ivalue < 0) || (value >= 0 && ivalue > 0)) {
							start += ivalue;
						}
					}
				}
			}

			base = scale.getPixelForValue(start);
			head = scale.getPixelForValue(start + value);
			size = (head - base) / 2;

			return {
				size: size,
				base: base,
				head: head,
				center: head + size / 2
			};
		},

		/**
		 * @private
		 */
		calculateBarIndexPixels: function(datasetIndex, index, ruler) {
			var me = this;
			var options = ruler.scale.options;
			var range = options.barThickness === 'flex'
				? computeFlexCategoryTraits(index, ruler, options)
				: computeFitCategoryTraits(index, ruler, options);

			var stackIndex = me.getStackIndex(datasetIndex, me.getMeta().stack);
			var center = range.start + (range.chunk * stackIndex) + (range.chunk / 2);
			var size = Math.min(
				helpers.valueOrDefault(options.maxBarThickness, Infinity),
				range.chunk * range.ratio);

			return {
				base: center - size / 2,
				head: center + size / 2,
				center: center,
				size: size
			};
		},

		draw: function() {
			var me = this;
			var chart = me.chart;
			var scale = me.getValueScale();
			var rects = me.getMeta().data;
			var dataset = me.getDataset();
			var ilen = rects.length;
			var i = 0;

			helpers.canvas.clipArea(chart.ctx, chart.chartArea);

			for (; i < ilen; ++i) {
				if (!isNaN(scale.getRightValue(dataset.data[i]))) {
					rects[i].draw();
				}
			}

			helpers.canvas.unclipArea(chart.ctx);
		},

		setHoverStyle: function(rectangle) {
			var dataset = this.chart.data.datasets[rectangle._datasetIndex];
			var index = rectangle._index;
			var custom = rectangle.custom || {};
			var model = rectangle._model;

			model.backgroundColor = custom.hoverBackgroundColor ? custom.hoverBackgroundColor : helpers.valueAtIndexOrDefault(dataset.hoverBackgroundColor, index, helpers.getHoverColor(model.backgroundColor));
			model.borderColor = custom.hoverBorderColor ? custom.hoverBorderColor : helpers.valueAtIndexOrDefault(dataset.hoverBorderColor, index, helpers.getHoverColor(model.borderColor));
			model.borderWidth = custom.hoverBorderWidth ? custom.hoverBorderWidth : helpers.valueAtIndexOrDefault(dataset.hoverBorderWidth, index, model.borderWidth);
		},

		removeHoverStyle: function(rectangle) {
			var dataset = this.chart.data.datasets[rectangle._datasetIndex];
			var index = rectangle._index;
			var custom = rectangle.custom || {};
			var model = rectangle._model;
			var rectangleElementOptions = this.chart.options.elements.rectangle;

			model.backgroundColor = custom.backgroundColor ? custom.backgroundColor : helpers.valueAtIndexOrDefault(dataset.backgroundColor, index, rectangleElementOptions.backgroundColor);
			model.borderColor = custom.borderColor ? custom.borderColor : helpers.valueAtIndexOrDefault(dataset.borderColor, index, rectangleElementOptions.borderColor);
			model.borderWidth = custom.borderWidth ? custom.borderWidth : helpers.valueAtIndexOrDefault(dataset.borderWidth, index, rectangleElementOptions.borderWidth);
		}
	});

	Chart.controllers.horizontalBar = Chart.controllers.bar.extend({
		/**
		 * @private
		 */
		getValueScaleId: function() {
			return this.getMeta().xAxisID;
		},

		/**
		 * @private
		 */
		getIndexScaleId: function() {
			return this.getMeta().yAxisID;
		}
	});
};


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(2);
var elements = __webpack_require__(13);
var helpers = __webpack_require__(1);

defaults._set('bubble', {
	hover: {
		mode: 'single'
	},

	scales: {
		xAxes: [{
			type: 'linear', // bubble should probably use a linear scale by default
			position: 'bottom',
			id: 'x-axis-0' // need an ID so datasets can reference the scale
		}],
		yAxes: [{
			type: 'linear',
			position: 'left',
			id: 'y-axis-0'
		}]
	},

	tooltips: {
		callbacks: {
			title: function() {
				// Title doesn't make sense for scatter since we format the data as a point
				return '';
			},
			label: function(item, data) {
				var datasetLabel = data.datasets[item.datasetIndex].label || '';
				var dataPoint = data.datasets[item.datasetIndex].data[item.index];
				return datasetLabel + ': (' + item.xLabel + ', ' + item.yLabel + ', ' + dataPoint.r + ')';
			}
		}
	}
});


module.exports = function(Chart) {

	Chart.controllers.bubble = Chart.DatasetController.extend({
		/**
		 * @protected
		 */
		dataElementType: elements.Point,

		/**
		 * @protected
		 */
		update: function(reset) {
			var me = this;
			var meta = me.getMeta();
			var points = meta.data;

			// Update Points
			helpers.each(points, function(point, index) {
				me.updateElement(point, index, reset);
			});
		},

		/**
		 * @protected
		 */
		updateElement: function(point, index, reset) {
			var me = this;
			var meta = me.getMeta();
			var custom = point.custom || {};
			var xScale = me.getScaleForId(meta.xAxisID);
			var yScale = me.getScaleForId(meta.yAxisID);
			var options = me._resolveElementOptions(point, index);
			var data = me.getDataset().data[index];
			var dsIndex = me.index;

			var x = reset ? xScale.getPixelForDecimal(0.5) : xScale.getPixelForValue(typeof data === 'object' ? data : NaN, index, dsIndex);
			var y = reset ? yScale.getBasePixel() : yScale.getPixelForValue(data, index, dsIndex);

			point._xScale = xScale;
			point._yScale = yScale;
			point._options = options;
			point._datasetIndex = dsIndex;
			point._index = index;
			point._model = {
				backgroundColor: options.backgroundColor,
				borderColor: options.borderColor,
				borderWidth: options.borderWidth,
				hitRadius: options.hitRadius,
				pointStyle: options.pointStyle,
				radius: reset ? 0 : options.radius,
				skip: custom.skip || isNaN(x) || isNaN(y),
				x: x,
				y: y,
			};

			point.pivot();
		},

		/**
		 * @protected
		 */
		setHoverStyle: function(point) {
			var model = point._model;
			var options = point._options;

			model.backgroundColor = helpers.valueOrDefault(options.hoverBackgroundColor, helpers.getHoverColor(options.backgroundColor));
			model.borderColor = helpers.valueOrDefault(options.hoverBorderColor, helpers.getHoverColor(options.borderColor));
			model.borderWidth = helpers.valueOrDefault(options.hoverBorderWidth, options.borderWidth);
			model.radius = options.radius + options.hoverRadius;
		},

		/**
		 * @protected
		 */
		removeHoverStyle: function(point) {
			var model = point._model;
			var options = point._options;

			model.backgroundColor = options.backgroundColor;
			model.borderColor = options.borderColor;
			model.borderWidth = options.borderWidth;
			model.radius = options.radius;
		},

		/**
		 * @private
		 */
		_resolveElementOptions: function(point, index) {
			var me = this;
			var chart = me.chart;
			var datasets = chart.data.datasets;
			var dataset = datasets[me.index];
			var custom = point.custom || {};
			var options = chart.options.elements.point;
			var resolve = helpers.options.resolve;
			var data = dataset.data[index];
			var values = {};
			var i, ilen, key;

			// Scriptable options
			var context = {
				chart: chart,
				dataIndex: index,
				dataset: dataset,
				datasetIndex: me.index
			};

			var keys = [
				'backgroundColor',
				'borderColor',
				'borderWidth',
				'hoverBackgroundColor',
				'hoverBorderColor',
				'hoverBorderWidth',
				'hoverRadius',
				'hitRadius',
				'pointStyle'
			];

			for (i = 0, ilen = keys.length; i < ilen; ++i) {
				key = keys[i];
				values[key] = resolve([
					custom[key],
					dataset[key],
					options[key]
				], context, index);
			}

			// Custom radius resolution
			values.radius = resolve([
				custom.radius,
				data ? data.r : undefined,
				dataset.radius,
				options.radius
			], context, index);

			return values;
		}
	});
};


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(2);
var elements = __webpack_require__(13);
var helpers = __webpack_require__(1);

defaults._set('doughnut', {
	animation: {
		// Boolean - Whether we animate the rotation of the Doughnut
		animateRotate: true,
		// Boolean - Whether we animate scaling the Doughnut from the centre
		animateScale: false
	},
	hover: {
		mode: 'single'
	},
	legendCallback: function(chart) {
		var text = [];
		text.push('<ul class="' + chart.id + '-legend">');

		var data = chart.data;
		var datasets = data.datasets;
		var labels = data.labels;

		if (datasets.length) {
			for (var i = 0; i < datasets[0].data.length; ++i) {
				text.push('<li><span style="background-color:' + datasets[0].backgroundColor[i] + '"></span>');
				if (labels[i]) {
					text.push(labels[i]);
				}
				text.push('</li>');
			}
		}

		text.push('</ul>');
		return text.join('');
	},
	legend: {
		labels: {
			generateLabels: function(chart) {
				var data = chart.data;
				if (data.labels.length && data.datasets.length) {
					return data.labels.map(function(label, i) {
						var meta = chart.getDatasetMeta(0);
						var ds = data.datasets[0];
						var arc = meta.data[i];
						var custom = arc && arc.custom || {};
						var valueAtIndexOrDefault = helpers.valueAtIndexOrDefault;
						var arcOpts = chart.options.elements.arc;
						var fill = custom.backgroundColor ? custom.backgroundColor : valueAtIndexOrDefault(ds.backgroundColor, i, arcOpts.backgroundColor);
						var stroke = custom.borderColor ? custom.borderColor : valueAtIndexOrDefault(ds.borderColor, i, arcOpts.borderColor);
						var bw = custom.borderWidth ? custom.borderWidth : valueAtIndexOrDefault(ds.borderWidth, i, arcOpts.borderWidth);

						return {
							text: label,
							fillStyle: fill,
							strokeStyle: stroke,
							lineWidth: bw,
							hidden: isNaN(ds.data[i]) || meta.data[i].hidden,

							// Extra data used for toggling the correct item
							index: i
						};
					});
				}
				return [];
			}
		},

		onClick: function(e, legendItem) {
			var index = legendItem.index;
			var chart = this.chart;
			var i, ilen, meta;

			for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
				meta = chart.getDatasetMeta(i);
				// toggle visibility of index if exists
				if (meta.data[index]) {
					meta.data[index].hidden = !meta.data[index].hidden;
				}
			}

			chart.update();
		}
	},

	// The percentage of the chart that we cut out of the middle.
	cutoutPercentage: 50,

	// The rotation of the chart, where the first data arc begins.
	rotation: Math.PI * -0.5,

	// The total circumference of the chart.
	circumference: Math.PI * 2.0,

	// Need to override these to give a nice default
	tooltips: {
		callbacks: {
			title: function() {
				return '';
			},
			label: function(tooltipItem, data) {
				var dataLabel = data.labels[tooltipItem.index];
				var value = ': ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];

				if (helpers.isArray(dataLabel)) {
					// show value on first line of multiline label
					// need to clone because we are changing the value
					dataLabel = dataLabel.slice();
					dataLabel[0] += value;
				} else {
					dataLabel += value;
				}

				return dataLabel;
			}
		}
	}
});

defaults._set('pie', helpers.clone(defaults.doughnut));
defaults._set('pie', {
	cutoutPercentage: 0
});

module.exports = function(Chart) {

	Chart.controllers.doughnut = Chart.controllers.pie = Chart.DatasetController.extend({

		dataElementType: elements.Arc,

		linkScales: helpers.noop,

		// Get index of the dataset in relation to the visible datasets. This allows determining the inner and outer radius correctly
		getRingIndex: function(datasetIndex) {
			var ringIndex = 0;

			for (var j = 0; j < datasetIndex; ++j) {
				if (this.chart.isDatasetVisible(j)) {
					++ringIndex;
				}
			}

			return ringIndex;
		},

		update: function(reset) {
			var me = this;
			var chart = me.chart;
			var chartArea = chart.chartArea;
			var opts = chart.options;
			var arcOpts = opts.elements.arc;
			var availableWidth = chartArea.right - chartArea.left - arcOpts.borderWidth;
			var availableHeight = chartArea.bottom - chartArea.top - arcOpts.borderWidth;
			var minSize = Math.min(availableWidth, availableHeight);
			var offset = {x: 0, y: 0};
			var meta = me.getMeta();
			var cutoutPercentage = opts.cutoutPercentage;
			var circumference = opts.circumference;

			// If the chart's circumference isn't a full circle, calculate minSize as a ratio of the width/height of the arc
			if (circumference < Math.PI * 2.0) {
				var startAngle = opts.rotation % (Math.PI * 2.0);
				startAngle += Math.PI * 2.0 * (startAngle >= Math.PI ? -1 : startAngle < -Math.PI ? 1 : 0);
				var endAngle = startAngle + circumference;
				var start = {x: Math.cos(startAngle), y: Math.sin(startAngle)};
				var end = {x: Math.cos(endAngle), y: Math.sin(endAngle)};
				var contains0 = (startAngle <= 0 && endAngle >= 0) || (startAngle <= Math.PI * 2.0 && Math.PI * 2.0 <= endAngle);
				var contains90 = (startAngle <= Math.PI * 0.5 && Math.PI * 0.5 <= endAngle) || (startAngle <= Math.PI * 2.5 && Math.PI * 2.5 <= endAngle);
				var contains180 = (startAngle <= -Math.PI && -Math.PI <= endAngle) || (startAngle <= Math.PI && Math.PI <= endAngle);
				var contains270 = (startAngle <= -Math.PI * 0.5 && -Math.PI * 0.5 <= endAngle) || (startAngle <= Math.PI * 1.5 && Math.PI * 1.5 <= endAngle);
				var cutout = cutoutPercentage / 100.0;
				var min = {x: contains180 ? -1 : Math.min(start.x * (start.x < 0 ? 1 : cutout), end.x * (end.x < 0 ? 1 : cutout)), y: contains270 ? -1 : Math.min(start.y * (start.y < 0 ? 1 : cutout), end.y * (end.y < 0 ? 1 : cutout))};
				var max = {x: contains0 ? 1 : Math.max(start.x * (start.x > 0 ? 1 : cutout), end.x * (end.x > 0 ? 1 : cutout)), y: contains90 ? 1 : Math.max(start.y * (start.y > 0 ? 1 : cutout), end.y * (end.y > 0 ? 1 : cutout))};
				var size = {width: (max.x - min.x) * 0.5, height: (max.y - min.y) * 0.5};
				minSize = Math.min(availableWidth / size.width, availableHeight / size.height);
				offset = {x: (max.x + min.x) * -0.5, y: (max.y + min.y) * -0.5};
			}

			chart.borderWidth = me.getMaxBorderWidth(meta.data);
			chart.outerRadius = Math.max((minSize - chart.borderWidth) / 2, 0);
			chart.innerRadius = Math.max(cutoutPercentage ? (chart.outerRadius / 100) * (cutoutPercentage) : 0, 0);
			chart.radiusLength = (chart.outerRadius - chart.innerRadius) / chart.getVisibleDatasetCount();
			chart.offsetX = offset.x * chart.outerRadius;
			chart.offsetY = offset.y * chart.outerRadius;

			meta.total = me.calculateTotal();

			me.outerRadius = chart.outerRadius - (chart.radiusLength * me.getRingIndex(me.index));
			me.innerRadius = Math.max(me.outerRadius - chart.radiusLength, 0);

			helpers.each(meta.data, function(arc, index) {
				me.updateElement(arc, index, reset);
			});
		},

		updateElement: function(arc, index, reset) {
			var me = this;
			var chart = me.chart;
			var chartArea = chart.chartArea;
			var opts = chart.options;
			var animationOpts = opts.animation;
			var centerX = (chartArea.left + chartArea.right) / 2;
			var centerY = (chartArea.top + chartArea.bottom) / 2;
			var startAngle = opts.rotation; // non reset case handled later
			var endAngle = opts.rotation; // non reset case handled later
			var dataset = me.getDataset();
			var circumference = reset && animationOpts.animateRotate ? 0 : arc.hidden ? 0 : me.calculateCircumference(dataset.data[index]) * (opts.circumference / (2.0 * Math.PI));
			var innerRadius = reset && animationOpts.animateScale ? 0 : me.innerRadius;
			var outerRadius = reset && animationOpts.animateScale ? 0 : me.outerRadius;
			var valueAtIndexOrDefault = helpers.valueAtIndexOrDefault;

			helpers.extend(arc, {
				// Utility
				_datasetIndex: me.index,
				_index: index,

				// Desired view properties
				_model: {
					x: centerX + chart.offsetX,
					y: centerY + chart.offsetY,
					startAngle: startAngle,
					endAngle: endAngle,
					circumference: circumference,
					outerRadius: outerRadius,
					innerRadius: innerRadius,
					label: valueAtIndexOrDefault(dataset.label, index, chart.data.labels[index])
				}
			});

			var model = arc._model;
			// Resets the visual styles
			this.removeHoverStyle(arc);

			// Set correct angles if not resetting
			if (!reset || !animationOpts.animateRotate) {
				if (index === 0) {
					model.startAngle = opts.rotation;
				} else {
					model.startAngle = me.getMeta().data[index - 1]._model.endAngle;
				}

				model.endAngle = model.startAngle + model.circumference;
			}

			arc.pivot();
		},

		removeHoverStyle: function(arc) {
			Chart.DatasetController.prototype.removeHoverStyle.call(this, arc, this.chart.options.elements.arc);
		},

		calculateTotal: function() {
			var dataset = this.getDataset();
			var meta = this.getMeta();
			var total = 0;
			var value;

			helpers.each(meta.data, function(element, index) {
				value = dataset.data[index];
				if (!isNaN(value) && !element.hidden) {
					total += Math.abs(value);
				}
			});

			/* if (total === 0) {
				total = NaN;
			}*/

			return total;
		},

		calculateCircumference: function(value) {
			var total = this.getMeta().total;
			if (total > 0 && !isNaN(value)) {
				return (Math.PI * 2.0) * (Math.abs(value) / total);
			}
			return 0;
		},

		// gets the max border or hover width to properly scale pie charts
		getMaxBorderWidth: function(arcs) {
			var max = 0;
			var index = this.index;
			var length = arcs.length;
			var borderWidth;
			var hoverWidth;

			for (var i = 0; i < length; i++) {
				borderWidth = arcs[i]._model ? arcs[i]._model.borderWidth : 0;
				hoverWidth = arcs[i]._chart ? arcs[i]._chart.config.data.datasets[index].hoverBorderWidth : 0;

				max = borderWidth > max ? borderWidth : max;
				max = hoverWidth > max ? hoverWidth : max;
			}
			return max;
		}
	});
};


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(2);
var elements = __webpack_require__(13);
var helpers = __webpack_require__(1);

defaults._set('line', {
	showLines: true,
	spanGaps: false,

	hover: {
		mode: 'label'
	},

	scales: {
		xAxes: [{
			type: 'category',
			id: 'x-axis-0'
		}],
		yAxes: [{
			type: 'linear',
			id: 'y-axis-0'
		}]
	}
});

module.exports = function(Chart) {

	function lineEnabled(dataset, options) {
		return helpers.valueOrDefault(dataset.showLine, options.showLines);
	}

	Chart.controllers.line = Chart.DatasetController.extend({

		datasetElementType: elements.Line,

		dataElementType: elements.Point,

		update: function(reset) {
			var me = this;
			var meta = me.getMeta();
			var line = meta.dataset;
			var points = meta.data || [];
			var options = me.chart.options;
			var lineElementOptions = options.elements.line;
			var scale = me.getScaleForId(meta.yAxisID);
			var i, ilen, custom;
			var dataset = me.getDataset();
			var showLine = lineEnabled(dataset, options);

			// Update Line
			if (showLine) {
				custom = line.custom || {};

				// Compatibility: If the properties are defined with only the old name, use those values
				if ((dataset.tension !== undefined) && (dataset.lineTension === undefined)) {
					dataset.lineTension = dataset.tension;
				}

				// Utility
				line._scale = scale;
				line._datasetIndex = me.index;
				// Data
				line._children = points;
				// Model
				line._model = {
					// Appearance
					// The default behavior of lines is to break at null values, according
					// to https://github.com/chartjs/Chart.js/issues/2435#issuecomment-216718158
					// This option gives lines the ability to span gaps
					spanGaps: dataset.spanGaps ? dataset.spanGaps : options.spanGaps,
					tension: custom.tension ? custom.tension : helpers.valueOrDefault(dataset.lineTension, lineElementOptions.tension),
					backgroundColor: custom.backgroundColor ? custom.backgroundColor : (dataset.backgroundColor || lineElementOptions.backgroundColor),
					borderWidth: custom.borderWidth ? custom.borderWidth : (dataset.borderWidth || lineElementOptions.borderWidth),
					borderColor: custom.borderColor ? custom.borderColor : (dataset.borderColor || lineElementOptions.borderColor),
					borderCapStyle: custom.borderCapStyle ? custom.borderCapStyle : (dataset.borderCapStyle || lineElementOptions.borderCapStyle),
					borderDash: custom.borderDash ? custom.borderDash : (dataset.borderDash || lineElementOptions.borderDash),
					borderDashOffset: custom.borderDashOffset ? custom.borderDashOffset : (dataset.borderDashOffset || lineElementOptions.borderDashOffset),
					borderJoinStyle: custom.borderJoinStyle ? custom.borderJoinStyle : (dataset.borderJoinStyle || lineElementOptions.borderJoinStyle),
					fill: custom.fill ? custom.fill : (dataset.fill !== undefined ? dataset.fill : lineElementOptions.fill),
					steppedLine: custom.steppedLine ? custom.steppedLine : helpers.valueOrDefault(dataset.steppedLine, lineElementOptions.stepped),
					cubicInterpolationMode: custom.cubicInterpolationMode ? custom.cubicInterpolationMode : helpers.valueOrDefault(dataset.cubicInterpolationMode, lineElementOptions.cubicInterpolationMode),
				};

				line.pivot();
			}

			// Update Points
			for (i = 0, ilen = points.length; i < ilen; ++i) {
				me.updateElement(points[i], i, reset);
			}

			if (showLine && line._model.tension !== 0) {
				me.updateBezierControlPoints();
			}

			// Now pivot the point for animation
			for (i = 0, ilen = points.length; i < ilen; ++i) {
				points[i].pivot();
			}
		},

		getPointBackgroundColor: function(point, index) {
			var backgroundColor = this.chart.options.elements.point.backgroundColor;
			var dataset = this.getDataset();
			var custom = point.custom || {};

			if (custom.backgroundColor) {
				backgroundColor = custom.backgroundColor;
			} else if (dataset.pointBackgroundColor) {
				backgroundColor = helpers.valueAtIndexOrDefault(dataset.pointBackgroundColor, index, backgroundColor);
			} else if (dataset.backgroundColor) {
				backgroundColor = dataset.backgroundColor;
			}

			return backgroundColor;
		},

		getPointBorderColor: function(point, index) {
			var borderColor = this.chart.options.elements.point.borderColor;
			var dataset = this.getDataset();
			var custom = point.custom || {};

			if (custom.borderColor) {
				borderColor = custom.borderColor;
			} else if (dataset.pointBorderColor) {
				borderColor = helpers.valueAtIndexOrDefault(dataset.pointBorderColor, index, borderColor);
			} else if (dataset.borderColor) {
				borderColor = dataset.borderColor;
			}

			return borderColor;
		},

		getPointBorderWidth: function(point, index) {
			var borderWidth = this.chart.options.elements.point.borderWidth;
			var dataset = this.getDataset();
			var custom = point.custom || {};

			if (!isNaN(custom.borderWidth)) {
				borderWidth = custom.borderWidth;
			} else if (!isNaN(dataset.pointBorderWidth) || helpers.isArray(dataset.pointBorderWidth)) {
				borderWidth = helpers.valueAtIndexOrDefault(dataset.pointBorderWidth, index, borderWidth);
			} else if (!isNaN(dataset.borderWidth)) {
				borderWidth = dataset.borderWidth;
			}

			return borderWidth;
		},

		updateElement: function(point, index, reset) {
			var me = this;
			var meta = me.getMeta();
			var custom = point.custom || {};
			var dataset = me.getDataset();
			var datasetIndex = me.index;
			var value = dataset.data[index];
			var yScale = me.getScaleForId(meta.yAxisID);
			var xScale = me.getScaleForId(meta.xAxisID);
			var pointOptions = me.chart.options.elements.point;
			var x, y;

			// Compatibility: If the properties are defined with only the old name, use those values
			if ((dataset.radius !== undefined) && (dataset.pointRadius === undefined)) {
				dataset.pointRadius = dataset.radius;
			}
			if ((dataset.hitRadius !== undefined) && (dataset.pointHitRadius === undefined)) {
				dataset.pointHitRadius = dataset.hitRadius;
			}

			x = xScale.getPixelForValue(typeof value === 'object' ? value : NaN, index, datasetIndex);
			y = reset ? yScale.getBasePixel() : me.calculatePointY(value, index, datasetIndex);

			// Utility
			point._xScale = xScale;
			point._yScale = yScale;
			point._datasetIndex = datasetIndex;
			point._index = index;

			// Desired view properties
			point._model = {
				x: x,
				y: y,
				skip: custom.skip || isNaN(x) || isNaN(y),
				// Appearance
				radius: custom.radius || helpers.valueAtIndexOrDefault(dataset.pointRadius, index, pointOptions.radius),
				pointStyle: custom.pointStyle || helpers.valueAtIndexOrDefault(dataset.pointStyle, index, pointOptions.pointStyle),
				backgroundColor: me.getPointBackgroundColor(point, index),
				borderColor: me.getPointBorderColor(point, index),
				borderWidth: me.getPointBorderWidth(point, index),
				tension: meta.dataset._model ? meta.dataset._model.tension : 0,
				steppedLine: meta.dataset._model ? meta.dataset._model.steppedLine : false,
				// Tooltip
				hitRadius: custom.hitRadius || helpers.valueAtIndexOrDefault(dataset.pointHitRadius, index, pointOptions.hitRadius)
			};
		},

		calculatePointY: function(value, index, datasetIndex) {
			var me = this;
			var chart = me.chart;
			var meta = me.getMeta();
			var yScale = me.getScaleForId(meta.yAxisID);
			var sumPos = 0;
			var sumNeg = 0;
			var i, ds, dsMeta;

			if (yScale.options.stacked) {
				for (i = 0; i < datasetIndex; i++) {
					ds = chart.data.datasets[i];
					dsMeta = chart.getDatasetMeta(i);
					if (dsMeta.type === 'line' && dsMeta.yAxisID === yScale.id && chart.isDatasetVisible(i)) {
						var stackedRightValue = Number(yScale.getRightValue(ds.data[index]));
						if (stackedRightValue < 0) {
							sumNeg += stackedRightValue || 0;
						} else {
							sumPos += stackedRightValue || 0;
						}
					}
				}

				var rightValue = Number(yScale.getRightValue(value));
				if (rightValue < 0) {
					return yScale.getPixelForValue(sumNeg + rightValue);
				}
				return yScale.getPixelForValue(sumPos + rightValue);
			}

			return yScale.getPixelForValue(value);
		},

		updateBezierControlPoints: function() {
			var me = this;
			var meta = me.getMeta();
			var area = me.chart.chartArea;
			var points = (meta.data || []);
			var i, ilen, point, model, controlPoints;

			// Only consider points that are drawn in case the spanGaps option is used
			if (meta.dataset._model.spanGaps) {
				points = points.filter(function(pt) {
					return !pt._model.skip;
				});
			}

			function capControlPoint(pt, min, max) {
				return Math.max(Math.min(pt, max), min);
			}

			if (meta.dataset._model.cubicInterpolationMode === 'monotone') {
				helpers.splineCurveMonotone(points);
			} else {
				for (i = 0, ilen = points.length; i < ilen; ++i) {
					point = points[i];
					model = point._model;
					controlPoints = helpers.splineCurve(
						helpers.previousItem(points, i)._model,
						model,
						helpers.nextItem(points, i)._model,
						meta.dataset._model.tension
					);
					model.controlPointPreviousX = controlPoints.previous.x;
					model.controlPointPreviousY = controlPoints.previous.y;
					model.controlPointNextX = controlPoints.next.x;
					model.controlPointNextY = controlPoints.next.y;
				}
			}

			if (me.chart.options.elements.line.capBezierPoints) {
				for (i = 0, ilen = points.length; i < ilen; ++i) {
					model = points[i]._model;
					model.controlPointPreviousX = capControlPoint(model.controlPointPreviousX, area.left, area.right);
					model.controlPointPreviousY = capControlPoint(model.controlPointPreviousY, area.top, area.bottom);
					model.controlPointNextX = capControlPoint(model.controlPointNextX, area.left, area.right);
					model.controlPointNextY = capControlPoint(model.controlPointNextY, area.top, area.bottom);
				}
			}
		},

		draw: function() {
			var me = this;
			var chart = me.chart;
			var meta = me.getMeta();
			var points = meta.data || [];
			var area = chart.chartArea;
			var ilen = points.length;
			var i = 0;

			helpers.canvas.clipArea(chart.ctx, area);

			if (lineEnabled(me.getDataset(), chart.options)) {
				meta.dataset.draw();
			}

			helpers.canvas.unclipArea(chart.ctx);

			// Draw the points
			for (; i < ilen; ++i) {
				points[i].draw(area);
			}
		},

		setHoverStyle: function(point) {
			// Point
			var dataset = this.chart.data.datasets[point._datasetIndex];
			var index = point._index;
			var custom = point.custom || {};
			var model = point._model;

			model.radius = custom.hoverRadius || helpers.valueAtIndexOrDefault(dataset.pointHoverRadius, index, this.chart.options.elements.point.hoverRadius);
			model.backgroundColor = custom.hoverBackgroundColor || helpers.valueAtIndexOrDefault(dataset.pointHoverBackgroundColor, index, helpers.getHoverColor(model.backgroundColor));
			model.borderColor = custom.hoverBorderColor || helpers.valueAtIndexOrDefault(dataset.pointHoverBorderColor, index, helpers.getHoverColor(model.borderColor));
			model.borderWidth = custom.hoverBorderWidth || helpers.valueAtIndexOrDefault(dataset.pointHoverBorderWidth, index, model.borderWidth);
		},

		removeHoverStyle: function(point) {
			var me = this;
			var dataset = me.chart.data.datasets[point._datasetIndex];
			var index = point._index;
			var custom = point.custom || {};
			var model = point._model;

			// Compatibility: If the properties are defined with only the old name, use those values
			if ((dataset.radius !== undefined) && (dataset.pointRadius === undefined)) {
				dataset.pointRadius = dataset.radius;
			}

			model.radius = custom.radius || helpers.valueAtIndexOrDefault(dataset.pointRadius, index, me.chart.options.elements.point.radius);
			model.backgroundColor = me.getPointBackgroundColor(point, index);
			model.borderColor = me.getPointBorderColor(point, index);
			model.borderWidth = me.getPointBorderWidth(point, index);
		}
	});
};


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(2);
var elements = __webpack_require__(13);
var helpers = __webpack_require__(1);

defaults._set('polarArea', {
	scale: {
		type: 'radialLinear',
		angleLines: {
			display: false
		},
		gridLines: {
			circular: true
		},
		pointLabels: {
			display: false
		},
		ticks: {
			beginAtZero: true
		}
	},

	// Boolean - Whether to animate the rotation of the chart
	animation: {
		animateRotate: true,
		animateScale: true
	},

	startAngle: -0.5 * Math.PI,
	legendCallback: function(chart) {
		var text = [];
		text.push('<ul class="' + chart.id + '-legend">');

		var data = chart.data;
		var datasets = data.datasets;
		var labels = data.labels;

		if (datasets.length) {
			for (var i = 0; i < datasets[0].data.length; ++i) {
				text.push('<li><span style="background-color:' + datasets[0].backgroundColor[i] + '"></span>');
				if (labels[i]) {
					text.push(labels[i]);
				}
				text.push('</li>');
			}
		}

		text.push('</ul>');
		return text.join('');
	},
	legend: {
		labels: {
			generateLabels: function(chart) {
				var data = chart.data;
				if (data.labels.length && data.datasets.length) {
					return data.labels.map(function(label, i) {
						var meta = chart.getDatasetMeta(0);
						var ds = data.datasets[0];
						var arc = meta.data[i];
						var custom = arc.custom || {};
						var valueAtIndexOrDefault = helpers.valueAtIndexOrDefault;
						var arcOpts = chart.options.elements.arc;
						var fill = custom.backgroundColor ? custom.backgroundColor : valueAtIndexOrDefault(ds.backgroundColor, i, arcOpts.backgroundColor);
						var stroke = custom.borderColor ? custom.borderColor : valueAtIndexOrDefault(ds.borderColor, i, arcOpts.borderColor);
						var bw = custom.borderWidth ? custom.borderWidth : valueAtIndexOrDefault(ds.borderWidth, i, arcOpts.borderWidth);

						return {
							text: label,
							fillStyle: fill,
							strokeStyle: stroke,
							lineWidth: bw,
							hidden: isNaN(ds.data[i]) || meta.data[i].hidden,

							// Extra data used for toggling the correct item
							index: i
						};
					});
				}
				return [];
			}
		},

		onClick: function(e, legendItem) {
			var index = legendItem.index;
			var chart = this.chart;
			var i, ilen, meta;

			for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
				meta = chart.getDatasetMeta(i);
				meta.data[index].hidden = !meta.data[index].hidden;
			}

			chart.update();
		}
	},

	// Need to override these to give a nice default
	tooltips: {
		callbacks: {
			title: function() {
				return '';
			},
			label: function(item, data) {
				return data.labels[item.index] + ': ' + item.yLabel;
			}
		}
	}
});

module.exports = function(Chart) {

	Chart.controllers.polarArea = Chart.DatasetController.extend({

		dataElementType: elements.Arc,

		linkScales: helpers.noop,

		update: function(reset) {
			var me = this;
			var chart = me.chart;
			var chartArea = chart.chartArea;
			var meta = me.getMeta();
			var opts = chart.options;
			var arcOpts = opts.elements.arc;
			var minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
			chart.outerRadius = Math.max((minSize - arcOpts.borderWidth / 2) / 2, 0);
			chart.innerRadius = Math.max(opts.cutoutPercentage ? (chart.outerRadius / 100) * (opts.cutoutPercentage) : 1, 0);
			chart.radiusLength = (chart.outerRadius - chart.innerRadius) / chart.getVisibleDatasetCount();

			me.outerRadius = chart.outerRadius - (chart.radiusLength * me.index);
			me.innerRadius = me.outerRadius - chart.radiusLength;

			meta.count = me.countVisibleElements();

			helpers.each(meta.data, function(arc, index) {
				me.updateElement(arc, index, reset);
			});
		},

		updateElement: function(arc, index, reset) {
			var me = this;
			var chart = me.chart;
			var dataset = me.getDataset();
			var opts = chart.options;
			var animationOpts = opts.animation;
			var scale = chart.scale;
			var labels = chart.data.labels;

			var circumference = me.calculateCircumference(dataset.data[index]);
			var centerX = scale.xCenter;
			var centerY = scale.yCenter;

			// If there is NaN data before us, we need to calculate the starting angle correctly.
			// We could be way more efficient here, but its unlikely that the polar area chart will have a lot of data
			var visibleCount = 0;
			var meta = me.getMeta();
			for (var i = 0; i < index; ++i) {
				if (!isNaN(dataset.data[i]) && !meta.data[i].hidden) {
					++visibleCount;
				}
			}

			// var negHalfPI = -0.5 * Math.PI;
			var datasetStartAngle = opts.startAngle;
			var distance = arc.hidden ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
			var startAngle = datasetStartAngle + (circumference * visibleCount);
			var endAngle = startAngle + (arc.hidden ? 0 : circumference);

			var resetRadius = animationOpts.animateScale ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);

			helpers.extend(arc, {
				// Utility
				_datasetIndex: me.index,
				_index: index,
				_scale: scale,

				// Desired view properties
				_model: {
					x: centerX,
					y: centerY,
					innerRadius: 0,
					outerRadius: reset ? resetRadius : distance,
					startAngle: reset && animationOpts.animateRotate ? datasetStartAngle : startAngle,
					endAngle: reset && animationOpts.animateRotate ? datasetStartAngle : endAngle,
					label: helpers.valueAtIndexOrDefault(labels, index, labels[index])
				}
			});

			// Apply border and fill style
			me.removeHoverStyle(arc);

			arc.pivot();
		},

		removeHoverStyle: function(arc) {
			Chart.DatasetController.prototype.removeHoverStyle.call(this, arc, this.chart.options.elements.arc);
		},

		countVisibleElements: function() {
			var dataset = this.getDataset();
			var meta = this.getMeta();
			var count = 0;

			helpers.each(meta.data, function(element, index) {
				if (!isNaN(dataset.data[index]) && !element.hidden) {
					count++;
				}
			});

			return count;
		},

		calculateCircumference: function(value) {
			var count = this.getMeta().count;
			if (count > 0 && !isNaN(value)) {
				return (2 * Math.PI) / count;
			}
			return 0;
		}
	});
};


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(2);
var elements = __webpack_require__(13);
var helpers = __webpack_require__(1);

defaults._set('radar', {
	scale: {
		type: 'radialLinear'
	},
	elements: {
		line: {
			tension: 0 // no bezier in radar
		}
	}
});

module.exports = function(Chart) {

	Chart.controllers.radar = Chart.DatasetController.extend({

		datasetElementType: elements.Line,

		dataElementType: elements.Point,

		linkScales: helpers.noop,

		update: function(reset) {
			var me = this;
			var meta = me.getMeta();
			var line = meta.dataset;
			var points = meta.data;
			var custom = line.custom || {};
			var dataset = me.getDataset();
			var lineElementOptions = me.chart.options.elements.line;
			var scale = me.chart.scale;

			// Compatibility: If the properties are defined with only the old name, use those values
			if ((dataset.tension !== undefined) && (dataset.lineTension === undefined)) {
				dataset.lineTension = dataset.tension;
			}

			helpers.extend(meta.dataset, {
				// Utility
				_datasetIndex: me.index,
				_scale: scale,
				// Data
				_children: points,
				_loop: true,
				// Model
				_model: {
					// Appearance
					tension: custom.tension ? custom.tension : helpers.valueOrDefault(dataset.lineTension, lineElementOptions.tension),
					backgroundColor: custom.backgroundColor ? custom.backgroundColor : (dataset.backgroundColor || lineElementOptions.backgroundColor),
					borderWidth: custom.borderWidth ? custom.borderWidth : (dataset.borderWidth || lineElementOptions.borderWidth),
					borderColor: custom.borderColor ? custom.borderColor : (dataset.borderColor || lineElementOptions.borderColor),
					fill: custom.fill ? custom.fill : (dataset.fill !== undefined ? dataset.fill : lineElementOptions.fill),
					borderCapStyle: custom.borderCapStyle ? custom.borderCapStyle : (dataset.borderCapStyle || lineElementOptions.borderCapStyle),
					borderDash: custom.borderDash ? custom.borderDash : (dataset.borderDash || lineElementOptions.borderDash),
					borderDashOffset: custom.borderDashOffset ? custom.borderDashOffset : (dataset.borderDashOffset || lineElementOptions.borderDashOffset),
					borderJoinStyle: custom.borderJoinStyle ? custom.borderJoinStyle : (dataset.borderJoinStyle || lineElementOptions.borderJoinStyle),
				}
			});

			meta.dataset.pivot();

			// Update Points
			helpers.each(points, function(point, index) {
				me.updateElement(point, index, reset);
			}, me);

			// Update bezier control points
			me.updateBezierControlPoints();
		},
		updateElement: function(point, index, reset) {
			var me = this;
			var custom = point.custom || {};
			var dataset = me.getDataset();
			var scale = me.chart.scale;
			var pointElementOptions = me.chart.options.elements.point;
			var pointPosition = scale.getPointPositionForValue(index, dataset.data[index]);

			// Compatibility: If the properties are defined with only the old name, use those values
			if ((dataset.radius !== undefined) && (dataset.pointRadius === undefined)) {
				dataset.pointRadius = dataset.radius;
			}
			if ((dataset.hitRadius !== undefined) && (dataset.pointHitRadius === undefined)) {
				dataset.pointHitRadius = dataset.hitRadius;
			}

			helpers.extend(point, {
				// Utility
				_datasetIndex: me.index,
				_index: index,
				_scale: scale,

				// Desired view properties
				_model: {
					x: reset ? scale.xCenter : pointPosition.x, // value not used in dataset scale, but we want a consistent API between scales
					y: reset ? scale.yCenter : pointPosition.y,

					// Appearance
					tension: custom.tension ? custom.tension : helpers.valueOrDefault(dataset.lineTension, me.chart.options.elements.line.tension),
					radius: custom.radius ? custom.radius : helpers.valueAtIndexOrDefault(dataset.pointRadius, index, pointElementOptions.radius),
					backgroundColor: custom.backgroundColor ? custom.backgroundColor : helpers.valueAtIndexOrDefault(dataset.pointBackgroundColor, index, pointElementOptions.backgroundColor),
					borderColor: custom.borderColor ? custom.borderColor : helpers.valueAtIndexOrDefault(dataset.pointBorderColor, index, pointElementOptions.borderColor),
					borderWidth: custom.borderWidth ? custom.borderWidth : helpers.valueAtIndexOrDefault(dataset.pointBorderWidth, index, pointElementOptions.borderWidth),
					pointStyle: custom.pointStyle ? custom.pointStyle : helpers.valueAtIndexOrDefault(dataset.pointStyle, index, pointElementOptions.pointStyle),

					// Tooltip
					hitRadius: custom.hitRadius ? custom.hitRadius : helpers.valueAtIndexOrDefault(dataset.pointHitRadius, index, pointElementOptions.hitRadius)
				}
			});

			point._model.skip = custom.skip ? custom.skip : (isNaN(point._model.x) || isNaN(point._model.y));
		},
		updateBezierControlPoints: function() {
			var chartArea = this.chart.chartArea;
			var meta = this.getMeta();

			helpers.each(meta.data, function(point, index) {
				var model = point._model;
				var controlPoints = helpers.splineCurve(
					helpers.previousItem(meta.data, index, true)._model,
					model,
					helpers.nextItem(meta.data, index, true)._model,
					model.tension
				);

				// Prevent the bezier going outside of the bounds of the graph
				model.controlPointPreviousX = Math.max(Math.min(controlPoints.previous.x, chartArea.right), chartArea.left);
				model.controlPointPreviousY = Math.max(Math.min(controlPoints.previous.y, chartArea.bottom), chartArea.top);

				model.controlPointNextX = Math.max(Math.min(controlPoints.next.x, chartArea.right), chartArea.left);
				model.controlPointNextY = Math.max(Math.min(controlPoints.next.y, chartArea.bottom), chartArea.top);

				// Now pivot the point for animation
				point.pivot();
			});
		},

		setHoverStyle: function(point) {
			// Point
			var dataset = this.chart.data.datasets[point._datasetIndex];
			var custom = point.custom || {};
			var index = point._index;
			var model = point._model;

			model.radius = custom.hoverRadius ? custom.hoverRadius : helpers.valueAtIndexOrDefault(dataset.pointHoverRadius, index, this.chart.options.elements.point.hoverRadius);
			model.backgroundColor = custom.hoverBackgroundColor ? custom.hoverBackgroundColor : helpers.valueAtIndexOrDefault(dataset.pointHoverBackgroundColor, index, helpers.getHoverColor(model.backgroundColor));
			model.borderColor = custom.hoverBorderColor ? custom.hoverBorderColor : helpers.valueAtIndexOrDefault(dataset.pointHoverBorderColor, index, helpers.getHoverColor(model.borderColor));
			model.borderWidth = custom.hoverBorderWidth ? custom.hoverBorderWidth : helpers.valueAtIndexOrDefault(dataset.pointHoverBorderWidth, index, model.borderWidth);
		},

		removeHoverStyle: function(point) {
			var dataset = this.chart.data.datasets[point._datasetIndex];
			var custom = point.custom || {};
			var index = point._index;
			var model = point._model;
			var pointElementOptions = this.chart.options.elements.point;

			model.radius = custom.radius ? custom.radius : helpers.valueAtIndexOrDefault(dataset.pointRadius, index, pointElementOptions.radius);
			model.backgroundColor = custom.backgroundColor ? custom.backgroundColor : helpers.valueAtIndexOrDefault(dataset.pointBackgroundColor, index, pointElementOptions.backgroundColor);
			model.borderColor = custom.borderColor ? custom.borderColor : helpers.valueAtIndexOrDefault(dataset.pointBorderColor, index, pointElementOptions.borderColor);
			model.borderWidth = custom.borderWidth ? custom.borderWidth : helpers.valueAtIndexOrDefault(dataset.pointBorderWidth, index, pointElementOptions.borderWidth);
		}
	});
};


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(2);

defaults._set('scatter', {
	hover: {
		mode: 'single'
	},

	scales: {
		xAxes: [{
			id: 'x-axis-1',    // need an ID so datasets can reference the scale
			type: 'linear',    // scatter should not use a category axis
			position: 'bottom'
		}],
		yAxes: [{
			id: 'y-axis-1',
			type: 'linear',
			position: 'left'
		}]
	},

	showLines: false,

	tooltips: {
		callbacks: {
			title: function() {
				return '';     // doesn't make sense for scatter since data are formatted as a point
			},
			label: function(item) {
				return '(' + item.xLabel + ', ' + item.yLabel + ')';
			}
		}
	}
});

module.exports = function(Chart) {

	// Scatter charts use line controllers
	Chart.controllers.scatter = Chart.controllers.line;

};


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function(Chart) {

	Chart.Bar = function(context, config) {
		config.type = 'bar';

		return new Chart(context, config);
	};

};


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function(Chart) {

	Chart.Bubble = function(context, config) {
		config.type = 'bubble';
		return new Chart(context, config);
	};

};


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function(Chart) {

	Chart.Doughnut = function(context, config) {
		config.type = 'doughnut';

		return new Chart(context, config);
	};

};


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function(Chart) {

	Chart.Line = function(context, config) {
		config.type = 'line';

		return new Chart(context, config);
	};

};


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function(Chart) {

	Chart.PolarArea = function(context, config) {
		config.type = 'polarArea';

		return new Chart(context, config);
	};

};


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function(Chart) {

	Chart.Radar = function(context, config) {
		config.type = 'radar';

		return new Chart(context, config);
	};

};


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function(Chart) {
	Chart.Scatter = function(context, config) {
		config.type = 'scatter';
		return new Chart(context, config);
	};
};


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {};
module.exports.filler = __webpack_require__(234);
module.exports.legend = __webpack_require__(235);
module.exports.title = __webpack_require__(236);


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Plugin based on discussion from the following Chart.js issues:
 * @see https://github.com/chartjs/Chart.js/issues/2380#issuecomment-279961569
 * @see https://github.com/chartjs/Chart.js/issues/2440#issuecomment-256461897
 */



var defaults = __webpack_require__(2);
var elements = __webpack_require__(13);
var helpers = __webpack_require__(1);

defaults._set('global', {
	plugins: {
		filler: {
			propagate: true
		}
	}
});

var mappers = {
	dataset: function(source) {
		var index = source.fill;
		var chart = source.chart;
		var meta = chart.getDatasetMeta(index);
		var visible = meta && chart.isDatasetVisible(index);
		var points = (visible && meta.dataset._children) || [];
		var length = points.length || 0;

		return !length ? null : function(point, i) {
			return (i < length && points[i]._view) || null;
		};
	},

	boundary: function(source) {
		var boundary = source.boundary;
		var x = boundary ? boundary.x : null;
		var y = boundary ? boundary.y : null;

		return function(point) {
			return {
				x: x === null ? point.x : x,
				y: y === null ? point.y : y,
			};
		};
	}
};

// @todo if (fill[0] === '#')
function decodeFill(el, index, count) {
	var model = el._model || {};
	var fill = model.fill;
	var target;

	if (fill === undefined) {
		fill = !!model.backgroundColor;
	}

	if (fill === false || fill === null) {
		return false;
	}

	if (fill === true) {
		return 'origin';
	}

	target = parseFloat(fill, 10);
	if (isFinite(target) && Math.floor(target) === target) {
		if (fill[0] === '-' || fill[0] === '+') {
			target = index + target;
		}

		if (target === index || target < 0 || target >= count) {
			return false;
		}

		return target;
	}

	switch (fill) {
	// compatibility
	case 'bottom':
		return 'start';
	case 'top':
		return 'end';
	case 'zero':
		return 'origin';
	// supported boundaries
	case 'origin':
	case 'start':
	case 'end':
		return fill;
	// invalid fill values
	default:
		return false;
	}
}

function computeBoundary(source) {
	var model = source.el._model || {};
	var scale = source.el._scale || {};
	var fill = source.fill;
	var target = null;
	var horizontal;

	if (isFinite(fill)) {
		return null;
	}

	// Backward compatibility: until v3, we still need to support boundary values set on
	// the model (scaleTop, scaleBottom and scaleZero) because some external plugins and
	// controllers might still use it (e.g. the Smith chart).

	if (fill === 'start') {
		target = model.scaleBottom === undefined ? scale.bottom : model.scaleBottom;
	} else if (fill === 'end') {
		target = model.scaleTop === undefined ? scale.top : model.scaleTop;
	} else if (model.scaleZero !== undefined) {
		target = model.scaleZero;
	} else if (scale.getBasePosition) {
		target = scale.getBasePosition();
	} else if (scale.getBasePixel) {
		target = scale.getBasePixel();
	}

	if (target !== undefined && target !== null) {
		if (target.x !== undefined && target.y !== undefined) {
			return target;
		}

		if (typeof target === 'number' && isFinite(target)) {
			horizontal = scale.isHorizontal();
			return {
				x: horizontal ? target : null,
				y: horizontal ? null : target
			};
		}
	}

	return null;
}

function resolveTarget(sources, index, propagate) {
	var source = sources[index];
	var fill = source.fill;
	var visited = [index];
	var target;

	if (!propagate) {
		return fill;
	}

	while (fill !== false && visited.indexOf(fill) === -1) {
		if (!isFinite(fill)) {
			return fill;
		}

		target = sources[fill];
		if (!target) {
			return false;
		}

		if (target.visible) {
			return fill;
		}

		visited.push(fill);
		fill = target.fill;
	}

	return false;
}

function createMapper(source) {
	var fill = source.fill;
	var type = 'dataset';

	if (fill === false) {
		return null;
	}

	if (!isFinite(fill)) {
		type = 'boundary';
	}

	return mappers[type](source);
}

function isDrawable(point) {
	return point && !point.skip;
}

function drawArea(ctx, curve0, curve1, len0, len1) {
	var i;

	if (!len0 || !len1) {
		return;
	}

	// building first area curve (normal)
	ctx.moveTo(curve0[0].x, curve0[0].y);
	for (i = 1; i < len0; ++i) {
		helpers.canvas.lineTo(ctx, curve0[i - 1], curve0[i]);
	}

	// joining the two area curves
	ctx.lineTo(curve1[len1 - 1].x, curve1[len1 - 1].y);

	// building opposite area curve (reverse)
	for (i = len1 - 1; i > 0; --i) {
		helpers.canvas.lineTo(ctx, curve1[i], curve1[i - 1], true);
	}
}

function doFill(ctx, points, mapper, view, color, loop) {
	var count = points.length;
	var span = view.spanGaps;
	var curve0 = [];
	var curve1 = [];
	var len0 = 0;
	var len1 = 0;
	var i, ilen, index, p0, p1, d0, d1;

	ctx.beginPath();

	for (i = 0, ilen = (count + !!loop); i < ilen; ++i) {
		index = i % count;
		p0 = points[index]._view;
		p1 = mapper(p0, index, view);
		d0 = isDrawable(p0);
		d1 = isDrawable(p1);

		if (d0 && d1) {
			len0 = curve0.push(p0);
			len1 = curve1.push(p1);
		} else if (len0 && len1) {
			if (!span) {
				drawArea(ctx, curve0, curve1, len0, len1);
				len0 = len1 = 0;
				curve0 = [];
				curve1 = [];
			} else {
				if (d0) {
					curve0.push(p0);
				}
				if (d1) {
					curve1.push(p1);
				}
			}
		}
	}

	drawArea(ctx, curve0, curve1, len0, len1);

	ctx.closePath();
	ctx.fillStyle = color;
	ctx.fill();
}

module.exports = {
	id: 'filler',

	afterDatasetsUpdate: function(chart, options) {
		var count = (chart.data.datasets || []).length;
		var propagate = options.propagate;
		var sources = [];
		var meta, i, el, source;

		for (i = 0; i < count; ++i) {
			meta = chart.getDatasetMeta(i);
			el = meta.dataset;
			source = null;

			if (el && el._model && el instanceof elements.Line) {
				source = {
					visible: chart.isDatasetVisible(i),
					fill: decodeFill(el, i, count),
					chart: chart,
					el: el
				};
			}

			meta.$filler = source;
			sources.push(source);
		}

		for (i = 0; i < count; ++i) {
			source = sources[i];
			if (!source) {
				continue;
			}

			source.fill = resolveTarget(sources, i, propagate);
			source.boundary = computeBoundary(source);
			source.mapper = createMapper(source);
		}
	},

	beforeDatasetDraw: function(chart, args) {
		var meta = args.meta.$filler;
		if (!meta) {
			return;
		}

		var ctx = chart.ctx;
		var el = meta.el;
		var view = el._view;
		var points = el._children || [];
		var mapper = meta.mapper;
		var color = view.backgroundColor || defaults.global.defaultColor;

		if (mapper && color && points.length) {
			helpers.canvas.clipArea(ctx, chart.chartArea);
			doFill(ctx, points, mapper, view, color, el._loop);
			helpers.canvas.unclipArea(ctx);
		}
	}
};


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(2);
var Element = __webpack_require__(8);
var helpers = __webpack_require__(1);
var layouts = __webpack_require__(21);

var noop = helpers.noop;

defaults._set('global', {
	legend: {
		display: true,
		position: 'top',
		fullWidth: true,
		reverse: false,
		weight: 1000,

		// a callback that will handle
		onClick: function(e, legendItem) {
			var index = legendItem.datasetIndex;
			var ci = this.chart;
			var meta = ci.getDatasetMeta(index);

			// See controller.isDatasetVisible comment
			meta.hidden = meta.hidden === null ? !ci.data.datasets[index].hidden : null;

			// We hid a dataset ... rerender the chart
			ci.update();
		},

		onHover: null,

		labels: {
			boxWidth: 40,
			padding: 10,
			// Generates labels shown in the legend
			// Valid properties to return:
			// text : text to display
			// fillStyle : fill of coloured box
			// strokeStyle: stroke of coloured box
			// hidden : if this legend item refers to a hidden item
			// lineCap : cap style for line
			// lineDash
			// lineDashOffset :
			// lineJoin :
			// lineWidth :
			generateLabels: function(chart) {
				var data = chart.data;
				return helpers.isArray(data.datasets) ? data.datasets.map(function(dataset, i) {
					return {
						text: dataset.label,
						fillStyle: (!helpers.isArray(dataset.backgroundColor) ? dataset.backgroundColor : dataset.backgroundColor[0]),
						hidden: !chart.isDatasetVisible(i),
						lineCap: dataset.borderCapStyle,
						lineDash: dataset.borderDash,
						lineDashOffset: dataset.borderDashOffset,
						lineJoin: dataset.borderJoinStyle,
						lineWidth: dataset.borderWidth,
						strokeStyle: dataset.borderColor,
						pointStyle: dataset.pointStyle,

						// Below is extra data used for toggling the datasets
						datasetIndex: i
					};
				}, this) : [];
			}
		}
	},

	legendCallback: function(chart) {
		var text = [];
		text.push('<ul class="' + chart.id + '-legend">');
		for (var i = 0; i < chart.data.datasets.length; i++) {
			text.push('<li><span style="background-color:' + chart.data.datasets[i].backgroundColor + '"></span>');
			if (chart.data.datasets[i].label) {
				text.push(chart.data.datasets[i].label);
			}
			text.push('</li>');
		}
		text.push('</ul>');
		return text.join('');
	}
});

/**
 * Helper function to get the box width based on the usePointStyle option
 * @param labelopts {Object} the label options on the legend
 * @param fontSize {Number} the label font size
 * @return {Number} width of the color box area
 */
function getBoxWidth(labelOpts, fontSize) {
	return labelOpts.usePointStyle ?
		fontSize * Math.SQRT2 :
		labelOpts.boxWidth;
}

/**
 * IMPORTANT: this class is exposed publicly as Chart.Legend, backward compatibility required!
 */
var Legend = Element.extend({

	initialize: function(config) {
		helpers.extend(this, config);

		// Contains hit boxes for each dataset (in dataset order)
		this.legendHitBoxes = [];

		// Are we in doughnut mode which has a different data type
		this.doughnutMode = false;
	},

	// These methods are ordered by lifecycle. Utilities then follow.
	// Any function defined here is inherited by all legend types.
	// Any function can be extended by the legend type

	beforeUpdate: noop,
	update: function(maxWidth, maxHeight, margins) {
		var me = this;

		// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
		me.beforeUpdate();

		// Absorb the master measurements
		me.maxWidth = maxWidth;
		me.maxHeight = maxHeight;
		me.margins = margins;

		// Dimensions
		me.beforeSetDimensions();
		me.setDimensions();
		me.afterSetDimensions();
		// Labels
		me.beforeBuildLabels();
		me.buildLabels();
		me.afterBuildLabels();

		// Fit
		me.beforeFit();
		me.fit();
		me.afterFit();
		//
		me.afterUpdate();

		return me.minSize;
	},
	afterUpdate: noop,

	//

	beforeSetDimensions: noop,
	setDimensions: function() {
		var me = this;
		// Set the unconstrained dimension before label rotation
		if (me.isHorizontal()) {
			// Reset position before calculating rotation
			me.width = me.maxWidth;
			me.left = 0;
			me.right = me.width;
		} else {
			me.height = me.maxHeight;

			// Reset position before calculating rotation
			me.top = 0;
			me.bottom = me.height;
		}

		// Reset padding
		me.paddingLeft = 0;
		me.paddingTop = 0;
		me.paddingRight = 0;
		me.paddingBottom = 0;

		// Reset minSize
		me.minSize = {
			width: 0,
			height: 0
		};
	},
	afterSetDimensions: noop,

	//

	beforeBuildLabels: noop,
	buildLabels: function() {
		var me = this;
		var labelOpts = me.options.labels || {};
		var legendItems = helpers.callback(labelOpts.generateLabels, [me.chart], me) || [];

		if (labelOpts.filter) {
			legendItems = legendItems.filter(function(item) {
				return labelOpts.filter(item, me.chart.data);
			});
		}

		if (me.options.reverse) {
			legendItems.reverse();
		}

		me.legendItems = legendItems;
	},
	afterBuildLabels: noop,

	//

	beforeFit: noop,
	fit: function() {
		var me = this;
		var opts = me.options;
		var labelOpts = opts.labels;
		var display = opts.display;

		var ctx = me.ctx;

		var globalDefault = defaults.global;
		var valueOrDefault = helpers.valueOrDefault;
		var fontSize = valueOrDefault(labelOpts.fontSize, globalDefault.defaultFontSize);
		var fontStyle = valueOrDefault(labelOpts.fontStyle, globalDefault.defaultFontStyle);
		var fontFamily = valueOrDefault(labelOpts.fontFamily, globalDefault.defaultFontFamily);
		var labelFont = helpers.fontString(fontSize, fontStyle, fontFamily);

		// Reset hit boxes
		var hitboxes = me.legendHitBoxes = [];

		var minSize = me.minSize;
		var isHorizontal = me.isHorizontal();

		if (isHorizontal) {
			minSize.width = me.maxWidth; // fill all the width
			minSize.height = display ? 10 : 0;
		} else {
			minSize.width = display ? 10 : 0;
			minSize.height = me.maxHeight; // fill all the height
		}

		// Increase sizes here
		if (display) {
			ctx.font = labelFont;

			if (isHorizontal) {
				// Labels

				// Width of each line of legend boxes. Labels wrap onto multiple lines when there are too many to fit on one
				var lineWidths = me.lineWidths = [0];
				var totalHeight = me.legendItems.length ? fontSize + (labelOpts.padding) : 0;

				ctx.textAlign = 'left';
				ctx.textBaseline = 'top';

				helpers.each(me.legendItems, function(legendItem, i) {
					var boxWidth = getBoxWidth(labelOpts, fontSize);
					var width = boxWidth + (fontSize / 2) + ctx.measureText(legendItem.text).width;

					if (lineWidths[lineWidths.length - 1] + width + labelOpts.padding >= me.width) {
						totalHeight += fontSize + (labelOpts.padding);
						lineWidths[lineWidths.length] = me.left;
					}

					// Store the hitbox width and height here. Final position will be updated in `draw`
					hitboxes[i] = {
						left: 0,
						top: 0,
						width: width,
						height: fontSize
					};

					lineWidths[lineWidths.length - 1] += width + labelOpts.padding;
				});

				minSize.height += totalHeight;

			} else {
				var vPadding = labelOpts.padding;
				var columnWidths = me.columnWidths = [];
				var totalWidth = labelOpts.padding;
				var currentColWidth = 0;
				var currentColHeight = 0;
				var itemHeight = fontSize + vPadding;

				helpers.each(me.legendItems, function(legendItem, i) {
					var boxWidth = getBoxWidth(labelOpts, fontSize);
					var itemWidth = boxWidth + (fontSize / 2) + ctx.measureText(legendItem.text).width;

					// If too tall, go to new column
					if (currentColHeight + itemHeight > minSize.height) {
						totalWidth += currentColWidth + labelOpts.padding;
						columnWidths.push(currentColWidth); // previous column width

						currentColWidth = 0;
						currentColHeight = 0;
					}

					// Get max width
					currentColWidth = Math.max(currentColWidth, itemWidth);
					currentColHeight += itemHeight;

					// Store the hitbox width and height here. Final position will be updated in `draw`
					hitboxes[i] = {
						left: 0,
						top: 0,
						width: itemWidth,
						height: fontSize
					};
				});

				totalWidth += currentColWidth;
				columnWidths.push(currentColWidth);
				minSize.width += totalWidth;
			}
		}

		me.width = minSize.width;
		me.height = minSize.height;
	},
	afterFit: noop,

	// Shared Methods
	isHorizontal: function() {
		return this.options.position === 'top' || this.options.position === 'bottom';
	},

	// Actually draw the legend on the canvas
	draw: function() {
		var me = this;
		var opts = me.options;
		var labelOpts = opts.labels;
		var globalDefault = defaults.global;
		var lineDefault = globalDefault.elements.line;
		var legendWidth = me.width;
		var lineWidths = me.lineWidths;

		if (opts.display) {
			var ctx = me.ctx;
			var valueOrDefault = helpers.valueOrDefault;
			var fontColor = valueOrDefault(labelOpts.fontColor, globalDefault.defaultFontColor);
			var fontSize = valueOrDefault(labelOpts.fontSize, globalDefault.defaultFontSize);
			var fontStyle = valueOrDefault(labelOpts.fontStyle, globalDefault.defaultFontStyle);
			var fontFamily = valueOrDefault(labelOpts.fontFamily, globalDefault.defaultFontFamily);
			var labelFont = helpers.fontString(fontSize, fontStyle, fontFamily);
			var cursor;

			// Canvas setup
			ctx.textAlign = 'left';
			ctx.textBaseline = 'middle';
			ctx.lineWidth = 0.5;
			ctx.strokeStyle = fontColor; // for strikethrough effect
			ctx.fillStyle = fontColor; // render in correct colour
			ctx.font = labelFont;

			var boxWidth = getBoxWidth(labelOpts, fontSize);
			var hitboxes = me.legendHitBoxes;

			// current position
			var drawLegendBox = function(x, y, legendItem) {
				if (isNaN(boxWidth) || boxWidth <= 0) {
					return;
				}

				// Set the ctx for the box
				ctx.save();

				ctx.fillStyle = valueOrDefault(legendItem.fillStyle, globalDefault.defaultColor);
				ctx.lineCap = valueOrDefault(legendItem.lineCap, lineDefault.borderCapStyle);
				ctx.lineDashOffset = valueOrDefault(legendItem.lineDashOffset, lineDefault.borderDashOffset);
				ctx.lineJoin = valueOrDefault(legendItem.lineJoin, lineDefault.borderJoinStyle);
				ctx.lineWidth = valueOrDefault(legendItem.lineWidth, lineDefault.borderWidth);
				ctx.strokeStyle = valueOrDefault(legendItem.strokeStyle, globalDefault.defaultColor);
				var isLineWidthZero = (valueOrDefault(legendItem.lineWidth, lineDefault.borderWidth) === 0);

				if (ctx.setLineDash) {
					// IE 9 and 10 do not support line dash
					ctx.setLineDash(valueOrDefault(legendItem.lineDash, lineDefault.borderDash));
				}

				if (opts.labels && opts.labels.usePointStyle) {
					// Recalculate x and y for drawPoint() because its expecting
					// x and y to be center of figure (instead of top left)
					var radius = fontSize * Math.SQRT2 / 2;
					var offSet = radius / Math.SQRT2;
					var centerX = x + offSet;
					var centerY = y + offSet;

					// Draw pointStyle as legend symbol
					helpers.canvas.drawPoint(ctx, legendItem.pointStyle, radius, centerX, centerY);
				} else {
					// Draw box as legend symbol
					if (!isLineWidthZero) {
						ctx.strokeRect(x, y, boxWidth, fontSize);
					}
					ctx.fillRect(x, y, boxWidth, fontSize);
				}

				ctx.restore();
			};
			var fillText = function(x, y, legendItem, textWidth) {
				var halfFontSize = fontSize / 2;
				var xLeft = boxWidth + halfFontSize + x;
				var yMiddle = y + halfFontSize;

				ctx.fillText(legendItem.text, xLeft, yMiddle);

				if (legendItem.hidden) {
					// Strikethrough the text if hidden
					ctx.beginPath();
					ctx.lineWidth = 2;
					ctx.moveTo(xLeft, yMiddle);
					ctx.lineTo(xLeft + textWidth, yMiddle);
					ctx.stroke();
				}
			};

			// Horizontal
			var isHorizontal = me.isHorizontal();
			if (isHorizontal) {
				cursor = {
					x: me.left + ((legendWidth - lineWidths[0]) / 2),
					y: me.top + labelOpts.padding,
					line: 0
				};
			} else {
				cursor = {
					x: me.left + labelOpts.padding,
					y: me.top + labelOpts.padding,
					line: 0
				};
			}

			var itemHeight = fontSize + labelOpts.padding;
			helpers.each(me.legendItems, function(legendItem, i) {
				var textWidth = ctx.measureText(legendItem.text).width;
				var width = boxWidth + (fontSize / 2) + textWidth;
				var x = cursor.x;
				var y = cursor.y;

				if (isHorizontal) {
					if (x + width >= legendWidth) {
						y = cursor.y += itemHeight;
						cursor.line++;
						x = cursor.x = me.left + ((legendWidth - lineWidths[cursor.line]) / 2);
					}
				} else if (y + itemHeight > me.bottom) {
					x = cursor.x = x + me.columnWidths[cursor.line] + labelOpts.padding;
					y = cursor.y = me.top + labelOpts.padding;
					cursor.line++;
				}

				drawLegendBox(x, y, legendItem);

				hitboxes[i].left = x;
				hitboxes[i].top = y;

				// Fill the actual label
				fillText(x, y, legendItem, textWidth);

				if (isHorizontal) {
					cursor.x += width + (labelOpts.padding);
				} else {
					cursor.y += itemHeight;
				}

			});
		}
	},

	/**
	 * Handle an event
	 * @private
	 * @param {IEvent} event - The event to handle
	 * @return {Boolean} true if a change occured
	 */
	handleEvent: function(e) {
		var me = this;
		var opts = me.options;
		var type = e.type === 'mouseup' ? 'click' : e.type;
		var changed = false;

		if (type === 'mousemove') {
			if (!opts.onHover) {
				return;
			}
		} else if (type === 'click') {
			if (!opts.onClick) {
				return;
			}
		} else {
			return;
		}

		// Chart event already has relative position in it
		var x = e.x;
		var y = e.y;

		if (x >= me.left && x <= me.right && y >= me.top && y <= me.bottom) {
			// See if we are touching one of the dataset boxes
			var lh = me.legendHitBoxes;
			for (var i = 0; i < lh.length; ++i) {
				var hitBox = lh[i];

				if (x >= hitBox.left && x <= hitBox.left + hitBox.width && y >= hitBox.top && y <= hitBox.top + hitBox.height) {
					// Touching an element
					if (type === 'click') {
						// use e.native for backwards compatibility
						opts.onClick.call(me, e.native, me.legendItems[i]);
						changed = true;
						break;
					} else if (type === 'mousemove') {
						// use e.native for backwards compatibility
						opts.onHover.call(me, e.native, me.legendItems[i]);
						changed = true;
						break;
					}
				}
			}
		}

		return changed;
	}
});

function createNewLegendAndAttach(chart, legendOpts) {
	var legend = new Legend({
		ctx: chart.ctx,
		options: legendOpts,
		chart: chart
	});

	layouts.configure(chart, legend, legendOpts);
	layouts.addBox(chart, legend);
	chart.legend = legend;
}

module.exports = {
	id: 'legend',

	/**
	 * Backward compatibility: since 2.1.5, the legend is registered as a plugin, making
	 * Chart.Legend obsolete. To avoid a breaking change, we export the Legend as part of
	 * the plugin, which one will be re-exposed in the chart.js file.
	 * https://github.com/chartjs/Chart.js/pull/2640
	 * @private
	 */
	_element: Legend,

	beforeInit: function(chart) {
		var legendOpts = chart.options.legend;

		if (legendOpts) {
			createNewLegendAndAttach(chart, legendOpts);
		}
	},

	beforeUpdate: function(chart) {
		var legendOpts = chart.options.legend;
		var legend = chart.legend;

		if (legendOpts) {
			helpers.mergeIf(legendOpts, defaults.global.legend);

			if (legend) {
				layouts.configure(chart, legend, legendOpts);
				legend.options = legendOpts;
			} else {
				createNewLegendAndAttach(chart, legendOpts);
			}
		} else if (legend) {
			layouts.removeBox(chart, legend);
			delete chart.legend;
		}
	},

	afterEvent: function(chart, e) {
		var legend = chart.legend;
		if (legend) {
			legend.handleEvent(e);
		}
	}
};


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(2);
var Element = __webpack_require__(8);
var helpers = __webpack_require__(1);
var layouts = __webpack_require__(21);

var noop = helpers.noop;

defaults._set('global', {
	title: {
		display: false,
		fontStyle: 'bold',
		fullWidth: true,
		lineHeight: 1.2,
		padding: 10,
		position: 'top',
		text: '',
		weight: 2000         // by default greater than legend (1000) to be above
	}
});

/**
 * IMPORTANT: this class is exposed publicly as Chart.Legend, backward compatibility required!
 */
var Title = Element.extend({
	initialize: function(config) {
		var me = this;
		helpers.extend(me, config);

		// Contains hit boxes for each dataset (in dataset order)
		me.legendHitBoxes = [];
	},

	// These methods are ordered by lifecycle. Utilities then follow.

	beforeUpdate: noop,
	update: function(maxWidth, maxHeight, margins) {
		var me = this;

		// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
		me.beforeUpdate();

		// Absorb the master measurements
		me.maxWidth = maxWidth;
		me.maxHeight = maxHeight;
		me.margins = margins;

		// Dimensions
		me.beforeSetDimensions();
		me.setDimensions();
		me.afterSetDimensions();
		// Labels
		me.beforeBuildLabels();
		me.buildLabels();
		me.afterBuildLabels();

		// Fit
		me.beforeFit();
		me.fit();
		me.afterFit();
		//
		me.afterUpdate();

		return me.minSize;

	},
	afterUpdate: noop,

	//

	beforeSetDimensions: noop,
	setDimensions: function() {
		var me = this;
		// Set the unconstrained dimension before label rotation
		if (me.isHorizontal()) {
			// Reset position before calculating rotation
			me.width = me.maxWidth;
			me.left = 0;
			me.right = me.width;
		} else {
			me.height = me.maxHeight;

			// Reset position before calculating rotation
			me.top = 0;
			me.bottom = me.height;
		}

		// Reset padding
		me.paddingLeft = 0;
		me.paddingTop = 0;
		me.paddingRight = 0;
		me.paddingBottom = 0;

		// Reset minSize
		me.minSize = {
			width: 0,
			height: 0
		};
	},
	afterSetDimensions: noop,

	//

	beforeBuildLabels: noop,
	buildLabels: noop,
	afterBuildLabels: noop,

	//

	beforeFit: noop,
	fit: function() {
		var me = this;
		var valueOrDefault = helpers.valueOrDefault;
		var opts = me.options;
		var display = opts.display;
		var fontSize = valueOrDefault(opts.fontSize, defaults.global.defaultFontSize);
		var minSize = me.minSize;
		var lineCount = helpers.isArray(opts.text) ? opts.text.length : 1;
		var lineHeight = helpers.options.toLineHeight(opts.lineHeight, fontSize);
		var textSize = display ? (lineCount * lineHeight) + (opts.padding * 2) : 0;

		if (me.isHorizontal()) {
			minSize.width = me.maxWidth; // fill all the width
			minSize.height = textSize;
		} else {
			minSize.width = textSize;
			minSize.height = me.maxHeight; // fill all the height
		}

		me.width = minSize.width;
		me.height = minSize.height;

	},
	afterFit: noop,

	// Shared Methods
	isHorizontal: function() {
		var pos = this.options.position;
		return pos === 'top' || pos === 'bottom';
	},

	// Actually draw the title block on the canvas
	draw: function() {
		var me = this;
		var ctx = me.ctx;
		var valueOrDefault = helpers.valueOrDefault;
		var opts = me.options;
		var globalDefaults = defaults.global;

		if (opts.display) {
			var fontSize = valueOrDefault(opts.fontSize, globalDefaults.defaultFontSize);
			var fontStyle = valueOrDefault(opts.fontStyle, globalDefaults.defaultFontStyle);
			var fontFamily = valueOrDefault(opts.fontFamily, globalDefaults.defaultFontFamily);
			var titleFont = helpers.fontString(fontSize, fontStyle, fontFamily);
			var lineHeight = helpers.options.toLineHeight(opts.lineHeight, fontSize);
			var offset = lineHeight / 2 + opts.padding;
			var rotation = 0;
			var top = me.top;
			var left = me.left;
			var bottom = me.bottom;
			var right = me.right;
			var maxWidth, titleX, titleY;

			ctx.fillStyle = valueOrDefault(opts.fontColor, globalDefaults.defaultFontColor); // render in correct colour
			ctx.font = titleFont;

			// Horizontal
			if (me.isHorizontal()) {
				titleX = left + ((right - left) / 2); // midpoint of the width
				titleY = top + offset;
				maxWidth = right - left;
			} else {
				titleX = opts.position === 'left' ? left + offset : right - offset;
				titleY = top + ((bottom - top) / 2);
				maxWidth = bottom - top;
				rotation = Math.PI * (opts.position === 'left' ? -0.5 : 0.5);
			}

			ctx.save();
			ctx.translate(titleX, titleY);
			ctx.rotate(rotation);
			ctx.textAlign = 'center';
			ctx.textBaseline = 'middle';

			var text = opts.text;
			if (helpers.isArray(text)) {
				var y = 0;
				for (var i = 0; i < text.length; ++i) {
					ctx.fillText(text[i], 0, y, maxWidth);
					y += lineHeight;
				}
			} else {
				ctx.fillText(text, 0, 0, maxWidth);
			}

			ctx.restore();
		}
	}
});

function createNewTitleBlockAndAttach(chart, titleOpts) {
	var title = new Title({
		ctx: chart.ctx,
		options: titleOpts,
		chart: chart
	});

	layouts.configure(chart, title, titleOpts);
	layouts.addBox(chart, title);
	chart.titleBlock = title;
}

module.exports = {
	id: 'title',

	/**
	 * Backward compatibility: since 2.1.5, the title is registered as a plugin, making
	 * Chart.Title obsolete. To avoid a breaking change, we export the Title as part of
	 * the plugin, which one will be re-exposed in the chart.js file.
	 * https://github.com/chartjs/Chart.js/pull/2640
	 * @private
	 */
	_element: Title,

	beforeInit: function(chart) {
		var titleOpts = chart.options.title;

		if (titleOpts) {
			createNewTitleBlockAndAttach(chart, titleOpts);
		}
	},

	beforeUpdate: function(chart) {
		var titleOpts = chart.options.title;
		var titleBlock = chart.titleBlock;

		if (titleOpts) {
			helpers.mergeIf(titleOpts, defaults.global.title);

			if (titleBlock) {
				layouts.configure(chart, titleBlock, titleOpts);
				titleBlock.options = titleOpts;
			} else {
				createNewTitleBlockAndAttach(chart, titleOpts);
			}
		} else if (titleBlock) {
			layouts.removeBox(chart, titleBlock);
			delete chart.titleBlock;
		}
	}
};


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(78),
    equalArrays = __webpack_require__(82),
    equalByTag = __webpack_require__(271),
    equalObjects = __webpack_require__(275),
    getTag = __webpack_require__(292),
    isArray = __webpack_require__(11),
    isBuffer = __webpack_require__(84),
    isTypedArray = __webpack_require__(85);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 238 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(35);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(35);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(35);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(35);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(34);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 244 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 245 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 246 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(34),
    Map = __webpack_require__(53),
    MapCache = __webpack_require__(54);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(79),
    isMasked = __webpack_require__(251),
    isObject = __webpack_require__(24),
    toSource = __webpack_require__(81);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(37);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 250 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(252);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(10);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 253 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(255),
    ListCache = __webpack_require__(34),
    Map = __webpack_require__(53);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(256),
    hashDelete = __webpack_require__(257),
    hashGet = __webpack_require__(258),
    hashHas = __webpack_require__(259),
    hashSet = __webpack_require__(260);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(38);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 257 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(38);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(38);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(38);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(39);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 262 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(39);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(39);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(39);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(54),
    setCacheAdd = __webpack_require__(267),
    setCacheHas = __webpack_require__(268);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 267 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 268 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 269 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 270 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(37),
    Uint8Array = __webpack_require__(272),
    eq = __webpack_require__(36),
    equalArrays = __webpack_require__(82),
    mapToArray = __webpack_require__(273),
    setToArray = __webpack_require__(274);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(10);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 273 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 274 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(276);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(277),
    getSymbols = __webpack_require__(279),
    keys = __webpack_require__(25);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(278),
    isArray = __webpack_require__(11);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 278 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(280),
    stubArray = __webpack_require__(281);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 280 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 281 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(283),
    isArguments = __webpack_require__(83),
    isArray = __webpack_require__(11),
    isBuffer = __webpack_require__(84),
    isIndex = __webpack_require__(55),
    isTypedArray = __webpack_require__(85);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 283 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(23),
    isObjectLike = __webpack_require__(26);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 285 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(23),
    isLength = __webpack_require__(56),
    isObjectLike = __webpack_require__(26);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 287 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(80);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(50)(module)))

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(86),
    nativeKeys = __webpack_require__(290);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(291);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 291 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(293),
    Map = __webpack_require__(53),
    Promise = __webpack_require__(294),
    Set = __webpack_require__(295),
    WeakMap = __webpack_require__(296),
    baseGetTag = __webpack_require__(23),
    toSource = __webpack_require__(81);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(14),
    root = __webpack_require__(10);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(14),
    root = __webpack_require__(10);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(14),
    root = __webpack_require__(10);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(14),
    root = __webpack_require__(10);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

var createFind = __webpack_require__(298),
    findIndex = __webpack_require__(316);

/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */
var find = createFind(findIndex);

module.exports = find;


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(57),
    isArrayLike = __webpack_require__(27),
    keys = __webpack_require__(25);

/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */
function createFind(findIndexFunc) {
  return function(collection, predicate, fromIndex) {
    var iterable = Object(collection);
    if (!isArrayLike(collection)) {
      var iteratee = baseIteratee(predicate, 3);
      collection = keys(collection);
      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
    }
    var index = findIndexFunc(collection, predicate, fromIndex);
    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
  };
}

module.exports = createFind;


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(300),
    getMatchData = __webpack_require__(301),
    matchesStrictComparable = __webpack_require__(88);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(78),
    baseIsEqual = __webpack_require__(52);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(87),
    keys = __webpack_require__(25);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(52),
    get = __webpack_require__(303),
    hasIn = __webpack_require__(310),
    isKey = __webpack_require__(58),
    isStrictComparable = __webpack_require__(87),
    matchesStrictComparable = __webpack_require__(88),
    toKey = __webpack_require__(41);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(89);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(305);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(306);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(54);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(308);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(37),
    arrayMap = __webpack_require__(309),
    isArray = __webpack_require__(11),
    isSymbol = __webpack_require__(40);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 309 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(311),
    hasPath = __webpack_require__(312);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 311 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(90),
    isArguments = __webpack_require__(83),
    isArray = __webpack_require__(11),
    isIndex = __webpack_require__(55),
    isLength = __webpack_require__(56),
    toKey = __webpack_require__(41);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(314),
    basePropertyDeep = __webpack_require__(315),
    isKey = __webpack_require__(58),
    toKey = __webpack_require__(41);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 314 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(89);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(317),
    baseIteratee = __webpack_require__(57),
    toInteger = __webpack_require__(318);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return baseFindIndex(array, baseIteratee(predicate, 3), index);
}

module.exports = findIndex;


/***/ }),
/* 317 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

var toFinite = __webpack_require__(319);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(320);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(24),
    isSymbol = __webpack_require__(40);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(60),
    createAggregator = __webpack_require__(322);

/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the last element responsible for generating the key. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * var array = [
 *   { 'dir': 'left', 'code': 97 },
 *   { 'dir': 'right', 'code': 100 }
 * ];
 *
 * _.keyBy(array, function(o) {
 *   return String.fromCharCode(o.code);
 * });
 * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
 *
 * _.keyBy(array, 'dir');
 * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
 */
var keyBy = createAggregator(function(result, value, key) {
  baseAssignValue(result, key, value);
});

module.exports = keyBy;


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

var arrayAggregator = __webpack_require__(323),
    baseAggregator = __webpack_require__(324),
    baseIteratee = __webpack_require__(57),
    isArray = __webpack_require__(11);

/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */
function createAggregator(setter, initializer) {
  return function(collection, iteratee) {
    var func = isArray(collection) ? arrayAggregator : baseAggregator,
        accumulator = initializer ? initializer() : {};

    return func(collection, setter, baseIteratee(iteratee, 2), accumulator);
  };
}

module.exports = createAggregator;


/***/ }),
/* 323 */
/***/ (function(module, exports) {

/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function arrayAggregator(array, setter, iteratee, accumulator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    var value = array[index];
    setter(accumulator, value, iteratee(value), array);
  }
  return accumulator;
}

module.exports = arrayAggregator;


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(325);

/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function baseAggregator(collection, setter, iteratee, accumulator) {
  baseEach(collection, function(value, key, collection) {
    setter(accumulator, value, iteratee(value), collection);
  });
  return accumulator;
}

module.exports = baseAggregator;


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(326),
    createBaseEach = __webpack_require__(329);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(327),
    keys = __webpack_require__(25);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(328);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 328 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(27);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_chartjs_2__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chart_piecelabel_js__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chart_piecelabel_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_chart_piecelabel_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__i18n__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var classNames=__webpack_require__(7);var PieChart=function(_Component){_inherits(PieChart,_Component);function PieChart(){_classCallCheck(this,PieChart);return _possibleConstructorReturn(this,(PieChart.__proto__||Object.getPrototypeOf(PieChart)).apply(this,arguments));}_createClass(PieChart,[{key:'render',value:function render(){var styles=this.props.styles;var data=this.props.data;var currency=this.props.currency;var labelsArray=[];var dataArray=[];var totals=Number(0.00);// Umsatz
for(var index=0;index<data.length;index++){var amount=Number(parseFloat(data[index].amount).toFixed(2));totals=Number(parseFloat(amount+totals).toFixed(2));labelsArray.push(data[index].title);dataArray.push(amount);}var pieData={labels:labelsArray,datasets:[{data:dataArray,backgroundColor:['rgba(245,166,35,1)','rgba(13,46,160,1)','rgba(125,156,94,1)']}]};var chartOptions={pieceLabel:{render:'percentage',precision:2,fontSize:15,fontColor:'#fff'},legend:{display:false}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classNames(styles.inputItem,styles.modulRingdiagram)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:styles.pieArea},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classNames(styles.pieParticluars,styles.pieInvestment)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:styles.bottom},__WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].translate('calculator:investment',this.props.location.pathname)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:styles.pieNumber},Number(dataArray[1]).toLocaleString('de-DE')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,currency.symbol)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classNames(styles.pieParticluars,styles.pieDeckung)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:styles.bottom},__WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].translate('calculator:contributionMargin',this.props.location.pathname)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:styles.pieNumber},Number(dataArray[2]).toLocaleString('de-DE')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,currency.symbol)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classNames(styles.pieParticluars,styles.pieTotals)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:styles.bottom},__WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].translate('calculator:turnover',this.props.location.pathname)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:styles.pieNumber},totals.toLocaleString('de-DE')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,currency.symbol,' / ',__WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].translate('calculator:year',this.props.location.pathname))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_chartjs_2__["b" /* Doughnut */],{data:pieData,width:456,height:330,options:chartOptions}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('aside',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classNames(styles.pieParticluars,styles.pieCosts)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:styles.bottom},__WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].translate('calculator:variableCosts',this.props.location.pathname)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:styles.pieNumber},Number(dataArray[0]).toLocaleString('de-DE')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,currency.symbol)))));}}]);return PieChart;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* withRouter */])(PieChart));

/***/ }),
/* 331 */
/***/ (function(module, exports) {

/**
 * [Chart.PieceLabel.js]{@link https://github.com/emn178/Chart.PieceLabel.js}
 *
 * @version 0.9.0
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2017
 * @license MIT
 */
(function () {
  if (typeof Chart === 'undefined') {
    console.warn('Can not find Chart object.');
    return;
  }

  function PieceLabel() {
    this.drawDataset = this.drawDataset.bind(this);
  }

  PieceLabel.prototype.beforeDatasetsUpdate = function (chartInstance) {
    if (this.parseOptions(chartInstance) && this.position === 'outside') {
      var padding = this.fontSize * 1.5 + 2;
      chartInstance.chartArea.top += padding;
      chartInstance.chartArea.bottom -= padding;
    }
  };

  PieceLabel.prototype.afterDatasetsDraw = function (chartInstance) {
    if (!this.parseOptions(chartInstance)) {
      return;
    }
    this.labelBounds = [];
    chartInstance.config.data.datasets.forEach(this.drawDataset);
  };

  PieceLabel.prototype.drawDataset = function (dataset) {
    var ctx = this.ctx;
    var chartInstance = this.chartInstance;
    var meta = dataset._meta[Object.keys(dataset._meta)[0]];
    var totalPercentage = 0;
    for (var i = 0; i < meta.data.length; i++) {
      var element = meta.data[i],
        view = element._view, text;

      //Skips label creation if value is zero and showZero is set
      if (view.circumference === 0 && !this.showZero) {
        continue;
      }
      switch (this.render) {
        case 'value':
          var value = dataset.data[i];
          if (this.format) {
            value = this.format(value);
          }
          text = value.toString();
          break;
        case 'label':
          text = chartInstance.config.data.labels[i];
          break;
        case 'image':
          text = this.images[i] ? this.loadImage(this.images[i]) : '';
          break;
        case 'percentage':
        default:
          var percentage = view.circumference / this.options.circumference * 100;
          percentage = parseFloat(percentage.toFixed(this.precision));
          if (!this.showActualPercentages) {
            totalPercentage += percentage;
            if (totalPercentage > 100) {
              percentage -= totalPercentage - 100;
              // After adjusting the percentage, need to trim the numbers after decimal points again, otherwise it may not show
              // on chart due to very long number after decimal point.
              percentage = parseFloat(percentage.toFixed(this.precision));
            }
          }
          text = percentage + '%';
          break;
      }
      if (typeof this.render === 'function') {
        text = this.render({
          label: chartInstance.config.data.labels[i],
          value: dataset.data[i],
          percentage: percentage,
          dataset: dataset,
          index: i
        });

        if (typeof text === 'object') {
          text = this.loadImage(text);
        }
      }
      if (!text) {
        return;
      }
      ctx.save();
      ctx.beginPath();
      ctx.font = Chart.helpers.fontString(this.fontSize, this.fontStyle, this.fontFamily);
      var position, innerRadius, arcOffset;
      if (this.position === 'outside' ||
        this.position === 'border' && chartInstance.config.type === 'pie') {
        innerRadius = view.outerRadius / 2;
        var rangeFromCentre, offset = this.fontSize + 2,
          centreAngle = view.startAngle + ((view.endAngle - view.startAngle) / 2);
        if (this.position === 'border') {
          rangeFromCentre = (view.outerRadius - innerRadius) / 2 + innerRadius;
        } else if (this.position === 'outside') {
          rangeFromCentre = (view.outerRadius - innerRadius) + innerRadius + offset;
        }
        position = {
          x: view.x + (Math.cos(centreAngle) * rangeFromCentre),
          y: view.y + (Math.sin(centreAngle) * rangeFromCentre)
        };
        if (this.position === 'outside') {
          if (position.x < view.x) {
            position.x -= offset;
          } else {
            position.x += offset;
          }
          arcOffset = view.outerRadius + offset;
        }
      } else {
        innerRadius = view.innerRadius;
        position = element.tooltipPosition();
      }

      var fontColor = this.fontColor;
      if (typeof fontColor === 'function') {
        fontColor = fontColor({
          label: chartInstance.config.data.labels[i],
          value: dataset.data[i],
          percentage: percentage,
          text: text,
          backgroundColor: dataset.backgroundColor[i],
          dataset: dataset,
          index: i
        });
      } else if (typeof fontColor !== 'string') {
        fontColor = fontColor[i] || this.options.defaultFontColor;
      }
      if (this.arc) {
        if (!arcOffset) {
          arcOffset = (innerRadius + view.outerRadius) / 2;
        }
        ctx.fillStyle = fontColor;
        ctx.textBaseline = 'middle';
        this.drawArcText(text, arcOffset, view, this.overlap);
      } else {
        var drawable, mertrics = this.measureText(text),
          left = position.x - mertrics.width / 2,
          right = position.x + mertrics.width / 2,
          top = position.y - this.fontSize / 2,
          bottom = position.y + this.fontSize / 2;
        if (this.overlap) {
          drawable = true;
        } else if (this.position === 'outside') {
          drawable = this.checkTextBound(left, right, top, bottom);
        } else {
          drawable = element.inRange(left, top) && element.inRange(left, bottom) &&
            element.inRange(right, top) && element.inRange(right, bottom);
        }
        if (drawable) {
          this.fillText(text, position, fontColor);
        }
      }
      ctx.restore();
    }
  };

  PieceLabel.prototype.parseOptions = function (chartInstance) {
    var pieceLabel = chartInstance.options.pieceLabel;
    if (pieceLabel) {
      this.chartInstance = chartInstance;
      this.ctx = chartInstance.chart.ctx;
      this.options = chartInstance.config.options;
      this.render = pieceLabel.render || pieceLabel.mode;
      this.position = pieceLabel.position || 'default';
      this.arc = pieceLabel.arc;
      this.format = pieceLabel.format;
      this.precision = pieceLabel.precision || 0;
      this.fontSize = pieceLabel.fontSize || this.options.defaultFontSize;
      this.fontColor = pieceLabel.fontColor || this.options.defaultFontColor;
      this.fontStyle = pieceLabel.fontStyle || this.options.defaultFontStyle;
      this.fontFamily = pieceLabel.fontFamily || this.options.defaultFontFamily;
      this.hasTooltip = chartInstance.tooltip._active && chartInstance.tooltip._active.length;
      this.showZero = pieceLabel.showZero;
      this.overlap = pieceLabel.overlap;
      this.images = pieceLabel.images || [];
      this.showActualPercentages = pieceLabel.showActualPercentages || false;
      return true;
    } else {
      return false;
    }
  };

  PieceLabel.prototype.checkTextBound = function (left, right, top, bottom) {
    var labelBounds = this.labelBounds;
    for (var i = 0;i < labelBounds.length;++i) {
      var bound = labelBounds[i];
      var potins = [
        [left, top],
        [left, bottom],
        [right, top],
        [right, bottom]
      ];
      for (var j = 0;j < potins.length;++j) {
        var x = potins[j][0];
        var y = potins[j][1];
        if (x >= bound.left && x <= bound.right && y >= bound.top && y <= bound.bottom) {
          return false;
        }
      }
      potins = [
        [bound.left, bound.top],
        [bound.left, bound.bottom],
        [bound.right, bound.top],
        [bound.right, bound.bottom]
      ];
      for (var j = 0;j < potins.length;++j) {
        var x = potins[j][0];
        var y = potins[j][1];
        if (x >= left && x <= right && y >= top && y <= bottom) {
          return false;
        }
      }
    }
    labelBounds.push({
      left: left,
      right: right,
      top: top,
      bottom: bottom
    });
    return true;
  };

  PieceLabel.prototype.measureText = function (text) {
    if (typeof text === 'object') {
      return { width: text.width, height: text.height };
    } else {
      return this.ctx.measureText(text);
    }
  };

  PieceLabel.prototype.fillText = function (text, position, fontColor) {
    var ctx = this.ctx;
    if (typeof text === 'object') {
      ctx.drawImage(text, position.x - text.width / 2, position.y - text.height / 2, text.width, text.height);
    } else {
      ctx.fillStyle = fontColor;
      ctx.textBaseline = 'top';
      ctx.textAlign = 'center';
      ctx.fillText(text, position.x, position.y - this.fontSize / 2);
    }
  };

  PieceLabel.prototype.loadImage = function (obj) {
    var image = new Image();
    image.src = obj.src;
    image.width = obj.width;
    image.height = obj.height;
    return image;
  };

  PieceLabel.prototype.drawArcText = function (str, radius, view, overlap) {
    var ctx = this.ctx,
      centerX = view.x,
      centerY = view.y,
      startAngle = view.startAngle,
      endAngle = view.endAngle;

    ctx.save();
    ctx.translate(centerX, centerY);
    var angleSize = endAngle - startAngle;
    startAngle += Math.PI / 2;
    endAngle += Math.PI / 2;
    var origStartAngle = startAngle;
    var mertrics = this.measureText(str);
    startAngle += (endAngle - (mertrics.width / radius + startAngle)) / 2;
    if (!overlap && endAngle - startAngle > angleSize) {
      ctx.restore();
      return;
    }

    if (typeof str === 'string') {
      ctx.rotate(startAngle);
      for (var i = 0; i < str.length; i++) {
        var char = str.charAt(i);
        mertrics = ctx.measureText(char);
        ctx.save();
        ctx.translate(0, -1 * radius);
        ctx.fillText(char, 0, 0);
        ctx.restore();
        ctx.rotate(mertrics.width / radius);
      }
    } else {
      ctx.rotate((origStartAngle + endAngle) / 2);
      ctx.translate(0, -1 * radius);
      this.fillText(str, { x: 0, y: 0 });
    }
    ctx.restore();
  };

  Chart.pluginService.register({
    beforeInit: function(chartInstance) {
      chartInstance.pieceLabel = new PieceLabel();
    },
    beforeDatasetsUpdate: function (chartInstance) {
      chartInstance.pieceLabel.beforeDatasetsUpdate(chartInstance);
    },
    afterDatasetsDraw: function (chartInstance) {
      chartInstance.pieceLabel.afterDatasetsDraw(chartInstance);
    }
  });
})();


/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__i18n__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var classNames=__webpack_require__(7);var TotalsView=function(_Component){_inherits(TotalsView,_Component);function TotalsView(){var _ref;var _temp,_this,_ret;_classCallCheck(this,TotalsView);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=TotalsView.__proto__||Object.getPrototypeOf(TotalsView)).call.apply(_ref,[this].concat(args))),_this),_this.returnData=function(data){var styles=_this.props.styles;var totalsData=data.map(function(item){var sum=Number(item.sum).toLocaleString('de-DE');if(item.sum>0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:item.month},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,item.month),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:styles.positive},sum));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:item.month},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,item.month),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:styles.negative},sum));}});return totalsData;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(TotalsView,[{key:'render',value:function render(){var styles=this.props.styles;var data=this.props.data;var leftData=[];var rightData=[];var isHighlightedBoxStyles=this.props.highlightBox?styles.highlight:null;for(var index=0;index<data.length;index++){if(index<12){leftData.push({month:data[index].month,sum:data[index].sum});}else{rightData.push({month:data[index].month,sum:data[index].sum});}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:styles.fullTotals},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classNames(styles.totalsData,isHighlightedBoxStyles)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_1__i18n__["a" /* default */].translate('calculator:month',this.props.location.pathname)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_1__i18n__["a" /* default */].translate('calculator:earnings',this.props.location.pathname))),this.returnData(leftData))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classNames(styles.totalsData,isHighlightedBoxStyles)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_1__i18n__["a" /* default */].translate('calculator:month',this.props.location.pathname)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_1__i18n__["a" /* default */].translate('calculator:earnings',this.props.location.pathname))),this.returnData(rightData))));}}]);return TotalsView;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* withRouter */])(TotalsView));

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__c_scenario_overview_css__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__c_scenario_overview_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__c_scenario_overview_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_icons_icon_scenario_dropdown_svg__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_icons_icon_scenario_dropdown_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_icons_icon_scenario_dropdown_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__i18n__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_dom__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ScenarioOverview=function(_Component){_inherits(ScenarioOverview,_Component);function ScenarioOverview(props){_classCallCheck(this,ScenarioOverview);var _this=_possibleConstructorReturn(this,(ScenarioOverview.__proto__||Object.getPrototypeOf(ScenarioOverview)).call(this,props));_this.handleDropdown=function(){var dropdown=_this.refs.dropdown;var activeState=_this.state.dropdownActive;if(dropdown!==undefined){if(activeState){dropdown.classList.remove(__WEBPACK_IMPORTED_MODULE_1__c_scenario_overview_css___default.a.dropdownActive);_this.setState({dropdownActive:false});}else{dropdown.classList.add(__WEBPACK_IMPORTED_MODULE_1__c_scenario_overview_css___default.a.dropdownActive);_this.setState({dropdownActive:true});}}};_this.state={dropdownActive:false};return _this;}_createClass(ScenarioOverview,[{key:'render',// draggable(element) {
//   var isMouseDown = false;
//   var mouseX;
//   var mouseY;
//   var elementX = 0;
//   var elementY = 0;
//   var currentStyleX = 0;
//   var originalStyleX = 0;
//   element.addEventListener('mousedown', onMouseDown, false);
//   /**
//    * Listens to `mousedown` event.
//    *
//    * @param {Object} event - The event.
//    */
//   function onMouseDown(event) {
//     mouseX = event.clientX;
//     // mouseY = event.clientY;
//     isMouseDown = true; 
//     originalStyleX = parseInt(element.style.right, 10);
//   }
//   // mouse button released
//   element.addEventListener('mouseup', onMouseUp);
//   /**
//    * Listens to `mouseup` event.
//    *
//    * @param {Object} event - The event.
//    */ 
//   function onMouseUp(event) {
//     isMouseDown = false;
//     elementX = parseFloat(element.style.left) || 0;
//     if (parseFloat(currentStyleX) < -100) {
//       element.classList.add('closed');
//       element.style.right = '-180px';
//       element.style.opacity = 0.5;
//     } else {
//       element.classList.remove('closed');
//       element.style.right = '0';
//       element.style.opacity = 1;
//     }
//   }
//   // need to attach to the entire document
//   // in order to take full width and height
//   // this ensures the element keeps up with the mouse
//   document.addEventListener('mousemove', onMouseMove);
//   /**
//    * Listens to `mousemove` event.
//    *
//    * @param {Object} event - The event.
//    */
//   function onMouseMove(event) {
//     if (!isMouseDown) return;
//       var deltaX = event.clientX - mouseX - originalStyleX;
//       var deltaY = event.clientY - mouseY;
//       element.style.right = elementX - deltaX + 'px';
//       element.style.top = elementY - deltaY + 'px';
//       currentStyleX = elementX - deltaX;
//       if (elementX - deltaX > 0) {
//         element.style.right = 0 + 'px';
//         currentStyleX = 0;
//       }
//   }
// }
value:function render(){var _this2=this;var scenario=this.props.scenarioData;var deviceData=this.props.deviceData;var currency=this.props.currency;var devices=deviceData.map(function(item){var unitPriceString='('+Number(item.unit_price).toLocaleString('de-DE')+' '+currency.symbol+')';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:item.id,value:item.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:__WEBPACK_IMPORTED_MODULE_1__c_scenario_overview_css___default.a.leftRow},__WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].translate('calculator:'+item.localeName,_this2.props.location.pathname),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:__WEBPACK_IMPORTED_MODULE_1__c_scenario_overview_css___default.a.price},unitPriceString)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:__WEBPACK_IMPORTED_MODULE_1__c_scenario_overview_css___default.a.qty},item.qty));});// setTimeout(() => {
//   // eslint-disable-next-line no-undef
//   this.draggable(document.getElementById('sticky-menu'))
// }, 1000)
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('aside',{id:'sticky-menu',className:__WEBPACK_IMPORTED_MODULE_1__c_scenario_overview_css___default.a.overviewContainer,style:{right:0}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,scenario.capacity,' ',__WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].translate('calculator:pieceHour',this.props.location.pathname)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1__c_scenario_overview_css___default.a.scenarioName},scenario.name,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:this.handleDropdown},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_2__assets_icons_icon_scenario_dropdown_svg___default.a,alt:''}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()(__WEBPACK_IMPORTED_MODULE_1__c_scenario_overview_css___default.a.dropdown),ref:'dropdown'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()(__WEBPACK_IMPORTED_MODULE_1__c_scenario_overview_css___default.a.headers,__WEBPACK_IMPORTED_MODULE_1__c_scenario_overview_css___default.a.headerLeft)},__WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].translate('calculator:device',this.props.location.pathname)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()(__WEBPACK_IMPORTED_MODULE_1__c_scenario_overview_css___default.a.headers,__WEBPACK_IMPORTED_MODULE_1__c_scenario_overview_css___default.a.headerRight)},__WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].translate('calculator:qty',this.props.location.pathname)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,devices),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(ev){return _this2.props.showOverlay(ev,true);},className:__WEBPACK_IMPORTED_MODULE_1__c_scenario_overview_css___default.a.button},__WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].translate('calculator:allSetups',this.props.location.pathname))));}}]);return ScenarioOverview;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["c" /* withRouter */])(ScenarioOverview));

/***/ }),
/* 334 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"overviewContainer":"yKuyKnfr9J7nGEQfDAYGP","scenarioName":"_3G57NcmaDuGvMNQv4Pbrci","dropdown":"_2o27Ra5XR6DCEn30n3Ijy2","dropdownActive":"_25bngw6uhMA5cxbQlcxigx","leftRow":"A3UPvqPBpNmnt_j7M1j5b","price":"_3mZalf5PlGwRJCLKmT9q4-","qty":"CNggKLjheGgNJbyXYJsnQ","button":"_3ouYfo_5g2q12EDNxi0cGi","headers":"_1e8GSasFE_SyFJWzkdQihb","headerLeft":"_3wyoHEjS6thLBiPC0Iv7UP","headerRight":"oBJ4I9izx8XLGMr-RHGsx"};

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_scenario_dropdown.7646a08d.svg";

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rooms_XS__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rooms_S__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__rooms_M__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__rooms_L__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__rooms_XL__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rooms_XXL__ = __webpack_require__(356);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Room=function(_React$Component){_inherits(Room,_React$Component);function Room(props){_classCallCheck(this,Room);var _this=_possibleConstructorReturn(this,(Room.__proto__||Object.getPrototypeOf(Room)).call(this,props));var calculatedWidth=(window.innerWidth||document.documentElement.clientWidth||document.getElementsByTagName('body')[0].clientWidth)/1;// let calculatedHeight = window.innerHeight||document.documentElement.clientHeight||document.getElementsByTagName('body')[0].clientHeight
_this.state={width:calculatedWidth>1000?1000:calculatedWidth,ratio:(calculatedWidth>1000?1000:calculatedWidth)/parseFloat(props.width),currentScenario:props.currentScenario};return _this;}_createClass(Room,[{key:'componentDidUpdate',value:function componentDidUpdate(){if(typeof this.props.currentScenario!=='undefined'&&typeof this.state.currentScenario!=='undefined'&&this.props.currentScenario.id!==this.state.currentScenario.id){this.setState({currentScenario:this.props.currentScenario});}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.state.currentScenario.id===1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{position:'relative',margin:'auto auto 50px',maxWidth:this.state.width,height:this.state.height}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__rooms_XS__["a" /* default */],{width:this.state.width})):null,this.state.currentScenario.id===2?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{position:'relative',margin:'auto auto 50px',maxWidth:this.state.width,height:this.state.height}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__rooms_S__["a" /* default */],{width:this.state.width})):null,this.state.currentScenario.id===3?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{position:'relative',margin:'auto auto 50px',maxWidth:this.state.width,height:this.state.height}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__rooms_M__["a" /* default */],{width:this.state.width})):null,this.state.currentScenario.id===4?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{position:'relative',margin:'auto auto 50px',maxWidth:this.state.width,height:this.state.height}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__rooms_L__["a" /* default */],{width:this.state.width})):null,this.state.currentScenario.id===5?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{position:'relative',margin:'auto auto 50px',maxWidth:this.state.width,height:this.state.height}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__rooms_XL__["a" /* default */],{width:this.state.width})):null,this.state.currentScenario.id===6?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{position:'relative',margin:'auto auto 50px',maxWidth:this.state.width,height:this.state.height}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__rooms_XXL__["a" /* default */],{width:this.state.width})):null);}}]);return Room;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Room);

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_web_animation__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_web_animation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_web_animation__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RoomXS=function(_React$Component){_inherits(RoomXS,_React$Component);function RoomXS(props){_classCallCheck(this,RoomXS);var _this=_possibleConstructorReturn(this,(RoomXS.__proto__||Object.getPrototypeOf(RoomXS)).call(this,props));_this.state={originalWidth:1051,originalHeight:944};_this.state=Object.assign({},_this.state,{width:parseFloat(props.width),height:_this.state.originalHeight/(_this.state.originalWidth/parseFloat(props.width)),ratio:_this.state.originalWidth/parseFloat(props.width)});return _this;}_createClass(RoomXS,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{width:this.state.width,height:this.state.height,viewBox:'0 0 '+this.state.originalWidth+' '+this.state.originalHeight},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('defs',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-1',points:'43.8613654 43.8613654 148.890523 25.5455751 130.574733 130.574733 25.5455751 148.890523'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-2',points:'389.227219 285.617463 494.256376 267.301673 475.940586 372.33083 370.911429 390.64662'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-3',points:'216.544292 164.739414 321.57345 146.423624 303.257659 251.452781 198.228502 269.768572'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-4',points:'130.202829 104.30039 235.231986 85.9845995 216.916196 191.013757 111.887039 209.329547'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-5',points:'302.885756 225.178439 407.914913 206.862648 389.599123 311.891806 284.569965 330.207596'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-6',points:'43.8613654 43.8613654 148.890523 25.5455751 130.574733 130.574733 25.5455751 148.890523'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-7',points:'389.227219 285.617463 494.256376 267.301673 475.940586 372.33083 370.911429 390.64662'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-8',points:'216.544292 164.739414 321.57345 146.423624 303.257659 251.452781 198.228502 269.768572'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-9',points:'130.202829 104.30039 235.231986 85.9845995 216.916196 191.013757 111.887039 209.329547'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-10',points:'302.885756 225.178439 407.914913 206.862648 389.599123 311.891806 284.569965 330.207596'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-11',points:'43.8613654 43.8613654 148.890523 25.5455751 130.574733 130.574733 25.5455751 148.890523'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-12',points:'389.227219 285.617463 494.256376 267.301673 475.940586 372.33083 370.911429 390.64662'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-13',points:'216.544292 164.739414 321.57345 146.423624 303.257659 251.452781 198.228502 269.768572'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-14',points:'130.202829 104.30039 235.231986 85.9845995 216.916196 191.013757 111.887039 209.329547'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-15',points:'302.885756 225.178439 407.914913 206.862648 389.599123 311.891806 284.569965 330.207596'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-16',points:'43.8613654 43.8613654 148.890523 25.5455751 130.574733 130.574733 25.5455751 148.890523'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-17',points:'389.227219 285.617463 494.256376 267.301673 475.940586 372.33083 370.911429 390.64662'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-18',points:'216.544292 164.739414 321.57345 146.423624 303.257659 251.452781 198.228502 269.768572'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-19',points:'130.202829 104.30039 235.231986 85.9845995 216.916196 191.013757 111.887039 209.329547'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-20',points:'302.885756 225.178439 407.914913 206.862648 389.599123 311.891806 284.569965 330.207596'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-21',points:'43.8613654 43.8613654 148.890523 25.5455751 130.574733 130.574733 25.5455751 148.890523'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-22',points:'389.227219 285.617463 494.256376 267.301673 475.940586 372.33083 370.911429 390.64662'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-23',points:'216.544292 164.739414 321.57345 146.423624 303.257659 251.452781 198.228502 269.768572'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-24',points:'130.202829 104.30039 235.231986 85.9845995 216.916196 191.013757 111.887039 209.329547'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-25',points:'302.885756 225.178439 407.914913 206.862648 389.599123 311.891806 284.569965 330.207596'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Packages/XS',fill:'none',fillRule:'evenodd',stroke:'none',strokeWidth:'1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'Rectangle-8',fill:'#DFDFDF',points:'140.714328 184.071615 669.932359 185.746854 477.171295 460.364297 -52.0467354 458.689058',transform:'translate(308.942812, 322.217956) rotate(-35.000000) translate(-308.942812, -322.217956) '}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'Rectangle-8',fill:'#929292',points:'571.498179 185.411826 1099.89647 185.742288 907.926659 460.05991 380.736532 459.747136',transform:'translate(740.316503, 322.735868) scale(-1, 1) rotate(-35.000000) translate(-740.316503, -322.735868) '}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Boden/5x5',transform:'translate(-338.000000, 311.000000)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'10m',transform:'translate(430.473868, 241.756098)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(87.218049, 87.218049) rotate(45.000000) translate(-87.218049, -87.218049) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'43.8613654 43.8613654 148.890523 25.5455751 130.574733 130.574733 25.5455751 148.890523'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M44.3944365,44.3944365 L26.3038391,148.132259 L130.041661,130.041661 L148.132259,26.3038391 L44.3944365,44.3944365 Z',stroke:'#979797',strokeWidth:'1.23344948'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(432.583903, 328.974147) rotate(45.000000) translate(-432.583903, -328.974147) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'389.227219 285.617463 494.256376 267.301673 475.940586 372.33083 370.911429 390.64662'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M389.76029,286.150534 L371.669693,389.888356 L475.407515,371.797759 L493.498112,268.059937 L389.76029,286.150534 Z',stroke:'#979797',strokeWidth:'1.23344948'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(259.900976, 208.096098) rotate(45.000000) translate(-259.900976, -208.096098) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'216.544292 164.739414 321.57345 146.423624 303.257659 251.452781 198.228502 269.768572'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M217.077363,165.272485 L198.986766,269.010308 L302.724588,250.91971 L320.815186,147.181888 L217.077363,165.272485 Z',stroke:'#979797',strokeWidth:'1.23344948'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(173.559512, 147.657073) rotate(45.000000) translate(-173.559512, -147.657073) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'130.202829 104.30039 235.231986 85.9845995 216.916196 191.013757 111.887039 209.329547'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M130.7359,104.833461 L112.645303,208.571283 L216.383125,190.480686 L234.473722,86.7428635 L130.7359,104.833461 Z',stroke:'#979797',strokeWidth:'1.23344948'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(346.242439, 268.535122) rotate(45.000000) translate(-346.242439, -268.535122) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'302.885756 225.178439 407.914913 206.862648 389.599123 311.891806 284.569965 330.207596'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M303.418827,225.71151 L285.328229,329.449332 L389.066052,311.358735 L407.156649,207.620912 L303.418827,225.71151 Z',stroke:'#979797',strokeWidth:'1.23344948'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'10m',transform:'translate(516.815331, 181.317073)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(87.218049, 87.218049) rotate(45.000000) translate(-87.218049, -87.218049) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'43.8613654 43.8613654 148.890523 25.5455751 130.574733 130.574733 25.5455751 148.890523'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M44.3944365,44.3944365 L26.3038391,148.132259 L130.041661,130.041661 L148.132259,26.3038391 L44.3944365,44.3944365 Z',stroke:'#979797',strokeWidth:'1.23344948'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(432.583903, 328.974147) rotate(45.000000) translate(-432.583903, -328.974147) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'389.227219 285.617463 494.256376 267.301673 475.940586 372.33083 370.911429 390.64662'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M389.76029,286.150534 L371.669693,389.888356 L475.407515,371.797759 L493.498112,268.059937 L389.76029,286.150534 Z',stroke:'#979797',strokeWidth:'1.23344948'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(259.900976, 208.096098) rotate(45.000000) translate(-259.900976, -208.096098) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'216.544292 164.739414 321.57345 146.423624 303.257659 251.452781 198.228502 269.768572'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M217.077363,165.272485 L198.986766,269.010308 L302.724588,250.91971 L320.815186,147.181888 L217.077363,165.272485 Z',stroke:'#979797',strokeWidth:'1.23344948'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(173.559512, 147.657073) rotate(45.000000) translate(-173.559512, -147.657073) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'130.202829 104.30039 235.231986 85.9845995 216.916196 191.013757 111.887039 209.329547'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M130.7359,104.833461 L112.645303,208.571283 L216.383125,190.480686 L234.473722,86.7428635 L130.7359,104.833461 Z',stroke:'#979797',strokeWidth:'1.23344948'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(346.242439, 268.535122) rotate(45.000000) translate(-346.242439, -268.535122) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'302.885756 225.178439 407.914913 206.862648 389.599123 311.891806 284.569965 330.207596'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M303.418827,225.71151 L285.328229,329.449332 L389.066052,311.358735 L407.156649,207.620912 L303.418827,225.71151 Z',stroke:'#979797',strokeWidth:'1.23344948'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'10m',transform:'translate(603.156794, 120.878049)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(87.218049, 87.218049) rotate(45.000000) translate(-87.218049, -87.218049) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'43.8613654 43.8613654 148.890523 25.5455751 130.574733 130.574733 25.5455751 148.890523'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M44.3944365,44.3944365 L26.3038391,148.132259 L130.041661,130.041661 L148.132259,26.3038391 L44.3944365,44.3944365 Z',stroke:'#979797',strokeWidth:'1.23344948'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(432.583903, 328.974147) rotate(45.000000) translate(-432.583903, -328.974147) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'389.227219 285.617463 494.256376 267.301673 475.940586 372.33083 370.911429 390.64662'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M389.76029,286.150534 L371.669693,389.888356 L475.407515,371.797759 L493.498112,268.059937 L389.76029,286.150534 Z',stroke:'#979797',strokeWidth:'1.23344948'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(259.900976, 208.096098) rotate(45.000000) translate(-259.900976, -208.096098) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'216.544292 164.739414 321.57345 146.423624 303.257659 251.452781 198.228502 269.768572'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M217.077363,165.272485 L198.986766,269.010308 L302.724588,250.91971 L320.815186,147.181888 L217.077363,165.272485 Z',stroke:'#979797',strokeWidth:'1.23344948'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(173.559512, 147.657073) rotate(45.000000) translate(-173.559512, -147.657073) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'130.202829 104.30039 235.231986 85.9845995 216.916196 191.013757 111.887039 209.329547'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M130.7359,104.833461 L112.645303,208.571283 L216.383125,190.480686 L234.473722,86.7428635 L130.7359,104.833461 Z',stroke:'#979797',strokeWidth:'1.23344948'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(346.242439, 268.535122) rotate(45.000000) translate(-346.242439, -268.535122) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'302.885756 225.178439 407.914913 206.862648 389.599123 311.891806 284.569965 330.207596'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M303.418827,225.71151 L285.328229,329.449332 L389.066052,311.358735 L407.156649,207.620912 L303.418827,225.71151 Z',stroke:'#979797',strokeWidth:'1.23344948'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'10m',transform:'translate(688.264808, 60.439024)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(87.218049, 87.218049) rotate(45.000000) translate(-87.218049, -87.218049) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'43.8613654 43.8613654 148.890523 25.5455751 130.574733 130.574733 25.5455751 148.890523'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M44.3944365,44.3944365 L26.3038391,148.132259 L130.041661,130.041661 L148.132259,26.3038391 L44.3944365,44.3944365 Z',stroke:'#979797',strokeWidth:'1.23344948'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(432.583903, 328.974147) rotate(45.000000) translate(-432.583903, -328.974147) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'389.227219 285.617463 494.256376 267.301673 475.940586 372.33083 370.911429 390.64662'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M389.76029,286.150534 L371.669693,389.888356 L475.407515,371.797759 L493.498112,268.059937 L389.76029,286.150534 Z',stroke:'#979797',strokeWidth:'1.23344948'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(259.900976, 208.096098) rotate(45.000000) translate(-259.900976, -208.096098) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'216.544292 164.739414 321.57345 146.423624 303.257659 251.452781 198.228502 269.768572'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M217.077363,165.272485 L198.986766,269.010308 L302.724588,250.91971 L320.815186,147.181888 L217.077363,165.272485 Z',stroke:'#979797',strokeWidth:'1.23344948'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(173.559512, 147.657073) rotate(45.000000) translate(-173.559512, -147.657073) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'130.202829 104.30039 235.231986 85.9845995 216.916196 191.013757 111.887039 209.329547'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M130.7359,104.833461 L112.645303,208.571283 L216.383125,190.480686 L234.473722,86.7428635 L130.7359,104.833461 Z',stroke:'#979797',strokeWidth:'1.23344948'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(346.242439, 268.535122) rotate(45.000000) translate(-346.242439, -268.535122) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'302.885756 225.178439 407.914913 206.862648 389.599123 311.891806 284.569965 330.207596'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M303.418827,225.71151 L285.328229,329.449332 L389.066052,311.358735 L407.156649,207.620912 L303.418827,225.71151 Z',stroke:'#979797',strokeWidth:'1.23344948'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'10m',transform:'translate(774.606272, 0.000000)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(87.218049, 87.218049) rotate(45.000000) translate(-87.218049, -87.218049) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'43.8613654 43.8613654 148.890523 25.5455751 130.574733 130.574733 25.5455751 148.890523'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M44.3944365,44.3944365 L26.3038391,148.132259 L130.041661,130.041661 L148.132259,26.3038391 L44.3944365,44.3944365 Z',stroke:'#979797',strokeWidth:'1.23344948'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(432.583903, 328.974147) rotate(45.000000) translate(-432.583903, -328.974147) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'389.227219 285.617463 494.256376 267.301673 475.940586 372.33083 370.911429 390.64662'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M389.76029,286.150534 L371.669693,389.888356 L475.407515,371.797759 L493.498112,268.059937 L389.76029,286.150534 Z',stroke:'#979797',strokeWidth:'1.23344948'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(259.900976, 208.096098) rotate(45.000000) translate(-259.900976, -208.096098) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'216.544292 164.739414 321.57345 146.423624 303.257659 251.452781 198.228502 269.768572'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M217.077363,165.272485 L198.986766,269.010308 L302.724588,250.91971 L320.815186,147.181888 L217.077363,165.272485 Z',stroke:'#979797',strokeWidth:'1.23344948'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(173.559512, 147.657073) rotate(45.000000) translate(-173.559512, -147.657073) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'130.202829 104.30039 235.231986 85.9845995 216.916196 191.013757 111.887039 209.329547'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M130.7359,104.833461 L112.645303,208.571283 L216.383125,190.480686 L234.473722,86.7428635 L130.7359,104.833461 Z',stroke:'#979797',strokeWidth:'1.23344948'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(346.242439, 268.535122) rotate(45.000000) translate(-346.242439, -268.535122) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'302.885756 225.178439 407.914913 206.862648 389.599123 311.891806 284.569965 330.207596'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M303.418827,225.71151 L285.328229,329.449332 L389.066052,311.358735 L407.156649,207.620912 L303.418827,225.71151 Z',stroke:'#979797',strokeWidth:'1.23344948'})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Desk,{ratio:this.state.ratio}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Pretreat,{ratio:this.state.ratio}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Press,{ratio:this.state.ratio}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Gtx,{ratio:this.state.ratio}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Senddesk,{ratio:this.state.ratio}));}}]);return RoomXS;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (RoomXS);var Desk=function(_React$Component2){_inherits(Desk,_React$Component2);function Desk(props){_classCallCheck(this,Desk);var _this2=_possibleConstructorReturn(this,(Desk.__proto__||Object.getPrototypeOf(Desk)).call(this,props));_this2.state={originalWidth:343,originalHeight:245,x:0,y:-500,opacity:0,ratio:parseFloat(props.ratio)};_this2.state=Object.assign({},_this2.state,{width:_this2.state.originalWidth/_this2.state.ratio,height:_this2.state.originalHeight/_this2.state.ratio});return _this2;}_createClass(Desk,[{key:'getKeyFrames',value:function getKeyFrames(){return[{transform:'translateY(-500px)',opacity:0,offset:0},{opacity:1,offset:1},{transform:'translateY(0)',opacity:1,offset:1}];}},{key:'getTiming',value:function getTiming(duration){return{duration:duration,easing:'ease-in',delay:0,iterations:1,fill:'forwards'};}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_web_animation__["Animated"].img,{keyframes:this.getKeyFrames(),timing:this.getTiming(750),style:{position:'absolute',top:456/this.state.ratio,left:181/this.state.ratio,opacity:this.state.opacity,transform:[{translateY:this.state.y}],width:this.state.width,height:this.state.height},src:__webpack_require__(17)});}}]);return Desk;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var Press=function(_React$Component3){_inherits(Press,_React$Component3);function Press(props){_classCallCheck(this,Press);var _this3=_possibleConstructorReturn(this,(Press.__proto__||Object.getPrototypeOf(Press)).call(this,props));_this3.state={originalWidth:262,originalHeight:256,x:0,y:-500,opacity:0,ratio:parseFloat(props.ratio)};_this3.state=Object.assign({},_this3.state,{width:_this3.state.originalWidth/_this3.state.ratio,height:_this3.state.originalHeight/_this3.state.ratio});return _this3;}_createClass(Press,[{key:'getKeyFrames',value:function getKeyFrames(){return[{transform:'translateY(-500px)',opacity:0,offset:0},{opacity:1,offset:1},{transform:'translateY(0)',opacity:1,offset:1}];}},{key:'getTiming',value:function getTiming(duration){return{duration:duration,easing:'ease-in',delay:0,iterations:1,fill:'forwards'};}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_web_animation__["Animated"].img,{keyframes:this.getKeyFrames(),timing:this.getTiming(750),style:{position:'absolute',top:325/this.state.ratio,left:351/this.state.ratio,opacity:this.state.opacity,transform:[{translateY:this.state.y}],width:this.state.width,height:this.state.height},src:__webpack_require__(18)});}}]);return Press;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var Pretreat=function(_React$Component4){_inherits(Pretreat,_React$Component4);function Pretreat(props){_classCallCheck(this,Pretreat);var _this4=_possibleConstructorReturn(this,(Pretreat.__proto__||Object.getPrototypeOf(Pretreat)).call(this,props));_this4.state={originalWidth:262,originalHeight:245,x:0,y:-500,opacity:0,ratio:parseFloat(props.ratio)};_this4.state=Object.assign({},_this4.state,{width:_this4.state.originalWidth/_this4.state.ratio,height:_this4.state.originalHeight/_this4.state.ratio});return _this4;}_createClass(Pretreat,[{key:'getKeyFrames',value:function getKeyFrames(){return[{transform:'translateY(-500px)',opacity:0,offset:0},{opacity:1,offset:1},{transform:'translateY(0)',opacity:1,offset:1}];}},{key:'getTiming',value:function getTiming(duration){return{duration:duration,easing:'ease-in',delay:0,iterations:1,fill:'forwards'};}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_web_animation__["Animated"].img,{keyframes:this.getKeyFrames(),timing:this.getTiming(750),style:{position:'absolute',top:275/this.state.ratio,left:439/this.state.ratio,opacity:this.state.opacity,transform:[{translateY:this.state.y}],width:this.state.width,height:this.state.height},src:__webpack_require__(28)});}}]);return Pretreat;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var Gtx=function(_React$Component5){_inherits(Gtx,_React$Component5);function Gtx(props){_classCallCheck(this,Gtx);var _this5=_possibleConstructorReturn(this,(Gtx.__proto__||Object.getPrototypeOf(Gtx)).call(this,props));_this5.state={originalWidth:434,originalHeight:309,x:0,y:-500,opacity:0,ratio:parseFloat(props.ratio)};_this5.state=Object.assign({},_this5.state,{width:_this5.state.originalWidth/_this5.state.ratio,height:_this5.state.originalHeight/_this5.state.ratio});return _this5;}_createClass(Gtx,[{key:'getKeyFrames',value:function getKeyFrames(){return[{transform:'translateY(-500px)',opacity:0,offset:0},{opacity:1,offset:1},{transform:'translateY(0)',opacity:1,offset:1}];}},{key:'getTiming',value:function getTiming(duration){return{duration:duration,easing:'ease-in',delay:0,iterations:1,fill:'forwards'};}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_web_animation__["Animated"].img,{keyframes:this.getKeyFrames(),timing:this.getTiming(750),style:{position:'absolute',top:455/this.state.ratio,left:436/this.state.ratio,opacity:this.state.opacity,transform:[{translateY:this.state.y}],width:this.state.width,height:this.state.height},src:__webpack_require__(3)});}}]);return Gtx;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var Senddesk=function(_React$Component6){_inherits(Senddesk,_React$Component6);function Senddesk(props){_classCallCheck(this,Senddesk);var _this6=_possibleConstructorReturn(this,(Senddesk.__proto__||Object.getPrototypeOf(Senddesk)).call(this,props));_this6.state={originalWidth:349,originalHeight:276,x:0,y:-500,opacity:0,ratio:parseFloat(props.ratio)};_this6.state=Object.assign({},_this6.state,{width:_this6.state.originalWidth/_this6.state.ratio,height:_this6.state.originalHeight/_this6.state.ratio});return _this6;}_createClass(Senddesk,[{key:'getKeyFrames',value:function getKeyFrames(){return[{transform:'translateY(-500px)',opacity:0,offset:0},{opacity:1,offset:1},{transform:'translateY(0)',opacity:1,offset:1}];}},{key:'getTiming',value:function getTiming(duration){return{duration:duration,easing:'ease-in',delay:0,iterations:1,fill:'forwards'};}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_web_animation__["Animated"].img,{keyframes:this.getKeyFrames(),timing:this.getTiming(750),style:{position:'absolute',top:665/this.state.ratio,left:350/this.state.ratio,opacity:this.state.opacity,transform:[{translateY:this.state.y}],width:this.state.width,height:this.state.height},src:__webpack_require__(19)});}}]);return Senddesk;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _with_hoc_elements = __webpack_require__(92);

var _with_hoc_elements2 = _interopRequireDefault(_with_hoc_elements);

var _animation = __webpack_require__(93);

var _animation2 = _interopRequireDefault(_animation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _with_hoc_elements2.default)(_animation2.default);

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// Thanks to styled-components -> ReactDOMFactories for this handy list!
exports.default = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr',

// SVG
'circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(97),
    baseAssignValue = __webpack_require__(60);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(342),
    isIterateeCall = __webpack_require__(349);

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(59),
    overRest = __webpack_require__(343),
    setToString = __webpack_require__(345);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(344);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 344 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(346),
    shortOut = __webpack_require__(348);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(347),
    defineProperty = __webpack_require__(91),
    identity = __webpack_require__(59);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),
/* 347 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 348 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(36),
    isArrayLike = __webpack_require__(27),
    isIndex = __webpack_require__(55),
    isObject = __webpack_require__(24);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _effect = __webpack_require__(98);

var _effect2 = _interopRequireDefault(_effect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint no-unused-vars:0 */


/**
 * <AnimationGroup/> is a grouping element that uses the GroupEffect class provided by the Web Animations API polyfill.
 * Any <Animatable/> elements in a <AnimationGroup/> will be run in parallel, and <AnimationGroup/> will provide a single
 * timeline for the GroupEffect.
 */
var AnimationGroup = function (_Effect) {
  _inherits(AnimationGroup, _Effect);

  function AnimationGroup() {
    _classCallCheck(this, AnimationGroup);

    return _possibleConstructorReturn(this, (AnimationGroup.__proto__ || Object.getPrototypeOf(AnimationGroup)).call(this, 'GroupEffect'));
  }

  return AnimationGroup;
}(_effect2.default);

exports.default = AnimationGroup;

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _effect = __webpack_require__(98);

var _effect2 = _interopRequireDefault(_effect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint no-unused-vars:0 */


/**
 * <AnimationSequence/> is a grouping element that uses the SequenceEffect class provided by the Web Animations API polyfill.
 * Any <Animatable/> elements in a <AnimationSequence/> will be run in serial, and <AnimationSequence/> will provide a single
 * timeline for the SequenceEffect.
 */
var AnimationSequence = function (_Effect) {
  _inherits(AnimationSequence, _Effect);

  function AnimationSequence() {
    _classCallCheck(this, AnimationSequence);

    return _possibleConstructorReturn(this, (AnimationSequence.__proto__ || Object.getPrototypeOf(AnimationSequence)).call(this, 'SequenceEffect'));
  }

  return AnimationSequence;
}(_effect2.default);

exports.default = AnimationSequence;

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_web_animation__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_web_animation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_web_animation__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RoomS=function(_React$Component){_inherits(RoomS,_React$Component);function RoomS(props){_classCallCheck(this,RoomS);var _this=_possibleConstructorReturn(this,(RoomS.__proto__||Object.getPrototypeOf(RoomS)).call(this,props));_this.state={originalWidth:1051,originalHeight:944};_this.state=Object.assign({},_this.state,{width:parseFloat(props.width),height:_this.state.originalHeight/(_this.state.originalWidth/parseFloat(props.width)),ratio:_this.state.originalWidth/parseFloat(props.width)});return _this;}_createClass(RoomS,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{height:this.state.height,width:this.state.width,viewBox:'0 0 '+this.state.originalWidth+' '+this.state.originalHeight},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('defs',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-1',points:'38.912556 38.912556 132.091438 22.6633077 115.842189 115.842189 22.6633077 132.091438'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-2',points:'345.31132 253.39169 438.490201 237.142442 422.240953 330.321324 329.062071 346.570572'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-3',points:'192.111938 146.152123 285.290819 129.902875 269.041571 223.081757 175.86269 239.331005'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-4',points:'115.512247 92.5323396 208.691128 76.2830914 192.44188 169.461973 99.2629986 185.711221'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-5',points:'268.711629 199.771907 361.89051 183.522659 345.641262 276.70154 252.46238 292.950788'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-6',points:'38.912556 38.912556 132.091438 22.6633077 115.842189 115.842189 22.6633077 132.091438'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-7',points:'345.31132 253.39169 438.490201 237.142442 422.240953 330.321324 329.062071 346.570572'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-8',points:'192.111938 146.152123 285.290819 129.902875 269.041571 223.081757 175.86269 239.331005'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-9',points:'115.512247 92.5323396 208.691128 76.2830914 192.44188 169.461973 99.2629986 185.711221'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-10',points:'268.711629 199.771907 361.89051 183.522659 345.641262 276.70154 252.46238 292.950788'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-11',points:'38.912556 38.912556 132.091438 22.6633077 115.842189 115.842189 22.6633077 132.091438'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-12',points:'345.31132 253.39169 438.490201 237.142442 422.240953 330.321324 329.062071 346.570572'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-13',points:'192.111938 146.152123 285.290819 129.902875 269.041571 223.081757 175.86269 239.331005'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-14',points:'115.512247 92.5323396 208.691128 76.2830914 192.44188 169.461973 99.2629986 185.711221'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-15',points:'268.711629 199.771907 361.89051 183.522659 345.641262 276.70154 252.46238 292.950788'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-16',points:'38.912556 38.912556 132.091438 22.6633077 115.842189 115.842189 22.6633077 132.091438'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-17',points:'345.31132 253.39169 438.490201 237.142442 422.240953 330.321324 329.062071 346.570572'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-18',points:'192.111938 146.152123 285.290819 129.902875 269.041571 223.081757 175.86269 239.331005'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-19',points:'115.512247 92.5323396 208.691128 76.2830914 192.44188 169.461973 99.2629986 185.711221'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-20',points:'268.711629 199.771907 361.89051 183.522659 345.641262 276.70154 252.46238 292.950788'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-21',points:'38.912556 38.912556 132.091438 22.6633077 115.842189 115.842189 22.6633077 132.091438'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-22',points:'345.31132 253.39169 438.490201 237.142442 422.240953 330.321324 329.062071 346.570572'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-23',points:'192.111938 146.152123 285.290819 129.902875 269.041571 223.081757 175.86269 239.331005'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-24',points:'115.512247 92.5323396 208.691128 76.2830914 192.44188 169.461973 99.2629986 185.711221'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-25',points:'268.711629 199.771907 361.89051 183.522659 345.641262 276.70154 252.46238 292.950788'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-26',points:'38.912556 38.912556 132.091438 22.6633077 115.842189 115.842189 22.6633077 132.091438'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-27',points:'345.31132 253.39169 438.490201 237.142442 422.240953 330.321324 329.062071 346.570572'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-28',points:'116.606528 521.490609 209.78541 505.24136 193.536161 598.420242 100.35728 614.66949'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-29',points:'40.0068373 575.110392 133.185719 558.861144 116.936471 652.040025 23.757589 668.289274'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-30',points:'193.206219 467.870825 286.385101 451.621577 270.135852 544.800458 176.956971 561.049707'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-31',points:'269.80591 414.251041 362.984792 398.001793 346.735543 491.180675 253.556662 507.429923'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-32',points:'345.31132 360.631258 438.490201 344.382009 422.240953 437.560891 329.062071 453.810139'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-33',points:'421.91101 307.011474 515.089892 290.762226 498.840644 383.941107 405.661762 400.190356'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-34',points:'192.111938 146.152123 285.290819 129.902875 269.041571 223.081757 175.86269 239.331005'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-35',points:'115.512247 92.5323396 208.691128 76.2830914 192.44188 169.461973 99.2629986 185.711221'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-36',points:'268.711629 199.771907 361.89051 183.522659 345.641262 276.70154 252.46238 292.950788'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Packages/S',fill:'none',fillRule:'evenodd',stroke:'none',strokeWidth:'1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'Rectangle-8',fill:'#DFDFDF',points:'102.053551 186.471789 662.179041 187.614363 491.324624 431.5908 -68.8008666 430.448226',transform:'translate(296.689087, 309.031295) rotate(-35.000000) translate(-296.689087, -309.031295) '}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'Rectangle-8',fill:'#929292',points:'560.420622 189.890225 1122.50615 190.676415 951.806817 435.009236 390.067201 433.72792',transform:'translate(756.286676, 312.449731) scale(-1, 1) rotate(-35.000000) translate(-756.286676, -312.449731) '}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Boden/6x6',transform:'translate(-240.000000, 275.000000)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'10m',transform:'translate(381.904173, 214.479134)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(77.377373, 77.377373) rotate(45.000000) translate(-77.377373, -77.377373) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'38.912556 38.912556 132.091438 22.6633077 115.842189 115.842189 22.6633077 132.091438'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M39.3854815,39.3854815 L23.336018,131.418727 L115.369264,115.369264 L131.418727,23.336018 L39.3854815,39.3854815 Z',stroke:'#979797',strokeWidth:'1.0942813'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(383.776136, 291.856507) rotate(45.000000) translate(-383.776136, -291.856507) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'345.31132 253.39169 438.490201 237.142442 422.240953 330.321324 329.062071 346.570572'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M345.784245,253.864616 L329.734782,345.897862 L421.768027,329.848398 L437.817491,237.815152 L345.784245,253.864616 Z',stroke:'#979797',strokeWidth:'1.0942813'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(230.576754, 184.616940) rotate(45.000000) translate(-230.576754, -184.616940) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'192.111938 146.152123 285.290819 129.902875 269.041571 223.081757 175.86269 239.331005'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M192.584863,146.625049 L176.5354,238.658295 L268.568646,222.608831 L284.618109,130.575585 L192.584863,146.625049 Z',stroke:'#979797',strokeWidth:'1.0942813'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(153.977064, 130.997156) rotate(45.000000) translate(-153.977064, -130.997156) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'115.512247 92.5323396 208.691128 76.2830914 192.44188 169.461973 99.2629986 185.711221'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M115.985172,93.0052651 L99.9357089,185.038511 L191.968955,168.989047 L208.018418,76.9558016 L115.985172,93.0052651 Z',stroke:'#979797',strokeWidth:'1.0942813'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(307.176445, 238.236724) rotate(45.000000) translate(-307.176445, -238.236724) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'268.711629 199.771907 361.89051 183.522659 345.641262 276.70154 252.46238 292.950788'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M269.184554,200.244832 L253.135091,292.278078 L345.168336,276.228615 L361.2178,184.195369 L269.184554,200.244832 Z',stroke:'#979797',strokeWidth:'1.0942813'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'10m',transform:'translate(305.304482, 268.098918)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(77.377373, 77.377373) rotate(45.000000) translate(-77.377373, -77.377373) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'38.912556 38.912556 132.091438 22.6633077 115.842189 115.842189 22.6633077 132.091438'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M39.3854815,39.3854815 L23.336018,131.418727 L115.369264,115.369264 L131.418727,23.336018 L39.3854815,39.3854815 Z',stroke:'#979797',strokeWidth:'1.0942813'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(383.776136, 291.856507) rotate(45.000000) translate(-383.776136, -291.856507) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'345.31132 253.39169 438.490201 237.142442 422.240953 330.321324 329.062071 346.570572'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M345.784245,253.864616 L329.734782,345.897862 L421.768027,329.848398 L437.817491,237.815152 L345.784245,253.864616 Z',stroke:'#979797',strokeWidth:'1.0942813'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(230.576754, 184.616940) rotate(45.000000) translate(-230.576754, -184.616940) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'192.111938 146.152123 285.290819 129.902875 269.041571 223.081757 175.86269 239.331005'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M192.584863,146.625049 L176.5354,238.658295 L268.568646,222.608831 L284.618109,130.575585 L192.584863,146.625049 Z',stroke:'#979797',strokeWidth:'1.0942813'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(153.977064, 130.997156) rotate(45.000000) translate(-153.977064, -130.997156) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'115.512247 92.5323396 208.691128 76.2830914 192.44188 169.461973 99.2629986 185.711221'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M115.985172,93.0052651 L99.9357089,185.038511 L191.968955,168.989047 L208.018418,76.9558016 L115.985172,93.0052651 Z',stroke:'#979797',strokeWidth:'1.0942813'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(307.176445, 238.236724) rotate(45.000000) translate(-307.176445, -238.236724) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'268.711629 199.771907 361.89051 183.522659 345.641262 276.70154 252.46238 292.950788'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M269.184554,200.244832 L253.135091,292.278078 L345.168336,276.228615 L361.2178,184.195369 L269.184554,200.244832 Z',stroke:'#979797',strokeWidth:'1.0942813'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'10m',transform:'translate(458.503864, 160.859351)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(77.377373, 77.377373) rotate(45.000000) translate(-77.377373, -77.377373) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'38.912556 38.912556 132.091438 22.6633077 115.842189 115.842189 22.6633077 132.091438'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M39.3854815,39.3854815 L23.336018,131.418727 L115.369264,115.369264 L131.418727,23.336018 L39.3854815,39.3854815 Z',stroke:'#979797',strokeWidth:'1.0942813'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(383.776136, 291.856507) rotate(45.000000) translate(-383.776136, -291.856507) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'345.31132 253.39169 438.490201 237.142442 422.240953 330.321324 329.062071 346.570572'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M345.784245,253.864616 L329.734782,345.897862 L421.768027,329.848398 L437.817491,237.815152 L345.784245,253.864616 Z',stroke:'#979797',strokeWidth:'1.0942813'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(230.576754, 184.616940) rotate(45.000000) translate(-230.576754, -184.616940) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'192.111938 146.152123 285.290819 129.902875 269.041571 223.081757 175.86269 239.331005'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M192.584863,146.625049 L176.5354,238.658295 L268.568646,222.608831 L284.618109,130.575585 L192.584863,146.625049 Z',stroke:'#979797',strokeWidth:'1.0942813'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(153.977064, 130.997156) rotate(45.000000) translate(-153.977064, -130.997156) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'115.512247 92.5323396 208.691128 76.2830914 192.44188 169.461973 99.2629986 185.711221'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M115.985172,93.0052651 L99.9357089,185.038511 L191.968955,168.989047 L208.018418,76.9558016 L115.985172,93.0052651 Z',stroke:'#979797',strokeWidth:'1.0942813'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(307.176445, 238.236724) rotate(45.000000) translate(-307.176445, -238.236724) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'268.711629 199.771907 361.89051 183.522659 345.641262 276.70154 252.46238 292.950788'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M269.184554,200.244832 L253.135091,292.278078 L345.168336,276.228615 L361.2178,184.195369 L269.184554,200.244832 Z',stroke:'#979797',strokeWidth:'1.0942813'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'10m',transform:'translate(535.103555, 107.239567)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(77.377373, 77.377373) rotate(45.000000) translate(-77.377373, -77.377373) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'38.912556 38.912556 132.091438 22.6633077 115.842189 115.842189 22.6633077 132.091438'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M39.3854815,39.3854815 L23.336018,131.418727 L115.369264,115.369264 L131.418727,23.336018 L39.3854815,39.3854815 Z',stroke:'#979797',strokeWidth:'1.0942813'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(383.776136, 291.856507) rotate(45.000000) translate(-383.776136, -291.856507) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'345.31132 253.39169 438.490201 237.142442 422.240953 330.321324 329.062071 346.570572'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M345.784245,253.864616 L329.734782,345.897862 L421.768027,329.848398 L437.817491,237.815152 L345.784245,253.864616 Z',stroke:'#979797',strokeWidth:'1.0942813'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(230.576754, 184.616940) rotate(45.000000) translate(-230.576754, -184.616940) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'192.111938 146.152123 285.290819 129.902875 269.041571 223.081757 175.86269 239.331005'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M192.584863,146.625049 L176.5354,238.658295 L268.568646,222.608831 L284.618109,130.575585 L192.584863,146.625049 Z',stroke:'#979797',strokeWidth:'1.0942813'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(153.977064, 130.997156) rotate(45.000000) translate(-153.977064, -130.997156) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'115.512247 92.5323396 208.691128 76.2830914 192.44188 169.461973 99.2629986 185.711221'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M115.985172,93.0052651 L99.9357089,185.038511 L191.968955,168.989047 L208.018418,76.9558016 L115.985172,93.0052651 Z',stroke:'#979797',strokeWidth:'1.0942813'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(307.176445, 238.236724) rotate(45.000000) translate(-307.176445, -238.236724) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'268.711629 199.771907 361.89051 183.522659 345.641262 276.70154 252.46238 292.950788'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M269.184554,200.244832 L253.135091,292.278078 L345.168336,276.228615 L361.2178,184.195369 L269.184554,200.244832 Z',stroke:'#979797',strokeWidth:'1.0942813'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'10m',transform:'translate(610.608964, 53.619784)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(77.377373, 77.377373) rotate(45.000000) translate(-77.377373, -77.377373) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'38.912556 38.912556 132.091438 22.6633077 115.842189 115.842189 22.6633077 132.091438'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M39.3854815,39.3854815 L23.336018,131.418727 L115.369264,115.369264 L131.418727,23.336018 L39.3854815,39.3854815 Z',stroke:'#979797',strokeWidth:'1.0942813'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(383.776136, 291.856507) rotate(45.000000) translate(-383.776136, -291.856507) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'345.31132 253.39169 438.490201 237.142442 422.240953 330.321324 329.062071 346.570572'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M345.784245,253.864616 L329.734782,345.897862 L421.768027,329.848398 L437.817491,237.815152 L345.784245,253.864616 Z',stroke:'#979797',strokeWidth:'1.0942813'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(230.576754, 184.616940) rotate(45.000000) translate(-230.576754, -184.616940) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'192.111938 146.152123 285.290819 129.902875 269.041571 223.081757 175.86269 239.331005'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M192.584863,146.625049 L176.5354,238.658295 L268.568646,222.608831 L284.618109,130.575585 L192.584863,146.625049 Z',stroke:'#979797',strokeWidth:'1.0942813'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(153.977064, 130.997156) rotate(45.000000) translate(-153.977064, -130.997156) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'115.512247 92.5323396 208.691128 76.2830914 192.44188 169.461973 99.2629986 185.711221'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M115.985172,93.0052651 L99.9357089,185.038511 L191.968955,168.989047 L208.018418,76.9558016 L115.985172,93.0052651 Z',stroke:'#979797',strokeWidth:'1.0942813'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(307.176445, 238.236724) rotate(45.000000) translate(-307.176445, -238.236724) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'268.711629 199.771907 361.89051 183.522659 345.641262 276.70154 252.46238 292.950788'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M269.184554,200.244832 L253.135091,292.278078 L345.168336,276.228615 L361.2178,184.195369 L269.184554,200.244832 Z',stroke:'#979797',strokeWidth:'1.0942813'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'10m',transform:'translate(687.208655, 0.000000)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(77.377373, 77.377373) rotate(45.000000) translate(-77.377373, -77.377373) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'38.912556 38.912556 132.091438 22.6633077 115.842189 115.842189 22.6633077 132.091438'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M39.3854815,39.3854815 L23.336018,131.418727 L115.369264,115.369264 L131.418727,23.336018 L39.3854815,39.3854815 Z',stroke:'#979797',strokeWidth:'1.0942813'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(383.776136, 291.856507) rotate(45.000000) translate(-383.776136, -291.856507) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'345.31132 253.39169 438.490201 237.142442 422.240953 330.321324 329.062071 346.570572'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M345.784245,253.864616 L329.734782,345.897862 L421.768027,329.848398 L437.817491,237.815152 L345.784245,253.864616 Z',stroke:'#979797',strokeWidth:'1.0942813'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(155.071345, 559.955425) rotate(45.000000) translate(-155.071345, -559.955425) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'116.606528 521.490609 209.78541 505.24136 193.536161 598.420242 100.35728 614.66949'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M117.079454,521.963534 L101.02999,613.99678 L193.063236,597.947316 L209.112699,505.914071 L117.079454,521.963534 Z',stroke:'#979797',strokeWidth:'1.0942813'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(78.471654, 613.575209) rotate(45.000000) translate(-78.471654, -613.575209) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'40.0068373 575.110392 133.185719 558.861144 116.936471 652.040025 23.757589 668.289274'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M40.4797628,575.583318 L24.4302993,667.616563 L116.463545,651.5671 L132.513009,559.533854 L40.4797628,575.583318 Z',stroke:'#979797',strokeWidth:'1.0942813'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(231.671036, 506.335642) rotate(45.000000) translate(-231.671036, -506.335642) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'193.206219 467.870825 286.385101 451.621577 270.135852 544.800458 176.956971 561.049707'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M193.679145,468.34375 L177.629681,560.376996 L269.662927,544.327533 L285.71239,452.294287 L193.679145,468.34375 Z',stroke:'#979797',strokeWidth:'1.0942813'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(308.270727, 452.715858) rotate(45.000000) translate(-308.270727, -452.715858) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'269.80591 414.251041 362.984792 398.001793 346.735543 491.180675 253.556662 507.429923'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M270.278835,414.723967 L254.229372,506.757213 L346.262618,490.707749 L362.312081,398.674503 L270.278835,414.723967 Z',stroke:'#979797',strokeWidth:'1.0942813'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(383.776136, 399.096074) rotate(45.000000) translate(-383.776136, -399.096074) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'345.31132 360.631258 438.490201 344.382009 422.240953 437.560891 329.062071 453.810139'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M345.784245,361.104183 L329.734782,453.137429 L421.768027,437.087965 L437.817491,345.05472 L345.784245,361.104183 Z',stroke:'#979797',strokeWidth:'1.0942813'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(460.375827, 345.476291) rotate(45.000000) translate(-460.375827, -345.476291) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'421.91101 307.011474 515.089892 290.762226 498.840644 383.941107 405.661762 400.190356'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M422.383936,307.4844 L406.334472,399.517645 L498.367718,383.468182 L514.417182,291.434936 L422.383936,307.4844 Z',stroke:'#979797',strokeWidth:'1.0942813'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(230.576754, 184.616940) rotate(45.000000) translate(-230.576754, -184.616940) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'192.111938 146.152123 285.290819 129.902875 269.041571 223.081757 175.86269 239.331005'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M192.584863,146.625049 L176.5354,238.658295 L268.568646,222.608831 L284.618109,130.575585 L192.584863,146.625049 Z',stroke:'#979797',strokeWidth:'1.0942813'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(153.977064, 130.997156) rotate(45.000000) translate(-153.977064, -130.997156) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'115.512247 92.5323396 208.691128 76.2830914 192.44188 169.461973 99.2629986 185.711221'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M115.985172,93.0052651 L99.9357089,185.038511 L191.968955,168.989047 L208.018418,76.9558016 L115.985172,93.0052651 Z',stroke:'#979797',strokeWidth:'1.0942813'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(307.176445, 238.236724) rotate(45.000000) translate(-307.176445, -238.236724) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'268.711629 199.771907 361.89051 183.522659 345.641262 276.70154 252.46238 292.950788'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M269.184554,200.244832 L253.135091,292.278078 L345.168336,276.228615 L361.2178,184.195369 L269.184554,200.244832 Z',stroke:'#979797',strokeWidth:'1.0942813'})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Desk,{ratio:this.state.ratio}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Pretreat,{ratio:this.state.ratio}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Press2,{ratio:this.state.ratio}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Press1,{ratio:this.state.ratio}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Gtx1,{ratio:this.state.ratio}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Gtx2,{ratio:this.state.ratio}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Senddesk,{ratio:this.state.ratio}));}}]);return RoomS;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (RoomS);var Gtx1=function(_React$Component2){_inherits(Gtx1,_React$Component2);function Gtx1(props){_classCallCheck(this,Gtx1);var _this2=_possibleConstructorReturn(this,(Gtx1.__proto__||Object.getPrototypeOf(Gtx1)).call(this,props));_this2.state={originalWidth:385,originalHeight:274,x:0,y:-500,opacity:0,ratio:parseFloat(props.ratio)};_this2.state=Object.assign({},_this2.state,{width:_this2.state.originalWidth/_this2.state.ratio,height:_this2.state.originalHeight/_this2.state.ratio});return _this2;}_createClass(Gtx1,[{key:'getKeyFrames',value:function getKeyFrames(){return[{transform:'translateY(-500px)',opacity:0,offset:0},{opacity:1,offset:1},{transform:'translateY(0)',opacity:1,offset:1}];}},{key:'getTiming',value:function getTiming(duration){return{duration:duration,easing:'ease-in',delay:0,iterations:1,fill:'forwards'};}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_web_animation__["Animated"].img,{keyframes:this.getKeyFrames(),timing:this.getTiming(750),style:{position:'absolute',top:510/this.state.ratio,left:601/this.state.ratio,opacity:this.state.opacity,transform:[{translateY:this.state.y}],width:this.state.width,height:'auto'},src:__webpack_require__(3)});}}]);return Gtx1;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var Gtx2=function(_React$Component3){_inherits(Gtx2,_React$Component3);function Gtx2(props){_classCallCheck(this,Gtx2);var _this3=_possibleConstructorReturn(this,(Gtx2.__proto__||Object.getPrototypeOf(Gtx2)).call(this,props));_this3.state={originalWidth:385,originalHeight:274,x:0,y:-500,opacity:0,ratio:parseFloat(props.ratio)};_this3.state=Object.assign({},_this3.state,{width:_this3.state.originalWidth/_this3.state.ratio,height:_this3.state.originalHeight/_this3.state.ratio});return _this3;}_createClass(Gtx2,[{key:'getKeyFrames',value:function getKeyFrames(){return[{transform:'translateY(-500px)',opacity:0,offset:0},{opacity:1,offset:1},{transform:'translateY(0)',opacity:1,offset:1}];}},{key:'getTiming',value:function getTiming(duration){return{duration:duration,easing:'ease-in',delay:0,iterations:1,fill:'forwards'};}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_web_animation__["Animated"].img,{keyframes:this.getKeyFrames(),timing:this.getTiming(750),style:{position:'absolute',top:402/this.state.ratio,left:449/this.state.ratio,opacity:this.state.opacity,transform:[{translateY:this.state.y}],width:this.state.width,height:'auto'},src:__webpack_require__(3)});}}]);return Gtx2;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var Senddesk=function(_React$Component4){_inherits(Senddesk,_React$Component4);function Senddesk(props){_classCallCheck(this,Senddesk);var _this4=_possibleConstructorReturn(this,(Senddesk.__proto__||Object.getPrototypeOf(Senddesk)).call(this,props));_this4.state={originalWidth:309,originalHeight:248,x:0,y:-500,opacity:0,ratio:parseFloat(props.ratio)};_this4.state=Object.assign({},_this4.state,{width:_this4.state.originalWidth/_this4.state.ratio,height:_this4.state.originalHeight/_this4.state.ratio});return _this4;}_createClass(Senddesk,[{key:'getKeyFrames',value:function getKeyFrames(){return[{transform:'translateY(-500px)',opacity:0,offset:0},{opacity:1,offset:1},{transform:'translateY(0)',opacity:1,offset:1}];}},{key:'getTiming',value:function getTiming(duration){return{duration:duration,easing:'ease-in',delay:0,iterations:1,fill:'forwards'};}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_web_animation__["Animated"].img,{keyframes:this.getKeyFrames(),timing:this.getTiming(750),style:{position:'absolute',top:591/this.state.ratio,left:371/this.state.ratio,opacity:this.state.opacity,transform:[{translateY:this.state.y}],width:this.state.width,height:'auto'},src:__webpack_require__(19)});}}]);return Senddesk;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var Desk=function(_React$Component5){_inherits(Desk,_React$Component5);function Desk(props){_classCallCheck(this,Desk);var _this5=_possibleConstructorReturn(this,(Desk.__proto__||Object.getPrototypeOf(Desk)).call(this,props));_this5.state={originalWidth:309,originalHeight:218,x:0,y:-500,opacity:0,ratio:parseFloat(props.ratio)};_this5.state=Object.assign({},_this5.state,{width:_this5.state.originalWidth/_this5.state.ratio,height:_this5.state.originalHeight/_this5.state.ratio});return _this5;}_createClass(Desk,[{key:'getKeyFrames',value:function getKeyFrames(){return[{transform:'translateY(-500px)',opacity:0,offset:0},{opacity:1,offset:1},{transform:'translateY(0)',opacity:1,offset:1}];}},{key:'getTiming',value:function getTiming(duration){return{duration:duration,easing:'ease-in',delay:0,iterations:1,fill:'forwards'};}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_web_animation__["Animated"].img,{keyframes:this.getKeyFrames(),timing:this.getTiming(750),style:{position:'absolute',top:458/this.state.ratio,left:143/this.state.ratio,opacity:this.state.opacity,transform:[{translateY:this.state.y}],width:this.state.width,height:'auto'},src:__webpack_require__(17)});}}]);return Desk;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var Press1=function(_React$Component6){_inherits(Press1,_React$Component6);function Press1(props){_classCallCheck(this,Press1);var _this6=_possibleConstructorReturn(this,(Press1.__proto__||Object.getPrototypeOf(Press1)).call(this,props));_this6.state={originalWidth:233,originalHeight:341,x:0,y:-500,opacity:0,ratio:parseFloat(props.ratio)};_this6.state=Object.assign({},_this6.state,{width:_this6.state.originalWidth/_this6.state.ratio,height:_this6.state.originalHeight/_this6.state.ratio});return _this6;}_createClass(Press1,[{key:'getKeyFrames',value:function getKeyFrames(){return[{transform:'translateY(-500px)',opacity:0,offset:0},{opacity:1,offset:1},{transform:'translateY(0)',opacity:1,offset:1}];}},{key:'getTiming',value:function getTiming(duration){return{duration:duration,easing:'ease-in',delay:0,iterations:1,fill:'forwards'};}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_web_animation__["Animated"].img,{keyframes:this.getKeyFrames(),timing:this.getTiming(750),style:{position:'absolute',top:340/this.state.ratio,left:295/this.state.ratio,opacity:this.state.opacity,transform:[{translateY:this.state.y}],width:this.state.width,height:'auto'},src:__webpack_require__(18)});}}]);return Press1;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var Press2=function(_React$Component7){_inherits(Press2,_React$Component7);function Press2(props){_classCallCheck(this,Press2);var _this7=_possibleConstructorReturn(this,(Press2.__proto__||Object.getPrototypeOf(Press2)).call(this,props));_this7.state={originalWidth:233,originalHeight:341,x:0,y:-500,opacity:0,ratio:parseFloat(props.ratio)};_this7.state=Object.assign({},_this7.state,{width:_this7.state.originalWidth/_this7.state.ratio,height:_this7.state.originalHeight/_this7.state.ratio});return _this7;}_createClass(Press2,[{key:'getKeyFrames',value:function getKeyFrames(){return[{transform:'translateY(-500px)',opacity:0,offset:0},{opacity:1,offset:1},{transform:'translateY(0)',opacity:1,offset:1}];}},{key:'getTiming',value:function getTiming(duration){return{duration:duration,easing:'ease-in',delay:0,iterations:1,fill:'forwards'};}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_web_animation__["Animated"].img,{keyframes:this.getKeyFrames(),timing:this.getTiming(750),style:{position:'absolute',top:285/this.state.ratio,left:372/this.state.ratio,opacity:this.state.opacity,transform:[{translateY:this.state.y}],width:this.state.width,height:'auto'},src:__webpack_require__(18)});}}]);return Press2;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var Pretreat=function(_React$Component8){_inherits(Pretreat,_React$Component8);function Pretreat(props){_classCallCheck(this,Pretreat);var _this8=_possibleConstructorReturn(this,(Pretreat.__proto__||Object.getPrototypeOf(Pretreat)).call(this,props));_this8.state={originalWidth:233,originalHeight:243,x:0,y:-500,opacity:0,ratio:parseFloat(props.ratio)};_this8.state=Object.assign({},_this8.state,{width:_this8.state.originalWidth/_this8.state.ratio,height:_this8.state.originalHeight/_this8.state.ratio});return _this8;}_createClass(Pretreat,[{key:'getKeyFrames',value:function getKeyFrames(){return[{transform:'translateY(-500px)',opacity:0,offset:0},{opacity:1,offset:1},{transform:'translateY(0)',opacity:1,offset:1}];}},{key:'getTiming',value:function getTiming(duration){return{duration:duration,easing:'ease-in',delay:0,iterations:1,fill:'forwards'};}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_web_animation__["Animated"].img,{keyframes:this.getKeyFrames(),timing:this.getTiming(750),style:{position:'absolute',top:241/this.state.ratio,left:444/this.state.ratio,opacity:this.state.opacity,transform:[{translateY:this.state.y}],width:this.state.width,height:'auto'},src:__webpack_require__(28)});}}]);return Pretreat;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_web_animation__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_web_animation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_web_animation__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RoomM=function(_React$Component){_inherits(RoomM,_React$Component);function RoomM(props){_classCallCheck(this,RoomM);var _this=_possibleConstructorReturn(this,(RoomM.__proto__||Object.getPrototypeOf(RoomM)).call(this,props));_this.state={originalWidth:1051,originalHeight:944};_this.state=Object.assign({},_this.state,{width:parseFloat(props.width),height:_this.state.originalHeight/(_this.state.originalWidth/parseFloat(props.width)),ratio:_this.state.originalWidth/parseFloat(props.width)});return _this;}_createClass(RoomM,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{height:this.state.height,width:this.state.width,viewBox:'0 0 '+this.state.originalWidth+' '+this.state.originalHeight},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('defs',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-1',points:'31.6684575 31.6684575 107.50083 18.4442266 94.2765994 94.2765994 18.4442266 107.50083'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-2',points:'281.026948 206.219401 356.859321 192.99517 343.63509 268.827543 267.802717 282.051774'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-3',points:'156.347703 118.943929 232.180076 105.719698 218.955845 181.552071 143.123472 194.776302'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-4',points:'405.706193 293.494873 481.538566 280.270642 468.314335 356.103014 392.481962 369.327245'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-5',points:'94.0080802 75.3061934 169.840453 62.0819624 156.616222 137.914335 80.7838492 151.138566'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-6',points:'343.366571 249.857137 419.198944 236.632906 405.974713 312.465279 330.14234 325.68951'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-7',points:'218.687325 162.581665 294.519698 149.357434 281.295467 225.189807 205.463094 238.414038'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-8',points:'468.045816 337.132608 543.878189 323.908377 530.653958 399.74075 454.821585 412.964981'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-9',points:'31.6684575 31.6684575 107.50083 18.4442266 94.2765994 94.2765994 18.4442266 107.50083'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-10',points:'281.026948 206.219401 356.859321 192.99517 343.63509 268.827543 267.802717 282.051774'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-11',points:'156.347703 118.943929 232.180076 105.719698 218.955845 181.552071 143.123472 194.776302'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-12',points:'405.706193 293.494873 481.538566 280.270642 468.314335 356.103014 392.481962 369.327245'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-13',points:'94.0080802 75.3061934 169.840453 62.0819624 156.616222 137.914335 80.7838492 151.138566'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-14',points:'343.366571 249.857137 419.198944 236.632906 405.974713 312.465279 330.14234 325.68951'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-15',points:'218.687325 162.581665 294.519698 149.357434 281.295467 225.189807 205.463094 238.414038'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-16',points:'468.045816 337.132608 543.878189 323.908377 530.653958 399.74075 454.821585 412.964981'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-17',points:'31.6684575 31.6684575 107.50083 18.4442266 94.2765994 94.2765994 18.4442266 107.50083'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-18',points:'281.026948 206.219401 356.859321 192.99517 343.63509 268.827543 267.802717 282.051774'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-19',points:'156.347703 118.943929 232.180076 105.719698 218.955845 181.552071 143.123472 194.776302'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-20',points:'405.706193 293.494873 481.538566 280.270642 468.314335 356.103014 392.481962 369.327245'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-21',points:'94.0080802 75.3061934 169.840453 62.0819624 156.616222 137.914335 80.7838492 151.138566'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-22',points:'343.366571 249.857137 419.198944 236.632906 405.974713 312.465279 330.14234 325.68951'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-23',points:'218.687325 162.581665 294.519698 149.357434 281.295467 225.189807 205.463094 238.414038'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-24',points:'468.045816 337.132608 543.878189 323.908377 530.653958 399.74075 454.821585 412.964981'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-25',points:'31.6684575 31.6684575 107.50083 18.4442266 94.2765994 94.2765994 18.4442266 107.50083'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-26',points:'281.026948 206.219401 356.859321 192.99517 343.63509 268.827543 267.802717 282.051774'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-27',points:'156.347703 118.943929 232.180076 105.719698 218.955845 181.552071 143.123472 194.776302'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-28',points:'405.706193 293.494873 481.538566 280.270642 468.314335 356.103014 392.481962 369.327245'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-29',points:'94.0080802 75.3061934 169.840453 62.0819624 156.616222 137.914335 80.7838492 151.138566'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-30',points:'343.366571 249.857137 419.198944 236.632906 405.974713 312.465279 330.14234 325.68951'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-31',points:'218.687325 162.581665 294.519698 149.357434 281.295467 225.189807 205.463094 238.414038'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-32',points:'468.045816 337.132608 543.878189 323.908377 530.653958 399.74075 454.821585 412.964981'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-33',points:'31.6684575 31.6684575 107.50083 18.4442266 94.2765994 94.2765994 18.4442266 107.50083'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-34',points:'281.026948 206.219401 356.859321 192.99517 343.63509 268.827543 267.802717 282.051774'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-35',points:'156.347703 118.943929 232.180076 105.719698 218.955845 181.552071 143.123472 194.776302'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-36',points:'405.706193 293.494873 481.538566 280.270642 468.314335 356.103014 392.481962 369.327245'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-37',points:'94.0080802 75.3061934 169.840453 62.0819624 156.616222 137.914335 80.7838492 151.138566'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-38',points:'343.366571 249.857137 419.198944 236.632906 405.974713 312.465279 330.14234 325.68951'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-39',points:'218.687325 162.581665 294.519698 149.357434 281.295467 225.189807 205.463094 238.414038'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-40',points:'468.045816 337.132608 543.878189 323.908377 530.653958 399.74075 454.821585 412.964981'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-41',points:'31.6684575 31.6684575 107.50083 18.4442266 94.2765994 94.2765994 18.4442266 107.50083'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-42',points:'281.026948 206.219401 356.859321 192.99517 343.63509 268.827543 267.802717 282.051774'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-43',points:'156.347703 118.943929 232.180076 105.719698 218.955845 181.552071 143.123472 194.776302'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-44',points:'405.706193 293.494873 481.538566 280.270642 468.314335 356.103014 392.481962 369.327245'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-45',points:'94.0080802 75.3061934 169.840453 62.0819624 156.616222 137.914335 80.7838492 151.138566'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-46',points:'343.366571 249.857137 419.198944 236.632906 405.974713 312.465279 330.14234 325.68951'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-47',points:'218.687325 162.581665 294.519698 149.357434 281.295467 225.189807 205.463094 238.414038'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-48',points:'468.045816 337.132608 543.878189 323.908377 530.653958 399.74075 454.821585 412.964981'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-49',points:'31.6684575 31.6684575 107.50083 18.4442266 94.2765994 94.2765994 18.4442266 107.50083'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-50',points:'281.026948 206.219401 356.859321 192.99517 343.63509 268.827543 267.802717 282.051774'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-51',points:'156.347703 118.943929 232.180076 105.719698 218.955845 181.552071 143.123472 194.776302'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-52',points:'405.706193 293.494873 481.538566 280.270642 468.314335 356.103014 392.481962 369.327245'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-53',points:'94.0080802 75.3061934 169.840453 62.0819624 156.616222 137.914335 80.7838492 151.138566'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-54',points:'343.366571 249.857137 419.198944 236.632906 405.974713 312.465279 330.14234 325.68951'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-55',points:'218.687325 162.581665 294.519698 149.357434 281.295467 225.189807 205.463094 238.414038'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-56',points:'468.045816 337.132608 543.878189 323.908377 530.653958 399.74075 454.821585 412.964981'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-57',points:'31.6684575 31.6684575 107.50083 18.4442266 94.2765994 94.2765994 18.4442266 107.50083'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-58',points:'281.026948 206.219401 356.859321 192.99517 343.63509 268.827543 267.802717 282.051774'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-59',points:'156.347703 118.943929 232.180076 105.719698 218.955845 181.552071 143.123472 194.776302'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-60',points:'405.706193 293.494873 481.538566 280.270642 468.314335 356.103014 392.481962 369.327245'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-61',points:'94.0080802 75.3061934 169.840453 62.0819624 156.616222 137.914335 80.7838492 151.138566'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-62',points:'343.366571 249.857137 419.198944 236.632906 405.974713 312.465279 330.14234 325.68951'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-63',points:'218.687325 162.581665 294.519698 149.357434 281.295467 225.189807 205.463094 238.414038'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-64',points:'468.045816 337.132608 543.878189 323.908377 530.653958 399.74075 454.821585 412.964981'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Packages/M',fill:'none',fillRule:'evenodd',stroke:'none',strokeWidth:'1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'Rectangle-8',fill:'#DFDFDF',points:'41.209039 196.948752 651.381485 197.121839 512.291038 395.248123 -97.881408 395.075036',transform:'translate(276.750039, 296.098438) rotate(-35.000000) translate(-276.750039, -296.098438) '}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'Rectangle-8',fill:'#929292',points:'541.039486 198.142862 1148.14134 197.927137 1009.26112 396.226508 402.440706 396.040391',transform:'translate(775.291021, 297.076822) scale(-1, 1) rotate(-35.000000) translate(-775.291021, -297.076822) '}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Boden/8x8',transform:'translate(-98.000000, 224.000000)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'10m',transform:'translate(124.679245, 305.464151)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(62.972528, 62.972528) rotate(45.000000) translate(-62.972528, -62.972528) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'31.6684575 31.6684575 107.50083 18.4442266 94.2765994 94.2765994 18.4442266 107.50083'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M32.0533416,32.0533416 L18.9917027,106.953354 L93.8917153,93.8917153 L106.953354,18.9917027 L32.0533416,32.0533416 Z',stroke:'#979797',strokeWidth:'0.890566038'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(312.331019, 237.523472) rotate(45.000000) translate(-312.331019, -237.523472) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'281.026948 206.219401 356.859321 192.99517 343.63509 268.827543 267.802717 282.051774'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M281.411832,206.604285 L268.350193,281.504298 L343.250206,268.442659 L356.311845,193.542646 L281.411832,206.604285 Z',stroke:'#979797',strokeWidth:'0.890566038'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(187.651774, 150.248000) rotate(45.000000) translate(-187.651774, -150.248000) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'156.347703 118.943929 232.180076 105.719698 218.955845 181.552071 143.123472 194.776302'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M156.732587,119.328813 L143.670948,194.228826 L218.570961,181.167187 L231.632599,106.267174 L156.732587,119.328813 Z',stroke:'#979797',strokeWidth:'0.890566038'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(437.010264, 324.798944) rotate(45.000000) translate(-437.010264, -324.798944) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'405.706193 293.494873 481.538566 280.270642 468.314335 356.103014 392.481962 369.327245'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M406.091077,293.879757 L393.029439,368.779769 L467.929451,355.71813 L480.99109,280.818118 L406.091077,293.879757 Z',stroke:'#979797',strokeWidth:'0.890566038'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(125.312151, 106.610264) rotate(45.000000) translate(-125.312151, -106.610264) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'94.0080802 75.3061934 169.840453 62.0819624 156.616222 137.914335 80.7838492 151.138566'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M94.3929642,75.6910774 L81.3313254,150.59109 L156.231338,137.529451 L169.292977,62.6294386 L94.3929642,75.6910774 Z',stroke:'#979797',strokeWidth:'0.890566038'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(374.670642, 281.161208) rotate(45.000000) translate(-374.670642, -281.161208) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'343.366571 249.857137 419.198944 236.632906 405.974713 312.465279 330.14234 325.68951'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M343.751455,250.242021 L330.689816,325.142033 L405.589829,312.080395 L418.651467,237.180382 L343.751455,250.242021 Z',stroke:'#979797',strokeWidth:'0.890566038'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(249.991396, 193.885736) rotate(45.000000) translate(-249.991396, -193.885736) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'218.687325 162.581665 294.519698 149.357434 281.295467 225.189807 205.463094 238.414038'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M219.072209,162.966549 L206.010571,237.866562 L280.910583,224.804923 L293.972222,149.90491 L219.072209,162.966549 Z',stroke:'#979797',strokeWidth:'0.890566038'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(499.349887, 368.436679) rotate(45.000000) translate(-499.349887, -368.436679) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'468.045816 337.132608 543.878189 323.908377 530.653958 399.74075 454.821585 412.964981'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M468.4307,337.517493 L455.369061,412.417505 L530.269074,399.355866 L543.330713,324.455854 L468.4307,337.517493 Z',stroke:'#979797',strokeWidth:'0.890566038'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'10m',transform:'translate(187.018868, 261.826415)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(62.972528, 62.972528) rotate(45.000000) translate(-62.972528, -62.972528) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'31.6684575 31.6684575 107.50083 18.4442266 94.2765994 94.2765994 18.4442266 107.50083'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M32.0533416,32.0533416 L18.9917027,106.953354 L93.8917153,93.8917153 L106.953354,18.9917027 L32.0533416,32.0533416 Z',stroke:'#979797',strokeWidth:'0.890566038'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(312.331019, 237.523472) rotate(45.000000) translate(-312.331019, -237.523472) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'281.026948 206.219401 356.859321 192.99517 343.63509 268.827543 267.802717 282.051774'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M281.411832,206.604285 L268.350193,281.504298 L343.250206,268.442659 L356.311845,193.542646 L281.411832,206.604285 Z',stroke:'#979797',strokeWidth:'0.890566038'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(187.651774, 150.248000) rotate(45.000000) translate(-187.651774, -150.248000) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'156.347703 118.943929 232.180076 105.719698 218.955845 181.552071 143.123472 194.776302'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M156.732587,119.328813 L143.670948,194.228826 L218.570961,181.167187 L231.632599,106.267174 L156.732587,119.328813 Z',stroke:'#979797',strokeWidth:'0.890566038'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(437.010264, 324.798944) rotate(45.000000) translate(-437.010264, -324.798944) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'405.706193 293.494873 481.538566 280.270642 468.314335 356.103014 392.481962 369.327245'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M406.091077,293.879757 L393.029439,368.779769 L467.929451,355.71813 L480.99109,280.818118 L406.091077,293.879757 Z',stroke:'#979797',strokeWidth:'0.890566038'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(125.312151, 106.610264) rotate(45.000000) translate(-125.312151, -106.610264) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'94.0080802 75.3061934 169.840453 62.0819624 156.616222 137.914335 80.7838492 151.138566'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M94.3929642,75.6910774 L81.3313254,150.59109 L156.231338,137.529451 L169.292977,62.6294386 L94.3929642,75.6910774 Z',stroke:'#979797',strokeWidth:'0.890566038'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(374.670642, 281.161208) rotate(45.000000) translate(-374.670642, -281.161208) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'343.366571 249.857137 419.198944 236.632906 405.974713 312.465279 330.14234 325.68951'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M343.751455,250.242021 L330.689816,325.142033 L405.589829,312.080395 L418.651467,237.180382 L343.751455,250.242021 Z',stroke:'#979797',strokeWidth:'0.890566038'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(249.991396, 193.885736) rotate(45.000000) translate(-249.991396, -193.885736) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'218.687325 162.581665 294.519698 149.357434 281.295467 225.189807 205.463094 238.414038'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M219.072209,162.966549 L206.010571,237.866562 L280.910583,224.804923 L293.972222,149.90491 L219.072209,162.966549 Z',stroke:'#979797',strokeWidth:'0.890566038'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(499.349887, 368.436679) rotate(45.000000) translate(-499.349887, -368.436679) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'468.045816 337.132608 543.878189 323.908377 530.653958 399.74075 454.821585 412.964981'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M468.4307,337.517493 L455.369061,412.417505 L530.269074,399.355866 L543.330713,324.455854 L468.4307,337.517493 Z',stroke:'#979797',strokeWidth:'0.890566038'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'10m',transform:'translate(248.467925, 218.188679)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(62.972528, 62.972528) rotate(45.000000) translate(-62.972528, -62.972528) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'31.6684575 31.6684575 107.50083 18.4442266 94.2765994 94.2765994 18.4442266 107.50083'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M32.0533416,32.0533416 L18.9917027,106.953354 L93.8917153,93.8917153 L106.953354,18.9917027 L32.0533416,32.0533416 Z',stroke:'#979797',strokeWidth:'0.890566038'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(312.331019, 237.523472) rotate(45.000000) translate(-312.331019, -237.523472) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'281.026948 206.219401 356.859321 192.99517 343.63509 268.827543 267.802717 282.051774'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M281.411832,206.604285 L268.350193,281.504298 L343.250206,268.442659 L356.311845,193.542646 L281.411832,206.604285 Z',stroke:'#979797',strokeWidth:'0.890566038'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(187.651774, 150.248000) rotate(45.000000) translate(-187.651774, -150.248000) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'156.347703 118.943929 232.180076 105.719698 218.955845 181.552071 143.123472 194.776302'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M156.732587,119.328813 L143.670948,194.228826 L218.570961,181.167187 L231.632599,106.267174 L156.732587,119.328813 Z',stroke:'#979797',strokeWidth:'0.890566038'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(437.010264, 324.798944) rotate(45.000000) translate(-437.010264, -324.798944) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'405.706193 293.494873 481.538566 280.270642 468.314335 356.103014 392.481962 369.327245'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M406.091077,293.879757 L393.029439,368.779769 L467.929451,355.71813 L480.99109,280.818118 L406.091077,293.879757 Z',stroke:'#979797',strokeWidth:'0.890566038'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(125.312151, 106.610264) rotate(45.000000) translate(-125.312151, -106.610264) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'94.0080802 75.3061934 169.840453 62.0819624 156.616222 137.914335 80.7838492 151.138566'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M94.3929642,75.6910774 L81.3313254,150.59109 L156.231338,137.529451 L169.292977,62.6294386 L94.3929642,75.6910774 Z',stroke:'#979797',strokeWidth:'0.890566038'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(374.670642, 281.161208) rotate(45.000000) translate(-374.670642, -281.161208) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'343.366571 249.857137 419.198944 236.632906 405.974713 312.465279 330.14234 325.68951'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M343.751455,250.242021 L330.689816,325.142033 L405.589829,312.080395 L418.651467,237.180382 L343.751455,250.242021 Z',stroke:'#979797',strokeWidth:'0.890566038'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(249.991396, 193.885736) rotate(45.000000) translate(-249.991396, -193.885736) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'218.687325 162.581665 294.519698 149.357434 281.295467 225.189807 205.463094 238.414038'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M219.072209,162.966549 L206.010571,237.866562 L280.910583,224.804923 L293.972222,149.90491 L219.072209,162.966549 Z',stroke:'#979797',strokeWidth:'0.890566038'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(499.349887, 368.436679) rotate(45.000000) translate(-499.349887, -368.436679) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'468.045816 337.132608 543.878189 323.908377 530.653958 399.74075 454.821585 412.964981'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M468.4307,337.517493 L455.369061,412.417505 L530.269074,399.355866 L543.330713,324.455854 L468.4307,337.517493 Z',stroke:'#979797',strokeWidth:'0.890566038'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'10m',transform:'translate(310.807547, 174.550943)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(62.972528, 62.972528) rotate(45.000000) translate(-62.972528, -62.972528) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'31.6684575 31.6684575 107.50083 18.4442266 94.2765994 94.2765994 18.4442266 107.50083'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M32.0533416,32.0533416 L18.9917027,106.953354 L93.8917153,93.8917153 L106.953354,18.9917027 L32.0533416,32.0533416 Z',stroke:'#979797',strokeWidth:'0.890566038'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(312.331019, 237.523472) rotate(45.000000) translate(-312.331019, -237.523472) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'281.026948 206.219401 356.859321 192.99517 343.63509 268.827543 267.802717 282.051774'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M281.411832,206.604285 L268.350193,281.504298 L343.250206,268.442659 L356.311845,193.542646 L281.411832,206.604285 Z',stroke:'#979797',strokeWidth:'0.890566038'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(187.651774, 150.248000) rotate(45.000000) translate(-187.651774, -150.248000) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'156.347703 118.943929 232.180076 105.719698 218.955845 181.552071 143.123472 194.776302'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M156.732587,119.328813 L143.670948,194.228826 L218.570961,181.167187 L231.632599,106.267174 L156.732587,119.328813 Z',stroke:'#979797',strokeWidth:'0.890566038'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(437.010264, 324.798944) rotate(45.000000) translate(-437.010264, -324.798944) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'405.706193 293.494873 481.538566 280.270642 468.314335 356.103014 392.481962 369.327245'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M406.091077,293.879757 L393.029439,368.779769 L467.929451,355.71813 L480.99109,280.818118 L406.091077,293.879757 Z',stroke:'#979797',strokeWidth:'0.890566038'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(125.312151, 106.610264) rotate(45.000000) translate(-125.312151, -106.610264) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'94.0080802 75.3061934 169.840453 62.0819624 156.616222 137.914335 80.7838492 151.138566'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M94.3929642,75.6910774 L81.3313254,150.59109 L156.231338,137.529451 L169.292977,62.6294386 L94.3929642,75.6910774 Z',stroke:'#979797',strokeWidth:'0.890566038'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(374.670642, 281.161208) rotate(45.000000) translate(-374.670642, -281.161208) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'343.366571 249.857137 419.198944 236.632906 405.974713 312.465279 330.14234 325.68951'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M343.751455,250.242021 L330.689816,325.142033 L405.589829,312.080395 L418.651467,237.180382 L343.751455,250.242021 Z',stroke:'#979797',strokeWidth:'0.890566038'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(249.991396, 193.885736) rotate(45.000000) translate(-249.991396, -193.885736) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'218.687325 162.581665 294.519698 149.357434 281.295467 225.189807 205.463094 238.414038'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M219.072209,162.966549 L206.010571,237.866562 L280.910583,224.804923 L293.972222,149.90491 L219.072209,162.966549 Z',stroke:'#979797',strokeWidth:'0.890566038'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(499.349887, 368.436679) rotate(45.000000) translate(-499.349887, -368.436679) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'468.045816 337.132608 543.878189 323.908377 530.653958 399.74075 454.821585 412.964981'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M468.4307,337.517493 L455.369061,412.417505 L530.269074,399.355866 L543.330713,324.455854 L468.4307,337.517493 Z',stroke:'#979797',strokeWidth:'0.890566038'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'10m',transform:'translate(373.147170, 130.913208)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(62.972528, 62.972528) rotate(45.000000) translate(-62.972528, -62.972528) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'31.6684575 31.6684575 107.50083 18.4442266 94.2765994 94.2765994 18.4442266 107.50083'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M32.0533416,32.0533416 L18.9917027,106.953354 L93.8917153,93.8917153 L106.953354,18.9917027 L32.0533416,32.0533416 Z',stroke:'#979797',strokeWidth:'0.890566038'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(312.331019, 237.523472) rotate(45.000000) translate(-312.331019, -237.523472) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'281.026948 206.219401 356.859321 192.99517 343.63509 268.827543 267.802717 282.051774'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M281.411832,206.604285 L268.350193,281.504298 L343.250206,268.442659 L356.311845,193.542646 L281.411832,206.604285 Z',stroke:'#979797',strokeWidth:'0.890566038'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(187.651774, 150.248000) rotate(45.000000) translate(-187.651774, -150.248000) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'156.347703 118.943929 232.180076 105.719698 218.955845 181.552071 143.123472 194.776302'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M156.732587,119.328813 L143.670948,194.228826 L218.570961,181.167187 L231.632599,106.267174 L156.732587,119.328813 Z',stroke:'#979797',strokeWidth:'0.890566038'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(437.010264, 324.798944) rotate(45.000000) translate(-437.010264, -324.798944) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'405.706193 293.494873 481.538566 280.270642 468.314335 356.103014 392.481962 369.327245'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M406.091077,293.879757 L393.029439,368.779769 L467.929451,355.71813 L480.99109,280.818118 L406.091077,293.879757 Z',stroke:'#979797',strokeWidth:'0.890566038'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(125.312151, 106.610264) rotate(45.000000) translate(-125.312151, -106.610264) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'94.0080802 75.3061934 169.840453 62.0819624 156.616222 137.914335 80.7838492 151.138566'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M94.3929642,75.6910774 L81.3313254,150.59109 L156.231338,137.529451 L169.292977,62.6294386 L94.3929642,75.6910774 Z',stroke:'#979797',strokeWidth:'0.890566038'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(374.670642, 281.161208) rotate(45.000000) translate(-374.670642, -281.161208) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'343.366571 249.857137 419.198944 236.632906 405.974713 312.465279 330.14234 325.68951'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M343.751455,250.242021 L330.689816,325.142033 L405.589829,312.080395 L418.651467,237.180382 L343.751455,250.242021 Z',stroke:'#979797',strokeWidth:'0.890566038'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(249.991396, 193.885736) rotate(45.000000) translate(-249.991396, -193.885736) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'218.687325 162.581665 294.519698 149.357434 281.295467 225.189807 205.463094 238.414038'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M219.072209,162.966549 L206.010571,237.866562 L280.910583,224.804923 L293.972222,149.90491 L219.072209,162.966549 Z',stroke:'#979797',strokeWidth:'0.890566038'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(499.349887, 368.436679) rotate(45.000000) translate(-499.349887, -368.436679) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'468.045816 337.132608 543.878189 323.908377 530.653958 399.74075 454.821585 412.964981'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M468.4307,337.517493 L455.369061,412.417505 L530.269074,399.355866 L543.330713,324.455854 L468.4307,337.517493 Z',stroke:'#979797',strokeWidth:'0.890566038'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'10m',transform:'translate(435.486792, 87.275472)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(62.972528, 62.972528) rotate(45.000000) translate(-62.972528, -62.972528) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'31.6684575 31.6684575 107.50083 18.4442266 94.2765994 94.2765994 18.4442266 107.50083'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M32.0533416,32.0533416 L18.9917027,106.953354 L93.8917153,93.8917153 L106.953354,18.9917027 L32.0533416,32.0533416 Z',stroke:'#979797',strokeWidth:'0.890566038'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(312.331019, 237.523472) rotate(45.000000) translate(-312.331019, -237.523472) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'281.026948 206.219401 356.859321 192.99517 343.63509 268.827543 267.802717 282.051774'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M281.411832,206.604285 L268.350193,281.504298 L343.250206,268.442659 L356.311845,193.542646 L281.411832,206.604285 Z',stroke:'#979797',strokeWidth:'0.890566038'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(187.651774, 150.248000) rotate(45.000000) translate(-187.651774, -150.248000) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'156.347703 118.943929 232.180076 105.719698 218.955845 181.552071 143.123472 194.776302'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M156.732587,119.328813 L143.670948,194.228826 L218.570961,181.167187 L231.632599,106.267174 L156.732587,119.328813 Z',stroke:'#979797',strokeWidth:'0.890566038'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(437.010264, 324.798944) rotate(45.000000) translate(-437.010264, -324.798944) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'405.706193 293.494873 481.538566 280.270642 468.314335 356.103014 392.481962 369.327245'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M406.091077,293.879757 L393.029439,368.779769 L467.929451,355.71813 L480.99109,280.818118 L406.091077,293.879757 Z',stroke:'#979797',strokeWidth:'0.890566038'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(125.312151, 106.610264) rotate(45.000000) translate(-125.312151, -106.610264) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'94.0080802 75.3061934 169.840453 62.0819624 156.616222 137.914335 80.7838492 151.138566'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M94.3929642,75.6910774 L81.3313254,150.59109 L156.231338,137.529451 L169.292977,62.6294386 L94.3929642,75.6910774 Z',stroke:'#979797',strokeWidth:'0.890566038'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(374.670642, 281.161208) rotate(45.000000) translate(-374.670642, -281.161208) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'343.366571 249.857137 419.198944 236.632906 405.974713 312.465279 330.14234 325.68951'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M343.751455,250.242021 L330.689816,325.142033 L405.589829,312.080395 L418.651467,237.180382 L343.751455,250.242021 Z',stroke:'#979797',strokeWidth:'0.890566038'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(249.991396, 193.885736) rotate(45.000000) translate(-249.991396, -193.885736) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'218.687325 162.581665 294.519698 149.357434 281.295467 225.189807 205.463094 238.414038'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M219.072209,162.966549 L206.010571,237.866562 L280.910583,224.804923 L293.972222,149.90491 L219.072209,162.966549 Z',stroke:'#979797',strokeWidth:'0.890566038'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(499.349887, 368.436679) rotate(45.000000) translate(-499.349887, -368.436679) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'468.045816 337.132608 543.878189 323.908377 530.653958 399.74075 454.821585 412.964981'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M468.4307,337.517493 L455.369061,412.417505 L530.269074,399.355866 L543.330713,324.455854 L468.4307,337.517493 Z',stroke:'#979797',strokeWidth:'0.890566038'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'10m',transform:'translate(496.935849, 43.637736)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(62.972528, 62.972528) rotate(45.000000) translate(-62.972528, -62.972528) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'31.6684575 31.6684575 107.50083 18.4442266 94.2765994 94.2765994 18.4442266 107.50083'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M32.0533416,32.0533416 L18.9917027,106.953354 L93.8917153,93.8917153 L106.953354,18.9917027 L32.0533416,32.0533416 Z',stroke:'#979797',strokeWidth:'0.890566038'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(312.331019, 237.523472) rotate(45.000000) translate(-312.331019, -237.523472) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'281.026948 206.219401 356.859321 192.99517 343.63509 268.827543 267.802717 282.051774'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M281.411832,206.604285 L268.350193,281.504298 L343.250206,268.442659 L356.311845,193.542646 L281.411832,206.604285 Z',stroke:'#979797',strokeWidth:'0.890566038'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(187.651774, 150.248000) rotate(45.000000) translate(-187.651774, -150.248000) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'156.347703 118.943929 232.180076 105.719698 218.955845 181.552071 143.123472 194.776302'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M156.732587,119.328813 L143.670948,194.228826 L218.570961,181.167187 L231.632599,106.267174 L156.732587,119.328813 Z',stroke:'#979797',strokeWidth:'0.890566038'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(437.010264, 324.798944) rotate(45.000000) translate(-437.010264, -324.798944) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'405.706193 293.494873 481.538566 280.270642 468.314335 356.103014 392.481962 369.327245'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M406.091077,293.879757 L393.029439,368.779769 L467.929451,355.71813 L480.99109,280.818118 L406.091077,293.879757 Z',stroke:'#979797',strokeWidth:'0.890566038'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(125.312151, 106.610264) rotate(45.000000) translate(-125.312151, -106.610264) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'94.0080802 75.3061934 169.840453 62.0819624 156.616222 137.914335 80.7838492 151.138566'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M94.3929642,75.6910774 L81.3313254,150.59109 L156.231338,137.529451 L169.292977,62.6294386 L94.3929642,75.6910774 Z',stroke:'#979797',strokeWidth:'0.890566038'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(374.670642, 281.161208) rotate(45.000000) translate(-374.670642, -281.161208) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'343.366571 249.857137 419.198944 236.632906 405.974713 312.465279 330.14234 325.68951'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M343.751455,250.242021 L330.689816,325.142033 L405.589829,312.080395 L418.651467,237.180382 L343.751455,250.242021 Z',stroke:'#979797',strokeWidth:'0.890566038'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(249.991396, 193.885736) rotate(45.000000) translate(-249.991396, -193.885736) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'218.687325 162.581665 294.519698 149.357434 281.295467 225.189807 205.463094 238.414038'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M219.072209,162.966549 L206.010571,237.866562 L280.910583,224.804923 L293.972222,149.90491 L219.072209,162.966549 Z',stroke:'#979797',strokeWidth:'0.890566038'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(499.349887, 368.436679) rotate(45.000000) translate(-499.349887, -368.436679) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'468.045816 337.132608 543.878189 323.908377 530.653958 399.74075 454.821585 412.964981'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M468.4307,337.517493 L455.369061,412.417505 L530.269074,399.355866 L543.330713,324.455854 L468.4307,337.517493 Z',stroke:'#979797',strokeWidth:'0.890566038'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'10m',transform:'translate(559.275472, 0.000000)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(62.972528, 62.972528) rotate(45.000000) translate(-62.972528, -62.972528) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'31.6684575 31.6684575 107.50083 18.4442266 94.2765994 94.2765994 18.4442266 107.50083'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M32.0533416,32.0533416 L18.9917027,106.953354 L93.8917153,93.8917153 L106.953354,18.9917027 L32.0533416,32.0533416 Z',stroke:'#979797',strokeWidth:'0.890566038'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(312.331019, 237.523472) rotate(45.000000) translate(-312.331019, -237.523472) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'281.026948 206.219401 356.859321 192.99517 343.63509 268.827543 267.802717 282.051774'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M281.411832,206.604285 L268.350193,281.504298 L343.250206,268.442659 L356.311845,193.542646 L281.411832,206.604285 Z',stroke:'#979797',strokeWidth:'0.890566038'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(187.651774, 150.248000) rotate(45.000000) translate(-187.651774, -150.248000) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'156.347703 118.943929 232.180076 105.719698 218.955845 181.552071 143.123472 194.776302'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M156.732587,119.328813 L143.670948,194.228826 L218.570961,181.167187 L231.632599,106.267174 L156.732587,119.328813 Z',stroke:'#979797',strokeWidth:'0.890566038'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(437.010264, 324.798944) rotate(45.000000) translate(-437.010264, -324.798944) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'405.706193 293.494873 481.538566 280.270642 468.314335 356.103014 392.481962 369.327245'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M406.091077,293.879757 L393.029439,368.779769 L467.929451,355.71813 L480.99109,280.818118 L406.091077,293.879757 Z',stroke:'#979797',strokeWidth:'0.890566038'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(125.312151, 106.610264) rotate(45.000000) translate(-125.312151, -106.610264) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'94.0080802 75.3061934 169.840453 62.0819624 156.616222 137.914335 80.7838492 151.138566'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M94.3929642,75.6910774 L81.3313254,150.59109 L156.231338,137.529451 L169.292977,62.6294386 L94.3929642,75.6910774 Z',stroke:'#979797',strokeWidth:'0.890566038'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(374.670642, 281.161208) rotate(45.000000) translate(-374.670642, -281.161208) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'343.366571 249.857137 419.198944 236.632906 405.974713 312.465279 330.14234 325.68951'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M343.751455,250.242021 L330.689816,325.142033 L405.589829,312.080395 L418.651467,237.180382 L343.751455,250.242021 Z',stroke:'#979797',strokeWidth:'0.890566038'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(249.991396, 193.885736) rotate(45.000000) translate(-249.991396, -193.885736) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'218.687325 162.581665 294.519698 149.357434 281.295467 225.189807 205.463094 238.414038'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M219.072209,162.966549 L206.010571,237.866562 L280.910583,224.804923 L293.972222,149.90491 L219.072209,162.966549 Z',stroke:'#979797',strokeWidth:'0.890566038'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(499.349887, 368.436679) rotate(45.000000) translate(-499.349887, -368.436679) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'468.045816 337.132608 543.878189 323.908377 530.653958 399.74075 454.821585 412.964981'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M468.4307,337.517493 L455.369061,412.417505 L530.269074,399.355866 L543.330713,324.455854 L468.4307,337.517493 Z',stroke:'#979797',strokeWidth:'0.890566038'})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Desk,{ratio:this.state.ratio}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Pretreat,{ratio:this.state.ratio}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Press,{ratio:this.state.ratio}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Gtx1,{ratio:this.state.ratio}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Gtx2,{ratio:this.state.ratio}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Gtx3,{ratio:this.state.ratio}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Senddesk,{ratio:this.state.ratio}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Dryer,{ratio:this.state.ratio}));}}]);return RoomM;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (RoomM);var Gtx1=function(_React$Component2){_inherits(Gtx1,_React$Component2);function Gtx1(props){_classCallCheck(this,Gtx1);var _this2=_possibleConstructorReturn(this,(Gtx1.__proto__||Object.getPrototypeOf(Gtx1)).call(this,props));_this2.state={originalWidth:313,originalHeight:223,x:0,y:-500,opacity:0,ratio:parseFloat(props.ratio)};_this2.state=Object.assign({},_this2.state,{width:_this2.state.originalWidth/_this2.state.ratio,height:_this2.state.originalHeight/_this2.state.ratio});return _this2;}_createClass(Gtx1,[{key:'getKeyFrames',value:function getKeyFrames(){return[{transform:'translateY(-500px)',opacity:0,offset:0},{opacity:1,offset:1},{transform:'translateY(0)',opacity:1,offset:1}];}},{key:'getTiming',value:function getTiming(duration){return{duration:duration,easing:'ease-in',delay:0,iterations:1,fill:'forwards'};}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_web_animation__["Animated"].img,{keyframes:this.getKeyFrames(),timing:this.getTiming(750),style:{position:'absolute',top:328/this.state.ratio,left:461/this.state.ratio,opacity:this.state.opacity,transform:[{translateY:this.state.y}],width:this.state.width,height:this.state.height},src:__webpack_require__(3)});}}]);return Gtx1;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var Gtx2=function(_React$Component3){_inherits(Gtx2,_React$Component3);function Gtx2(props){_classCallCheck(this,Gtx2);var _this3=_possibleConstructorReturn(this,(Gtx2.__proto__||Object.getPrototypeOf(Gtx2)).call(this,props));_this3.state={originalWidth:313,originalHeight:223,x:0,y:-500,opacity:0,ratio:parseFloat(props.ratio)};_this3.state=Object.assign({},_this3.state,{width:_this3.state.originalWidth/_this3.state.ratio,height:_this3.state.originalHeight/_this3.state.ratio});return _this3;}_createClass(Gtx2,[{key:'getKeyFrames',value:function getKeyFrames(){return[{transform:'translateY(-500px)',opacity:0,offset:0},{opacity:1,offset:1},{transform:'translateY(0)',opacity:1,offset:1}];}},{key:'getTiming',value:function getTiming(duration){return{duration:duration,easing:'ease-in',delay:0,iterations:1,fill:'forwards'};}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_web_animation__["Animated"].img,{keyframes:this.getKeyFrames(),timing:this.getTiming(750),style:{position:'absolute',top:414/this.state.ratio,left:588/this.state.ratio,opacity:this.state.opacity,transform:[{translateY:this.state.y}],width:this.state.width,height:this.state.height},src:__webpack_require__(3)});}}]);return Gtx2;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var Gtx3=function(_React$Component4){_inherits(Gtx3,_React$Component4);function Gtx3(props){_classCallCheck(this,Gtx3);var _this4=_possibleConstructorReturn(this,(Gtx3.__proto__||Object.getPrototypeOf(Gtx3)).call(this,props));_this4.state={originalWidth:313,originalHeight:223,x:0,y:-500,opacity:0,ratio:parseFloat(props.ratio)};_this4.state=Object.assign({},_this4.state,{width:_this4.state.originalWidth/_this4.state.ratio,height:_this4.state.originalHeight/_this4.state.ratio});return _this4;}_createClass(Gtx3,[{key:'getKeyFrames',value:function getKeyFrames(){return[{transform:'translateY(-500px)',opacity:0,offset:0},{opacity:1,offset:1},{transform:'translateY(0)',opacity:1,offset:1}];}},{key:'getTiming',value:function getTiming(duration){return{duration:duration,easing:'ease-in',delay:0,iterations:1,fill:'forwards'};}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_web_animation__["Animated"].img,{keyframes:this.getKeyFrames(),timing:this.getTiming(750),style:{position:'absolute',top:502/this.state.ratio,left:714/this.state.ratio,opacity:this.state.opacity,transform:[{translateY:this.state.y}],width:this.state.width,height:this.state.height},src:__webpack_require__(3)});}}]);return Gtx3;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var Senddesk=function(_React$Component5){_inherits(Senddesk,_React$Component5);function Senddesk(props){_classCallCheck(this,Senddesk);var _this5=_possibleConstructorReturn(this,(Senddesk.__proto__||Object.getPrototypeOf(Senddesk)).call(this,props));_this5.state={originalWidth:251,originalHeight:201,x:0,y:-500,opacity:0,ratio:parseFloat(props.ratio)};_this5.state=Object.assign({},_this5.state,{width:_this5.state.originalWidth/_this5.state.ratio,height:_this5.state.originalHeight/_this5.state.ratio});return _this5;}_createClass(Senddesk,[{key:'getKeyFrames',value:function getKeyFrames(){return[{transform:'translateY(-500px)',opacity:0,offset:0},{opacity:1,offset:1},{transform:'translateY(0)',opacity:1,offset:1}];}},{key:'getTiming',value:function getTiming(duration){return{duration:duration,easing:'ease-in',delay:0,iterations:1,fill:'forwards'};}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_web_animation__["Animated"].img,{keyframes:this.getKeyFrames(),timing:this.getTiming(750),style:{position:'absolute',top:611/this.state.ratio,left:587/this.state.ratio,opacity:this.state.opacity,transform:[{translateY:this.state.y}],width:this.state.width,height:this.state.height},src:__webpack_require__(19)});}}]);return Senddesk;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var Desk=function(_React$Component6){_inherits(Desk,_React$Component6);function Desk(props){_classCallCheck(this,Desk);var _this6=_possibleConstructorReturn(this,(Desk.__proto__||Object.getPrototypeOf(Desk)).call(this,props));_this6.state={originalWidth:251,originalHeight:178,x:0,y:-500,opacity:0,ratio:parseFloat(props.ratio)};_this6.state=Object.assign({},_this6.state,{width:_this6.state.originalWidth/_this6.state.ratio,height:_this6.state.originalHeight/_this6.state.ratio});return _this6;}_createClass(Desk,[{key:'getKeyFrames',value:function getKeyFrames(){return[{transform:'translateY(-500px)',opacity:0,offset:0},{opacity:1,offset:1},{transform:'translateY(0)',opacity:1,offset:1}];}},{key:'getTiming',value:function getTiming(duration){return{duration:duration,easing:'ease-in',delay:0,iterations:1,fill:'forwards'};}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_web_animation__["Animated"].img,{keyframes:this.getKeyFrames(),timing:this.getTiming(750),style:{position:'absolute',top:502/this.state.ratio,left:399/this.state.ratio,opacity:this.state.opacity,transform:[{translateY:this.state.y}],width:this.state.width,height:this.state.height},src:__webpack_require__(17)});}}]);return Desk;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var Press=function(_React$Component7){_inherits(Press,_React$Component7);function Press(props){_classCallCheck(this,Press);var _this7=_possibleConstructorReturn(this,(Press.__proto__||Object.getPrototypeOf(Press)).call(this,props));_this7.state={originalWidth:190,originalHeight:185,x:0,y:-500,opacity:0,ratio:parseFloat(props.ratio)};_this7.state=Object.assign({},_this7.state,{width:_this7.state.originalWidth/_this7.state.ratio,height:_this7.state.originalHeight/_this7.state.ratio});return _this7;}_createClass(Press,[{key:'getKeyFrames',value:function getKeyFrames(){return[{transform:'translateY(-500px)',opacity:0,offset:0},{opacity:1,offset:1},{transform:'translateY(0)',opacity:1,offset:1}];}},{key:'getTiming',value:function getTiming(duration){return{duration:duration,easing:'ease-in',delay:0,iterations:1,fill:'forwards'};}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_web_animation__["Animated"].img,{keyframes:this.getKeyFrames(),timing:this.getTiming(750),style:{position:'absolute',top:235/this.state.ratio,left:399/this.state.ratio,opacity:this.state.opacity,transform:[{translateY:this.state.y}],width:this.state.width,height:this.state.height},src:__webpack_require__(18)});}}]);return Press;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var Pretreat=function(_React$Component8){_inherits(Pretreat,_React$Component8);function Pretreat(props){_classCallCheck(this,Pretreat);var _this8=_possibleConstructorReturn(this,(Pretreat.__proto__||Object.getPrototypeOf(Pretreat)).call(this,props));_this8.state={originalWidth:190,originalHeight:176,x:0,y:-500,opacity:0,ratio:parseFloat(props.ratio)};_this8.state=Object.assign({},_this8.state,{width:_this8.state.originalWidth/_this8.state.ratio,height:_this8.state.originalHeight/_this8.state.ratio});return _this8;}_createClass(Pretreat,[{key:'getKeyFrames',value:function getKeyFrames(){return[{transform:'translateY(-500px)',opacity:0,offset:0},{opacity:1,offset:1},{transform:'translateY(0)',opacity:1,offset:1}];}},{key:'getTiming',value:function getTiming(duration){return{duration:duration,easing:'ease-in',delay:0,iterations:1,fill:'forwards'};}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_web_animation__["Animated"].img,{keyframes:this.getKeyFrames(),timing:this.getTiming(750),style:{position:'absolute',top:198/this.state.ratio,left:461/this.state.ratio,opacity:this.state.opacity,transform:[{translateY:this.state.y}],width:this.state.width,height:this.state.height},src:__webpack_require__(28)});}}]);return Pretreat;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var Dryer=function(_React$Component9){_inherits(Dryer,_React$Component9);function Dryer(props){_classCallCheck(this,Dryer);var _this9=_possibleConstructorReturn(this,(Dryer.__proto__||Object.getPrototypeOf(Dryer)).call(this,props));_this9.state={originalWidth:498,originalHeight:375,x:0,y:-500,opacity:0,ratio:parseFloat(props.ratio)};_this9.state=Object.assign({},_this9.state,{width:_this9.state.originalWidth/_this9.state.ratio,height:_this9.state.originalHeight/_this9.state.ratio});return _this9;}_createClass(Dryer,[{key:'getKeyFrames',value:function getKeyFrames(){return[{transform:'translateY(-500px)',opacity:0,offset:0},{opacity:1,offset:1},{transform:'translateY(0)',opacity:1,offset:1}];}},{key:'getTiming',value:function getTiming(duration){return{duration:duration,easing:'ease-in',delay:0,iterations:1,fill:'forwards'};}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_web_animation__["Animated"].img,{keyframes:this.getKeyFrames(),timing:this.getTiming(750),style:{position:'absolute',top:355/this.state.ratio,left:25/this.state.ratio,opacity:this.state.opacity,transform:[{translateY:this.state.y}],width:this.state.width,height:this.state.height},src:__webpack_require__(42)});}}]);return Dryer;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_web_animation__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_web_animation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_web_animation__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RoomL=function(_React$Component){_inherits(RoomL,_React$Component);function RoomL(props){_classCallCheck(this,RoomL);var _this=_possibleConstructorReturn(this,(RoomL.__proto__||Object.getPrototypeOf(RoomL)).call(this,props));_this.state={originalWidth:1051,originalHeight:944};_this.state=Object.assign({},_this.state,{width:parseFloat(props.width),height:_this.state.originalHeight/(_this.state.originalWidth/parseFloat(props.width)),ratio:_this.state.originalWidth/parseFloat(props.width)});return _this;}_createClass(RoomL,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{height:this.state.height,width:this.state.width,viewBox:'0 0 '+this.state.originalWidth+' '+this.state.originalHeight},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('defs',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-1',points:'26.6699404 26.6699404 90.5330086 15.5330086 79.3960768 79.3960768 15.5330086 90.5330086'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-2',points:'236.66994 173.66994 300.533009 162.533009 289.396077 226.396077 225.533009 237.533009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-3',points:'131.66994 100.16994 195.533009 89.0330086 184.396077 152.896077 120.533009 164.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-4',points:'341.66994 247.16994 405.533009 236.033009 394.396077 299.896077 330.533009 311.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-5',points:'446.66994 320.827949 510.533009 309.691017 499.396077 373.554085 435.533009 384.691017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-6',points:'79.1699404 63.4199404 143.033009 52.2830086 131.896077 116.146077 68.0330086 127.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-7',points:'289.16994 210.41994 353.033009 199.283009 341.896077 263.146077 278.033009 274.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-8',points:'184.16994 136.91994 248.033009 125.783009 236.896077 189.646077 173.033009 200.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-9',points:'394.16994 283.91994 458.033009 272.783009 446.896077 336.646077 383.033009 347.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-10',points:'499.16994 357.577949 563.033009 346.441017 551.896077 410.304085 488.033009 421.441017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-11',points:'26.6699404 26.6699404 90.5330086 15.5330086 79.3960768 79.3960768 15.5330086 90.5330086'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-12',points:'236.66994 173.66994 300.533009 162.533009 289.396077 226.396077 225.533009 237.533009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-13',points:'131.66994 100.16994 195.533009 89.0330086 184.396077 152.896077 120.533009 164.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-14',points:'341.66994 247.16994 405.533009 236.033009 394.396077 299.896077 330.533009 311.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-15',points:'446.66994 320.827949 510.533009 309.691017 499.396077 373.554085 435.533009 384.691017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-16',points:'79.1699404 63.4199404 143.033009 52.2830086 131.896077 116.146077 68.0330086 127.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-17',points:'289.16994 210.41994 353.033009 199.283009 341.896077 263.146077 278.033009 274.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-18',points:'184.16994 136.91994 248.033009 125.783009 236.896077 189.646077 173.033009 200.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-19',points:'394.16994 283.91994 458.033009 272.783009 446.896077 336.646077 383.033009 347.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-20',points:'499.16994 357.577949 563.033009 346.441017 551.896077 410.304085 488.033009 421.441017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-21',points:'26.6699404 26.6699404 90.5330086 15.5330086 79.3960768 79.3960768 15.5330086 90.5330086'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-22',points:'236.66994 173.66994 300.533009 162.533009 289.396077 226.396077 225.533009 237.533009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-23',points:'131.66994 100.16994 195.533009 89.0330086 184.396077 152.896077 120.533009 164.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-24',points:'341.66994 247.16994 405.533009 236.033009 394.396077 299.896077 330.533009 311.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-25',points:'446.66994 320.827949 510.533009 309.691017 499.396077 373.554085 435.533009 384.691017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-26',points:'79.1699404 63.4199404 143.033009 52.2830086 131.896077 116.146077 68.0330086 127.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-27',points:'289.16994 210.41994 353.033009 199.283009 341.896077 263.146077 278.033009 274.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-28',points:'184.16994 136.91994 248.033009 125.783009 236.896077 189.646077 173.033009 200.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-29',points:'394.16994 283.91994 458.033009 272.783009 446.896077 336.646077 383.033009 347.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-30',points:'499.16994 357.577949 563.033009 346.441017 551.896077 410.304085 488.033009 421.441017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-31',points:'26.6699404 26.6699404 90.5330086 15.5330086 79.3960768 79.3960768 15.5330086 90.5330086'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-32',points:'236.66994 173.66994 300.533009 162.533009 289.396077 226.396077 225.533009 237.533009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-33',points:'131.66994 100.16994 195.533009 89.0330086 184.396077 152.896077 120.533009 164.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-34',points:'341.66994 247.16994 405.533009 236.033009 394.396077 299.896077 330.533009 311.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-35',points:'446.66994 320.827949 510.533009 309.691017 499.396077 373.554085 435.533009 384.691017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-36',points:'79.1699404 63.4199404 143.033009 52.2830086 131.896077 116.146077 68.0330086 127.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-37',points:'289.16994 210.41994 353.033009 199.283009 341.896077 263.146077 278.033009 274.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-38',points:'184.16994 136.91994 248.033009 125.783009 236.896077 189.646077 173.033009 200.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-39',points:'394.16994 283.91994 458.033009 272.783009 446.896077 336.646077 383.033009 347.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-40',points:'499.16994 357.577949 563.033009 346.441017 551.896077 410.304085 488.033009 421.441017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-41',points:'26.6699404 26.6699404 90.5330086 15.5330086 79.3960768 79.3960768 15.5330086 90.5330086'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-42',points:'236.66994 173.66994 300.533009 162.533009 289.396077 226.396077 225.533009 237.533009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-43',points:'131.66994 100.16994 195.533009 89.0330086 184.396077 152.896077 120.533009 164.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-44',points:'341.66994 247.16994 405.533009 236.033009 394.396077 299.896077 330.533009 311.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-45',points:'446.66994 320.827949 510.533009 309.691017 499.396077 373.554085 435.533009 384.691017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-46',points:'79.1699404 63.4199404 143.033009 52.2830086 131.896077 116.146077 68.0330086 127.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-47',points:'289.16994 210.41994 353.033009 199.283009 341.896077 263.146077 278.033009 274.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-48',points:'184.16994 136.91994 248.033009 125.783009 236.896077 189.646077 173.033009 200.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-49',points:'394.16994 283.91994 458.033009 272.783009 446.896077 336.646077 383.033009 347.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-50',points:'499.16994 357.577949 563.033009 346.441017 551.896077 410.304085 488.033009 421.441017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-51',points:'26.6699404 26.6699404 90.5330086 15.5330086 79.3960768 79.3960768 15.5330086 90.5330086'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-52',points:'236.66994 173.66994 300.533009 162.533009 289.396077 226.396077 225.533009 237.533009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-53',points:'131.66994 100.16994 195.533009 89.0330086 184.396077 152.896077 120.533009 164.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-54',points:'341.66994 247.16994 405.533009 236.033009 394.396077 299.896077 330.533009 311.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-55',points:'446.66994 320.827949 510.533009 309.691017 499.396077 373.554085 435.533009 384.691017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-56',points:'79.1699404 63.4199404 143.033009 52.2830086 131.896077 116.146077 68.0330086 127.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-57',points:'289.16994 210.41994 353.033009 199.283009 341.896077 263.146077 278.033009 274.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-58',points:'184.16994 136.91994 248.033009 125.783009 236.896077 189.646077 173.033009 200.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-59',points:'394.16994 283.91994 458.033009 272.783009 446.896077 336.646077 383.033009 347.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-60',points:'499.16994 357.577949 563.033009 346.441017 551.896077 410.304085 488.033009 421.441017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-61',points:'26.6699404 26.6699404 90.5330086 15.5330086 79.3960768 79.3960768 15.5330086 90.5330086'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-62',points:'236.66994 173.66994 300.533009 162.533009 289.396077 226.396077 225.533009 237.533009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-63',points:'131.66994 100.16994 195.533009 89.0330086 184.396077 152.896077 120.533009 164.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-64',points:'341.66994 247.16994 405.533009 236.033009 394.396077 299.896077 330.533009 311.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-65',points:'446.66994 320.827949 510.533009 309.691017 499.396077 373.554085 435.533009 384.691017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-66',points:'79.1699404 63.4199404 143.033009 52.2830086 131.896077 116.146077 68.0330086 127.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-67',points:'289.16994 210.41994 353.033009 199.283009 341.896077 263.146077 278.033009 274.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-68',points:'184.16994 136.91994 248.033009 125.783009 236.896077 189.646077 173.033009 200.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-69',points:'394.16994 283.91994 458.033009 272.783009 446.896077 336.646077 383.033009 347.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-70',points:'499.16994 357.577949 563.033009 346.441017 551.896077 410.304085 488.033009 421.441017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-71',points:'26.6699404 26.6699404 90.5330086 15.5330086 79.3960768 79.3960768 15.5330086 90.5330086'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-72',points:'236.66994 173.66994 300.533009 162.533009 289.396077 226.396077 225.533009 237.533009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-73',points:'131.66994 100.16994 195.533009 89.0330086 184.396077 152.896077 120.533009 164.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-74',points:'341.66994 247.16994 405.533009 236.033009 394.396077 299.896077 330.533009 311.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-75',points:'446.66994 320.827949 510.533009 309.691017 499.396077 373.554085 435.533009 384.691017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-76',points:'79.1699404 63.4199404 143.033009 52.2830086 131.896077 116.146077 68.0330086 127.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-77',points:'289.16994 210.41994 353.033009 199.283009 341.896077 263.146077 278.033009 274.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-78',points:'184.16994 136.91994 248.033009 125.783009 236.896077 189.646077 173.033009 200.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-79',points:'394.16994 283.91994 458.033009 272.783009 446.896077 336.646077 383.033009 347.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-80',points:'499.16994 357.577949 563.033009 346.441017 551.896077 410.304085 488.033009 421.441017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-81',points:'26.6699404 26.6699404 90.5330086 15.5330086 79.3960768 79.3960768 15.5330086 90.5330086'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-82',points:'236.66994 173.66994 300.533009 162.533009 289.396077 226.396077 225.533009 237.533009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-83',points:'131.66994 100.16994 195.533009 89.0330086 184.396077 152.896077 120.533009 164.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-84',points:'341.66994 247.16994 405.533009 236.033009 394.396077 299.896077 330.533009 311.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-85',points:'446.66994 320.827949 510.533009 309.691017 499.396077 373.554085 435.533009 384.691017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-86',points:'79.1699404 63.4199404 143.033009 52.2830086 131.896077 116.146077 68.0330086 127.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-87',points:'289.16994 210.41994 353.033009 199.283009 341.896077 263.146077 278.033009 274.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-88',points:'184.16994 136.91994 248.033009 125.783009 236.896077 189.646077 173.033009 200.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-89',points:'394.16994 283.91994 458.033009 272.783009 446.896077 336.646077 383.033009 347.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-90',points:'499.16994 357.577949 563.033009 346.441017 551.896077 410.304085 488.033009 421.441017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-91',points:'26.6699404 26.6699404 90.5330086 15.5330086 79.3960768 79.3960768 15.5330086 90.5330086'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-92',points:'236.66994 173.66994 300.533009 162.533009 289.396077 226.396077 225.533009 237.533009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-93',points:'131.66994 100.16994 195.533009 89.0330086 184.396077 152.896077 120.533009 164.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-94',points:'341.66994 247.16994 405.533009 236.033009 394.396077 299.896077 330.533009 311.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-95',points:'446.66994 320.827949 510.533009 309.691017 499.396077 373.554085 435.533009 384.691017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-96',points:'79.1699404 63.4199404 143.033009 52.2830086 131.896077 116.146077 68.0330086 127.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-97',points:'289.16994 210.41994 353.033009 199.283009 341.896077 263.146077 278.033009 274.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-98',points:'184.16994 136.91994 248.033009 125.783009 236.896077 189.646077 173.033009 200.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-99',points:'394.16994 283.91994 458.033009 272.783009 446.896077 336.646077 383.033009 347.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-100',points:'499.16994 357.577949 563.033009 346.441017 551.896077 410.304085 488.033009 421.441017'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Packages/L',fill:'none'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'Rectangle-8',fill:'#DFDFDF',points:'1.12727029 203 642 203 524.87273 370 -116 370',transform:'rotate(-35 263 286.5)'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'Rectangle-8',fill:'#929292',points:'525.8493 204 1167 204 1049.91343 371 409 370.661584',transform:'scale(-1 1) rotate(-35 0 2786.717)'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Boden/10x10',transform:'translate(0 189)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'10m',transform:'translate(0 330.75)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 53.033 53.033)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M26.9940747,26.9940747 L15.9940717,90.0719455 L79.0719424,79.0719424 L90.0719455,15.9940717 L26.9940747,26.9940747 Z',stroke:'#979797'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 263.033 200.033)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M236.994075,173.994075 L225.994072,237.071946 L289.071942,226.071942 L300.071946,162.994072 L236.994075,173.994075 Z',stroke:'#979797'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 158.033 126.533)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M131.994075,100.494075 L120.994072,163.571946 L184.071942,152.571942 L195.071946,89.4940717 L131.994075,100.494075 Z',stroke:'#979797'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 368.033 273.533)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M341.994075,247.494075 L330.994072,310.571946 L394.071942,299.571942 L405.071946,236.494072 L341.994075,247.494075 Z',stroke:'#979797'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 473.033 347.191)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M446.994075,321.152083 L435.994072,384.229954 L499.071942,373.229951 L510.071946,310.15208 L446.994075,321.152083 Z',stroke:'#979797'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 105.533 89.783)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M79.4940747,63.7440747 L68.4940717,126.821946 L131.571942,115.821942 L142.571946,52.7440717 L79.4940747,63.7440747 Z',stroke:'#979797'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 315.533 236.783)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M289.494075,210.744075 L278.494072,273.821946 L341.571942,262.821942 L352.571946,199.744072 L289.494075,210.744075 Z',stroke:'#979797'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 210.533 163.283)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M184.494075,137.244075 L173.494072,200.321946 L236.571942,189.321942 L247.571946,126.244072 L184.494075,137.244075 Z',stroke:'#979797'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 420.533 310.283)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M394.494075,284.244075 L383.494072,347.321946 L446.571942,336.321942 L457.571946,273.244072 L394.494075,284.244075 Z',stroke:'#979797'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 525.533 383.941)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M499.494075,357.902083 L488.494072,420.979954 L551.571942,409.979951 L562.571946,346.90208 L499.494075,357.902083 Z',stroke:'#979797'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'10m',transform:'translate(52.5 294)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 53.033 53.033)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M26.9940747,26.9940747 L15.9940717,90.0719455 L79.0719424,79.0719424 L90.0719455,15.9940717 L26.9940747,26.9940747 Z',stroke:'#979797'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 263.033 200.033)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M236.994075,173.994075 L225.994072,237.071946 L289.071942,226.071942 L300.071946,162.994072 L236.994075,173.994075 Z',stroke:'#979797'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 158.033 126.533)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M131.994075,100.494075 L120.994072,163.571946 L184.071942,152.571942 L195.071946,89.4940717 L131.994075,100.494075 Z',stroke:'#979797'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 368.033 273.533)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M341.994075,247.494075 L330.994072,310.571946 L394.071942,299.571942 L405.071946,236.494072 L341.994075,247.494075 Z',stroke:'#979797'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 473.033 347.191)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M446.994075,321.152083 L435.994072,384.229954 L499.071942,373.229951 L510.071946,310.15208 L446.994075,321.152083 Z',stroke:'#979797'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 105.533 89.783)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M79.4940747,63.7440747 L68.4940717,126.821946 L131.571942,115.821942 L142.571946,52.7440717 L79.4940747,63.7440747 Z',stroke:'#979797'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 315.533 236.783)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M289.494075,210.744075 L278.494072,273.821946 L341.571942,262.821942 L352.571946,199.744072 L289.494075,210.744075 Z',stroke:'#979797'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 210.533 163.283)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M184.494075,137.244075 L173.494072,200.321946 L236.571942,189.321942 L247.571946,126.244072 L184.494075,137.244075 Z',stroke:'#979797'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 420.533 310.283)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M394.494075,284.244075 L383.494072,347.321946 L446.571942,336.321942 L457.571946,273.244072 L394.494075,284.244075 Z',stroke:'#979797'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 525.533 383.941)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M499.494075,357.902083 L488.494072,420.979954 L551.571942,409.979951 L562.571946,346.90208 L499.494075,357.902083 Z',stroke:'#979797'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'10m',transform:'translate(105 257.25)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 53.033 53.033)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M26.9940747,26.9940747 L15.9940717,90.0719455 L79.0719424,79.0719424 L90.0719455,15.9940717 L26.9940747,26.9940747 Z',stroke:'#979797'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 263.033 200.033)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M236.994075,173.994075 L225.994072,237.071946 L289.071942,226.071942 L300.071946,162.994072 L236.994075,173.994075 Z',stroke:'#979797'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 158.033 126.533)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M131.994075,100.494075 L120.994072,163.571946 L184.071942,152.571942 L195.071946,89.4940717 L131.994075,100.494075 Z',stroke:'#979797'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 368.033 273.533)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M341.994075,247.494075 L330.994072,310.571946 L394.071942,299.571942 L405.071946,236.494072 L341.994075,247.494075 Z',stroke:'#979797'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 473.033 347.191)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M446.994075,321.152083 L435.994072,384.229954 L499.071942,373.229951 L510.071946,310.15208 L446.994075,321.152083 Z',stroke:'#979797'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 105.533 89.783)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M79.4940747,63.7440747 L68.4940717,126.821946 L131.571942,115.821942 L142.571946,52.7440717 L79.4940747,63.7440747 Z',stroke:'#979797'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 315.533 236.783)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M289.494075,210.744075 L278.494072,273.821946 L341.571942,262.821942 L352.571946,199.744072 L289.494075,210.744075 Z',stroke:'#979797'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 210.533 163.283)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M184.494075,137.244075 L173.494072,200.321946 L236.571942,189.321942 L247.571946,126.244072 L184.494075,137.244075 Z',stroke:'#979797'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 420.533 310.283)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M394.494075,284.244075 L383.494072,347.321946 L446.571942,336.321942 L457.571946,273.244072 L394.494075,284.244075 Z',stroke:'#979797'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 525.533 383.941)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M499.494075,357.902083 L488.494072,420.979954 L551.571942,409.979951 L562.571946,346.90208 L499.494075,357.902083 Z',stroke:'#979797'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'10m',transform:'translate(157.5 220.5)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 53.033 53.033)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M26.9940747,26.9940747 L15.9940717,90.0719455 L79.0719424,79.0719424 L90.0719455,15.9940717 L26.9940747,26.9940747 Z',stroke:'#979797'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 263.033 200.033)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M236.994075,173.994075 L225.994072,237.071946 L289.071942,226.071942 L300.071946,162.994072 L236.994075,173.994075 Z',stroke:'#979797'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 158.033 126.533)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M131.994075,100.494075 L120.994072,163.571946 L184.071942,152.571942 L195.071946,89.4940717 L131.994075,100.494075 Z',stroke:'#979797'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 368.033 273.533)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M341.994075,247.494075 L330.994072,310.571946 L394.071942,299.571942 L405.071946,236.494072 L341.994075,247.494075 Z',stroke:'#979797'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 473.033 347.191)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M446.994075,321.152083 L435.994072,384.229954 L499.071942,373.229951 L510.071946,310.15208 L446.994075,321.152083 Z',stroke:'#979797'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 105.533 89.783)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M79.4940747,63.7440747 L68.4940717,126.821946 L131.571942,115.821942 L142.571946,52.7440717 L79.4940747,63.7440747 Z',stroke:'#979797'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 315.533 236.783)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M289.494075,210.744075 L278.494072,273.821946 L341.571942,262.821942 L352.571946,199.744072 L289.494075,210.744075 Z',stroke:'#979797'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 210.533 163.283)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M184.494075,137.244075 L173.494072,200.321946 L236.571942,189.321942 L247.571946,126.244072 L184.494075,137.244075 Z',stroke:'#979797'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 420.533 310.283)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M394.494075,284.244075 L383.494072,347.321946 L446.571942,336.321942 L457.571946,273.244072 L394.494075,284.244075 Z',stroke:'#979797'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 525.533 383.941)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M499.494075,357.902083 L488.494072,420.979954 L551.571942,409.979951 L562.571946,346.90208 L499.494075,357.902083 Z',stroke:'#979797'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'10m',transform:'translate(209.25 183.75)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 53.033 53.033)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M26.9940747,26.9940747 L15.9940717,90.0719455 L79.0719424,79.0719424 L90.0719455,15.9940717 L26.9940747,26.9940747 Z',stroke:'#979797'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 263.033 200.033)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M236.994075,173.994075 L225.994072,237.071946 L289.071942,226.071942 L300.071946,162.994072 L236.994075,173.994075 Z',stroke:'#979797'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 158.033 126.533)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M131.994075,100.494075 L120.994072,163.571946 L184.071942,152.571942 L195.071946,89.4940717 L131.994075,100.494075 Z',stroke:'#979797'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 368.033 273.533)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M341.994075,247.494075 L330.994072,310.571946 L394.071942,299.571942 L405.071946,236.494072 L341.994075,247.494075 Z',stroke:'#979797'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 473.033 347.191)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M446.994075,321.152083 L435.994072,384.229954 L499.071942,373.229951 L510.071946,310.15208 L446.994075,321.152083 Z',stroke:'#979797'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 105.533 89.783)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M79.4940747,63.7440747 L68.4940717,126.821946 L131.571942,115.821942 L142.571946,52.7440717 L79.4940747,63.7440747 Z',stroke:'#979797'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 315.533 236.783)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M289.494075,210.744075 L278.494072,273.821946 L341.571942,262.821942 L352.571946,199.744072 L289.494075,210.744075 Z',stroke:'#979797'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 210.533 163.283)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M184.494075,137.244075 L173.494072,200.321946 L236.571942,189.321942 L247.571946,126.244072 L184.494075,137.244075 Z',stroke:'#979797'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 420.533 310.283)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M394.494075,284.244075 L383.494072,347.321946 L446.571942,336.321942 L457.571946,273.244072 L394.494075,284.244075 Z',stroke:'#979797'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 525.533 383.941)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M499.494075,357.902083 L488.494072,420.979954 L551.571942,409.979951 L562.571946,346.90208 L499.494075,357.902083 Z',stroke:'#979797'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'10m',transform:'translate(261.75 147)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 53.033 53.033)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M26.9940747,26.9940747 L15.9940717,90.0719455 L79.0719424,79.0719424 L90.0719455,15.9940717 L26.9940747,26.9940747 Z',stroke:'#979797'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 263.033 200.033)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M236.994075,173.994075 L225.994072,237.071946 L289.071942,226.071942 L300.071946,162.994072 L236.994075,173.994075 Z',stroke:'#979797'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 158.033 126.533)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M131.994075,100.494075 L120.994072,163.571946 L184.071942,152.571942 L195.071946,89.4940717 L131.994075,100.494075 Z',stroke:'#979797'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 368.033 273.533)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M341.994075,247.494075 L330.994072,310.571946 L394.071942,299.571942 L405.071946,236.494072 L341.994075,247.494075 Z',stroke:'#979797'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 473.033 347.191)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M446.994075,321.152083 L435.994072,384.229954 L499.071942,373.229951 L510.071946,310.15208 L446.994075,321.152083 Z',stroke:'#979797'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 105.533 89.783)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M79.4940747,63.7440747 L68.4940717,126.821946 L131.571942,115.821942 L142.571946,52.7440717 L79.4940747,63.7440747 Z',stroke:'#979797'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 315.533 236.783)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M289.494075,210.744075 L278.494072,273.821946 L341.571942,262.821942 L352.571946,199.744072 L289.494075,210.744075 Z',stroke:'#979797'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 210.533 163.283)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M184.494075,137.244075 L173.494072,200.321946 L236.571942,189.321942 L247.571946,126.244072 L184.494075,137.244075 Z',stroke:'#979797'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 420.533 310.283)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M394.494075,284.244075 L383.494072,347.321946 L446.571942,336.321942 L457.571946,273.244072 L394.494075,284.244075 Z',stroke:'#979797'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 525.533 383.941)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M499.494075,357.902083 L488.494072,420.979954 L551.571942,409.979951 L562.571946,346.90208 L499.494075,357.902083 Z',stroke:'#979797'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'10m',transform:'translate(314.25 110.25)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 53.033 53.033)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M26.9940747,26.9940747 L15.9940717,90.0719455 L79.0719424,79.0719424 L90.0719455,15.9940717 L26.9940747,26.9940747 Z',stroke:'#979797'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 263.033 200.033)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M236.994075,173.994075 L225.994072,237.071946 L289.071942,226.071942 L300.071946,162.994072 L236.994075,173.994075 Z',stroke:'#979797'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 158.033 126.533)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M131.994075,100.494075 L120.994072,163.571946 L184.071942,152.571942 L195.071946,89.4940717 L131.994075,100.494075 Z',stroke:'#979797'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 368.033 273.533)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M341.994075,247.494075 L330.994072,310.571946 L394.071942,299.571942 L405.071946,236.494072 L341.994075,247.494075 Z',stroke:'#979797'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 473.033 347.191)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M446.994075,321.152083 L435.994072,384.229954 L499.071942,373.229951 L510.071946,310.15208 L446.994075,321.152083 Z',stroke:'#979797'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 105.533 89.783)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M79.4940747,63.7440747 L68.4940717,126.821946 L131.571942,115.821942 L142.571946,52.7440717 L79.4940747,63.7440747 Z',stroke:'#979797'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 315.533 236.783)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M289.494075,210.744075 L278.494072,273.821946 L341.571942,262.821942 L352.571946,199.744072 L289.494075,210.744075 Z',stroke:'#979797'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 210.533 163.283)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M184.494075,137.244075 L173.494072,200.321946 L236.571942,189.321942 L247.571946,126.244072 L184.494075,137.244075 Z',stroke:'#979797'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 420.533 310.283)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M394.494075,284.244075 L383.494072,347.321946 L446.571942,336.321942 L457.571946,273.244072 L394.494075,284.244075 Z',stroke:'#979797'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 525.533 383.941)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M499.494075,357.902083 L488.494072,420.979954 L551.571942,409.979951 L562.571946,346.90208 L499.494075,357.902083 Z',stroke:'#979797'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'10m',transform:'translate(366.75 73.5)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 53.033 53.033)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M26.9940747,26.9940747 L15.9940717,90.0719455 L79.0719424,79.0719424 L90.0719455,15.9940717 L26.9940747,26.9940747 Z',stroke:'#979797'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 263.033 200.033)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M236.994075,173.994075 L225.994072,237.071946 L289.071942,226.071942 L300.071946,162.994072 L236.994075,173.994075 Z',stroke:'#979797'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 158.033 126.533)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M131.994075,100.494075 L120.994072,163.571946 L184.071942,152.571942 L195.071946,89.4940717 L131.994075,100.494075 Z',stroke:'#979797'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 368.033 273.533)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M341.994075,247.494075 L330.994072,310.571946 L394.071942,299.571942 L405.071946,236.494072 L341.994075,247.494075 Z',stroke:'#979797'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 473.033 347.191)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M446.994075,321.152083 L435.994072,384.229954 L499.071942,373.229951 L510.071946,310.15208 L446.994075,321.152083 Z',stroke:'#979797'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 105.533 89.783)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M79.4940747,63.7440747 L68.4940717,126.821946 L131.571942,115.821942 L142.571946,52.7440717 L79.4940747,63.7440747 Z',stroke:'#979797'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 315.533 236.783)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M289.494075,210.744075 L278.494072,273.821946 L341.571942,262.821942 L352.571946,199.744072 L289.494075,210.744075 Z',stroke:'#979797'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 210.533 163.283)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M184.494075,137.244075 L173.494072,200.321946 L236.571942,189.321942 L247.571946,126.244072 L184.494075,137.244075 Z',stroke:'#979797'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 420.533 310.283)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M394.494075,284.244075 L383.494072,347.321946 L446.571942,336.321942 L457.571946,273.244072 L394.494075,284.244075 Z',stroke:'#979797'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 525.533 383.941)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M499.494075,357.902083 L488.494072,420.979954 L551.571942,409.979951 L562.571946,346.90208 L499.494075,357.902083 Z',stroke:'#979797'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'10m',transform:'translate(418.5 36.75)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 53.033 53.033)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M26.9940747,26.9940747 L15.9940717,90.0719455 L79.0719424,79.0719424 L90.0719455,15.9940717 L26.9940747,26.9940747 Z',stroke:'#979797'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 263.033 200.033)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M236.994075,173.994075 L225.994072,237.071946 L289.071942,226.071942 L300.071946,162.994072 L236.994075,173.994075 Z',stroke:'#979797'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 158.033 126.533)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M131.994075,100.494075 L120.994072,163.571946 L184.071942,152.571942 L195.071946,89.4940717 L131.994075,100.494075 Z',stroke:'#979797'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 368.033 273.533)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M341.994075,247.494075 L330.994072,310.571946 L394.071942,299.571942 L405.071946,236.494072 L341.994075,247.494075 Z',stroke:'#979797'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 473.033 347.191)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M446.994075,321.152083 L435.994072,384.229954 L499.071942,373.229951 L510.071946,310.15208 L446.994075,321.152083 Z',stroke:'#979797'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 105.533 89.783)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M79.4940747,63.7440747 L68.4940717,126.821946 L131.571942,115.821942 L142.571946,52.7440717 L79.4940747,63.7440747 Z',stroke:'#979797'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 315.533 236.783)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M289.494075,210.744075 L278.494072,273.821946 L341.571942,262.821942 L352.571946,199.744072 L289.494075,210.744075 Z',stroke:'#979797'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 210.533 163.283)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M184.494075,137.244075 L173.494072,200.321946 L236.571942,189.321942 L247.571946,126.244072 L184.494075,137.244075 Z',stroke:'#979797'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 420.533 310.283)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M394.494075,284.244075 L383.494072,347.321946 L446.571942,336.321942 L457.571946,273.244072 L394.494075,284.244075 Z',stroke:'#979797'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 525.533 383.941)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M499.494075,357.902083 L488.494072,420.979954 L551.571942,409.979951 L562.571946,346.90208 L499.494075,357.902083 Z',stroke:'#979797'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'10m',transform:'translate(471)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 53.033 53.033)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M26.9940747,26.9940747 L15.9940717,90.0719455 L79.0719424,79.0719424 L90.0719455,15.9940717 L26.9940747,26.9940747 Z',stroke:'#979797'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 263.033 200.033)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M236.994075,173.994075 L225.994072,237.071946 L289.071942,226.071942 L300.071946,162.994072 L236.994075,173.994075 Z',stroke:'#979797'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 158.033 126.533)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M131.994075,100.494075 L120.994072,163.571946 L184.071942,152.571942 L195.071946,89.4940717 L131.994075,100.494075 Z',stroke:'#979797'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 368.033 273.533)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M341.994075,247.494075 L330.994072,310.571946 L394.071942,299.571942 L405.071946,236.494072 L341.994075,247.494075 Z',stroke:'#979797'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 473.033 347.191)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M446.994075,321.152083 L435.994072,384.229954 L499.071942,373.229951 L510.071946,310.15208 L446.994075,321.152083 Z',stroke:'#979797'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 105.533 89.783)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M79.4940747,63.7440747 L68.4940717,126.821946 L131.571942,115.821942 L142.571946,52.7440717 L79.4940747,63.7440747 Z',stroke:'#979797'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 315.533 236.783)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M289.494075,210.744075 L278.494072,273.821946 L341.571942,262.821942 L352.571946,199.744072 L289.494075,210.744075 Z',stroke:'#979797'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 210.533 163.283)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M184.494075,137.244075 L173.494072,200.321946 L236.571942,189.321942 L247.571946,126.244072 L184.494075,137.244075 Z',stroke:'#979797'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 420.533 310.283)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M394.494075,284.244075 L383.494072,347.321946 L446.571942,336.321942 L457.571946,273.244072 L394.494075,284.244075 Z',stroke:'#979797'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'rotate(45 525.533 383.941)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#D8D8D8',d:'M499.494075,357.902083 L488.494072,420.979954 L551.571942,409.979951 L562.571946,346.90208 L499.494075,357.902083 Z',stroke:'#979797'})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Desk,{ratio:this.state.ratio}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Pretreat,{ratio:this.state.ratio}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Press,{ratio:this.state.ratio}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Gtx1,{ratio:this.state.ratio}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Gtx2,{ratio:this.state.ratio}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Gtx3,{ratio:this.state.ratio}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Gtx4,{ratio:this.state.ratio}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Senddesk,{ratio:this.state.ratio}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Dryer,{ratio:this.state.ratio}));}}]);return RoomL;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (RoomL);var Gtx1=function(_React$Component2){_inherits(Gtx1,_React$Component2);function Gtx1(props){_classCallCheck(this,Gtx1);var _this2=_possibleConstructorReturn(this,(Gtx1.__proto__||Object.getPrototypeOf(Gtx1)).call(this,props));_this2.state={originalWidth:264,originalHeight:188,x:0,y:-500,opacity:0,ratio:parseFloat(props.ratio)};_this2.state=Object.assign({},_this2.state,{width:_this2.state.originalWidth/_this2.state.ratio,height:_this2.state.originalHeight/_this2.state.ratio});return _this2;}_createClass(Gtx1,[{key:'getKeyFrames',value:function getKeyFrames(){return[{transform:'translateY(-500px)',opacity:0,offset:0},{opacity:1,offset:1},{transform:'translateY(0)',opacity:1,offset:1}];}},{key:'getTiming',value:function getTiming(duration){return{duration:duration,easing:'ease-in',delay:0,iterations:1,fill:'forwards'};}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_web_animation__["Animated"].img,{keyframes:this.getKeyFrames(),timing:this.getTiming(750),style:{position:'absolute',top:278/this.state.ratio,left:471/this.state.ratio,opacity:this.state.opacity,transform:[{translateY:this.state.y}],width:this.state.width,height:this.state.height},src:__webpack_require__(3)});}}]);return Gtx1;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var Gtx2=function(_React$Component3){_inherits(Gtx2,_React$Component3);function Gtx2(props){_classCallCheck(this,Gtx2);var _this3=_possibleConstructorReturn(this,(Gtx2.__proto__||Object.getPrototypeOf(Gtx2)).call(this,props));_this3.state={originalWidth:264,originalHeight:188,x:0,y:-500,opacity:0,ratio:parseFloat(props.ratio)};_this3.state=Object.assign({},_this3.state,{width:_this3.state.originalWidth/_this3.state.ratio,height:_this3.state.originalHeight/_this3.state.ratio});return _this3;}_createClass(Gtx2,[{key:'getKeyFrames',value:function getKeyFrames(){return[{transform:'translateY(-500px)',opacity:0,offset:0},{opacity:1,offset:1},{transform:'translateY(0)',opacity:1,offset:1}];}},{key:'getTiming',value:function getTiming(duration){return{duration:duration,easing:'ease-in',delay:0,iterations:1,fill:'forwards'};}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_web_animation__["Animated"].img,{keyframes:this.getKeyFrames(),timing:this.getTiming(750),style:{position:'absolute',top:352/this.state.ratio,left:577/this.state.ratio,opacity:this.state.opacity,transform:[{translateY:this.state.y}],width:this.state.width,height:this.state.height},src:__webpack_require__(3)});}}]);return Gtx2;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var Gtx3=function(_React$Component4){_inherits(Gtx3,_React$Component4);function Gtx3(props){_classCallCheck(this,Gtx3);var _this4=_possibleConstructorReturn(this,(Gtx3.__proto__||Object.getPrototypeOf(Gtx3)).call(this,props));_this4.state={originalWidth:264,originalHeight:188,x:0,y:-500,opacity:0,ratio:parseFloat(props.ratio)};_this4.state=Object.assign({},_this4.state,{width:_this4.state.originalWidth/_this4.state.ratio,height:_this4.state.originalHeight/_this4.state.ratio});return _this4;}_createClass(Gtx3,[{key:'getKeyFrames',value:function getKeyFrames(){return[{transform:'translateY(-500px)',opacity:0,offset:0},{opacity:1,offset:1},{transform:'translateY(0)',opacity:1,offset:1}];}},{key:'getTiming',value:function getTiming(duration){return{duration:duration,easing:'ease-in',delay:0,iterations:1,fill:'forwards'};}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_web_animation__["Animated"].img,{keyframes:this.getKeyFrames(),timing:this.getTiming(750),style:{position:'absolute',top:425/this.state.ratio,left:683/this.state.ratio,opacity:this.state.opacity,transform:[{translateY:this.state.y}],width:this.state.width,height:this.state.height},src:__webpack_require__(3)});}}]);return Gtx3;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var Gtx4=function(_React$Component5){_inherits(Gtx4,_React$Component5);function Gtx4(props){_classCallCheck(this,Gtx4);var _this5=_possibleConstructorReturn(this,(Gtx4.__proto__||Object.getPrototypeOf(Gtx4)).call(this,props));_this5.state={originalWidth:264,originalHeight:188,x:0,y:-500,opacity:0,ratio:parseFloat(props.ratio)};_this5.state=Object.assign({},_this5.state,{width:_this5.state.originalWidth/_this5.state.ratio,height:_this5.state.originalHeight/_this5.state.ratio});return _this5;}_createClass(Gtx4,[{key:'getKeyFrames',value:function getKeyFrames(){return[{transform:'translateY(-500px)',opacity:0,offset:0},{opacity:1,offset:1},{transform:'translateY(0)',opacity:1,offset:1}];}},{key:'getTiming',value:function getTiming(duration){return{duration:duration,easing:'ease-in',delay:0,iterations:1,fill:'forwards'};}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_web_animation__["Animated"].img,{keyframes:this.getKeyFrames(),timing:this.getTiming(750),style:{position:'absolute',top:497/this.state.ratio,left:789/this.state.ratio,opacity:this.state.opacity,transform:[{translateY:this.state.y}],width:this.state.width,height:this.state.height},src:__webpack_require__(3)});}}]);return Gtx4;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var Senddesk=function(_React$Component6){_inherits(Senddesk,_React$Component6);function Senddesk(props){_classCallCheck(this,Senddesk);var _this6=_possibleConstructorReturn(this,(Senddesk.__proto__||Object.getPrototypeOf(Senddesk)).call(this,props));_this6.state={originalWidth:212,originalHeight:170,x:0,y:-500,opacity:0,ratio:parseFloat(props.ratio)};_this6.state=Object.assign({},_this6.state,{width:_this6.state.originalWidth/_this6.state.ratio,height:_this6.state.originalHeight/_this6.state.ratio});return _this6;}_createClass(Senddesk,[{key:'getKeyFrames',value:function getKeyFrames(){return[{transform:'translateY(-500px)',opacity:0,offset:0},{opacity:1,offset:1},{transform:'translateY(0)',opacity:1,offset:1}];}},{key:'getTiming',value:function getTiming(duration){return{duration:duration,easing:'ease-in',delay:0,iterations:1,fill:'forwards'};}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_web_animation__["Animated"].img,{keyframes:this.getKeyFrames(),timing:this.getTiming(750),style:{position:'absolute',top:515/this.state.ratio,left:574/this.state.ratio,opacity:this.state.opacity,transform:[{translateY:this.state.y}],width:this.state.width,height:this.state.height},src:__webpack_require__(19)});}}]);return Senddesk;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var Desk=function(_React$Component7){_inherits(Desk,_React$Component7);function Desk(props){_classCallCheck(this,Desk);var _this7=_possibleConstructorReturn(this,(Desk.__proto__||Object.getPrototypeOf(Desk)).call(this,props));_this7.state={originalWidth:212,originalHeight:150,x:0,y:-500,opacity:0,ratio:parseFloat(props.ratio)};_this7.state=Object.assign({},_this7.state,{width:_this7.state.originalWidth/_this7.state.ratio,height:_this7.state.originalHeight/_this7.state.ratio});return _this7;}_createClass(Desk,[{key:'getKeyFrames',value:function getKeyFrames(){return[{transform:'translateY(-500px)',opacity:0,offset:0},{opacity:1,offset:1},{transform:'translateY(0)',opacity:1,offset:1}];}},{key:'getTiming',value:function getTiming(duration){return{duration:duration,easing:'ease-in',delay:0,iterations:1,fill:'forwards'};}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_web_animation__["Animated"].img,{keyframes:this.getKeyFrames(),timing:this.getTiming(750),style:{position:'absolute',top:424/this.state.ratio,left:418/this.state.ratio,opacity:this.state.opacity,transform:[{translateY:this.state.y}],width:this.state.width,height:this.state.height},src:__webpack_require__(17)});}}]);return Desk;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var Press=function(_React$Component8){_inherits(Press,_React$Component8);function Press(props){_classCallCheck(this,Press);var _this8=_possibleConstructorReturn(this,(Press.__proto__||Object.getPrototypeOf(Press)).call(this,props));_this8.state={originalWidth:160,originalHeight:156,x:0,y:-500,opacity:0,ratio:parseFloat(props.ratio)};_this8.state=Object.assign({},_this8.state,{width:_this8.state.originalWidth/_this8.state.ratio,height:_this8.state.originalHeight/_this8.state.ratio});return _this8;}_createClass(Press,[{key:'getKeyFrames',value:function getKeyFrames(){return[{transform:'translateY(-500px)',opacity:0,offset:0},{opacity:1,offset:1},{transform:'translateY(0)',opacity:1,offset:1}];}},{key:'getTiming',value:function getTiming(duration){return{duration:duration,easing:'ease-in',delay:0,iterations:1,fill:'forwards'};}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_web_animation__["Animated"].img,{keyframes:this.getKeyFrames(),timing:this.getTiming(750),style:{position:'absolute',top:197/this.state.ratio,left:419/this.state.ratio,opacity:this.state.opacity,transform:[{translateY:this.state.y}],width:this.state.width,height:this.state.height},src:__webpack_require__(18)});}}]);return Press;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var Pretreat=function(_React$Component9){_inherits(Pretreat,_React$Component9);function Pretreat(props){_classCallCheck(this,Pretreat);var _this9=_possibleConstructorReturn(this,(Pretreat.__proto__||Object.getPrototypeOf(Pretreat)).call(this,props));_this9.state={originalWidth:160,originalHeight:149,x:0,y:-500,opacity:0,ratio:parseFloat(props.ratio)};_this9.state=Object.assign({},_this9.state,{width:_this9.state.originalWidth/_this9.state.ratio,height:_this9.state.originalHeight/_this9.state.ratio});return _this9;}_createClass(Pretreat,[{key:'getKeyFrames',value:function getKeyFrames(){return[{transform:'translateY(-500px)',opacity:0,offset:0},{opacity:1,offset:1},{transform:'translateY(0)',opacity:1,offset:1}];}},{key:'getTiming',value:function getTiming(duration){return{duration:duration,easing:'ease-in',delay:0,iterations:1,fill:'forwards'};}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_web_animation__["Animated"].img,{keyframes:this.getKeyFrames(),timing:this.getTiming(750),style:{position:'absolute',top:168/this.state.ratio,left:470/this.state.ratio,opacity:this.state.opacity,transform:[{translateY:this.state.y}],width:this.state.width,height:this.state.height},src:__webpack_require__(28)});}}]);return Pretreat;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var Dryer=function(_React$Component10){_inherits(Dryer,_React$Component10);function Dryer(props){_classCallCheck(this,Dryer);var _this10=_possibleConstructorReturn(this,(Dryer.__proto__||Object.getPrototypeOf(Dryer)).call(this,props));_this10.state={originalWidth:420,originalHeight:316,x:0,y:-500,opacity:0,ratio:parseFloat(props.ratio)};_this10.state=Object.assign({},_this10.state,{width:_this10.state.originalWidth/_this10.state.ratio,height:_this10.state.originalHeight/_this10.state.ratio});return _this10;}_createClass(Dryer,[{key:'getKeyFrames',value:function getKeyFrames(){return[{transform:'translateY(-500px)',opacity:0,offset:0},{opacity:1,offset:1},{transform:'translateY(0)',opacity:1,offset:1}];}},{key:'getTiming',value:function getTiming(duration){return{duration:duration,easing:'ease-in',delay:0,iterations:1,fill:'forwards'};}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_web_animation__["Animated"].img,{keyframes:this.getKeyFrames(),timing:this.getTiming(750),style:{position:'absolute',top:300/this.state.ratio,left:103/this.state.ratio,opacity:this.state.opacity,transform:[{translateY:this.state.y}],width:this.state.width,height:this.state.height},src:__webpack_require__(42)});}}]);return Dryer;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_web_animation__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_web_animation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_web_animation__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RoomXL=function(_React$Component){_inherits(RoomXL,_React$Component);function RoomXL(props){_classCallCheck(this,RoomXL);var _this=_possibleConstructorReturn(this,(RoomXL.__proto__||Object.getPrototypeOf(RoomXL)).call(this,props));_this.state={originalWidth:1051,originalHeight:944};_this.state=Object.assign({},_this.state,{width:parseFloat(props.width),height:_this.state.originalHeight/(_this.state.originalWidth/parseFloat(props.width)),ratio:_this.state.originalWidth/parseFloat(props.width)});return _this;}_createClass(RoomXL,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{height:this.state.height,width:this.state.width,viewBox:'0 0 '+this.state.originalWidth+' '+this.state.originalHeight},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('defs',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-1',points:'26.6699404 26.6699404 90.5330086 15.5330086 79.3960768 79.3960768 15.5330086 90.5330086'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-2',points:'236.66994 173.66994 300.533009 162.533009 289.396077 226.396077 225.533009 237.533009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-3',points:'131.66994 100.16994 195.533009 89.0330086 184.396077 152.896077 120.533009 164.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-4',points:'341.66994 247.16994 405.533009 236.033009 394.396077 299.896077 330.533009 311.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-5',points:'446.66994 320.827949 510.533009 309.691017 499.396077 373.554085 435.533009 384.691017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-6',points:'79.1699404 63.4199404 143.033009 52.2830086 131.896077 116.146077 68.0330086 127.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-7',points:'289.16994 210.41994 353.033009 199.283009 341.896077 263.146077 278.033009 274.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-8',points:'184.16994 136.91994 248.033009 125.783009 236.896077 189.646077 173.033009 200.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-9',points:'394.16994 283.91994 458.033009 272.783009 446.896077 336.646077 383.033009 347.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-10',points:'499.16994 357.577949 563.033009 346.441017 551.896077 410.304085 488.033009 421.441017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-11',points:'26.6699404 26.6699404 90.5330086 15.5330086 79.3960768 79.3960768 15.5330086 90.5330086'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-12',points:'236.66994 173.66994 300.533009 162.533009 289.396077 226.396077 225.533009 237.533009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-13',points:'131.66994 100.16994 195.533009 89.0330086 184.396077 152.896077 120.533009 164.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-14',points:'341.66994 247.16994 405.533009 236.033009 394.396077 299.896077 330.533009 311.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-15',points:'446.66994 320.827949 510.533009 309.691017 499.396077 373.554085 435.533009 384.691017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-16',points:'79.1699404 63.4199404 143.033009 52.2830086 131.896077 116.146077 68.0330086 127.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-17',points:'289.16994 210.41994 353.033009 199.283009 341.896077 263.146077 278.033009 274.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-18',points:'184.16994 136.91994 248.033009 125.783009 236.896077 189.646077 173.033009 200.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-19',points:'394.16994 283.91994 458.033009 272.783009 446.896077 336.646077 383.033009 347.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-20',points:'499.16994 357.577949 563.033009 346.441017 551.896077 410.304085 488.033009 421.441017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-21',points:'26.6699404 26.6699404 90.5330086 15.5330086 79.3960768 79.3960768 15.5330086 90.5330086'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-22',points:'236.66994 173.66994 300.533009 162.533009 289.396077 226.396077 225.533009 237.533009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-23',points:'131.66994 100.16994 195.533009 89.0330086 184.396077 152.896077 120.533009 164.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-24',points:'341.66994 247.16994 405.533009 236.033009 394.396077 299.896077 330.533009 311.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-25',points:'446.66994 320.827949 510.533009 309.691017 499.396077 373.554085 435.533009 384.691017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-26',points:'79.1699404 63.4199404 143.033009 52.2830086 131.896077 116.146077 68.0330086 127.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-27',points:'289.16994 210.41994 353.033009 199.283009 341.896077 263.146077 278.033009 274.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-28',points:'184.16994 136.91994 248.033009 125.783009 236.896077 189.646077 173.033009 200.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-29',points:'394.16994 283.91994 458.033009 272.783009 446.896077 336.646077 383.033009 347.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-30',points:'499.16994 357.577949 563.033009 346.441017 551.896077 410.304085 488.033009 421.441017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-31',points:'26.6699404 26.6699404 90.5330086 15.5330086 79.3960768 79.3960768 15.5330086 90.5330086'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-32',points:'236.66994 173.66994 300.533009 162.533009 289.396077 226.396077 225.533009 237.533009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-33',points:'131.66994 100.16994 195.533009 89.0330086 184.396077 152.896077 120.533009 164.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-34',points:'341.66994 247.16994 405.533009 236.033009 394.396077 299.896077 330.533009 311.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-35',points:'446.66994 320.827949 510.533009 309.691017 499.396077 373.554085 435.533009 384.691017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-36',points:'79.1699404 63.4199404 143.033009 52.2830086 131.896077 116.146077 68.0330086 127.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-37',points:'289.16994 210.41994 353.033009 199.283009 341.896077 263.146077 278.033009 274.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-38',points:'184.16994 136.91994 248.033009 125.783009 236.896077 189.646077 173.033009 200.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-39',points:'394.16994 283.91994 458.033009 272.783009 446.896077 336.646077 383.033009 347.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-40',points:'499.16994 357.577949 563.033009 346.441017 551.896077 410.304085 488.033009 421.441017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-41',points:'26.6699404 26.6699404 90.5330086 15.5330086 79.3960768 79.3960768 15.5330086 90.5330086'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-42',points:'236.66994 173.66994 300.533009 162.533009 289.396077 226.396077 225.533009 237.533009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-43',points:'131.66994 100.16994 195.533009 89.0330086 184.396077 152.896077 120.533009 164.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-44',points:'341.66994 247.16994 405.533009 236.033009 394.396077 299.896077 330.533009 311.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-45',points:'446.66994 320.827949 510.533009 309.691017 499.396077 373.554085 435.533009 384.691017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-46',points:'79.1699404 63.4199404 143.033009 52.2830086 131.896077 116.146077 68.0330086 127.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-47',points:'289.16994 210.41994 353.033009 199.283009 341.896077 263.146077 278.033009 274.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-48',points:'184.16994 136.91994 248.033009 125.783009 236.896077 189.646077 173.033009 200.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-49',points:'394.16994 283.91994 458.033009 272.783009 446.896077 336.646077 383.033009 347.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-50',points:'499.16994 357.577949 563.033009 346.441017 551.896077 410.304085 488.033009 421.441017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-51',points:'26.6699404 26.6699404 90.5330086 15.5330086 79.3960768 79.3960768 15.5330086 90.5330086'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-52',points:'236.66994 173.66994 300.533009 162.533009 289.396077 226.396077 225.533009 237.533009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-53',points:'131.66994 100.16994 195.533009 89.0330086 184.396077 152.896077 120.533009 164.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-54',points:'341.66994 247.16994 405.533009 236.033009 394.396077 299.896077 330.533009 311.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-55',points:'446.66994 320.827949 510.533009 309.691017 499.396077 373.554085 435.533009 384.691017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-56',points:'79.1699404 63.4199404 143.033009 52.2830086 131.896077 116.146077 68.0330086 127.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-57',points:'289.16994 210.41994 353.033009 199.283009 341.896077 263.146077 278.033009 274.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-58',points:'184.16994 136.91994 248.033009 125.783009 236.896077 189.646077 173.033009 200.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-59',points:'394.16994 283.91994 458.033009 272.783009 446.896077 336.646077 383.033009 347.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-60',points:'499.16994 357.577949 563.033009 346.441017 551.896077 410.304085 488.033009 421.441017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-61',points:'26.6699404 26.6699404 90.5330086 15.5330086 79.3960768 79.3960768 15.5330086 90.5330086'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-62',points:'236.66994 173.66994 300.533009 162.533009 289.396077 226.396077 225.533009 237.533009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-63',points:'131.66994 100.16994 195.533009 89.0330086 184.396077 152.896077 120.533009 164.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-64',points:'341.66994 247.16994 405.533009 236.033009 394.396077 299.896077 330.533009 311.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-65',points:'446.66994 320.827949 510.533009 309.691017 499.396077 373.554085 435.533009 384.691017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-66',points:'79.1699404 63.4199404 143.033009 52.2830086 131.896077 116.146077 68.0330086 127.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-67',points:'289.16994 210.41994 353.033009 199.283009 341.896077 263.146077 278.033009 274.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-68',points:'184.16994 136.91994 248.033009 125.783009 236.896077 189.646077 173.033009 200.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-69',points:'394.16994 283.91994 458.033009 272.783009 446.896077 336.646077 383.033009 347.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-70',points:'499.16994 357.577949 563.033009 346.441017 551.896077 410.304085 488.033009 421.441017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-71',points:'26.6699404 26.6699404 90.5330086 15.5330086 79.3960768 79.3960768 15.5330086 90.5330086'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-72',points:'236.66994 173.66994 300.533009 162.533009 289.396077 226.396077 225.533009 237.533009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-73',points:'131.66994 100.16994 195.533009 89.0330086 184.396077 152.896077 120.533009 164.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-74',points:'341.66994 247.16994 405.533009 236.033009 394.396077 299.896077 330.533009 311.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-75',points:'446.66994 320.827949 510.533009 309.691017 499.396077 373.554085 435.533009 384.691017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-76',points:'79.1699404 63.4199404 143.033009 52.2830086 131.896077 116.146077 68.0330086 127.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-77',points:'289.16994 210.41994 353.033009 199.283009 341.896077 263.146077 278.033009 274.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-78',points:'184.16994 136.91994 248.033009 125.783009 236.896077 189.646077 173.033009 200.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-79',points:'394.16994 283.91994 458.033009 272.783009 446.896077 336.646077 383.033009 347.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-80',points:'499.16994 357.577949 563.033009 346.441017 551.896077 410.304085 488.033009 421.441017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-81',points:'26.6699404 26.6699404 90.5330086 15.5330086 79.3960768 79.3960768 15.5330086 90.5330086'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-82',points:'236.66994 173.66994 300.533009 162.533009 289.396077 226.396077 225.533009 237.533009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-83',points:'131.66994 100.16994 195.533009 89.0330086 184.396077 152.896077 120.533009 164.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-84',points:'341.66994 247.16994 405.533009 236.033009 394.396077 299.896077 330.533009 311.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-85',points:'446.66994 320.827949 510.533009 309.691017 499.396077 373.554085 435.533009 384.691017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-86',points:'79.1699404 63.4199404 143.033009 52.2830086 131.896077 116.146077 68.0330086 127.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-87',points:'289.16994 210.41994 353.033009 199.283009 341.896077 263.146077 278.033009 274.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-88',points:'184.16994 136.91994 248.033009 125.783009 236.896077 189.646077 173.033009 200.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-89',points:'394.16994 283.91994 458.033009 272.783009 446.896077 336.646077 383.033009 347.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-90',points:'499.16994 357.577949 563.033009 346.441017 551.896077 410.304085 488.033009 421.441017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-91',points:'26.6699404 26.6699404 90.5330086 15.5330086 79.3960768 79.3960768 15.5330086 90.5330086'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-92',points:'236.66994 173.66994 300.533009 162.533009 289.396077 226.396077 225.533009 237.533009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-93',points:'131.66994 100.16994 195.533009 89.0330086 184.396077 152.896077 120.533009 164.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-94',points:'341.66994 247.16994 405.533009 236.033009 394.396077 299.896077 330.533009 311.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-95',points:'446.66994 320.827949 510.533009 309.691017 499.396077 373.554085 435.533009 384.691017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-96',points:'79.1699404 63.4199404 143.033009 52.2830086 131.896077 116.146077 68.0330086 127.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-97',points:'289.16994 210.41994 353.033009 199.283009 341.896077 263.146077 278.033009 274.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-98',points:'184.16994 136.91994 248.033009 125.783009 236.896077 189.646077 173.033009 200.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-99',points:'394.16994 283.91994 458.033009 272.783009 446.896077 336.646077 383.033009 347.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-100',points:'499.16994 357.577949 563.033009 346.441017 551.896077 410.304085 488.033009 421.441017'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Packages/XL',fill:'none',fillRule:'evenodd',stroke:'none',strokeWidth:'1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'Rectangle-8',fill:'#DFDFDF',points:'1.12727029 203 642 203 524.87273 370 -116 370',transform:'translate(263.000000, 286.500000) rotate(-35.000000) translate(-263.000000, -286.500000) '}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'Rectangle-8',fill:'#929292',points:'525.8493 204 1167 204 1049.91343 371 409 370.661584',transform:'translate(788.000000, 287.500000) scale(-1, 1) rotate(-35.000000) translate(-788.000000, -287.500000) '}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Boden/10x10',transform:'translate(0.000000, 189.000000)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'10m',transform:'translate(0.000000, 330.750000)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(53.033009, 53.033009) rotate(45.000000) translate(-53.033009, -53.033009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'26.6699404 26.6699404 90.5330086 15.5330086 79.3960768 79.3960768 15.5330086 90.5330086'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M26.9940747,26.9940747 L15.9940717,90.0719455 L79.0719424,79.0719424 L90.0719455,15.9940717 L26.9940747,26.9940747 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(263.033009, 200.033009) rotate(45.000000) translate(-263.033009, -200.033009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'236.66994 173.66994 300.533009 162.533009 289.396077 226.396077 225.533009 237.533009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M236.994075,173.994075 L225.994072,237.071946 L289.071942,226.071942 L300.071946,162.994072 L236.994075,173.994075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(158.033009, 126.533009) rotate(45.000000) translate(-158.033009, -126.533009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'131.66994 100.16994 195.533009 89.0330086 184.396077 152.896077 120.533009 164.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M131.994075,100.494075 L120.994072,163.571946 L184.071942,152.571942 L195.071946,89.4940717 L131.994075,100.494075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(368.033009, 273.533009) rotate(45.000000) translate(-368.033009, -273.533009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'341.66994 247.16994 405.533009 236.033009 394.396077 299.896077 330.533009 311.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M341.994075,247.494075 L330.994072,310.571946 L394.071942,299.571942 L405.071946,236.494072 L341.994075,247.494075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(473.033009, 347.191017) rotate(45.000000) translate(-473.033009, -347.191017) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'446.66994 320.827949 510.533009 309.691017 499.396077 373.554085 435.533009 384.691017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M446.994075,321.152083 L435.994072,384.229954 L499.071942,373.229951 L510.071946,310.15208 L446.994075,321.152083 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(105.533009, 89.783009) rotate(45.000000) translate(-105.533009, -89.783009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'79.1699404 63.4199404 143.033009 52.2830086 131.896077 116.146077 68.0330086 127.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M79.4940747,63.7440747 L68.4940717,126.821946 L131.571942,115.821942 L142.571946,52.7440717 L79.4940747,63.7440747 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(315.533009, 236.783009) rotate(45.000000) translate(-315.533009, -236.783009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'289.16994 210.41994 353.033009 199.283009 341.896077 263.146077 278.033009 274.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M289.494075,210.744075 L278.494072,273.821946 L341.571942,262.821942 L352.571946,199.744072 L289.494075,210.744075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(210.533009, 163.283009) rotate(45.000000) translate(-210.533009, -163.283009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'184.16994 136.91994 248.033009 125.783009 236.896077 189.646077 173.033009 200.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M184.494075,137.244075 L173.494072,200.321946 L236.571942,189.321942 L247.571946,126.244072 L184.494075,137.244075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(420.533009, 310.283009) rotate(45.000000) translate(-420.533009, -310.283009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'394.16994 283.91994 458.033009 272.783009 446.896077 336.646077 383.033009 347.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M394.494075,284.244075 L383.494072,347.321946 L446.571942,336.321942 L457.571946,273.244072 L394.494075,284.244075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(525.533009, 383.941017) rotate(45.000000) translate(-525.533009, -383.941017) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'499.16994 357.577949 563.033009 346.441017 551.896077 410.304085 488.033009 421.441017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M499.494075,357.902083 L488.494072,420.979954 L551.571942,409.979951 L562.571946,346.90208 L499.494075,357.902083 Z',stroke:'#979797',strokeWidth:'0.75'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'10m',transform:'translate(52.500000, 294.000000)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(53.033009, 53.033009) rotate(45.000000) translate(-53.033009, -53.033009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'26.6699404 26.6699404 90.5330086 15.5330086 79.3960768 79.3960768 15.5330086 90.5330086'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M26.9940747,26.9940747 L15.9940717,90.0719455 L79.0719424,79.0719424 L90.0719455,15.9940717 L26.9940747,26.9940747 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(263.033009, 200.033009) rotate(45.000000) translate(-263.033009, -200.033009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'236.66994 173.66994 300.533009 162.533009 289.396077 226.396077 225.533009 237.533009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M236.994075,173.994075 L225.994072,237.071946 L289.071942,226.071942 L300.071946,162.994072 L236.994075,173.994075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(158.033009, 126.533009) rotate(45.000000) translate(-158.033009, -126.533009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'131.66994 100.16994 195.533009 89.0330086 184.396077 152.896077 120.533009 164.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M131.994075,100.494075 L120.994072,163.571946 L184.071942,152.571942 L195.071946,89.4940717 L131.994075,100.494075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(368.033009, 273.533009) rotate(45.000000) translate(-368.033009, -273.533009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'341.66994 247.16994 405.533009 236.033009 394.396077 299.896077 330.533009 311.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M341.994075,247.494075 L330.994072,310.571946 L394.071942,299.571942 L405.071946,236.494072 L341.994075,247.494075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(473.033009, 347.191017) rotate(45.000000) translate(-473.033009, -347.191017) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'446.66994 320.827949 510.533009 309.691017 499.396077 373.554085 435.533009 384.691017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M446.994075,321.152083 L435.994072,384.229954 L499.071942,373.229951 L510.071946,310.15208 L446.994075,321.152083 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(105.533009, 89.783009) rotate(45.000000) translate(-105.533009, -89.783009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'79.1699404 63.4199404 143.033009 52.2830086 131.896077 116.146077 68.0330086 127.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M79.4940747,63.7440747 L68.4940717,126.821946 L131.571942,115.821942 L142.571946,52.7440717 L79.4940747,63.7440747 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(315.533009, 236.783009) rotate(45.000000) translate(-315.533009, -236.783009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'289.16994 210.41994 353.033009 199.283009 341.896077 263.146077 278.033009 274.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M289.494075,210.744075 L278.494072,273.821946 L341.571942,262.821942 L352.571946,199.744072 L289.494075,210.744075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(210.533009, 163.283009) rotate(45.000000) translate(-210.533009, -163.283009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'184.16994 136.91994 248.033009 125.783009 236.896077 189.646077 173.033009 200.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M184.494075,137.244075 L173.494072,200.321946 L236.571942,189.321942 L247.571946,126.244072 L184.494075,137.244075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(420.533009, 310.283009) rotate(45.000000) translate(-420.533009, -310.283009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'394.16994 283.91994 458.033009 272.783009 446.896077 336.646077 383.033009 347.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M394.494075,284.244075 L383.494072,347.321946 L446.571942,336.321942 L457.571946,273.244072 L394.494075,284.244075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(525.533009, 383.941017) rotate(45.000000) translate(-525.533009, -383.941017) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'499.16994 357.577949 563.033009 346.441017 551.896077 410.304085 488.033009 421.441017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M499.494075,357.902083 L488.494072,420.979954 L551.571942,409.979951 L562.571946,346.90208 L499.494075,357.902083 Z',stroke:'#979797',strokeWidth:'0.75'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'10m',transform:'translate(105.000000, 257.250000)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(53.033009, 53.033009) rotate(45.000000) translate(-53.033009, -53.033009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'26.6699404 26.6699404 90.5330086 15.5330086 79.3960768 79.3960768 15.5330086 90.5330086'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M26.9940747,26.9940747 L15.9940717,90.0719455 L79.0719424,79.0719424 L90.0719455,15.9940717 L26.9940747,26.9940747 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(263.033009, 200.033009) rotate(45.000000) translate(-263.033009, -200.033009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'236.66994 173.66994 300.533009 162.533009 289.396077 226.396077 225.533009 237.533009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M236.994075,173.994075 L225.994072,237.071946 L289.071942,226.071942 L300.071946,162.994072 L236.994075,173.994075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(158.033009, 126.533009) rotate(45.000000) translate(-158.033009, -126.533009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'131.66994 100.16994 195.533009 89.0330086 184.396077 152.896077 120.533009 164.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M131.994075,100.494075 L120.994072,163.571946 L184.071942,152.571942 L195.071946,89.4940717 L131.994075,100.494075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(368.033009, 273.533009) rotate(45.000000) translate(-368.033009, -273.533009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'341.66994 247.16994 405.533009 236.033009 394.396077 299.896077 330.533009 311.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M341.994075,247.494075 L330.994072,310.571946 L394.071942,299.571942 L405.071946,236.494072 L341.994075,247.494075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(473.033009, 347.191017) rotate(45.000000) translate(-473.033009, -347.191017) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'446.66994 320.827949 510.533009 309.691017 499.396077 373.554085 435.533009 384.691017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M446.994075,321.152083 L435.994072,384.229954 L499.071942,373.229951 L510.071946,310.15208 L446.994075,321.152083 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(105.533009, 89.783009) rotate(45.000000) translate(-105.533009, -89.783009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'79.1699404 63.4199404 143.033009 52.2830086 131.896077 116.146077 68.0330086 127.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M79.4940747,63.7440747 L68.4940717,126.821946 L131.571942,115.821942 L142.571946,52.7440717 L79.4940747,63.7440747 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(315.533009, 236.783009) rotate(45.000000) translate(-315.533009, -236.783009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'289.16994 210.41994 353.033009 199.283009 341.896077 263.146077 278.033009 274.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M289.494075,210.744075 L278.494072,273.821946 L341.571942,262.821942 L352.571946,199.744072 L289.494075,210.744075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(210.533009, 163.283009) rotate(45.000000) translate(-210.533009, -163.283009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'184.16994 136.91994 248.033009 125.783009 236.896077 189.646077 173.033009 200.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M184.494075,137.244075 L173.494072,200.321946 L236.571942,189.321942 L247.571946,126.244072 L184.494075,137.244075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(420.533009, 310.283009) rotate(45.000000) translate(-420.533009, -310.283009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'394.16994 283.91994 458.033009 272.783009 446.896077 336.646077 383.033009 347.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M394.494075,284.244075 L383.494072,347.321946 L446.571942,336.321942 L457.571946,273.244072 L394.494075,284.244075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(525.533009, 383.941017) rotate(45.000000) translate(-525.533009, -383.941017) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'499.16994 357.577949 563.033009 346.441017 551.896077 410.304085 488.033009 421.441017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M499.494075,357.902083 L488.494072,420.979954 L551.571942,409.979951 L562.571946,346.90208 L499.494075,357.902083 Z',stroke:'#979797',strokeWidth:'0.75'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'10m',transform:'translate(157.500000, 220.500000)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(53.033009, 53.033009) rotate(45.000000) translate(-53.033009, -53.033009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'26.6699404 26.6699404 90.5330086 15.5330086 79.3960768 79.3960768 15.5330086 90.5330086'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M26.9940747,26.9940747 L15.9940717,90.0719455 L79.0719424,79.0719424 L90.0719455,15.9940717 L26.9940747,26.9940747 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(263.033009, 200.033009) rotate(45.000000) translate(-263.033009, -200.033009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'236.66994 173.66994 300.533009 162.533009 289.396077 226.396077 225.533009 237.533009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M236.994075,173.994075 L225.994072,237.071946 L289.071942,226.071942 L300.071946,162.994072 L236.994075,173.994075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(158.033009, 126.533009) rotate(45.000000) translate(-158.033009, -126.533009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'131.66994 100.16994 195.533009 89.0330086 184.396077 152.896077 120.533009 164.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M131.994075,100.494075 L120.994072,163.571946 L184.071942,152.571942 L195.071946,89.4940717 L131.994075,100.494075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(368.033009, 273.533009) rotate(45.000000) translate(-368.033009, -273.533009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'341.66994 247.16994 405.533009 236.033009 394.396077 299.896077 330.533009 311.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M341.994075,247.494075 L330.994072,310.571946 L394.071942,299.571942 L405.071946,236.494072 L341.994075,247.494075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(473.033009, 347.191017) rotate(45.000000) translate(-473.033009, -347.191017) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'446.66994 320.827949 510.533009 309.691017 499.396077 373.554085 435.533009 384.691017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M446.994075,321.152083 L435.994072,384.229954 L499.071942,373.229951 L510.071946,310.15208 L446.994075,321.152083 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(105.533009, 89.783009) rotate(45.000000) translate(-105.533009, -89.783009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'79.1699404 63.4199404 143.033009 52.2830086 131.896077 116.146077 68.0330086 127.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M79.4940747,63.7440747 L68.4940717,126.821946 L131.571942,115.821942 L142.571946,52.7440717 L79.4940747,63.7440747 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(315.533009, 236.783009) rotate(45.000000) translate(-315.533009, -236.783009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'289.16994 210.41994 353.033009 199.283009 341.896077 263.146077 278.033009 274.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M289.494075,210.744075 L278.494072,273.821946 L341.571942,262.821942 L352.571946,199.744072 L289.494075,210.744075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(210.533009, 163.283009) rotate(45.000000) translate(-210.533009, -163.283009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'184.16994 136.91994 248.033009 125.783009 236.896077 189.646077 173.033009 200.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M184.494075,137.244075 L173.494072,200.321946 L236.571942,189.321942 L247.571946,126.244072 L184.494075,137.244075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(420.533009, 310.283009) rotate(45.000000) translate(-420.533009, -310.283009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'394.16994 283.91994 458.033009 272.783009 446.896077 336.646077 383.033009 347.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M394.494075,284.244075 L383.494072,347.321946 L446.571942,336.321942 L457.571946,273.244072 L394.494075,284.244075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(525.533009, 383.941017) rotate(45.000000) translate(-525.533009, -383.941017) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'499.16994 357.577949 563.033009 346.441017 551.896077 410.304085 488.033009 421.441017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M499.494075,357.902083 L488.494072,420.979954 L551.571942,409.979951 L562.571946,346.90208 L499.494075,357.902083 Z',stroke:'#979797',strokeWidth:'0.75'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'10m',transform:'translate(209.250000, 183.750000)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(53.033009, 53.033009) rotate(45.000000) translate(-53.033009, -53.033009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'26.6699404 26.6699404 90.5330086 15.5330086 79.3960768 79.3960768 15.5330086 90.5330086'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M26.9940747,26.9940747 L15.9940717,90.0719455 L79.0719424,79.0719424 L90.0719455,15.9940717 L26.9940747,26.9940747 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(263.033009, 200.033009) rotate(45.000000) translate(-263.033009, -200.033009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'236.66994 173.66994 300.533009 162.533009 289.396077 226.396077 225.533009 237.533009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M236.994075,173.994075 L225.994072,237.071946 L289.071942,226.071942 L300.071946,162.994072 L236.994075,173.994075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(158.033009, 126.533009) rotate(45.000000) translate(-158.033009, -126.533009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'131.66994 100.16994 195.533009 89.0330086 184.396077 152.896077 120.533009 164.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M131.994075,100.494075 L120.994072,163.571946 L184.071942,152.571942 L195.071946,89.4940717 L131.994075,100.494075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(368.033009, 273.533009) rotate(45.000000) translate(-368.033009, -273.533009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'341.66994 247.16994 405.533009 236.033009 394.396077 299.896077 330.533009 311.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M341.994075,247.494075 L330.994072,310.571946 L394.071942,299.571942 L405.071946,236.494072 L341.994075,247.494075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(473.033009, 347.191017) rotate(45.000000) translate(-473.033009, -347.191017) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'446.66994 320.827949 510.533009 309.691017 499.396077 373.554085 435.533009 384.691017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M446.994075,321.152083 L435.994072,384.229954 L499.071942,373.229951 L510.071946,310.15208 L446.994075,321.152083 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(105.533009, 89.783009) rotate(45.000000) translate(-105.533009, -89.783009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'79.1699404 63.4199404 143.033009 52.2830086 131.896077 116.146077 68.0330086 127.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M79.4940747,63.7440747 L68.4940717,126.821946 L131.571942,115.821942 L142.571946,52.7440717 L79.4940747,63.7440747 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(315.533009, 236.783009) rotate(45.000000) translate(-315.533009, -236.783009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'289.16994 210.41994 353.033009 199.283009 341.896077 263.146077 278.033009 274.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M289.494075,210.744075 L278.494072,273.821946 L341.571942,262.821942 L352.571946,199.744072 L289.494075,210.744075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(210.533009, 163.283009) rotate(45.000000) translate(-210.533009, -163.283009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'184.16994 136.91994 248.033009 125.783009 236.896077 189.646077 173.033009 200.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M184.494075,137.244075 L173.494072,200.321946 L236.571942,189.321942 L247.571946,126.244072 L184.494075,137.244075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(420.533009, 310.283009) rotate(45.000000) translate(-420.533009, -310.283009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'394.16994 283.91994 458.033009 272.783009 446.896077 336.646077 383.033009 347.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M394.494075,284.244075 L383.494072,347.321946 L446.571942,336.321942 L457.571946,273.244072 L394.494075,284.244075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(525.533009, 383.941017) rotate(45.000000) translate(-525.533009, -383.941017) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'499.16994 357.577949 563.033009 346.441017 551.896077 410.304085 488.033009 421.441017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M499.494075,357.902083 L488.494072,420.979954 L551.571942,409.979951 L562.571946,346.90208 L499.494075,357.902083 Z',stroke:'#979797',strokeWidth:'0.75'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'10m',transform:'translate(261.750000, 147.000000)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(53.033009, 53.033009) rotate(45.000000) translate(-53.033009, -53.033009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'26.6699404 26.6699404 90.5330086 15.5330086 79.3960768 79.3960768 15.5330086 90.5330086'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M26.9940747,26.9940747 L15.9940717,90.0719455 L79.0719424,79.0719424 L90.0719455,15.9940717 L26.9940747,26.9940747 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(263.033009, 200.033009) rotate(45.000000) translate(-263.033009, -200.033009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'236.66994 173.66994 300.533009 162.533009 289.396077 226.396077 225.533009 237.533009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M236.994075,173.994075 L225.994072,237.071946 L289.071942,226.071942 L300.071946,162.994072 L236.994075,173.994075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(158.033009, 126.533009) rotate(45.000000) translate(-158.033009, -126.533009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'131.66994 100.16994 195.533009 89.0330086 184.396077 152.896077 120.533009 164.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M131.994075,100.494075 L120.994072,163.571946 L184.071942,152.571942 L195.071946,89.4940717 L131.994075,100.494075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(368.033009, 273.533009) rotate(45.000000) translate(-368.033009, -273.533009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'341.66994 247.16994 405.533009 236.033009 394.396077 299.896077 330.533009 311.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M341.994075,247.494075 L330.994072,310.571946 L394.071942,299.571942 L405.071946,236.494072 L341.994075,247.494075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(473.033009, 347.191017) rotate(45.000000) translate(-473.033009, -347.191017) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'446.66994 320.827949 510.533009 309.691017 499.396077 373.554085 435.533009 384.691017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M446.994075,321.152083 L435.994072,384.229954 L499.071942,373.229951 L510.071946,310.15208 L446.994075,321.152083 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(105.533009, 89.783009) rotate(45.000000) translate(-105.533009, -89.783009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'79.1699404 63.4199404 143.033009 52.2830086 131.896077 116.146077 68.0330086 127.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M79.4940747,63.7440747 L68.4940717,126.821946 L131.571942,115.821942 L142.571946,52.7440717 L79.4940747,63.7440747 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(315.533009, 236.783009) rotate(45.000000) translate(-315.533009, -236.783009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'289.16994 210.41994 353.033009 199.283009 341.896077 263.146077 278.033009 274.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M289.494075,210.744075 L278.494072,273.821946 L341.571942,262.821942 L352.571946,199.744072 L289.494075,210.744075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(210.533009, 163.283009) rotate(45.000000) translate(-210.533009, -163.283009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'184.16994 136.91994 248.033009 125.783009 236.896077 189.646077 173.033009 200.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M184.494075,137.244075 L173.494072,200.321946 L236.571942,189.321942 L247.571946,126.244072 L184.494075,137.244075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(420.533009, 310.283009) rotate(45.000000) translate(-420.533009, -310.283009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'394.16994 283.91994 458.033009 272.783009 446.896077 336.646077 383.033009 347.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M394.494075,284.244075 L383.494072,347.321946 L446.571942,336.321942 L457.571946,273.244072 L394.494075,284.244075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(525.533009, 383.941017) rotate(45.000000) translate(-525.533009, -383.941017) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'499.16994 357.577949 563.033009 346.441017 551.896077 410.304085 488.033009 421.441017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M499.494075,357.902083 L488.494072,420.979954 L551.571942,409.979951 L562.571946,346.90208 L499.494075,357.902083 Z',stroke:'#979797',strokeWidth:'0.75'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'10m',transform:'translate(314.250000, 110.250000)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(53.033009, 53.033009) rotate(45.000000) translate(-53.033009, -53.033009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'26.6699404 26.6699404 90.5330086 15.5330086 79.3960768 79.3960768 15.5330086 90.5330086'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M26.9940747,26.9940747 L15.9940717,90.0719455 L79.0719424,79.0719424 L90.0719455,15.9940717 L26.9940747,26.9940747 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(263.033009, 200.033009) rotate(45.000000) translate(-263.033009, -200.033009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'236.66994 173.66994 300.533009 162.533009 289.396077 226.396077 225.533009 237.533009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M236.994075,173.994075 L225.994072,237.071946 L289.071942,226.071942 L300.071946,162.994072 L236.994075,173.994075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(158.033009, 126.533009) rotate(45.000000) translate(-158.033009, -126.533009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'131.66994 100.16994 195.533009 89.0330086 184.396077 152.896077 120.533009 164.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M131.994075,100.494075 L120.994072,163.571946 L184.071942,152.571942 L195.071946,89.4940717 L131.994075,100.494075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(368.033009, 273.533009) rotate(45.000000) translate(-368.033009, -273.533009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'341.66994 247.16994 405.533009 236.033009 394.396077 299.896077 330.533009 311.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M341.994075,247.494075 L330.994072,310.571946 L394.071942,299.571942 L405.071946,236.494072 L341.994075,247.494075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(473.033009, 347.191017) rotate(45.000000) translate(-473.033009, -347.191017) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'446.66994 320.827949 510.533009 309.691017 499.396077 373.554085 435.533009 384.691017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M446.994075,321.152083 L435.994072,384.229954 L499.071942,373.229951 L510.071946,310.15208 L446.994075,321.152083 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(105.533009, 89.783009) rotate(45.000000) translate(-105.533009, -89.783009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'79.1699404 63.4199404 143.033009 52.2830086 131.896077 116.146077 68.0330086 127.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M79.4940747,63.7440747 L68.4940717,126.821946 L131.571942,115.821942 L142.571946,52.7440717 L79.4940747,63.7440747 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(315.533009, 236.783009) rotate(45.000000) translate(-315.533009, -236.783009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'289.16994 210.41994 353.033009 199.283009 341.896077 263.146077 278.033009 274.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M289.494075,210.744075 L278.494072,273.821946 L341.571942,262.821942 L352.571946,199.744072 L289.494075,210.744075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(210.533009, 163.283009) rotate(45.000000) translate(-210.533009, -163.283009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'184.16994 136.91994 248.033009 125.783009 236.896077 189.646077 173.033009 200.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M184.494075,137.244075 L173.494072,200.321946 L236.571942,189.321942 L247.571946,126.244072 L184.494075,137.244075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(420.533009, 310.283009) rotate(45.000000) translate(-420.533009, -310.283009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'394.16994 283.91994 458.033009 272.783009 446.896077 336.646077 383.033009 347.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M394.494075,284.244075 L383.494072,347.321946 L446.571942,336.321942 L457.571946,273.244072 L394.494075,284.244075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(525.533009, 383.941017) rotate(45.000000) translate(-525.533009, -383.941017) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'499.16994 357.577949 563.033009 346.441017 551.896077 410.304085 488.033009 421.441017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M499.494075,357.902083 L488.494072,420.979954 L551.571942,409.979951 L562.571946,346.90208 L499.494075,357.902083 Z',stroke:'#979797',strokeWidth:'0.75'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'10m',transform:'translate(366.750000, 73.500000)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(53.033009, 53.033009) rotate(45.000000) translate(-53.033009, -53.033009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'26.6699404 26.6699404 90.5330086 15.5330086 79.3960768 79.3960768 15.5330086 90.5330086'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M26.9940747,26.9940747 L15.9940717,90.0719455 L79.0719424,79.0719424 L90.0719455,15.9940717 L26.9940747,26.9940747 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(263.033009, 200.033009) rotate(45.000000) translate(-263.033009, -200.033009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'236.66994 173.66994 300.533009 162.533009 289.396077 226.396077 225.533009 237.533009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M236.994075,173.994075 L225.994072,237.071946 L289.071942,226.071942 L300.071946,162.994072 L236.994075,173.994075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(158.033009, 126.533009) rotate(45.000000) translate(-158.033009, -126.533009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'131.66994 100.16994 195.533009 89.0330086 184.396077 152.896077 120.533009 164.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M131.994075,100.494075 L120.994072,163.571946 L184.071942,152.571942 L195.071946,89.4940717 L131.994075,100.494075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(368.033009, 273.533009) rotate(45.000000) translate(-368.033009, -273.533009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'341.66994 247.16994 405.533009 236.033009 394.396077 299.896077 330.533009 311.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M341.994075,247.494075 L330.994072,310.571946 L394.071942,299.571942 L405.071946,236.494072 L341.994075,247.494075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(473.033009, 347.191017) rotate(45.000000) translate(-473.033009, -347.191017) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'446.66994 320.827949 510.533009 309.691017 499.396077 373.554085 435.533009 384.691017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M446.994075,321.152083 L435.994072,384.229954 L499.071942,373.229951 L510.071946,310.15208 L446.994075,321.152083 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(105.533009, 89.783009) rotate(45.000000) translate(-105.533009, -89.783009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'79.1699404 63.4199404 143.033009 52.2830086 131.896077 116.146077 68.0330086 127.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M79.4940747,63.7440747 L68.4940717,126.821946 L131.571942,115.821942 L142.571946,52.7440717 L79.4940747,63.7440747 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(315.533009, 236.783009) rotate(45.000000) translate(-315.533009, -236.783009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'289.16994 210.41994 353.033009 199.283009 341.896077 263.146077 278.033009 274.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M289.494075,210.744075 L278.494072,273.821946 L341.571942,262.821942 L352.571946,199.744072 L289.494075,210.744075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(210.533009, 163.283009) rotate(45.000000) translate(-210.533009, -163.283009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'184.16994 136.91994 248.033009 125.783009 236.896077 189.646077 173.033009 200.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M184.494075,137.244075 L173.494072,200.321946 L236.571942,189.321942 L247.571946,126.244072 L184.494075,137.244075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(420.533009, 310.283009) rotate(45.000000) translate(-420.533009, -310.283009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'394.16994 283.91994 458.033009 272.783009 446.896077 336.646077 383.033009 347.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M394.494075,284.244075 L383.494072,347.321946 L446.571942,336.321942 L457.571946,273.244072 L394.494075,284.244075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(525.533009, 383.941017) rotate(45.000000) translate(-525.533009, -383.941017) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'499.16994 357.577949 563.033009 346.441017 551.896077 410.304085 488.033009 421.441017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M499.494075,357.902083 L488.494072,420.979954 L551.571942,409.979951 L562.571946,346.90208 L499.494075,357.902083 Z',stroke:'#979797',strokeWidth:'0.75'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'10m',transform:'translate(418.500000, 36.750000)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(53.033009, 53.033009) rotate(45.000000) translate(-53.033009, -53.033009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'26.6699404 26.6699404 90.5330086 15.5330086 79.3960768 79.3960768 15.5330086 90.5330086'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M26.9940747,26.9940747 L15.9940717,90.0719455 L79.0719424,79.0719424 L90.0719455,15.9940717 L26.9940747,26.9940747 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(263.033009, 200.033009) rotate(45.000000) translate(-263.033009, -200.033009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'236.66994 173.66994 300.533009 162.533009 289.396077 226.396077 225.533009 237.533009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M236.994075,173.994075 L225.994072,237.071946 L289.071942,226.071942 L300.071946,162.994072 L236.994075,173.994075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(158.033009, 126.533009) rotate(45.000000) translate(-158.033009, -126.533009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'131.66994 100.16994 195.533009 89.0330086 184.396077 152.896077 120.533009 164.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M131.994075,100.494075 L120.994072,163.571946 L184.071942,152.571942 L195.071946,89.4940717 L131.994075,100.494075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(368.033009, 273.533009) rotate(45.000000) translate(-368.033009, -273.533009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'341.66994 247.16994 405.533009 236.033009 394.396077 299.896077 330.533009 311.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M341.994075,247.494075 L330.994072,310.571946 L394.071942,299.571942 L405.071946,236.494072 L341.994075,247.494075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(473.033009, 347.191017) rotate(45.000000) translate(-473.033009, -347.191017) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'446.66994 320.827949 510.533009 309.691017 499.396077 373.554085 435.533009 384.691017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M446.994075,321.152083 L435.994072,384.229954 L499.071942,373.229951 L510.071946,310.15208 L446.994075,321.152083 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(105.533009, 89.783009) rotate(45.000000) translate(-105.533009, -89.783009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'79.1699404 63.4199404 143.033009 52.2830086 131.896077 116.146077 68.0330086 127.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M79.4940747,63.7440747 L68.4940717,126.821946 L131.571942,115.821942 L142.571946,52.7440717 L79.4940747,63.7440747 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(315.533009, 236.783009) rotate(45.000000) translate(-315.533009, -236.783009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'289.16994 210.41994 353.033009 199.283009 341.896077 263.146077 278.033009 274.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M289.494075,210.744075 L278.494072,273.821946 L341.571942,262.821942 L352.571946,199.744072 L289.494075,210.744075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(210.533009, 163.283009) rotate(45.000000) translate(-210.533009, -163.283009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'184.16994 136.91994 248.033009 125.783009 236.896077 189.646077 173.033009 200.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M184.494075,137.244075 L173.494072,200.321946 L236.571942,189.321942 L247.571946,126.244072 L184.494075,137.244075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(420.533009, 310.283009) rotate(45.000000) translate(-420.533009, -310.283009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'394.16994 283.91994 458.033009 272.783009 446.896077 336.646077 383.033009 347.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M394.494075,284.244075 L383.494072,347.321946 L446.571942,336.321942 L457.571946,273.244072 L394.494075,284.244075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(525.533009, 383.941017) rotate(45.000000) translate(-525.533009, -383.941017) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'499.16994 357.577949 563.033009 346.441017 551.896077 410.304085 488.033009 421.441017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M499.494075,357.902083 L488.494072,420.979954 L551.571942,409.979951 L562.571946,346.90208 L499.494075,357.902083 Z',stroke:'#979797',strokeWidth:'0.75'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'10m',transform:'translate(471.000000, 0.000000)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(53.033009, 53.033009) rotate(45.000000) translate(-53.033009, -53.033009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'26.6699404 26.6699404 90.5330086 15.5330086 79.3960768 79.3960768 15.5330086 90.5330086'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M26.9940747,26.9940747 L15.9940717,90.0719455 L79.0719424,79.0719424 L90.0719455,15.9940717 L26.9940747,26.9940747 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(263.033009, 200.033009) rotate(45.000000) translate(-263.033009, -200.033009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'236.66994 173.66994 300.533009 162.533009 289.396077 226.396077 225.533009 237.533009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M236.994075,173.994075 L225.994072,237.071946 L289.071942,226.071942 L300.071946,162.994072 L236.994075,173.994075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(158.033009, 126.533009) rotate(45.000000) translate(-158.033009, -126.533009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'131.66994 100.16994 195.533009 89.0330086 184.396077 152.896077 120.533009 164.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M131.994075,100.494075 L120.994072,163.571946 L184.071942,152.571942 L195.071946,89.4940717 L131.994075,100.494075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(368.033009, 273.533009) rotate(45.000000) translate(-368.033009, -273.533009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'341.66994 247.16994 405.533009 236.033009 394.396077 299.896077 330.533009 311.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M341.994075,247.494075 L330.994072,310.571946 L394.071942,299.571942 L405.071946,236.494072 L341.994075,247.494075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(473.033009, 347.191017) rotate(45.000000) translate(-473.033009, -347.191017) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'446.66994 320.827949 510.533009 309.691017 499.396077 373.554085 435.533009 384.691017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M446.994075,321.152083 L435.994072,384.229954 L499.071942,373.229951 L510.071946,310.15208 L446.994075,321.152083 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(105.533009, 89.783009) rotate(45.000000) translate(-105.533009, -89.783009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'79.1699404 63.4199404 143.033009 52.2830086 131.896077 116.146077 68.0330086 127.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M79.4940747,63.7440747 L68.4940717,126.821946 L131.571942,115.821942 L142.571946,52.7440717 L79.4940747,63.7440747 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(315.533009, 236.783009) rotate(45.000000) translate(-315.533009, -236.783009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'289.16994 210.41994 353.033009 199.283009 341.896077 263.146077 278.033009 274.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M289.494075,210.744075 L278.494072,273.821946 L341.571942,262.821942 L352.571946,199.744072 L289.494075,210.744075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(210.533009, 163.283009) rotate(45.000000) translate(-210.533009, -163.283009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'184.16994 136.91994 248.033009 125.783009 236.896077 189.646077 173.033009 200.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M184.494075,137.244075 L173.494072,200.321946 L236.571942,189.321942 L247.571946,126.244072 L184.494075,137.244075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(420.533009, 310.283009) rotate(45.000000) translate(-420.533009, -310.283009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'394.16994 283.91994 458.033009 272.783009 446.896077 336.646077 383.033009 347.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M394.494075,284.244075 L383.494072,347.321946 L446.571942,336.321942 L457.571946,273.244072 L394.494075,284.244075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(525.533009, 383.941017) rotate(45.000000) translate(-525.533009, -383.941017) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'499.16994 357.577949 563.033009 346.441017 551.896077 410.304085 488.033009 421.441017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M499.494075,357.902083 L488.494072,420.979954 L551.571942,409.979951 L562.571946,346.90208 L499.494075,357.902083 Z',stroke:'#979797',strokeWidth:'0.75'})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Desk,{ratio:this.state.ratio}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Pretreat,{ratio:this.state.ratio}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Press,{ratio:this.state.ratio}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Gtx1,{ratio:this.state.ratio}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Gtx2,{ratio:this.state.ratio}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Gtx3,{ratio:this.state.ratio}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Gtx4,{ratio:this.state.ratio}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Gtx5,{ratio:this.state.ratio}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Senddesk,{ratio:this.state.ratio}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Dryer,{ratio:this.state.ratio}));}}]);return RoomXL;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (RoomXL);var Gtx1=function(_React$Component2){_inherits(Gtx1,_React$Component2);function Gtx1(props){_classCallCheck(this,Gtx1);var _this2=_possibleConstructorReturn(this,(Gtx1.__proto__||Object.getPrototypeOf(Gtx1)).call(this,props));_this2.state={originalWidth:264,originalHeight:188,x:0,y:-500,opacity:0,ratio:parseFloat(props.ratio)};_this2.state=Object.assign({},_this2.state,{width:_this2.state.originalWidth/_this2.state.ratio,height:_this2.state.originalHeight/_this2.state.ratio});return _this2;}_createClass(Gtx1,[{key:'getKeyFrames',value:function getKeyFrames(){return[{transform:'translateY(-500px)',opacity:0,offset:0},{opacity:1,offset:1},{transform:'translateY(0)',opacity:1,offset:1}];}},{key:'getTiming',value:function getTiming(duration){return{duration:duration,easing:'ease-in',delay:0,iterations:1,fill:'forwards'};}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_web_animation__["Animated"].img,{keyframes:this.getKeyFrames(),timing:this.getTiming(750),style:{position:'absolute',top:533/this.state.ratio,left:523/this.state.ratio,opacity:this.state.opacity,transform:[{translateY:this.state.y}],width:this.state.width,height:this.state.height},src:__webpack_require__(3)});}}]);return Gtx1;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var Gtx2=function(_React$Component3){_inherits(Gtx2,_React$Component3);function Gtx2(props){_classCallCheck(this,Gtx2);var _this3=_possibleConstructorReturn(this,(Gtx2.__proto__||Object.getPrototypeOf(Gtx2)).call(this,props));_this3.state={originalWidth:264,originalHeight:188,x:0,y:-500,opacity:0,ratio:parseFloat(props.ratio)};_this3.state=Object.assign({},_this3.state,{width:_this3.state.originalWidth/_this3.state.ratio,height:_this3.state.originalHeight/_this3.state.ratio});return _this3;}_createClass(Gtx2,[{key:'getKeyFrames',value:function getKeyFrames(){return[{transform:'translateY(-500px)',opacity:0,offset:0},{opacity:1,offset:1},{transform:'translateY(0)',opacity:1,offset:1}];}},{key:'getTiming',value:function getTiming(duration){return{duration:duration,easing:'ease-in',delay:0,iterations:1,fill:'forwards'};}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_web_animation__["Animated"].img,{keyframes:this.getKeyFrames(),timing:this.getTiming(750),style:{position:'absolute',top:352/this.state.ratio,left:577/this.state.ratio,opacity:this.state.opacity,transform:[{translateY:this.state.y}],width:this.state.width,height:this.state.height},src:__webpack_require__(3)});}}]);return Gtx2;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var Gtx3=function(_React$Component4){_inherits(Gtx3,_React$Component4);function Gtx3(props){_classCallCheck(this,Gtx3);var _this4=_possibleConstructorReturn(this,(Gtx3.__proto__||Object.getPrototypeOf(Gtx3)).call(this,props));_this4.state={originalWidth:264,originalHeight:188,x:0,y:-500,opacity:0,ratio:parseFloat(props.ratio)};_this4.state=Object.assign({},_this4.state,{width:_this4.state.originalWidth/_this4.state.ratio,height:_this4.state.originalHeight/_this4.state.ratio});return _this4;}_createClass(Gtx3,[{key:'getKeyFrames',value:function getKeyFrames(){return[{transform:'translateY(-500px)',opacity:0,offset:0},{opacity:1,offset:1},{transform:'translateY(0)',opacity:1,offset:1}];}},{key:'getTiming',value:function getTiming(duration){return{duration:duration,easing:'ease-in',delay:0,iterations:1,fill:'forwards'};}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_web_animation__["Animated"].img,{keyframes:this.getKeyFrames(),timing:this.getTiming(750),style:{position:'absolute',top:425/this.state.ratio,left:683/this.state.ratio,opacity:this.state.opacity,transform:[{translateY:this.state.y}],width:this.state.width,height:this.state.height},src:__webpack_require__(3)});}}]);return Gtx3;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var Gtx4=function(_React$Component5){_inherits(Gtx4,_React$Component5);function Gtx4(props){_classCallCheck(this,Gtx4);var _this5=_possibleConstructorReturn(this,(Gtx4.__proto__||Object.getPrototypeOf(Gtx4)).call(this,props));_this5.state={originalWidth:264,originalHeight:188,x:0,y:-500,opacity:0,ratio:parseFloat(props.ratio)};_this5.state=Object.assign({},_this5.state,{width:_this5.state.originalWidth/_this5.state.ratio,height:_this5.state.originalHeight/_this5.state.ratio});return _this5;}_createClass(Gtx4,[{key:'getKeyFrames',value:function getKeyFrames(){return[{transform:'translateY(-500px)',opacity:0,offset:0},{opacity:1,offset:1},{transform:'translateY(0)',opacity:1,offset:1}];}},{key:'getTiming',value:function getTiming(duration){return{duration:duration,easing:'ease-in',delay:0,iterations:1,fill:'forwards'};}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_web_animation__["Animated"].img,{keyframes:this.getKeyFrames(),timing:this.getTiming(750),style:{position:'absolute',top:497/this.state.ratio,left:789/this.state.ratio,opacity:this.state.opacity,transform:[{translateY:this.state.y}],width:this.state.width,height:this.state.height},src:__webpack_require__(3)});}}]);return Gtx4;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var Gtx5=function(_React$Component6){_inherits(Gtx5,_React$Component6);function Gtx5(props){_classCallCheck(this,Gtx5);var _this6=_possibleConstructorReturn(this,(Gtx5.__proto__||Object.getPrototypeOf(Gtx5)).call(this,props));_this6.state={originalWidth:264,originalHeight:188,x:0,y:-500,opacity:0,ratio:parseFloat(props.ratio)};_this6.state=Object.assign({},_this6.state,{width:_this6.state.originalWidth/_this6.state.ratio,height:_this6.state.originalHeight/_this6.state.ratio});return _this6;}_createClass(Gtx5,[{key:'getKeyFrames',value:function getKeyFrames(){return[{transform:'translateY(-500px)',opacity:0,offset:0},{opacity:1,offset:1},{transform:'translateY(0)',opacity:1,offset:1}];}},{key:'getTiming',value:function getTiming(duration){return{duration:duration,easing:'ease-in',delay:0,iterations:1,fill:'forwards'};}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_web_animation__["Animated"].img,{keyframes:this.getKeyFrames(),timing:this.getTiming(750),style:{position:'absolute',top:608/this.state.ratio,left:628/this.state.ratio,opacity:this.state.opacity,transform:[{translateY:this.state.y}],width:this.state.width,height:this.state.height},src:__webpack_require__(3)});}}]);return Gtx5;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var Senddesk=function(_React$Component7){_inherits(Senddesk,_React$Component7);function Senddesk(props){_classCallCheck(this,Senddesk);var _this7=_possibleConstructorReturn(this,(Senddesk.__proto__||Object.getPrototypeOf(Senddesk)).call(this,props));_this7.state={originalWidth:212,originalHeight:170,x:0,y:-500,opacity:0,ratio:parseFloat(props.ratio)};_this7.state=Object.assign({},_this7.state,{width:_this7.state.originalWidth/_this7.state.ratio,height:_this7.state.originalHeight/_this7.state.ratio});return _this7;}_createClass(Senddesk,[{key:'getKeyFrames',value:function getKeyFrames(){return[{transform:'translateY(-500px)',opacity:0,offset:0},{opacity:1,offset:1},{transform:'translateY(0)',opacity:1,offset:1}];}},{key:'getTiming',value:function getTiming(duration){return{duration:duration,easing:'ease-in',delay:0,iterations:1,fill:'forwards'};}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_web_animation__["Animated"].img,{keyframes:this.getKeyFrames(),timing:this.getTiming(750),style:{position:'absolute',top:258/this.state.ratio,left:524/this.state.ratio,opacity:this.state.opacity,transform:[{translateY:this.state.y}],width:this.state.width,height:this.state.height},src:__webpack_require__(19)});}}]);return Senddesk;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var Desk=function(_React$Component8){_inherits(Desk,_React$Component8);function Desk(props){_classCallCheck(this,Desk);var _this8=_possibleConstructorReturn(this,(Desk.__proto__||Object.getPrototypeOf(Desk)).call(this,props));_this8.state={originalWidth:212,originalHeight:150,x:0,y:-500,opacity:0,ratio:parseFloat(props.ratio)};_this8.state=Object.assign({},_this8.state,{width:_this8.state.originalWidth/_this8.state.ratio,height:_this8.state.originalHeight/_this8.state.ratio});return _this8;}_createClass(Desk,[{key:'getKeyFrames',value:function getKeyFrames(){return[{transform:'translateY(-500px)',opacity:0,offset:0},{opacity:1,offset:1},{transform:'translateY(0)',opacity:1,offset:1}];}},{key:'getTiming',value:function getTiming(duration){return{duration:duration,easing:'ease-in',delay:0,iterations:1,fill:'forwards'};}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_web_animation__["Animated"].img,{keyframes:this.getKeyFrames(),timing:this.getTiming(750),style:{position:'absolute',top:462/this.state.ratio,left:470/this.state.ratio,opacity:this.state.opacity,transform:[{translateY:this.state.y}],width:this.state.width,height:this.state.height},src:__webpack_require__(17)});}}]);return Desk;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var Press=function(_React$Component9){_inherits(Press,_React$Component9);function Press(props){_classCallCheck(this,Press);var _this9=_possibleConstructorReturn(this,(Press.__proto__||Object.getPrototypeOf(Press)).call(this,props));_this9.state={originalWidth:160,originalHeight:156,x:0,y:-500,opacity:0,ratio:parseFloat(props.ratio)};_this9.state=Object.assign({},_this9.state,{width:_this9.state.originalWidth/_this9.state.ratio,height:_this9.state.originalHeight/_this9.state.ratio});return _this9;}_createClass(Press,[{key:'getKeyFrames',value:function getKeyFrames(){return[{transform:'translateY(-500px)',opacity:0,offset:0},{opacity:1,offset:1},{transform:'translateY(0)',opacity:1,offset:1}];}},{key:'getTiming',value:function getTiming(duration){return{duration:duration,easing:'ease-in',delay:0,iterations:1,fill:'forwards'};}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_web_animation__["Animated"].img,{keyframes:this.getKeyFrames(),timing:this.getTiming(750),style:{position:'absolute',top:197/this.state.ratio,left:419/this.state.ratio,opacity:this.state.opacity,transform:[{translateY:this.state.y}],width:this.state.width,height:this.state.height},src:__webpack_require__(18)});}}]);return Press;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var Pretreat=function(_React$Component10){_inherits(Pretreat,_React$Component10);function Pretreat(props){_classCallCheck(this,Pretreat);var _this10=_possibleConstructorReturn(this,(Pretreat.__proto__||Object.getPrototypeOf(Pretreat)).call(this,props));_this10.state={originalWidth:160,originalHeight:149,x:0,y:-500,opacity:0,ratio:parseFloat(props.ratio)};_this10.state=Object.assign({},_this10.state,{width:_this10.state.originalWidth/_this10.state.ratio,height:_this10.state.originalHeight/_this10.state.ratio});return _this10;}_createClass(Pretreat,[{key:'getKeyFrames',value:function getKeyFrames(){return[{transform:'translateY(-500px)',opacity:0,offset:0},{opacity:1,offset:1},{transform:'translateY(0)',opacity:1,offset:1}];}},{key:'getTiming',value:function getTiming(duration){return{duration:duration,easing:'ease-in',delay:0,iterations:1,fill:'forwards'};}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_web_animation__["Animated"].img,{keyframes:this.getKeyFrames(),timing:this.getTiming(750),style:{position:'absolute',top:168/this.state.ratio,left:470/this.state.ratio,opacity:this.state.opacity,transform:[{translateY:this.state.y}],width:this.state.width,height:this.state.height},src:__webpack_require__(28)});}}]);return Pretreat;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var Dryer=function(_React$Component11){_inherits(Dryer,_React$Component11);function Dryer(props){_classCallCheck(this,Dryer);var _this11=_possibleConstructorReturn(this,(Dryer.__proto__||Object.getPrototypeOf(Dryer)).call(this,props));_this11.state={originalWidth:420,originalHeight:316,x:0,y:-500,opacity:0,ratio:parseFloat(props.ratio)};_this11.state=Object.assign({},_this11.state,{width:_this11.state.originalWidth/_this11.state.ratio,height:_this11.state.originalHeight/_this11.state.ratio});return _this11;}_createClass(Dryer,[{key:'getKeyFrames',value:function getKeyFrames(){return[{transform:'translateY(-500px)',opacity:0,offset:0},{opacity:1,offset:1},{transform:'translateY(0)',opacity:1,offset:1}];}},{key:'getTiming',value:function getTiming(duration){return{duration:duration,easing:'ease-in',delay:0,iterations:1,fill:'forwards'};}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_web_animation__["Animated"].img,{keyframes:this.getKeyFrames(),timing:this.getTiming(750),style:{position:'absolute',top:300/this.state.ratio,left:103/this.state.ratio,opacity:this.state.opacity,transform:[{translateY:this.state.y}],width:this.state.width,height:this.state.height},src:__webpack_require__(42)});}}]);return Dryer;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_web_animation__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_web_animation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_web_animation__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RoomXXL=function(_React$Component){_inherits(RoomXXL,_React$Component);function RoomXXL(props){_classCallCheck(this,RoomXXL);var _this=_possibleConstructorReturn(this,(RoomXXL.__proto__||Object.getPrototypeOf(RoomXXL)).call(this,props));_this.state={originalWidth:1051,originalHeight:944};_this.state=Object.assign({},_this.state,{width:parseFloat(props.width),height:_this.state.originalHeight/(_this.state.originalWidth/parseFloat(props.width)),ratio:_this.state.originalWidth/parseFloat(props.width)});return _this;}_createClass(RoomXXL,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{height:this.state.height,width:this.state.width,viewBox:'0 0 '+this.state.originalWidth+' '+this.state.originalHeight},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('defs',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-1',points:'26.6699404 26.6699404 90.5330086 15.5330086 79.3960768 79.3960768 15.5330086 90.5330086'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-2',points:'236.66994 173.66994 300.533009 162.533009 289.396077 226.396077 225.533009 237.533009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-3',points:'131.66994 100.16994 195.533009 89.0330086 184.396077 152.896077 120.533009 164.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-4',points:'341.66994 247.16994 405.533009 236.033009 394.396077 299.896077 330.533009 311.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-5',points:'446.66994 320.827949 510.533009 309.691017 499.396077 373.554085 435.533009 384.691017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-6',points:'79.1699404 63.4199404 143.033009 52.2830086 131.896077 116.146077 68.0330086 127.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-7',points:'289.16994 210.41994 353.033009 199.283009 341.896077 263.146077 278.033009 274.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-8',points:'184.16994 136.91994 248.033009 125.783009 236.896077 189.646077 173.033009 200.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-9',points:'394.16994 283.91994 458.033009 272.783009 446.896077 336.646077 383.033009 347.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-10',points:'499.16994 357.577949 563.033009 346.441017 551.896077 410.304085 488.033009 421.441017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-11',points:'26.6699404 26.6699404 90.5330086 15.5330086 79.3960768 79.3960768 15.5330086 90.5330086'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-12',points:'236.66994 173.66994 300.533009 162.533009 289.396077 226.396077 225.533009 237.533009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-13',points:'131.66994 100.16994 195.533009 89.0330086 184.396077 152.896077 120.533009 164.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-14',points:'341.66994 247.16994 405.533009 236.033009 394.396077 299.896077 330.533009 311.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-15',points:'446.66994 320.827949 510.533009 309.691017 499.396077 373.554085 435.533009 384.691017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-16',points:'79.1699404 63.4199404 143.033009 52.2830086 131.896077 116.146077 68.0330086 127.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-17',points:'289.16994 210.41994 353.033009 199.283009 341.896077 263.146077 278.033009 274.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-18',points:'184.16994 136.91994 248.033009 125.783009 236.896077 189.646077 173.033009 200.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-19',points:'394.16994 283.91994 458.033009 272.783009 446.896077 336.646077 383.033009 347.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-20',points:'499.16994 357.577949 563.033009 346.441017 551.896077 410.304085 488.033009 421.441017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-21',points:'26.6699404 26.6699404 90.5330086 15.5330086 79.3960768 79.3960768 15.5330086 90.5330086'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-22',points:'236.66994 173.66994 300.533009 162.533009 289.396077 226.396077 225.533009 237.533009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-23',points:'131.66994 100.16994 195.533009 89.0330086 184.396077 152.896077 120.533009 164.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-24',points:'341.66994 247.16994 405.533009 236.033009 394.396077 299.896077 330.533009 311.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-25',points:'446.66994 320.827949 510.533009 309.691017 499.396077 373.554085 435.533009 384.691017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-26',points:'79.1699404 63.4199404 143.033009 52.2830086 131.896077 116.146077 68.0330086 127.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-27',points:'289.16994 210.41994 353.033009 199.283009 341.896077 263.146077 278.033009 274.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-28',points:'184.16994 136.91994 248.033009 125.783009 236.896077 189.646077 173.033009 200.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-29',points:'394.16994 283.91994 458.033009 272.783009 446.896077 336.646077 383.033009 347.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-30',points:'499.16994 357.577949 563.033009 346.441017 551.896077 410.304085 488.033009 421.441017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-31',points:'26.6699404 26.6699404 90.5330086 15.5330086 79.3960768 79.3960768 15.5330086 90.5330086'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-32',points:'236.66994 173.66994 300.533009 162.533009 289.396077 226.396077 225.533009 237.533009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-33',points:'131.66994 100.16994 195.533009 89.0330086 184.396077 152.896077 120.533009 164.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-34',points:'341.66994 247.16994 405.533009 236.033009 394.396077 299.896077 330.533009 311.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-35',points:'446.66994 320.827949 510.533009 309.691017 499.396077 373.554085 435.533009 384.691017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-36',points:'79.1699404 63.4199404 143.033009 52.2830086 131.896077 116.146077 68.0330086 127.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-37',points:'289.16994 210.41994 353.033009 199.283009 341.896077 263.146077 278.033009 274.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-38',points:'184.16994 136.91994 248.033009 125.783009 236.896077 189.646077 173.033009 200.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-39',points:'394.16994 283.91994 458.033009 272.783009 446.896077 336.646077 383.033009 347.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-40',points:'499.16994 357.577949 563.033009 346.441017 551.896077 410.304085 488.033009 421.441017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-41',points:'26.6699404 26.6699404 90.5330086 15.5330086 79.3960768 79.3960768 15.5330086 90.5330086'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-42',points:'236.66994 173.66994 300.533009 162.533009 289.396077 226.396077 225.533009 237.533009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-43',points:'131.66994 100.16994 195.533009 89.0330086 184.396077 152.896077 120.533009 164.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-44',points:'341.66994 247.16994 405.533009 236.033009 394.396077 299.896077 330.533009 311.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-45',points:'446.66994 320.827949 510.533009 309.691017 499.396077 373.554085 435.533009 384.691017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-46',points:'79.1699404 63.4199404 143.033009 52.2830086 131.896077 116.146077 68.0330086 127.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-47',points:'289.16994 210.41994 353.033009 199.283009 341.896077 263.146077 278.033009 274.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-48',points:'184.16994 136.91994 248.033009 125.783009 236.896077 189.646077 173.033009 200.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-49',points:'394.16994 283.91994 458.033009 272.783009 446.896077 336.646077 383.033009 347.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-50',points:'499.16994 357.577949 563.033009 346.441017 551.896077 410.304085 488.033009 421.441017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-51',points:'26.6699404 26.6699404 90.5330086 15.5330086 79.3960768 79.3960768 15.5330086 90.5330086'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-52',points:'236.66994 173.66994 300.533009 162.533009 289.396077 226.396077 225.533009 237.533009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-53',points:'131.66994 100.16994 195.533009 89.0330086 184.396077 152.896077 120.533009 164.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-54',points:'341.66994 247.16994 405.533009 236.033009 394.396077 299.896077 330.533009 311.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-55',points:'446.66994 320.827949 510.533009 309.691017 499.396077 373.554085 435.533009 384.691017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-56',points:'79.1699404 63.4199404 143.033009 52.2830086 131.896077 116.146077 68.0330086 127.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-57',points:'289.16994 210.41994 353.033009 199.283009 341.896077 263.146077 278.033009 274.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-58',points:'184.16994 136.91994 248.033009 125.783009 236.896077 189.646077 173.033009 200.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-59',points:'394.16994 283.91994 458.033009 272.783009 446.896077 336.646077 383.033009 347.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-60',points:'499.16994 357.577949 563.033009 346.441017 551.896077 410.304085 488.033009 421.441017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-61',points:'26.6699404 26.6699404 90.5330086 15.5330086 79.3960768 79.3960768 15.5330086 90.5330086'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-62',points:'236.66994 173.66994 300.533009 162.533009 289.396077 226.396077 225.533009 237.533009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-63',points:'131.66994 100.16994 195.533009 89.0330086 184.396077 152.896077 120.533009 164.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-64',points:'341.66994 247.16994 405.533009 236.033009 394.396077 299.896077 330.533009 311.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-65',points:'446.66994 320.827949 510.533009 309.691017 499.396077 373.554085 435.533009 384.691017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-66',points:'79.1699404 63.4199404 143.033009 52.2830086 131.896077 116.146077 68.0330086 127.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-67',points:'289.16994 210.41994 353.033009 199.283009 341.896077 263.146077 278.033009 274.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-68',points:'184.16994 136.91994 248.033009 125.783009 236.896077 189.646077 173.033009 200.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-69',points:'394.16994 283.91994 458.033009 272.783009 446.896077 336.646077 383.033009 347.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-70',points:'499.16994 357.577949 563.033009 346.441017 551.896077 410.304085 488.033009 421.441017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-71',points:'26.6699404 26.6699404 90.5330086 15.5330086 79.3960768 79.3960768 15.5330086 90.5330086'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-72',points:'236.66994 173.66994 300.533009 162.533009 289.396077 226.396077 225.533009 237.533009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-73',points:'131.66994 100.16994 195.533009 89.0330086 184.396077 152.896077 120.533009 164.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-74',points:'341.66994 247.16994 405.533009 236.033009 394.396077 299.896077 330.533009 311.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-75',points:'446.66994 320.827949 510.533009 309.691017 499.396077 373.554085 435.533009 384.691017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-76',points:'79.1699404 63.4199404 143.033009 52.2830086 131.896077 116.146077 68.0330086 127.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-77',points:'289.16994 210.41994 353.033009 199.283009 341.896077 263.146077 278.033009 274.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-78',points:'184.16994 136.91994 248.033009 125.783009 236.896077 189.646077 173.033009 200.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-79',points:'394.16994 283.91994 458.033009 272.783009 446.896077 336.646077 383.033009 347.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-80',points:'499.16994 357.577949 563.033009 346.441017 551.896077 410.304085 488.033009 421.441017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-81',points:'26.6699404 26.6699404 90.5330086 15.5330086 79.3960768 79.3960768 15.5330086 90.5330086'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-82',points:'236.66994 173.66994 300.533009 162.533009 289.396077 226.396077 225.533009 237.533009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-83',points:'131.66994 100.16994 195.533009 89.0330086 184.396077 152.896077 120.533009 164.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-84',points:'341.66994 247.16994 405.533009 236.033009 394.396077 299.896077 330.533009 311.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-85',points:'446.66994 320.827949 510.533009 309.691017 499.396077 373.554085 435.533009 384.691017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-86',points:'79.1699404 63.4199404 143.033009 52.2830086 131.896077 116.146077 68.0330086 127.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-87',points:'289.16994 210.41994 353.033009 199.283009 341.896077 263.146077 278.033009 274.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-88',points:'184.16994 136.91994 248.033009 125.783009 236.896077 189.646077 173.033009 200.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-89',points:'394.16994 283.91994 458.033009 272.783009 446.896077 336.646077 383.033009 347.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-90',points:'499.16994 357.577949 563.033009 346.441017 551.896077 410.304085 488.033009 421.441017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-91',points:'26.6699404 26.6699404 90.5330086 15.5330086 79.3960768 79.3960768 15.5330086 90.5330086'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-92',points:'236.66994 173.66994 300.533009 162.533009 289.396077 226.396077 225.533009 237.533009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-93',points:'131.66994 100.16994 195.533009 89.0330086 184.396077 152.896077 120.533009 164.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-94',points:'341.66994 247.16994 405.533009 236.033009 394.396077 299.896077 330.533009 311.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-95',points:'446.66994 320.827949 510.533009 309.691017 499.396077 373.554085 435.533009 384.691017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-96',points:'79.1699404 63.4199404 143.033009 52.2830086 131.896077 116.146077 68.0330086 127.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-97',points:'289.16994 210.41994 353.033009 199.283009 341.896077 263.146077 278.033009 274.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-98',points:'184.16994 136.91994 248.033009 125.783009 236.896077 189.646077 173.033009 200.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-99',points:'394.16994 283.91994 458.033009 272.783009 446.896077 336.646077 383.033009 347.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-100',points:'499.16994 357.577949 563.033009 346.441017 551.896077 410.304085 488.033009 421.441017'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Packages/XXL',fill:'none',fillRule:'evenodd',stroke:'none',strokeWidth:'1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'Rectangle-8',fill:'#DFDFDF',points:'1.12727029 203 642 203 524.87273 370 -116 370',transform:'translate(263.000000, 286.500000) rotate(-35.000000) translate(-263.000000, -286.500000) '}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'Rectangle-8',fill:'#929292',points:'525.8493 204 1167 204 1049.91343 371 409 370.661584',transform:'translate(788.000000, 287.500000) scale(-1, 1) rotate(-35.000000) translate(-788.000000, -287.500000) '}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Boden/10x10',transform:'translate(0.000000, 189.000000)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'10m',transform:'translate(0.000000, 330.750000)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(53.033009, 53.033009) rotate(45.000000) translate(-53.033009, -53.033009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'26.6699404 26.6699404 90.5330086 15.5330086 79.3960768 79.3960768 15.5330086 90.5330086'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M26.9940747,26.9940747 L15.9940717,90.0719455 L79.0719424,79.0719424 L90.0719455,15.9940717 L26.9940747,26.9940747 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(263.033009, 200.033009) rotate(45.000000) translate(-263.033009, -200.033009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'236.66994 173.66994 300.533009 162.533009 289.396077 226.396077 225.533009 237.533009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M236.994075,173.994075 L225.994072,237.071946 L289.071942,226.071942 L300.071946,162.994072 L236.994075,173.994075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(158.033009, 126.533009) rotate(45.000000) translate(-158.033009, -126.533009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'131.66994 100.16994 195.533009 89.0330086 184.396077 152.896077 120.533009 164.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M131.994075,100.494075 L120.994072,163.571946 L184.071942,152.571942 L195.071946,89.4940717 L131.994075,100.494075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(368.033009, 273.533009) rotate(45.000000) translate(-368.033009, -273.533009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'341.66994 247.16994 405.533009 236.033009 394.396077 299.896077 330.533009 311.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M341.994075,247.494075 L330.994072,310.571946 L394.071942,299.571942 L405.071946,236.494072 L341.994075,247.494075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(473.033009, 347.191017) rotate(45.000000) translate(-473.033009, -347.191017) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'446.66994 320.827949 510.533009 309.691017 499.396077 373.554085 435.533009 384.691017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M446.994075,321.152083 L435.994072,384.229954 L499.071942,373.229951 L510.071946,310.15208 L446.994075,321.152083 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(105.533009, 89.783009) rotate(45.000000) translate(-105.533009, -89.783009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'79.1699404 63.4199404 143.033009 52.2830086 131.896077 116.146077 68.0330086 127.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M79.4940747,63.7440747 L68.4940717,126.821946 L131.571942,115.821942 L142.571946,52.7440717 L79.4940747,63.7440747 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(315.533009, 236.783009) rotate(45.000000) translate(-315.533009, -236.783009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'289.16994 210.41994 353.033009 199.283009 341.896077 263.146077 278.033009 274.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M289.494075,210.744075 L278.494072,273.821946 L341.571942,262.821942 L352.571946,199.744072 L289.494075,210.744075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(210.533009, 163.283009) rotate(45.000000) translate(-210.533009, -163.283009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'184.16994 136.91994 248.033009 125.783009 236.896077 189.646077 173.033009 200.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M184.494075,137.244075 L173.494072,200.321946 L236.571942,189.321942 L247.571946,126.244072 L184.494075,137.244075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(420.533009, 310.283009) rotate(45.000000) translate(-420.533009, -310.283009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'394.16994 283.91994 458.033009 272.783009 446.896077 336.646077 383.033009 347.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M394.494075,284.244075 L383.494072,347.321946 L446.571942,336.321942 L457.571946,273.244072 L394.494075,284.244075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(525.533009, 383.941017) rotate(45.000000) translate(-525.533009, -383.941017) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'499.16994 357.577949 563.033009 346.441017 551.896077 410.304085 488.033009 421.441017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M499.494075,357.902083 L488.494072,420.979954 L551.571942,409.979951 L562.571946,346.90208 L499.494075,357.902083 Z',stroke:'#979797',strokeWidth:'0.75'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'10m',transform:'translate(52.500000, 294.000000)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(53.033009, 53.033009) rotate(45.000000) translate(-53.033009, -53.033009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'26.6699404 26.6699404 90.5330086 15.5330086 79.3960768 79.3960768 15.5330086 90.5330086'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M26.9940747,26.9940747 L15.9940717,90.0719455 L79.0719424,79.0719424 L90.0719455,15.9940717 L26.9940747,26.9940747 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(263.033009, 200.033009) rotate(45.000000) translate(-263.033009, -200.033009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'236.66994 173.66994 300.533009 162.533009 289.396077 226.396077 225.533009 237.533009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M236.994075,173.994075 L225.994072,237.071946 L289.071942,226.071942 L300.071946,162.994072 L236.994075,173.994075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(158.033009, 126.533009) rotate(45.000000) translate(-158.033009, -126.533009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'131.66994 100.16994 195.533009 89.0330086 184.396077 152.896077 120.533009 164.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M131.994075,100.494075 L120.994072,163.571946 L184.071942,152.571942 L195.071946,89.4940717 L131.994075,100.494075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(368.033009, 273.533009) rotate(45.000000) translate(-368.033009, -273.533009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'341.66994 247.16994 405.533009 236.033009 394.396077 299.896077 330.533009 311.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M341.994075,247.494075 L330.994072,310.571946 L394.071942,299.571942 L405.071946,236.494072 L341.994075,247.494075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(473.033009, 347.191017) rotate(45.000000) translate(-473.033009, -347.191017) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'446.66994 320.827949 510.533009 309.691017 499.396077 373.554085 435.533009 384.691017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M446.994075,321.152083 L435.994072,384.229954 L499.071942,373.229951 L510.071946,310.15208 L446.994075,321.152083 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(105.533009, 89.783009) rotate(45.000000) translate(-105.533009, -89.783009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'79.1699404 63.4199404 143.033009 52.2830086 131.896077 116.146077 68.0330086 127.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M79.4940747,63.7440747 L68.4940717,126.821946 L131.571942,115.821942 L142.571946,52.7440717 L79.4940747,63.7440747 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(315.533009, 236.783009) rotate(45.000000) translate(-315.533009, -236.783009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'289.16994 210.41994 353.033009 199.283009 341.896077 263.146077 278.033009 274.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M289.494075,210.744075 L278.494072,273.821946 L341.571942,262.821942 L352.571946,199.744072 L289.494075,210.744075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(210.533009, 163.283009) rotate(45.000000) translate(-210.533009, -163.283009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'184.16994 136.91994 248.033009 125.783009 236.896077 189.646077 173.033009 200.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M184.494075,137.244075 L173.494072,200.321946 L236.571942,189.321942 L247.571946,126.244072 L184.494075,137.244075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(420.533009, 310.283009) rotate(45.000000) translate(-420.533009, -310.283009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'394.16994 283.91994 458.033009 272.783009 446.896077 336.646077 383.033009 347.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M394.494075,284.244075 L383.494072,347.321946 L446.571942,336.321942 L457.571946,273.244072 L394.494075,284.244075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(525.533009, 383.941017) rotate(45.000000) translate(-525.533009, -383.941017) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'499.16994 357.577949 563.033009 346.441017 551.896077 410.304085 488.033009 421.441017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M499.494075,357.902083 L488.494072,420.979954 L551.571942,409.979951 L562.571946,346.90208 L499.494075,357.902083 Z',stroke:'#979797',strokeWidth:'0.75'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'10m',transform:'translate(105.000000, 257.250000)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(53.033009, 53.033009) rotate(45.000000) translate(-53.033009, -53.033009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'26.6699404 26.6699404 90.5330086 15.5330086 79.3960768 79.3960768 15.5330086 90.5330086'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M26.9940747,26.9940747 L15.9940717,90.0719455 L79.0719424,79.0719424 L90.0719455,15.9940717 L26.9940747,26.9940747 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(263.033009, 200.033009) rotate(45.000000) translate(-263.033009, -200.033009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'236.66994 173.66994 300.533009 162.533009 289.396077 226.396077 225.533009 237.533009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M236.994075,173.994075 L225.994072,237.071946 L289.071942,226.071942 L300.071946,162.994072 L236.994075,173.994075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(158.033009, 126.533009) rotate(45.000000) translate(-158.033009, -126.533009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'131.66994 100.16994 195.533009 89.0330086 184.396077 152.896077 120.533009 164.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M131.994075,100.494075 L120.994072,163.571946 L184.071942,152.571942 L195.071946,89.4940717 L131.994075,100.494075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(368.033009, 273.533009) rotate(45.000000) translate(-368.033009, -273.533009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'341.66994 247.16994 405.533009 236.033009 394.396077 299.896077 330.533009 311.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M341.994075,247.494075 L330.994072,310.571946 L394.071942,299.571942 L405.071946,236.494072 L341.994075,247.494075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(473.033009, 347.191017) rotate(45.000000) translate(-473.033009, -347.191017) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'446.66994 320.827949 510.533009 309.691017 499.396077 373.554085 435.533009 384.691017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M446.994075,321.152083 L435.994072,384.229954 L499.071942,373.229951 L510.071946,310.15208 L446.994075,321.152083 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(105.533009, 89.783009) rotate(45.000000) translate(-105.533009, -89.783009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'79.1699404 63.4199404 143.033009 52.2830086 131.896077 116.146077 68.0330086 127.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M79.4940747,63.7440747 L68.4940717,126.821946 L131.571942,115.821942 L142.571946,52.7440717 L79.4940747,63.7440747 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(315.533009, 236.783009) rotate(45.000000) translate(-315.533009, -236.783009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'289.16994 210.41994 353.033009 199.283009 341.896077 263.146077 278.033009 274.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M289.494075,210.744075 L278.494072,273.821946 L341.571942,262.821942 L352.571946,199.744072 L289.494075,210.744075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(210.533009, 163.283009) rotate(45.000000) translate(-210.533009, -163.283009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'184.16994 136.91994 248.033009 125.783009 236.896077 189.646077 173.033009 200.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M184.494075,137.244075 L173.494072,200.321946 L236.571942,189.321942 L247.571946,126.244072 L184.494075,137.244075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(420.533009, 310.283009) rotate(45.000000) translate(-420.533009, -310.283009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'394.16994 283.91994 458.033009 272.783009 446.896077 336.646077 383.033009 347.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M394.494075,284.244075 L383.494072,347.321946 L446.571942,336.321942 L457.571946,273.244072 L394.494075,284.244075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(525.533009, 383.941017) rotate(45.000000) translate(-525.533009, -383.941017) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'499.16994 357.577949 563.033009 346.441017 551.896077 410.304085 488.033009 421.441017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M499.494075,357.902083 L488.494072,420.979954 L551.571942,409.979951 L562.571946,346.90208 L499.494075,357.902083 Z',stroke:'#979797',strokeWidth:'0.75'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'10m',transform:'translate(157.500000, 220.500000)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(53.033009, 53.033009) rotate(45.000000) translate(-53.033009, -53.033009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'26.6699404 26.6699404 90.5330086 15.5330086 79.3960768 79.3960768 15.5330086 90.5330086'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M26.9940747,26.9940747 L15.9940717,90.0719455 L79.0719424,79.0719424 L90.0719455,15.9940717 L26.9940747,26.9940747 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(263.033009, 200.033009) rotate(45.000000) translate(-263.033009, -200.033009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'236.66994 173.66994 300.533009 162.533009 289.396077 226.396077 225.533009 237.533009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M236.994075,173.994075 L225.994072,237.071946 L289.071942,226.071942 L300.071946,162.994072 L236.994075,173.994075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(158.033009, 126.533009) rotate(45.000000) translate(-158.033009, -126.533009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'131.66994 100.16994 195.533009 89.0330086 184.396077 152.896077 120.533009 164.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M131.994075,100.494075 L120.994072,163.571946 L184.071942,152.571942 L195.071946,89.4940717 L131.994075,100.494075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(368.033009, 273.533009) rotate(45.000000) translate(-368.033009, -273.533009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'341.66994 247.16994 405.533009 236.033009 394.396077 299.896077 330.533009 311.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M341.994075,247.494075 L330.994072,310.571946 L394.071942,299.571942 L405.071946,236.494072 L341.994075,247.494075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(473.033009, 347.191017) rotate(45.000000) translate(-473.033009, -347.191017) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'446.66994 320.827949 510.533009 309.691017 499.396077 373.554085 435.533009 384.691017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M446.994075,321.152083 L435.994072,384.229954 L499.071942,373.229951 L510.071946,310.15208 L446.994075,321.152083 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(105.533009, 89.783009) rotate(45.000000) translate(-105.533009, -89.783009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'79.1699404 63.4199404 143.033009 52.2830086 131.896077 116.146077 68.0330086 127.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M79.4940747,63.7440747 L68.4940717,126.821946 L131.571942,115.821942 L142.571946,52.7440717 L79.4940747,63.7440747 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(315.533009, 236.783009) rotate(45.000000) translate(-315.533009, -236.783009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'289.16994 210.41994 353.033009 199.283009 341.896077 263.146077 278.033009 274.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M289.494075,210.744075 L278.494072,273.821946 L341.571942,262.821942 L352.571946,199.744072 L289.494075,210.744075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(210.533009, 163.283009) rotate(45.000000) translate(-210.533009, -163.283009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'184.16994 136.91994 248.033009 125.783009 236.896077 189.646077 173.033009 200.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M184.494075,137.244075 L173.494072,200.321946 L236.571942,189.321942 L247.571946,126.244072 L184.494075,137.244075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(420.533009, 310.283009) rotate(45.000000) translate(-420.533009, -310.283009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'394.16994 283.91994 458.033009 272.783009 446.896077 336.646077 383.033009 347.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M394.494075,284.244075 L383.494072,347.321946 L446.571942,336.321942 L457.571946,273.244072 L394.494075,284.244075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(525.533009, 383.941017) rotate(45.000000) translate(-525.533009, -383.941017) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'499.16994 357.577949 563.033009 346.441017 551.896077 410.304085 488.033009 421.441017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M499.494075,357.902083 L488.494072,420.979954 L551.571942,409.979951 L562.571946,346.90208 L499.494075,357.902083 Z',stroke:'#979797',strokeWidth:'0.75'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'10m',transform:'translate(209.250000, 183.750000)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(53.033009, 53.033009) rotate(45.000000) translate(-53.033009, -53.033009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'26.6699404 26.6699404 90.5330086 15.5330086 79.3960768 79.3960768 15.5330086 90.5330086'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M26.9940747,26.9940747 L15.9940717,90.0719455 L79.0719424,79.0719424 L90.0719455,15.9940717 L26.9940747,26.9940747 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(263.033009, 200.033009) rotate(45.000000) translate(-263.033009, -200.033009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'236.66994 173.66994 300.533009 162.533009 289.396077 226.396077 225.533009 237.533009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M236.994075,173.994075 L225.994072,237.071946 L289.071942,226.071942 L300.071946,162.994072 L236.994075,173.994075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(158.033009, 126.533009) rotate(45.000000) translate(-158.033009, -126.533009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'131.66994 100.16994 195.533009 89.0330086 184.396077 152.896077 120.533009 164.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M131.994075,100.494075 L120.994072,163.571946 L184.071942,152.571942 L195.071946,89.4940717 L131.994075,100.494075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(368.033009, 273.533009) rotate(45.000000) translate(-368.033009, -273.533009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'341.66994 247.16994 405.533009 236.033009 394.396077 299.896077 330.533009 311.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M341.994075,247.494075 L330.994072,310.571946 L394.071942,299.571942 L405.071946,236.494072 L341.994075,247.494075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(473.033009, 347.191017) rotate(45.000000) translate(-473.033009, -347.191017) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'446.66994 320.827949 510.533009 309.691017 499.396077 373.554085 435.533009 384.691017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M446.994075,321.152083 L435.994072,384.229954 L499.071942,373.229951 L510.071946,310.15208 L446.994075,321.152083 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(105.533009, 89.783009) rotate(45.000000) translate(-105.533009, -89.783009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'79.1699404 63.4199404 143.033009 52.2830086 131.896077 116.146077 68.0330086 127.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M79.4940747,63.7440747 L68.4940717,126.821946 L131.571942,115.821942 L142.571946,52.7440717 L79.4940747,63.7440747 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(315.533009, 236.783009) rotate(45.000000) translate(-315.533009, -236.783009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'289.16994 210.41994 353.033009 199.283009 341.896077 263.146077 278.033009 274.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M289.494075,210.744075 L278.494072,273.821946 L341.571942,262.821942 L352.571946,199.744072 L289.494075,210.744075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(210.533009, 163.283009) rotate(45.000000) translate(-210.533009, -163.283009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'184.16994 136.91994 248.033009 125.783009 236.896077 189.646077 173.033009 200.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M184.494075,137.244075 L173.494072,200.321946 L236.571942,189.321942 L247.571946,126.244072 L184.494075,137.244075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(420.533009, 310.283009) rotate(45.000000) translate(-420.533009, -310.283009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'394.16994 283.91994 458.033009 272.783009 446.896077 336.646077 383.033009 347.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M394.494075,284.244075 L383.494072,347.321946 L446.571942,336.321942 L457.571946,273.244072 L394.494075,284.244075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(525.533009, 383.941017) rotate(45.000000) translate(-525.533009, -383.941017) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'499.16994 357.577949 563.033009 346.441017 551.896077 410.304085 488.033009 421.441017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M499.494075,357.902083 L488.494072,420.979954 L551.571942,409.979951 L562.571946,346.90208 L499.494075,357.902083 Z',stroke:'#979797',strokeWidth:'0.75'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'10m',transform:'translate(261.750000, 147.000000)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(53.033009, 53.033009) rotate(45.000000) translate(-53.033009, -53.033009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'26.6699404 26.6699404 90.5330086 15.5330086 79.3960768 79.3960768 15.5330086 90.5330086'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M26.9940747,26.9940747 L15.9940717,90.0719455 L79.0719424,79.0719424 L90.0719455,15.9940717 L26.9940747,26.9940747 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(263.033009, 200.033009) rotate(45.000000) translate(-263.033009, -200.033009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'236.66994 173.66994 300.533009 162.533009 289.396077 226.396077 225.533009 237.533009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M236.994075,173.994075 L225.994072,237.071946 L289.071942,226.071942 L300.071946,162.994072 L236.994075,173.994075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(158.033009, 126.533009) rotate(45.000000) translate(-158.033009, -126.533009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'131.66994 100.16994 195.533009 89.0330086 184.396077 152.896077 120.533009 164.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M131.994075,100.494075 L120.994072,163.571946 L184.071942,152.571942 L195.071946,89.4940717 L131.994075,100.494075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(368.033009, 273.533009) rotate(45.000000) translate(-368.033009, -273.533009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'341.66994 247.16994 405.533009 236.033009 394.396077 299.896077 330.533009 311.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M341.994075,247.494075 L330.994072,310.571946 L394.071942,299.571942 L405.071946,236.494072 L341.994075,247.494075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(473.033009, 347.191017) rotate(45.000000) translate(-473.033009, -347.191017) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'446.66994 320.827949 510.533009 309.691017 499.396077 373.554085 435.533009 384.691017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M446.994075,321.152083 L435.994072,384.229954 L499.071942,373.229951 L510.071946,310.15208 L446.994075,321.152083 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(105.533009, 89.783009) rotate(45.000000) translate(-105.533009, -89.783009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'79.1699404 63.4199404 143.033009 52.2830086 131.896077 116.146077 68.0330086 127.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M79.4940747,63.7440747 L68.4940717,126.821946 L131.571942,115.821942 L142.571946,52.7440717 L79.4940747,63.7440747 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(315.533009, 236.783009) rotate(45.000000) translate(-315.533009, -236.783009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'289.16994 210.41994 353.033009 199.283009 341.896077 263.146077 278.033009 274.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M289.494075,210.744075 L278.494072,273.821946 L341.571942,262.821942 L352.571946,199.744072 L289.494075,210.744075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(210.533009, 163.283009) rotate(45.000000) translate(-210.533009, -163.283009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'184.16994 136.91994 248.033009 125.783009 236.896077 189.646077 173.033009 200.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M184.494075,137.244075 L173.494072,200.321946 L236.571942,189.321942 L247.571946,126.244072 L184.494075,137.244075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(420.533009, 310.283009) rotate(45.000000) translate(-420.533009, -310.283009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'394.16994 283.91994 458.033009 272.783009 446.896077 336.646077 383.033009 347.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M394.494075,284.244075 L383.494072,347.321946 L446.571942,336.321942 L457.571946,273.244072 L394.494075,284.244075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(525.533009, 383.941017) rotate(45.000000) translate(-525.533009, -383.941017) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'499.16994 357.577949 563.033009 346.441017 551.896077 410.304085 488.033009 421.441017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M499.494075,357.902083 L488.494072,420.979954 L551.571942,409.979951 L562.571946,346.90208 L499.494075,357.902083 Z',stroke:'#979797',strokeWidth:'0.75'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'10m',transform:'translate(314.250000, 110.250000)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(53.033009, 53.033009) rotate(45.000000) translate(-53.033009, -53.033009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'26.6699404 26.6699404 90.5330086 15.5330086 79.3960768 79.3960768 15.5330086 90.5330086'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M26.9940747,26.9940747 L15.9940717,90.0719455 L79.0719424,79.0719424 L90.0719455,15.9940717 L26.9940747,26.9940747 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(263.033009, 200.033009) rotate(45.000000) translate(-263.033009, -200.033009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'236.66994 173.66994 300.533009 162.533009 289.396077 226.396077 225.533009 237.533009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M236.994075,173.994075 L225.994072,237.071946 L289.071942,226.071942 L300.071946,162.994072 L236.994075,173.994075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(158.033009, 126.533009) rotate(45.000000) translate(-158.033009, -126.533009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'131.66994 100.16994 195.533009 89.0330086 184.396077 152.896077 120.533009 164.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M131.994075,100.494075 L120.994072,163.571946 L184.071942,152.571942 L195.071946,89.4940717 L131.994075,100.494075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(368.033009, 273.533009) rotate(45.000000) translate(-368.033009, -273.533009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'341.66994 247.16994 405.533009 236.033009 394.396077 299.896077 330.533009 311.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M341.994075,247.494075 L330.994072,310.571946 L394.071942,299.571942 L405.071946,236.494072 L341.994075,247.494075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(473.033009, 347.191017) rotate(45.000000) translate(-473.033009, -347.191017) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'446.66994 320.827949 510.533009 309.691017 499.396077 373.554085 435.533009 384.691017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M446.994075,321.152083 L435.994072,384.229954 L499.071942,373.229951 L510.071946,310.15208 L446.994075,321.152083 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(105.533009, 89.783009) rotate(45.000000) translate(-105.533009, -89.783009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'79.1699404 63.4199404 143.033009 52.2830086 131.896077 116.146077 68.0330086 127.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M79.4940747,63.7440747 L68.4940717,126.821946 L131.571942,115.821942 L142.571946,52.7440717 L79.4940747,63.7440747 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(315.533009, 236.783009) rotate(45.000000) translate(-315.533009, -236.783009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'289.16994 210.41994 353.033009 199.283009 341.896077 263.146077 278.033009 274.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M289.494075,210.744075 L278.494072,273.821946 L341.571942,262.821942 L352.571946,199.744072 L289.494075,210.744075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(210.533009, 163.283009) rotate(45.000000) translate(-210.533009, -163.283009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'184.16994 136.91994 248.033009 125.783009 236.896077 189.646077 173.033009 200.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M184.494075,137.244075 L173.494072,200.321946 L236.571942,189.321942 L247.571946,126.244072 L184.494075,137.244075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(420.533009, 310.283009) rotate(45.000000) translate(-420.533009, -310.283009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'394.16994 283.91994 458.033009 272.783009 446.896077 336.646077 383.033009 347.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M394.494075,284.244075 L383.494072,347.321946 L446.571942,336.321942 L457.571946,273.244072 L394.494075,284.244075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(525.533009, 383.941017) rotate(45.000000) translate(-525.533009, -383.941017) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'499.16994 357.577949 563.033009 346.441017 551.896077 410.304085 488.033009 421.441017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M499.494075,357.902083 L488.494072,420.979954 L551.571942,409.979951 L562.571946,346.90208 L499.494075,357.902083 Z',stroke:'#979797',strokeWidth:'0.75'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'10m',transform:'translate(366.750000, 73.500000)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(53.033009, 53.033009) rotate(45.000000) translate(-53.033009, -53.033009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'26.6699404 26.6699404 90.5330086 15.5330086 79.3960768 79.3960768 15.5330086 90.5330086'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M26.9940747,26.9940747 L15.9940717,90.0719455 L79.0719424,79.0719424 L90.0719455,15.9940717 L26.9940747,26.9940747 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(263.033009, 200.033009) rotate(45.000000) translate(-263.033009, -200.033009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'236.66994 173.66994 300.533009 162.533009 289.396077 226.396077 225.533009 237.533009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M236.994075,173.994075 L225.994072,237.071946 L289.071942,226.071942 L300.071946,162.994072 L236.994075,173.994075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(158.033009, 126.533009) rotate(45.000000) translate(-158.033009, -126.533009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'131.66994 100.16994 195.533009 89.0330086 184.396077 152.896077 120.533009 164.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M131.994075,100.494075 L120.994072,163.571946 L184.071942,152.571942 L195.071946,89.4940717 L131.994075,100.494075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(368.033009, 273.533009) rotate(45.000000) translate(-368.033009, -273.533009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'341.66994 247.16994 405.533009 236.033009 394.396077 299.896077 330.533009 311.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M341.994075,247.494075 L330.994072,310.571946 L394.071942,299.571942 L405.071946,236.494072 L341.994075,247.494075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(473.033009, 347.191017) rotate(45.000000) translate(-473.033009, -347.191017) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'446.66994 320.827949 510.533009 309.691017 499.396077 373.554085 435.533009 384.691017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M446.994075,321.152083 L435.994072,384.229954 L499.071942,373.229951 L510.071946,310.15208 L446.994075,321.152083 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(105.533009, 89.783009) rotate(45.000000) translate(-105.533009, -89.783009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'79.1699404 63.4199404 143.033009 52.2830086 131.896077 116.146077 68.0330086 127.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M79.4940747,63.7440747 L68.4940717,126.821946 L131.571942,115.821942 L142.571946,52.7440717 L79.4940747,63.7440747 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(315.533009, 236.783009) rotate(45.000000) translate(-315.533009, -236.783009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'289.16994 210.41994 353.033009 199.283009 341.896077 263.146077 278.033009 274.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M289.494075,210.744075 L278.494072,273.821946 L341.571942,262.821942 L352.571946,199.744072 L289.494075,210.744075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(210.533009, 163.283009) rotate(45.000000) translate(-210.533009, -163.283009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'184.16994 136.91994 248.033009 125.783009 236.896077 189.646077 173.033009 200.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M184.494075,137.244075 L173.494072,200.321946 L236.571942,189.321942 L247.571946,126.244072 L184.494075,137.244075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(420.533009, 310.283009) rotate(45.000000) translate(-420.533009, -310.283009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'394.16994 283.91994 458.033009 272.783009 446.896077 336.646077 383.033009 347.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M394.494075,284.244075 L383.494072,347.321946 L446.571942,336.321942 L457.571946,273.244072 L394.494075,284.244075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(525.533009, 383.941017) rotate(45.000000) translate(-525.533009, -383.941017) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'499.16994 357.577949 563.033009 346.441017 551.896077 410.304085 488.033009 421.441017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M499.494075,357.902083 L488.494072,420.979954 L551.571942,409.979951 L562.571946,346.90208 L499.494075,357.902083 Z',stroke:'#979797',strokeWidth:'0.75'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'10m',transform:'translate(418.500000, 36.750000)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(53.033009, 53.033009) rotate(45.000000) translate(-53.033009, -53.033009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'26.6699404 26.6699404 90.5330086 15.5330086 79.3960768 79.3960768 15.5330086 90.5330086'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M26.9940747,26.9940747 L15.9940717,90.0719455 L79.0719424,79.0719424 L90.0719455,15.9940717 L26.9940747,26.9940747 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(263.033009, 200.033009) rotate(45.000000) translate(-263.033009, -200.033009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'236.66994 173.66994 300.533009 162.533009 289.396077 226.396077 225.533009 237.533009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M236.994075,173.994075 L225.994072,237.071946 L289.071942,226.071942 L300.071946,162.994072 L236.994075,173.994075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(158.033009, 126.533009) rotate(45.000000) translate(-158.033009, -126.533009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'131.66994 100.16994 195.533009 89.0330086 184.396077 152.896077 120.533009 164.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M131.994075,100.494075 L120.994072,163.571946 L184.071942,152.571942 L195.071946,89.4940717 L131.994075,100.494075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(368.033009, 273.533009) rotate(45.000000) translate(-368.033009, -273.533009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'341.66994 247.16994 405.533009 236.033009 394.396077 299.896077 330.533009 311.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M341.994075,247.494075 L330.994072,310.571946 L394.071942,299.571942 L405.071946,236.494072 L341.994075,247.494075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(473.033009, 347.191017) rotate(45.000000) translate(-473.033009, -347.191017) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'446.66994 320.827949 510.533009 309.691017 499.396077 373.554085 435.533009 384.691017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M446.994075,321.152083 L435.994072,384.229954 L499.071942,373.229951 L510.071946,310.15208 L446.994075,321.152083 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(105.533009, 89.783009) rotate(45.000000) translate(-105.533009, -89.783009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'79.1699404 63.4199404 143.033009 52.2830086 131.896077 116.146077 68.0330086 127.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M79.4940747,63.7440747 L68.4940717,126.821946 L131.571942,115.821942 L142.571946,52.7440717 L79.4940747,63.7440747 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(315.533009, 236.783009) rotate(45.000000) translate(-315.533009, -236.783009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'289.16994 210.41994 353.033009 199.283009 341.896077 263.146077 278.033009 274.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M289.494075,210.744075 L278.494072,273.821946 L341.571942,262.821942 L352.571946,199.744072 L289.494075,210.744075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(210.533009, 163.283009) rotate(45.000000) translate(-210.533009, -163.283009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'184.16994 136.91994 248.033009 125.783009 236.896077 189.646077 173.033009 200.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M184.494075,137.244075 L173.494072,200.321946 L236.571942,189.321942 L247.571946,126.244072 L184.494075,137.244075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(420.533009, 310.283009) rotate(45.000000) translate(-420.533009, -310.283009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'394.16994 283.91994 458.033009 272.783009 446.896077 336.646077 383.033009 347.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M394.494075,284.244075 L383.494072,347.321946 L446.571942,336.321942 L457.571946,273.244072 L394.494075,284.244075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(525.533009, 383.941017) rotate(45.000000) translate(-525.533009, -383.941017) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'499.16994 357.577949 563.033009 346.441017 551.896077 410.304085 488.033009 421.441017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M499.494075,357.902083 L488.494072,420.979954 L551.571942,409.979951 L562.571946,346.90208 L499.494075,357.902083 Z',stroke:'#979797',strokeWidth:'0.75'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'10m',transform:'translate(471.000000, 0.000000)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(53.033009, 53.033009) rotate(45.000000) translate(-53.033009, -53.033009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'26.6699404 26.6699404 90.5330086 15.5330086 79.3960768 79.3960768 15.5330086 90.5330086'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M26.9940747,26.9940747 L15.9940717,90.0719455 L79.0719424,79.0719424 L90.0719455,15.9940717 L26.9940747,26.9940747 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(263.033009, 200.033009) rotate(45.000000) translate(-263.033009, -200.033009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'236.66994 173.66994 300.533009 162.533009 289.396077 226.396077 225.533009 237.533009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M236.994075,173.994075 L225.994072,237.071946 L289.071942,226.071942 L300.071946,162.994072 L236.994075,173.994075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(158.033009, 126.533009) rotate(45.000000) translate(-158.033009, -126.533009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'131.66994 100.16994 195.533009 89.0330086 184.396077 152.896077 120.533009 164.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M131.994075,100.494075 L120.994072,163.571946 L184.071942,152.571942 L195.071946,89.4940717 L131.994075,100.494075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(368.033009, 273.533009) rotate(45.000000) translate(-368.033009, -273.533009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'341.66994 247.16994 405.533009 236.033009 394.396077 299.896077 330.533009 311.033009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M341.994075,247.494075 L330.994072,310.571946 L394.071942,299.571942 L405.071946,236.494072 L341.994075,247.494075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(473.033009, 347.191017) rotate(45.000000) translate(-473.033009, -347.191017) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'446.66994 320.827949 510.533009 309.691017 499.396077 373.554085 435.533009 384.691017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M446.994075,321.152083 L435.994072,384.229954 L499.071942,373.229951 L510.071946,310.15208 L446.994075,321.152083 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(105.533009, 89.783009) rotate(45.000000) translate(-105.533009, -89.783009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'79.1699404 63.4199404 143.033009 52.2830086 131.896077 116.146077 68.0330086 127.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M79.4940747,63.7440747 L68.4940717,126.821946 L131.571942,115.821942 L142.571946,52.7440717 L79.4940747,63.7440747 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(315.533009, 236.783009) rotate(45.000000) translate(-315.533009, -236.783009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'289.16994 210.41994 353.033009 199.283009 341.896077 263.146077 278.033009 274.283009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M289.494075,210.744075 L278.494072,273.821946 L341.571942,262.821942 L352.571946,199.744072 L289.494075,210.744075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(210.533009, 163.283009) rotate(45.000000) translate(-210.533009, -163.283009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'184.16994 136.91994 248.033009 125.783009 236.896077 189.646077 173.033009 200.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M184.494075,137.244075 L173.494072,200.321946 L236.571942,189.321942 L247.571946,126.244072 L184.494075,137.244075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(420.533009, 310.283009) rotate(45.000000) translate(-420.533009, -310.283009) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'394.16994 283.91994 458.033009 272.783009 446.896077 336.646077 383.033009 347.783009'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M394.494075,284.244075 L383.494072,347.321946 L446.571942,336.321942 L457.571946,273.244072 L394.494075,284.244075 Z',stroke:'#979797',strokeWidth:'0.75'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Rectangle-5',fill:'#D8D8D8',transform:'translate(525.533009, 383.941017) rotate(45.000000) translate(-525.533009, -383.941017) '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#D8D8D8',fillRule:'evenodd',points:'499.16994 357.577949 563.033009 346.441017 551.896077 410.304085 488.033009 421.441017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M499.494075,357.902083 L488.494072,420.979954 L551.571942,409.979951 L562.571946,346.90208 L499.494075,357.902083 Z',stroke:'#979797',strokeWidth:'0.75'})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Desk,{ratio:this.state.ratio}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Gtx1,{ratio:this.state.ratio}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Gtx2,{ratio:this.state.ratio}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Gtx3,{ratio:this.state.ratio}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Gtx4,{ratio:this.state.ratio}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Gtx5,{ratio:this.state.ratio}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Gtx6,{ratio:this.state.ratio}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Senddesk,{ratio:this.state.ratio}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Dryer,{ratio:this.state.ratio}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PretreatLine,{ratio:this.state.ratio}));}}]);return RoomXXL;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (RoomXXL);var Gtx1=function(_React$Component2){_inherits(Gtx1,_React$Component2);function Gtx1(props){_classCallCheck(this,Gtx1);var _this2=_possibleConstructorReturn(this,(Gtx1.__proto__||Object.getPrototypeOf(Gtx1)).call(this,props));_this2.state={originalWidth:264,originalHeight:188,x:0,y:-500,opacity:0,ratio:parseFloat(props.ratio)};_this2.state=Object.assign({},_this2.state,{width:_this2.state.originalWidth/_this2.state.ratio,height:_this2.state.originalHeight/_this2.state.ratio});return _this2;}_createClass(Gtx1,[{key:'getKeyFrames',value:function getKeyFrames(){return[{transform:'translateY(-500px)',opacity:0,offset:0},{opacity:1,offset:1},{transform:'translateY(0)',opacity:1,offset:1}];}},{key:'getTiming',value:function getTiming(duration){return{duration:duration,easing:'ease-in',delay:0,iterations:1,fill:'forwards'};}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_web_animation__["Animated"].img,{keyframes:this.getKeyFrames(),timing:this.getTiming(750),style:{position:'absolute',top:533/this.state.ratio,left:523/this.state.ratio,opacity:this.state.opacity,transform:[{translateY:this.state.y}],width:this.state.width,height:this.state.height},src:__webpack_require__(3)});}}]);return Gtx1;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var Gtx2=function(_React$Component3){_inherits(Gtx2,_React$Component3);function Gtx2(props){_classCallCheck(this,Gtx2);var _this3=_possibleConstructorReturn(this,(Gtx2.__proto__||Object.getPrototypeOf(Gtx2)).call(this,props));_this3.state={originalWidth:264,originalHeight:188,x:0,y:-500,opacity:0,ratio:parseFloat(props.ratio)};_this3.state=Object.assign({},_this3.state,{width:_this3.state.originalWidth/_this3.state.ratio,height:_this3.state.originalHeight/_this3.state.ratio});return _this3;}_createClass(Gtx2,[{key:'getKeyFrames',value:function getKeyFrames(){return[{transform:'translateY(-500px)',opacity:0,offset:0},{opacity:1,offset:1},{transform:'translateY(0)',opacity:1,offset:1}];}},{key:'getTiming',value:function getTiming(duration){return{duration:duration,easing:'ease-in',delay:0,iterations:1,fill:'forwards'};}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_web_animation__["Animated"].img,{keyframes:this.getKeyFrames(),timing:this.getTiming(750),style:{position:'absolute',top:352/this.state.ratio,left:577/this.state.ratio,opacity:this.state.opacity,transform:[{translateY:this.state.y}],width:this.state.width,height:this.state.height},src:__webpack_require__(3)});}}]);return Gtx2;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var Gtx3=function(_React$Component4){_inherits(Gtx3,_React$Component4);function Gtx3(props){_classCallCheck(this,Gtx3);var _this4=_possibleConstructorReturn(this,(Gtx3.__proto__||Object.getPrototypeOf(Gtx3)).call(this,props));_this4.state={originalWidth:264,originalHeight:188,x:0,y:-500,opacity:0,ratio:parseFloat(props.ratio)};_this4.state=Object.assign({},_this4.state,{width:_this4.state.originalWidth/_this4.state.ratio,height:_this4.state.originalHeight/_this4.state.ratio});return _this4;}_createClass(Gtx3,[{key:'getKeyFrames',value:function getKeyFrames(){return[{transform:'translateY(-500px)',opacity:0,offset:0},{opacity:1,offset:1},{transform:'translateY(0)',opacity:1,offset:1}];}},{key:'getTiming',value:function getTiming(duration){return{duration:duration,easing:'ease-in',delay:0,iterations:1,fill:'forwards'};}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_web_animation__["Animated"].img,{keyframes:this.getKeyFrames(),timing:this.getTiming(750),style:{position:'absolute',top:425/this.state.ratio,left:683/this.state.ratio,opacity:this.state.opacity,transform:[{translateY:this.state.y}],width:this.state.width,height:this.state.height},src:__webpack_require__(3)});}}]);return Gtx3;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var Gtx4=function(_React$Component5){_inherits(Gtx4,_React$Component5);function Gtx4(props){_classCallCheck(this,Gtx4);var _this5=_possibleConstructorReturn(this,(Gtx4.__proto__||Object.getPrototypeOf(Gtx4)).call(this,props));_this5.state={originalWidth:264,originalHeight:188,x:0,y:-500,opacity:0,ratio:parseFloat(props.ratio)};_this5.state=Object.assign({},_this5.state,{width:_this5.state.originalWidth/_this5.state.ratio,height:_this5.state.originalHeight/_this5.state.ratio});return _this5;}_createClass(Gtx4,[{key:'getKeyFrames',value:function getKeyFrames(){return[{transform:'translateY(-500px)',opacity:0,offset:0},{opacity:1,offset:1},{transform:'translateY(0)',opacity:1,offset:1}];}},{key:'getTiming',value:function getTiming(duration){return{duration:duration,easing:'ease-in',delay:0,iterations:1,fill:'forwards'};}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_web_animation__["Animated"].img,{keyframes:this.getKeyFrames(),timing:this.getTiming(750),style:{position:'absolute',top:497/this.state.ratio,left:789/this.state.ratio,opacity:this.state.opacity,transform:[{translateY:this.state.y}],width:this.state.width,height:this.state.height},src:__webpack_require__(3)});}}]);return Gtx4;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var Gtx5=function(_React$Component6){_inherits(Gtx5,_React$Component6);function Gtx5(props){_classCallCheck(this,Gtx5);var _this6=_possibleConstructorReturn(this,(Gtx5.__proto__||Object.getPrototypeOf(Gtx5)).call(this,props));_this6.state={originalWidth:264,originalHeight:188,x:0,y:-500,opacity:0,ratio:parseFloat(props.ratio)};_this6.state=Object.assign({},_this6.state,{width:_this6.state.originalWidth/_this6.state.ratio,height:_this6.state.originalHeight/_this6.state.ratio});return _this6;}_createClass(Gtx5,[{key:'getKeyFrames',value:function getKeyFrames(){return[{transform:'translateY(-500px)',opacity:0,offset:0},{opacity:1,offset:1},{transform:'translateY(0)',opacity:1,offset:1}];}},{key:'getTiming',value:function getTiming(duration){return{duration:duration,easing:'ease-in',delay:0,iterations:1,fill:'forwards'};}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_web_animation__["Animated"].img,{keyframes:this.getKeyFrames(),timing:this.getTiming(750),style:{position:'absolute',top:608/this.state.ratio,left:628/this.state.ratio,opacity:this.state.opacity,transform:[{translateY:this.state.y}],width:this.state.width,height:this.state.height},src:__webpack_require__(3)});}}]);return Gtx5;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var Gtx6=function(_React$Component7){_inherits(Gtx6,_React$Component7);function Gtx6(props){_classCallCheck(this,Gtx6);var _this7=_possibleConstructorReturn(this,(Gtx6.__proto__||Object.getPrototypeOf(Gtx6)).call(this,props));_this7.state={originalWidth:264,originalHeight:188,x:0,y:-500,opacity:0,ratio:parseFloat(props.ratio)};_this7.state=Object.assign({},_this7.state,{width:_this7.state.originalWidth/_this7.state.ratio,height:_this7.state.originalHeight/_this7.state.ratio});return _this7;}_createClass(Gtx6,[{key:'getKeyFrames',value:function getKeyFrames(){return[{transform:'translateY(-500px)',opacity:0,offset:0},{opacity:1,offset:1},{transform:'translateY(0)',opacity:1,offset:1}];}},{key:'getTiming',value:function getTiming(duration){return{duration:duration,easing:'ease-in',delay:0,iterations:1,fill:'forwards'};}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_web_animation__["Animated"].img,{keyframes:this.getKeyFrames(),timing:this.getTiming(750),style:{position:'absolute',top:461/this.state.ratio,left:418/this.state.ratio,opacity:this.state.opacity,transform:[{translateY:this.state.y}],width:this.state.width,height:this.state.height},src:__webpack_require__(3)});}}]);return Gtx6;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var Senddesk=function(_React$Component8){_inherits(Senddesk,_React$Component8);function Senddesk(props){_classCallCheck(this,Senddesk);var _this8=_possibleConstructorReturn(this,(Senddesk.__proto__||Object.getPrototypeOf(Senddesk)).call(this,props));_this8.state={originalWidth:212,originalHeight:170,x:0,y:-500,opacity:0,ratio:parseFloat(props.ratio)};_this8.state=Object.assign({},_this8.state,{width:_this8.state.originalWidth/_this8.state.ratio,height:_this8.state.originalHeight/_this8.state.ratio});return _this8;}_createClass(Senddesk,[{key:'getKeyFrames',value:function getKeyFrames(){return[{transform:'translateY(-500px)',opacity:0,offset:0},{opacity:1,offset:1},{transform:'translateY(0)',opacity:1,offset:1}];}},{key:'getTiming',value:function getTiming(duration){return{duration:duration,easing:'ease-in',delay:0,iterations:1,fill:'forwards'};}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_web_animation__["Animated"].img,{keyframes:this.getKeyFrames(),timing:this.getTiming(750),style:{position:'absolute',top:735/this.state.ratio,left:474/this.state.ratio,opacity:this.state.opacity,transform:[{translateY:this.state.y}],width:this.state.width,height:this.state.height},src:__webpack_require__(19)});}}]);return Senddesk;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var Desk=function(_React$Component9){_inherits(Desk,_React$Component9);function Desk(props){_classCallCheck(this,Desk);var _this9=_possibleConstructorReturn(this,(Desk.__proto__||Object.getPrototypeOf(Desk)).call(this,props));_this9.state={originalWidth:212,originalHeight:150,x:0,y:-500,opacity:0,ratio:parseFloat(props.ratio)};_this9.state=Object.assign({},_this9.state,{width:_this9.state.originalWidth/_this9.state.ratio,height:_this9.state.originalHeight/_this9.state.ratio});return _this9;}_createClass(Desk,[{key:'getKeyFrames',value:function getKeyFrames(){return[{transform:'translateY(-500px)',opacity:0,offset:0},{opacity:1,offset:1},{transform:'translateY(0)',opacity:1,offset:1}];}},{key:'getTiming',value:function getTiming(duration){return{duration:duration,easing:'ease-in',delay:0,iterations:1,fill:'forwards'};}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_web_animation__["Animated"].img,{keyframes:this.getKeyFrames(),timing:this.getTiming(750),style:{position:'absolute',top:645/this.state.ratio,left:315/this.state.ratio,opacity:this.state.opacity,transform:[{translateY:this.state.y}],width:this.state.width,height:this.state.height},src:__webpack_require__(17)});}}]);return Desk;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var PretreatLine=function(_React$Component10){_inherits(PretreatLine,_React$Component10);function PretreatLine(props){_classCallCheck(this,PretreatLine);var _this10=_possibleConstructorReturn(this,(PretreatLine.__proto__||Object.getPrototypeOf(PretreatLine)).call(this,props));_this10.state={originalWidth:420,originalHeight:310,x:0,y:-500,opacity:0,ratio:parseFloat(props.ratio)};_this10.state=Object.assign({},_this10.state,{width:_this10.state.originalWidth/_this10.state.ratio,height:_this10.state.originalHeight/_this10.state.ratio});return _this10;}_createClass(PretreatLine,[{key:'getKeyFrames',value:function getKeyFrames(){return[{transform:'translateY(-500px)',opacity:0,offset:0},{opacity:1,offset:1},{transform:'translateY(0)',opacity:1,offset:1}];}},{key:'getTiming',value:function getTiming(duration){return{duration:duration,easing:'ease-in',delay:0,iterations:1,fill:'forwards'};}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_web_animation__["Animated"].img,{keyframes:this.getKeyFrames(),timing:this.getTiming(750),style:{position:'absolute',top:189/this.state.ratio,left:263/this.state.ratio,opacity:this.state.opacity,transform:[{translateY:this.state.y}],width:this.state.width,height:this.state.height},src:__webpack_require__(357)});}}]);return PretreatLine;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var Dryer=function(_React$Component11){_inherits(Dryer,_React$Component11);function Dryer(props){_classCallCheck(this,Dryer);var _this11=_possibleConstructorReturn(this,(Dryer.__proto__||Object.getPrototypeOf(Dryer)).call(this,props));_this11.state={originalWidth:420,originalHeight:316,x:0,y:-500,opacity:0,ratio:parseFloat(props.ratio)};_this11.state=Object.assign({},_this11.state,{width:_this11.state.originalWidth/_this11.state.ratio,height:_this11.state.originalHeight/_this11.state.ratio});return _this11;}_createClass(Dryer,[{key:'getKeyFrames',value:function getKeyFrames(){return[{transform:'translateY(-500px)',opacity:0,offset:0},{opacity:1,offset:1},{transform:'translateY(0)',opacity:1,offset:1}];}},{key:'getTiming',value:function getTiming(duration){return{duration:duration,easing:'ease-in',delay:0,iterations:1,fill:'forwards'};}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_web_animation__["Animated"].img,{keyframes:this.getKeyFrames(),timing:this.getTiming(750),style:{position:'absolute',top:372/this.state.ratio,left:0/this.state.ratio,opacity:this.state.opacity,transform:[{translateY:this.state.y}],width:this.state.width,height:this.state.height},src:__webpack_require__(42)});}}]);return Dryer;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/pretreat_line.7e8a2f20.png";

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__overlay_css__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__overlay_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__overlay_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_scenarios_json__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_scenarios_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__data_scenarios_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_devices_json__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_devices_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__data_devices_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__i18n__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_dom__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var classNames=__webpack_require__(7);var Overlay=function(_React$Component){_inherits(Overlay,_React$Component);function Overlay(props){_classCallCheck(this,Overlay);var _this=_possibleConstructorReturn(this,(Overlay.__proto__||Object.getPrototypeOf(Overlay)).call(this,props));_this.returnDevicePricingDataView=function(){var devices=_this.props.deviceData.map(function(device){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:device.id,className:__WEBPACK_IMPORTED_MODULE_1__overlay_css___default.a.devicePricingContainer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,__WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].translate('calculator:'+device.localeName,_this.props.location.pathname)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this.props.currency.symbol,' ',Number(device.unit_price).toLocaleString('de-DE')));});return devices;};_this.returnScenarioOverviewView=function(){var currentScenario=_this.props.scenarioData;var scenarios=__WEBPACK_IMPORTED_MODULE_2__data_scenarios_json___default.a.map(function(scenario){var id=scenario.id;var deviceList=scenario.items.map(function(device){var deviceItem=__WEBPACK_IMPORTED_MODULE_3__data_devices_json___default.a.filter(function(devices){return devices.id===device.id;})[0];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:device.id+'-device'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:__WEBPACK_IMPORTED_MODULE_1__overlay_css___default.a.showSmaller},deviceItem.name,':\xA0'),device.qty);});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:id+'-scenario',className:classNames(__WEBPACK_IMPORTED_MODULE_1__overlay_css___default.a.scenarioLineItem,currentScenario.id===id?__WEBPACK_IMPORTED_MODULE_1__overlay_css___default.a.activeScenario:'',_this.state.currentlySelectedScenario.id===id&&_this.state.currentlySelectedScenario.id!==currentScenario.id&&_this.state.hasChangedSelection?__WEBPACK_IMPORTED_MODULE_1__overlay_css___default.a.currentlySelectedScenario:''),onClick:function onClick(){return _this.selectScenario(scenario);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:__WEBPACK_IMPORTED_MODULE_1__overlay_css___default.a.showSmaller},'Scenario:\xA0'),scenario.short_name),deviceList,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:__WEBPACK_IMPORTED_MODULE_1__overlay_css___default.a.showSmaller},__WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].translate('calculator:capacity',_this.props.location.pathname),' (',__WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].translate('calculator:pieceHours',_this.props.location.pathname),'):\xA0'),scenario.capacity)));});return scenarios;};_this.selectScenario=function(scenario){_this.setState({currentlySelectedScenario:scenario,hasChangedSelection:true},function(){console.log(scenario);});};_this.toggleOverlay=function(ev){_this.setState({currentlySelectedScenarioId:_this.props.scenarioData.id,hasChangedSelection:false});_this.props.showOverlay(ev,false);};_this.handleScenarioChange=function(){_this.setState({hasChangedSelection:false});_this.props.triggerScenarioChange(_this.state.currentlySelectedScenario);_this.props.showOverlay(null,false);};_this.state={scenario:props.scenario,selectedScenario:props.scenarioData,currency:props.currency,deviceData:props.deviceData,currentlySelectedScenario:props.scenarioData,hasChangedSelection:false};return _this;}_createClass(Overlay,[{key:'setActiveScenario',value:function setActiveScenario(scenario){var _this2=this;this.setState({scenario:scenario},function(){_this2.prepareScenarioList();});}},{key:'saveOverlay',value:function saveOverlay(ev){ev.preventDefault();if(this.state.scenario){this.props.triggerScenarioChange(this.state.scenario);}this.props.showOverlay(ev,false);}},{key:'render',value:function render(){var _this3=this;var devices=this.returnDevicePricingDataView();var scenarios=this.returnScenarioOverviewView();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1__overlay_css___default.a.overlay,style:this.props.shouldShow?{opacity:1,visibility:'visible'}:{opacity:0,visibility:'hidden'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1__overlay_css___default.a.overlayInner},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1__overlay_css___default.a.close},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(ev){return _this3.toggleOverlay(ev);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{width:'25px',height:'25px',viewBox:'0 0 62 62',version:'1.1',xmlns:'http://www.w3.org/2000/svg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('defs',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Symbols',stroke:'none',fill:'none'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Exit',transform:'translate(1.000000, 1.000000)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('circle',{id:'Oval-2',stroke:'#FFFFFF',fill:'#0D2EA0',cx:'30',cy:'30',r:'30'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Group',transform:'translate(30.500000, 30.500000) rotate(45.000000) translate(-30.500000, -30.500000) translate(13.000000, 13.000000)',fill:'#FFFFFF'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect',{id:'Rectangle-8',x:'0',y:'15',width:'35',height:'5'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect',{id:'Rectangle-8',x:'15',y:'0',width:'5',height:'35'})))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1__overlay_css___default.a.deviceDataContainer},devices),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1__overlay_css___default.a.scenarioOverviewList},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:__WEBPACK_IMPORTED_MODULE_1__overlay_css___default.a.scenarioOverviewHeader},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Scenario'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].translate('calculator:gtxprinter',this.props.location.pathname)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].translate('calculator:transferpresse',this.props.location.pathname)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].translate('calculator:pretreatmaker',this.props.location.pathname)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].translate('calculator:pretreatmakerLine',this.props.location.pathname)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].translate('calculator:tunneltrockner',this.props.location.pathname)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].translate('calculator:capacity',this.props.location.pathname),' (',__WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].translate('calculator:pieceHour',this.props.location.pathname),')')),scenarios),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:classNames(__WEBPACK_IMPORTED_MODULE_1__overlay_css___default.a.button,this.state.hasChangedSelection?__WEBPACK_IMPORTED_MODULE_1__overlay_css___default.a.buttonActive:''),onClick:function onClick(){return _this3.handleScenarioChange();}},__WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].translate('calculator:apply',this.props.location.pathname))));}}]);return Overlay;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["c" /* withRouter */])(Overlay));

/***/ }),
/* 359 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"overlay":"_15d4wAeD9FZA-MDZAREnRp","overlayInner":"_3Lln1Zt6wdF8azlGOdGzxz","close":"_1BwKml_xxsP_Hypc2kP5oD","deviceDataContainer":"_72Hv9C6ZZVIXUaD9xIFHl","devicePricingContainer":"_3r1LkMDvA5botT6cLREjjT","scenarioOverviewList":"_2Rd41SzTLOJR6rjTmBBUoB","scenarioLineItem":"_1idyb5-pG0uB_F30YivPoJ","scenarioOverviewHeader":"_1o1iH52O5WfrRn7U6fvstP","activeScenario":"_9gQANwXO--KmLuwQ8AqS5","currentlySelectedScenario":"_1ylt7ukgF03gg-Kj1dnxL6","button":"_2V8bT2T57CaaA24DbSPXax","buttonActive":"_21MxzTFWWTBvKiltpxAnXl","showSmaller":"_3YaKYci22jvR7bO3CImEcy"};

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__i18n__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Help=function(_Component){_inherits(Help,_Component);function Help(props){_classCallCheck(this,Help);var _this=_possibleConstructorReturn(this,(Help.__proto__||Object.getPrototypeOf(Help)).call(this,props));_this.toggleHelpSection=function(){console.log("Opening help section");_this.setState({helpOpen:_this.state.helpOpen?false:true});};_this.state={helpOpen:false};return _this;}_createClass(Help,[{key:'render',value:function render(){var _this2=this;var styles=this.props.styles;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:styles.helpButtonContainer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:styles.helpButton,onClick:function onClick(){return _this2.toggleHelpSection();}},__WEBPACK_IMPORTED_MODULE_1__i18n__["a" /* default */].translate('help:button',this.props.location.pathname)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:styles.helpOverlay,onClick:function onClick(){return _this2.toggleHelpSection();},style:this.state.helpOpen?{opacity:1,visibility:'visible'}:{opacity:0,visibility:'hidden'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:styles.helpOverlayContent},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:styles.helpCloseButton,onClick:function onClick(){return _this2.toggleHelpSection();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{width:'25px',height:'25px',viewBox:'0 0 62 62',version:'1.1',xmlns:'http://www.w3.org/2000/svg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('defs',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Symbols',stroke:'none',fill:'none'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Exit',transform:'translate(1.000000, 1.000000)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('circle',{id:'Oval-2',stroke:'#FFFFFF',fill:'#0D2EA0',cx:'30',cy:'30',r:'30'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Group',transform:'translate(30.500000, 30.500000) rotate(45.000000) translate(-30.500000, -30.500000) translate(13.000000, 13.000000)',fill:'#FFFFFF'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect',{id:'Rectangle-8',x:'0',y:'15',width:'35',height:'5'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect',{id:'Rectangle-8',x:'15',y:'0',width:'5',height:'35'}))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,__WEBPACK_IMPORTED_MODULE_1__i18n__["a" /* default */].translate('help:title',this.props.location.pathname)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:styles.helpContent},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Nutzen Sie unseren Service zum ersten Mal?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Unsere Step-by-Step Anleitung f\xFChrt Sie durch die wichtigsten Funktionen und erkl\xE4rt Ihnen die Handhabung des Produktionskalkulators.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Mit Hilfe des Kalkulators k\xF6nnen Sie anhand eigener Werte die Gewinnschwelle und den Deckungsbeitrag f\xFCr das erste und zweite Jahr berechnen. Au\xDFerdem werden Ihnen diese Werte graphisch dargestellt, sodass Sie einen einfachen und schnellen \xDCberblick erhalten.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Geben Sie die gew\xFCnschten Werte in die Felder mit den orange hinterlegten Zahlen ein. Sie k\xF6nnen folgende Werte individuell anpassen:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'das Nachfragevolumen'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'die Materialkosten pro St\xFCck'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'die Produktionswochen'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'die t\xE4gliche Arbeitszeit'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'die Personalkosten pro Stunde'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'den Listenpreis pro St\xFCck')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Durch Ihre Angaben werden weitere Werte, wie zum Beispiel die Druck- oder Personalkosten, neu kalkuliert und angezeigt.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Auch ist es m\xF6glich, die Variablen der Produkte zu \xE4ndern. W\xE4hlen Sie zum Beispiel die Zahl der Tintenpackungen, die Gr\xF6\xDFe der Druckfl\xE4chen oder den Farbauftrag aus, um Ihre Kalkulation zu spezifizieren.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Sie k\xF6nnen im unteren Bereich des Kalkulators eine Auflistung des Ertrags Ihrer Investitionen in Form einer Tabelle einsehen. Unterst\xFCtzt wird die Anzeige von einem Balken- und einem Ringdiagramm, welche die Aufteilung des gesch\xE4tzten Umsatzes in variable Kosten, die Investitionssumme und den \xFCbrig bleibenden Deckungsbetrag einteilt.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Ben\xF6tigen Sie weitere Hilfe? Wir sind gerne f\xFCr Sie da!'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\xDCber unser Kontaktformular erreichen Sie unsere fachkundigen Brother Representatives und k\xF6nnen Ihre Fragen, Anregungen oder W\xFCnsche mitteilen. Nutzen Sie hierzu einfach den Button \u201EKontakt aufnehmen\u201C im unteren Bereich unserer Webseite.')))));}}]);return Help;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* withRouter */])(Help));

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__step_by_step_css__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__step_by_step_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__step_by_step_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__s_user_input__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__s_slider_druckfarbe__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__s_slider_textil__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__i18n__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_dom__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Steps=function(_Component){_inherits(Steps,_Component);function Steps(props){_classCallCheck(this,Steps);var _this=_possibleConstructorReturn(this,(Steps.__proto__||Object.getPrototypeOf(Steps)).call(this,props));_this.toggleStepsOverlays=function(){_this.props.toggleStepByStep();};_this.handleUserInputChange=function(value,name){_this.props.handleUserInputChange(value,name);};_this.handleChangeColor=function(selected){_this.props.onChangeColor(selected);};_this.handleChangeTextile=function(selected){_this.props.onChangeTextile(selected);};_this.pushToCompletedSteps=function(step){var completedSteps=_this.state.completedSteps;var completedStep=completedSteps.filter(function(item){return item.step===step;})[0];if(completedStep!==undefined&&completedStep.step!==step&&!_this.state.isFinished){completedSteps.push({step:step});}else if(completedStep===undefined){completedSteps.push({step:step});}};_this.renderStepButton=function(){var isLastStep=_this.state.currentStep===_this.state.lastStep?true:false;var buttonWording=isLastStep?"Anwenden":"Weiter";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this.goToNextStep(isLastStep);}},buttonWording);};_this.renderPrevStepButton=function(){var isFirstStep=_this.state.currentStep===0?true:false;if(!isFirstStep){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this.goToPreviousStep();}},'Zur\xFCck');}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this.goToPreviousStep();},disabled:'disabled'},'Zur\xFCck');}};_this.goToPreviousStep=function(){var stepTo=_this.state.currentStep>=0?_this.state.currentStep-1:_this.state.currentStep;_this.setState({currentStep:stepTo>0?stepTo:0});};_this.goToNextStep=function(){var shouldCloseModal=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var stepTo=_this.state.currentStep<=_this.state.lastStep?_this.state.currentStep+1:_this.state.currentStep;var isFinished=stepTo>_this.state.lastStep?true:false;_this.pushToCompletedSteps(_this.state.currentStep);_this.setState({currentStep:stepTo>_this.state.lastStep?_this.state.lastStep:stepTo,finishedAllSteps:isFinished});if(shouldCloseModal){_this.toggleStepsOverlays();}};_this.goToStep=function(step){_this.setState({currentStep:step});};_this.renderStepView=function(){var renderedSteps=[];var completedSteps=_this.state.completedSteps;var _loop=function _loop(step){var currentStepInCompletedList=completedSteps.filter(function(item){return item.step===step;})[0];var isCurrentStep=step===_this.state.currentStep?true:false;var isCompletedStep=currentStepInCompletedList!==undefined&&currentStepInCompletedList.step===step?true:false;if(isCurrentStep){renderedSteps.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'step-'+step,className:__WEBPACK_IMPORTED_MODULE_1__step_by_step_css___default.a.currentStep},step+1));}else if(isCompletedStep){renderedSteps.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'step-'+step,className:__WEBPACK_IMPORTED_MODULE_1__step_by_step_css___default.a.completedStep,onClick:function onClick(){return _this.goToStep(step);}},step+1));}else{renderedSteps.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'step-'+step},step+1));}};for(var step=0;step<=_this.state.lastStep;step++){_loop(step);}return renderedSteps;};_this.returnCurrentStep=function(calculatorState){//const completedSteps = this.state.completedSteps;
//const lastCompletedStep = completedSteps !== undefined ? completedSteps[completedSteps.length - 1] : null 
var currentStep=_this.state.currentStep;if(currentStep===0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__s_user_input__["a" /* default */],{description:__WEBPACK_IMPORTED_MODULE_5__i18n__["a" /* default */].translate('calculator:demandVolume',_this.props.location.pathname),unitInfo:__WEBPACK_IMPORTED_MODULE_5__i18n__["a" /* default */].translate('calculator:pieceWeek',_this.props.location.pathname),name:'demandVolume',onChange:_this.handleUserInputChange,value:calculatorState.demandVolume,styles:__WEBPACK_IMPORTED_MODULE_1__step_by_step_css___default.a,icon:null,helpText:__WEBPACK_IMPORTED_MODULE_5__i18n__["a" /* default */].translate('steps:demandVolumeHelp',_this.props.location.pathname),step:currentStep});}else if(currentStep===1){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__s_user_input__["a" /* default */],{description:__WEBPACK_IMPORTED_MODULE_5__i18n__["a" /* default */].translate('calculator:productionWeeks',_this.props.location.pathname),unitInfo:__WEBPACK_IMPORTED_MODULE_5__i18n__["a" /* default */].translate('calculator:weekYear',_this.props.location.pathname),onChange:_this.handleUserInputChange,value:calculatorState.productionWeeks,name:'productionWeeks',styles:__WEBPACK_IMPORTED_MODULE_1__step_by_step_css___default.a,helpText:__WEBPACK_IMPORTED_MODULE_5__i18n__["a" /* default */].translate('steps:productionWeeksHelp',_this.props.location.pathname),step:currentStep});}else if(currentStep===2){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__s_user_input__["a" /* default */],{description:__WEBPACK_IMPORTED_MODULE_5__i18n__["a" /* default */].translate('calculator:productionHours',_this.props.location.pathname),unitInfo:__WEBPACK_IMPORTED_MODULE_5__i18n__["a" /* default */].translate('calculator:hoursDay',_this.props.location.pathname),onChange:_this.handleUserInputChange,value:calculatorState.productionHours,name:'productionHours',styles:__WEBPACK_IMPORTED_MODULE_1__step_by_step_css___default.a,helpText:__WEBPACK_IMPORTED_MODULE_5__i18n__["a" /* default */].translate('steps:productionHoursHelp',_this.props.location.pathname),step:currentStep});}else if(currentStep===3){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__s_user_input__["a" /* default */],{description:__WEBPACK_IMPORTED_MODULE_5__i18n__["a" /* default */].translate('calculator:listPrice',_this.props.location.pathname),unitInfo:__WEBPACK_IMPORTED_MODULE_5__i18n__["a" /* default */].translate('calculator:piece',_this.props.location.pathname),onChange:_this.handleUserInputChange,value:calculatorState.listPrice,name:'listPrice',styles:__WEBPACK_IMPORTED_MODULE_1__step_by_step_css___default.a,helpText:__WEBPACK_IMPORTED_MODULE_5__i18n__["a" /* default */].translate('steps:listPriceHelp',_this.props.location.pathname),step:currentStep});}else if(currentStep===4){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__s_slider_druckfarbe__["a" /* default */],{styles:__WEBPACK_IMPORTED_MODULE_1__step_by_step_css___default.a,onChange:_this.handleChangeColor,name:'druck',value:calculatorState.printColorPercentage,textilePercentage:calculatorState.textileColorPercentage,label:__WEBPACK_IMPORTED_MODULE_5__i18n__["a" /* default */].translate('calculator:printColor',_this.props.location.pathname),showPercentage:'true',helpText:__WEBPACK_IMPORTED_MODULE_5__i18n__["a" /* default */].translate('steps:printColorHelp',_this.props.location.pathname),white:__WEBPACK_IMPORTED_MODULE_5__i18n__["a" /* default */].translate('calculator:white',_this.props.location.pathname)});}else if(currentStep===5){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__s_slider_textil__["a" /* default */],{styles:__WEBPACK_IMPORTED_MODULE_1__step_by_step_css___default.a,onChange:_this.handleChangeTextile,name:'textile',value:calculatorState.textileColorPercentage,label:__WEBPACK_IMPORTED_MODULE_5__i18n__["a" /* default */].translate('calculator:textileColor',_this.props.location.pathname),showPercentage:'true',helpText:__WEBPACK_IMPORTED_MODULE_5__i18n__["a" /* default */].translate('steps:textileHelp',_this.props.location.pathname),white:__WEBPACK_IMPORTED_MODULE_5__i18n__["a" /* default */].translate('calculator:white',_this.props.location.pathname),colourful:__WEBPACK_IMPORTED_MODULE_5__i18n__["a" /* default */].translate('calculator:colourful',_this.props.location.pathname),dark:__WEBPACK_IMPORTED_MODULE_5__i18n__["a" /* default */].translate('calculator:dark',_this.props.location.pathname)});}};_this.state={currentStep:0,lastStep:5,// 6 in total
completedSteps:[],// Have a simple array to keep track of completed steps.
finishedAllSteps:false};return _this;}_createClass(Steps,[{key:'render',value:function render(){var _this2=this;var calculatorState=this.props.calculatorState;var currentStepView=this.props.isOpen?this.returnCurrentStep(calculatorState):null;var nextButton=this.props.isOpen?this.renderStepButton():null;var prevButton=this.props.isOpen?this.renderPrevStepButton():null;var stepView=this.props.isOpen?this.renderStepView():null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1__step_by_step_css___default.a.overlay,style:this.props.isOpen?{opacity:1,visibility:'visible'}:{opacity:0,visibility:'hidden'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1__step_by_step_css___default.a.overlayContainer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1__step_by_step_css___default.a.closeButton,onClick:function onClick(){return _this2.toggleStepsOverlays();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{width:'25px',height:'25px',viewBox:'0 0 62 62',version:'1.1',xmlns:'http://www.w3.org/2000/svg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('defs',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Symbols',stroke:'none',fill:'none'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Exit',transform:'translate(1.000000, 1.000000)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('circle',{id:'Oval-2',stroke:'#FFFFFF',fill:'#0D2EA0',cx:'30',cy:'30',r:'30'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Group',transform:'translate(30.500000, 30.500000) rotate(45.000000) translate(-30.500000, -30.500000) translate(13.000000, 13.000000)',fill:'#FFFFFF'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect',{id:'Rectangle-8',x:'0',y:'15',width:'35',height:'5'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect',{id:'Rectangle-8',x:'15',y:'0',width:'5',height:'35'}))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1__step_by_step_css___default.a.stepContainer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:__WEBPACK_IMPORTED_MODULE_1__step_by_step_css___default.a.headerStep},this.state.currentStep+1),currentStepView),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1__step_by_step_css___default.a.controls},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1__step_by_step_css___default.a.prev},prevButton),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1__step_by_step_css___default.a.next},nextButton),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,stepView))));}}]);return Steps;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_react_router_dom__["c" /* withRouter */])(Steps));

/***/ }),
/* 362 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"overlay":"_1tf1LmiZmsc9TuTMH42_sP","overlayContainer":"_2deZ7SId0JSMcV-a9WR7-0","closeButton":"gmdBmI-pX2PY2_r_zkBGN","controls":"_2OInZth0bskbyDdTScULyp","completedStep":"WPrTpqI4JzQCGEJVC8zpk","currentStep":"ub-28sLz7U6MgDn4aeLTw","prev":"_3fi0xVAEic_TZdSvyCVFF_","next":"_1BnjOYo6jxcLu-AxklHdFe","headerStep":"_20WFN8SA1PASOk-uoJUxUi","inputItem":"_3sU0JbG0ad_ZqmjTUBxWyF","info":"ODxOue53QTnuptMbj4Xdw"};

/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var classNames=__webpack_require__(7);var UserInput=function(_Component){_inherits(UserInput,_Component);function UserInput(props){_classCallCheck(this,UserInput);var _this=_possibleConstructorReturn(this,(UserInput.__proto__||Object.getPrototypeOf(UserInput)).call(this,props));_this.handleChange=_this.handleChange.bind(_this);return _this;}_createClass(UserInput,[{key:'handleChange',value:function handleChange(e){var value=e.target.value;if(value===''){value=0;}var name=this.props.name;this.props.onChange(value,name,this.props.step);}},{key:'render',value:function render(){var styles=this.props.styles;var separator=this.props.currency!==undefined&&this.props.unitInfo?" / ":"";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{ref:'section',className:classNames(styles.inputItem,styles.inputColour)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:styles.info},this.props.description),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,this.props.helpText),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:styles.inputField,type:'number'//defaultValue={parseFloat(this.props.value).toFixed(2)}
,value:this.props.value,name:this.props.name,onChange:this.handleChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.props.currency!==undefined&&this.props.currency.symbol,' ',separator,' ',this.props.unitInfo));}}]);return UserInput;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (UserInput);

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UserSliderInputDruckfarbe=function(_Component){_inherits(UserSliderInputDruckfarbe,_Component);function UserSliderInputDruckfarbe(props){_classCallCheck(this,UserSliderInputDruckfarbe);var _this=_possibleConstructorReturn(this,(UserSliderInputDruckfarbe.__proto__||Object.getPrototypeOf(UserSliderInputDruckfarbe)).call(this,props));_this.setLabels=function(value){if(value<=0&&!_this.state.overrideLabels){_this.setState({leftLabel:_this.props.white});}else if(value>0&&value<100&&_this.state.leftLabel!==_this.props.white+"+cmyk"&&!_this.state.overrideLabels){_this.setState({leftLabel:_this.props.white+"+cmyk"});}if(_this.state.rightLabel!=="cmyk"&&!_this.state.overrideLabels){_this.setState({rightLabel:"cmyk"});}};_this.componentDidMount=function(){var value=_this.props.value;_this.props.onChange(value);};_this.componentDidUpdate=function(){if(_this.props.textilePercentage>=51&&!_this.state.overrideLabels){_this.setState({overrideLabels:true},function(){_this.setState({rightLabel:"cmyk+"+_this.props.white,leftLabel:""+_this.props.white});});}else if(_this.props.textilePercentage<=50&&_this.state.overrideLabels){_this.setState({overrideLabels:false},function(){_this.setLabels(_this.props.value);});}else if(_this.props.textilePercentage<=50&&!_this.state.overrideLabels&&_this.state.leftLabel!==""+_this.props.white){_this.setLabels(_this.props.value);}else if(_this.props.textilePercentage<=50&&!_this.state.overrideLabels&&_this.props.value>0&&_this.state.leftLabel!==_this.props.white+"+cmyk"){_this.setLabels(_this.props.value);}};_this.state={leftLabel:_this.props.white+"+cmyk",rightLabel:"cmyk",overrideLabels:false};_this.handleChange=_this.handleChange.bind(_this);return _this;}_createClass(UserSliderInputDruckfarbe,[{key:"handleChange",value:function handleChange(e){var value=e.target.value;this.props.onChange(value);this.setLabels(value);}},{key:"render",value:function render(){var styles=this.props.styles;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{key:this.props.name,className:styles.inputItem},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:styles.info},this.props.label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,this.props.helpText),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:styles.slider},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("aside",{className:styles.sliderData},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",null,100-this.props.value,this.props.showPercentage&&"%"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",null,this.props.value,this.props.showPercentage&&"%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{onChange:this.handleChange,type:"range",name:this.props.name,value:this.props.value,max:"100",min:"0",step:"1"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("aside",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",null,this.state.leftLabel),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",null,this.state.rightLabel))));}}]);return UserSliderInputDruckfarbe;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (UserSliderInputDruckfarbe);

/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UserSliderInputTextil=function(_Component){_inherits(UserSliderInputTextil,_Component);function UserSliderInputTextil(props){_classCallCheck(this,UserSliderInputTextil);var _this=_possibleConstructorReturn(this,(UserSliderInputTextil.__proto__||Object.getPrototypeOf(UserSliderInputTextil)).call(this,props));_this.setLabels=function(value){if(value>50&&_this.state.rightLabel!==_this.props.dark){_this.setState({rightLabel:_this.props.dark});}else if(value<=50&&_this.state.rightLabel!==_this.props.colourful){_this.setState({rightLabel:_this.props.colourful});}};_this.componentDidMount=function(){var value=_this.props.value;_this.props.onChange(value);_this.setLabels(value);};_this.state={leftLabel:_this.props.white,rightLabel:_this.props.colourful};_this.handleChange=_this.handleChange.bind(_this);return _this;}_createClass(UserSliderInputTextil,[{key:"handleChange",value:function handleChange(e){var value=e.target.value;this.props.onChange(value);this.setLabels(value);}},{key:"render",value:function render(){var styles=this.props.styles;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{key:this.props.name,className:styles.inputItem},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:styles.info},this.props.label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,this.props.helpText),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:styles.slider},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("aside",{className:styles.sliderData},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",null,100-this.props.value,this.props.showPercentage&&"%"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",null,this.props.value,this.props.showPercentage&&"%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{onChange:this.handleChange,type:"range",name:this.props.name,value:this.props.value,max:"100",min:"0",step:"1"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("aside",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",null,this.props.white),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",null,this.state.rightLabel))));}}]);return UserSliderInputTextil;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (UserSliderInputTextil);

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__footer_css__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__footer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__footer_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var classNames=__webpack_require__(7);var Footer=function(_Component){_inherits(Footer,_Component);function Footer(){_classCallCheck(this,Footer);return _possibleConstructorReturn(this,(Footer.__proto__||Object.getPrototypeOf(Footer)).apply(this,arguments));}_createClass(Footer,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('footer',{className:__WEBPACK_IMPORTED_MODULE_1__footer_css___default.a.row},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1__footer_css___default.a.logosContainer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1__footer_css___default.a.logoGtx},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'',alt:''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1__footer_css___default.a.logoBro},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'',alt:''}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:classNames(__WEBPACK_IMPORTED_MODULE_1__footer_css___default.a.inline,__WEBPACK_IMPORTED_MODULE_1__footer_css___default.a.fooMenu)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'//brothergtx.com/de/vorteile-des-dtg.html',target:'_blank',rel:'noopener noreferrer'},'Vorteile des DTG')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'//brothergtx.com/de/technische-infos.html',target:'_blank',rel:'noopener noreferrer'},'Technische Infos')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'//brothergtx.com/de/multi-media-galerie.html',target:'_blank',rel:'noopener noreferrer'},'Multi-Media Galerie')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'//brothergtx.com/de/handler-in-der-nahe-finden.html',target:'_blank',rel:'noopener noreferrer'},'H\xE4ndler in der N\xE4he finden'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:__WEBPACK_IMPORTED_MODULE_1__footer_css___default.a.footerP},'\xA91995-2018 Brother International Corporation. All rights reserved',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' Images are for illustrative purposes only.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:classNames(__WEBPACK_IMPORTED_MODULE_1__footer_css___default.a.inline,__WEBPACK_IMPORTED_MODULE_1__footer_css___default.a.fooBro)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'//brothergtx.com/de/auxiliary/uber-brother.html',target:'_blank',rel:'noopener noreferrer'},'\xDCber Brother')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'//brothergtx.com/de/auxiliary/privacy-policy.html',target:'_blank',rel:'noopener noreferrer'},'Privacy Policy')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'//brothergtx.com/de/auxiliary/kontakt.html',target:'_blank',rel:'noopener noreferrer'},'Kontakt')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'//brothergtx.com/de/auxiliary/impressum.html',target:'_blank',rel:'noopener noreferrer'},'Impressum'))));}}]);return Footer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Footer);

/***/ }),
/* 367 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"row":"umElGc6EV0OyqMSedm_UE","footerP":"_141Y-9BLuah4aCEbWlgBlm","logosContainer":"_2gsabTfjw_pIjunUoPYqxe","logoGtx":"_2-f7Xz2UuUnLd3vl_tU_D7","inline":"_3qR147S9wXfQsz-Fmfsort","fooBro":"_3wLCneMKlfOJdr6UAvOT3A"};

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

/*! lazysizes - v4.0.2 */
!function(a,b){var c=function(){b(a.lazySizes),a.removeEventListener("lazyunveilread",c,!0)};b=b.bind(null,a,a.document),"object"==typeof module&&module.exports?b(__webpack_require__(29),__webpack_require__(369)):a.lazySizes?c():a.addEventListener("lazyunveilread",c,!0)}(window,function(a,b,c){"use strict";var d,e=c&&c.cfg||a.lazySizesConfig,f=b.createElement("img"),g="sizes"in f&&"srcset"in f,h=/\s+\d+h/g,i=function(){var a=/\s+(\d+)(w|h)\s+(\d+)(w|h)/,c=Array.prototype.forEach;return function(d){var e=b.createElement("img"),f=function(b){var c,d,e=b.getAttribute(lazySizesConfig.srcsetAttr);e&&((d=e.match(a))&&(c="w"==d[2]?d[1]/d[3]:d[3]/d[1],c&&b.setAttribute("data-aspectratio",c)),b.setAttribute(lazySizesConfig.srcsetAttr,e.replace(h,"")))},g=function(a){var b=a.target.parentNode;b&&"PICTURE"==b.nodeName&&c.call(b.getElementsByTagName("source"),f),f(a.target)},i=function(){e.currentSrc&&b.removeEventListener("lazybeforeunveil",g)};d[1]&&(b.addEventListener("lazybeforeunveil",g),e.onload=i,e.onerror=i,e.srcset="data:,a 1w 1h",e.complete&&i())}}();if(e||(e={},a.lazySizesConfig=e),e.supportsType||(e.supportsType=function(a){return!a}),!a.picturefill&&!e.pf){if(a.HTMLPictureElement&&g)return b.msElementsFromPoint&&i(navigator.userAgent.match(/Edge\/(\d+)/)),void(e.pf=function(){});e.pf=function(b){var c,e;if(!a.picturefill)for(c=0,e=b.elements.length;e>c;c++)d(b.elements[c])},d=function(){var f=function(a,b){return a.w-b.w},i=/^\s*\d+\.*\d*px\s*$/,j=function(a){var b,c,d=a.length,e=a[d-1],f=0;for(f;d>f;f++)if(e=a[f],e.d=e.w/a.w,e.d>=a.d){!e.cached&&(b=a[f-1])&&b.d>a.d-.13*Math.pow(a.d,2.2)&&(c=Math.pow(b.d-.6,1.6),b.cached&&(b.d+=.15*c),b.d+(e.d-a.d)*c>a.d&&(e=b));break}return e},k=function(){var a,b=/(([^,\s].[^\s]+)\s+(\d+)w)/g,c=/\s/,d=function(b,c,d,e){a.push({c:c,u:d,w:1*e})};return function(e){return a=[],e=e.trim(),e.replace(h,"").replace(b,d),a.length||!e||c.test(e)||a.push({c:e,u:e,w:99}),a}}(),l=function(){l.init||(l.init=!0,addEventListener("resize",function(){var a,c=b.getElementsByClassName("lazymatchmedia"),e=function(){var a,b;for(a=0,b=c.length;b>a;a++)d(c[a])};return function(){clearTimeout(a),a=setTimeout(e,66)}}()))},m=function(b,d){var f,g=b.getAttribute("srcset")||b.getAttribute(e.srcsetAttr);!g&&d&&(g=b._lazypolyfill?b._lazypolyfill._set:b.getAttribute(e.srcAttr)||b.getAttribute("src")),b._lazypolyfill&&b._lazypolyfill._set==g||(f=k(g||""),d&&b.parentNode&&(f.isPicture="PICTURE"==b.parentNode.nodeName.toUpperCase(),f.isPicture&&a.matchMedia&&(c.aC(b,"lazymatchmedia"),l())),f._set=g,Object.defineProperty(b,"_lazypolyfill",{value:f,writable:!0}))},n=function(b){var d=a.devicePixelRatio||1,e=c.getX&&c.getX(b);return Math.min(e||d,2.5,d)},o=function(b){return a.matchMedia?(o=function(a){return!a||(matchMedia(a)||{}).matches})(b):!b},p=function(a){var b,d,g,h,k,l,p;if(h=a,m(h,!0),k=h._lazypolyfill,k.isPicture)for(d=0,b=a.parentNode.getElementsByTagName("source"),g=b.length;g>d;d++)if(e.supportsType(b[d].getAttribute("type"),a)&&o(b[d].getAttribute("media"))){h=b[d],m(h),k=h._lazypolyfill;break}return k.length>1?(p=h.getAttribute("sizes")||"",p=i.test(p)&&parseInt(p,10)||c.gW(a,a.parentNode),k.d=n(a),!k.src||!k.w||k.w<p?(k.w=p,l=j(k.sort(f)),k.src=l):l=k.src):l=k[0],l},q=function(a){if(!g||!a.parentNode||"PICTURE"==a.parentNode.nodeName.toUpperCase()){var b=p(a);b&&b.u&&a._lazypolyfill.cur!=b.u&&(a._lazypolyfill.cur=b.u,b.cached=!0,a.setAttribute(e.srcAttr,b.u),a.setAttribute("src",b.u))}};return q.parse=k,q}(),e.loadedClass&&e.loadingClass&&!function(){var a=[];['img[sizes$="px"][srcset].',"picture > img:not([srcset])."].forEach(function(b){a.push(b+e.loadedClass),a.push(b+e.loadingClass)}),e.pf({elements:b.querySelectorAll(a.join(", "))})}()}});

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Some versions of iOS (8.1-) do load the first candidate of a srcset candidate list, if width descriptors with the sizes attribute is used.
 * This tiny extension prevents this wasted download by creating a picture structure around the image.
 * Note: This extension is already included in the ls.respimg.js file.
 *
 * Usage:
 *
 * <img
 * 	class="lazyload"
 * 	data-sizes="auto"
 * 	data-srcset="small.jpg 640px,
 * 		medium.jpg 980w,
 * 		large.jpg 1280w"
 * 	/>
 */

(function(window, factory) {
	var globalInstall = function(){
		factory(window.lazySizes);
		window.removeEventListener('lazyunveilread', globalInstall, true);
	};

	factory = factory.bind(null, window, window.document);

	if(typeof module == 'object' && module.exports){
		factory(__webpack_require__(29));
	} else if(window.lazySizes) {
		globalInstall();
	} else {
		window.addEventListener('lazyunveilread', globalInstall, true);
	}
}(window, function(window, document, lazySizes) {
	'use strict';
	var regPicture;
	var img = document.createElement('img');

	if(('srcset' in img) && !('sizes' in img) && !window.HTMLPictureElement){
		regPicture = /^picture$/i;
		document.addEventListener('lazybeforeunveil', function(e){
			if(e.detail.instance != lazySizes){return;}

			var elem, parent, srcset, sizes, isPicture;
			var picture, source;
			if(e.defaultPrevented ||
				lazySizesConfig.noIOSFix ||
				!(elem = e.target) ||
				!(srcset = elem.getAttribute(lazySizesConfig.srcsetAttr)) ||
				!(parent = elem.parentNode) ||
				(
					!(isPicture = regPicture.test(parent.nodeName || '')) &&
					!(sizes = elem.getAttribute('sizes') || elem.getAttribute(lazySizesConfig.sizesAttr))
				)
			){return;}

			picture = isPicture ? parent : document.createElement('picture');

			if(!elem._lazyImgSrc){
				Object.defineProperty(elem, '_lazyImgSrc', {
					value: document.createElement('source'),
					writable: true
				});
			}
			source = elem._lazyImgSrc;

			if(sizes){
				source.setAttribute('sizes', sizes);
			}

			source.setAttribute(lazySizesConfig.srcsetAttr, srcset);
			elem.setAttribute('data-pfsrcset', srcset);
			elem.removeAttribute(lazySizesConfig.srcsetAttr);

			if(!isPicture){
				parent.insertBefore(picture, elem);
				picture.appendChild(elem);
			}
			picture.insertBefore(source, elem);
		});
	}
}));


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

/*! lazysizes - v4.0.2 */
!function(a,b){var c=function(){b(a.lazySizes),a.removeEventListener("lazyunveilread",c,!0)};b=b.bind(null,a,a.document),"object"==typeof module&&module.exports?b(__webpack_require__(29)):a.lazySizes?c():a.addEventListener("lazyunveilread",c,!0)}(window,function(a,b,c){"use strict";if(a.addEventListener){var d=/\s+/g,e=/\s*\|\s+|\s+\|\s*/g,f=/^(.+?)(?:\s+\[\s*(.+?)\s*\])?$/,g=/\(|\)|'/,h={contain:1,cover:1},i=function(a){var b=c.gW(a,a.parentNode);return(!a._lazysizesWidth||b>a._lazysizesWidth)&&(a._lazysizesWidth=b),a._lazysizesWidth},j=function(a){var b;return b=(getComputedStyle(a)||{getPropertyValue:function(){}}).getPropertyValue("background-size"),!h[b]&&h[a.style.backgroundSize]&&(b=a.style.backgroundSize),b},k=function(a,c,g){var h=b.createElement("picture"),i=c.getAttribute(lazySizesConfig.sizesAttr),j=c.getAttribute("data-ratio"),k=c.getAttribute("data-optimumx");c._lazybgset&&c._lazybgset.parentNode==c&&c.removeChild(c._lazybgset),Object.defineProperty(g,"_lazybgset",{value:c,writable:!0}),Object.defineProperty(c,"_lazybgset",{value:h,writable:!0}),a=a.replace(d," ").split(e),h.style.display="none",g.className=lazySizesConfig.lazyClass,1!=a.length||i||(i="auto"),a.forEach(function(a){var c,d=b.createElement("source");i&&"auto"!=i&&d.setAttribute("sizes",i),(c=a.match(f))&&(d.setAttribute(lazySizesConfig.srcsetAttr,c[1]),c[2]&&d.setAttribute("media",lazySizesConfig.customMedia[c[2]]||c[2])),h.appendChild(d)}),i&&(g.setAttribute(lazySizesConfig.sizesAttr,i),c.removeAttribute(lazySizesConfig.sizesAttr),c.removeAttribute("sizes")),k&&g.setAttribute("data-optimumx",k),j&&g.setAttribute("data-ratio",j),h.appendChild(g),c.appendChild(h)},l=function(a){if(a.target._lazybgset){var b=a.target,d=b._lazybgset,e=b.currentSrc||b.src;e&&(d.style.backgroundImage="url("+(g.test(e)?JSON.stringify(e):e)+")"),b._lazybgsetLoading&&(c.fire(d,"_lazyloaded",{},!1,!0),delete b._lazybgsetLoading)}};addEventListener("lazybeforeunveil",function(a){var d,e,f;!a.defaultPrevented&&(d=a.target.getAttribute("data-bgset"))&&(f=a.target,e=b.createElement("img"),e.alt="",e._lazybgsetLoading=!0,a.detail.firesLoad=!0,k(d,f,e),setTimeout(function(){c.loader.unveil(e),c.rAF(function(){c.fire(e,"_lazyloaded",{},!0,!0),e.complete&&l({target:e})})}))}),b.addEventListener("load",l,!0),a.addEventListener("lazybeforesizes",function(a){if(a.detail.instance==c&&a.target._lazybgset&&a.detail.dataAttr){var b=a.target._lazybgset,d=j(b);h[d]&&(a.target._lazysizesParentFit=d,c.rAF(function(){a.target.setAttribute("data-parent-fit",d),a.target._lazysizesParentFit&&delete a.target._lazysizesParentFit}))}},!0),b.documentElement.addEventListener("lazybeforesizes",function(a){!a.defaultPrevented&&a.target._lazybgset&&a.detail.instance==c&&(a.detail.width=i(a.target._lazybgset))})}});

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

/*! lazysizes - v4.0.2 */
!function(a,b){var c=function(){b(a.lazySizes),a.removeEventListener("lazyunveilread",c,!0)};b=b.bind(null,a,a.document),"object"==typeof module&&module.exports?b(__webpack_require__(29)):a.lazySizes?c():a.addEventListener("lazyunveilread",c,!0)}(window,function(a,b,c){"use strict";function d(a,c){if(!g[a]){var d=b.createElement(c?"link":"script"),e=b.getElementsByTagName("script")[0];c?(d.rel="stylesheet",d.href=a):d.src=a,g[a]=!0,g[d.src||d.href]=!0,e.parentNode.insertBefore(d,e)}}var e,f,g={};b.addEventListener&&(f=/\(|\)|\s|'/,e=function(a,c){var d=b.createElement("img");d.onload=function(){d.onload=null,d.onerror=null,d=null,c()},d.onerror=d.onload,d.src=a,d&&d.complete&&d.onload&&d.onload()},addEventListener("lazybeforeunveil",function(a){if(a.detail.instance==c){var b,g,h,i;a.defaultPrevented||("none"==a.target.preload&&(a.target.preload="auto"),b=a.target.getAttribute("data-link"),b&&d(b,!0),b=a.target.getAttribute("data-script"),b&&d(b),b=a.target.getAttribute("data-require"),b&&(c.cfg.requireJs?c.cfg.requireJs([b]):d(b)),h=a.target.getAttribute("data-bg"),h&&(a.detail.firesLoad=!0,g=function(){a.target.style.backgroundImage="url("+(f.test(h)?JSON.stringify(h):h)+")",a.detail.firesLoad=!1,c.fire(a.target,"_lazyloaded",{},!0,!0)},e(h,g)),i=a.target.getAttribute("data-poster"),i&&(a.detail.firesLoad=!0,g=function(){a.target.poster=i,a.detail.firesLoad=!1,c.fire(a.target,"_lazyloaded",{},!0,!0)},e(i,g)))}},!1))});

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* unused harmony export unregister */
// In production, we register a service worker to serve assets from local cache.
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the "N+1" visit to a page, since previously
// cached resources are updated in the background.
// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.
var isLocalhost=Boolean(window.location.hostname==='localhost'||// [::1] is the IPv6 localhost address.
window.location.hostname==='[::1]'||// 127.0.0.1/8 is considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));function register(){if("production"==='production'&&'serviceWorker'in navigator){// The URL constructor is available in all browsers that support SW.
var publicUrl=new URL(".",window.location);if(publicUrl.origin!==window.location.origin){// Our service worker won't work if PUBLIC_URL is on a different origin
// from what our page is served on. This might happen if a CDN is used to
// serve assets; see https://github.com/facebookincubator/create-react-app/issues/2374
return;}window.addEventListener('load',function(){var swUrl="."+'/service-worker.js';if(isLocalhost){// This is running on localhost. Lets check if a service worker still exists or not.
checkValidServiceWorker(swUrl);// Add some additional logging to localhost, pointing developers to the
// service worker/PWA documentation.
navigator.serviceWorker.ready.then(function(){console.log('This web app is being served cache-first by a service '+'worker. To learn more, visit https://goo.gl/SC7cgQ');});}else{// Is not local host. Just register service worker
registerValidSW(swUrl);}});}}function registerValidSW(swUrl){navigator.serviceWorker.register(swUrl).then(function(registration){registration.onupdatefound=function(){var installingWorker=registration.installing;installingWorker.onstatechange=function(){if(installingWorker.state==='installed'){if(navigator.serviceWorker.controller){// At this point, the old content will have been purged and
// the fresh content will have been added to the cache.
// It's the perfect time to display a "New content is
// available; please refresh." message in your web app.
console.log('New content is available; please refresh.');}else{// At this point, everything has been precached.
// It's the perfect time to display a
// "Content is cached for offline use." message.
console.log('Content is cached for offline use.');}}};};}).catch(function(error){console.error('Error during service worker registration:',error);});}function checkValidServiceWorker(swUrl){// Check if the service worker can be found. If it can't reload the page.
fetch(swUrl).then(function(response){// Ensure service worker exists, and that we really are getting a JS file.
if(response.status===404||response.headers.get('content-type').indexOf('javascript')===-1){// No service worker found. Probably a different app. Reload the page.
navigator.serviceWorker.ready.then(function(registration){registration.unregister().then(function(){window.location.reload();});});}else{// Service worker found. Proceed as normal.
registerValidSW(swUrl);}}).catch(function(){console.log('No internet connection found. App is running in offline mode.');});}function unregister(){if('serviceWorker'in navigator){navigator.serviceWorker.ready.then(function(registration){registration.unregister();});}}

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.41f17119.js